/* eslint-disable @typescript-eslint/no-unsed-var */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date, represented as a 'yyyy-mm-dd' string */
  Date: { input: any; output: any; }
  /** A date and time, represented as an ISO-8601 string */
  DateTime: { input: any; output: any; }
  FileUpload: { input: any; output: any; }
};

export enum ActionItemCombinationRelation {
  BeforeRespectivePrescription = 'BEFORE_RESPECTIVE_PRESCRIPTION',
  StartingFromOrBeforeRespectivePrescription = 'STARTING_FROM_OR_BEFORE_RESPECTIVE_PRESCRIPTION',
  StartingFromRespectivePrescription = 'STARTING_FROM_RESPECTIVE_PRESCRIPTION'
}

export enum ActionItemCombinationRule {
  Independently = 'INDEPENDENTLY',
  InCombinationWith = 'IN_COMBINATION_WITH'
}

export enum ActionItemRangeType {
  StartingFrom = 'STARTING_FROM',
  StartingFromConditionBound = 'STARTING_FROM_CONDITION_BOUND',
  Within = 'WITHIN',
  WithinConditionBound = 'WITHIN_CONDITION_BOUND'
}

export enum ActionLogicalOperator {
  AndTo = 'AND_TO',
  Of = 'OF',
  OrTo = 'OR_TO'
}

export type ActionPrescriptionRelationship = {
  order?: Maybe<Scalars['Int']['output']>;
};

export type ActionPrescriptionRelationshipSort = {
  order?: InputMaybe<SortDirection>;
};

export type ActionPrescriptionRelationshipWhere = {
  AND?: InputMaybe<Array<ActionPrescriptionRelationshipWhere>>;
  NOT?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  OR?: InputMaybe<Array<ActionPrescriptionRelationshipWhere>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export enum ActionSetsOperator {
  BiggestOf = 'BIGGEST_OF'
}

export enum ActionType {
  Apply = 'APPLY',
  Deduct = 'DEDUCT',
  SetBasePriceTo = 'SET_BASE_PRICE_TO',
  SetNetPriceTo = 'SET_NET_PRICE_TO'
}

export type AddedTransactionsInfo = {
  __typename?: 'AddedTransactionsInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedByEmail: Scalars['String']['output'];
  addedOn?: Maybe<Scalars['DateTime']['output']>;
  document: Document;
  documentAggregate?: Maybe<AddedTransactionsInfoDocumentDocumentAggregationSelection>;
  documentConnection: AddedTransactionsInfoDocumentConnection;
  transactionIds: Array<Scalars['String']['output']>;
};


export type AddedTransactionsInfoDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type AddedTransactionsInfoDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type AddedTransactionsInfoDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AddedTransactionsInfoDocumentConnectionSort>>;
  where?: InputMaybe<AddedTransactionsInfoDocumentConnectionWhere>;
};

export type AddedTransactionsInfoAggregateSelection = {
  __typename?: 'AddedTransactionsInfoAggregateSelection';
  addedByEmail: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type AddedTransactionsInfoDocumentAggregateInput = {
  AND?: InputMaybe<Array<AddedTransactionsInfoDocumentAggregateInput>>;
  NOT?: InputMaybe<AddedTransactionsInfoDocumentAggregateInput>;
  OR?: InputMaybe<Array<AddedTransactionsInfoDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AddedTransactionsInfoDocumentNodeAggregationWhereInput>;
};

export type AddedTransactionsInfoDocumentConnection = {
  __typename?: 'AddedTransactionsInfoDocumentConnection';
  edges: Array<AddedTransactionsInfoDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AddedTransactionsInfoDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type AddedTransactionsInfoDocumentConnectionWhere = {
  AND?: InputMaybe<Array<AddedTransactionsInfoDocumentConnectionWhere>>;
  NOT?: InputMaybe<AddedTransactionsInfoDocumentConnectionWhere>;
  OR?: InputMaybe<Array<AddedTransactionsInfoDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type AddedTransactionsInfoDocumentDocumentAggregationSelection = {
  __typename?: 'AddedTransactionsInfoDocumentDocumentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AddedTransactionsInfoDocumentDocumentNodeAggregateSelection>;
};

export type AddedTransactionsInfoDocumentDocumentNodeAggregateSelection = {
  __typename?: 'AddedTransactionsInfoDocumentDocumentNodeAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  creatorOrgName: StringAggregateSelectionNullable;
  creatorTenantId: StringAggregateSelectionNonNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  exposureLog: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastChangedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  lastSentForSmartMipReview: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  orderNo: StringAggregateSelectionNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  paymentReminderEmail: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipInvoiceFileId: StringAggregateSelectionNullable;
  smartMipInvoiceId: StringAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type AddedTransactionsInfoDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AddedTransactionsInfoDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AddedTransactionsInfoDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AddedTransactionsInfoDocumentNodeAggregationWhereInput>>;
  adjustedInvoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creatorOrgName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  orderNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reviewRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  senderLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentToReviewOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AddedTransactionsInfoDocumentRelationship = {
  __typename?: 'AddedTransactionsInfoDocumentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Document;
};

export type AddedTransactionsInfoEdge = {
  __typename?: 'AddedTransactionsInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AddedTransactionsInfo;
};

export type AddedTransactionsInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AddedTransactionsInfoSort objects to sort AddedTransactionsInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AddedTransactionsInfoSort>>;
};

/** Fields to sort AddedTransactionsInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one AddedTransactionsInfoSort object. */
export type AddedTransactionsInfoSort = {
  addedByEmail?: InputMaybe<SortDirection>;
  addedOn?: InputMaybe<SortDirection>;
};

export type AddedTransactionsInfoWhere = {
  AND?: InputMaybe<Array<AddedTransactionsInfoWhere>>;
  NOT?: InputMaybe<AddedTransactionsInfoWhere>;
  OR?: InputMaybe<Array<AddedTransactionsInfoWhere>>;
  addedByEmail?: InputMaybe<Scalars['String']['input']>;
  addedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedOn?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  addedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<AddedTransactionsInfoDocumentAggregateInput>;
  documentConnection?: InputMaybe<AddedTransactionsInfoDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<AddedTransactionsInfoDocumentConnectionWhere>;
  document_NOT?: InputMaybe<DocumentWhere>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type AddedTransactionsInfosConnection = {
  __typename?: 'AddedTransactionsInfosConnection';
  edges: Array<AddedTransactionsInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdministrationsDiscontinuationNote = {
  __typename?: 'AdministrationsDiscontinuationNote';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  administrationsAfterDnWithDocument: Scalars['Int']['output'];
  administrationsAfterDnWithoutDocument: Scalars['Int']['output'];
};

export type AdministrationsDiscontinuationNoteAggregateSelection = {
  __typename?: 'AdministrationsDiscontinuationNoteAggregateSelection';
  administrationsAfterDnWithDocument: IntAggregateSelectionNonNullable;
  administrationsAfterDnWithoutDocument: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
};

export type AdministrationsDiscontinuationNoteEdge = {
  __typename?: 'AdministrationsDiscontinuationNoteEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AdministrationsDiscontinuationNote;
};

export type AdministrationsDiscontinuationNoteOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AdministrationsDiscontinuationNoteSort objects to sort AdministrationsDiscontinuationNotes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AdministrationsDiscontinuationNoteSort>>;
};

/** Fields to sort AdministrationsDiscontinuationNotes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdministrationsDiscontinuationNoteSort object. */
export type AdministrationsDiscontinuationNoteSort = {
  administrationsAfterDnWithDocument?: InputMaybe<SortDirection>;
  administrationsAfterDnWithoutDocument?: InputMaybe<SortDirection>;
};

export type AdministrationsDiscontinuationNoteWhere = {
  AND?: InputMaybe<Array<AdministrationsDiscontinuationNoteWhere>>;
  NOT?: InputMaybe<AdministrationsDiscontinuationNoteWhere>;
  OR?: InputMaybe<Array<AdministrationsDiscontinuationNoteWhere>>;
  administrationsAfterDnWithDocument?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithDocument_GT?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithDocument_GTE?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithDocument_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  administrationsAfterDnWithDocument_LT?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithDocument_LTE?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithoutDocument?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithoutDocument_GT?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithoutDocument_GTE?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithoutDocument_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  administrationsAfterDnWithoutDocument_LT?: InputMaybe<Scalars['Int']['input']>;
  administrationsAfterDnWithoutDocument_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AdministrationsDiscontinuationNotesConnection = {
  __typename?: 'AdministrationsDiscontinuationNotesConnection';
  edges: Array<AdministrationsDiscontinuationNoteEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdverseEventCounterparties = {
  __typename?: 'AdverseEventCounterparties';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: CounterpartyRole;
};

export type AdverseEventCounterpartiesAggregateSelection = {
  __typename?: 'AdverseEventCounterpartiesAggregateSelection';
  count: Scalars['Int']['output'];
  id: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AdverseEventCounterpartiesConnection = {
  __typename?: 'AdverseEventCounterpartiesConnection';
  edges: Array<AdverseEventCounterpartiesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdverseEventCounterpartiesEdge = {
  __typename?: 'AdverseEventCounterpartiesEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AdverseEventCounterparties;
};

export type AdverseEventCounterpartiesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AdverseEventCounterpartiesSort objects to sort AdverseEventCounterparties by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AdverseEventCounterpartiesSort>>;
};

/** Fields to sort AdverseEventCounterparties by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventCounterpartiesSort object. */
export type AdverseEventCounterpartiesSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type AdverseEventCounterpartiesWhere = {
  AND?: InputMaybe<Array<AdverseEventCounterpartiesWhere>>;
  NOT?: InputMaybe<AdverseEventCounterpartiesWhere>;
  OR?: InputMaybe<Array<AdverseEventCounterpartiesWhere>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CounterpartyRole>;
  role_IN?: InputMaybe<Array<CounterpartyRole>>;
};

export enum AdverseEventGrades {
  I = 'I',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  NoInfo = 'NO_INFO'
}

export type AdverseEventReport = {
  __typename?: 'AdverseEventReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEvents: Array<AdverseEventReportItem>;
  agreementId?: Maybe<Scalars['String']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  caseId?: Maybe<Scalars['String']['output']>;
  diseaseName?: Maybe<Scalars['String']['output']>;
  formPreparationBrandName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  indicationCode?: Maybe<Scalars['String']['output']>;
  initials?: Maybe<Scalars['String']['output']>;
  preparationBrandName?: Maybe<Scalars['String']['output']>;
  tags: Array<AgreementTag>;
  therapyStartDate?: Maybe<Scalars['Date']['output']>;
  treatingPhysician?: Maybe<TreatingPhysician>;
  yearOfBirth?: Maybe<Scalars['Int']['output']>;
};

export type AdverseEventReportAggregateSelection = {
  __typename?: 'AdverseEventReportAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  caseId: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  diseaseName: StringAggregateSelectionNullable;
  formPreparationBrandName: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  indicationCode: StringAggregateSelectionNullable;
  initials: StringAggregateSelectionNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  yearOfBirth: IntAggregateSelectionNullable;
};

export type AdverseEventReportEdge = {
  __typename?: 'AdverseEventReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AdverseEventReport;
};

export type AdverseEventReportItem = {
  __typename?: 'AdverseEventReportItem';
  TRAE?: Maybe<Scalars['Boolean']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEvent?: Maybe<AdverseEventType>;
  assessmentDate?: Maybe<Scalars['Date']['output']>;
  doseModification?: Maybe<IrAdverseEventDoseModifications>;
  grade?: Maybe<AdverseEventGrades>;
};

export type AdverseEventReportItemAggregateSelection = {
  __typename?: 'AdverseEventReportItemAggregateSelection';
  count: Scalars['Int']['output'];
};

export type AdverseEventReportItemEdge = {
  __typename?: 'AdverseEventReportItemEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AdverseEventReportItem;
};

export type AdverseEventReportItemOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AdverseEventReportItemSort objects to sort AdverseEventReportItems by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AdverseEventReportItemSort>>;
};

/** Fields to sort AdverseEventReportItems by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventReportItemSort object. */
export type AdverseEventReportItemSort = {
  TRAE?: InputMaybe<SortDirection>;
  adverseEvent?: InputMaybe<SortDirection>;
  assessmentDate?: InputMaybe<SortDirection>;
  doseModification?: InputMaybe<SortDirection>;
  grade?: InputMaybe<SortDirection>;
};

export type AdverseEventReportItemWhere = {
  AND?: InputMaybe<Array<AdverseEventReportItemWhere>>;
  NOT?: InputMaybe<AdverseEventReportItemWhere>;
  OR?: InputMaybe<Array<AdverseEventReportItemWhere>>;
  TRAE?: InputMaybe<Scalars['Boolean']['input']>;
  adverseEvent?: InputMaybe<AdverseEventType>;
  adverseEvent_IN?: InputMaybe<Array<InputMaybe<AdverseEventType>>>;
  assessmentDate?: InputMaybe<Scalars['Date']['input']>;
  assessmentDate_GT?: InputMaybe<Scalars['Date']['input']>;
  assessmentDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  assessmentDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  assessmentDate_LT?: InputMaybe<Scalars['Date']['input']>;
  assessmentDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  doseModification?: InputMaybe<IrAdverseEventDoseModifications>;
  doseModification_IN?: InputMaybe<Array<InputMaybe<IrAdverseEventDoseModifications>>>;
  grade?: InputMaybe<AdverseEventGrades>;
  grade_IN?: InputMaybe<Array<InputMaybe<AdverseEventGrades>>>;
};

export type AdverseEventReportItemsConnection = {
  __typename?: 'AdverseEventReportItemsConnection';
  edges: Array<AdverseEventReportItemEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdverseEventReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AdverseEventReportSort objects to sort AdverseEventReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AdverseEventReportSort>>;
};

/** Fields to sort AdverseEventReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventReportSort object. */
export type AdverseEventReportSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  caseId?: InputMaybe<SortDirection>;
  diseaseName?: InputMaybe<SortDirection>;
  formPreparationBrandName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indicationCode?: InputMaybe<SortDirection>;
  initials?: InputMaybe<SortDirection>;
  preparationBrandName?: InputMaybe<SortDirection>;
  therapyStartDate?: InputMaybe<SortDirection>;
  yearOfBirth?: InputMaybe<SortDirection>;
};

export type AdverseEventReportWhere = {
  AND?: InputMaybe<Array<AdverseEventReportWhere>>;
  NOT?: InputMaybe<AdverseEventReportWhere>;
  OR?: InputMaybe<Array<AdverseEventReportWhere>>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  caseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  diseaseName?: InputMaybe<Scalars['String']['input']>;
  diseaseName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  diseaseName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  diseaseName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  diseaseName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  diseaseName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formPreparationBrandName?: InputMaybe<Scalars['String']['input']>;
  formPreparationBrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formPreparationBrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formPreparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formPreparationBrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formPreparationBrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indicationCode?: InputMaybe<Scalars['String']['input']>;
  indicationCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indicationCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indicationCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indicationCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indicationCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  initials_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initials_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initials_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initials_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initials_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapyStartDate?: InputMaybe<Scalars['Date']['input']>;
  therapyStartDate_GT?: InputMaybe<Scalars['Date']['input']>;
  therapyStartDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  therapyStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  therapyStartDate_LT?: InputMaybe<Scalars['Date']['input']>;
  therapyStartDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  yearOfBirth_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AdverseEventReportsConnection = {
  __typename?: 'AdverseEventReportsConnection';
  edges: Array<AdverseEventReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AdverseEventType {
  AbdominalPain = 'ABDOMINAL_PAIN',
  AcuteHepatitis = 'ACUTE_HEPATITIS',
  Alopecia = 'ALOPECIA',
  AltIncreased = 'ALT_INCREASED',
  Anemia = 'ANEMIA',
  Arthralgia = 'ARTHRALGIA',
  AstIncreased = 'AST_INCREASED',
  BackPain = 'BACK_PAIN',
  BloodCreatinineIncreased = 'BLOOD_CREATININE_INCREASED',
  ChestPain = 'CHEST_PAIN',
  Colitis = 'COLITIS',
  Constipation = 'CONSTIPATION',
  Cough = 'COUGH',
  CreatinineIncreased = 'CREATININE_INCREASED',
  DecreasedAppetite = 'DECREASED_APPETITE',
  DermatologicalToxicity = 'DERMATOLOGICAL_TOXICITY',
  Diarrhoea = 'DIARRHOEA',
  Dizziness = 'DIZZINESS',
  Dysgeusia = 'DYSGEUSIA',
  Dyspepsia = 'DYSPEPSIA',
  Dyspnea = 'DYSPNEA',
  Ecchymosis = 'ECCHYMOSIS',
  Edema = 'EDEMA',
  Endocrinopathies = 'ENDOCRINOPATHIES',
  Epistaxis = 'EPISTAXIS',
  Erythemia = 'ERYTHEMIA',
  Fatique = 'FATIQUE',
  GammaGlutamylTransferaseIncreased = 'GAMMA_GLUTAMYL_TRANSFERASE_INCREASED',
  GlucoseSerumDecreased = 'GLUCOSE_SERUM_DECREASED',
  Headache = 'HEADACHE',
  HemoglobinDecreased = 'HEMOGLOBIN_DECREASED',
  Hepatotoxicity = 'HEPATOTOXICITY',
  Hypertension = 'HYPERTENSION',
  Hypokalemia = 'HYPOKALEMIA',
  Hypopituitarism = 'HYPOPITUITARISM',
  Hypothyroidism = 'HYPOTHYROIDISM',
  Infection = 'INFECTION',
  InjectionSiteReaction = 'INJECTION_SITE_REACTION',
  InterstitialLungDisease = 'INTERSTITIAL_LUNG_DISEASE',
  LeukocytesDecreased = 'LEUKOCYTES_DECREASED',
  Leukopenia = 'LEUKOPENIA',
  LymphocytesDecreased = 'LYMPHOCYTES_DECREASED',
  MusculoskeletalPain = 'MUSCULOSKELETAL_PAIN',
  Myocarditis = 'MYOCARDITIS',
  Nausea = 'NAUSEA',
  NeurologicToxicity = 'NEUROLOGIC_TOXICITY',
  Neutropenia = 'NEUTROPENIA',
  NeutrophilsDecreased = 'NEUTROPHILS_DECREASED',
  NoInfo = 'NO_INFO',
  PainInExtremity = 'PAIN_IN_EXTREMITY',
  PeripheralEdema = 'PERIPHERAL_EDEMA',
  PhotosensitivityReaction = 'PHOTOSENSITIVITY_REACTION',
  PlateletsDecreased = 'PLATELETS_DECREASED',
  Pneumonitis = 'PNEUMONITIS',
  Proteinuria = 'PROTEINURIA',
  Pruritus = 'PRURITUS',
  Pyrexia = 'PYREXIA',
  Rash = 'RASH',
  RenalToxicity = 'RENAL_TOXICITY',
  RespiratoryTractInfection = 'RESPIRATORY_TRACT_INFECTION',
  Somnolence = 'SOMNOLENCE',
  Stomatitis = 'STOMATITIS',
  SystemicHypertension = 'SYSTEMIC_HYPERTENSION',
  Thrombocytopenia = 'THROMBOCYTOPENIA',
  ViralInfection = 'VIRAL_INFECTION',
  Vomiting = 'VOMITING'
}

export type AdverseEventsOccurenceReport = {
  __typename?: 'AdverseEventsOccurenceReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEvent?: Maybe<AdverseEventType>;
  gradeICount?: Maybe<Scalars['Int']['output']>;
  gradeIICount?: Maybe<Scalars['Int']['output']>;
  gradeIIICount?: Maybe<Scalars['Int']['output']>;
  gradeIVCount?: Maybe<Scalars['Int']['output']>;
};

export type AdverseEventsOccurenceReportAggregateSelection = {
  __typename?: 'AdverseEventsOccurenceReportAggregateSelection';
  count: Scalars['Int']['output'];
  gradeICount: IntAggregateSelectionNullable;
  gradeIICount: IntAggregateSelectionNullable;
  gradeIIICount: IntAggregateSelectionNullable;
  gradeIVCount: IntAggregateSelectionNullable;
};

export type AdverseEventsOccurenceReportEdge = {
  __typename?: 'AdverseEventsOccurenceReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AdverseEventsOccurenceReport;
};

export type AdverseEventsOccurenceReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AdverseEventsOccurenceReportSort objects to sort AdverseEventsOccurenceReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AdverseEventsOccurenceReportSort>>;
};

/** Fields to sort AdverseEventsOccurenceReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one AdverseEventsOccurenceReportSort object. */
export type AdverseEventsOccurenceReportSort = {
  adverseEvent?: InputMaybe<SortDirection>;
  gradeICount?: InputMaybe<SortDirection>;
  gradeIICount?: InputMaybe<SortDirection>;
  gradeIIICount?: InputMaybe<SortDirection>;
  gradeIVCount?: InputMaybe<SortDirection>;
};

export type AdverseEventsOccurenceReportWhere = {
  AND?: InputMaybe<Array<AdverseEventsOccurenceReportWhere>>;
  NOT?: InputMaybe<AdverseEventsOccurenceReportWhere>;
  OR?: InputMaybe<Array<AdverseEventsOccurenceReportWhere>>;
  adverseEvent?: InputMaybe<AdverseEventType>;
  adverseEvent_IN?: InputMaybe<Array<InputMaybe<AdverseEventType>>>;
  gradeICount?: InputMaybe<Scalars['Int']['input']>;
  gradeICount_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeICount_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeICount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  gradeICount_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeICount_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeIICount?: InputMaybe<Scalars['Int']['input']>;
  gradeIICount_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeIICount_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeIICount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  gradeIICount_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeIICount_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeIIICount?: InputMaybe<Scalars['Int']['input']>;
  gradeIIICount_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeIIICount_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeIIICount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  gradeIIICount_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeIIICount_LTE?: InputMaybe<Scalars['Int']['input']>;
  gradeIVCount?: InputMaybe<Scalars['Int']['input']>;
  gradeIVCount_GT?: InputMaybe<Scalars['Int']['input']>;
  gradeIVCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  gradeIVCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  gradeIVCount_LT?: InputMaybe<Scalars['Int']['input']>;
  gradeIVCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AdverseEventsOccurenceReportsConnection = {
  __typename?: 'AdverseEventsOccurenceReportsConnection';
  edges: Array<AdverseEventsOccurenceReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Agreement = {
  __typename?: 'Agreement';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  allowedForms?: Maybe<Array<Scalars['String']['output']>>;
  allowedRecords?: Maybe<Array<Scalars['String']['output']>>;
  canParticipateInApproval: Scalars['Boolean']['output'];
  canUserViewFinancials: Scalars['Boolean']['output'];
  counterpartyRoles: Array<Organization>;
  counterpartyRolesAggregate?: Maybe<AgreementOrganizationCounterpartyRolesAggregationSelection>;
  counterpartyRolesConnection: AgreementCounterpartyRolesConnection;
  country: Country;
  countryAggregate?: Maybe<AgreementCountryCountryAggregationSelection>;
  countryConnection: AgreementCountryConnection;
  currency: Currency;
  currencyAggregate?: Maybe<AgreementCurrencyCurrencyAggregationSelection>;
  currencyConnection: AgreementCurrencyConnection;
  dataContainers: Array<DataContainer>;
  dataContainersAggregate?: Maybe<AgreementDataContainerDataContainersAggregationSelection>;
  dataContainersConnection: AgreementDataContainersConnection;
  daysToExpiry?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceAlternativeSets: Array<DeviceAlternative>;
  deviceAlternativeSetsAggregate?: Maybe<AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  deviceAlternativeSetsConnection: AgreementDeviceAlternativeSetsConnection;
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<AgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: AgreementFinancialDataPointsConnection;
  formattedAmount?: Maybe<Scalars['String']['output']>;
  formattedCounterparties?: Maybe<Scalars['String']['output']>;
  formattedDiseases?: Maybe<Scalars['String']['output']>;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  formattedProducts?: Maybe<Scalars['String']['output']>;
  formattedTags: Scalars['String']['output'];
  formattedValidityPeriod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialVersionId: Scalars['String']['output'];
  isApprovedByOrganization: Scalars['Boolean']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isCaseless: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  isFirstVersion: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isInsightsAvailable?: Maybe<Scalars['Boolean']['output']>;
  isLastVersion: Scalars['Boolean']['output'];
  isStobContract: Scalars['Boolean']['output'];
  lastVersionStatus?: Maybe<ContractStatus>;
  lastVersionValidToDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  negotiableAttributes: Array<CatalogueAttribute>;
  negotiableAttributesAggregate?: Maybe<AgreementCatalogueAttributeNegotiableAttributesAggregationSelection>;
  negotiableAttributesConnection: AgreementNegotiableAttributesConnection;
  nextVersions: Array<Agreement>;
  nextVersionsAggregate?: Maybe<AgreementAgreementNextVersionsAggregationSelection>;
  nextVersionsConnection: AgreementNextVersionsConnection;
  pushedOn?: Maybe<Scalars['DateTime']['output']>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<AgreementScenarioScenariosAggregationSelection>;
  scenariosConnection: AgreementScenariosConnection;
  status?: Maybe<ContractStatus>;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<AgreementAgreementTagTagsAggregationSelection>;
  tagsConnection: AgreementTagsConnection;
  tenantIds?: Maybe<Array<Scalars['String']['output']>>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  userOrganizationRole?: Maybe<CounterpartyRole>;
  userRoles: Array<User>;
  userRolesAggregate?: Maybe<AgreementUserUserRolesAggregationSelection>;
  userRolesConnection: AgreementUserRolesConnection;
  validFromDate: Scalars['Date']['output'];
  validToDate?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
  workflows: Array<ContractWorkflow>;
  workflowsAggregate?: Maybe<AgreementContractWorkflowWorkflowsAggregationSelection>;
  workflowsConnection: AgreementWorkflowsConnection;
};


export type AgreementCounterpartyRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementCounterpartyRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementCounterpartyRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCounterpartyRolesConnectionSort>>;
  where?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
};


export type AgreementCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCountryConnectionSort>>;
  where?: InputMaybe<AgreementCountryConnectionWhere>;
};


export type AgreementCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementCurrencyConnectionSort>>;
  where?: InputMaybe<AgreementCurrencyConnectionWhere>;
};


export type AgreementDataContainersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataContainerOptions>;
  where?: InputMaybe<DataContainerWhere>;
};


export type AgreementDataContainersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataContainerWhere>;
};


export type AgreementDataContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDataContainersConnectionSort>>;
  where?: InputMaybe<AgreementDataContainersConnectionWhere>;
};


export type AgreementDeviceAlternativeSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementDeviceAlternativeSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementDeviceAlternativeSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionSort>>;
  where?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
};


export type AgreementFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type AgreementFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type AgreementFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<AgreementFinancialDataPointsConnectionWhere>;
};


export type AgreementNegotiableAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementNegotiableAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementNegotiableAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementNegotiableAttributesConnectionSort>>;
  where?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
};


export type AgreementNextVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementNextVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementNextVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementNextVersionsConnectionSort>>;
  where?: InputMaybe<AgreementNextVersionsConnectionWhere>;
};


export type AgreementScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScenariosConnectionSort>>;
  where?: InputMaybe<AgreementScenariosConnectionWhere>;
};


export type AgreementTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTagsConnectionSort>>;
  where?: InputMaybe<AgreementTagsConnectionWhere>;
};


export type AgreementUserRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementUserRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementUserRolesConnectionSort>>;
  where?: InputMaybe<AgreementUserRolesConnectionWhere>;
};


export type AgreementWorkflowsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ContractWorkflowOptions>;
  where?: InputMaybe<ContractWorkflowWhere>;
};


export type AgreementWorkflowsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContractWorkflowWhere>;
};


export type AgreementWorkflowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementWorkflowsConnectionSort>>;
  where?: InputMaybe<AgreementWorkflowsConnectionWhere>;
};

export type AgreementAggregateSelection = {
  __typename?: 'AgreementAggregateSelection';
  count: Scalars['Int']['output'];
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementAgreementNextVersionsAggregationSelection = {
  __typename?: 'AgreementAgreementNextVersionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementAgreementNextVersionsNodeAggregateSelection>;
};

export type AgreementAgreementNextVersionsNodeAggregateSelection = {
  __typename?: 'AgreementAgreementNextVersionsNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementAgreementTagTagsAggregationSelection = {
  __typename?: 'AgreementAgreementTagTagsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementAgreementTagTagsNodeAggregateSelection>;
};

export type AgreementAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'AgreementAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementCatalogueAttributeNegotiableAttributesAggregationSelection = {
  __typename?: 'AgreementCatalogueAttributeNegotiableAttributesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
};

export type AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection = {
  __typename?: 'AgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type AgreementContractWorkflowWorkflowsAggregationSelection = {
  __typename?: 'AgreementContractWorkflowWorkflowsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export type AgreementCounterpartyRolesAggregateInput = {
  AND?: InputMaybe<Array<AgreementCounterpartyRolesAggregateInput>>;
  NOT?: InputMaybe<AgreementCounterpartyRolesAggregateInput>;
  OR?: InputMaybe<Array<AgreementCounterpartyRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCounterpartyRolesNodeAggregationWhereInput>;
};

export type AgreementCounterpartyRolesConnection = {
  __typename?: 'AgreementCounterpartyRolesConnection';
  edges: Array<AgreementCounterpartyRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCounterpartyRolesConnectionSort = {
  edge?: InputMaybe<CounterpartyRoleRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementCounterpartyRolesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCounterpartyRolesConnectionWhere>>;
  NOT?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCounterpartyRolesConnectionWhere>>;
  edge?: InputMaybe<CounterpartyRoleRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementCounterpartyRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCounterpartyRolesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementCounterpartyRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementCounterpartyRolesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCounterpartyRolesRelationship = CounterpartyRoleRelationship & {
  __typename?: 'AgreementCounterpartyRolesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
  role: CounterpartyRole;
};

export type AgreementCountryAggregateInput = {
  AND?: InputMaybe<Array<AgreementCountryAggregateInput>>;
  NOT?: InputMaybe<AgreementCountryAggregateInput>;
  OR?: InputMaybe<Array<AgreementCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCountryNodeAggregationWhereInput>;
};

export type AgreementCountryConnection = {
  __typename?: 'AgreementCountryConnection';
  edges: Array<AgreementCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type AgreementCountryConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCountryConnectionWhere>>;
  NOT?: InputMaybe<AgreementCountryConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type AgreementCountryCountryAggregationSelection = {
  __typename?: 'AgreementCountryCountryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCountryCountryNodeAggregateSelection>;
};

export type AgreementCountryCountryNodeAggregateSelection = {
  __typename?: 'AgreementCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type AgreementCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCountryRelationship = {
  __typename?: 'AgreementCountryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type AgreementCurrencyAggregateInput = {
  AND?: InputMaybe<Array<AgreementCurrencyAggregateInput>>;
  NOT?: InputMaybe<AgreementCurrencyAggregateInput>;
  OR?: InputMaybe<Array<AgreementCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementCurrencyNodeAggregationWhereInput>;
};

export type AgreementCurrencyConnection = {
  __typename?: 'AgreementCurrencyConnection';
  edges: Array<AgreementCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type AgreementCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<AgreementCurrencyConnectionWhere>>;
  NOT?: InputMaybe<AgreementCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<AgreementCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type AgreementCurrencyCurrencyAggregationSelection = {
  __typename?: 'AgreementCurrencyCurrencyAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementCurrencyCurrencyNodeAggregateSelection>;
};

export type AgreementCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'AgreementCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type AgreementCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementCurrencyRelationship = {
  __typename?: 'AgreementCurrencyRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Currency;
};

export enum AgreementDashboardTarget {
  Buyer = 'BUYER',
  Mixed = 'MIXED',
  Seller = 'SELLER'
}

export type AgreementDataContainerDataContainersAggregationSelection = {
  __typename?: 'AgreementDataContainerDataContainersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDataContainerDataContainersNodeAggregateSelection>;
};

export type AgreementDataContainerDataContainersNodeAggregateSelection = {
  __typename?: 'AgreementDataContainerDataContainersNodeAggregateSelection';
  subType: StringAggregateSelectionNonNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
};

export type AgreementDataContainersAggregateInput = {
  AND?: InputMaybe<Array<AgreementDataContainersAggregateInput>>;
  NOT?: InputMaybe<AgreementDataContainersAggregateInput>;
  OR?: InputMaybe<Array<AgreementDataContainersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDataContainersNodeAggregationWhereInput>;
};

export type AgreementDataContainersConnection = {
  __typename?: 'AgreementDataContainersConnection';
  edges: Array<AgreementDataContainersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDataContainersConnectionSort = {
  node?: InputMaybe<DataContainerSort>;
};

export type AgreementDataContainersConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDataContainersConnectionWhere>>;
  NOT?: InputMaybe<AgreementDataContainersConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDataContainersConnectionWhere>>;
  node?: InputMaybe<DataContainerWhere>;
};

export type AgreementDataContainersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDataContainersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDataContainersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDataContainersNodeAggregationWhereInput>>;
  subType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDataContainersRelationship = {
  __typename?: 'AgreementDataContainersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DataContainer;
};

export type AgreementDecision = {
  __typename?: 'AgreementDecision';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  asOf: Organization;
  asOfAggregate?: Maybe<AgreementDecisionOrganizationAsOfAggregationSelection>;
  asOfConnection: AgreementDecisionAsOfConnection;
  createdOn: Scalars['DateTime']['output'];
  decision: Decision;
  isArchived: Scalars['Boolean']['output'];
  madeBy: User;
  madeByAggregate?: Maybe<AgreementDecisionUserMadeByAggregationSelection>;
  madeByConnection: AgreementDecisionMadeByConnection;
};


export type AgreementDecisionAsOfArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementDecisionAsOfAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementDecisionAsOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDecisionAsOfConnectionSort>>;
  where?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
};


export type AgreementDecisionMadeByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementDecisionMadeByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementDecisionMadeByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementDecisionMadeByConnectionSort>>;
  where?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
};

export type AgreementDecisionAggregateSelection = {
  __typename?: 'AgreementDecisionAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
};

export type AgreementDecisionAsOfAggregateInput = {
  AND?: InputMaybe<Array<AgreementDecisionAsOfAggregateInput>>;
  NOT?: InputMaybe<AgreementDecisionAsOfAggregateInput>;
  OR?: InputMaybe<Array<AgreementDecisionAsOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDecisionAsOfNodeAggregationWhereInput>;
};

export type AgreementDecisionAsOfConnection = {
  __typename?: 'AgreementDecisionAsOfConnection';
  edges: Array<AgreementDecisionAsOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDecisionAsOfConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementDecisionAsOfConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDecisionAsOfConnectionWhere>>;
  NOT?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDecisionAsOfConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementDecisionAsOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDecisionAsOfNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementDecisionAsOfNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDecisionAsOfNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDecisionAsOfRelationship = {
  __typename?: 'AgreementDecisionAsOfRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type AgreementDecisionEdge = {
  __typename?: 'AgreementDecisionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementDecision;
};

export type AgreementDecisionInput = {
  agreementId: Scalars['ID']['input'];
  decision: Decision;
};

export type AgreementDecisionMadeByAggregateInput = {
  AND?: InputMaybe<Array<AgreementDecisionMadeByAggregateInput>>;
  NOT?: InputMaybe<AgreementDecisionMadeByAggregateInput>;
  OR?: InputMaybe<Array<AgreementDecisionMadeByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDecisionMadeByNodeAggregationWhereInput>;
};

export type AgreementDecisionMadeByConnection = {
  __typename?: 'AgreementDecisionMadeByConnection';
  edges: Array<AgreementDecisionMadeByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDecisionMadeByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementDecisionMadeByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDecisionMadeByConnectionWhere>>;
  NOT?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDecisionMadeByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementDecisionMadeByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDecisionMadeByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDecisionMadeByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDecisionMadeByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDecisionMadeByRelationship = {
  __typename?: 'AgreementDecisionMadeByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementDecisionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementDecisionSort objects to sort AgreementDecisions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementDecisionSort>>;
};

export type AgreementDecisionOrganizationAsOfAggregationSelection = {
  __typename?: 'AgreementDecisionOrganizationAsOfAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDecisionOrganizationAsOfNodeAggregateSelection>;
};

export type AgreementDecisionOrganizationAsOfNodeAggregateSelection = {
  __typename?: 'AgreementDecisionOrganizationAsOfNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

/** Fields to sort AgreementDecisions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementDecisionSort object. */
export type AgreementDecisionSort = {
  createdOn?: InputMaybe<SortDirection>;
  decision?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
};

export type AgreementDecisionUserMadeByAggregationSelection = {
  __typename?: 'AgreementDecisionUserMadeByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDecisionUserMadeByNodeAggregateSelection>;
};

export type AgreementDecisionUserMadeByNodeAggregateSelection = {
  __typename?: 'AgreementDecisionUserMadeByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementDecisionWhere = {
  AND?: InputMaybe<Array<AgreementDecisionWhere>>;
  NOT?: InputMaybe<AgreementDecisionWhere>;
  OR?: InputMaybe<Array<AgreementDecisionWhere>>;
  asOf?: InputMaybe<OrganizationWhere>;
  asOfAggregate?: InputMaybe<AgreementDecisionAsOfAggregateInput>;
  asOfConnection?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
  asOfConnection_NOT?: InputMaybe<AgreementDecisionAsOfConnectionWhere>;
  asOf_NOT?: InputMaybe<OrganizationWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<Decision>;
  decision_IN?: InputMaybe<Array<Decision>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  madeBy?: InputMaybe<UserWhere>;
  madeByAggregate?: InputMaybe<AgreementDecisionMadeByAggregateInput>;
  madeByConnection?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
  madeByConnection_NOT?: InputMaybe<AgreementDecisionMadeByConnectionWhere>;
  madeBy_NOT?: InputMaybe<UserWhere>;
};

export type AgreementDecisionsConnection = {
  __typename?: 'AgreementDecisionsConnection';
  edges: Array<AgreementDecisionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection = {
  __typename?: 'AgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
};

export type AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection = {
  __typename?: 'AgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
};

export type AgreementDeviceAlternativeSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementDeviceAlternativeSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type AgreementDeviceAlternativeSetsConnection = {
  __typename?: 'AgreementDeviceAlternativeSetsConnection';
  edges: Array<AgreementDeviceAlternativeSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementDeviceAlternativeSetsConnectionSort = {
  node?: InputMaybe<DeviceAlternativeSort>;
};

export type AgreementDeviceAlternativeSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsConnectionWhere>>;
  node?: InputMaybe<DeviceAlternativeWhere>;
};

export type AgreementDeviceAlternativeSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementDeviceAlternativeSetsRelationship = {
  __typename?: 'AgreementDeviceAlternativeSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<AgreementFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<AgreementFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<AgreementFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementFinancialDataPointsNodeAggregationWhereInput>;
};

export type AgreementFinancialDataPointsConnection = {
  __typename?: 'AgreementFinancialDataPointsConnection';
  edges: Array<AgreementFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type AgreementFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<AgreementFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type AgreementFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementFinancialDataPointsRelationship = {
  __typename?: 'AgreementFinancialDataPointsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type AgreementFinancialSummaryColumnRelationship = {
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AgreementFinancialSummaryColumnRelationshipSort = {
  hasHelpMessage?: InputMaybe<SortDirection>;
  isIncluded?: InputMaybe<SortDirection>;
  localizationKey?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
};

export type AgreementFinancialSummaryColumnRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementFinancialSummaryColumnRelationshipWhere>>;
  NOT?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementFinancialSummaryColumnRelationshipWhere>>;
  hasHelpMessage?: InputMaybe<Scalars['Boolean']['input']>;
  isIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  localizationKey?: InputMaybe<Scalars['String']['input']>;
  localizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  localizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  localizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  localizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  localizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_GT?: InputMaybe<Scalars['Int']['input']>;
  position_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  position_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'AgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type AgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'AgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type AgreementNegotiableAttributesAggregateInput = {
  AND?: InputMaybe<Array<AgreementNegotiableAttributesAggregateInput>>;
  NOT?: InputMaybe<AgreementNegotiableAttributesAggregateInput>;
  OR?: InputMaybe<Array<AgreementNegotiableAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementNegotiableAttributesNodeAggregationWhereInput>;
};

export type AgreementNegotiableAttributesConnection = {
  __typename?: 'AgreementNegotiableAttributesConnection';
  edges: Array<AgreementNegotiableAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementNegotiableAttributesConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type AgreementNegotiableAttributesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementNegotiableAttributesConnectionWhere>>;
  NOT?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementNegotiableAttributesConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type AgreementNegotiableAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementNegotiableAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementNegotiableAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementNegotiableAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementNegotiableAttributesRelationship = {
  __typename?: 'AgreementNegotiableAttributesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type AgreementNextVersionsAggregateInput = {
  AND?: InputMaybe<Array<AgreementNextVersionsAggregateInput>>;
  NOT?: InputMaybe<AgreementNextVersionsAggregateInput>;
  OR?: InputMaybe<Array<AgreementNextVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementNextVersionsNodeAggregationWhereInput>;
};

export type AgreementNextVersionsConnection = {
  __typename?: 'AgreementNextVersionsConnection';
  edges: Array<AgreementNextVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementNextVersionsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type AgreementNextVersionsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementNextVersionsConnectionWhere>>;
  NOT?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementNextVersionsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type AgreementNextVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementNextVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementNextVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementNextVersionsNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementNextVersionsRelationship = {
  __typename?: 'AgreementNextVersionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementSort objects to sort Agreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementSort>>;
};

export type AgreementOrganizationCounterpartyRolesAggregationSelection = {
  __typename?: 'AgreementOrganizationCounterpartyRolesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementOrganizationCounterpartyRolesNodeAggregateSelection>;
};

export type AgreementOrganizationCounterpartyRolesNodeAggregateSelection = {
  __typename?: 'AgreementOrganizationCounterpartyRolesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type AgreementReport = {
  __typename?: 'AgreementReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEventsOccurenceData?: Maybe<Array<AdverseEventsOccurenceReport>>;
  averageLdlDiscount?: Maybe<Scalars['Float']['output']>;
  averageLdlLevel?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountDelta?: Maybe<Scalars['Float']['output']>;
  discountRatio?: Maybe<Scalars['Float']['output']>;
  discountRatioDelta?: Maybe<Scalars['Float']['output']>;
  dotThresholds: Array<Scalars['Int']['output']>;
  durationDays?: Maybe<Scalars['Int']['output']>;
  durationDaysDiscontinued?: Maybe<Scalars['Int']['output']>;
  enabledWidgetTypes: Array<WidgetType>;
  expenditureDistributionDataPoints: Array<ExpenditureDistributionDataPoint>;
  financialReportDataPoints: Array<FinancialReportDataPoint>;
  financialSummaryRows: Array<FinancialSummaryRow>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  grossAmountDelta?: Maybe<Scalars['Float']['output']>;
  initialResponseReviewData?: Maybe<Array<InitialResponseReviewReport>>;
  ldlReportingData: Array<LdLReportingDataPoint>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  organizationNetRevenues: Array<NetRevenueByOrganization>;
  patientReportDataPoints: Array<PatientReportDataPoint>;
  patientReviewData?: Maybe<PatientReviewData>;
  patientsWithAE?: Maybe<Scalars['Float']['output']>;
  progressionFreePatients?: Maybe<Scalars['Float']['output']>;
  reasonOfTreatmentDiscontinuationData?: Maybe<Array<ReasonOfTreatmentDiscontinuationReport>>;
  totalPatients?: Maybe<Scalars['Int']['output']>;
  totalResponse?: Maybe<Scalars['Int']['output']>;
  treatmentDurationData: Array<CaseReportDataPoint>;
  treatmentPatients: Array<TreatmentPatient>;
};

export type AgreementReportAggregateSelection = {
  __typename?: 'AgreementReportAggregateSelection';
  averageLdlDiscount: FloatAggregateSelectionNullable;
  averageLdlLevel: FloatAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNullable;
  discountAmountDelta: FloatAggregateSelectionNullable;
  discountRatio: FloatAggregateSelectionNullable;
  discountRatioDelta: FloatAggregateSelectionNullable;
  durationDays: IntAggregateSelectionNullable;
  durationDaysDiscontinued: IntAggregateSelectionNullable;
  grossAmount: FloatAggregateSelectionNullable;
  grossAmountDelta: FloatAggregateSelectionNullable;
  netAmount: FloatAggregateSelectionNullable;
  patientsWithAE: FloatAggregateSelectionNullable;
  progressionFreePatients: FloatAggregateSelectionNullable;
  totalPatients: IntAggregateSelectionNullable;
  totalResponse: IntAggregateSelectionNullable;
};

export type AgreementReportEdge = {
  __typename?: 'AgreementReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementReport;
};

export type AgreementReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementReportSort objects to sort AgreementReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementReportSort>>;
};

/** Fields to sort AgreementReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementReportSort object. */
export type AgreementReportSort = {
  averageLdlDiscount?: InputMaybe<SortDirection>;
  averageLdlLevel?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  discountAmountDelta?: InputMaybe<SortDirection>;
  discountRatio?: InputMaybe<SortDirection>;
  discountRatioDelta?: InputMaybe<SortDirection>;
  durationDays?: InputMaybe<SortDirection>;
  durationDaysDiscontinued?: InputMaybe<SortDirection>;
  grossAmount?: InputMaybe<SortDirection>;
  grossAmountDelta?: InputMaybe<SortDirection>;
  netAmount?: InputMaybe<SortDirection>;
  patientsWithAE?: InputMaybe<SortDirection>;
  progressionFreePatients?: InputMaybe<SortDirection>;
  totalPatients?: InputMaybe<SortDirection>;
  totalResponse?: InputMaybe<SortDirection>;
};

export type AgreementReportWhere = {
  AND?: InputMaybe<Array<AgreementReportWhere>>;
  NOT?: InputMaybe<AgreementReportWhere>;
  OR?: InputMaybe<Array<AgreementReportWhere>>;
  averageLdlDiscount?: InputMaybe<Scalars['Float']['input']>;
  averageLdlDiscount_GT?: InputMaybe<Scalars['Float']['input']>;
  averageLdlDiscount_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageLdlDiscount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  averageLdlDiscount_LT?: InputMaybe<Scalars['Float']['input']>;
  averageLdlDiscount_LTE?: InputMaybe<Scalars['Float']['input']>;
  averageLdlLevel?: InputMaybe<Scalars['Float']['input']>;
  averageLdlLevel_GT?: InputMaybe<Scalars['Float']['input']>;
  averageLdlLevel_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageLdlLevel_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  averageLdlLevel_LT?: InputMaybe<Scalars['Float']['input']>;
  averageLdlLevel_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatioDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatio_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_LTE?: InputMaybe<Scalars['Float']['input']>;
  dotThresholds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dotThresholds_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_GT?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationDaysDiscontinued_LT?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_LTE?: InputMaybe<Scalars['Int']['input']>;
  durationDays_GT?: InputMaybe<Scalars['Int']['input']>;
  durationDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationDays_LT?: InputMaybe<Scalars['Int']['input']>;
  durationDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  enabledWidgetTypes?: InputMaybe<Array<WidgetType>>;
  enabledWidgetTypes_INCLUDES?: InputMaybe<WidgetType>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  netAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_GT?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  patientsWithAE_LT?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_LTE?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_GT?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_GTE?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  progressionFreePatients_LT?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPatients?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_GT?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalPatients_LT?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalResponse?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_GT?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalResponse_LT?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementReportsConnection = {
  __typename?: 'AgreementReportsConnection';
  edges: Array<AgreementReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRun = {
  __typename?: 'AgreementRun';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAgreementRunSubscriptionActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: AgreementRunStatus;
  tenantIds: Array<Scalars['String']['output']>;
};

export type AgreementRunAggregateSelection = {
  __typename?: 'AgreementRunAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
};

export type AgreementRunAttemptInfo = {
  __typename?: 'AgreementRunAttemptInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementIdsToBeAttempted: Array<Scalars['String']['output']>;
  attemptedAgreementCount?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  failedAgreementIds: Array<Scalars['String']['output']>;
  filtersAppliedForRun?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBulkRun?: Maybe<Scalars['Boolean']['output']>;
  nonAttemptedAgreementCount?: Maybe<Scalars['Int']['output']>;
  organizationTriggered?: Maybe<Organization>;
  organizationTriggeredAggregate?: Maybe<AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection>;
  organizationTriggeredConnection: AgreementRunAttemptInfoOrganizationTriggeredConnection;
  runEnd?: Maybe<Scalars['DateTime']['output']>;
  runInitiator?: Maybe<User>;
  runInitiatorAggregate?: Maybe<AgreementRunAttemptInfoUserRunInitiatorAggregationSelection>;
  runInitiatorConnection: AgreementRunAttemptInfoRunInitiatorConnection;
  runStart?: Maybe<Scalars['DateTime']['output']>;
  succeededCount?: Maybe<Scalars['Int']['output']>;
  triggeredEvent?: Maybe<AgreementRunTrigger>;
};


export type AgreementRunAttemptInfoOrganizationTriggeredArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementRunAttemptInfoOrganizationTriggeredAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementRunAttemptInfoOrganizationTriggeredConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredConnectionSort>>;
  where?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
};


export type AgreementRunAttemptInfoRunInitiatorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementRunAttemptInfoRunInitiatorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementRunAttemptInfoRunInitiatorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorConnectionSort>>;
  where?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
};

export type AgreementRunAttemptInfoAggregateSelection = {
  __typename?: 'AgreementRunAttemptInfoAggregateSelection';
  attemptedAgreementCount: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  filtersAppliedForRun: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  nonAttemptedAgreementCount: IntAggregateSelectionNullable;
  runEnd: DateTimeAggregateSelectionNullable;
  runStart: DateTimeAggregateSelectionNullable;
  succeededCount: IntAggregateSelectionNullable;
};

export type AgreementRunAttemptInfoEdge = {
  __typename?: 'AgreementRunAttemptInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementRunAttemptInfo;
};

export type AgreementRunAttemptInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementRunAttemptInfoSort objects to sort AgreementRunAttemptInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementRunAttemptInfoSort>>;
};

export type AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection = {
  __typename?: 'AgreementRunAttemptInfoOrganizationOrganizationTriggeredAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection>;
};

export type AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection = {
  __typename?: 'AgreementRunAttemptInfoOrganizationOrganizationTriggeredNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type AgreementRunAttemptInfoOrganizationTriggeredAggregateInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnection = {
  __typename?: 'AgreementRunAttemptInfoOrganizationTriggeredConnection';
  edges: Array<AgreementRunAttemptInfoOrganizationTriggeredRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoOrganizationTriggeredNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementRunAttemptInfoOrganizationTriggeredRelationship = {
  __typename?: 'AgreementRunAttemptInfoOrganizationTriggeredRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type AgreementRunAttemptInfoRunInitiatorAggregateInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorAggregateInput>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorAggregateInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>;
};

export type AgreementRunAttemptInfoRunInitiatorConnection = {
  __typename?: 'AgreementRunAttemptInfoRunInitiatorConnection';
  edges: Array<AgreementRunAttemptInfoRunInitiatorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRunAttemptInfoRunInitiatorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementRunAttemptInfoRunInitiatorConnectionWhere = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorConnectionWhere>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoRunInitiatorNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementRunAttemptInfoRunInitiatorRelationship = {
  __typename?: 'AgreementRunAttemptInfoRunInitiatorRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

/** Fields to sort AgreementRunAttemptInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementRunAttemptInfoSort object. */
export type AgreementRunAttemptInfoSort = {
  attemptedAgreementCount?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  filtersAppliedForRun?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isBulkRun?: InputMaybe<SortDirection>;
  nonAttemptedAgreementCount?: InputMaybe<SortDirection>;
  runEnd?: InputMaybe<SortDirection>;
  runStart?: InputMaybe<SortDirection>;
  succeededCount?: InputMaybe<SortDirection>;
  triggeredEvent?: InputMaybe<SortDirection>;
};

export type AgreementRunAttemptInfoUserRunInitiatorAggregationSelection = {
  __typename?: 'AgreementRunAttemptInfoUserRunInitiatorAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection>;
};

export type AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection = {
  __typename?: 'AgreementRunAttemptInfoUserRunInitiatorNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementRunAttemptInfoWhere = {
  AND?: InputMaybe<Array<AgreementRunAttemptInfoWhere>>;
  NOT?: InputMaybe<AgreementRunAttemptInfoWhere>;
  OR?: InputMaybe<Array<AgreementRunAttemptInfoWhere>>;
  agreementIdsToBeAttempted?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementIdsToBeAttempted_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  attemptedAgreementCount?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  attemptedAgreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  failedAgreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  failedAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersAppliedForRun_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersAppliedForRun_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isBulkRun?: InputMaybe<Scalars['Boolean']['input']>;
  nonAttemptedAgreementCount?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nonAttemptedAgreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationTriggered?: InputMaybe<OrganizationWhere>;
  organizationTriggeredAggregate?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredAggregateInput>;
  organizationTriggeredConnection?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
  organizationTriggeredConnection_NOT?: InputMaybe<AgreementRunAttemptInfoOrganizationTriggeredConnectionWhere>;
  organizationTriggered_NOT?: InputMaybe<OrganizationWhere>;
  runEnd?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  runEnd_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runInitiator?: InputMaybe<UserWhere>;
  runInitiatorAggregate?: InputMaybe<AgreementRunAttemptInfoRunInitiatorAggregateInput>;
  runInitiatorConnection?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
  runInitiatorConnection_NOT?: InputMaybe<AgreementRunAttemptInfoRunInitiatorConnectionWhere>;
  runInitiator_NOT?: InputMaybe<UserWhere>;
  runStart?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  runStart_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  succeededCount?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  succeededCount_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredEvent?: InputMaybe<AgreementRunTrigger>;
  triggeredEvent_IN?: InputMaybe<Array<InputMaybe<AgreementRunTrigger>>>;
};

export type AgreementRunAttemptInfosConnection = {
  __typename?: 'AgreementRunAttemptInfosConnection';
  edges: Array<AgreementRunAttemptInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementRunEdge = {
  __typename?: 'AgreementRunEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementRun;
};

export enum AgreementRunFrequency {
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Nightly = 'NIGHTLY',
  Weekly = 'WEEKLY'
}

export type AgreementRunOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementRunSort objects to sort AgreementRuns by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementRunSort>>;
};

/** Fields to sort AgreementRuns by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementRunSort object. */
export type AgreementRunSort = {
  id?: InputMaybe<SortDirection>;
  isAgreementRunSubscriptionActive?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export enum AgreementRunStatus {
  Executed = 'EXECUTED',
  InExecution = 'IN_EXECUTION'
}

export enum AgreementRunTrigger {
  AutomatedRun = 'AUTOMATED_RUN',
  DataAdditionManual = 'DATA_ADDITION_MANUAL',
  DataAdditionUpload = 'DATA_ADDITION_UPLOAD',
  DataEditionDeletionManual = 'DATA_EDITION_DELETION_MANUAL',
  DataEditionDeletionUpload = 'DATA_EDITION_DELETION_UPLOAD'
}

export type AgreementRunWhere = {
  AND?: InputMaybe<Array<AgreementRunWhere>>;
  NOT?: InputMaybe<AgreementRunWhere>;
  OR?: InputMaybe<Array<AgreementRunWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAgreementRunSubscriptionActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AgreementRunStatus>;
  status_IN?: InputMaybe<Array<AgreementRunStatus>>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementRunsConnection = {
  __typename?: 'AgreementRunsConnection';
  edges: Array<AgreementRunEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScenarioScenariosAggregationSelection = {
  __typename?: 'AgreementScenarioScenariosAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScenarioScenariosNodeAggregateSelection>;
};

export type AgreementScenarioScenariosNodeAggregateSelection = {
  __typename?: 'AgreementScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScenariosAggregateInput = {
  AND?: InputMaybe<Array<AgreementScenariosAggregateInput>>;
  NOT?: InputMaybe<AgreementScenariosAggregateInput>;
  OR?: InputMaybe<Array<AgreementScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScenariosNodeAggregationWhereInput>;
};

export type AgreementScenariosConnection = {
  __typename?: 'AgreementScenariosConnection';
  edges: Array<AgreementScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScenariosConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type AgreementScenariosConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScenariosConnectionWhere>>;
  NOT?: InputMaybe<AgreementScenariosConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScenariosConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type AgreementScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScenariosRelationship = {
  __typename?: 'AgreementScenariosRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type AgreementScope = {
  __typename?: 'AgreementScope';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementsCount: Scalars['Int']['output'];
  article71Indications: Array<Article71Indication>;
  article71IndicationsAggregate?: Maybe<AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection>;
  article71IndicationsConnection: AgreementScopeArticle71IndicationsConnection;
  code: Scalars['String']['output'];
  countryScopes: Array<Country>;
  countryScopesAggregate?: Maybe<AgreementScopeCountryCountryScopesAggregationSelection>;
  countryScopesConnection: AgreementScopeCountryScopesConnection;
  countryScopesTemplates: Array<AgreementScopeCountryScope>;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<AgreementScopeCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: AgreementScopeCyclesConnection;
  diseases: Array<Disease>;
  diseasesAggregate?: Maybe<AgreementScopeDiseaseDiseasesAggregationSelection>;
  diseasesConnection: AgreementScopeDiseasesConnection;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: AgreementScopeEnrollingConditionSetsConnection;
  indications: Array<Indication>;
  indicationsAggregate?: Maybe<AgreementScopeIndicationIndicationsAggregationSelection>;
  indicationsConnection: AgreementScopeIndicationsConnection;
  isDeleted: Scalars['Boolean']['output'];
  logicalOperator: ConditionLogicalOperator;
  order: Scalars['Int']['output'];
  orgScopes?: Maybe<Array<OrganizationScope>>;
  organizationScopes: Array<Organization>;
  organizationScopesAggregate?: Maybe<AgreementScopeOrganizationOrganizationScopesAggregationSelection>;
  organizationScopesAgreements: Array<AgreementScopeOrganizationScope>;
  organizationScopesConnection: AgreementScopeOrganizationScopesConnection;
  organizationsCount: Scalars['Int']['output'];
  scopeId: Scalars['String']['output'];
  tenantIds?: Maybe<Array<Scalars['String']['output']>>;
  treatmentSets: Array<TreatmentSet>;
  treatmentSetsAggregate?: Maybe<AgreementScopeTreatmentSetTreatmentSetsAggregationSelection>;
  treatmentSetsConnection: AgreementScopeTreatmentSetsConnection;
};


export type AgreementScopeArticle71IndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type AgreementScopeArticle71IndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type AgreementScopeArticle71IndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeArticle71IndicationsConnectionSort>>;
  where?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
};


export type AgreementScopeCountryScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementScopeCountryScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementScopeCountryScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeCountryScopesConnectionSort>>;
  where?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
};


export type AgreementScopeCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementScopeCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementScopeCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeCyclesConnectionSort>>;
  where?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
};


export type AgreementScopeDiseasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DiseaseOptions>;
  where?: InputMaybe<DiseaseWhere>;
};


export type AgreementScopeDiseasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DiseaseWhere>;
};


export type AgreementScopeDiseasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeDiseasesConnectionSort>>;
  where?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
};


export type AgreementScopeEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementScopeEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementScopeEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
};


export type AgreementScopeIndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<IndicationOptions>;
  where?: InputMaybe<IndicationWhere>;
};


export type AgreementScopeIndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IndicationWhere>;
};


export type AgreementScopeIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeIndicationsConnectionSort>>;
  where?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
};


export type AgreementScopeOrganizationScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementScopeOrganizationScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type AgreementScopeOrganizationScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeOrganizationScopesConnectionSort>>;
  where?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
};


export type AgreementScopeTreatmentSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type AgreementScopeTreatmentSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type AgreementScopeTreatmentSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementScopeTreatmentSetsConnectionSort>>;
  where?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
};

export type AgreementScopeAggregateSelection = {
  __typename?: 'AgreementScopeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection = {
  __typename?: 'AgreementScopeArticle71IndicationArticle71IndicationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection>;
};

export type AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection = {
  __typename?: 'AgreementScopeArticle71IndicationArticle71IndicationsNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type AgreementScopeArticle71IndicationsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeArticle71IndicationsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeArticle71IndicationsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeArticle71IndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>;
};

export type AgreementScopeArticle71IndicationsConnection = {
  __typename?: 'AgreementScopeArticle71IndicationsConnection';
  edges: Array<AgreementScopeArticle71IndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeArticle71IndicationsConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type AgreementScopeArticle71IndicationsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeArticle71IndicationsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeArticle71IndicationsConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type AgreementScopeArticle71IndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeArticle71IndicationsNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeArticle71IndicationsRelationship = {
  __typename?: 'AgreementScopeArticle71IndicationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type AgreementScopeCountryCountryScopesAggregationSelection = {
  __typename?: 'AgreementScopeCountryCountryScopesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementScopeCountryCountryScopesEdgeAggregateSelection>;
  node?: Maybe<AgreementScopeCountryCountryScopesNodeAggregateSelection>;
};

export type AgreementScopeCountryCountryScopesEdgeAggregateSelection = {
  __typename?: 'AgreementScopeCountryCountryScopesEdgeAggregateSelection';
  countryScopeId: StringAggregateSelectionNonNullable;
};

export type AgreementScopeCountryCountryScopesNodeAggregateSelection = {
  __typename?: 'AgreementScopeCountryCountryScopesNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type AgreementScopeCountryScope = {
  __typename?: 'AgreementScopeCountryScope';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  countryCode: Scalars['String']['output'];
  countryScopeIds: Array<Scalars['String']['output']>;
  templateIds: Array<Scalars['String']['output']>;
  templateNames: Array<Scalars['String']['output']>;
};

export type AgreementScopeCountryScopeAggregateSelection = {
  __typename?: 'AgreementScopeCountryScopeAggregateSelection';
  count: Scalars['Int']['output'];
  countryCode: StringAggregateSelectionNonNullable;
};

export type AgreementScopeCountryScopeEdge = {
  __typename?: 'AgreementScopeCountryScopeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementScopeCountryScope;
};

export type AgreementScopeCountryScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementScopeCountryScopeSort objects to sort AgreementScopeCountryScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementScopeCountryScopeSort>>;
};

/** Fields to sort AgreementScopeCountryScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementScopeCountryScopeSort object. */
export type AgreementScopeCountryScopeSort = {
  countryCode?: InputMaybe<SortDirection>;
};

export type AgreementScopeCountryScopeWhere = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopeWhere>>;
  NOT?: InputMaybe<AgreementScopeCountryScopeWhere>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopeWhere>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  countryCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  countryScopeIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  templateIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  templateNames?: InputMaybe<Array<Scalars['String']['input']>>;
  templateNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementScopeCountryScopesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementScopeCountryScopesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementScopeCountryScopesNodeAggregationWhereInput>;
};

export type AgreementScopeCountryScopesConnection = {
  __typename?: 'AgreementScopeCountryScopesConnection';
  edges: Array<AgreementScopeCountryScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeCountryScopesConnectionSort = {
  edge?: InputMaybe<CountryScopeRelationshipSort>;
  node?: InputMaybe<CountrySort>;
};

export type AgreementScopeCountryScopesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesConnectionWhere>>;
  edge?: InputMaybe<CountryScopeRelationshipWhere>;
  node?: InputMaybe<CountryWhere>;
};

export type AgreementScopeCountryScopesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesEdgeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeCountryScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeCountryScopesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeCountryScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeCountryScopesNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeCountryScopesRelationship = CountryScopeRelationship & {
  __typename?: 'AgreementScopeCountryScopesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  countryScopeId: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  node: Country;
};

export type AgreementScopeCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'AgreementScopeCycleConfigurationCyclesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeCycleConfigurationCyclesNodeAggregateSelection>;
};

export type AgreementScopeCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'AgreementScopeCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScopeCyclesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeCyclesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeCyclesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeCyclesNodeAggregationWhereInput>;
};

export type AgreementScopeCyclesConnection = {
  __typename?: 'AgreementScopeCyclesConnection';
  edges: Array<AgreementScopeCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type AgreementScopeCyclesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeCyclesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type AgreementScopeCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeCyclesRelationship = {
  __typename?: 'AgreementScopeCyclesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type AgreementScopeDiseaseDiseasesAggregationSelection = {
  __typename?: 'AgreementScopeDiseaseDiseasesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementScopeDiseaseDiseasesEdgeAggregateSelection>;
  node?: Maybe<AgreementScopeDiseaseDiseasesNodeAggregateSelection>;
};

export type AgreementScopeDiseaseDiseasesEdgeAggregateSelection = {
  __typename?: 'AgreementScopeDiseaseDiseasesEdgeAggregateSelection';
  Score: FloatAggregateSelectionNullable;
};

export type AgreementScopeDiseaseDiseasesNodeAggregateSelection = {
  __typename?: 'AgreementScopeDiseaseDiseasesNodeAggregateSelection';
  Icd10Code: StringAggregateSelectionNonNullable;
  Name: StringAggregateSelectionNonNullable;
};

export type AgreementScopeDiseasesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeDiseasesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementScopeDiseasesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementScopeDiseasesNodeAggregationWhereInput>;
};

export type AgreementScopeDiseasesConnection = {
  __typename?: 'AgreementScopeDiseasesConnection';
  edges: Array<AgreementScopeDiseasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeDiseasesConnectionSort = {
  edge?: InputMaybe<EnrollingConditionDiseaseRelationshipSort>;
  node?: InputMaybe<DiseaseSort>;
};

export type AgreementScopeDiseasesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesConnectionWhere>>;
  edge?: InputMaybe<EnrollingConditionDiseaseRelationshipWhere>;
  node?: InputMaybe<DiseaseWhere>;
};

export type AgreementScopeDiseasesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeDiseasesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesEdgeAggregationWhereInput>>;
  Score_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementScopeDiseasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeDiseasesNodeAggregationWhereInput>>;
  Icd10Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementScopeDiseasesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementScopeDiseasesNodeAggregationWhereInput>>;
};

export type AgreementScopeDiseasesRelationship = EnrollingConditionDiseaseRelationship & {
  __typename?: 'AgreementScopeDiseasesRelationship';
  Score?: Maybe<Scalars['Float']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Disease;
};

export type AgreementScopeEdge = {
  __typename?: 'AgreementScopeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

export type AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'AgreementScopeEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementScopeEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScopeEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type AgreementScopeEnrollingConditionSetsConnection = {
  __typename?: 'AgreementScopeEnrollingConditionSetsConnection';
  edges: Array<AgreementScopeEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeEnrollingConditionSetsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type AgreementScopeEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeEnrollingConditionSetsRelationship = {
  __typename?: 'AgreementScopeEnrollingConditionSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type AgreementScopeIndicationIndicationsAggregationSelection = {
  __typename?: 'AgreementScopeIndicationIndicationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeIndicationIndicationsNodeAggregateSelection>;
};

export type AgreementScopeIndicationIndicationsNodeAggregateSelection = {
  __typename?: 'AgreementScopeIndicationIndicationsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  intent: StringAggregateSelectionNullable;
  intentLocalizationKey: StringAggregateSelectionNullable;
  line: StringAggregateSelectionNullable;
  lineLocalizationKey: StringAggregateSelectionNullable;
  mutation: StringAggregateSelectionNullable;
  mutationLocalizationKey: StringAggregateSelectionNullable;
  type: StringAggregateSelectionNullable;
  typeLocalizationKey: StringAggregateSelectionNullable;
};

export type AgreementScopeIndicationsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeIndicationsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeIndicationsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeIndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeIndicationsNodeAggregationWhereInput>;
};

export type AgreementScopeIndicationsConnection = {
  __typename?: 'AgreementScopeIndicationsConnection';
  edges: Array<AgreementScopeIndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeIndicationsConnectionSort = {
  node?: InputMaybe<IndicationSort>;
};

export type AgreementScopeIndicationsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeIndicationsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeIndicationsConnectionWhere>>;
  node?: InputMaybe<IndicationWhere>;
};

export type AgreementScopeIndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeIndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeIndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeIndicationsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  intent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  line_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  line_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeIndicationsRelationship = {
  __typename?: 'AgreementScopeIndicationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Indication;
};

export type AgreementScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementScopeSort objects to sort AgreementScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementScopeSort>>;
};

export type AgreementScopeOrganizationOrganizationScopesAggregationSelection = {
  __typename?: 'AgreementScopeOrganizationOrganizationScopesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection>;
  node?: Maybe<AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection>;
};

export type AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection = {
  __typename?: 'AgreementScopeOrganizationOrganizationScopesEdgeAggregateSelection';
  organizationScopeId: StringAggregateSelectionNullable;
};

export type AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection = {
  __typename?: 'AgreementScopeOrganizationOrganizationScopesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type AgreementScopeOrganizationScope = {
  __typename?: 'AgreementScopeOrganizationScope';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementId?: Maybe<Scalars['String']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  organizationScopeId: Scalars['String']['output'];
};

export type AgreementScopeOrganizationScopeAggregateSelection = {
  __typename?: 'AgreementScopeOrganizationScopeAggregateSelection';
  agreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  organizationId: StringAggregateSelectionNonNullable;
  organizationName: StringAggregateSelectionNonNullable;
  organizationScopeId: StringAggregateSelectionNonNullable;
};

export type AgreementScopeOrganizationScopeEdge = {
  __typename?: 'AgreementScopeOrganizationScopeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementScopeOrganizationScope;
};

export type AgreementScopeOrganizationScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementScopeOrganizationScopeSort objects to sort AgreementScopeOrganizationScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementScopeOrganizationScopeSort>>;
};

/** Fields to sort AgreementScopeOrganizationScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementScopeOrganizationScopeSort object. */
export type AgreementScopeOrganizationScopeSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  organizationId?: InputMaybe<SortDirection>;
  organizationName?: InputMaybe<SortDirection>;
  organizationScopeId?: InputMaybe<SortDirection>;
};

export type AgreementScopeOrganizationScopeWhere = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopeWhere>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopeWhere>>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementScopeOrganizationScopesAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementScopeOrganizationScopesNodeAggregationWhereInput>;
};

export type AgreementScopeOrganizationScopesConnection = {
  __typename?: 'AgreementScopeOrganizationScopesConnection';
  edges: Array<AgreementScopeOrganizationScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeOrganizationScopesConnectionSort = {
  edge?: InputMaybe<OrganizationScopeRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type AgreementScopeOrganizationScopesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesConnectionWhere>>;
  edge?: InputMaybe<OrganizationScopeRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type AgreementScopeOrganizationScopesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesEdgeAggregationWhereInput>>;
  organizationScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeOrganizationScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeOrganizationScopesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementScopeOrganizationScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeOrganizationScopesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeOrganizationScopesRelationship = OrganizationScopeRelationship & {
  __typename?: 'AgreementScopeOrganizationScopesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
  organizationScopeId?: Maybe<Scalars['String']['output']>;
};

export type AgreementScopeRelationship = {
  excludedOn?: Maybe<Scalars['Date']['output']>;
  isExtended?: Maybe<Scalars['Boolean']['output']>;
};

export type AgreementScopeRelationshipSort = {
  excludedOn?: InputMaybe<SortDirection>;
  isExtended?: InputMaybe<SortDirection>;
};

export type AgreementScopeRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementScopeRelationshipWhere>>;
  NOT?: InputMaybe<AgreementScopeRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementScopeRelationshipWhere>>;
  excludedOn?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_GT?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  excludedOn_LT?: InputMaybe<Scalars['Date']['input']>;
  excludedOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fields to sort AgreementScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementScopeSort object. */
export type AgreementScopeSort = {
  agreementsCount?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  logicalOperator?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  organizationsCount?: InputMaybe<SortDirection>;
  scopeId?: InputMaybe<SortDirection>;
};

export type AgreementScopeTreatmentSetTreatmentSetsAggregationSelection = {
  __typename?: 'AgreementScopeTreatmentSetTreatmentSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection>;
};

export type AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection = {
  __typename?: 'AgreementScopeTreatmentSetTreatmentSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementScopeTreatmentSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementScopeTreatmentSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementScopeTreatmentSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementScopeTreatmentSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementScopeTreatmentSetsNodeAggregationWhereInput>;
};

export type AgreementScopeTreatmentSetsConnection = {
  __typename?: 'AgreementScopeTreatmentSetsConnection';
  edges: Array<AgreementScopeTreatmentSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementScopeTreatmentSetsConnectionSort = {
  node?: InputMaybe<TreatmentSetSort>;
};

export type AgreementScopeTreatmentSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementScopeTreatmentSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementScopeTreatmentSetsConnectionWhere>>;
  node?: InputMaybe<TreatmentSetWhere>;
};

export type AgreementScopeTreatmentSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementScopeTreatmentSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementScopeTreatmentSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementScopeTreatmentSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementScopeTreatmentSetsRelationship = {
  __typename?: 'AgreementScopeTreatmentSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type AgreementScopeWhere = {
  AND?: InputMaybe<Array<AgreementScopeWhere>>;
  NOT?: InputMaybe<AgreementScopeWhere>;
  OR?: InputMaybe<Array<AgreementScopeWhere>>;
  article71IndicationsAggregate?: InputMaybe<AgreementScopeArticle71IndicationsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_ALL?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_NONE?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SINGLE?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SOME?: InputMaybe<AgreementScopeArticle71IndicationsConnectionWhere>;
  /** Return AgreementScopes where all of the related Article71Indications match this filter */
  article71Indications_ALL?: InputMaybe<Article71IndicationWhere>;
  /** Return AgreementScopes where none of the related Article71Indications match this filter */
  article71Indications_NONE?: InputMaybe<Article71IndicationWhere>;
  /** Return AgreementScopes where one of the related Article71Indications match this filter */
  article71Indications_SINGLE?: InputMaybe<Article71IndicationWhere>;
  /** Return AgreementScopes where some of the related Article71Indications match this filter */
  article71Indications_SOME?: InputMaybe<Article71IndicationWhere>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopesAggregate?: InputMaybe<AgreementScopeCountryScopesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_ALL?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_NONE?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_SINGLE?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeCountryScopesConnections match this filter */
  countryScopesConnection_SOME?: InputMaybe<AgreementScopeCountryScopesConnectionWhere>;
  /** Return AgreementScopes where all of the related Countries match this filter */
  countryScopes_ALL?: InputMaybe<CountryWhere>;
  /** Return AgreementScopes where none of the related Countries match this filter */
  countryScopes_NONE?: InputMaybe<CountryWhere>;
  /** Return AgreementScopes where one of the related Countries match this filter */
  countryScopes_SINGLE?: InputMaybe<CountryWhere>;
  /** Return AgreementScopes where some of the related Countries match this filter */
  countryScopes_SOME?: InputMaybe<CountryWhere>;
  cyclesAggregate?: InputMaybe<AgreementScopeCyclesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<AgreementScopeCyclesConnectionWhere>;
  /** Return AgreementScopes where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementScopes where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementScopes where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementScopes where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  diseasesAggregate?: InputMaybe<AgreementScopeDiseasesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_ALL?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_NONE?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_SINGLE?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeDiseasesConnections match this filter */
  diseasesConnection_SOME?: InputMaybe<AgreementScopeDiseasesConnectionWhere>;
  /** Return AgreementScopes where all of the related Diseases match this filter */
  diseases_ALL?: InputMaybe<DiseaseWhere>;
  /** Return AgreementScopes where none of the related Diseases match this filter */
  diseases_NONE?: InputMaybe<DiseaseWhere>;
  /** Return AgreementScopes where one of the related Diseases match this filter */
  diseases_SINGLE?: InputMaybe<DiseaseWhere>;
  /** Return AgreementScopes where some of the related Diseases match this filter */
  diseases_SOME?: InputMaybe<DiseaseWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<AgreementScopeEnrollingConditionSetsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<AgreementScopeEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementScopes where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementScopes where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementScopes where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementScopes where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  indicationsAggregate?: InputMaybe<AgreementScopeIndicationsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_ALL?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_NONE?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_SINGLE?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeIndicationsConnections match this filter */
  indicationsConnection_SOME?: InputMaybe<AgreementScopeIndicationsConnectionWhere>;
  /** Return AgreementScopes where all of the related Indications match this filter */
  indications_ALL?: InputMaybe<IndicationWhere>;
  /** Return AgreementScopes where none of the related Indications match this filter */
  indications_NONE?: InputMaybe<IndicationWhere>;
  /** Return AgreementScopes where one of the related Indications match this filter */
  indications_SINGLE?: InputMaybe<IndicationWhere>;
  /** Return AgreementScopes where some of the related Indications match this filter */
  indications_SOME?: InputMaybe<IndicationWhere>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  logicalOperator?: InputMaybe<ConditionLogicalOperator>;
  logicalOperator_IN?: InputMaybe<Array<ConditionLogicalOperator>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationScopesAggregate?: InputMaybe<AgreementScopeOrganizationScopesAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_ALL?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_NONE?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_SINGLE?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeOrganizationScopesConnections match this filter */
  organizationScopesConnection_SOME?: InputMaybe<AgreementScopeOrganizationScopesConnectionWhere>;
  /** Return AgreementScopes where all of the related Organizations match this filter */
  organizationScopes_ALL?: InputMaybe<OrganizationWhere>;
  /** Return AgreementScopes where none of the related Organizations match this filter */
  organizationScopes_NONE?: InputMaybe<OrganizationWhere>;
  /** Return AgreementScopes where one of the related Organizations match this filter */
  organizationScopes_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return AgreementScopes where some of the related Organizations match this filter */
  organizationScopes_SOME?: InputMaybe<OrganizationWhere>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  scopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  treatmentSetsAggregate?: InputMaybe<AgreementScopeTreatmentSetsAggregateInput>;
  /** Return AgreementScopes where all of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_ALL?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where none of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_NONE?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where one of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SINGLE?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where some of the related AgreementScopeTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SOME?: InputMaybe<AgreementScopeTreatmentSetsConnectionWhere>;
  /** Return AgreementScopes where all of the related TreatmentSets match this filter */
  treatmentSets_ALL?: InputMaybe<TreatmentSetWhere>;
  /** Return AgreementScopes where none of the related TreatmentSets match this filter */
  treatmentSets_NONE?: InputMaybe<TreatmentSetWhere>;
  /** Return AgreementScopes where one of the related TreatmentSets match this filter */
  treatmentSets_SINGLE?: InputMaybe<TreatmentSetWhere>;
  /** Return AgreementScopes where some of the related TreatmentSets match this filter */
  treatmentSets_SOME?: InputMaybe<TreatmentSetWhere>;
};

export type AgreementScopesConnection = {
  __typename?: 'AgreementScopesConnection';
  edges: Array<AgreementScopeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Agreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSort object. */
export type AgreementSort = {
  canParticipateInApproval?: InputMaybe<SortDirection>;
  canUserViewFinancials?: InputMaybe<SortDirection>;
  daysToExpiry?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  formattedAmount?: InputMaybe<SortDirection>;
  formattedCounterparties?: InputMaybe<SortDirection>;
  formattedDiseases?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  formattedProducts?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  formattedValidityPeriod?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  isApprovedByOrganization?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isExtended?: InputMaybe<SortDirection>;
  isFirstVersion?: InputMaybe<SortDirection>;
  isHidden?: InputMaybe<SortDirection>;
  isInsightsAvailable?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  isStobContract?: InputMaybe<SortDirection>;
  lastVersionStatus?: InputMaybe<SortDirection>;
  lastVersionValidToDate?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pushedOn?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subjectMatter?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  userOrganizationRole?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type AgreementSpecificRole = {
  __typename?: 'AgreementSpecificRole';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementId: Scalars['ID']['output'];
  agreementName: Scalars['String']['output'];
  agreementTags: Array<Scalars['String']['output']>;
  agreementUserRole?: Maybe<AgreementUserRole>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AgreementSpecificRoleAggregateSelection = {
  __typename?: 'AgreementSpecificRoleAggregateSelection';
  agreementId: IdAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  firstName: StringAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  userId: StringAggregateSelectionNonNullable;
};

export type AgreementSpecificRoleEdge = {
  __typename?: 'AgreementSpecificRoleEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementSpecificRole;
};

export type AgreementSpecificRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementSpecificRoleSort objects to sort AgreementSpecificRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementSpecificRoleSort>>;
};

/** Fields to sort AgreementSpecificRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSpecificRoleSort object. */
export type AgreementSpecificRoleSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  agreementUserRole?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type AgreementSpecificRoleWhere = {
  AND?: InputMaybe<Array<AgreementSpecificRoleWhere>>;
  NOT?: InputMaybe<AgreementSpecificRoleWhere>;
  OR?: InputMaybe<Array<AgreementSpecificRoleWhere>>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementTags?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementTags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  agreementUserRole?: InputMaybe<AgreementUserRole>;
  agreementUserRole_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type AgreementSpecificRolesConnection = {
  __typename?: 'AgreementSpecificRolesConnection';
  edges: Array<AgreementSpecificRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementSpecificUserRole = {
  __typename?: 'AgreementSpecificUserRole';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementId: Scalars['ID']['output'];
  agreementName: Scalars['String']['output'];
  agreementTags: Array<Scalars['String']['output']>;
  agreementUserRole?: Maybe<AgreementUserRole>;
};

export type AgreementSpecificUserRoleAggregateSelection = {
  __typename?: 'AgreementSpecificUserRoleAggregateSelection';
  agreementId: IdAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
};

export type AgreementSpecificUserRoleEdge = {
  __typename?: 'AgreementSpecificUserRoleEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementSpecificUserRole;
};

export type AgreementSpecificUserRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementSpecificUserRoleSort objects to sort AgreementSpecificUserRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementSpecificUserRoleSort>>;
};

/** Fields to sort AgreementSpecificUserRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementSpecificUserRoleSort object. */
export type AgreementSpecificUserRoleSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  agreementUserRole?: InputMaybe<SortDirection>;
};

export type AgreementSpecificUserRoleWhere = {
  AND?: InputMaybe<Array<AgreementSpecificUserRoleWhere>>;
  NOT?: InputMaybe<AgreementSpecificUserRoleWhere>;
  OR?: InputMaybe<Array<AgreementSpecificUserRoleWhere>>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementTags?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementTags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  agreementUserRole?: InputMaybe<AgreementUserRole>;
  agreementUserRole_IN?: InputMaybe<Array<InputMaybe<AgreementUserRole>>>;
};

export type AgreementSpecificUserRolesConnection = {
  __typename?: 'AgreementSpecificUserRolesConnection';
  edges: Array<AgreementSpecificUserRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementStatusTransition = {
  __typename?: 'AgreementStatusTransition';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  causedBy?: Maybe<User>;
  causedByAggregate?: Maybe<AgreementStatusTransitionUserCausedByAggregationSelection>;
  causedByConnection: AgreementStatusTransitionCausedByConnection;
  createdOn: Scalars['DateTime']['output'];
  from?: Maybe<ContractStatus>;
  to: ContractStatus;
};


export type AgreementStatusTransitionCausedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementStatusTransitionCausedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementStatusTransitionCausedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionSort>>;
  where?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
};

export type AgreementStatusTransitionAggregateSelection = {
  __typename?: 'AgreementStatusTransitionAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
};

export type AgreementStatusTransitionCausedByAggregateInput = {
  AND?: InputMaybe<Array<AgreementStatusTransitionCausedByAggregateInput>>;
  NOT?: InputMaybe<AgreementStatusTransitionCausedByAggregateInput>;
  OR?: InputMaybe<Array<AgreementStatusTransitionCausedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementStatusTransitionCausedByNodeAggregationWhereInput>;
};

export type AgreementStatusTransitionCausedByConnection = {
  __typename?: 'AgreementStatusTransitionCausedByConnection';
  edges: Array<AgreementStatusTransitionCausedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementStatusTransitionCausedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementStatusTransitionCausedByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionWhere>>;
  NOT?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementStatusTransitionCausedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementStatusTransitionCausedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementStatusTransitionCausedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementStatusTransitionCausedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementStatusTransitionCausedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementStatusTransitionCausedByRelationship = {
  __typename?: 'AgreementStatusTransitionCausedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementStatusTransitionEdge = {
  __typename?: 'AgreementStatusTransitionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementStatusTransition;
};

export type AgreementStatusTransitionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementStatusTransitionSort objects to sort AgreementStatusTransitions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementStatusTransitionSort>>;
};

/** Fields to sort AgreementStatusTransitions by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementStatusTransitionSort object. */
export type AgreementStatusTransitionSort = {
  createdOn?: InputMaybe<SortDirection>;
  from?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
};

export type AgreementStatusTransitionUserCausedByAggregationSelection = {
  __typename?: 'AgreementStatusTransitionUserCausedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementStatusTransitionUserCausedByNodeAggregateSelection>;
};

export type AgreementStatusTransitionUserCausedByNodeAggregateSelection = {
  __typename?: 'AgreementStatusTransitionUserCausedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementStatusTransitionWhere = {
  AND?: InputMaybe<Array<AgreementStatusTransitionWhere>>;
  NOT?: InputMaybe<AgreementStatusTransitionWhere>;
  OR?: InputMaybe<Array<AgreementStatusTransitionWhere>>;
  causedBy?: InputMaybe<UserWhere>;
  causedByAggregate?: InputMaybe<AgreementStatusTransitionCausedByAggregateInput>;
  causedByConnection?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
  causedByConnection_NOT?: InputMaybe<AgreementStatusTransitionCausedByConnectionWhere>;
  causedBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<ContractStatus>;
  from_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  to?: InputMaybe<ContractStatus>;
  to_IN?: InputMaybe<Array<ContractStatus>>;
};

export type AgreementStatusTransitionsConnection = {
  __typename?: 'AgreementStatusTransitionsConnection';
  edges: Array<AgreementStatusTransitionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AgreementSubjectMatter {
  Devices = 'DEVICES',
  Drugs = 'DRUGS'
}

export type AgreementTableRow = ITableRowView & {
  __typename?: 'AgreementTableRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementTagTypes: Array<Scalars['String']['output']>;
  canUserViewFinancials?: Maybe<Scalars['Boolean']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyName?: Maybe<Scalars['String']['output']>;
  daysToExpiry?: Maybe<Scalars['Int']['output']>;
  formattedContent?: Maybe<Scalars['String']['output']>;
  formattedCounterparties?: Maybe<Scalars['String']['output']>;
  formattedDiseases?: Maybe<Scalars['String']['output']>;
  formattedExposedToUserIds?: Maybe<Scalars['String']['output']>;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  formattedProducts?: Maybe<Scalars['String']['output']>;
  formattedTags?: Maybe<Scalars['String']['output']>;
  formattedValidityPeriod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastVersionStatus?: Maybe<ContractStatus>;
  lastVersionValidToDate?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  status?: Maybe<ContractStatus>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<AgreementTableRowUserUsersAggregationSelection>;
  usersConnection: ITableRowViewUsersConnection;
  validFromDate?: Maybe<Scalars['Date']['output']>;
  validToDate?: Maybe<Scalars['Date']['output']>;
};


export type AgreementTableRowUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTableRowUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTableRowUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ITableRowViewUsersConnectionSort>>;
  where?: InputMaybe<ITableRowViewUsersConnectionWhere>;
};

export type AgreementTableRowAggregateSelection = {
  __typename?: 'AgreementTableRowAggregateSelection';
  count: Scalars['Int']['output'];
  currencyCode: StringAggregateSelectionNullable;
  currencyName: StringAggregateSelectionNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedExposedToUserIds: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type AgreementTableRowEdge = {
  __typename?: 'AgreementTableRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTableRow;
};

export type AgreementTableRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTableRowSort objects to sort AgreementTableRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTableRowSort>>;
};

/** Fields to sort AgreementTableRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTableRowSort object. */
export type AgreementTableRowSort = {
  canUserViewFinancials?: InputMaybe<SortDirection>;
  currencyCode?: InputMaybe<SortDirection>;
  currencyName?: InputMaybe<SortDirection>;
  daysToExpiry?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  formattedCounterparties?: InputMaybe<SortDirection>;
  formattedDiseases?: InputMaybe<SortDirection>;
  formattedExposedToUserIds?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  formattedProducts?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  formattedValidityPeriod?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastVersionStatus?: InputMaybe<SortDirection>;
  lastVersionValidToDate?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
};

export type AgreementTableRowUserUsersAggregationSelection = {
  __typename?: 'AgreementTableRowUserUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTableRowUserUsersNodeAggregateSelection>;
};

export type AgreementTableRowUserUsersNodeAggregateSelection = {
  __typename?: 'AgreementTableRowUserUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementTableRowUsersAggregateInput = {
  AND?: InputMaybe<Array<AgreementTableRowUsersAggregateInput>>;
  NOT?: InputMaybe<AgreementTableRowUsersAggregateInput>;
  OR?: InputMaybe<Array<AgreementTableRowUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTableRowUsersNodeAggregationWhereInput>;
};

export type AgreementTableRowUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTableRowUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTableRowUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTableRowUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTableRowWhere = {
  AND?: InputMaybe<Array<AgreementTableRowWhere>>;
  NOT?: InputMaybe<AgreementTableRowWhere>;
  OR?: InputMaybe<Array<AgreementTableRowWhere>>;
  agreementTagTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementTagTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  canUserViewFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyName?: InputMaybe<Scalars['String']['input']>;
  currencyName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  daysToExpiry?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  daysToExpiry_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCounterparties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedDiseases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedExposedToUserIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedProducts_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedValidityPeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastVersionStatus?: InputMaybe<ContractStatus>;
  lastVersionStatus_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  lastVersionValidToDate?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lastVersionValidToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ContractStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  usersAggregate?: InputMaybe<AgreementTableRowUsersAggregateInput>;
  /** Return AgreementTableRows where all of the related ITableRowViewUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return AgreementTableRows where none of the related ITableRowViewUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return AgreementTableRows where one of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return AgreementTableRows where some of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return AgreementTableRows where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return AgreementTableRows where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return AgreementTableRows where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return AgreementTableRows where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type AgreementTableRowsConnection = {
  __typename?: 'AgreementTableRowsConnection';
  edges: Array<AgreementTableRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTag = {
  __typename?: 'AgreementTag';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  defaultUserRoles: Array<User>;
  defaultUserRolesAggregate?: Maybe<AgreementTagUserDefaultUserRolesAggregationSelection>;
  defaultUserRolesConnection: AgreementTagDefaultUserRolesConnection;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: AgreementTagType;
};


export type AgreementTagDefaultUserRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTagDefaultUserRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTagDefaultUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionSort>>;
  where?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
};

export type AgreementTagAggregateSelection = {
  __typename?: 'AgreementTagAggregateSelection';
  count: Scalars['Int']['output'];
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementTagDefaultUserRolesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTagDefaultUserRolesAggregateInput>>;
  NOT?: InputMaybe<AgreementTagDefaultUserRolesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTagDefaultUserRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTagDefaultUserRolesNodeAggregationWhereInput>;
};

export type AgreementTagDefaultUserRolesConnection = {
  __typename?: 'AgreementTagDefaultUserRolesConnection';
  edges: Array<AgreementTagDefaultUserRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTagDefaultUserRolesConnectionSort = {
  edge?: InputMaybe<AgreementTagUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type AgreementTagDefaultUserRolesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTagDefaultUserRolesConnectionWhere>>;
  edge?: InputMaybe<AgreementTagUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementTagDefaultUserRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTagDefaultUserRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTagDefaultUserRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTagDefaultUserRolesNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTagDefaultUserRolesRelationship = AgreementTagUserRoleRelationship & {
  __typename?: 'AgreementTagDefaultUserRolesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  caseAssignee?: Maybe<AssigneeStatus>;
  cursor: Scalars['String']['output'];
  documentAssignee?: Maybe<AssigneeStatus>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type AgreementTagEdge = {
  __typename?: 'AgreementTagEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type AgreementTagOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTagSort objects to sort AgreementTags by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTagSort>>;
};

export type AgreementTagRole = {
  __typename?: 'AgreementTagRole';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  caseAssignee?: Maybe<AssigneeStatus>;
  documentAssignee?: Maybe<AssigneeStatus>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
  tagName: Scalars['String']['output'];
  tagType: AgreementTagType;
};

export type AgreementTagRoleAggregateSelection = {
  __typename?: 'AgreementTagRoleAggregateSelection';
  count: Scalars['Int']['output'];
  tagName: StringAggregateSelectionNonNullable;
};

export type AgreementTagRoleEdge = {
  __typename?: 'AgreementTagRoleEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTagRole;
};

export type AgreementTagRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTagRoleSort objects to sort AgreementTagRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTagRoleSort>>;
};

/** Fields to sort AgreementTagRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTagRoleSort object. */
export type AgreementTagRoleSort = {
  caseAssignee?: InputMaybe<SortDirection>;
  documentAssignee?: InputMaybe<SortDirection>;
  isAgreementAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  tagName?: InputMaybe<SortDirection>;
  tagType?: InputMaybe<SortDirection>;
};

export type AgreementTagRoleWhere = {
  AND?: InputMaybe<Array<AgreementTagRoleWhere>>;
  NOT?: InputMaybe<AgreementTagRoleWhere>;
  OR?: InputMaybe<Array<AgreementTagRoleWhere>>;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  caseAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  isAgreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
  tagName?: InputMaybe<Scalars['String']['input']>;
  tagName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tagName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tagName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tagName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<AgreementTagType>;
  tagType_IN?: InputMaybe<Array<AgreementTagType>>;
};

export type AgreementTagRolesConnection = {
  __typename?: 'AgreementTagRolesConnection';
  edges: Array<AgreementTagRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort AgreementTags by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTagSort object. */
export type AgreementTagSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum AgreementTagType {
  Article_71 = 'ARTICLE_71',
  Custom = 'CUSTOM',
  Sll = 'SLL',
  VolumeBased = 'VOLUME_BASED'
}

export type AgreementTagUserDefaultUserRolesAggregationSelection = {
  __typename?: 'AgreementTagUserDefaultUserRolesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTagUserDefaultUserRolesNodeAggregateSelection>;
};

export type AgreementTagUserDefaultUserRolesNodeAggregateSelection = {
  __typename?: 'AgreementTagUserDefaultUserRolesNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementTagUserRoleRelationship = {
  caseAssignee?: Maybe<AssigneeStatus>;
  documentAssignee?: Maybe<AssigneeStatus>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
};

export type AgreementTagUserRoleRelationshipSort = {
  caseAssignee?: InputMaybe<SortDirection>;
  documentAssignee?: InputMaybe<SortDirection>;
  isAgreementAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type AgreementTagUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTagUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTagUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTagUserRoleRelationshipWhere>>;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  caseAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  isAgreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type AgreementTagWhere = {
  AND?: InputMaybe<Array<AgreementTagWhere>>;
  NOT?: InputMaybe<AgreementTagWhere>;
  OR?: InputMaybe<Array<AgreementTagWhere>>;
  defaultUserRolesAggregate?: InputMaybe<AgreementTagDefaultUserRolesAggregateInput>;
  /** Return AgreementTags where all of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_ALL?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where none of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_NONE?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where one of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_SINGLE?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where some of the related AgreementTagDefaultUserRolesConnections match this filter */
  defaultUserRolesConnection_SOME?: InputMaybe<AgreementTagDefaultUserRolesConnectionWhere>;
  /** Return AgreementTags where all of the related Users match this filter */
  defaultUserRoles_ALL?: InputMaybe<UserWhere>;
  /** Return AgreementTags where none of the related Users match this filter */
  defaultUserRoles_NONE?: InputMaybe<UserWhere>;
  /** Return AgreementTags where one of the related Users match this filter */
  defaultUserRoles_SINGLE?: InputMaybe<UserWhere>;
  /** Return AgreementTags where some of the related Users match this filter */
  defaultUserRoles_SOME?: InputMaybe<UserWhere>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AgreementTagType>;
  type_IN?: InputMaybe<Array<AgreementTagType>>;
};

export type AgreementTagsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTagsAggregateInput>>;
  NOT?: InputMaybe<AgreementTagsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTagsNodeAggregationWhereInput>;
};

export type AgreementTagsConnection = {
  __typename?: 'AgreementTagsConnection';
  edges: Array<AgreementTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type AgreementTagsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTagsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTagsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type AgreementTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTagsRelationship = {
  __typename?: 'AgreementTagsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type AgreementTemplate = {
  __typename?: 'AgreementTemplate';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedBy: User;
  addedByAggregate?: Maybe<AgreementTemplateUserAddedByAggregationSelection>;
  addedByConnection: AgreementTemplateAddedByConnection;
  addedByName?: Maybe<Scalars['String']['output']>;
  agreementQuantity: Scalars['Int']['output'];
  agreements: Array<Agreement>;
  agreementsAggregate?: Maybe<AgreementTemplateAgreementAgreementsAggregationSelection>;
  agreementsConnection: AgreementTemplateAgreementsConnection;
  allowedForms?: Maybe<Array<Scalars['String']['output']>>;
  allowedRecords?: Maybe<Array<Scalars['String']['output']>>;
  caseSuspensionIntervalDays?: Maybe<Scalars['Int']['output']>;
  childAgreementsDefaultStatus?: Maybe<ContractStatus>;
  country: Country;
  countryAggregate?: Maybe<AgreementTemplateCountryCountryAggregationSelection>;
  countryConnection: AgreementTemplateCountryConnection;
  coveringFormWaitInterval?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currency: Currency;
  currencyAggregate?: Maybe<AgreementTemplateCurrencyCurrencyAggregationSelection>;
  currencyConnection: AgreementTemplateCurrencyConnection;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<AgreementTemplateCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: AgreementTemplateCyclesConnection;
  defaultPriceRate?: Maybe<Scalars['Float']['output']>;
  deviceAlternativeSets: Array<DeviceAlternative>;
  deviceAlternativeSetsAggregate?: Maybe<AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  deviceAlternativeSetsConnection: AgreementTemplateDeviceAlternativeSetsConnection;
  dotThresholds?: Maybe<ChartRangeConfiguration>;
  dotThresholdsAggregate?: Maybe<AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection>;
  dotThresholdsConnection: AgreementTemplateDotThresholdsConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsAggregate?: Maybe<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  eligibilityConditionSetsConnection: AgreementTemplateEligibilityConditionSetsConnection;
  eligibilityConditionTreatments?: Maybe<Array<Maybe<Treatment>>>;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: AgreementTemplateEnrollingConditionSetsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsAggregate?: Maybe<AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  enrollingPeriodsConnection: AgreementTemplateEnrollingPeriodsConnection;
  enrolmentDateType?: Maybe<EnrolmentDateType>;
  expectedDocument: DocumentType;
  financialSummaryConfig: Array<FinancialSummaryColumn>;
  financialSummaryConfigAggregate?: Maybe<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  financialSummaryConfigConnection: AgreementTemplateFinancialSummaryConfigConnection;
  formattedTags?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialVersion?: Maybe<AgreementTemplate>;
  initialVersionAggregate?: Maybe<AgreementTemplateAgreementTemplateInitialVersionAggregationSelection>;
  initialVersionConnection: AgreementTemplateInitialVersionConnection;
  initialVersionId: Scalars['ID']['output'];
  isAllowedFormsEnabled: Scalars['Boolean']['output'];
  isAllowedRecordsEnabled: Scalars['Boolean']['output'];
  isCaseless: Scalars['Boolean']['output'];
  isCoveringIntervalEnabled: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFirstVersion: Scalars['Boolean']['output'];
  isLastVersion: Scalars['Boolean']['output'];
  isRequiredFormsEnabled: Scalars['Boolean']['output'];
  isRequiredRecordsEnabled: Scalars['Boolean']['output'];
  lastUpdatedOn?: Maybe<Scalars['Float']['output']>;
  limitation?: Maybe<Limitation>;
  limitationAggregate?: Maybe<AgreementTemplateLimitationLimitationAggregationSelection>;
  limitationConnection: AgreementTemplateLimitationConnection;
  name: Scalars['String']['output'];
  negotiableAttributes: Array<CatalogueAttribute>;
  negotiableAttributesAggregate?: Maybe<AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection>;
  negotiableAttributesConnection: AgreementTemplateNegotiableAttributesConnection;
  nextVersions: Array<AgreementTemplate>;
  nextVersionsAggregate?: Maybe<AgreementTemplateAgreementTemplateNextVersionsAggregationSelection>;
  nextVersionsConnection: AgreementTemplateNextVersionsConnection;
  rangeChartConfig?: Maybe<ChartRangeConfiguration>;
  rangeChartConfigAggregate?: Maybe<AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection>;
  rangeChartConfigConnection: AgreementTemplateRangeChartConfigConnection;
  requiredForms?: Maybe<Array<Scalars['String']['output']>>;
  requiredRecords?: Maybe<Array<Scalars['String']['output']>>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<AgreementTemplateScenarioScenariosAggregationSelection>;
  scenariosConnection: AgreementTemplateScenariosConnection;
  scenariosRelevantBrands: Array<Brand>;
  scenariosRelevantBrandsAggregate?: Maybe<AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection>;
  scenariosRelevantBrandsConnection: AgreementTemplateScenariosRelevantBrandsConnection;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<AgreementTemplateAgreementTagTagsAggregationSelection>;
  tagsConnection: AgreementTemplateTagsConnection;
  treatmentPrices: Array<Treatment>;
  treatmentPricesAggregate?: Maybe<AgreementTemplateTreatmentTreatmentPricesAggregationSelection>;
  treatmentPricesConnection: AgreementTemplateTreatmentPricesConnection;
  treatments?: Maybe<Scalars['String']['output']>;
  validFromDate: Scalars['Date']['output'];
  validToDate?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
};


export type AgreementTemplateAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTemplateAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type AgreementTemplateAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateAddedByConnectionSort>>;
  where?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
};


export type AgreementTemplateAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementTemplateAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type AgreementTemplateAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateAgreementsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
};


export type AgreementTemplateCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementTemplateCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type AgreementTemplateCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateCountryConnectionSort>>;
  where?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
};


export type AgreementTemplateCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementTemplateCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type AgreementTemplateCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateCurrencyConnectionSort>>;
  where?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
};


export type AgreementTemplateCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementTemplateCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type AgreementTemplateCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateCyclesConnectionSort>>;
  where?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
};


export type AgreementTemplateDeviceAlternativeSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementTemplateDeviceAlternativeSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type AgreementTemplateDeviceAlternativeSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
};


export type AgreementTemplateDotThresholdsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateDotThresholdsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateDotThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateDotThresholdsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
};


export type AgreementTemplateEligibilityConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type AgreementTemplateEligibilityConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type AgreementTemplateEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
};


export type AgreementTemplateEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementTemplateEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type AgreementTemplateEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
};


export type AgreementTemplateEnrollingPeriodsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type AgreementTemplateEnrollingPeriodsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type AgreementTemplateEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
};


export type AgreementTemplateFinancialSummaryConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type AgreementTemplateFinancialSummaryConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type AgreementTemplateFinancialSummaryConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigConnectionSort>>;
  where?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
};


export type AgreementTemplateInitialVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateInitialVersionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateInitialVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateInitialVersionConnectionSort>>;
  where?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
};


export type AgreementTemplateLimitationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type AgreementTemplateLimitationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type AgreementTemplateLimitationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateLimitationConnectionSort>>;
  where?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
};


export type AgreementTemplateNegotiableAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementTemplateNegotiableAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type AgreementTemplateNegotiableAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateNegotiableAttributesConnectionSort>>;
  where?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
};


export type AgreementTemplateNextVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateNextVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type AgreementTemplateNextVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateNextVersionsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
};


export type AgreementTemplateRangeChartConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateRangeChartConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type AgreementTemplateRangeChartConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateRangeChartConfigConnectionSort>>;
  where?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
};


export type AgreementTemplateScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementTemplateScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type AgreementTemplateScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateScenariosConnectionSort>>;
  where?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
};


export type AgreementTemplateScenariosRelevantBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type AgreementTemplateScenariosRelevantBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type AgreementTemplateScenariosRelevantBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
};


export type AgreementTemplateTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTemplateTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type AgreementTemplateTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateTagsConnectionSort>>;
  where?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
};


export type AgreementTemplateTreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type AgreementTemplateTreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type AgreementTemplateTreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AgreementTemplateTreatmentPricesConnectionSort>>;
  where?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
};

export type AgreementTemplateAddedByAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateAddedByAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateAddedByAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateAddedByNodeAggregationWhereInput>;
};

export type AgreementTemplateAddedByConnection = {
  __typename?: 'AgreementTemplateAddedByConnection';
  edges: Array<AgreementTemplateAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type AgreementTemplateAddedByConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateAddedByConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementTemplateAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateAddedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateAddedByRelationship = {
  __typename?: 'AgreementTemplateAddedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type AgreementTemplateAggregateSelection = {
  __typename?: 'AgreementTemplateAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementAgreementsAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementAgreementsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementAgreementsNodeAggregateSelection>;
};

export type AgreementTemplateAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementAgreementsNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementTagTagsAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementTagTagsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementTagTagsNodeAggregateSelection>;
};

export type AgreementTemplateAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementTemplateInitialVersionAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateInitialVersionAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection>;
};

export type AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateInitialVersionNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementTemplateNextVersionsAggregationSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateNextVersionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection>;
};

export type AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateAgreementTemplateNextVersionsNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateAgreementsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateAgreementsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateAgreementsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateAgreementsNodeAggregationWhereInput>;
};

export type AgreementTemplateAgreementsConnection = {
  __typename?: 'AgreementTemplateAgreementsConnection';
  edges: Array<AgreementTemplateAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateAgreementsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type AgreementTemplateAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateAgreementsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateAgreementsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type AgreementTemplateAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateAgreementsNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateAgreementsRelationship = {
  __typename?: 'AgreementTemplateAgreementsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection = {
  __typename?: 'AgreementTemplateBrandScenariosRelevantBrandsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection>;
};

export type AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateBrandScenariosRelevantBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection = {
  __typename?: 'AgreementTemplateCatalogueAttributeNegotiableAttributesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
};

export type AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCatalogueAttributeNegotiableAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationDotThresholdsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
};

export type AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationDotThresholdsEdgeAggregateSelection';
  threshold: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationRangeChartConfigAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
};

export type AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateChartRangeConfigurationRangeChartConfigEdgeAggregateSelection';
  from: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  to: IntAggregateSelectionNullable;
};

export type AgreementTemplateCountryAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateCountryAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateCountryAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateCountryNodeAggregationWhereInput>;
};

export type AgreementTemplateCountryConnection = {
  __typename?: 'AgreementTemplateCountryConnection';
  edges: Array<AgreementTemplateCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type AgreementTemplateCountryConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateCountryConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type AgreementTemplateCountryCountryAggregationSelection = {
  __typename?: 'AgreementTemplateCountryCountryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCountryCountryNodeAggregateSelection>;
};

export type AgreementTemplateCountryCountryNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateCountryRelationship = {
  __typename?: 'AgreementTemplateCountryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type AgreementTemplateCurrencyAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateCurrencyAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateCurrencyAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateCurrencyNodeAggregationWhereInput>;
};

export type AgreementTemplateCurrencyConnection = {
  __typename?: 'AgreementTemplateCurrencyConnection';
  edges: Array<AgreementTemplateCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type AgreementTemplateCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateCurrencyConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type AgreementTemplateCurrencyCurrencyAggregationSelection = {
  __typename?: 'AgreementTemplateCurrencyCurrencyAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCurrencyCurrencyNodeAggregateSelection>;
};

export type AgreementTemplateCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type AgreementTemplateCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTemplateCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateCurrencyRelationship = {
  __typename?: 'AgreementTemplateCurrencyRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type AgreementTemplateCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'AgreementTemplateCycleConfigurationCyclesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection>;
};

export type AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'AgreementTemplateCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateCyclesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateCyclesAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateCyclesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateCyclesNodeAggregationWhereInput>;
};

export type AgreementTemplateCyclesConnection = {
  __typename?: 'AgreementTemplateCyclesConnection';
  edges: Array<AgreementTemplateCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type AgreementTemplateCyclesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateCyclesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type AgreementTemplateCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateCyclesRelationship = {
  __typename?: 'AgreementTemplateCyclesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection = {
  __typename?: 'AgreementTemplateDeviceAlternativeDeviceAlternativeSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
};

export type AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateDeviceAlternativeSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateDeviceAlternativeSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type AgreementTemplateDeviceAlternativeSetsConnection = {
  __typename?: 'AgreementTemplateDeviceAlternativeSetsConnection';
  edges: Array<AgreementTemplateDeviceAlternativeSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateDeviceAlternativeSetsConnectionSort = {
  node?: InputMaybe<DeviceAlternativeSort>;
};

export type AgreementTemplateDeviceAlternativeSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsConnectionWhere>>;
  node?: InputMaybe<DeviceAlternativeWhere>;
};

export type AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateDeviceAlternativeSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateDeviceAlternativeSetsRelationship = {
  __typename?: 'AgreementTemplateDeviceAlternativeSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type AgreementTemplateDotThresholdsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateDotThresholdsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateDotThresholdsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateDotThresholdsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>;
};

export type AgreementTemplateDotThresholdsConnection = {
  __typename?: 'AgreementTemplateDotThresholdsConnection';
  edges: Array<AgreementTemplateDotThresholdsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateDotThresholdsConnectionSort = {
  edge?: InputMaybe<ThresholdConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type AgreementTemplateDotThresholdsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateDotThresholdsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateDotThresholdsConnectionWhere>>;
  edge?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type AgreementTemplateDotThresholdsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateDotThresholdsEdgeAggregationWhereInput>>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateDotThresholdsRelationship = ThresholdConfigurationRelationship & {
  __typename?: 'AgreementTemplateDotThresholdsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
  threshold: Scalars['Int']['output'];
};

export type AgreementTemplateEdge = {
  __typename?: 'AgreementTemplateEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateEligibilityConditionRelationship = {
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateEligibilityConditionRelationshipSort = {
  cycleAdherence?: InputMaybe<SortDirection>;
  days?: InputMaybe<SortDirection>;
  minimumPercentage?: InputMaybe<SortDirection>;
  numberOfAdministeredRangeDays?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatments?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<SortDirection>;
  previousTestNumber?: InputMaybe<SortDirection>;
  referenceAdministrationSequenceNumber?: InputMaybe<SortDirection>;
  referenceTestRangeDays?: InputMaybe<SortDirection>;
  treatments?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type AgreementTemplateEligibilityConditionRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionRelationshipWhere>>;
  cycleAdherence?: InputMaybe<CycleAdherence>;
  cycleAdherence_IN?: InputMaybe<Array<InputMaybe<CycleAdherence>>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minimumPercentage_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<ArithmeticalOperator>;
  numberOfAdministeredTreatmentsOperator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  numberOfAdministeredTreatments_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredTreatments_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  previousTestNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceAdministrationSequenceNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceTestRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceTestRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatments_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  value_GT?: InputMaybe<Scalars['Int']['input']>;
  value_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  value_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetEligibilityConditionSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  node?: Maybe<AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection';
  days: IntAggregateSelectionNullable;
  minimumPercentage: IntAggregateSelectionNullable;
  numberOfAdministeredTreatments: IntAggregateSelectionNullable;
  previousTestNumber: IntAggregateSelectionNullable;
  referenceAdministrationSequenceNumber: IntAggregateSelectionNullable;
  value: IntAggregateSelectionNullable;
};

export type AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  inputLabel: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateEligibilityConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>;
};

export type AgreementTemplateEligibilityConditionSetsConnection = {
  __typename?: 'AgreementTemplateEligibilityConditionSetsConnection';
  edges: Array<AgreementTemplateEligibilityConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateEligibilityConditionSetsConnectionSort = {
  edge?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipSort>;
  node?: InputMaybe<EligibilityConditionSetSort>;
};

export type AgreementTemplateEligibilityConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsConnectionWhere>>;
  edge?: InputMaybe<AgreementTemplateEligibilityConditionRelationshipWhere>;
  node?: InputMaybe<EligibilityConditionSetWhere>;
};

export type AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsEdgeAggregationWhereInput>>;
  days_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  days_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateEligibilityConditionSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEligibilityConditionSetsRelationship = AgreementTemplateEligibilityConditionRelationship & {
  __typename?: 'AgreementTemplateEligibilityConditionSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  node: EligibilityConditionSet;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'AgreementTemplateEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'AgreementTemplateEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type AgreementTemplateEnrollingConditionSetsConnection = {
  __typename?: 'AgreementTemplateEnrollingConditionSetsConnection';
  edges: Array<AgreementTemplateEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateEnrollingConditionSetsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type AgreementTemplateEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEnrollingConditionSetsRelationship = {
  __typename?: 'AgreementTemplateEnrollingConditionSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection = {
  __typename?: 'AgreementTemplateEnrollingPeriodEnrollingPeriodsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export type AgreementTemplateEnrollingPeriodsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingPeriodsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateEnrollingPeriodsConnection = {
  __typename?: 'AgreementTemplateEnrollingPeriodsConnection';
  edges: Array<AgreementTemplateEnrollingPeriodsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateEnrollingPeriodsConnectionSort = {
  node?: InputMaybe<EnrollingPeriodSort>;
};

export type AgreementTemplateEnrollingPeriodsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateEnrollingPeriodsConnectionWhere>>;
  node?: InputMaybe<EnrollingPeriodWhere>;
};

export type AgreementTemplateEnrollingPeriodsRelationship = {
  __typename?: 'AgreementTemplateEnrollingPeriodsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection = {
  __typename?: 'AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  node?: Maybe<AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection';
  localizationKey: StringAggregateSelectionNullable;
  position: IntAggregateSelectionNullable;
};

export type AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection = {
  __typename?: 'AgreementTemplateFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateFinancialSummaryConfigAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>;
};

export type AgreementTemplateFinancialSummaryConfigConnection = {
  __typename?: 'AgreementTemplateFinancialSummaryConfigConnection';
  edges: Array<AgreementTemplateFinancialSummaryConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateFinancialSummaryConfigConnectionSort = {
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipSort>;
  node?: InputMaybe<FinancialSummaryColumnSort>;
};

export type AgreementTemplateFinancialSummaryConfigConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigConnectionWhere>>;
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  node?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigEdgeAggregationWhereInput>>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateFinancialSummaryConfigNodeAggregationWhereInput>>;
};

export type AgreementTemplateFinancialSummaryConfigRelationship = AgreementFinancialSummaryColumnRelationship & {
  __typename?: 'AgreementTemplateFinancialSummaryConfigRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  node: FinancialSummaryColumn;
  position?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateInitialVersionAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateInitialVersionAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateInitialVersionAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateInitialVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateInitialVersionNodeAggregationWhereInput>;
};

export type AgreementTemplateInitialVersionConnection = {
  __typename?: 'AgreementTemplateInitialVersionConnection';
  edges: Array<AgreementTemplateInitialVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateInitialVersionConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type AgreementTemplateInitialVersionConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateInitialVersionConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateInitialVersionConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type AgreementTemplateInitialVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateInitialVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateInitialVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateInitialVersionNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateInitialVersionRelationship = {
  __typename?: 'AgreementTemplateInitialVersionRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateLimitationAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateLimitationAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateLimitationAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateLimitationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateLimitationNodeAggregationWhereInput>;
};

export type AgreementTemplateLimitationConnection = {
  __typename?: 'AgreementTemplateLimitationConnection';
  edges: Array<AgreementTemplateLimitationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateLimitationConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type AgreementTemplateLimitationConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateLimitationConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateLimitationConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type AgreementTemplateLimitationLimitationAggregationSelection = {
  __typename?: 'AgreementTemplateLimitationLimitationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateLimitationLimitationNodeAggregateSelection>;
};

export type AgreementTemplateLimitationLimitationNodeAggregateSelection = {
  __typename?: 'AgreementTemplateLimitationLimitationNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type AgreementTemplateLimitationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateLimitationNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTemplateLimitationNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateLimitationNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateLimitationRelationship = {
  __typename?: 'AgreementTemplateLimitationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type AgreementTemplateNegotiableAttributesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateNegotiableAttributesAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateNegotiableAttributesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateNegotiableAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>;
};

export type AgreementTemplateNegotiableAttributesConnection = {
  __typename?: 'AgreementTemplateNegotiableAttributesConnection';
  edges: Array<AgreementTemplateNegotiableAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateNegotiableAttributesConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type AgreementTemplateNegotiableAttributesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateNegotiableAttributesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateNegotiableAttributesConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type AgreementTemplateNegotiableAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateNegotiableAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateNegotiableAttributesRelationship = {
  __typename?: 'AgreementTemplateNegotiableAttributesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type AgreementTemplateNextVersionsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateNextVersionsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateNextVersionsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateNextVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateNextVersionsNodeAggregationWhereInput>;
};

export type AgreementTemplateNextVersionsConnection = {
  __typename?: 'AgreementTemplateNextVersionsConnection';
  edges: Array<AgreementTemplateNextVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateNextVersionsConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type AgreementTemplateNextVersionsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateNextVersionsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateNextVersionsConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type AgreementTemplateNextVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateNextVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateNextVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateNextVersionsNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateNextVersionsRelationship = {
  __typename?: 'AgreementTemplateNextVersionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type AgreementTemplateOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementTemplateSort objects to sort AgreementTemplates by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementTemplateSort>>;
};

export type AgreementTemplateRangeChartConfigAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateRangeChartConfigAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateRangeChartConfigAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateRangeChartConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>;
};

export type AgreementTemplateRangeChartConfigConnection = {
  __typename?: 'AgreementTemplateRangeChartConfigConnection';
  edges: Array<AgreementTemplateRangeChartConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateRangeChartConfigConnectionSort = {
  edge?: InputMaybe<ChartRangeConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type AgreementTemplateRangeChartConfigConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateRangeChartConfigConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateRangeChartConfigConnectionWhere>>;
  edge?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type AgreementTemplateRangeChartConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateRangeChartConfigEdgeAggregationWhereInput>>;
  from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  from_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  to_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateRangeChartConfigRelationship = ChartRangeConfigurationRelationship & {
  __typename?: 'AgreementTemplateRangeChartConfigRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  node: ChartRangeConfiguration;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type AgreementTemplateScenarioScenariosAggregationSelection = {
  __typename?: 'AgreementTemplateScenarioScenariosAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateScenarioScenariosNodeAggregateSelection>;
};

export type AgreementTemplateScenarioScenariosNodeAggregateSelection = {
  __typename?: 'AgreementTemplateScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type AgreementTemplateScenariosAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateScenariosNodeAggregationWhereInput>;
};

export type AgreementTemplateScenariosConnection = {
  __typename?: 'AgreementTemplateScenariosConnection';
  edges: Array<AgreementTemplateScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateScenariosConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type AgreementTemplateScenariosConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type AgreementTemplateScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateScenariosRelationship = {
  __typename?: 'AgreementTemplateScenariosRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type AgreementTemplateScenariosRelevantBrandsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosRelevantBrandsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>;
};

export type AgreementTemplateScenariosRelevantBrandsConnection = {
  __typename?: 'AgreementTemplateScenariosRelevantBrandsConnection';
  edges: Array<AgreementTemplateScenariosRelevantBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateScenariosRelevantBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type AgreementTemplateScenariosRelevantBrandsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateScenariosRelevantBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AgreementTemplateScenariosRelevantBrandsRelationship = {
  __typename?: 'AgreementTemplateScenariosRelevantBrandsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

/** Fields to sort AgreementTemplates by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementTemplateSort object. */
export type AgreementTemplateSort = {
  addedByName?: InputMaybe<SortDirection>;
  agreementQuantity?: InputMaybe<SortDirection>;
  caseSuspensionIntervalDays?: InputMaybe<SortDirection>;
  childAgreementsDefaultStatus?: InputMaybe<SortDirection>;
  coveringFormWaitInterval?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  defaultPriceRate?: InputMaybe<SortDirection>;
  enrolmentDateType?: InputMaybe<SortDirection>;
  expectedDocument?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  isAllowedFormsEnabled?: InputMaybe<SortDirection>;
  isAllowedRecordsEnabled?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isCoveringIntervalEnabled?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isFirstVersion?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  isRequiredFormsEnabled?: InputMaybe<SortDirection>;
  isRequiredRecordsEnabled?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  subjectMatter?: InputMaybe<SortDirection>;
  treatments?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type AgreementTemplateTagsAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateTagsAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateTagsAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementTemplateTagsNodeAggregationWhereInput>;
};

export type AgreementTemplateTagsConnection = {
  __typename?: 'AgreementTemplateTagsConnection';
  edges: Array<AgreementTemplateTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type AgreementTemplateTagsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateTagsConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type AgreementTemplateTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateTagsRelationship = {
  __typename?: 'AgreementTemplateTagsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type AgreementTemplateTreatmentPriceRelationship = {
  basePriceType?: Maybe<PriceType>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type AgreementTemplateTreatmentPriceRelationshipSort = {
  basePriceType?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
};

export type AgreementTemplateTreatmentPriceRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPriceRelationshipWhere>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPriceRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPriceRelationshipWhere>>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_GT?: InputMaybe<Scalars['Float']['input']>;
  price_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  price_LT?: InputMaybe<Scalars['Float']['input']>;
  price_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementTemplateTreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>;
  node?: InputMaybe<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>;
};

export type AgreementTemplateTreatmentPricesConnection = {
  __typename?: 'AgreementTemplateTreatmentPricesConnection';
  edges: Array<AgreementTemplateTreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementTemplateTreatmentPricesConnectionSort = {
  edge?: InputMaybe<AgreementTemplateTreatmentPriceRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type AgreementTemplateTreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesConnectionWhere>>;
  edge?: InputMaybe<AgreementTemplateTreatmentPriceRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type AgreementTemplateTreatmentPricesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesEdgeAggregationWhereInput>>;
  price_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AgreementTemplateTreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<AgreementTemplateTreatmentPricesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplateTreatmentPricesRelationship = AgreementTemplateTreatmentPriceRelationship & {
  __typename?: 'AgreementTemplateTreatmentPricesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  basePriceType?: Maybe<PriceType>;
  cursor: Scalars['String']['output'];
  node: Treatment;
  price?: Maybe<Scalars['Float']['output']>;
};

export type AgreementTemplateTreatmentTreatmentPricesAggregationSelection = {
  __typename?: 'AgreementTemplateTreatmentTreatmentPricesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection>;
  node?: Maybe<AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection>;
};

export type AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection = {
  __typename?: 'AgreementTemplateTreatmentTreatmentPricesEdgeAggregateSelection';
  price: FloatAggregateSelectionNullable;
};

export type AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection = {
  __typename?: 'AgreementTemplateTreatmentTreatmentPricesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type AgreementTemplateUserAddedByAggregationSelection = {
  __typename?: 'AgreementTemplateUserAddedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementTemplateUserAddedByNodeAggregateSelection>;
};

export type AgreementTemplateUserAddedByNodeAggregateSelection = {
  __typename?: 'AgreementTemplateUserAddedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementTemplateWhere = {
  AND?: InputMaybe<Array<AgreementTemplateWhere>>;
  NOT?: InputMaybe<AgreementTemplateWhere>;
  OR?: InputMaybe<Array<AgreementTemplateWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<AgreementTemplateAddedByAggregateInput>;
  addedByConnection?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<AgreementTemplateAddedByConnectionWhere>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  agreementsAggregate?: InputMaybe<AgreementTemplateAgreementsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<AgreementTemplateAgreementsConnectionWhere>;
  /** Return AgreementTemplates where all of the related Agreements match this filter */
  agreements_ALL?: InputMaybe<AgreementWhere>;
  /** Return AgreementTemplates where none of the related Agreements match this filter */
  agreements_NONE?: InputMaybe<AgreementWhere>;
  /** Return AgreementTemplates where one of the related Agreements match this filter */
  agreements_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return AgreementTemplates where some of the related Agreements match this filter */
  agreements_SOME?: InputMaybe<AgreementWhere>;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  caseSuspensionIntervalDays_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  childAgreementsDefaultStatus?: InputMaybe<ContractStatus>;
  childAgreementsDefaultStatus_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<AgreementTemplateCountryAggregateInput>;
  countryConnection?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<AgreementTemplateCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coveringFormWaitInterval_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<AgreementTemplateCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<AgreementTemplateCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  cyclesAggregate?: InputMaybe<AgreementTemplateCyclesAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<AgreementTemplateCyclesConnectionWhere>;
  /** Return AgreementTemplates where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementTemplates where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementTemplates where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return AgreementTemplates where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  defaultPriceRate_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSetsAggregate?: InputMaybe<AgreementTemplateDeviceAlternativeSetsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_ALL?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_NONE?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SINGLE?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SOME?: InputMaybe<AgreementTemplateDeviceAlternativeSetsConnectionWhere>;
  /** Return AgreementTemplates where all of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_ALL?: InputMaybe<DeviceAlternativeWhere>;
  /** Return AgreementTemplates where none of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_NONE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return AgreementTemplates where one of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SINGLE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return AgreementTemplates where some of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SOME?: InputMaybe<DeviceAlternativeWhere>;
  dotThresholds?: InputMaybe<ChartRangeConfigurationWhere>;
  dotThresholdsAggregate?: InputMaybe<AgreementTemplateDotThresholdsAggregateInput>;
  dotThresholdsConnection?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
  dotThresholdsConnection_NOT?: InputMaybe<AgreementTemplateDotThresholdsConnectionWhere>;
  dotThresholds_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  eligibilityConditionSetsAggregate?: InputMaybe<AgreementTemplateEligibilityConditionSetsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_ALL?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_NONE?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SINGLE?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SOME?: InputMaybe<AgreementTemplateEligibilityConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where all of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_ALL?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return AgreementTemplates where none of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_NONE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return AgreementTemplates where one of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SINGLE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return AgreementTemplates where some of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SOME?: InputMaybe<EligibilityConditionSetWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<AgreementTemplateEnrollingConditionSetsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<AgreementTemplateEnrollingConditionSetsConnectionWhere>;
  /** Return AgreementTemplates where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementTemplates where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementTemplates where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return AgreementTemplates where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  enrollingPeriodsAggregate?: InputMaybe<AgreementTemplateEnrollingPeriodsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_ALL?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_NONE?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SINGLE?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SOME?: InputMaybe<AgreementTemplateEnrollingPeriodsConnectionWhere>;
  /** Return AgreementTemplates where all of the related EnrollingPeriods match this filter */
  enrollingPeriods_ALL?: InputMaybe<EnrollingPeriodWhere>;
  /** Return AgreementTemplates where none of the related EnrollingPeriods match this filter */
  enrollingPeriods_NONE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return AgreementTemplates where one of the related EnrollingPeriods match this filter */
  enrollingPeriods_SINGLE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return AgreementTemplates where some of the related EnrollingPeriods match this filter */
  enrollingPeriods_SOME?: InputMaybe<EnrollingPeriodWhere>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  enrolmentDateType_IN?: InputMaybe<Array<InputMaybe<EnrolmentDateType>>>;
  expectedDocument?: InputMaybe<DocumentType>;
  expectedDocument_IN?: InputMaybe<Array<DocumentType>>;
  financialSummaryConfigAggregate?: InputMaybe<AgreementTemplateFinancialSummaryConfigAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_ALL?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_NONE?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SINGLE?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SOME?: InputMaybe<AgreementTemplateFinancialSummaryConfigConnectionWhere>;
  /** Return AgreementTemplates where all of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_ALL?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return AgreementTemplates where none of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_NONE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return AgreementTemplates where one of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SINGLE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return AgreementTemplates where some of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SOME?: InputMaybe<FinancialSummaryColumnWhere>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion?: InputMaybe<AgreementTemplateWhere>;
  initialVersionAggregate?: InputMaybe<AgreementTemplateInitialVersionAggregateInput>;
  initialVersionConnection?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
  initialVersionConnection_NOT?: InputMaybe<AgreementTemplateInitialVersionConnectionWhere>;
  initialVersionId?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion_NOT?: InputMaybe<AgreementTemplateWhere>;
  isAllowedFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  isCoveringIntervalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  limitation?: InputMaybe<LimitationWhere>;
  limitationAggregate?: InputMaybe<AgreementTemplateLimitationAggregateInput>;
  limitationConnection?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
  limitationConnection_NOT?: InputMaybe<AgreementTemplateLimitationConnectionWhere>;
  limitation_NOT?: InputMaybe<LimitationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  negotiableAttributesAggregate?: InputMaybe<AgreementTemplateNegotiableAttributesAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_ALL?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_NONE?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SINGLE?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SOME?: InputMaybe<AgreementTemplateNegotiableAttributesConnectionWhere>;
  /** Return AgreementTemplates where all of the related CatalogueAttributes match this filter */
  negotiableAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return AgreementTemplates where none of the related CatalogueAttributes match this filter */
  negotiableAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return AgreementTemplates where one of the related CatalogueAttributes match this filter */
  negotiableAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return AgreementTemplates where some of the related CatalogueAttributes match this filter */
  negotiableAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  nextVersionsAggregate?: InputMaybe<AgreementTemplateNextVersionsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_ALL?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_NONE?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_SINGLE?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateNextVersionsConnections match this filter */
  nextVersionsConnection_SOME?: InputMaybe<AgreementTemplateNextVersionsConnectionWhere>;
  /** Return AgreementTemplates where all of the related AgreementTemplates match this filter */
  nextVersions_ALL?: InputMaybe<AgreementTemplateWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplates match this filter */
  nextVersions_NONE?: InputMaybe<AgreementTemplateWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplates match this filter */
  nextVersions_SINGLE?: InputMaybe<AgreementTemplateWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplates match this filter */
  nextVersions_SOME?: InputMaybe<AgreementTemplateWhere>;
  rangeChartConfig?: InputMaybe<ChartRangeConfigurationWhere>;
  rangeChartConfigAggregate?: InputMaybe<AgreementTemplateRangeChartConfigAggregateInput>;
  rangeChartConfigConnection?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
  rangeChartConfigConnection_NOT?: InputMaybe<AgreementTemplateRangeChartConfigConnectionWhere>;
  rangeChartConfig_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scenariosAggregate?: InputMaybe<AgreementTemplateScenariosAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<AgreementTemplateScenariosConnectionWhere>;
  scenariosRelevantBrandsAggregate?: InputMaybe<AgreementTemplateScenariosRelevantBrandsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_ALL?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_NONE?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SINGLE?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SOME?: InputMaybe<AgreementTemplateScenariosRelevantBrandsConnectionWhere>;
  /** Return AgreementTemplates where all of the related Brands match this filter */
  scenariosRelevantBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where none of the related Brands match this filter */
  scenariosRelevantBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where one of the related Brands match this filter */
  scenariosRelevantBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where some of the related Brands match this filter */
  scenariosRelevantBrands_SOME?: InputMaybe<BrandWhere>;
  /** Return AgreementTemplates where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return AgreementTemplates where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return AgreementTemplates where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return AgreementTemplates where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  subjectMatter?: InputMaybe<AgreementSubjectMatter>;
  subjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  tagsAggregate?: InputMaybe<AgreementTemplateTagsAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<AgreementTemplateTagsConnectionWhere>;
  /** Return AgreementTemplates where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return AgreementTemplates where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return AgreementTemplates where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return AgreementTemplates where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  treatmentPricesAggregate?: InputMaybe<AgreementTemplateTreatmentPricesAggregateInput>;
  /** Return AgreementTemplates where all of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_ALL?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where none of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_NONE?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where one of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SINGLE?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where some of the related AgreementTemplateTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SOME?: InputMaybe<AgreementTemplateTreatmentPricesConnectionWhere>;
  /** Return AgreementTemplates where all of the related Treatments match this filter */
  treatmentPrices_ALL?: InputMaybe<TreatmentWhere>;
  /** Return AgreementTemplates where none of the related Treatments match this filter */
  treatmentPrices_NONE?: InputMaybe<TreatmentWhere>;
  /** Return AgreementTemplates where one of the related Treatments match this filter */
  treatmentPrices_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return AgreementTemplates where some of the related Treatments match this filter */
  treatmentPrices_SOME?: InputMaybe<TreatmentWhere>;
  treatments?: InputMaybe<Scalars['String']['input']>;
  treatments_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  treatments_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatments_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatments_MATCHES?: InputMaybe<Scalars['String']['input']>;
  treatments_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementTemplatesConnection = {
  __typename?: 'AgreementTemplatesConnection';
  edges: Array<AgreementTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AgreementUserRole {
  Approver = 'APPROVER',
  Editor = 'EDITOR',
  FullAccessUser = 'FULL_ACCESS_USER',
  LimitedAccessUser = 'LIMITED_ACCESS_USER',
  Owner = 'OWNER'
}

export type AgreementUserRoleRelationship = {
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
};

export type AgreementUserRoleRelationshipSort = {
  canApprove?: InputMaybe<SortDirection>;
  canModifyFinancials?: InputMaybe<SortDirection>;
  canViewFinancials?: InputMaybe<SortDirection>;
  isAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type AgreementUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<AgreementUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<AgreementUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<AgreementUserRoleRelationshipWhere>>;
  canApprove?: InputMaybe<Scalars['Boolean']['input']>;
  canModifyFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  canViewFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  isAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type AgreementUserRolesAggregateInput = {
  AND?: InputMaybe<Array<AgreementUserRolesAggregateInput>>;
  NOT?: InputMaybe<AgreementUserRolesAggregateInput>;
  OR?: InputMaybe<Array<AgreementUserRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<AgreementUserRolesNodeAggregationWhereInput>;
};

export type AgreementUserRolesConnection = {
  __typename?: 'AgreementUserRolesConnection';
  edges: Array<AgreementUserRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementUserRolesConnectionSort = {
  edge?: InputMaybe<AgreementUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type AgreementUserRolesConnectionWhere = {
  AND?: InputMaybe<Array<AgreementUserRolesConnectionWhere>>;
  NOT?: InputMaybe<AgreementUserRolesConnectionWhere>;
  OR?: InputMaybe<Array<AgreementUserRolesConnectionWhere>>;
  edge?: InputMaybe<AgreementUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type AgreementUserRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<AgreementUserRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<AgreementUserRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<AgreementUserRolesNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementUserRolesRelationship = AgreementUserRoleRelationship & {
  __typename?: 'AgreementUserRolesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type AgreementUserUserRolesAggregationSelection = {
  __typename?: 'AgreementUserUserRolesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<AgreementUserUserRolesNodeAggregateSelection>;
};

export type AgreementUserUserRolesNodeAggregateSelection = {
  __typename?: 'AgreementUserUserRolesNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type AgreementWhere = {
  AND?: InputMaybe<Array<AgreementWhere>>;
  NOT?: InputMaybe<AgreementWhere>;
  OR?: InputMaybe<Array<AgreementWhere>>;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  counterpartyRolesAggregate?: InputMaybe<AgreementCounterpartyRolesAggregateInput>;
  /** Return Agreements where all of the related AgreementCounterpartyRolesConnections match this filter */
  counterpartyRolesConnection_ALL?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
  /** Return Agreements where none of the related AgreementCounterpartyRolesConnections match this filter */
  counterpartyRolesConnection_NONE?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
  /** Return Agreements where one of the related AgreementCounterpartyRolesConnections match this filter */
  counterpartyRolesConnection_SINGLE?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
  /** Return Agreements where some of the related AgreementCounterpartyRolesConnections match this filter */
  counterpartyRolesConnection_SOME?: InputMaybe<AgreementCounterpartyRolesConnectionWhere>;
  /** Return Agreements where all of the related Organizations match this filter */
  counterpartyRoles_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Agreements where none of the related Organizations match this filter */
  counterpartyRoles_NONE?: InputMaybe<OrganizationWhere>;
  /** Return Agreements where one of the related Organizations match this filter */
  counterpartyRoles_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Agreements where some of the related Organizations match this filter */
  counterpartyRoles_SOME?: InputMaybe<OrganizationWhere>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<AgreementCountryAggregateInput>;
  countryConnection?: InputMaybe<AgreementCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<AgreementCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<AgreementCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<AgreementCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<AgreementCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  dataContainersAggregate?: InputMaybe<AgreementDataContainersAggregateInput>;
  /** Return Agreements where all of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_ALL?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where none of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_NONE?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where one of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_SINGLE?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where some of the related AgreementDataContainersConnections match this filter */
  dataContainersConnection_SOME?: InputMaybe<AgreementDataContainersConnectionWhere>;
  /** Return Agreements where all of the related DataContainers match this filter */
  dataContainers_ALL?: InputMaybe<DataContainerWhere>;
  /** Return Agreements where none of the related DataContainers match this filter */
  dataContainers_NONE?: InputMaybe<DataContainerWhere>;
  /** Return Agreements where one of the related DataContainers match this filter */
  dataContainers_SINGLE?: InputMaybe<DataContainerWhere>;
  /** Return Agreements where some of the related DataContainers match this filter */
  dataContainers_SOME?: InputMaybe<DataContainerWhere>;
  daysToExpiry?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  daysToExpiry_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_LTE?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deviceAlternativeSetsAggregate?: InputMaybe<AgreementDeviceAlternativeSetsAggregateInput>;
  /** Return Agreements where all of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_ALL?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where none of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_NONE?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where one of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SINGLE?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where some of the related AgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SOME?: InputMaybe<AgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return Agreements where all of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_ALL?: InputMaybe<DeviceAlternativeWhere>;
  /** Return Agreements where none of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_NONE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return Agreements where one of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SINGLE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return Agreements where some of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SOME?: InputMaybe<DeviceAlternativeWhere>;
  financialDataPointsAggregate?: InputMaybe<AgreementFinancialDataPointsAggregateInput>;
  /** Return Agreements where all of the related AgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<AgreementFinancialDataPointsConnectionWhere>;
  /** Return Agreements where none of the related AgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<AgreementFinancialDataPointsConnectionWhere>;
  /** Return Agreements where one of the related AgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<AgreementFinancialDataPointsConnectionWhere>;
  /** Return Agreements where some of the related AgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<AgreementFinancialDataPointsConnectionWhere>;
  /** Return Agreements where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Agreements where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Agreements where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Agreements where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedAmount_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCounterparties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedDiseases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedProducts_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedValidityPeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersionId?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  initialVersionId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isInsightsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  lastVersionValidToDate?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lastVersionValidToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  lastVersionValidToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  negotiableAttributesAggregate?: InputMaybe<AgreementNegotiableAttributesAggregateInput>;
  /** Return Agreements where all of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_ALL?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where none of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_NONE?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where one of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SINGLE?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where some of the related AgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SOME?: InputMaybe<AgreementNegotiableAttributesConnectionWhere>;
  /** Return Agreements where all of the related CatalogueAttributes match this filter */
  negotiableAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return Agreements where none of the related CatalogueAttributes match this filter */
  negotiableAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return Agreements where one of the related CatalogueAttributes match this filter */
  negotiableAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return Agreements where some of the related CatalogueAttributes match this filter */
  negotiableAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  nextVersionsAggregate?: InputMaybe<AgreementNextVersionsAggregateInput>;
  /** Return Agreements where all of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_ALL?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where none of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_NONE?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where one of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SINGLE?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where some of the related AgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SOME?: InputMaybe<AgreementNextVersionsConnectionWhere>;
  /** Return Agreements where all of the related Agreements match this filter */
  nextVersions_ALL?: InputMaybe<AgreementWhere>;
  /** Return Agreements where none of the related Agreements match this filter */
  nextVersions_NONE?: InputMaybe<AgreementWhere>;
  /** Return Agreements where one of the related Agreements match this filter */
  nextVersions_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return Agreements where some of the related Agreements match this filter */
  nextVersions_SOME?: InputMaybe<AgreementWhere>;
  pushedOn?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenariosAggregate?: InputMaybe<AgreementScenariosAggregateInput>;
  /** Return Agreements where all of the related AgreementScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where none of the related AgreementScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where one of the related AgreementScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where some of the related AgreementScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<AgreementScenariosConnectionWhere>;
  /** Return Agreements where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return Agreements where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return Agreements where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return Agreements where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  status?: InputMaybe<ContractStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ContractStatus>>>;
  subjectMatter?: InputMaybe<AgreementSubjectMatter>;
  subjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  tagsAggregate?: InputMaybe<AgreementTagsAggregateInput>;
  /** Return Agreements where all of the related AgreementTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where none of the related AgreementTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where one of the related AgreementTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where some of the related AgreementTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<AgreementTagsConnectionWhere>;
  /** Return Agreements where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return Agreements where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return Agreements where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return Agreements where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  userRolesAggregate?: InputMaybe<AgreementUserRolesAggregateInput>;
  /** Return Agreements where all of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_ALL?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where none of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_NONE?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where one of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_SINGLE?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where some of the related AgreementUserRolesConnections match this filter */
  userRolesConnection_SOME?: InputMaybe<AgreementUserRolesConnectionWhere>;
  /** Return Agreements where all of the related Users match this filter */
  userRoles_ALL?: InputMaybe<UserWhere>;
  /** Return Agreements where none of the related Users match this filter */
  userRoles_NONE?: InputMaybe<UserWhere>;
  /** Return Agreements where one of the related Users match this filter */
  userRoles_SINGLE?: InputMaybe<UserWhere>;
  /** Return Agreements where some of the related Users match this filter */
  userRoles_SOME?: InputMaybe<UserWhere>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
  workflowsAggregate?: InputMaybe<AgreementWorkflowsAggregateInput>;
  /** Return Agreements where all of the related AgreementWorkflowsConnections match this filter */
  workflowsConnection_ALL?: InputMaybe<AgreementWorkflowsConnectionWhere>;
  /** Return Agreements where none of the related AgreementWorkflowsConnections match this filter */
  workflowsConnection_NONE?: InputMaybe<AgreementWorkflowsConnectionWhere>;
  /** Return Agreements where one of the related AgreementWorkflowsConnections match this filter */
  workflowsConnection_SINGLE?: InputMaybe<AgreementWorkflowsConnectionWhere>;
  /** Return Agreements where some of the related AgreementWorkflowsConnections match this filter */
  workflowsConnection_SOME?: InputMaybe<AgreementWorkflowsConnectionWhere>;
  /** Return Agreements where all of the related ContractWorkflows match this filter */
  workflows_ALL?: InputMaybe<ContractWorkflowWhere>;
  /** Return Agreements where none of the related ContractWorkflows match this filter */
  workflows_NONE?: InputMaybe<ContractWorkflowWhere>;
  /** Return Agreements where one of the related ContractWorkflows match this filter */
  workflows_SINGLE?: InputMaybe<ContractWorkflowWhere>;
  /** Return Agreements where some of the related ContractWorkflows match this filter */
  workflows_SOME?: InputMaybe<ContractWorkflowWhere>;
};

export type AgreementWorkflowsAggregateInput = {
  AND?: InputMaybe<Array<AgreementWorkflowsAggregateInput>>;
  NOT?: InputMaybe<AgreementWorkflowsAggregateInput>;
  OR?: InputMaybe<Array<AgreementWorkflowsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type AgreementWorkflowsConnection = {
  __typename?: 'AgreementWorkflowsConnection';
  edges: Array<AgreementWorkflowsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementWorkflowsConnectionSort = {
  node?: InputMaybe<ContractWorkflowSort>;
};

export type AgreementWorkflowsConnectionWhere = {
  AND?: InputMaybe<Array<AgreementWorkflowsConnectionWhere>>;
  NOT?: InputMaybe<AgreementWorkflowsConnectionWhere>;
  OR?: InputMaybe<Array<AgreementWorkflowsConnectionWhere>>;
  node?: InputMaybe<ContractWorkflowWhere>;
};

export type AgreementWorkflowsRelationship = {
  __typename?: 'AgreementWorkflowsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ContractWorkflow;
};

export type AgreementsConnection = {
  __typename?: 'AgreementsConnection';
  edges: Array<AgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementsTableSourceFilterData = {
  __typename?: 'AgreementsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amountRanges: Array<AmountRange>;
  brandNames: Array<Scalars['String']['output']>;
  counterparties: Array<Scalars['String']['output']>;
  daysToExpiryRanges: Array<NumericRange>;
  diseases: Array<DiseaseFilterData>;
  ids: Array<Scalars['String']['output']>;
  maxValidFromDate?: Maybe<Scalars['Date']['output']>;
  minValidFromDate?: Maybe<Scalars['Date']['output']>;
  names: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type AgreementsTableSourceFilterDataAggregateSelection = {
  __typename?: 'AgreementsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
};

export type AgreementsTableSourceFilterDataConnection = {
  __typename?: 'AgreementsTableSourceFilterDataConnection';
  edges: Array<AgreementsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AgreementsTableSourceFilterDataEdge = {
  __typename?: 'AgreementsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementsTableSourceFilterData;
};

export type AgreementsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AgreementsTableSourceFilterDataSort objects to sort AgreementsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AgreementsTableSourceFilterDataSort>>;
};

/** Fields to sort AgreementsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one AgreementsTableSourceFilterDataSort object. */
export type AgreementsTableSourceFilterDataSort = {
  maxValidFromDate?: InputMaybe<SortDirection>;
  minValidFromDate?: InputMaybe<SortDirection>;
};

export type AgreementsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<AgreementsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<AgreementsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<AgreementsTableSourceFilterDataWhere>>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  counterparties?: InputMaybe<Array<Scalars['String']['input']>>;
  counterparties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  maxValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  minValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  names_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export enum AmountOfThresholdBasis {
  GrossAmount = 'GROSS_AMOUNT',
  NetAmount = 'NET_AMOUNT'
}

export type AmountRange = {
  __typename?: 'AmountRange';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  end: Scalars['Float']['output'];
  start: Scalars['Float']['output'];
};

export type AmountRangeAggregateSelection = {
  __typename?: 'AmountRangeAggregateSelection';
  count: IntAggregateSelectionNonNullable;
  end: FloatAggregateSelectionNonNullable;
  start: FloatAggregateSelectionNonNullable;
};

export type AmountRangeEdge = {
  __typename?: 'AmountRangeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AmountRange;
};

export type AmountRangeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AmountRangeSort objects to sort AmountRanges by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AmountRangeSort>>;
};

/** Fields to sort AmountRanges by. The order in which sorts are applied is not guaranteed when specifying many fields in one AmountRangeSort object. */
export type AmountRangeSort = {
  count?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
};

export type AmountRangeWhere = {
  AND?: InputMaybe<Array<AmountRangeWhere>>;
  NOT?: InputMaybe<AmountRangeWhere>;
  OR?: InputMaybe<Array<AmountRangeWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Float']['input']>;
  end_GT?: InputMaybe<Scalars['Float']['input']>;
  end_GTE?: InputMaybe<Scalars['Float']['input']>;
  end_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  end_LT?: InputMaybe<Scalars['Float']['input']>;
  end_LTE?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
  start_GT?: InputMaybe<Scalars['Float']['input']>;
  start_GTE?: InputMaybe<Scalars['Float']['input']>;
  start_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  start_LT?: InputMaybe<Scalars['Float']['input']>;
  start_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AmountRangesConnection = {
  __typename?: 'AmountRangesConnection';
  edges: Array<AmountRangeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AmountsType {
  TotalAmount = 'TOTAL_AMOUNT'
}

export type ApplyUserRolesToAllInput = {
  agreementTag: AgreementTagType;
  userId: Scalars['String']['input'];
};

export enum ArithmeticalOperator {
  Both = 'BOTH',
  Equal = 'EQUAL',
  GreaterThen = 'GREATER_THEN',
  GreaterThenOrEqual = 'GREATER_THEN_OR_EQUAL',
  LessThen = 'LESS_THEN',
  LessThenOrEqual = 'LESS_THEN_OR_EQUAL'
}

export type Article71Indication = {
  __typename?: 'Article71Indication';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementScope?: Maybe<AgreementScope>;
  agreementScopeAggregate?: Maybe<Article71IndicationAgreementScopeAgreementScopeAggregationSelection>;
  agreementScopeConnection: Article71IndicationAgreementScopeConnection;
  agreementTemplate?: Maybe<AgreementTemplate>;
  agreementTemplateAggregate?: Maybe<Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection>;
  agreementTemplateConnection: Article71IndicationAgreementTemplateConnection;
  approvalDate?: Maybe<Scalars['Date']['output']>;
  brand: Brand;
  brandAggregate?: Maybe<Article71IndicationBrandBrandAggregationSelection>;
  brandConnection: Article71IndicationBrandConnection;
  cases: Array<Case>;
  casesAggregate?: Maybe<Article71IndicationCaseCasesAggregationSelection>;
  casesConnection: Article71IndicationCasesConnection;
  countryScopeId?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  mainIndication?: Maybe<MainIndication>;
  mainIndicationAggregate?: Maybe<Article71IndicationMainIndicationMainIndicationAggregationSelection>;
  mainIndicationConnection: Article71IndicationMainIndicationConnection;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sllAdditionDate?: Maybe<Scalars['Date']['output']>;
};


export type Article71IndicationAgreementScopeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type Article71IndicationAgreementScopeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type Article71IndicationAgreementScopeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationAgreementScopeConnectionSort>>;
  where?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
};


export type Article71IndicationAgreementTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type Article71IndicationAgreementTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type Article71IndicationAgreementTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationAgreementTemplateConnectionSort>>;
  where?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
};


export type Article71IndicationBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type Article71IndicationBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type Article71IndicationBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationBrandConnectionSort>>;
  where?: InputMaybe<Article71IndicationBrandConnectionWhere>;
};


export type Article71IndicationCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type Article71IndicationCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type Article71IndicationCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationCasesConnectionSort>>;
  where?: InputMaybe<Article71IndicationCasesConnectionWhere>;
};


export type Article71IndicationMainIndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MainIndicationOptions>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type Article71IndicationMainIndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type Article71IndicationMainIndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Article71IndicationMainIndicationConnectionSort>>;
  where?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
};

export type Article71IndicationAggregateSelection = {
  __typename?: 'Article71IndicationAggregateSelection';
  count: Scalars['Int']['output'];
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type Article71IndicationAgreementScopeAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementScopeAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementScopeAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementScopeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationAgreementScopeNodeAggregationWhereInput>;
};

export type Article71IndicationAgreementScopeAgreementScopeAggregationSelection = {
  __typename?: 'Article71IndicationAgreementScopeAgreementScopeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection>;
};

export type Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection = {
  __typename?: 'Article71IndicationAgreementScopeAgreementScopeNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type Article71IndicationAgreementScopeConnection = {
  __typename?: 'Article71IndicationAgreementScopeConnection';
  edges: Array<Article71IndicationAgreementScopeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationAgreementScopeConnectionSort = {
  node?: InputMaybe<AgreementScopeSort>;
};

export type Article71IndicationAgreementScopeConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationAgreementScopeConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationAgreementScopeConnectionWhere>>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type Article71IndicationAgreementScopeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementScopeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementScopeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementScopeNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type Article71IndicationAgreementScopeRelationship = {
  __typename?: 'Article71IndicationAgreementScopeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

export type Article71IndicationAgreementTemplateAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementTemplateAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementTemplateAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationAgreementTemplateNodeAggregationWhereInput>;
};

export type Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection = {
  __typename?: 'Article71IndicationAgreementTemplateAgreementTemplateAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection>;
};

export type Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection = {
  __typename?: 'Article71IndicationAgreementTemplateAgreementTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type Article71IndicationAgreementTemplateConnection = {
  __typename?: 'Article71IndicationAgreementTemplateConnection';
  edges: Array<Article71IndicationAgreementTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationAgreementTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type Article71IndicationAgreementTemplateConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationAgreementTemplateConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationAgreementTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type Article71IndicationAgreementTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationAgreementTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationAgreementTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationAgreementTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type Article71IndicationAgreementTemplateRelationship = {
  __typename?: 'Article71IndicationAgreementTemplateRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type Article71IndicationBrandAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationBrandAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationBrandAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationBrandNodeAggregationWhereInput>;
};

export type Article71IndicationBrandBrandAggregationSelection = {
  __typename?: 'Article71IndicationBrandBrandAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationBrandBrandNodeAggregateSelection>;
};

export type Article71IndicationBrandBrandNodeAggregateSelection = {
  __typename?: 'Article71IndicationBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type Article71IndicationBrandConnection = {
  __typename?: 'Article71IndicationBrandConnection';
  edges: Array<Article71IndicationBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type Article71IndicationBrandConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationBrandConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationBrandConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type Article71IndicationBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<Article71IndicationBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Article71IndicationBrandRelationship = {
  __typename?: 'Article71IndicationBrandRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type Article71IndicationCaseCasesAggregationSelection = {
  __typename?: 'Article71IndicationCaseCasesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationCaseCasesNodeAggregateSelection>;
};

export type Article71IndicationCaseCasesNodeAggregateSelection = {
  __typename?: 'Article71IndicationCaseCasesNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type Article71IndicationCasesAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationCasesAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationCasesAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationCasesNodeAggregationWhereInput>;
};

export type Article71IndicationCasesConnection = {
  __typename?: 'Article71IndicationCasesConnection';
  edges: Array<Article71IndicationCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type Article71IndicationCasesConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationCasesConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type Article71IndicationCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationCasesNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type Article71IndicationCasesRelationship = {
  __typename?: 'Article71IndicationCasesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type Article71IndicationEdge = {
  __typename?: 'Article71IndicationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type Article71IndicationMainIndicationAggregateInput = {
  AND?: InputMaybe<Array<Article71IndicationMainIndicationAggregateInput>>;
  NOT?: InputMaybe<Article71IndicationMainIndicationAggregateInput>;
  OR?: InputMaybe<Array<Article71IndicationMainIndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<Article71IndicationMainIndicationNodeAggregationWhereInput>;
};

export type Article71IndicationMainIndicationConnection = {
  __typename?: 'Article71IndicationMainIndicationConnection';
  edges: Array<Article71IndicationMainIndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Article71IndicationMainIndicationConnectionSort = {
  node?: InputMaybe<MainIndicationSort>;
};

export type Article71IndicationMainIndicationConnectionWhere = {
  AND?: InputMaybe<Array<Article71IndicationMainIndicationConnectionWhere>>;
  NOT?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
  OR?: InputMaybe<Array<Article71IndicationMainIndicationConnectionWhere>>;
  node?: InputMaybe<MainIndicationWhere>;
};

export type Article71IndicationMainIndicationMainIndicationAggregationSelection = {
  __typename?: 'Article71IndicationMainIndicationMainIndicationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<Article71IndicationMainIndicationMainIndicationNodeAggregateSelection>;
};

export type Article71IndicationMainIndicationMainIndicationNodeAggregateSelection = {
  __typename?: 'Article71IndicationMainIndicationMainIndicationNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
};

export type Article71IndicationMainIndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<Article71IndicationMainIndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<Article71IndicationMainIndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<Article71IndicationMainIndicationNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Article71IndicationMainIndicationRelationship = {
  __typename?: 'Article71IndicationMainIndicationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: MainIndication;
};

export type Article71IndicationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more Article71IndicationSort objects to sort Article71Indications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<Article71IndicationSort>>;
};

/** Fields to sort Article71Indications by. The order in which sorts are applied is not guaranteed when specifying many fields in one Article71IndicationSort object. */
export type Article71IndicationSort = {
  approvalDate?: InputMaybe<SortDirection>;
  countryScopeId?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  notes?: InputMaybe<SortDirection>;
  sllAdditionDate?: InputMaybe<SortDirection>;
};

export type Article71IndicationWhere = {
  AND?: InputMaybe<Array<Article71IndicationWhere>>;
  NOT?: InputMaybe<Article71IndicationWhere>;
  OR?: InputMaybe<Array<Article71IndicationWhere>>;
  agreementScope?: InputMaybe<AgreementScopeWhere>;
  agreementScopeAggregate?: InputMaybe<Article71IndicationAgreementScopeAggregateInput>;
  agreementScopeConnection?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
  agreementScopeConnection_NOT?: InputMaybe<Article71IndicationAgreementScopeConnectionWhere>;
  agreementScope_NOT?: InputMaybe<AgreementScopeWhere>;
  agreementTemplate?: InputMaybe<AgreementTemplateWhere>;
  agreementTemplateAggregate?: InputMaybe<Article71IndicationAgreementTemplateAggregateInput>;
  agreementTemplateConnection?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
  agreementTemplateConnection_NOT?: InputMaybe<Article71IndicationAgreementTemplateConnectionWhere>;
  agreementTemplate_NOT?: InputMaybe<AgreementTemplateWhere>;
  approvalDate?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_GT?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  approvalDate_LT?: InputMaybe<Scalars['Date']['input']>;
  approvalDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<Article71IndicationBrandAggregateInput>;
  brandConnection?: InputMaybe<Article71IndicationBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<Article71IndicationBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  casesAggregate?: InputMaybe<Article71IndicationCasesAggregateInput>;
  /** Return Article71Indications where all of the related Article71IndicationCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where none of the related Article71IndicationCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where one of the related Article71IndicationCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where some of the related Article71IndicationCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<Article71IndicationCasesConnectionWhere>;
  /** Return Article71Indications where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return Article71Indications where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return Article71Indications where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return Article71Indications where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  countryScopeId?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  mainIndication?: InputMaybe<MainIndicationWhere>;
  mainIndicationAggregate?: InputMaybe<Article71IndicationMainIndicationAggregateInput>;
  mainIndicationConnection?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
  mainIndicationConnection_NOT?: InputMaybe<Article71IndicationMainIndicationConnectionWhere>;
  mainIndication_NOT?: InputMaybe<MainIndicationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  notes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  notes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes_MATCHES?: InputMaybe<Scalars['String']['input']>;
  notes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sllAdditionDate?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_GT?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  sllAdditionDate_LT?: InputMaybe<Scalars['Date']['input']>;
  sllAdditionDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type Article71IndicationsConnection = {
  __typename?: 'Article71IndicationsConnection';
  edges: Array<Article71IndicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum Article71Status {
  NotSlReimbursedArt_71B = 'NOT_SL_REIMBURSED_ART_71_B',
  SlReimbursedWithoutPm = 'SL_REIMBURSED_WITHOUT_PM',
  SlReimbursedWithPmOffLabel = 'SL_REIMBURSED_WITH_PM_OFF_LABEL',
  SlReimbursedWithPmOffLimitation = 'SL_REIMBURSED_WITH_PM_OFF_LIMITATION'
}

export type AssignInvoiceToUserInput = {
  assignee?: InputMaybe<AssigneeInput>;
  invoiceId: Scalars['ID']['input'];
};

export type AssignUserToDomainInput = {
  domainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};

export type AssigneeInput = {
  emails: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};

export enum AssigneeStatus {
  No = 'NO',
  YesAlways = 'YES_ALWAYS',
  YesWhenCreator = 'YES_WHEN_CREATOR'
}

export enum AttachmentProgressStage {
  Complete = 'COMPLETE',
  Scanning = 'SCANNING',
  Uploading = 'UPLOADING',
  VirusFound = 'VIRUS_FOUND'
}

export enum AttributeSize {
  Extralong = 'EXTRALONG',
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT'
}

export enum AttributeValidationStatus {
  Invalid = 'INVALID',
  Missing = 'MISSING',
  Valid = 'VALID'
}

export type AuthOrganization = {
  __typename?: 'AuthOrganization';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  emailEncryptionEnabled?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publicAgreementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  twoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthOrganizationAggregateSelection = {
  __typename?: 'AuthOrganizationAggregateSelection';
  count: Scalars['Int']['output'];
  externalId: StringAggregateSelectionNullable;
  id: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
};

export type AuthOrganizationEdge = {
  __typename?: 'AuthOrganizationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AuthOrganization;
};

export type AuthOrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AuthOrganizationSort objects to sort AuthOrganizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AuthOrganizationSort>>;
};

/** Fields to sort AuthOrganizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one AuthOrganizationSort object. */
export type AuthOrganizationSort = {
  emailEncryptionEnabled?: InputMaybe<SortDirection>;
  externalId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  publicAgreementsEnabled?: InputMaybe<SortDirection>;
  twoFactorEnabled?: InputMaybe<SortDirection>;
};

export type AuthOrganizationWhere = {
  AND?: InputMaybe<Array<AuthOrganizationWhere>>;
  NOT?: InputMaybe<AuthOrganizationWhere>;
  OR?: InputMaybe<Array<AuthOrganizationWhere>>;
  emailEncryptionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  externalId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAgreementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthOrganizationsConnection = {
  __typename?: 'AuthOrganizationsConnection';
  edges: Array<AuthOrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AutogenerationTrigger {
  UncoveredClaimQuest = 'UNCOVERED_CLAIM_QUEST'
}

export type AverageGenericPrice = {
  __typename?: 'AverageGenericPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
};

export type AverageGenericPriceAggregateSelection = {
  __typename?: 'AverageGenericPriceAggregateSelection';
  Price: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type AverageGenericPriceEdge = {
  __typename?: 'AverageGenericPriceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AverageGenericPrice;
};

export type AverageGenericPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AverageGenericPriceSort objects to sort AverageGenericPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AverageGenericPriceSort>>;
};

/** Fields to sort AverageGenericPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one AverageGenericPriceSort object. */
export type AverageGenericPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type AverageGenericPriceWhere = {
  AND?: InputMaybe<Array<AverageGenericPriceWhere>>;
  NOT?: InputMaybe<AverageGenericPriceWhere>;
  OR?: InputMaybe<Array<AverageGenericPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type AverageGenericPricesConnection = {
  __typename?: 'AverageGenericPricesConnection';
  edges: Array<AverageGenericPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AverageLaPressureAndLaVolumeRow = {
  __typename?: 'AverageLAPressureAndLAVolumeRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  averageLAPressure: Scalars['Float']['output'];
  averageLAVolume: Scalars['Float']['output'];
  interventionType: ReportInterventionType;
  maxLAPressure: Scalars['Float']['output'];
  maxLAVolume: Scalars['Float']['output'];
  minLAPressure: Scalars['Float']['output'];
  minLAVolume: Scalars['Float']['output'];
};

export type AverageLaPressureAndLaVolumeRowAggregateSelection = {
  __typename?: 'AverageLAPressureAndLAVolumeRowAggregateSelection';
  averageLAPressure: FloatAggregateSelectionNonNullable;
  averageLAVolume: FloatAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  maxLAPressure: FloatAggregateSelectionNonNullable;
  maxLAVolume: FloatAggregateSelectionNonNullable;
  minLAPressure: FloatAggregateSelectionNonNullable;
  minLAVolume: FloatAggregateSelectionNonNullable;
};

export type AverageLaPressureAndLaVolumeRowEdge = {
  __typename?: 'AverageLAPressureAndLAVolumeRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AverageLaPressureAndLaVolumeRow;
};

export type AverageLaPressureAndLaVolumeRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more AverageLAPressureAndLAVolumeRowSort objects to sort AverageLaPressureAndLaVolumeRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<AverageLaPressureAndLaVolumeRowSort>>;
};

/** Fields to sort AverageLaPressureAndLaVolumeRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one AverageLAPressureAndLAVolumeRowSort object. */
export type AverageLaPressureAndLaVolumeRowSort = {
  averageLAPressure?: InputMaybe<SortDirection>;
  averageLAVolume?: InputMaybe<SortDirection>;
  interventionType?: InputMaybe<SortDirection>;
  maxLAPressure?: InputMaybe<SortDirection>;
  maxLAVolume?: InputMaybe<SortDirection>;
  minLAPressure?: InputMaybe<SortDirection>;
  minLAVolume?: InputMaybe<SortDirection>;
};

export type AverageLaPressureAndLaVolumeRowWhere = {
  AND?: InputMaybe<Array<AverageLaPressureAndLaVolumeRowWhere>>;
  NOT?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
  OR?: InputMaybe<Array<AverageLaPressureAndLaVolumeRowWhere>>;
  averageLAPressure?: InputMaybe<Scalars['Float']['input']>;
  averageLAPressure_GT?: InputMaybe<Scalars['Float']['input']>;
  averageLAPressure_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageLAPressure_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  averageLAPressure_LT?: InputMaybe<Scalars['Float']['input']>;
  averageLAPressure_LTE?: InputMaybe<Scalars['Float']['input']>;
  averageLAVolume?: InputMaybe<Scalars['Float']['input']>;
  averageLAVolume_GT?: InputMaybe<Scalars['Float']['input']>;
  averageLAVolume_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageLAVolume_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  averageLAVolume_LT?: InputMaybe<Scalars['Float']['input']>;
  averageLAVolume_LTE?: InputMaybe<Scalars['Float']['input']>;
  interventionType?: InputMaybe<ReportInterventionType>;
  interventionType_IN?: InputMaybe<Array<ReportInterventionType>>;
  maxLAPressure?: InputMaybe<Scalars['Float']['input']>;
  maxLAPressure_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLAPressure_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLAPressure_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxLAPressure_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLAPressure_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLAVolume?: InputMaybe<Scalars['Float']['input']>;
  maxLAVolume_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLAVolume_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLAVolume_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  maxLAVolume_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLAVolume_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLAPressure?: InputMaybe<Scalars['Float']['input']>;
  minLAPressure_GT?: InputMaybe<Scalars['Float']['input']>;
  minLAPressure_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLAPressure_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  minLAPressure_LT?: InputMaybe<Scalars['Float']['input']>;
  minLAPressure_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLAVolume?: InputMaybe<Scalars['Float']['input']>;
  minLAVolume_GT?: InputMaybe<Scalars['Float']['input']>;
  minLAVolume_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLAVolume_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  minLAVolume_LT?: InputMaybe<Scalars['Float']['input']>;
  minLAVolume_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type AverageLaPressureAndLaVolumeRowsConnection = {
  __typename?: 'AverageLaPressureAndLaVolumeRowsConnection';
  edges: Array<AverageLaPressureAndLaVolumeRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreement = {
  __typename?: 'BaseAgreement';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedBy: User;
  addedByAggregate?: Maybe<BaseAgreementUserAddedByAggregationSelection>;
  addedByConnection: BaseAgreementAddedByConnection;
  allowedFormFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  allowedForms?: Maybe<Array<Scalars['String']['output']>>;
  allowedRecordFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  allowedRecords?: Maybe<Array<Scalars['String']['output']>>;
  canUserViewFinancials: Scalars['Boolean']['output'];
  caseSuspensionIntervalDays?: Maybe<Scalars['Int']['output']>;
  caselessAgreementDataSnapshot?: Maybe<Scalars['String']['output']>;
  cases: Array<Case>;
  casesAggregate?: Maybe<BaseAgreementCaseCasesAggregationSelection>;
  casesConnection: BaseAgreementCasesConnection;
  counterparties: Array<Organization>;
  counterpartiesAggregate?: Maybe<BaseAgreementOrganizationCounterpartiesAggregationSelection>;
  counterpartiesConnection: BaseAgreementCounterpartiesConnection;
  country: Country;
  countryAggregate?: Maybe<BaseAgreementCountryCountryAggregationSelection>;
  countryConnection: BaseAgreementCountryConnection;
  coveringFormWaitInterval?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currency?: Maybe<Currency>;
  currencyAggregate?: Maybe<BaseAgreementCurrencyCurrencyAggregationSelection>;
  currencyConnection: BaseAgreementCurrencyConnection;
  cycles: Array<CycleConfiguration>;
  cyclesAggregate?: Maybe<BaseAgreementCycleConfigurationCyclesAggregationSelection>;
  cyclesConnection: BaseAgreementCyclesConnection;
  dataContainers: Array<DataContainer>;
  dataContainersAggregate?: Maybe<BaseAgreementDataContainerDataContainersAggregationSelection>;
  dataContainersConnection: BaseAgreementDataContainersConnection;
  dataSource: DataSource;
  dataSourceAggregate?: Maybe<BaseAgreementDataSourceDataSourceAggregationSelection>;
  dataSourceConnection: BaseAgreementDataSourceConnection;
  daysToExpiry?: Maybe<Scalars['Int']['output']>;
  decisions: Array<AgreementDecision>;
  decisionsAggregate?: Maybe<BaseAgreementAgreementDecisionDecisionsAggregationSelection>;
  decisionsConnection: BaseAgreementDecisionsConnection;
  defaultPriceRate?: Maybe<Scalars['Float']['output']>;
  deviceAlternativeSets: Array<DeviceAlternative>;
  deviceAlternativeSetsAggregate?: Maybe<BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection>;
  deviceAlternativeSetsConnection: BaseAgreementDeviceAlternativeSetsConnection;
  dotThresholds?: Maybe<ChartRangeConfiguration>;
  dotThresholdsAggregate?: Maybe<BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection>;
  dotThresholdsConnection: BaseAgreementDotThresholdsConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsAggregate?: Maybe<BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection>;
  eligibilityConditionSetsConnection: BaseAgreementEligibilityConditionSetsConnection;
  eligibilityConditionTreatments?: Maybe<Array<Maybe<Treatment>>>;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate?: Maybe<BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection>;
  enrollingConditionSetsConnection: BaseAgreementEnrollingConditionSetsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsAggregate?: Maybe<BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection>;
  enrollingPeriodsConnection: BaseAgreementEnrollingPeriodsConnection;
  enrolmentDateType?: Maybe<EnrolmentDateType>;
  expectedDocument: DocumentType;
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: BaseAgreementFinancialDataPointsConnection;
  financialSummaryConfig: Array<FinancialSummaryColumn>;
  financialSummaryConfigAggregate?: Maybe<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection>;
  financialSummaryConfigConnection: BaseAgreementFinancialSummaryConfigConnection;
  firstExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  formattedAmount?: Maybe<Scalars['String']['output']>;
  formattedCounterparties?: Maybe<Scalars['String']['output']>;
  formattedDiseases?: Maybe<Scalars['String']['output']>;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  formattedProducts?: Maybe<Scalars['String']['output']>;
  formattedTags: Scalars['String']['output'];
  formattedValidityPeriod?: Maybe<Scalars['String']['output']>;
  generics: Array<Generic>;
  id: Scalars['ID']['output'];
  initialVersion?: Maybe<BaseAgreement>;
  initialVersionAggregate?: Maybe<BaseAgreementBaseAgreementInitialVersionAggregationSelection>;
  initialVersionConnection: BaseAgreementInitialVersionConnection;
  initialVersionId: Scalars['String']['output'];
  isAllowedFormsEnabled: Scalars['Boolean']['output'];
  isAllowedRecordsEnabled: Scalars['Boolean']['output'];
  isCaseless: Scalars['Boolean']['output'];
  isCoveringIntervalEnabled: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  isFirstVersion: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isInsightsAvailable?: Maybe<Scalars['Boolean']['output']>;
  isLastVersion: Scalars['Boolean']['output'];
  isRequiredFormsEnabled: Scalars['Boolean']['output'];
  isRequiredRecordsEnabled: Scalars['Boolean']['output'];
  isScenariosInSync?: Maybe<Scalars['Boolean']['output']>;
  isScopeSync?: Maybe<Scalars['Boolean']['output']>;
  isValidityPeriodInSync?: Maybe<Scalars['Boolean']['output']>;
  lastExecutionDate?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedOn?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  negotiableAttributes: Array<CatalogueAttribute>;
  negotiableAttributesAggregate?: Maybe<BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection>;
  negotiableAttributesConnection: BaseAgreementNegotiableAttributesConnection;
  nextVersions: Array<BaseAgreement>;
  nextVersionsAggregate?: Maybe<BaseAgreementBaseAgreementNextVersionsAggregationSelection>;
  nextVersionsConnection: BaseAgreementNextVersionsConnection;
  participatingCounterparties: Array<Organization>;
  pushedBy?: Maybe<User>;
  pushedByAggregate?: Maybe<BaseAgreementUserPushedByAggregationSelection>;
  pushedByConnection: BaseAgreementPushedByConnection;
  pushedOn?: Maybe<Scalars['DateTime']['output']>;
  rangeChartConfig?: Maybe<ChartRangeConfiguration>;
  rangeChartConfigAggregate?: Maybe<BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection>;
  rangeChartConfigConnection: BaseAgreementRangeChartConfigConnection;
  reportData?: Maybe<Scalars['String']['output']>;
  requiredFormFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  requiredForms?: Maybe<Array<Scalars['String']['output']>>;
  requiredRecordFlexEntityTypes?: Maybe<Array<FlexEntityType>>;
  requiredRecords?: Maybe<Array<Scalars['String']['output']>>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<BaseAgreementScenarioScenariosAggregationSelection>;
  scenariosConnection: BaseAgreementScenariosConnection;
  scenariosRelevantBrands: Array<Brand>;
  scenariosRelevantBrandsAggregate?: Maybe<BaseAgreementBrandScenariosRelevantBrandsAggregationSelection>;
  scenariosRelevantBrandsConnection: BaseAgreementScenariosRelevantBrandsConnection;
  status: ContractStatus;
  statusTransitions: Array<AgreementStatusTransition>;
  statusTransitionsAggregate?: Maybe<BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection>;
  statusTransitionsConnection: BaseAgreementStatusTransitionsConnection;
  subjectMatter: AgreementSubjectMatter;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<BaseAgreementAgreementTagTagsAggregationSelection>;
  tagsConnection: BaseAgreementTagsConnection;
  template?: Maybe<AgreementTemplate>;
  templateAggregate?: Maybe<BaseAgreementAgreementTemplateTemplateAggregationSelection>;
  templateConnection: BaseAgreementTemplateConnection;
  tenantIds: Array<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  treatmentPrices: Array<Treatment>;
  treatmentPricesAggregate?: Maybe<BaseAgreementTreatmentTreatmentPricesAggregationSelection>;
  treatmentPricesConnection: BaseAgreementTreatmentPricesConnection;
  userContexts: Array<UserContext>;
  userContextsAggregate?: Maybe<BaseAgreementUserContextUserContextsAggregationSelection>;
  userContextsConnection: BaseAgreementUserContextsConnection;
  userOrganizationRole?: Maybe<CounterpartyRole>;
  userRoles: Array<User>;
  userRolesAggregate?: Maybe<BaseAgreementUserUserRolesAggregationSelection>;
  userRolesConnection: BaseAgreementUserRolesConnection;
  validFromDate: Scalars['Date']['output'];
  validToDate?: Maybe<Scalars['Date']['output']>;
  version: Scalars['Int']['output'];
};


export type BaseAgreementAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementAddedByConnectionSort>>;
  where?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
};


export type BaseAgreementCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type BaseAgreementCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type BaseAgreementCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCasesConnectionSort>>;
  where?: InputMaybe<BaseAgreementCasesConnectionWhere>;
};


export type BaseAgreementCounterpartiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type BaseAgreementCounterpartiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type BaseAgreementCounterpartiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionSort>>;
  where?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
};


export type BaseAgreementCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type BaseAgreementCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type BaseAgreementCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCountryConnectionSort>>;
  where?: InputMaybe<BaseAgreementCountryConnectionWhere>;
};


export type BaseAgreementCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type BaseAgreementCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type BaseAgreementCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCurrencyConnectionSort>>;
  where?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
};


export type BaseAgreementCyclesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type BaseAgreementCyclesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type BaseAgreementCyclesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementCyclesConnectionSort>>;
  where?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
};


export type BaseAgreementDataContainersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataContainerOptions>;
  where?: InputMaybe<DataContainerWhere>;
};


export type BaseAgreementDataContainersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataContainerWhere>;
};


export type BaseAgreementDataContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDataContainersConnectionSort>>;
  where?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
};


export type BaseAgreementDataSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DataSourceOptions>;
  where?: InputMaybe<DataSourceWhere>;
};


export type BaseAgreementDataSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DataSourceWhere>;
};


export type BaseAgreementDataSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDataSourceConnectionSort>>;
  where?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
};


export type BaseAgreementDecisionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementDecisionOptions>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type BaseAgreementDecisionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type BaseAgreementDecisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDecisionsConnectionSort>>;
  where?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
};


export type BaseAgreementDeviceAlternativeSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type BaseAgreementDeviceAlternativeSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type BaseAgreementDeviceAlternativeSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionSort>>;
  where?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
};


export type BaseAgreementDotThresholdsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementDotThresholdsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementDotThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementDotThresholdsConnectionSort>>;
  where?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
};


export type BaseAgreementEligibilityConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type BaseAgreementEligibilityConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type BaseAgreementEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionSort>>;
  where?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
};


export type BaseAgreementEnrollingConditionSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type BaseAgreementEnrollingConditionSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type BaseAgreementEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionSort>>;
  where?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
};


export type BaseAgreementEnrollingPeriodsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type BaseAgreementEnrollingPeriodsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type BaseAgreementEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionSort>>;
  where?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
};


export type BaseAgreementFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type BaseAgreementFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type BaseAgreementFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
};


export type BaseAgreementFinancialSummaryConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type BaseAgreementFinancialSummaryConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type BaseAgreementFinancialSummaryConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionSort>>;
  where?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
};


export type BaseAgreementInitialVersionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementInitialVersionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementInitialVersionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementInitialVersionConnectionSort>>;
  where?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
};


export type BaseAgreementNegotiableAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type BaseAgreementNegotiableAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type BaseAgreementNegotiableAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementNegotiableAttributesConnectionSort>>;
  where?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
};


export type BaseAgreementNextVersionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementNextVersionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type BaseAgreementNextVersionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementNextVersionsConnectionSort>>;
  where?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
};


export type BaseAgreementPushedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementPushedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementPushedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementPushedByConnectionSort>>;
  where?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
};


export type BaseAgreementRangeChartConfigArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementRangeChartConfigAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type BaseAgreementRangeChartConfigConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementRangeChartConfigConnectionSort>>;
  where?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
};


export type BaseAgreementScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type BaseAgreementScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type BaseAgreementScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementScenariosConnectionSort>>;
  where?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
};


export type BaseAgreementScenariosRelevantBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type BaseAgreementScenariosRelevantBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type BaseAgreementScenariosRelevantBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsConnectionSort>>;
  where?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
};


export type BaseAgreementStatusTransitionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementStatusTransitionOptions>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type BaseAgreementStatusTransitionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type BaseAgreementStatusTransitionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionSort>>;
  where?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
};


export type BaseAgreementTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type BaseAgreementTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type BaseAgreementTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementTagsConnectionSort>>;
  where?: InputMaybe<BaseAgreementTagsConnectionWhere>;
};


export type BaseAgreementTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type BaseAgreementTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type BaseAgreementTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementTemplateConnectionSort>>;
  where?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
};


export type BaseAgreementTreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type BaseAgreementTreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type BaseAgreementTreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionSort>>;
  where?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
};


export type BaseAgreementUserContextsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserContextOptions>;
  where?: InputMaybe<UserContextWhere>;
};


export type BaseAgreementUserContextsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserContextWhere>;
};


export type BaseAgreementUserContextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementUserContextsConnectionSort>>;
  where?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
};


export type BaseAgreementUserRolesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementUserRolesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BaseAgreementUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BaseAgreementUserRolesConnectionSort>>;
  where?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
};

export type BaseAgreementAddedByAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementAddedByAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementAddedByAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementAddedByNodeAggregationWhereInput>;
};

export type BaseAgreementAddedByConnection = {
  __typename?: 'BaseAgreementAddedByConnection';
  edges: Array<BaseAgreementAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type BaseAgreementAddedByConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementAddedByConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type BaseAgreementAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementAddedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementAddedByRelationship = {
  __typename?: 'BaseAgreementAddedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type BaseAgreementAggregateSelection = {
  __typename?: 'BaseAgreementAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementDecisionDecisionsAggregationSelection = {
  __typename?: 'BaseAgreementAgreementDecisionDecisionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection>;
};

export type BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementDecisionDecisionsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection = {
  __typename?: 'BaseAgreementAgreementStatusTransitionStatusTransitionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection>;
};

export type BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementStatusTransitionStatusTransitionsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementTagTagsAggregationSelection = {
  __typename?: 'BaseAgreementAgreementTagTagsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementTagTagsNodeAggregateSelection>;
};

export type BaseAgreementAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type BaseAgreementAgreementTemplateTemplateAggregationSelection = {
  __typename?: 'BaseAgreementAgreementTemplateTemplateAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementAgreementTemplateTemplateNodeAggregateSelection>;
};

export type BaseAgreementAgreementTemplateTemplateNodeAggregateSelection = {
  __typename?: 'BaseAgreementAgreementTemplateTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementBaseAgreementInitialVersionAggregationSelection = {
  __typename?: 'BaseAgreementBaseAgreementInitialVersionAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection>;
};

export type BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection = {
  __typename?: 'BaseAgreementBaseAgreementInitialVersionNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementBaseAgreementNextVersionsAggregationSelection = {
  __typename?: 'BaseAgreementBaseAgreementNextVersionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection>;
};

export type BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection = {
  __typename?: 'BaseAgreementBaseAgreementNextVersionsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type BaseAgreementBrandScenariosRelevantBrandsAggregationSelection = {
  __typename?: 'BaseAgreementBrandScenariosRelevantBrandsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection>;
};

export type BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection = {
  __typename?: 'BaseAgreementBrandScenariosRelevantBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type BaseAgreementCaseCasesAggregationSelection = {
  __typename?: 'BaseAgreementCaseCasesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCaseCasesNodeAggregateSelection>;
};

export type BaseAgreementCaseCasesNodeAggregateSelection = {
  __typename?: 'BaseAgreementCaseCasesNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type BaseAgreementCasesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCasesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCasesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCasesNodeAggregationWhereInput>;
};

export type BaseAgreementCasesConnection = {
  __typename?: 'BaseAgreementCasesConnection';
  edges: Array<BaseAgreementCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type BaseAgreementCasesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCasesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type BaseAgreementCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCasesNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementCasesRelationship = {
  __typename?: 'BaseAgreementCasesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection = {
  __typename?: 'BaseAgreementCatalogueAttributeNegotiableAttributesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection>;
};

export type BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection = {
  __typename?: 'BaseAgreementCatalogueAttributeNegotiableAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationDotThresholdsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection>;
};

export type BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationDotThresholdsEdgeAggregateSelection';
  threshold: IntAggregateSelectionNonNullable;
};

export type BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationRangeChartConfigAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection>;
};

export type BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection = {
  __typename?: 'BaseAgreementChartRangeConfigurationRangeChartConfigEdgeAggregateSelection';
  from: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  to: IntAggregateSelectionNullable;
};

export type BaseAgreementCounterpartiesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartiesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCounterpartiesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCounterpartiesNodeAggregationWhereInput>;
};

export type BaseAgreementCounterpartiesConnection = {
  __typename?: 'BaseAgreementCounterpartiesConnection';
  edges: Array<BaseAgreementCounterpartiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCounterpartiesConnectionSort = {
  edge?: InputMaybe<BaseAgreementCounterpartyRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type BaseAgreementCounterpartiesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartiesConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementCounterpartyRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type BaseAgreementCounterpartiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartiesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BaseAgreementCounterpartiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartiesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCounterpartiesRelationship = BaseAgreementCounterpartyRelationship & {
  __typename?: 'BaseAgreementCounterpartiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  node: Organization;
  role: CounterpartyRole;
};

export type BaseAgreementCounterpartyRelationship = {
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  role: CounterpartyRole;
};

export type BaseAgreementCounterpartyRelationshipSort = {
  isApprovalRequired?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type BaseAgreementCounterpartyRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementCounterpartyRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementCounterpartyRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementCounterpartyRelationshipWhere>>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<CounterpartyRole>;
  role_IN?: InputMaybe<Array<CounterpartyRole>>;
};

export type BaseAgreementCountryAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCountryAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCountryAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCountryNodeAggregationWhereInput>;
};

export type BaseAgreementCountryConnection = {
  __typename?: 'BaseAgreementCountryConnection';
  edges: Array<BaseAgreementCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type BaseAgreementCountryConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCountryConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCountryConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type BaseAgreementCountryCountryAggregationSelection = {
  __typename?: 'BaseAgreementCountryCountryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCountryCountryNodeAggregateSelection>;
};

export type BaseAgreementCountryCountryNodeAggregateSelection = {
  __typename?: 'BaseAgreementCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type BaseAgreementCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCountryRelationship = {
  __typename?: 'BaseAgreementCountryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type BaseAgreementCurrencyAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCurrencyAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCurrencyAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCurrencyNodeAggregationWhereInput>;
};

export type BaseAgreementCurrencyConnection = {
  __typename?: 'BaseAgreementCurrencyConnection';
  edges: Array<BaseAgreementCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type BaseAgreementCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCurrencyConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type BaseAgreementCurrencyCurrencyAggregationSelection = {
  __typename?: 'BaseAgreementCurrencyCurrencyAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCurrencyCurrencyNodeAggregateSelection>;
};

export type BaseAgreementCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'BaseAgreementCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type BaseAgreementCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BaseAgreementCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<BaseAgreementCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCurrencyRelationship = {
  __typename?: 'BaseAgreementCurrencyRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type BaseAgreementCycleConfigurationCyclesAggregationSelection = {
  __typename?: 'BaseAgreementCycleConfigurationCyclesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementCycleConfigurationCyclesNodeAggregateSelection>;
};

export type BaseAgreementCycleConfigurationCyclesNodeAggregateSelection = {
  __typename?: 'BaseAgreementCycleConfigurationCyclesNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type BaseAgreementCyclesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementCyclesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementCyclesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementCyclesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementCyclesNodeAggregationWhereInput>;
};

export type BaseAgreementCyclesConnection = {
  __typename?: 'BaseAgreementCyclesConnection';
  edges: Array<BaseAgreementCyclesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementCyclesConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type BaseAgreementCyclesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementCyclesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementCyclesConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type BaseAgreementCyclesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementCyclesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementCyclesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementCyclesNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementCyclesRelationship = {
  __typename?: 'BaseAgreementCyclesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type BaseAgreementDataContainerDataContainersAggregationSelection = {
  __typename?: 'BaseAgreementDataContainerDataContainersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementDataContainerDataContainersNodeAggregateSelection>;
};

export type BaseAgreementDataContainerDataContainersNodeAggregateSelection = {
  __typename?: 'BaseAgreementDataContainerDataContainersNodeAggregateSelection';
  subType: StringAggregateSelectionNonNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
};

export type BaseAgreementDataContainersAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDataContainersAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDataContainersAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDataContainersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDataContainersNodeAggregationWhereInput>;
};

export type BaseAgreementDataContainersConnection = {
  __typename?: 'BaseAgreementDataContainersConnection';
  edges: Array<BaseAgreementDataContainersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDataContainersConnectionSort = {
  node?: InputMaybe<DataContainerSort>;
};

export type BaseAgreementDataContainersConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDataContainersConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDataContainersConnectionWhere>>;
  node?: InputMaybe<DataContainerWhere>;
};

export type BaseAgreementDataContainersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDataContainersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDataContainersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDataContainersNodeAggregationWhereInput>>;
  subType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  subType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  subType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  subType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDataContainersRelationship = {
  __typename?: 'BaseAgreementDataContainersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DataContainer;
};

export type BaseAgreementDataSourceAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDataSourceAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDataSourceAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDataSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDataSourceNodeAggregationWhereInput>;
};

export type BaseAgreementDataSourceConnection = {
  __typename?: 'BaseAgreementDataSourceConnection';
  edges: Array<BaseAgreementDataSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDataSourceConnectionSort = {
  node?: InputMaybe<DataSourceSort>;
};

export type BaseAgreementDataSourceConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDataSourceConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDataSourceConnectionWhere>>;
  node?: InputMaybe<DataSourceWhere>;
};

export type BaseAgreementDataSourceDataSourceAggregationSelection = {
  __typename?: 'BaseAgreementDataSourceDataSourceAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementDataSourceDataSourceNodeAggregateSelection>;
};

export type BaseAgreementDataSourceDataSourceNodeAggregateSelection = {
  __typename?: 'BaseAgreementDataSourceDataSourceNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type BaseAgreementDataSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDataSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDataSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDataSourceNodeAggregationWhereInput>>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDataSourceRelationship = {
  __typename?: 'BaseAgreementDataSourceRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DataSource;
};

export type BaseAgreementDecisionsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDecisionsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDecisionsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDecisionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDecisionsNodeAggregationWhereInput>;
};

export type BaseAgreementDecisionsConnection = {
  __typename?: 'BaseAgreementDecisionsConnection';
  edges: Array<BaseAgreementDecisionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDecisionsConnectionSort = {
  node?: InputMaybe<AgreementDecisionSort>;
};

export type BaseAgreementDecisionsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDecisionsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDecisionsConnectionWhere>>;
  node?: InputMaybe<AgreementDecisionWhere>;
};

export type BaseAgreementDecisionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDecisionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDecisionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDecisionsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementDecisionsRelationship = {
  __typename?: 'BaseAgreementDecisionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementDecision;
};

export type BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection = {
  __typename?: 'BaseAgreementDeviceAlternativeDeviceAlternativeSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection>;
};

export type BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection = {
  __typename?: 'BaseAgreementDeviceAlternativeDeviceAlternativeSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
};

export type BaseAgreementDeviceAlternativeSetsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
};

export type BaseAgreementDeviceAlternativeSetsConnection = {
  __typename?: 'BaseAgreementDeviceAlternativeSetsConnection';
  edges: Array<BaseAgreementDeviceAlternativeSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDeviceAlternativeSetsConnectionSort = {
  node?: InputMaybe<DeviceAlternativeSort>;
};

export type BaseAgreementDeviceAlternativeSetsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsConnectionWhere>>;
  node?: InputMaybe<DeviceAlternativeWhere>;
};

export type BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDeviceAlternativeSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDeviceAlternativeSetsRelationship = {
  __typename?: 'BaseAgreementDeviceAlternativeSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type BaseAgreementDotThresholdsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementDotThresholdsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementDotThresholdsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementDotThresholdsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementDotThresholdsEdgeAggregationWhereInput>;
};

export type BaseAgreementDotThresholdsConnection = {
  __typename?: 'BaseAgreementDotThresholdsConnection';
  edges: Array<BaseAgreementDotThresholdsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementDotThresholdsConnectionSort = {
  edge?: InputMaybe<ThresholdConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type BaseAgreementDotThresholdsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementDotThresholdsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementDotThresholdsConnectionWhere>>;
  edge?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type BaseAgreementDotThresholdsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementDotThresholdsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementDotThresholdsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementDotThresholdsEdgeAggregationWhereInput>>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementDotThresholdsRelationship = ThresholdConfigurationRelationship & {
  __typename?: 'BaseAgreementDotThresholdsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
  threshold: Scalars['Int']['output'];
};

export type BaseAgreementEdge = {
  __typename?: 'BaseAgreementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type BaseAgreementEligibilityConditionRelationship = {
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementEligibilityConditionRelationshipSort = {
  cycleAdherence?: InputMaybe<SortDirection>;
  days?: InputMaybe<SortDirection>;
  minimumPercentage?: InputMaybe<SortDirection>;
  numberOfAdministeredRangeDays?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatments?: InputMaybe<SortDirection>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<SortDirection>;
  previousTestNumber?: InputMaybe<SortDirection>;
  referenceAdministrationSequenceNumber?: InputMaybe<SortDirection>;
  referenceTestRangeDays?: InputMaybe<SortDirection>;
  treatments?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type BaseAgreementEligibilityConditionRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionRelationshipWhere>>;
  cycleAdherence?: InputMaybe<CycleAdherence>;
  cycleAdherence_IN?: InputMaybe<Array<InputMaybe<CycleAdherence>>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minimumPercentage_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatmentsOperator?: InputMaybe<ArithmeticalOperator>;
  numberOfAdministeredTreatmentsOperator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  numberOfAdministeredTreatments_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  numberOfAdministeredTreatments_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  previousTestNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceAdministrationSequenceNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceTestRangeDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceTestRangeDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatments_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
  value_GT?: InputMaybe<Scalars['Int']['input']>;
  value_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  value_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection = {
  __typename?: 'BaseAgreementEligibilityConditionSetEligibilityConditionSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection>;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection = {
  __typename?: 'BaseAgreementEligibilityConditionSetEligibilityConditionSetsEdgeAggregateSelection';
  days: IntAggregateSelectionNullable;
  minimumPercentage: IntAggregateSelectionNullable;
  numberOfAdministeredTreatments: IntAggregateSelectionNullable;
  previousTestNumber: IntAggregateSelectionNullable;
  referenceAdministrationSequenceNumber: IntAggregateSelectionNullable;
  value: IntAggregateSelectionNullable;
};

export type BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection = {
  __typename?: 'BaseAgreementEligibilityConditionSetEligibilityConditionSetsNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  inputLabel: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
};

export type BaseAgreementEligibilityConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>;
};

export type BaseAgreementEligibilityConditionSetsConnection = {
  __typename?: 'BaseAgreementEligibilityConditionSetsConnection';
  edges: Array<BaseAgreementEligibilityConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementEligibilityConditionSetsConnectionSort = {
  edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipSort>;
  node?: InputMaybe<EligibilityConditionSetSort>;
};

export type BaseAgreementEligibilityConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementEligibilityConditionRelationshipWhere>;
  node?: InputMaybe<EligibilityConditionSetWhere>;
};

export type BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsEdgeAggregationWhereInput>>;
  days_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  days_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  days_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  days_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  days_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minimumPercentage_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minimumPercentage_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  numberOfAdministeredTreatments_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfAdministeredTreatments_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  previousTestNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  previousTestNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  referenceAdministrationSequenceNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  referenceAdministrationSequenceNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementEligibilityConditionSetsNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  inputLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  inputLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEligibilityConditionSetsRelationship = BaseAgreementEligibilityConditionRelationship & {
  __typename?: 'BaseAgreementEligibilityConditionSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  cycleAdherence?: Maybe<CycleAdherence>;
  days?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Int']['output']>;
  node: EligibilityConditionSet;
  numberOfAdministeredRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  numberOfAdministeredTreatments?: Maybe<Scalars['Int']['output']>;
  numberOfAdministeredTreatmentsOperator?: Maybe<ArithmeticalOperator>;
  previousTestNumber?: Maybe<Scalars['Int']['output']>;
  referenceAdministrationSequenceNumber?: Maybe<Scalars['Int']['output']>;
  referenceTestRangeDays?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection = {
  __typename?: 'BaseAgreementEnrollingConditionSetEnrollingConditionSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection>;
};

export type BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection = {
  __typename?: 'BaseAgreementEnrollingConditionSetEnrollingConditionSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type BaseAgreementEnrollingConditionSetsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>;
};

export type BaseAgreementEnrollingConditionSetsConnection = {
  __typename?: 'BaseAgreementEnrollingConditionSetsConnection';
  edges: Array<BaseAgreementEnrollingConditionSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementEnrollingConditionSetsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSetSort>;
};

export type BaseAgreementEnrollingConditionSetsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionSetWhere>;
};

export type BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingConditionSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEnrollingConditionSetsRelationship = {
  __typename?: 'BaseAgreementEnrollingConditionSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection = {
  __typename?: 'BaseAgreementEnrollingPeriodEnrollingPeriodsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export type BaseAgreementEnrollingPeriodsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingPeriodsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementEnrollingPeriodsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingPeriodsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementEnrollingPeriodsConnection = {
  __typename?: 'BaseAgreementEnrollingPeriodsConnection';
  edges: Array<BaseAgreementEnrollingPeriodsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementEnrollingPeriodsConnectionSort = {
  node?: InputMaybe<EnrollingPeriodSort>;
};

export type BaseAgreementEnrollingPeriodsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementEnrollingPeriodsConnectionWhere>>;
  node?: InputMaybe<EnrollingPeriodWhere>;
};

export type BaseAgreementEnrollingPeriodsRelationship = {
  __typename?: 'BaseAgreementEnrollingPeriodsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type BaseAgreementFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>;
};

export type BaseAgreementFinancialDataPointsConnection = {
  __typename?: 'BaseAgreementFinancialDataPointsConnection';
  edges: Array<BaseAgreementFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type BaseAgreementFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type BaseAgreementFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementFinancialDataPointsRelationship = {
  __typename?: 'BaseAgreementFinancialDataPointsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection = {
  __typename?: 'BaseAgreementFinancialSummaryColumnFinancialSummaryConfigAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection>;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection = {
  __typename?: 'BaseAgreementFinancialSummaryColumnFinancialSummaryConfigEdgeAggregateSelection';
  localizationKey: StringAggregateSelectionNullable;
  position: IntAggregateSelectionNullable;
};

export type BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection = {
  __typename?: 'BaseAgreementFinancialSummaryColumnFinancialSummaryConfigNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type BaseAgreementFinancialSummaryConfigAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>;
};

export type BaseAgreementFinancialSummaryConfigConnection = {
  __typename?: 'BaseAgreementFinancialSummaryConfigConnection';
  edges: Array<BaseAgreementFinancialSummaryConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementFinancialSummaryConfigConnectionSort = {
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipSort>;
  node?: InputMaybe<FinancialSummaryColumnSort>;
};

export type BaseAgreementFinancialSummaryConfigConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigConnectionWhere>>;
  edge?: InputMaybe<AgreementFinancialSummaryColumnRelationshipWhere>;
  node?: InputMaybe<FinancialSummaryColumnWhere>;
};

export type BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigEdgeAggregationWhereInput>>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  position_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementFinancialSummaryConfigNodeAggregationWhereInput>>;
};

export type BaseAgreementFinancialSummaryConfigRelationship = AgreementFinancialSummaryColumnRelationship & {
  __typename?: 'BaseAgreementFinancialSummaryConfigRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  hasHelpMessage?: Maybe<Scalars['Boolean']['output']>;
  isIncluded?: Maybe<Scalars['Boolean']['output']>;
  localizationKey?: Maybe<Scalars['String']['output']>;
  node: FinancialSummaryColumn;
  position?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'BaseAgreementFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'BaseAgreementFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type BaseAgreementInitialVersionAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementInitialVersionAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementInitialVersionAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementInitialVersionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementInitialVersionNodeAggregationWhereInput>;
};

export type BaseAgreementInitialVersionConnection = {
  __typename?: 'BaseAgreementInitialVersionConnection';
  edges: Array<BaseAgreementInitialVersionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementInitialVersionConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type BaseAgreementInitialVersionConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementInitialVersionConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementInitialVersionConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementInitialVersionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementInitialVersionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementInitialVersionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementInitialVersionNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementInitialVersionRelationship = {
  __typename?: 'BaseAgreementInitialVersionRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type BaseAgreementNegotiableAttributesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementNegotiableAttributesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementNegotiableAttributesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementNegotiableAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>;
};

export type BaseAgreementNegotiableAttributesConnection = {
  __typename?: 'BaseAgreementNegotiableAttributesConnection';
  edges: Array<BaseAgreementNegotiableAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementNegotiableAttributesConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type BaseAgreementNegotiableAttributesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementNegotiableAttributesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementNegotiableAttributesConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type BaseAgreementNegotiableAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementNegotiableAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementNegotiableAttributesRelationship = {
  __typename?: 'BaseAgreementNegotiableAttributesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type BaseAgreementNextVersionsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementNextVersionsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementNextVersionsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementNextVersionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementNextVersionsNodeAggregationWhereInput>;
};

export type BaseAgreementNextVersionsConnection = {
  __typename?: 'BaseAgreementNextVersionsConnection';
  edges: Array<BaseAgreementNextVersionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementNextVersionsConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type BaseAgreementNextVersionsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementNextVersionsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementNextVersionsConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type BaseAgreementNextVersionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementNextVersionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementNextVersionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementNextVersionsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementNextVersionsRelationship = {
  __typename?: 'BaseAgreementNextVersionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type BaseAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BaseAgreementSort objects to sort BaseAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BaseAgreementSort>>;
};

export type BaseAgreementOrganizationCounterpartiesAggregationSelection = {
  __typename?: 'BaseAgreementOrganizationCounterpartiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementOrganizationCounterpartiesNodeAggregateSelection>;
};

export type BaseAgreementOrganizationCounterpartiesNodeAggregateSelection = {
  __typename?: 'BaseAgreementOrganizationCounterpartiesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type BaseAgreementPushedByAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementPushedByAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementPushedByAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementPushedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementPushedByNodeAggregationWhereInput>;
};

export type BaseAgreementPushedByConnection = {
  __typename?: 'BaseAgreementPushedByConnection';
  edges: Array<BaseAgreementPushedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementPushedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type BaseAgreementPushedByConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementPushedByConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementPushedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type BaseAgreementPushedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementPushedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementPushedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementPushedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementPushedByRelationship = {
  __typename?: 'BaseAgreementPushedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type BaseAgreementRangeChartConfigAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementRangeChartConfigAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementRangeChartConfigAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementRangeChartConfigAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>;
};

export type BaseAgreementRangeChartConfigConnection = {
  __typename?: 'BaseAgreementRangeChartConfigConnection';
  edges: Array<BaseAgreementRangeChartConfigRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementRangeChartConfigConnectionSort = {
  edge?: InputMaybe<ChartRangeConfigurationRelationshipSort>;
  node?: InputMaybe<ChartRangeConfigurationSort>;
};

export type BaseAgreementRangeChartConfigConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementRangeChartConfigConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementRangeChartConfigConnectionWhere>>;
  edge?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  node?: InputMaybe<ChartRangeConfigurationWhere>;
};

export type BaseAgreementRangeChartConfigEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementRangeChartConfigEdgeAggregationWhereInput>>;
  from_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  from_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  from_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  from_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  from_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  to_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  to_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  to_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  to_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementRangeChartConfigRelationship = ChartRangeConfigurationRelationship & {
  __typename?: 'BaseAgreementRangeChartConfigRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  node: ChartRangeConfiguration;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type BaseAgreementScenarioScenariosAggregationSelection = {
  __typename?: 'BaseAgreementScenarioScenariosAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementScenarioScenariosNodeAggregateSelection>;
};

export type BaseAgreementScenarioScenariosNodeAggregateSelection = {
  __typename?: 'BaseAgreementScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type BaseAgreementScenariosAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementScenariosNodeAggregationWhereInput>;
};

export type BaseAgreementScenariosConnection = {
  __typename?: 'BaseAgreementScenariosConnection';
  edges: Array<BaseAgreementScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementScenariosConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type BaseAgreementScenariosConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementScenariosConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementScenariosConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type BaseAgreementScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementScenariosRelationship = {
  __typename?: 'BaseAgreementScenariosRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type BaseAgreementScenariosRelevantBrandsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosRelevantBrandsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>;
};

export type BaseAgreementScenariosRelevantBrandsConnection = {
  __typename?: 'BaseAgreementScenariosRelevantBrandsConnection';
  edges: Array<BaseAgreementScenariosRelevantBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementScenariosRelevantBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type BaseAgreementScenariosRelevantBrandsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<BaseAgreementScenariosRelevantBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementScenariosRelevantBrandsRelationship = {
  __typename?: 'BaseAgreementScenariosRelevantBrandsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

/** Fields to sort BaseAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one BaseAgreementSort object. */
export type BaseAgreementSort = {
  canUserViewFinancials?: InputMaybe<SortDirection>;
  caseSuspensionIntervalDays?: InputMaybe<SortDirection>;
  caselessAgreementDataSnapshot?: InputMaybe<SortDirection>;
  coveringFormWaitInterval?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  daysToExpiry?: InputMaybe<SortDirection>;
  defaultPriceRate?: InputMaybe<SortDirection>;
  enrolmentDateType?: InputMaybe<SortDirection>;
  expectedDocument?: InputMaybe<SortDirection>;
  firstExecutionDate?: InputMaybe<SortDirection>;
  formattedAmount?: InputMaybe<SortDirection>;
  formattedCounterparties?: InputMaybe<SortDirection>;
  formattedDiseases?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  formattedProducts?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  formattedValidityPeriod?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  initialVersionId?: InputMaybe<SortDirection>;
  isAllowedFormsEnabled?: InputMaybe<SortDirection>;
  isAllowedRecordsEnabled?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isCoveringIntervalEnabled?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isExtended?: InputMaybe<SortDirection>;
  isFirstVersion?: InputMaybe<SortDirection>;
  isHidden?: InputMaybe<SortDirection>;
  isInsightsAvailable?: InputMaybe<SortDirection>;
  isLastVersion?: InputMaybe<SortDirection>;
  isRequiredFormsEnabled?: InputMaybe<SortDirection>;
  isRequiredRecordsEnabled?: InputMaybe<SortDirection>;
  isScenariosInSync?: InputMaybe<SortDirection>;
  isScopeSync?: InputMaybe<SortDirection>;
  isValidityPeriodInSync?: InputMaybe<SortDirection>;
  lastExecutionDate?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  pushedOn?: InputMaybe<SortDirection>;
  reportData?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  subjectMatter?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
  userOrganizationRole?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type BaseAgreementStatusTransitionsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementStatusTransitionsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementStatusTransitionsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementStatusTransitionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementStatusTransitionsNodeAggregationWhereInput>;
};

export type BaseAgreementStatusTransitionsConnection = {
  __typename?: 'BaseAgreementStatusTransitionsConnection';
  edges: Array<BaseAgreementStatusTransitionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementStatusTransitionsConnectionSort = {
  node?: InputMaybe<AgreementStatusTransitionSort>;
};

export type BaseAgreementStatusTransitionsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementStatusTransitionsConnectionWhere>>;
  node?: InputMaybe<AgreementStatusTransitionWhere>;
};

export type BaseAgreementStatusTransitionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementStatusTransitionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementStatusTransitionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementStatusTransitionsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BaseAgreementStatusTransitionsRelationship = {
  __typename?: 'BaseAgreementStatusTransitionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementStatusTransition;
};

export type BaseAgreementTagsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementTagsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementTagsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementTagsNodeAggregationWhereInput>;
};

export type BaseAgreementTagsConnection = {
  __typename?: 'BaseAgreementTagsConnection';
  edges: Array<BaseAgreementTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type BaseAgreementTagsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementTagsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type BaseAgreementTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementTagsRelationship = {
  __typename?: 'BaseAgreementTagsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type BaseAgreementTemplateAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementTemplateAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementTemplateAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementTemplateNodeAggregationWhereInput>;
};

export type BaseAgreementTemplateConnection = {
  __typename?: 'BaseAgreementTemplateConnection';
  edges: Array<BaseAgreementTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type BaseAgreementTemplateConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementTemplateConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type BaseAgreementTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementTemplateRelationship = {
  __typename?: 'BaseAgreementTemplateRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type BaseAgreementTreatmentPriceRelationship = {
  basePriceType?: Maybe<PriceType>;
  price: Scalars['Float']['output'];
};

export type BaseAgreementTreatmentPriceRelationshipSort = {
  basePriceType?: InputMaybe<SortDirection>;
  price?: InputMaybe<SortDirection>;
};

export type BaseAgreementTreatmentPriceRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPriceRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPriceRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPriceRelationshipWhere>>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_GT?: InputMaybe<Scalars['Float']['input']>;
  price_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  price_LT?: InputMaybe<Scalars['Float']['input']>;
  price_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementTreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementTreatmentPricesNodeAggregationWhereInput>;
};

export type BaseAgreementTreatmentPricesConnection = {
  __typename?: 'BaseAgreementTreatmentPricesConnection';
  edges: Array<BaseAgreementTreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementTreatmentPricesConnectionSort = {
  edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type BaseAgreementTreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementTreatmentPriceRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type BaseAgreementTreatmentPricesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesEdgeAggregationWhereInput>>;
  price_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  price_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  price_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  price_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseAgreementTreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementTreatmentPricesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BaseAgreementTreatmentPricesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<BaseAgreementTreatmentPricesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementTreatmentPricesRelationship = BaseAgreementTreatmentPriceRelationship & {
  __typename?: 'BaseAgreementTreatmentPricesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  basePriceType?: Maybe<PriceType>;
  cursor: Scalars['String']['output'];
  node: Treatment;
  price: Scalars['Float']['output'];
};

export type BaseAgreementTreatmentTreatmentPricesAggregationSelection = {
  __typename?: 'BaseAgreementTreatmentTreatmentPricesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection>;
};

export type BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection = {
  __typename?: 'BaseAgreementTreatmentTreatmentPricesEdgeAggregateSelection';
  price: FloatAggregateSelectionNonNullable;
};

export type BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection = {
  __typename?: 'BaseAgreementTreatmentTreatmentPricesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type BaseAgreementUserAddedByAggregationSelection = {
  __typename?: 'BaseAgreementUserAddedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementUserAddedByNodeAggregateSelection>;
};

export type BaseAgreementUserAddedByNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserAddedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type BaseAgreementUserContextUserContextsAggregationSelection = {
  __typename?: 'BaseAgreementUserContextUserContextsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<BaseAgreementUserContextUserContextsEdgeAggregateSelection>;
  node?: Maybe<BaseAgreementUserContextUserContextsNodeAggregateSelection>;
};

export type BaseAgreementUserContextUserContextsEdgeAggregateSelection = {
  __typename?: 'BaseAgreementUserContextUserContextsEdgeAggregateSelection';
  categoryInput: StringAggregateSelectionNullable;
  rebateObjective: StringAggregateSelectionNullable;
  timeframeLabel: StringAggregateSelectionNonNullable;
};

export type BaseAgreementUserContextUserContextsNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserContextUserContextsNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  filterCaseLogs: StringAggregateSelectionNullable;
  filtersAgreements: StringAggregateSelectionNullable;
  filtersCases: StringAggregateSelectionNullable;
  filtersDataForms: StringAggregateSelectionNullable;
  filtersDataRecords: StringAggregateSelectionNullable;
  filtersDocuments: StringAggregateSelectionNullable;
  filtersRefunds: StringAggregateSelectionNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  timePeriodCaseDetails: StringAggregateSelectionNullable;
  timePeriodFilterDashboard: StringAggregateSelectionNullable;
  timePeriodFilterHome: StringAggregateSelectionNullable;
  timePeriodFilterReporting: StringAggregateSelectionNullable;
  transactionsInCreditNoteDocumentTableColumns: StringAggregateSelectionNullable;
  transactionsInDocumentTableColumnsRefundInvoice: StringAggregateSelectionNullable;
  transactionsInFreeOfChargeDocumentTableColumns: StringAggregateSelectionNullable;
};

export type BaseAgreementUserContextsAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementUserContextsAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<BaseAgreementUserContextsEdgeAggregationWhereInput>;
  node?: InputMaybe<BaseAgreementUserContextsNodeAggregationWhereInput>;
};

export type BaseAgreementUserContextsConnection = {
  __typename?: 'BaseAgreementUserContextsConnection';
  edges: Array<BaseAgreementUserContextsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementUserContextsConnectionSort = {
  edge?: InputMaybe<ScenarioInsightsUserContextSort>;
  node?: InputMaybe<UserContextSort>;
};

export type BaseAgreementUserContextsConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsConnectionWhere>>;
  edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
  node?: InputMaybe<UserContextWhere>;
};

export type BaseAgreementUserContextsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementUserContextsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsEdgeAggregationWhereInput>>;
  categoryInput_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementUserContextsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementUserContextsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementUserContextsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementUserContextsNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementUserContextsRelationship = ScenarioInsightsUserContext & {
  __typename?: 'BaseAgreementUserContextsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  categoryInput?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  node: UserContext;
  rebateObjective?: Maybe<Scalars['String']['output']>;
  timeframeLabel: Scalars['String']['output'];
};

export type BaseAgreementUserPushedByAggregationSelection = {
  __typename?: 'BaseAgreementUserPushedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementUserPushedByNodeAggregateSelection>;
};

export type BaseAgreementUserPushedByNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserPushedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type BaseAgreementUserRoleRelationship = {
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  role: AgreementUserRole;
};

export type BaseAgreementUserRoleRelationshipSort = {
  canApprove?: InputMaybe<SortDirection>;
  canModifyFinancials?: InputMaybe<SortDirection>;
  canViewFinancials?: InputMaybe<SortDirection>;
  isAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type BaseAgreementUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<BaseAgreementUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<BaseAgreementUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<BaseAgreementUserRoleRelationshipWhere>>;
  canApprove?: InputMaybe<Scalars['Boolean']['input']>;
  canModifyFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  canViewFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  isAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type BaseAgreementUserRolesAggregateInput = {
  AND?: InputMaybe<Array<BaseAgreementUserRolesAggregateInput>>;
  NOT?: InputMaybe<BaseAgreementUserRolesAggregateInput>;
  OR?: InputMaybe<Array<BaseAgreementUserRolesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BaseAgreementUserRolesNodeAggregationWhereInput>;
};

export type BaseAgreementUserRolesConnection = {
  __typename?: 'BaseAgreementUserRolesConnection';
  edges: Array<BaseAgreementUserRolesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseAgreementUserRolesConnectionSort = {
  edge?: InputMaybe<BaseAgreementUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type BaseAgreementUserRolesConnectionWhere = {
  AND?: InputMaybe<Array<BaseAgreementUserRolesConnectionWhere>>;
  NOT?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  OR?: InputMaybe<Array<BaseAgreementUserRolesConnectionWhere>>;
  edge?: InputMaybe<BaseAgreementUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type BaseAgreementUserRolesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BaseAgreementUserRolesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BaseAgreementUserRolesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BaseAgreementUserRolesNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementUserRolesRelationship = BaseAgreementUserRoleRelationship & {
  __typename?: 'BaseAgreementUserRolesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  canApprove: Scalars['Boolean']['output'];
  canModifyFinancials: Scalars['Boolean']['output'];
  canViewFinancials: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type BaseAgreementUserUserRolesAggregationSelection = {
  __typename?: 'BaseAgreementUserUserRolesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BaseAgreementUserUserRolesNodeAggregateSelection>;
};

export type BaseAgreementUserUserRolesNodeAggregateSelection = {
  __typename?: 'BaseAgreementUserUserRolesNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type BaseAgreementWhere = {
  AND?: InputMaybe<Array<BaseAgreementWhere>>;
  NOT?: InputMaybe<BaseAgreementWhere>;
  OR?: InputMaybe<Array<BaseAgreementWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<BaseAgreementAddedByAggregateInput>;
  addedByConnection?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<BaseAgreementAddedByConnectionWhere>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  allowedForms?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  allowedRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  allowedRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseSuspensionIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  caseSuspensionIntervalDays_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caselessAgreementDataSnapshot_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caselessAgreementDataSnapshot_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  casesAggregate?: InputMaybe<BaseAgreementCasesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<BaseAgreementCasesConnectionWhere>;
  /** Return BaseAgreements where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return BaseAgreements where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return BaseAgreements where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return BaseAgreements where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  counterpartiesAggregate?: InputMaybe<BaseAgreementCounterpartiesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_ALL?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_NONE?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_SINGLE?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementCounterpartiesConnections match this filter */
  counterpartiesConnection_SOME?: InputMaybe<BaseAgreementCounterpartiesConnectionWhere>;
  /** Return BaseAgreements where all of the related Organizations match this filter */
  counterparties_ALL?: InputMaybe<OrganizationWhere>;
  /** Return BaseAgreements where none of the related Organizations match this filter */
  counterparties_NONE?: InputMaybe<OrganizationWhere>;
  /** Return BaseAgreements where one of the related Organizations match this filter */
  counterparties_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return BaseAgreements where some of the related Organizations match this filter */
  counterparties_SOME?: InputMaybe<OrganizationWhere>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<BaseAgreementCountryAggregateInput>;
  countryConnection?: InputMaybe<BaseAgreementCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<BaseAgreementCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  coveringFormWaitInterval?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  coveringFormWaitInterval_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<BaseAgreementCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<BaseAgreementCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  cyclesAggregate?: InputMaybe<BaseAgreementCyclesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_ALL?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_NONE?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_SINGLE?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementCyclesConnections match this filter */
  cyclesConnection_SOME?: InputMaybe<BaseAgreementCyclesConnectionWhere>;
  /** Return BaseAgreements where all of the related CycleConfigurations match this filter */
  cycles_ALL?: InputMaybe<CycleConfigurationWhere>;
  /** Return BaseAgreements where none of the related CycleConfigurations match this filter */
  cycles_NONE?: InputMaybe<CycleConfigurationWhere>;
  /** Return BaseAgreements where one of the related CycleConfigurations match this filter */
  cycles_SINGLE?: InputMaybe<CycleConfigurationWhere>;
  /** Return BaseAgreements where some of the related CycleConfigurations match this filter */
  cycles_SOME?: InputMaybe<CycleConfigurationWhere>;
  dataContainersAggregate?: InputMaybe<BaseAgreementDataContainersAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_ALL?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_NONE?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_SINGLE?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementDataContainersConnections match this filter */
  dataContainersConnection_SOME?: InputMaybe<BaseAgreementDataContainersConnectionWhere>;
  /** Return BaseAgreements where all of the related DataContainers match this filter */
  dataContainers_ALL?: InputMaybe<DataContainerWhere>;
  /** Return BaseAgreements where none of the related DataContainers match this filter */
  dataContainers_NONE?: InputMaybe<DataContainerWhere>;
  /** Return BaseAgreements where one of the related DataContainers match this filter */
  dataContainers_SINGLE?: InputMaybe<DataContainerWhere>;
  /** Return BaseAgreements where some of the related DataContainers match this filter */
  dataContainers_SOME?: InputMaybe<DataContainerWhere>;
  dataSource?: InputMaybe<DataSourceWhere>;
  dataSourceAggregate?: InputMaybe<BaseAgreementDataSourceAggregateInput>;
  dataSourceConnection?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
  dataSourceConnection_NOT?: InputMaybe<BaseAgreementDataSourceConnectionWhere>;
  dataSource_NOT?: InputMaybe<DataSourceWhere>;
  daysToExpiry?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  daysToExpiry_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_LTE?: InputMaybe<Scalars['Int']['input']>;
  decisionsAggregate?: InputMaybe<BaseAgreementDecisionsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_ALL?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_NONE?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_SINGLE?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementDecisionsConnections match this filter */
  decisionsConnection_SOME?: InputMaybe<BaseAgreementDecisionsConnectionWhere>;
  /** Return BaseAgreements where all of the related AgreementDecisions match this filter */
  decisions_ALL?: InputMaybe<AgreementDecisionWhere>;
  /** Return BaseAgreements where none of the related AgreementDecisions match this filter */
  decisions_NONE?: InputMaybe<AgreementDecisionWhere>;
  /** Return BaseAgreements where one of the related AgreementDecisions match this filter */
  decisions_SINGLE?: InputMaybe<AgreementDecisionWhere>;
  /** Return BaseAgreements where some of the related AgreementDecisions match this filter */
  decisions_SOME?: InputMaybe<AgreementDecisionWhere>;
  defaultPriceRate?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  defaultPriceRate_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  deviceAlternativeSetsAggregate?: InputMaybe<BaseAgreementDeviceAlternativeSetsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_ALL?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_NONE?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SINGLE?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementDeviceAlternativeSetsConnections match this filter */
  deviceAlternativeSetsConnection_SOME?: InputMaybe<BaseAgreementDeviceAlternativeSetsConnectionWhere>;
  /** Return BaseAgreements where all of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_ALL?: InputMaybe<DeviceAlternativeWhere>;
  /** Return BaseAgreements where none of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_NONE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return BaseAgreements where one of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SINGLE?: InputMaybe<DeviceAlternativeWhere>;
  /** Return BaseAgreements where some of the related DeviceAlternatives match this filter */
  deviceAlternativeSets_SOME?: InputMaybe<DeviceAlternativeWhere>;
  dotThresholds?: InputMaybe<ChartRangeConfigurationWhere>;
  dotThresholdsAggregate?: InputMaybe<BaseAgreementDotThresholdsAggregateInput>;
  dotThresholdsConnection?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
  dotThresholdsConnection_NOT?: InputMaybe<BaseAgreementDotThresholdsConnectionWhere>;
  dotThresholds_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  eligibilityConditionSetsAggregate?: InputMaybe<BaseAgreementEligibilityConditionSetsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_ALL?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_NONE?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SINGLE?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementEligibilityConditionSetsConnections match this filter */
  eligibilityConditionSetsConnection_SOME?: InputMaybe<BaseAgreementEligibilityConditionSetsConnectionWhere>;
  /** Return BaseAgreements where all of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_ALL?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return BaseAgreements where none of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_NONE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return BaseAgreements where one of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SINGLE?: InputMaybe<EligibilityConditionSetWhere>;
  /** Return BaseAgreements where some of the related EligibilityConditionSets match this filter */
  eligibilityConditionSets_SOME?: InputMaybe<EligibilityConditionSetWhere>;
  enrollingConditionSetsAggregate?: InputMaybe<BaseAgreementEnrollingConditionSetsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_ALL?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_NONE?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SINGLE?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementEnrollingConditionSetsConnections match this filter */
  enrollingConditionSetsConnection_SOME?: InputMaybe<BaseAgreementEnrollingConditionSetsConnectionWhere>;
  /** Return BaseAgreements where all of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_ALL?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return BaseAgreements where none of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_NONE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return BaseAgreements where one of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SINGLE?: InputMaybe<EnrollingConditionSetWhere>;
  /** Return BaseAgreements where some of the related EnrollingConditionSets match this filter */
  enrollingConditionSets_SOME?: InputMaybe<EnrollingConditionSetWhere>;
  enrollingPeriodsAggregate?: InputMaybe<BaseAgreementEnrollingPeriodsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_ALL?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_NONE?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SINGLE?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementEnrollingPeriodsConnections match this filter */
  enrollingPeriodsConnection_SOME?: InputMaybe<BaseAgreementEnrollingPeriodsConnectionWhere>;
  /** Return BaseAgreements where all of the related EnrollingPeriods match this filter */
  enrollingPeriods_ALL?: InputMaybe<EnrollingPeriodWhere>;
  /** Return BaseAgreements where none of the related EnrollingPeriods match this filter */
  enrollingPeriods_NONE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return BaseAgreements where one of the related EnrollingPeriods match this filter */
  enrollingPeriods_SINGLE?: InputMaybe<EnrollingPeriodWhere>;
  /** Return BaseAgreements where some of the related EnrollingPeriods match this filter */
  enrollingPeriods_SOME?: InputMaybe<EnrollingPeriodWhere>;
  enrolmentDateType?: InputMaybe<EnrolmentDateType>;
  enrolmentDateType_IN?: InputMaybe<Array<InputMaybe<EnrolmentDateType>>>;
  expectedDocument?: InputMaybe<DocumentType>;
  expectedDocument_IN?: InputMaybe<Array<DocumentType>>;
  financialDataPointsAggregate?: InputMaybe<BaseAgreementFinancialDataPointsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<BaseAgreementFinancialDataPointsConnectionWhere>;
  /** Return BaseAgreements where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return BaseAgreements where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return BaseAgreements where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return BaseAgreements where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  financialSummaryConfigAggregate?: InputMaybe<BaseAgreementFinancialSummaryConfigAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_ALL?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_NONE?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SINGLE?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementFinancialSummaryConfigConnections match this filter */
  financialSummaryConfigConnection_SOME?: InputMaybe<BaseAgreementFinancialSummaryConfigConnectionWhere>;
  /** Return BaseAgreements where all of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_ALL?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return BaseAgreements where none of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_NONE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return BaseAgreements where one of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SINGLE?: InputMaybe<FinancialSummaryColumnWhere>;
  /** Return BaseAgreements where some of the related FinancialSummaryColumns match this filter */
  financialSummaryConfig_SOME?: InputMaybe<FinancialSummaryColumnWhere>;
  firstExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstExecutionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedAmount_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedAmount_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCounterparties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCounterparties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedDiseases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedDiseases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedProducts_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedProducts_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedValidityPeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedValidityPeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initialVersion?: InputMaybe<BaseAgreementWhere>;
  initialVersionAggregate?: InputMaybe<BaseAgreementInitialVersionAggregateInput>;
  initialVersionConnection?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
  initialVersionConnection_NOT?: InputMaybe<BaseAgreementInitialVersionConnectionWhere>;
  initialVersionId?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  initialVersionId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initialVersionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  initialVersion_NOT?: InputMaybe<BaseAgreementWhere>;
  isAllowedFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  isCoveringIntervalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isExtended?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isInsightsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isLastVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredFormsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredRecordsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isScenariosInSync?: InputMaybe<Scalars['Boolean']['input']>;
  isScopeSync?: InputMaybe<Scalars['Boolean']['input']>;
  isValidityPeriodInSync?: InputMaybe<Scalars['Boolean']['input']>;
  lastExecutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastExecutionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  negotiableAttributesAggregate?: InputMaybe<BaseAgreementNegotiableAttributesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_ALL?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_NONE?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SINGLE?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementNegotiableAttributesConnections match this filter */
  negotiableAttributesConnection_SOME?: InputMaybe<BaseAgreementNegotiableAttributesConnectionWhere>;
  /** Return BaseAgreements where all of the related CatalogueAttributes match this filter */
  negotiableAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return BaseAgreements where none of the related CatalogueAttributes match this filter */
  negotiableAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return BaseAgreements where one of the related CatalogueAttributes match this filter */
  negotiableAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return BaseAgreements where some of the related CatalogueAttributes match this filter */
  negotiableAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  nextVersionsAggregate?: InputMaybe<BaseAgreementNextVersionsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_ALL?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_NONE?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SINGLE?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementNextVersionsConnections match this filter */
  nextVersionsConnection_SOME?: InputMaybe<BaseAgreementNextVersionsConnectionWhere>;
  /** Return BaseAgreements where all of the related BaseAgreements match this filter */
  nextVersions_ALL?: InputMaybe<BaseAgreementWhere>;
  /** Return BaseAgreements where none of the related BaseAgreements match this filter */
  nextVersions_NONE?: InputMaybe<BaseAgreementWhere>;
  /** Return BaseAgreements where one of the related BaseAgreements match this filter */
  nextVersions_SINGLE?: InputMaybe<BaseAgreementWhere>;
  /** Return BaseAgreements where some of the related BaseAgreements match this filter */
  nextVersions_SOME?: InputMaybe<BaseAgreementWhere>;
  pushedBy?: InputMaybe<UserWhere>;
  pushedByAggregate?: InputMaybe<BaseAgreementPushedByAggregateInput>;
  pushedByConnection?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
  pushedByConnection_NOT?: InputMaybe<BaseAgreementPushedByConnectionWhere>;
  pushedBy_NOT?: InputMaybe<UserWhere>;
  pushedOn?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  pushedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  rangeChartConfig?: InputMaybe<ChartRangeConfigurationWhere>;
  rangeChartConfigAggregate?: InputMaybe<BaseAgreementRangeChartConfigAggregateInput>;
  rangeChartConfigConnection?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
  rangeChartConfigConnection_NOT?: InputMaybe<BaseAgreementRangeChartConfigConnectionWhere>;
  rangeChartConfig_NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  reportData?: InputMaybe<Scalars['String']['input']>;
  reportData_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reportData_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reportData_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reportData_MATCHES?: InputMaybe<Scalars['String']['input']>;
  reportData_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  requiredForms?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredForms_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  requiredRecords?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRecords_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scenariosAggregate?: InputMaybe<BaseAgreementScenariosAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<BaseAgreementScenariosConnectionWhere>;
  scenariosRelevantBrandsAggregate?: InputMaybe<BaseAgreementScenariosRelevantBrandsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_ALL?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_NONE?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SINGLE?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementScenariosRelevantBrandsConnections match this filter */
  scenariosRelevantBrandsConnection_SOME?: InputMaybe<BaseAgreementScenariosRelevantBrandsConnectionWhere>;
  /** Return BaseAgreements where all of the related Brands match this filter */
  scenariosRelevantBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where none of the related Brands match this filter */
  scenariosRelevantBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where one of the related Brands match this filter */
  scenariosRelevantBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where some of the related Brands match this filter */
  scenariosRelevantBrands_SOME?: InputMaybe<BrandWhere>;
  /** Return BaseAgreements where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return BaseAgreements where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return BaseAgreements where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return BaseAgreements where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  status?: InputMaybe<ContractStatus>;
  statusTransitionsAggregate?: InputMaybe<BaseAgreementStatusTransitionsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_ALL?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_NONE?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_SINGLE?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementStatusTransitionsConnections match this filter */
  statusTransitionsConnection_SOME?: InputMaybe<BaseAgreementStatusTransitionsConnectionWhere>;
  /** Return BaseAgreements where all of the related AgreementStatusTransitions match this filter */
  statusTransitions_ALL?: InputMaybe<AgreementStatusTransitionWhere>;
  /** Return BaseAgreements where none of the related AgreementStatusTransitions match this filter */
  statusTransitions_NONE?: InputMaybe<AgreementStatusTransitionWhere>;
  /** Return BaseAgreements where one of the related AgreementStatusTransitions match this filter */
  statusTransitions_SINGLE?: InputMaybe<AgreementStatusTransitionWhere>;
  /** Return BaseAgreements where some of the related AgreementStatusTransitions match this filter */
  statusTransitions_SOME?: InputMaybe<AgreementStatusTransitionWhere>;
  status_IN?: InputMaybe<Array<ContractStatus>>;
  subjectMatter?: InputMaybe<AgreementSubjectMatter>;
  subjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  tagsAggregate?: InputMaybe<BaseAgreementTagsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<BaseAgreementTagsConnectionWhere>;
  /** Return BaseAgreements where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return BaseAgreements where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return BaseAgreements where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return BaseAgreements where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  template?: InputMaybe<AgreementTemplateWhere>;
  templateAggregate?: InputMaybe<BaseAgreementTemplateAggregateInput>;
  templateConnection?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
  templateConnection_NOT?: InputMaybe<BaseAgreementTemplateConnectionWhere>;
  template_NOT?: InputMaybe<AgreementTemplateWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatmentPricesAggregate?: InputMaybe<BaseAgreementTreatmentPricesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_ALL?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_NONE?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SINGLE?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementTreatmentPricesConnections match this filter */
  treatmentPricesConnection_SOME?: InputMaybe<BaseAgreementTreatmentPricesConnectionWhere>;
  /** Return BaseAgreements where all of the related Treatments match this filter */
  treatmentPrices_ALL?: InputMaybe<TreatmentWhere>;
  /** Return BaseAgreements where none of the related Treatments match this filter */
  treatmentPrices_NONE?: InputMaybe<TreatmentWhere>;
  /** Return BaseAgreements where one of the related Treatments match this filter */
  treatmentPrices_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return BaseAgreements where some of the related Treatments match this filter */
  treatmentPrices_SOME?: InputMaybe<TreatmentWhere>;
  userContextsAggregate?: InputMaybe<BaseAgreementUserContextsAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_ALL?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_NONE?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_SINGLE?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementUserContextsConnections match this filter */
  userContextsConnection_SOME?: InputMaybe<BaseAgreementUserContextsConnectionWhere>;
  /** Return BaseAgreements where all of the related UserContexts match this filter */
  userContexts_ALL?: InputMaybe<UserContextWhere>;
  /** Return BaseAgreements where none of the related UserContexts match this filter */
  userContexts_NONE?: InputMaybe<UserContextWhere>;
  /** Return BaseAgreements where one of the related UserContexts match this filter */
  userContexts_SINGLE?: InputMaybe<UserContextWhere>;
  /** Return BaseAgreements where some of the related UserContexts match this filter */
  userContexts_SOME?: InputMaybe<UserContextWhere>;
  userRolesAggregate?: InputMaybe<BaseAgreementUserRolesAggregateInput>;
  /** Return BaseAgreements where all of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_ALL?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where none of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_NONE?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where one of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_SINGLE?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where some of the related BaseAgreementUserRolesConnections match this filter */
  userRolesConnection_SOME?: InputMaybe<BaseAgreementUserRolesConnectionWhere>;
  /** Return BaseAgreements where all of the related Users match this filter */
  userRoles_ALL?: InputMaybe<UserWhere>;
  /** Return BaseAgreements where none of the related Users match this filter */
  userRoles_NONE?: InputMaybe<UserWhere>;
  /** Return BaseAgreements where one of the related Users match this filter */
  userRoles_SINGLE?: InputMaybe<UserWhere>;
  /** Return BaseAgreements where some of the related Users match this filter */
  userRoles_SOME?: InputMaybe<UserWhere>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BaseAgreementsConnection = {
  __typename?: 'BaseAgreementsConnection';
  edges: Array<BaseAgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BaseUserInfo = {
  __typename?: 'BaseUserInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type BaseUserInfoAggregateSelection = {
  __typename?: 'BaseUserInfoAggregateSelection';
  count: Scalars['Int']['output'];
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
};

export type BaseUserInfoEdge = {
  __typename?: 'BaseUserInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseUserInfo;
};

export type BaseUserInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BaseUserInfoSort objects to sort BaseUserInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BaseUserInfoSort>>;
};

/** Fields to sort BaseUserInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one BaseUserInfoSort object. */
export type BaseUserInfoSort = {
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
};

export type BaseUserInfoWhere = {
  AND?: InputMaybe<Array<BaseUserInfoWhere>>;
  NOT?: InputMaybe<BaseUserInfoWhere>;
  OR?: InputMaybe<Array<BaseUserInfoWhere>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type BaseUserInfosConnection = {
  __typename?: 'BaseUserInfosConnection';
  edges: Array<BaseUserInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum BlobContainerType {
  CompanyLogo = 'COMPANY_LOGO',
  ProfilePicture = 'PROFILE_PICTURE',
  Signature = 'SIGNATURE'
}

export type BookDemoInput = {
  book_a_demo?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  newsletter_signup?: InputMaybe<Scalars['String']['input']>;
};

export type Brand = {
  __typename?: 'Brand';
  Name: Scalars['String']['output'];
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  art71DataLastUpdatedBy?: Maybe<User>;
  art71DataLastUpdatedByAggregate?: Maybe<BrandUserArt71DataLastUpdatedByAggregationSelection>;
  art71DataLastUpdatedByConnection: BrandArt71DataLastUpdatedByConnection;
  art71DataLastUpdatedByEmail?: Maybe<Scalars['String']['output']>;
  art71DataLastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  article71Indications: Array<Article71Indication>;
  article71IndicationsAggregate?: Maybe<BrandArticle71IndicationArticle71IndicationsAggregationSelection>;
  article71IndicationsConnection: BrandArticle71IndicationsConnection;
  id: Scalars['ID']['output'];
  isPatented?: Maybe<Scalars['Boolean']['output']>;
  mainIndications: Array<MainIndication>;
  mainIndicationsAggregate?: Maybe<BrandMainIndicationMainIndicationsAggregationSelection>;
  mainIndicationsConnection: BrandMainIndicationsConnection;
  patentExpiryDate?: Maybe<Scalars['Date']['output']>;
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<BrandPreparationPreparationsAggregationSelection>;
  preparationsConnection: BrandPreparationsConnection;
};


export type BrandArt71DataLastUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type BrandArt71DataLastUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type BrandArt71DataLastUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandArt71DataLastUpdatedByConnectionSort>>;
  where?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
};


export type BrandArticle71IndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type BrandArticle71IndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type BrandArticle71IndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandArticle71IndicationsConnectionSort>>;
  where?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
};


export type BrandMainIndicationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MainIndicationOptions>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type BrandMainIndicationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type BrandMainIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandMainIndicationsConnectionSort>>;
  where?: InputMaybe<BrandMainIndicationsConnectionWhere>;
};


export type BrandPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type BrandPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type BrandPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<BrandPreparationsConnectionSort>>;
  where?: InputMaybe<BrandPreparationsConnectionWhere>;
};

export type BrandAggregateSelection = {
  __typename?: 'BrandAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type BrandArt71DataLastUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<BrandArt71DataLastUpdatedByAggregateInput>>;
  NOT?: InputMaybe<BrandArt71DataLastUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<BrandArt71DataLastUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>;
};

export type BrandArt71DataLastUpdatedByConnection = {
  __typename?: 'BrandArt71DataLastUpdatedByConnection';
  edges: Array<BrandArt71DataLastUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandArt71DataLastUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type BrandArt71DataLastUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<BrandArt71DataLastUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<BrandArt71DataLastUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type BrandArt71DataLastUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandArt71DataLastUpdatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandArt71DataLastUpdatedByRelationship = {
  __typename?: 'BrandArt71DataLastUpdatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type BrandArticle71IndicationArticle71IndicationsAggregationSelection = {
  __typename?: 'BrandArticle71IndicationArticle71IndicationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection>;
};

export type BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection = {
  __typename?: 'BrandArticle71IndicationArticle71IndicationsNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type BrandArticle71IndicationsAggregateInput = {
  AND?: InputMaybe<Array<BrandArticle71IndicationsAggregateInput>>;
  NOT?: InputMaybe<BrandArticle71IndicationsAggregateInput>;
  OR?: InputMaybe<Array<BrandArticle71IndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandArticle71IndicationsNodeAggregationWhereInput>;
};

export type BrandArticle71IndicationsConnection = {
  __typename?: 'BrandArticle71IndicationsConnection';
  edges: Array<BrandArticle71IndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandArticle71IndicationsConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type BrandArticle71IndicationsConnectionWhere = {
  AND?: InputMaybe<Array<BrandArticle71IndicationsConnectionWhere>>;
  NOT?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  OR?: InputMaybe<Array<BrandArticle71IndicationsConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type BrandArticle71IndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandArticle71IndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BrandArticle71IndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandArticle71IndicationsNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandArticle71IndicationsRelationship = {
  __typename?: 'BrandArticle71IndicationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type BrandEdge = {
  __typename?: 'BrandEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type BrandMainIndicationMainIndicationsAggregationSelection = {
  __typename?: 'BrandMainIndicationMainIndicationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BrandMainIndicationMainIndicationsNodeAggregateSelection>;
};

export type BrandMainIndicationMainIndicationsNodeAggregateSelection = {
  __typename?: 'BrandMainIndicationMainIndicationsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
};

export type BrandMainIndicationsAggregateInput = {
  AND?: InputMaybe<Array<BrandMainIndicationsAggregateInput>>;
  NOT?: InputMaybe<BrandMainIndicationsAggregateInput>;
  OR?: InputMaybe<Array<BrandMainIndicationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandMainIndicationsNodeAggregationWhereInput>;
};

export type BrandMainIndicationsConnection = {
  __typename?: 'BrandMainIndicationsConnection';
  edges: Array<BrandMainIndicationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandMainIndicationsConnectionSort = {
  node?: InputMaybe<MainIndicationSort>;
};

export type BrandMainIndicationsConnectionWhere = {
  AND?: InputMaybe<Array<BrandMainIndicationsConnectionWhere>>;
  NOT?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  OR?: InputMaybe<Array<BrandMainIndicationsConnectionWhere>>;
  node?: InputMaybe<MainIndicationWhere>;
};

export type BrandMainIndicationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandMainIndicationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<BrandMainIndicationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandMainIndicationsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BrandMainIndicationsRelationship = {
  __typename?: 'BrandMainIndicationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: MainIndication;
};

export type BrandOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more BrandSort objects to sort Brands by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<BrandSort>>;
};

export type BrandPreparationPreparationsAggregationSelection = {
  __typename?: 'BrandPreparationPreparationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BrandPreparationPreparationsNodeAggregateSelection>;
};

export type BrandPreparationPreparationsNodeAggregateSelection = {
  __typename?: 'BrandPreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type BrandPreparationsAggregateInput = {
  AND?: InputMaybe<Array<BrandPreparationsAggregateInput>>;
  NOT?: InputMaybe<BrandPreparationsAggregateInput>;
  OR?: InputMaybe<Array<BrandPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<BrandPreparationsNodeAggregationWhereInput>;
};

export type BrandPreparationsConnection = {
  __typename?: 'BrandPreparationsConnection';
  edges: Array<BrandPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BrandPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type BrandPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<BrandPreparationsConnectionWhere>>;
  NOT?: InputMaybe<BrandPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<BrandPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type BrandPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<BrandPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<BrandPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<BrandPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type BrandPreparationsRelationship = {
  __typename?: 'BrandPreparationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

/** Fields to sort Brands by. The order in which sorts are applied is not guaranteed when specifying many fields in one BrandSort object. */
export type BrandSort = {
  Name?: InputMaybe<SortDirection>;
  art71DataLastUpdatedByEmail?: InputMaybe<SortDirection>;
  art71DataLastUpdatedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isPatented?: InputMaybe<SortDirection>;
  patentExpiryDate?: InputMaybe<SortDirection>;
};

export type BrandUserArt71DataLastUpdatedByAggregationSelection = {
  __typename?: 'BrandUserArt71DataLastUpdatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<BrandUserArt71DataLastUpdatedByNodeAggregateSelection>;
};

export type BrandUserArt71DataLastUpdatedByNodeAggregateSelection = {
  __typename?: 'BrandUserArt71DataLastUpdatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type BrandWhere = {
  AND?: InputMaybe<Array<BrandWhere>>;
  NOT?: InputMaybe<BrandWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<BrandWhere>>;
  art71DataLastUpdatedBy?: InputMaybe<UserWhere>;
  art71DataLastUpdatedByAggregate?: InputMaybe<BrandArt71DataLastUpdatedByAggregateInput>;
  art71DataLastUpdatedByConnection?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
  art71DataLastUpdatedByConnection_NOT?: InputMaybe<BrandArt71DataLastUpdatedByConnectionWhere>;
  art71DataLastUpdatedByEmail?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  art71DataLastUpdatedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  art71DataLastUpdatedBy_NOT?: InputMaybe<UserWhere>;
  art71DataLastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  art71DataLastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  article71IndicationsAggregate?: InputMaybe<BrandArticle71IndicationsAggregateInput>;
  /** Return Brands where all of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_ALL?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where none of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_NONE?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where one of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SINGLE?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where some of the related BrandArticle71IndicationsConnections match this filter */
  article71IndicationsConnection_SOME?: InputMaybe<BrandArticle71IndicationsConnectionWhere>;
  /** Return Brands where all of the related Article71Indications match this filter */
  article71Indications_ALL?: InputMaybe<Article71IndicationWhere>;
  /** Return Brands where none of the related Article71Indications match this filter */
  article71Indications_NONE?: InputMaybe<Article71IndicationWhere>;
  /** Return Brands where one of the related Article71Indications match this filter */
  article71Indications_SINGLE?: InputMaybe<Article71IndicationWhere>;
  /** Return Brands where some of the related Article71Indications match this filter */
  article71Indications_SOME?: InputMaybe<Article71IndicationWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isPatented?: InputMaybe<Scalars['Boolean']['input']>;
  mainIndicationsAggregate?: InputMaybe<BrandMainIndicationsAggregateInput>;
  /** Return Brands where all of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_ALL?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where none of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_NONE?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where one of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_SINGLE?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where some of the related BrandMainIndicationsConnections match this filter */
  mainIndicationsConnection_SOME?: InputMaybe<BrandMainIndicationsConnectionWhere>;
  /** Return Brands where all of the related MainIndications match this filter */
  mainIndications_ALL?: InputMaybe<MainIndicationWhere>;
  /** Return Brands where none of the related MainIndications match this filter */
  mainIndications_NONE?: InputMaybe<MainIndicationWhere>;
  /** Return Brands where one of the related MainIndications match this filter */
  mainIndications_SINGLE?: InputMaybe<MainIndicationWhere>;
  /** Return Brands where some of the related MainIndications match this filter */
  mainIndications_SOME?: InputMaybe<MainIndicationWhere>;
  patentExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_GT?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  patentExpiryDate_LT?: InputMaybe<Scalars['Date']['input']>;
  patentExpiryDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  preparationsAggregate?: InputMaybe<BrandPreparationsAggregateInput>;
  /** Return Brands where all of the related BrandPreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where none of the related BrandPreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where one of the related BrandPreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where some of the related BrandPreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<BrandPreparationsConnectionWhere>;
  /** Return Brands where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Brands where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Brands where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Brands where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
};

export type BrandsConnection = {
  __typename?: 'BrandsConnection';
  edges: Array<BrandEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CanDeleteFlexEntityOutput = {
  __typename?: 'CanDeleteFlexEntityOutput';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  deletableResult: Array<IsFlexEntityDeletable>;
  impacts: Array<EnvironmentImpact>;
};

export type CanDeleteFlexEntityOutputAggregateSelection = {
  __typename?: 'CanDeleteFlexEntityOutputAggregateSelection';
  count: Scalars['Int']['output'];
};

export type CanDeleteFlexEntityOutputEdge = {
  __typename?: 'CanDeleteFlexEntityOutputEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CanDeleteFlexEntityOutput;
};

export type CanDeleteFlexEntityOutputOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CanDeleteFlexEntityOutputWhere = {
  AND?: InputMaybe<Array<CanDeleteFlexEntityOutputWhere>>;
  NOT?: InputMaybe<CanDeleteFlexEntityOutputWhere>;
  OR?: InputMaybe<Array<CanDeleteFlexEntityOutputWhere>>;
};

export type CanDeleteFlexEntityOutputsConnection = {
  __typename?: 'CanDeleteFlexEntityOutputsConnection';
  edges: Array<CanDeleteFlexEntityOutputEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CanadianPriceType {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaListPricePercent = 'ALBERTA_LIST_PRICE_PERCENT',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  AlbertaMarkedUpPricePercent = 'ALBERTA_MARKED_UP_PRICE_PERCENT',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaListPricePercent = 'BRITISH_COLUMBIA_LIST_PRICE_PERCENT',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  BritishColumbiaMarkedUpPricePercent = 'BRITISH_COLUMBIA_MARKED_UP_PRICE_PERCENT',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaListPricePercent = 'MANITOBA_LIST_PRICE_PERCENT',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  ManitobaMarkedUpPricePercent = 'MANITOBA_MARKED_UP_PRICE_PERCENT',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorListPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE_PERCENT',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewfoundlandAndLabradorMarkedUpPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE_PERCENT',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickListPricePercent = 'NEW_BRUNSWICK_LIST_PRICE_PERCENT',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NewBrunswickMarkedUpPricePercent = 'NEW_BRUNSWICK_MARKED_UP_PRICE_PERCENT',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbListPricePercent = 'NIHB_LIST_PRICE_PERCENT',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NihbMarkedUpPricePercent = 'NIHB_MARKED_UP_PRICE_PERCENT',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesListPricePercent = 'NORTHWEST_TERRITORIES_LIST_PRICE_PERCENT',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NorthwestTerritoriesMarkedUpPricePercent = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE_PERCENT',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaListPricePercent = 'NOVA_SCOTIA_LIST_PRICE_PERCENT',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NovaScotiaMarkedUpPricePercent = 'NOVA_SCOTIA_MARKED_UP_PRICE_PERCENT',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutListPricePercent = 'NUNAVUT_LIST_PRICE_PERCENT',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  NunavutMarkedUpPricePercent = 'NUNAVUT_MARKED_UP_PRICE_PERCENT',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioListPricePercent = 'ONTARIO_LIST_PRICE_PERCENT',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  OntarioMarkedUpPricePercent = 'ONTARIO_MARKED_UP_PRICE_PERCENT',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandListPricePercent = 'PRINCE_EDWARD_ISLAND_LIST_PRICE_PERCENT',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  PrinceEdwardIslandMarkedUpPricePercent = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE_PERCENT',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecListPricePercent = 'QUEBEC_LIST_PRICE_PERCENT',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  QuebecMarkedUpPricePercent = 'QUEBEC_MARKED_UP_PRICE_PERCENT',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanListPricePercent = 'SASKATCHEWAN_LIST_PRICE_PERCENT',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  SaskatchewanMarkedUpPricePercent = 'SASKATCHEWAN_MARKED_UP_PRICE_PERCENT',
  VacListPrice = 'VAC_LIST_PRICE',
  VacListPricePercent = 'VAC_LIST_PRICE_PERCENT',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  VacMarkedUpPricePercent = 'VAC_MARKED_UP_PRICE_PERCENT',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonListPricePercent = 'YUKON_LIST_PRICE_PERCENT',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE',
  YukonMarkedUpPricePercent = 'YUKON_MARKED_UP_PRICE_PERCENT'
}

export type Case = {
  __typename?: 'Case';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  actualAgreementId?: Maybe<Scalars['String']['output']>;
  agreement?: Maybe<Agreement>;
  agreementName?: Maybe<Scalars['String']['output']>;
  agreementTag?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  agreementUserRole?: Maybe<AgreementUserRole>;
  assignedTo: Array<User>;
  baseAgreement: BaseAgreement;
  baseAgreementAggregate?: Maybe<CaseBaseAgreementBaseAgreementAggregationSelection>;
  baseAgreementConnection: CaseBaseAgreementConnection;
  canUserViewFinancials: Scalars['Boolean']['output'];
  caseAssignee: Array<User>;
  caseAssigneeAggregate?: Maybe<CaseUserCaseAssigneeAggregationSelection>;
  caseAssigneeConnection: CaseCaseAssigneeConnection;
  caseEventLogs: Array<CaseEventLog>;
  caseEventLogsAggregate?: Maybe<CaseCaseEventLogCaseEventLogsAggregationSelection>;
  caseEventLogsConnection: CaseCaseEventLogsConnection;
  caseReportingData?: Maybe<CaseReportingData>;
  caseReportingDataAggregate?: Maybe<CaseCaseReportingDataCaseReportingDataAggregationSelection>;
  caseReportingDataConnection: CaseCaseReportingDataConnection;
  cohort?: Maybe<EnrollingPeriod>;
  cohortAggregate?: Maybe<CaseEnrollingPeriodCohortAggregationSelection>;
  cohortConnection: CaseCohortConnection;
  counterpartyInReview?: Maybe<Scalars['String']['output']>;
  creationDate: Scalars['Date']['output'];
  currentReviewers: Array<Organization>;
  disease?: Maybe<Disease>;
  diseaseAggregate?: Maybe<CaseDiseaseDiseaseAggregationSelection>;
  diseaseConnection: CaseDiseaseConnection;
  documentRefundGroups: Array<DocumentRefundGroup>;
  documentRefundGroupsAggregate?: Maybe<CaseDocumentRefundGroupDocumentRefundGroupsAggregationSelection>;
  documentRefundGroupsConnection: CaseDocumentRefundGroupsConnection;
  documentStatus?: Maybe<DocumentStatus>;
  enrolmentDate: Scalars['Date']['output'];
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: CaseFinancialDataPointsConnection;
  flexEntities: Array<FlexEntity>;
  flexEntitiesAggregate?: Maybe<CaseFlexEntityFlexEntitiesAggregationSelection>;
  flexEntitiesConnection: CaseFlexEntitiesConnection;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  formattedRefundRate?: Maybe<Scalars['String']['output']>;
  history: Array<CaseHistoryRecord>;
  historyAggregate?: Maybe<CaseCaseHistoryRecordHistoryAggregationSelection>;
  historyConnection: CaseHistoryConnection;
  id: Scalars['ID']['output'];
  indication?: Maybe<Indication>;
  indicationAggregate?: Maybe<CaseIndicationIndicationAggregationSelection>;
  indicationConnection: CaseIndicationConnection;
  isArchived: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isFormOwner?: Maybe<Scalars['Boolean']['output']>;
  isTreatmentDiscontinued: Scalars['Boolean']['output'];
  lastFinancialUpdateDate?: Maybe<Scalars['Date']['output']>;
  lastStatusChangeDate?: Maybe<Scalars['DateTime']['output']>;
  lastUpdateDate: Scalars['Date']['output'];
  legalEntity?: Maybe<Organization>;
  legalEntityAggregate?: Maybe<CaseOrganizationLegalEntityAggregationSelection>;
  legalEntityConnection: CaseLegalEntityConnection;
  matchedScopeIds?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Message>;
  messageAggregate?: Maybe<CaseMessageMessageAggregationSelection>;
  messageConnection: CaseMessageConnection;
  messageCount?: Maybe<Scalars['Int']['output']>;
  negotiationRounds: Array<NegotiationRound>;
  negotiationRoundsAggregate?: Maybe<CaseNegotiationRoundNegotiationRoundsAggregationSelection>;
  negotiationRoundsConnection: CaseNegotiationRoundsConnection;
  patient?: Maybe<Patient>;
  patientAggregate?: Maybe<CasePatientPatientAggregationSelection>;
  patientConnection: CasePatientConnection;
  patientInitials?: Maybe<Scalars['String']['output']>;
  patientInsuranceId: Scalars['String']['output'];
  preparationBrandName?: Maybe<Scalars['String']['output']>;
  preparationGenericName?: Maybe<Scalars['String']['output']>;
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<CasePreparationPreparationsAggregationSelection>;
  preparationsConnection: CasePreparationsConnection;
  rating?: Maybe<CoverageRequestRating>;
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<CaseRefundRefundsAggregationSelection>;
  refundsConnection: CaseRefundsConnection;
  relevantArticle71Indication?: Maybe<Article71Indication>;
  relevantArticle71IndicationAggregate?: Maybe<CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection>;
  relevantArticle71IndicationConnection: CaseRelevantArticle71IndicationConnection;
  sourceTenantId: Scalars['String']['output'];
  status: CaseStatus;
  submissionDate?: Maybe<Scalars['DateTime']['output']>;
  suspensionReason?: Maybe<Scalars['String']['output']>;
  tenantIds?: Maybe<Array<Scalars['String']['output']>>;
  therapyDecision?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};


export type CaseBaseAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type CaseBaseAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type CaseBaseAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseBaseAgreementConnectionSort>>;
  where?: InputMaybe<CaseBaseAgreementConnectionWhere>;
};


export type CaseCaseAssigneeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CaseCaseAssigneeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CaseCaseAssigneeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseCaseAssigneeConnectionSort>>;
  where?: InputMaybe<CaseCaseAssigneeConnectionWhere>;
};


export type CaseCaseEventLogsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseEventLogOptions>;
  where?: InputMaybe<CaseEventLogWhere>;
};


export type CaseCaseEventLogsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseEventLogWhere>;
};


export type CaseCaseEventLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseCaseEventLogsConnectionSort>>;
  where?: InputMaybe<CaseCaseEventLogsConnectionWhere>;
};


export type CaseCaseReportingDataArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseReportingDataOptions>;
  where?: InputMaybe<CaseReportingDataWhere>;
};


export type CaseCaseReportingDataAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseReportingDataWhere>;
};


export type CaseCaseReportingDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseCaseReportingDataConnectionSort>>;
  where?: InputMaybe<CaseCaseReportingDataConnectionWhere>;
};


export type CaseCohortArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type CaseCohortAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type CaseCohortConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseCohortConnectionSort>>;
  where?: InputMaybe<CaseCohortConnectionWhere>;
};


export type CaseDiseaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DiseaseOptions>;
  where?: InputMaybe<DiseaseWhere>;
};


export type CaseDiseaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DiseaseWhere>;
};


export type CaseDiseaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseDiseaseConnectionSort>>;
  where?: InputMaybe<CaseDiseaseConnectionWhere>;
};


export type CaseDocumentRefundGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentRefundGroupOptions>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type CaseDocumentRefundGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type CaseDocumentRefundGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseDocumentRefundGroupsConnectionSort>>;
  where?: InputMaybe<CaseDocumentRefundGroupsConnectionWhere>;
};


export type CaseFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type CaseFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type CaseFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
};


export type CaseFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type CaseFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type CaseFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseFlexEntitiesConnectionSort>>;
  where?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
};


export type CaseHistoryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseHistoryRecordOptions>;
  where?: InputMaybe<CaseHistoryRecordWhere>;
};


export type CaseHistoryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseHistoryRecordWhere>;
};


export type CaseHistoryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseHistoryConnectionSort>>;
  where?: InputMaybe<CaseHistoryConnectionWhere>;
};


export type CaseIndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<IndicationOptions>;
  where?: InputMaybe<IndicationWhere>;
};


export type CaseIndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IndicationWhere>;
};


export type CaseIndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseIndicationConnectionSort>>;
  where?: InputMaybe<CaseIndicationConnectionWhere>;
};


export type CaseLegalEntityArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type CaseLegalEntityAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type CaseLegalEntityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseLegalEntityConnectionSort>>;
  where?: InputMaybe<CaseLegalEntityConnectionWhere>;
};


export type CaseMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type CaseMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type CaseMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseMessageConnectionSort>>;
  where?: InputMaybe<CaseMessageConnectionWhere>;
};


export type CaseNegotiationRoundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NegotiationRoundOptions>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type CaseNegotiationRoundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type CaseNegotiationRoundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseNegotiationRoundsConnectionSort>>;
  where?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
};


export type CasePatientArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PatientOptions>;
  where?: InputMaybe<PatientWhere>;
};


export type CasePatientAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientWhere>;
};


export type CasePatientConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CasePatientConnectionSort>>;
  where?: InputMaybe<CasePatientConnectionWhere>;
};


export type CasePreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type CasePreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type CasePreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CasePreparationsConnectionSort>>;
  where?: InputMaybe<CasePreparationsConnectionWhere>;
};


export type CaseRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type CaseRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type CaseRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseRefundsConnectionSort>>;
  where?: InputMaybe<CaseRefundsConnectionWhere>;
};


export type CaseRelevantArticle71IndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type CaseRelevantArticle71IndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type CaseRelevantArticle71IndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseRelevantArticle71IndicationConnectionSort>>;
  where?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
};

export type CaseAggregateSelection = {
  __typename?: 'CaseAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection = {
  __typename?: 'CaseArticle71IndicationRelevantArticle71IndicationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection>;
};

export type CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection = {
  __typename?: 'CaseArticle71IndicationRelevantArticle71IndicationNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type CaseAssigneeDataInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CaseBaseAgreementAggregateInput = {
  AND?: InputMaybe<Array<CaseBaseAgreementAggregateInput>>;
  NOT?: InputMaybe<CaseBaseAgreementAggregateInput>;
  OR?: InputMaybe<Array<CaseBaseAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseBaseAgreementNodeAggregationWhereInput>;
};

export type CaseBaseAgreementBaseAgreementAggregationSelection = {
  __typename?: 'CaseBaseAgreementBaseAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseBaseAgreementBaseAgreementNodeAggregateSelection>;
};

export type CaseBaseAgreementBaseAgreementNodeAggregateSelection = {
  __typename?: 'CaseBaseAgreementBaseAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type CaseBaseAgreementConnection = {
  __typename?: 'CaseBaseAgreementConnection';
  edges: Array<CaseBaseAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseBaseAgreementConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type CaseBaseAgreementConnectionWhere = {
  AND?: InputMaybe<Array<CaseBaseAgreementConnectionWhere>>;
  NOT?: InputMaybe<CaseBaseAgreementConnectionWhere>;
  OR?: InputMaybe<Array<CaseBaseAgreementConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type CaseBaseAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseBaseAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseBaseAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseBaseAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseBaseAgreementRelationship = {
  __typename?: 'CaseBaseAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type CaseCaseAssigneeAggregateInput = {
  AND?: InputMaybe<Array<CaseCaseAssigneeAggregateInput>>;
  NOT?: InputMaybe<CaseCaseAssigneeAggregateInput>;
  OR?: InputMaybe<Array<CaseCaseAssigneeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseCaseAssigneeNodeAggregationWhereInput>;
};

export type CaseCaseAssigneeConnection = {
  __typename?: 'CaseCaseAssigneeConnection';
  edges: Array<CaseCaseAssigneeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseCaseAssigneeConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CaseCaseAssigneeConnectionWhere = {
  AND?: InputMaybe<Array<CaseCaseAssigneeConnectionWhere>>;
  NOT?: InputMaybe<CaseCaseAssigneeConnectionWhere>;
  OR?: InputMaybe<Array<CaseCaseAssigneeConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CaseCaseAssigneeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseCaseAssigneeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseCaseAssigneeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseCaseAssigneeNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseCaseAssigneeRelationship = {
  __typename?: 'CaseCaseAssigneeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type CaseCaseEventLogCaseEventLogsAggregationSelection = {
  __typename?: 'CaseCaseEventLogCaseEventLogsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseCaseEventLogCaseEventLogsNodeAggregateSelection>;
};

export type CaseCaseEventLogCaseEventLogsNodeAggregateSelection = {
  __typename?: 'CaseCaseEventLogCaseEventLogsNodeAggregateSelection';
  data: StringAggregateSelectionNullable;
  triggeredOn: DateTimeAggregateSelectionNonNullable;
};

export type CaseCaseEventLogsAggregateInput = {
  AND?: InputMaybe<Array<CaseCaseEventLogsAggregateInput>>;
  NOT?: InputMaybe<CaseCaseEventLogsAggregateInput>;
  OR?: InputMaybe<Array<CaseCaseEventLogsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseCaseEventLogsNodeAggregationWhereInput>;
};

export type CaseCaseEventLogsConnection = {
  __typename?: 'CaseCaseEventLogsConnection';
  edges: Array<CaseCaseEventLogsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseCaseEventLogsConnectionSort = {
  node?: InputMaybe<CaseEventLogSort>;
};

export type CaseCaseEventLogsConnectionWhere = {
  AND?: InputMaybe<Array<CaseCaseEventLogsConnectionWhere>>;
  NOT?: InputMaybe<CaseCaseEventLogsConnectionWhere>;
  OR?: InputMaybe<Array<CaseCaseEventLogsConnectionWhere>>;
  node?: InputMaybe<CaseEventLogWhere>;
};

export type CaseCaseEventLogsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseCaseEventLogsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseCaseEventLogsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseCaseEventLogsNodeAggregationWhereInput>>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggeredOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CaseCaseEventLogsRelationship = {
  __typename?: 'CaseCaseEventLogsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseEventLog;
};

export type CaseCaseHistoryRecordHistoryAggregationSelection = {
  __typename?: 'CaseCaseHistoryRecordHistoryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseCaseHistoryRecordHistoryNodeAggregateSelection>;
};

export type CaseCaseHistoryRecordHistoryNodeAggregateSelection = {
  __typename?: 'CaseCaseHistoryRecordHistoryNodeAggregateSelection';
  changedOn: DateTimeAggregateSelectionNonNullable;
  reason: StringAggregateSelectionNullable;
};

export type CaseCaseReportingDataAggregateInput = {
  AND?: InputMaybe<Array<CaseCaseReportingDataAggregateInput>>;
  NOT?: InputMaybe<CaseCaseReportingDataAggregateInput>;
  OR?: InputMaybe<Array<CaseCaseReportingDataAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseCaseReportingDataNodeAggregationWhereInput>;
};

export type CaseCaseReportingDataCaseReportingDataAggregationSelection = {
  __typename?: 'CaseCaseReportingDataCaseReportingDataAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseCaseReportingDataCaseReportingDataNodeAggregateSelection>;
};

export type CaseCaseReportingDataCaseReportingDataNodeAggregateSelection = {
  __typename?: 'CaseCaseReportingDataCaseReportingDataNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  ldlDelta: FloatAggregateSelectionNullable;
  snapshot: StringAggregateSelectionNullable;
};

export type CaseCaseReportingDataConnection = {
  __typename?: 'CaseCaseReportingDataConnection';
  edges: Array<CaseCaseReportingDataRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseCaseReportingDataConnectionSort = {
  node?: InputMaybe<CaseReportingDataSort>;
};

export type CaseCaseReportingDataConnectionWhere = {
  AND?: InputMaybe<Array<CaseCaseReportingDataConnectionWhere>>;
  NOT?: InputMaybe<CaseCaseReportingDataConnectionWhere>;
  OR?: InputMaybe<Array<CaseCaseReportingDataConnectionWhere>>;
  node?: InputMaybe<CaseReportingDataWhere>;
};

export type CaseCaseReportingDataNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseCaseReportingDataNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseCaseReportingDataNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseCaseReportingDataNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  ldlDelta_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  snapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  snapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  snapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  snapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  snapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  snapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  snapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  snapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  snapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  snapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  snapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseCaseReportingDataRelationship = {
  __typename?: 'CaseCaseReportingDataRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseReportingData;
};

export type CaseCohortAggregateInput = {
  AND?: InputMaybe<Array<CaseCohortAggregateInput>>;
  NOT?: InputMaybe<CaseCohortAggregateInput>;
  OR?: InputMaybe<Array<CaseCohortAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseCohortConnection = {
  __typename?: 'CaseCohortConnection';
  edges: Array<CaseCohortRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseCohortConnectionSort = {
  node?: InputMaybe<EnrollingPeriodSort>;
};

export type CaseCohortConnectionWhere = {
  AND?: InputMaybe<Array<CaseCohortConnectionWhere>>;
  NOT?: InputMaybe<CaseCohortConnectionWhere>;
  OR?: InputMaybe<Array<CaseCohortConnectionWhere>>;
  node?: InputMaybe<EnrollingPeriodWhere>;
};

export type CaseCohortRelationship = {
  __typename?: 'CaseCohortRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type CaseDiseaseAggregateInput = {
  AND?: InputMaybe<Array<CaseDiseaseAggregateInput>>;
  NOT?: InputMaybe<CaseDiseaseAggregateInput>;
  OR?: InputMaybe<Array<CaseDiseaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseDiseaseNodeAggregationWhereInput>;
};

export type CaseDiseaseConnection = {
  __typename?: 'CaseDiseaseConnection';
  edges: Array<CaseDiseaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseDiseaseConnectionSort = {
  node?: InputMaybe<DiseaseSort>;
};

export type CaseDiseaseConnectionWhere = {
  AND?: InputMaybe<Array<CaseDiseaseConnectionWhere>>;
  NOT?: InputMaybe<CaseDiseaseConnectionWhere>;
  OR?: InputMaybe<Array<CaseDiseaseConnectionWhere>>;
  node?: InputMaybe<DiseaseWhere>;
};

export type CaseDiseaseDiseaseAggregationSelection = {
  __typename?: 'CaseDiseaseDiseaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseDiseaseDiseaseNodeAggregateSelection>;
};

export type CaseDiseaseDiseaseNodeAggregateSelection = {
  __typename?: 'CaseDiseaseDiseaseNodeAggregateSelection';
  Icd10Code: StringAggregateSelectionNonNullable;
  Name: StringAggregateSelectionNonNullable;
};

export type CaseDiseaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseDiseaseNodeAggregationWhereInput>>;
  Icd10Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Icd10Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Icd10Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CaseDiseaseNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CaseDiseaseNodeAggregationWhereInput>>;
};

export type CaseDiseaseRelationship = {
  __typename?: 'CaseDiseaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Disease;
};

export type CaseDocumentRefundGroupDocumentRefundGroupsAggregationSelection = {
  __typename?: 'CaseDocumentRefundGroupDocumentRefundGroupsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection>;
};

export type CaseDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection = {
  __typename?: 'CaseDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type CaseDocumentRefundGroupsAggregateInput = {
  AND?: InputMaybe<Array<CaseDocumentRefundGroupsAggregateInput>>;
  NOT?: InputMaybe<CaseDocumentRefundGroupsAggregateInput>;
  OR?: InputMaybe<Array<CaseDocumentRefundGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseDocumentRefundGroupsNodeAggregationWhereInput>;
};

export type CaseDocumentRefundGroupsConnection = {
  __typename?: 'CaseDocumentRefundGroupsConnection';
  edges: Array<CaseDocumentRefundGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseDocumentRefundGroupsConnectionSort = {
  node?: InputMaybe<DocumentRefundGroupSort>;
};

export type CaseDocumentRefundGroupsConnectionWhere = {
  AND?: InputMaybe<Array<CaseDocumentRefundGroupsConnectionWhere>>;
  NOT?: InputMaybe<CaseDocumentRefundGroupsConnectionWhere>;
  OR?: InputMaybe<Array<CaseDocumentRefundGroupsConnectionWhere>>;
  node?: InputMaybe<DocumentRefundGroupWhere>;
};

export type CaseDocumentRefundGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseDocumentRefundGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseDocumentRefundGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseDocumentRefundGroupsNodeAggregationWhereInput>>;
};

export type CaseDocumentRefundGroupsRelationship = {
  __typename?: 'CaseDocumentRefundGroupsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentRefundGroup;
};

export type CaseEdge = {
  __typename?: 'CaseEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type CaseEnrollingPeriodCohortAggregationSelection = {
  __typename?: 'CaseEnrollingPeriodCohortAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export enum CaseEventCategory {
  Chat = 'CHAT',
  DataAddition = 'DATA_ADDITION',
  FinanciallyRelevant = 'FINANCIALLY_RELEVANT',
  Negotiation = 'NEGOTIATION',
  System = 'SYSTEM'
}

export type CaseEventLog = {
  __typename?: 'CaseEventLog';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  case: Case;
  caseAggregate?: Maybe<CaseEventLogCaseCaseAggregationSelection>;
  caseConnection: CaseEventLogCaseConnection;
  data?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<DocumentStatus>;
  eventCategory: CaseEventCategory;
  eventType: CaseEventType;
  trigger: CaseEventTrigger;
  triggeredBy?: Maybe<User>;
  triggeredByAggregate?: Maybe<CaseEventLogUserTriggeredByAggregationSelection>;
  triggeredByConnection: CaseEventLogTriggeredByConnection;
  triggeredOn: Scalars['DateTime']['output'];
};


export type CaseEventLogCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type CaseEventLogCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type CaseEventLogCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseEventLogCaseConnectionSort>>;
  where?: InputMaybe<CaseEventLogCaseConnectionWhere>;
};


export type CaseEventLogTriggeredByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CaseEventLogTriggeredByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CaseEventLogTriggeredByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseEventLogTriggeredByConnectionSort>>;
  where?: InputMaybe<CaseEventLogTriggeredByConnectionWhere>;
};

export type CaseEventLogAggregateSelection = {
  __typename?: 'CaseEventLogAggregateSelection';
  count: Scalars['Int']['output'];
  data: StringAggregateSelectionNullable;
  triggeredOn: DateTimeAggregateSelectionNonNullable;
};

export type CaseEventLogCaseAggregateInput = {
  AND?: InputMaybe<Array<CaseEventLogCaseAggregateInput>>;
  NOT?: InputMaybe<CaseEventLogCaseAggregateInput>;
  OR?: InputMaybe<Array<CaseEventLogCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseEventLogCaseNodeAggregationWhereInput>;
};

export type CaseEventLogCaseCaseAggregationSelection = {
  __typename?: 'CaseEventLogCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseEventLogCaseCaseNodeAggregateSelection>;
};

export type CaseEventLogCaseCaseNodeAggregateSelection = {
  __typename?: 'CaseEventLogCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type CaseEventLogCaseConnection = {
  __typename?: 'CaseEventLogCaseConnection';
  edges: Array<CaseEventLogCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseEventLogCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type CaseEventLogCaseConnectionWhere = {
  AND?: InputMaybe<Array<CaseEventLogCaseConnectionWhere>>;
  NOT?: InputMaybe<CaseEventLogCaseConnectionWhere>;
  OR?: InputMaybe<Array<CaseEventLogCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type CaseEventLogCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseEventLogCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseEventLogCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseEventLogCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseEventLogCaseRelationship = {
  __typename?: 'CaseEventLogCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type CaseEventLogEdge = {
  __typename?: 'CaseEventLogEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseEventLog;
};

export type CaseEventLogOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseEventLogSort objects to sort CaseEventLogs by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseEventLogSort>>;
};

/** Fields to sort CaseEventLogs by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseEventLogSort object. */
export type CaseEventLogSort = {
  data?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  eventCategory?: InputMaybe<SortDirection>;
  eventType?: InputMaybe<SortDirection>;
  trigger?: InputMaybe<SortDirection>;
  triggeredOn?: InputMaybe<SortDirection>;
};

export type CaseEventLogTriggeredByAggregateInput = {
  AND?: InputMaybe<Array<CaseEventLogTriggeredByAggregateInput>>;
  NOT?: InputMaybe<CaseEventLogTriggeredByAggregateInput>;
  OR?: InputMaybe<Array<CaseEventLogTriggeredByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseEventLogTriggeredByNodeAggregationWhereInput>;
};

export type CaseEventLogTriggeredByConnection = {
  __typename?: 'CaseEventLogTriggeredByConnection';
  edges: Array<CaseEventLogTriggeredByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseEventLogTriggeredByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CaseEventLogTriggeredByConnectionWhere = {
  AND?: InputMaybe<Array<CaseEventLogTriggeredByConnectionWhere>>;
  NOT?: InputMaybe<CaseEventLogTriggeredByConnectionWhere>;
  OR?: InputMaybe<Array<CaseEventLogTriggeredByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CaseEventLogTriggeredByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseEventLogTriggeredByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseEventLogTriggeredByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseEventLogTriggeredByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseEventLogTriggeredByRelationship = {
  __typename?: 'CaseEventLogTriggeredByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type CaseEventLogUserTriggeredByAggregationSelection = {
  __typename?: 'CaseEventLogUserTriggeredByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseEventLogUserTriggeredByNodeAggregateSelection>;
};

export type CaseEventLogUserTriggeredByNodeAggregateSelection = {
  __typename?: 'CaseEventLogUserTriggeredByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type CaseEventLogWhere = {
  AND?: InputMaybe<Array<CaseEventLogWhere>>;
  NOT?: InputMaybe<CaseEventLogWhere>;
  OR?: InputMaybe<Array<CaseEventLogWhere>>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<CaseEventLogCaseAggregateInput>;
  caseConnection?: InputMaybe<CaseEventLogCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<CaseEventLogCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  eventCategory?: InputMaybe<CaseEventCategory>;
  eventCategory_IN?: InputMaybe<Array<CaseEventCategory>>;
  eventType?: InputMaybe<CaseEventType>;
  eventType_IN?: InputMaybe<Array<CaseEventType>>;
  trigger?: InputMaybe<CaseEventTrigger>;
  trigger_IN?: InputMaybe<Array<CaseEventTrigger>>;
  triggeredBy?: InputMaybe<UserWhere>;
  triggeredByAggregate?: InputMaybe<CaseEventLogTriggeredByAggregateInput>;
  triggeredByConnection?: InputMaybe<CaseEventLogTriggeredByConnectionWhere>;
  triggeredByConnection_NOT?: InputMaybe<CaseEventLogTriggeredByConnectionWhere>;
  triggeredBy_NOT?: InputMaybe<UserWhere>;
  triggeredOn?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  triggeredOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  triggeredOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CaseEventLogsConnection = {
  __typename?: 'CaseEventLogsConnection';
  edges: Array<CaseEventLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CaseEventTrigger {
  Application = 'APPLICATION',
  User = 'USER'
}

export enum CaseEventType {
  AttributesChange = 'ATTRIBUTES_CHANGE',
  AutoDiscontinuation = 'AUTO_DISCONTINUATION',
  CaseAcceptance = 'CASE_ACCEPTANCE',
  CaseCreation = 'CASE_CREATION',
  CaseProcessedWithoutReview = 'CASE_PROCESSED_WITHOUT_REVIEW',
  CaseStateChange = 'CASE_STATE_CHANGE',
  FileAttachment = 'FILE_ATTACHMENT',
  FormAddition = 'FORM_ADDITION',
  FormAdditionQuestAutoGeneration = 'FORM_ADDITION_QUEST_AUTO_GENERATION',
  FormDeletion = 'FORM_DELETION',
  FormEdit = 'FORM_EDIT',
  ManualAgreementExecution = 'MANUAL_AGREEMENT_EXECUTION',
  NegotiableAttributesAddition = 'NEGOTIABLE_ATTRIBUTES_ADDITION',
  NegotiationRoundRejection = 'NEGOTIATION_ROUND_REJECTION',
  RecordAddition = 'RECORD_ADDITION',
  RecordRevocation = 'RECORD_REVOCATION',
  RecordUpdate = 'RECORD_UPDATE',
  ReplyAddition = 'REPLY_ADDITION',
  ThreadCreation = 'THREAD_CREATION',
  UserMention = 'USER_MENTION'
}

export type CaseFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<CaseFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<CaseFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<CaseFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseFinancialDataPointsNodeAggregationWhereInput>;
};

export type CaseFinancialDataPointsConnection = {
  __typename?: 'CaseFinancialDataPointsConnection';
  edges: Array<CaseFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type CaseFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<CaseFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<CaseFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type CaseFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseFinancialDataPointsRelationship = {
  __typename?: 'CaseFinancialDataPointsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type CaseFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<CaseFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<CaseFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<CaseFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseFlexEntitiesNodeAggregationWhereInput>;
};

export type CaseFlexEntitiesConnection = {
  __typename?: 'CaseFlexEntitiesConnection';
  edges: Array<CaseFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseFlexEntitiesConnectionSort = {
  edge?: InputMaybe<CaseFlexEntityRelationshipSort>;
  node?: InputMaybe<FlexEntitySort>;
};

export type CaseFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<CaseFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<CaseFlexEntitiesConnectionWhere>>;
  edge?: InputMaybe<CaseFlexEntityRelationshipWhere>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type CaseFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseFlexEntitiesRelationship = CaseFlexEntityRelationship & {
  __typename?: 'CaseFlexEntitiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isStartingPoint: Scalars['Boolean']['output'];
  node: FlexEntity;
};

export type CaseFlexEntityFlexEntitiesAggregationSelection = {
  __typename?: 'CaseFlexEntityFlexEntitiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseFlexEntityFlexEntitiesNodeAggregateSelection>;
};

export type CaseFlexEntityFlexEntitiesNodeAggregateSelection = {
  __typename?: 'CaseFlexEntityFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type CaseFlexEntityRelationship = {
  isStartingPoint: Scalars['Boolean']['output'];
};

export type CaseFlexEntityRelationshipSort = {
  isStartingPoint?: InputMaybe<SortDirection>;
};

export type CaseFlexEntityRelationshipWhere = {
  AND?: InputMaybe<Array<CaseFlexEntityRelationshipWhere>>;
  NOT?: InputMaybe<CaseFlexEntityRelationshipWhere>;
  OR?: InputMaybe<Array<CaseFlexEntityRelationshipWhere>>;
  isStartingPoint?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'CaseFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'CaseFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type CaseHistoryAggregateInput = {
  AND?: InputMaybe<Array<CaseHistoryAggregateInput>>;
  NOT?: InputMaybe<CaseHistoryAggregateInput>;
  OR?: InputMaybe<Array<CaseHistoryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseHistoryNodeAggregationWhereInput>;
};

export type CaseHistoryConnection = {
  __typename?: 'CaseHistoryConnection';
  edges: Array<CaseHistoryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseHistoryConnectionSort = {
  node?: InputMaybe<CaseHistoryRecordSort>;
};

export type CaseHistoryConnectionWhere = {
  AND?: InputMaybe<Array<CaseHistoryConnectionWhere>>;
  NOT?: InputMaybe<CaseHistoryConnectionWhere>;
  OR?: InputMaybe<Array<CaseHistoryConnectionWhere>>;
  node?: InputMaybe<CaseHistoryRecordWhere>;
};

export type CaseHistoryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseHistoryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseHistoryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseHistoryNodeAggregationWhereInput>>;
  changedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseHistoryRecord = {
  __typename?: 'CaseHistoryRecord';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  changeBy?: Maybe<User>;
  changeByAggregate?: Maybe<CaseHistoryRecordUserChangeByAggregationSelection>;
  changeByConnection: CaseHistoryRecordChangeByConnection;
  changedOn: Scalars['DateTime']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: CaseStatus;
};


export type CaseHistoryRecordChangeByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CaseHistoryRecordChangeByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CaseHistoryRecordChangeByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CaseHistoryRecordChangeByConnectionSort>>;
  where?: InputMaybe<CaseHistoryRecordChangeByConnectionWhere>;
};

export type CaseHistoryRecordAggregateSelection = {
  __typename?: 'CaseHistoryRecordAggregateSelection';
  changedOn: DateTimeAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  reason: StringAggregateSelectionNullable;
};

export type CaseHistoryRecordChangeByAggregateInput = {
  AND?: InputMaybe<Array<CaseHistoryRecordChangeByAggregateInput>>;
  NOT?: InputMaybe<CaseHistoryRecordChangeByAggregateInput>;
  OR?: InputMaybe<Array<CaseHistoryRecordChangeByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseHistoryRecordChangeByNodeAggregationWhereInput>;
};

export type CaseHistoryRecordChangeByConnection = {
  __typename?: 'CaseHistoryRecordChangeByConnection';
  edges: Array<CaseHistoryRecordChangeByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseHistoryRecordChangeByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CaseHistoryRecordChangeByConnectionWhere = {
  AND?: InputMaybe<Array<CaseHistoryRecordChangeByConnectionWhere>>;
  NOT?: InputMaybe<CaseHistoryRecordChangeByConnectionWhere>;
  OR?: InputMaybe<Array<CaseHistoryRecordChangeByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CaseHistoryRecordChangeByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseHistoryRecordChangeByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseHistoryRecordChangeByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseHistoryRecordChangeByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseHistoryRecordChangeByRelationship = {
  __typename?: 'CaseHistoryRecordChangeByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type CaseHistoryRecordEdge = {
  __typename?: 'CaseHistoryRecordEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseHistoryRecord;
};

export type CaseHistoryRecordOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseHistoryRecordSort objects to sort CaseHistoryRecords by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseHistoryRecordSort>>;
};

/** Fields to sort CaseHistoryRecords by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseHistoryRecordSort object. */
export type CaseHistoryRecordSort = {
  changedOn?: InputMaybe<SortDirection>;
  reason?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type CaseHistoryRecordUserChangeByAggregationSelection = {
  __typename?: 'CaseHistoryRecordUserChangeByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseHistoryRecordUserChangeByNodeAggregateSelection>;
};

export type CaseHistoryRecordUserChangeByNodeAggregateSelection = {
  __typename?: 'CaseHistoryRecordUserChangeByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type CaseHistoryRecordWhere = {
  AND?: InputMaybe<Array<CaseHistoryRecordWhere>>;
  NOT?: InputMaybe<CaseHistoryRecordWhere>;
  OR?: InputMaybe<Array<CaseHistoryRecordWhere>>;
  changeBy?: InputMaybe<UserWhere>;
  changeByAggregate?: InputMaybe<CaseHistoryRecordChangeByAggregateInput>;
  changeByConnection?: InputMaybe<CaseHistoryRecordChangeByConnectionWhere>;
  changeByConnection_NOT?: InputMaybe<CaseHistoryRecordChangeByConnectionWhere>;
  changeBy_NOT?: InputMaybe<UserWhere>;
  changedOn?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  changedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  reason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  reason_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reason_MATCHES?: InputMaybe<Scalars['String']['input']>;
  reason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CaseStatus>;
  status_IN?: InputMaybe<Array<CaseStatus>>;
};

export type CaseHistoryRecordsConnection = {
  __typename?: 'CaseHistoryRecordsConnection';
  edges: Array<CaseHistoryRecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseHistoryRelationship = {
  __typename?: 'CaseHistoryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseHistoryRecord;
};

export type CaseIndicationAggregateInput = {
  AND?: InputMaybe<Array<CaseIndicationAggregateInput>>;
  NOT?: InputMaybe<CaseIndicationAggregateInput>;
  OR?: InputMaybe<Array<CaseIndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseIndicationNodeAggregationWhereInput>;
};

export type CaseIndicationConnection = {
  __typename?: 'CaseIndicationConnection';
  edges: Array<CaseIndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseIndicationConnectionSort = {
  node?: InputMaybe<IndicationSort>;
};

export type CaseIndicationConnectionWhere = {
  AND?: InputMaybe<Array<CaseIndicationConnectionWhere>>;
  NOT?: InputMaybe<CaseIndicationConnectionWhere>;
  OR?: InputMaybe<Array<CaseIndicationConnectionWhere>>;
  node?: InputMaybe<IndicationWhere>;
};

export type CaseIndicationIndicationAggregationSelection = {
  __typename?: 'CaseIndicationIndicationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseIndicationIndicationNodeAggregateSelection>;
};

export type CaseIndicationIndicationNodeAggregateSelection = {
  __typename?: 'CaseIndicationIndicationNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  intent: StringAggregateSelectionNullable;
  intentLocalizationKey: StringAggregateSelectionNullable;
  line: StringAggregateSelectionNullable;
  lineLocalizationKey: StringAggregateSelectionNullable;
  mutation: StringAggregateSelectionNullable;
  mutationLocalizationKey: StringAggregateSelectionNullable;
  type: StringAggregateSelectionNullable;
  typeLocalizationKey: StringAggregateSelectionNullable;
};

export type CaseIndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseIndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseIndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseIndicationNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intentLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  intent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  intent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  intent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lineLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  line_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  line_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  line_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  line_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  line_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutationLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  mutation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  mutation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  mutation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  typeLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseIndicationRelationship = {
  __typename?: 'CaseIndicationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Indication;
};

export type CaseInfo = {
  __typename?: 'CaseInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  caseId: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  isAssignee: Scalars['Boolean']['output'];
  patientId: Scalars['String']['output'];
  therapyDecision: Scalars['String']['output'];
  userRole: AgreementUserRole;
};

export type CaseInfoAggregateSelection = {
  __typename?: 'CaseInfoAggregateSelection';
  caseId: IdAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  currency: StringAggregateSelectionNonNullable;
  patientId: StringAggregateSelectionNonNullable;
  therapyDecision: StringAggregateSelectionNonNullable;
};

export type CaseInfoEdge = {
  __typename?: 'CaseInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseInfo;
};

export type CaseInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseInfoSort objects to sort CaseInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseInfoSort>>;
};

/** Fields to sort CaseInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseInfoSort object. */
export type CaseInfoSort = {
  caseId?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  isAssignee?: InputMaybe<SortDirection>;
  patientId?: InputMaybe<SortDirection>;
  therapyDecision?: InputMaybe<SortDirection>;
  userRole?: InputMaybe<SortDirection>;
};

export type CaseInfoWhere = {
  AND?: InputMaybe<Array<CaseInfoWhere>>;
  NOT?: InputMaybe<CaseInfoWhere>;
  OR?: InputMaybe<Array<CaseInfoWhere>>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  caseId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  caseId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  caseId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  caseId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapyDecision?: InputMaybe<Scalars['String']['input']>;
  therapyDecision_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  therapyDecision_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapyDecision_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  therapyDecision_MATCHES?: InputMaybe<Scalars['String']['input']>;
  therapyDecision_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<AgreementUserRole>;
  userRole_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type CaseInfosConnection = {
  __typename?: 'CaseInfosConnection';
  edges: Array<CaseInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseLegalEntityAggregateInput = {
  AND?: InputMaybe<Array<CaseLegalEntityAggregateInput>>;
  NOT?: InputMaybe<CaseLegalEntityAggregateInput>;
  OR?: InputMaybe<Array<CaseLegalEntityAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseLegalEntityNodeAggregationWhereInput>;
};

export type CaseLegalEntityConnection = {
  __typename?: 'CaseLegalEntityConnection';
  edges: Array<CaseLegalEntityRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseLegalEntityConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CaseLegalEntityConnectionWhere = {
  AND?: InputMaybe<Array<CaseLegalEntityConnectionWhere>>;
  NOT?: InputMaybe<CaseLegalEntityConnectionWhere>;
  OR?: InputMaybe<Array<CaseLegalEntityConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type CaseLegalEntityNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseLegalEntityNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CaseLegalEntityNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseLegalEntityNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseLegalEntityRelationship = {
  __typename?: 'CaseLegalEntityRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CaseMessageAggregateInput = {
  AND?: InputMaybe<Array<CaseMessageAggregateInput>>;
  NOT?: InputMaybe<CaseMessageAggregateInput>;
  OR?: InputMaybe<Array<CaseMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseMessageNodeAggregationWhereInput>;
};

export type CaseMessageConnection = {
  __typename?: 'CaseMessageConnection';
  edges: Array<CaseMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseMessageConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type CaseMessageConnectionWhere = {
  AND?: InputMaybe<Array<CaseMessageConnectionWhere>>;
  NOT?: InputMaybe<CaseMessageConnectionWhere>;
  OR?: InputMaybe<Array<CaseMessageConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type CaseMessageMessageAggregationSelection = {
  __typename?: 'CaseMessageMessageAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseMessageMessageNodeAggregateSelection>;
};

export type CaseMessageMessageNodeAggregateSelection = {
  __typename?: 'CaseMessageMessageNodeAggregateSelection';
  content: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
};

export type CaseMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseMessageNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseMessageRelationship = {
  __typename?: 'CaseMessageRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Message;
};

export type CaseNegotiationRoundNegotiationRoundsAggregationSelection = {
  __typename?: 'CaseNegotiationRoundNegotiationRoundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection>;
};

export type CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection = {
  __typename?: 'CaseNegotiationRoundNegotiationRoundsNodeAggregateSelection';
  changedOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CaseNegotiationRoundsAggregateInput = {
  AND?: InputMaybe<Array<CaseNegotiationRoundsAggregateInput>>;
  NOT?: InputMaybe<CaseNegotiationRoundsAggregateInput>;
  OR?: InputMaybe<Array<CaseNegotiationRoundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseNegotiationRoundsNodeAggregationWhereInput>;
};

export type CaseNegotiationRoundsConnection = {
  __typename?: 'CaseNegotiationRoundsConnection';
  edges: Array<CaseNegotiationRoundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseNegotiationRoundsConnectionSort = {
  node?: InputMaybe<NegotiationRoundSort>;
};

export type CaseNegotiationRoundsConnectionWhere = {
  AND?: InputMaybe<Array<CaseNegotiationRoundsConnectionWhere>>;
  NOT?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  OR?: InputMaybe<Array<CaseNegotiationRoundsConnectionWhere>>;
  node?: InputMaybe<NegotiationRoundWhere>;
};

export type CaseNegotiationRoundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseNegotiationRoundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseNegotiationRoundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseNegotiationRoundsNodeAggregationWhereInput>>;
  changedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseNegotiationRoundsRelationship = {
  __typename?: 'CaseNegotiationRoundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NegotiationRound;
};

export type CaseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseSort objects to sort Cases by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseSort>>;
};

export type CaseOrganizationLegalEntityAggregationSelection = {
  __typename?: 'CaseOrganizationLegalEntityAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseOrganizationLegalEntityNodeAggregateSelection>;
};

export type CaseOrganizationLegalEntityNodeAggregateSelection = {
  __typename?: 'CaseOrganizationLegalEntityNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type CasePatientAggregateInput = {
  AND?: InputMaybe<Array<CasePatientAggregateInput>>;
  NOT?: InputMaybe<CasePatientAggregateInput>;
  OR?: InputMaybe<Array<CasePatientAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CasePatientNodeAggregationWhereInput>;
};

export type CasePatientConnection = {
  __typename?: 'CasePatientConnection';
  edges: Array<CasePatientRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CasePatientConnectionSort = {
  node?: InputMaybe<PatientSort>;
};

export type CasePatientConnectionWhere = {
  AND?: InputMaybe<Array<CasePatientConnectionWhere>>;
  NOT?: InputMaybe<CasePatientConnectionWhere>;
  OR?: InputMaybe<Array<CasePatientConnectionWhere>>;
  node?: InputMaybe<PatientWhere>;
};

export type CasePatientNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CasePatientNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CasePatientNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CasePatientNodeAggregationWhereInput>>;
  initials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdateDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CasePatientPatientAggregationSelection = {
  __typename?: 'CasePatientPatientAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CasePatientPatientNodeAggregateSelection>;
};

export type CasePatientPatientNodeAggregateSelection = {
  __typename?: 'CasePatientPatientNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  initials: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  yearOfBirth: IntAggregateSelectionNullable;
};

export type CasePatientRelationship = {
  __typename?: 'CasePatientRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type CasePreparationPreparationsAggregationSelection = {
  __typename?: 'CasePreparationPreparationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CasePreparationPreparationsNodeAggregateSelection>;
};

export type CasePreparationPreparationsNodeAggregateSelection = {
  __typename?: 'CasePreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CasePreparationsAggregateInput = {
  AND?: InputMaybe<Array<CasePreparationsAggregateInput>>;
  NOT?: InputMaybe<CasePreparationsAggregateInput>;
  OR?: InputMaybe<Array<CasePreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CasePreparationsNodeAggregationWhereInput>;
};

export type CasePreparationsConnection = {
  __typename?: 'CasePreparationsConnection';
  edges: Array<CasePreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CasePreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type CasePreparationsConnectionWhere = {
  AND?: InputMaybe<Array<CasePreparationsConnectionWhere>>;
  NOT?: InputMaybe<CasePreparationsConnectionWhere>;
  OR?: InputMaybe<Array<CasePreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type CasePreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CasePreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CasePreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CasePreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CasePreparationsRelationship = {
  __typename?: 'CasePreparationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type CaseRefundRefundsAggregationSelection = {
  __typename?: 'CaseRefundRefundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseRefundRefundsNodeAggregateSelection>;
};

export type CaseRefundRefundsNodeAggregateSelection = {
  __typename?: 'CaseRefundRefundsNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type CaseRefundsAggregateInput = {
  AND?: InputMaybe<Array<CaseRefundsAggregateInput>>;
  NOT?: InputMaybe<CaseRefundsAggregateInput>;
  OR?: InputMaybe<Array<CaseRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseRefundsNodeAggregationWhereInput>;
};

export type CaseRefundsConnection = {
  __typename?: 'CaseRefundsConnection';
  edges: Array<CaseRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type CaseRefundsConnectionWhere = {
  AND?: InputMaybe<Array<CaseRefundsConnectionWhere>>;
  NOT?: InputMaybe<CaseRefundsConnectionWhere>;
  OR?: InputMaybe<Array<CaseRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type CaseRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseRefundsNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CaseRefundsRelationship = {
  __typename?: 'CaseRefundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type CaseRelevantArticle71IndicationAggregateInput = {
  AND?: InputMaybe<Array<CaseRelevantArticle71IndicationAggregateInput>>;
  NOT?: InputMaybe<CaseRelevantArticle71IndicationAggregateInput>;
  OR?: InputMaybe<Array<CaseRelevantArticle71IndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseRelevantArticle71IndicationNodeAggregationWhereInput>;
};

export type CaseRelevantArticle71IndicationConnection = {
  __typename?: 'CaseRelevantArticle71IndicationConnection';
  edges: Array<CaseRelevantArticle71IndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseRelevantArticle71IndicationConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type CaseRelevantArticle71IndicationConnectionWhere = {
  AND?: InputMaybe<Array<CaseRelevantArticle71IndicationConnectionWhere>>;
  NOT?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
  OR?: InputMaybe<Array<CaseRelevantArticle71IndicationConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type CaseRelevantArticle71IndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseRelevantArticle71IndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseRelevantArticle71IndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseRelevantArticle71IndicationNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseRelevantArticle71IndicationRelationship = {
  __typename?: 'CaseRelevantArticle71IndicationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type CaseReportDataPoint = {
  __typename?: 'CaseReportDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  durationDays?: Maybe<Scalars['Int']['output']>;
  lastClaimReceived?: Maybe<Scalars['Date']['output']>;
  payableBalance?: Maybe<Scalars['Float']['output']>;
  reasonOfDiscontinuation?: Maybe<ReasonsForDiscontinuation>;
  refundableBalance?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<CaseReportingStatus>;
  variableBalance?: Maybe<Scalars['Float']['output']>;
};

export type CaseReportDataPointAggregateSelection = {
  __typename?: 'CaseReportDataPointAggregateSelection';
  caseId: IdAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  durationDays: IntAggregateSelectionNullable;
  payableBalance: FloatAggregateSelectionNullable;
  refundableBalance: FloatAggregateSelectionNullable;
  variableBalance: FloatAggregateSelectionNullable;
};

export type CaseReportDataPointEdge = {
  __typename?: 'CaseReportDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseReportDataPoint;
};

export type CaseReportDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseReportDataPointSort objects to sort CaseReportDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseReportDataPointSort>>;
};

/** Fields to sort CaseReportDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseReportDataPointSort object. */
export type CaseReportDataPointSort = {
  caseId?: InputMaybe<SortDirection>;
  durationDays?: InputMaybe<SortDirection>;
  lastClaimReceived?: InputMaybe<SortDirection>;
  payableBalance?: InputMaybe<SortDirection>;
  reasonOfDiscontinuation?: InputMaybe<SortDirection>;
  refundableBalance?: InputMaybe<SortDirection>;
  state?: InputMaybe<SortDirection>;
  variableBalance?: InputMaybe<SortDirection>;
};

export type CaseReportDataPointWhere = {
  AND?: InputMaybe<Array<CaseReportDataPointWhere>>;
  NOT?: InputMaybe<CaseReportDataPointWhere>;
  OR?: InputMaybe<Array<CaseReportDataPointWhere>>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  caseId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  caseId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  caseId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  caseId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationDays_GT?: InputMaybe<Scalars['Int']['input']>;
  durationDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationDays_LT?: InputMaybe<Scalars['Int']['input']>;
  durationDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastClaimReceived?: InputMaybe<Scalars['Date']['input']>;
  lastClaimReceived_GT?: InputMaybe<Scalars['Date']['input']>;
  lastClaimReceived_GTE?: InputMaybe<Scalars['Date']['input']>;
  lastClaimReceived_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lastClaimReceived_LT?: InputMaybe<Scalars['Date']['input']>;
  lastClaimReceived_LTE?: InputMaybe<Scalars['Date']['input']>;
  payableBalance?: InputMaybe<Scalars['Float']['input']>;
  payableBalance_GT?: InputMaybe<Scalars['Float']['input']>;
  payableBalance_GTE?: InputMaybe<Scalars['Float']['input']>;
  payableBalance_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  payableBalance_LT?: InputMaybe<Scalars['Float']['input']>;
  payableBalance_LTE?: InputMaybe<Scalars['Float']['input']>;
  reasonOfDiscontinuation?: InputMaybe<ReasonsForDiscontinuation>;
  reasonOfDiscontinuation_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
  refundableBalance?: InputMaybe<Scalars['Float']['input']>;
  refundableBalance_GT?: InputMaybe<Scalars['Float']['input']>;
  refundableBalance_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundableBalance_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  refundableBalance_LT?: InputMaybe<Scalars['Float']['input']>;
  refundableBalance_LTE?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<CaseReportingStatus>;
  state_IN?: InputMaybe<Array<InputMaybe<CaseReportingStatus>>>;
  variableBalance?: InputMaybe<Scalars['Float']['input']>;
  variableBalance_GT?: InputMaybe<Scalars['Float']['input']>;
  variableBalance_GTE?: InputMaybe<Scalars['Float']['input']>;
  variableBalance_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  variableBalance_LT?: InputMaybe<Scalars['Float']['input']>;
  variableBalance_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaseReportDataPointsConnection = {
  __typename?: 'CaseReportDataPointsConnection';
  edges: Array<CaseReportDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseReportingData = {
  __typename?: 'CaseReportingData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  ldlDelta?: Maybe<Scalars['Float']['output']>;
  ldlDeltaType?: Maybe<DeltaType>;
  snapshot?: Maybe<Scalars['String']['output']>;
};

export type CaseReportingDataAggregateSelection = {
  __typename?: 'CaseReportingDataAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  ldlDelta: FloatAggregateSelectionNullable;
  snapshot: StringAggregateSelectionNullable;
};

export type CaseReportingDataConnection = {
  __typename?: 'CaseReportingDataConnection';
  edges: Array<CaseReportingDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseReportingDataEdge = {
  __typename?: 'CaseReportingDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseReportingData;
};

export type CaseReportingDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseReportingDataSort objects to sort CaseReportingData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseReportingDataSort>>;
};

/** Fields to sort CaseReportingData by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseReportingDataSort object. */
export type CaseReportingDataSort = {
  createdOn?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  ldlDelta?: InputMaybe<SortDirection>;
  ldlDeltaType?: InputMaybe<SortDirection>;
  snapshot?: InputMaybe<SortDirection>;
};

export type CaseReportingDataWhere = {
  AND?: InputMaybe<Array<CaseReportingDataWhere>>;
  NOT?: InputMaybe<CaseReportingDataWhere>;
  OR?: InputMaybe<Array<CaseReportingDataWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  ldlDelta?: InputMaybe<Scalars['Float']['input']>;
  ldlDeltaType?: InputMaybe<DeltaType>;
  ldlDeltaType_IN?: InputMaybe<Array<InputMaybe<DeltaType>>>;
  ldlDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ldlDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  ldlDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  snapshot?: InputMaybe<Scalars['String']['input']>;
  snapshot_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  snapshot_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  snapshot_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snapshot_MATCHES?: InputMaybe<Scalars['String']['input']>;
  snapshot_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum CaseReportingStatus {
  Continues = 'CONTINUES',
  Discontinued = 'DISCONTINUED',
  Unknown = 'UNKNOWN'
}

/** Fields to sort Cases by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseSort object. */
export type CaseSort = {
  actualAgreementId?: InputMaybe<SortDirection>;
  agreement?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  agreementUserRole?: InputMaybe<SortDirection>;
  canUserViewFinancials?: InputMaybe<SortDirection>;
  counterpartyInReview?: InputMaybe<SortDirection>;
  creationDate?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  enrolmentDate?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  formattedRefundRate?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isFormOwner?: InputMaybe<SortDirection>;
  isTreatmentDiscontinued?: InputMaybe<SortDirection>;
  lastFinancialUpdateDate?: InputMaybe<SortDirection>;
  lastStatusChangeDate?: InputMaybe<SortDirection>;
  lastUpdateDate?: InputMaybe<SortDirection>;
  messageCount?: InputMaybe<SortDirection>;
  patientInitials?: InputMaybe<SortDirection>;
  patientInsuranceId?: InputMaybe<SortDirection>;
  preparationBrandName?: InputMaybe<SortDirection>;
  preparationGenericName?: InputMaybe<SortDirection>;
  rating?: InputMaybe<SortDirection>;
  sourceTenantId?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  submissionDate?: InputMaybe<SortDirection>;
  suspensionReason?: InputMaybe<SortDirection>;
  therapyDecision?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
};

export enum CaseStatus {
  Abandoned = 'ABANDONED',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  InReview = 'IN_REVIEW',
  Suspended = 'SUSPENDED',
  Tentative = 'TENTATIVE'
}

export type CaseTableRow = ITableRowView & {
  __typename?: 'CaseTableRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  actualAgreementId?: Maybe<Scalars['ID']['output']>;
  agreementId: Scalars['ID']['output'];
  agreementName?: Maybe<Scalars['String']['output']>;
  canUserViewFinancials?: Maybe<Scalars['Boolean']['output']>;
  counterpartyInReview?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  currencyName?: Maybe<Scalars['String']['output']>;
  currentReviewerNames?: Maybe<Array<Scalars['String']['output']>>;
  documentStatus?: Maybe<DocumentStatus>;
  formattedContent?: Maybe<Scalars['String']['output']>;
  formattedExposedToUserIds?: Maybe<Scalars['String']['output']>;
  formattedIndications?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastFinancialUpdateDate?: Maybe<Scalars['Date']['output']>;
  lastStatusChangeDate?: Maybe<Scalars['DateTime']['output']>;
  order: Scalars['Int']['output'];
  participatingCounterpartyNames?: Maybe<Array<Scalars['String']['output']>>;
  patientInitials?: Maybe<Scalars['String']['output']>;
  patientInsuranceId?: Maybe<Scalars['String']['output']>;
  preparationBrandName?: Maybe<Scalars['String']['output']>;
  preparationGenericName?: Maybe<Scalars['String']['output']>;
  sourceTenantId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CaseStatus>;
  suspensionReason?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<CaseTableRowUserUsersAggregationSelection>;
  usersConnection: ITableRowViewUsersConnection;
};


export type CaseTableRowUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CaseTableRowUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CaseTableRowUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ITableRowViewUsersConnectionSort>>;
  where?: InputMaybe<ITableRowViewUsersConnectionWhere>;
};

export type CaseTableRowAggregateSelection = {
  __typename?: 'CaseTableRowAggregateSelection';
  actualAgreementId: IdAggregateSelectionNullable;
  agreementId: IdAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  counterpartyInReview: StringAggregateSelectionNullable;
  currencyCode: StringAggregateSelectionNullable;
  currencyName: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNullable;
  formattedExposedToUserIds: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type CaseTableRowEdge = {
  __typename?: 'CaseTableRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaseTableRow;
};

export type CaseTableRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaseTableRowSort objects to sort CaseTableRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaseTableRowSort>>;
};

/** Fields to sort CaseTableRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaseTableRowSort object. */
export type CaseTableRowSort = {
  actualAgreementId?: InputMaybe<SortDirection>;
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  canUserViewFinancials?: InputMaybe<SortDirection>;
  counterpartyInReview?: InputMaybe<SortDirection>;
  currencyCode?: InputMaybe<SortDirection>;
  currencyName?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  formattedExposedToUserIds?: InputMaybe<SortDirection>;
  formattedIndications?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastFinancialUpdateDate?: InputMaybe<SortDirection>;
  lastStatusChangeDate?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  patientInitials?: InputMaybe<SortDirection>;
  patientInsuranceId?: InputMaybe<SortDirection>;
  preparationBrandName?: InputMaybe<SortDirection>;
  preparationGenericName?: InputMaybe<SortDirection>;
  sourceTenantId?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  suspensionReason?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
};

export type CaseTableRowUserUsersAggregationSelection = {
  __typename?: 'CaseTableRowUserUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseTableRowUserUsersNodeAggregateSelection>;
};

export type CaseTableRowUserUsersNodeAggregateSelection = {
  __typename?: 'CaseTableRowUserUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type CaseTableRowUsersAggregateInput = {
  AND?: InputMaybe<Array<CaseTableRowUsersAggregateInput>>;
  NOT?: InputMaybe<CaseTableRowUsersAggregateInput>;
  OR?: InputMaybe<Array<CaseTableRowUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CaseTableRowUsersNodeAggregationWhereInput>;
};

export type CaseTableRowUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CaseTableRowUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CaseTableRowUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CaseTableRowUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseTableRowWhere = {
  AND?: InputMaybe<Array<CaseTableRowWhere>>;
  NOT?: InputMaybe<CaseTableRowWhere>;
  OR?: InputMaybe<Array<CaseTableRowWhere>>;
  actualAgreementId?: InputMaybe<Scalars['ID']['input']>;
  actualAgreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  actualAgreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  actualAgreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  actualAgreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  canUserViewFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  counterpartyInReview?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterpartyInReview_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyName?: InputMaybe<Scalars['String']['input']>;
  currencyName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerNames?: InputMaybe<Array<Scalars['String']['input']>>;
  currentReviewerNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  documentStatus?: InputMaybe<DocumentStatus>;
  documentStatus_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedExposedToUserIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastFinancialUpdateDate?: InputMaybe<Scalars['Date']['input']>;
  lastFinancialUpdateDate_GT?: InputMaybe<Scalars['Date']['input']>;
  lastFinancialUpdateDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  lastFinancialUpdateDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lastFinancialUpdateDate_LT?: InputMaybe<Scalars['Date']['input']>;
  lastFinancialUpdateDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  lastStatusChangeDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastStatusChangeDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  participatingCounterpartyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  participatingCounterpartyNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientInitials?: InputMaybe<Scalars['String']['input']>;
  patientInitials_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientInitials_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientInitials_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientInitials_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientInitials_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientInsuranceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationGenericName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceTenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CaseStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<CaseStatus>>>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suspensionReason_MATCHES?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  usersAggregate?: InputMaybe<CaseTableRowUsersAggregateInput>;
  /** Return CaseTableRows where all of the related ITableRowViewUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return CaseTableRows where none of the related ITableRowViewUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return CaseTableRows where one of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return CaseTableRows where some of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return CaseTableRows where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return CaseTableRows where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return CaseTableRows where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return CaseTableRows where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type CaseTableRowsConnection = {
  __typename?: 'CaseTableRowsConnection';
  edges: Array<CaseTableRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CaseTaskRelationship = {
  formDueOrOverdue?: Maybe<Scalars['String']['output']>;
};

export type CaseTaskRelationshipSort = {
  formDueOrOverdue?: InputMaybe<SortDirection>;
};

export type CaseTaskRelationshipWhere = {
  AND?: InputMaybe<Array<CaseTaskRelationshipWhere>>;
  NOT?: InputMaybe<CaseTaskRelationshipWhere>;
  OR?: InputMaybe<Array<CaseTaskRelationshipWhere>>;
  formDueOrOverdue?: InputMaybe<Scalars['String']['input']>;
  formDueOrOverdue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formDueOrOverdue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formDueOrOverdue_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formDueOrOverdue_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formDueOrOverdue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CaseUserCaseAssigneeAggregationSelection = {
  __typename?: 'CaseUserCaseAssigneeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CaseUserCaseAssigneeNodeAggregateSelection>;
};

export type CaseUserCaseAssigneeNodeAggregateSelection = {
  __typename?: 'CaseUserCaseAssigneeNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type CaseWhere = {
  AND?: InputMaybe<Array<CaseWhere>>;
  NOT?: InputMaybe<CaseWhere>;
  OR?: InputMaybe<Array<CaseWhere>>;
  actualAgreementId?: InputMaybe<Scalars['String']['input']>;
  actualAgreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  actualAgreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  actualAgreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actualAgreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  actualAgreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  baseAgreement?: InputMaybe<BaseAgreementWhere>;
  baseAgreementAggregate?: InputMaybe<CaseBaseAgreementAggregateInput>;
  baseAgreementConnection?: InputMaybe<CaseBaseAgreementConnectionWhere>;
  baseAgreementConnection_NOT?: InputMaybe<CaseBaseAgreementConnectionWhere>;
  baseAgreement_NOT?: InputMaybe<BaseAgreementWhere>;
  caseAssigneeAggregate?: InputMaybe<CaseCaseAssigneeAggregateInput>;
  /** Return Cases where all of the related CaseCaseAssigneeConnections match this filter */
  caseAssigneeConnection_ALL?: InputMaybe<CaseCaseAssigneeConnectionWhere>;
  /** Return Cases where none of the related CaseCaseAssigneeConnections match this filter */
  caseAssigneeConnection_NONE?: InputMaybe<CaseCaseAssigneeConnectionWhere>;
  /** Return Cases where one of the related CaseCaseAssigneeConnections match this filter */
  caseAssigneeConnection_SINGLE?: InputMaybe<CaseCaseAssigneeConnectionWhere>;
  /** Return Cases where some of the related CaseCaseAssigneeConnections match this filter */
  caseAssigneeConnection_SOME?: InputMaybe<CaseCaseAssigneeConnectionWhere>;
  /** Return Cases where all of the related Users match this filter */
  caseAssignee_ALL?: InputMaybe<UserWhere>;
  /** Return Cases where none of the related Users match this filter */
  caseAssignee_NONE?: InputMaybe<UserWhere>;
  /** Return Cases where one of the related Users match this filter */
  caseAssignee_SINGLE?: InputMaybe<UserWhere>;
  /** Return Cases where some of the related Users match this filter */
  caseAssignee_SOME?: InputMaybe<UserWhere>;
  caseEventLogsAggregate?: InputMaybe<CaseCaseEventLogsAggregateInput>;
  /** Return Cases where all of the related CaseCaseEventLogsConnections match this filter */
  caseEventLogsConnection_ALL?: InputMaybe<CaseCaseEventLogsConnectionWhere>;
  /** Return Cases where none of the related CaseCaseEventLogsConnections match this filter */
  caseEventLogsConnection_NONE?: InputMaybe<CaseCaseEventLogsConnectionWhere>;
  /** Return Cases where one of the related CaseCaseEventLogsConnections match this filter */
  caseEventLogsConnection_SINGLE?: InputMaybe<CaseCaseEventLogsConnectionWhere>;
  /** Return Cases where some of the related CaseCaseEventLogsConnections match this filter */
  caseEventLogsConnection_SOME?: InputMaybe<CaseCaseEventLogsConnectionWhere>;
  /** Return Cases where all of the related CaseEventLogs match this filter */
  caseEventLogs_ALL?: InputMaybe<CaseEventLogWhere>;
  /** Return Cases where none of the related CaseEventLogs match this filter */
  caseEventLogs_NONE?: InputMaybe<CaseEventLogWhere>;
  /** Return Cases where one of the related CaseEventLogs match this filter */
  caseEventLogs_SINGLE?: InputMaybe<CaseEventLogWhere>;
  /** Return Cases where some of the related CaseEventLogs match this filter */
  caseEventLogs_SOME?: InputMaybe<CaseEventLogWhere>;
  caseReportingData?: InputMaybe<CaseReportingDataWhere>;
  caseReportingDataAggregate?: InputMaybe<CaseCaseReportingDataAggregateInput>;
  caseReportingDataConnection?: InputMaybe<CaseCaseReportingDataConnectionWhere>;
  caseReportingDataConnection_NOT?: InputMaybe<CaseCaseReportingDataConnectionWhere>;
  caseReportingData_NOT?: InputMaybe<CaseReportingDataWhere>;
  cohort?: InputMaybe<EnrollingPeriodWhere>;
  cohortAggregate?: InputMaybe<CaseCohortAggregateInput>;
  cohortConnection?: InputMaybe<CaseCohortConnectionWhere>;
  cohortConnection_NOT?: InputMaybe<CaseCohortConnectionWhere>;
  cohort_NOT?: InputMaybe<EnrollingPeriodWhere>;
  counterpartyInReview?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterpartyInReview_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterpartyInReview_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  creationDate?: InputMaybe<Scalars['Date']['input']>;
  creationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  creationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  creationDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  creationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  creationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  disease?: InputMaybe<DiseaseWhere>;
  diseaseAggregate?: InputMaybe<CaseDiseaseAggregateInput>;
  diseaseConnection?: InputMaybe<CaseDiseaseConnectionWhere>;
  diseaseConnection_NOT?: InputMaybe<CaseDiseaseConnectionWhere>;
  disease_NOT?: InputMaybe<DiseaseWhere>;
  documentRefundGroupsAggregate?: InputMaybe<CaseDocumentRefundGroupsAggregateInput>;
  /** Return Cases where all of the related CaseDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_ALL?: InputMaybe<CaseDocumentRefundGroupsConnectionWhere>;
  /** Return Cases where none of the related CaseDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_NONE?: InputMaybe<CaseDocumentRefundGroupsConnectionWhere>;
  /** Return Cases where one of the related CaseDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_SINGLE?: InputMaybe<CaseDocumentRefundGroupsConnectionWhere>;
  /** Return Cases where some of the related CaseDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_SOME?: InputMaybe<CaseDocumentRefundGroupsConnectionWhere>;
  /** Return Cases where all of the related DocumentRefundGroups match this filter */
  documentRefundGroups_ALL?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Cases where none of the related DocumentRefundGroups match this filter */
  documentRefundGroups_NONE?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Cases where one of the related DocumentRefundGroups match this filter */
  documentRefundGroups_SINGLE?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Cases where some of the related DocumentRefundGroups match this filter */
  documentRefundGroups_SOME?: InputMaybe<DocumentRefundGroupWhere>;
  enrolmentDate?: InputMaybe<Scalars['Date']['input']>;
  enrolmentDate_GT?: InputMaybe<Scalars['Date']['input']>;
  enrolmentDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  enrolmentDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  enrolmentDate_LT?: InputMaybe<Scalars['Date']['input']>;
  enrolmentDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  financialDataPointsAggregate?: InputMaybe<CaseFinancialDataPointsAggregateInput>;
  /** Return Cases where all of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where none of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where one of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where some of the related CaseFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<CaseFinancialDataPointsConnectionWhere>;
  /** Return Cases where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Cases where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Cases where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Cases where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  flexEntitiesAggregate?: InputMaybe<CaseFlexEntitiesAggregateInput>;
  /** Return Cases where all of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_ALL?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where none of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_NONE?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where one of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SINGLE?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where some of the related CaseFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SOME?: InputMaybe<CaseFlexEntitiesConnectionWhere>;
  /** Return Cases where all of the related FlexEntities match this filter */
  flexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Cases where none of the related FlexEntities match this filter */
  flexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Cases where one of the related FlexEntities match this filter */
  flexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Cases where some of the related FlexEntities match this filter */
  flexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  formattedIndications?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedIndications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedIndications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  historyAggregate?: InputMaybe<CaseHistoryAggregateInput>;
  /** Return Cases where all of the related CaseHistoryConnections match this filter */
  historyConnection_ALL?: InputMaybe<CaseHistoryConnectionWhere>;
  /** Return Cases where none of the related CaseHistoryConnections match this filter */
  historyConnection_NONE?: InputMaybe<CaseHistoryConnectionWhere>;
  /** Return Cases where one of the related CaseHistoryConnections match this filter */
  historyConnection_SINGLE?: InputMaybe<CaseHistoryConnectionWhere>;
  /** Return Cases where some of the related CaseHistoryConnections match this filter */
  historyConnection_SOME?: InputMaybe<CaseHistoryConnectionWhere>;
  /** Return Cases where all of the related CaseHistoryRecords match this filter */
  history_ALL?: InputMaybe<CaseHistoryRecordWhere>;
  /** Return Cases where none of the related CaseHistoryRecords match this filter */
  history_NONE?: InputMaybe<CaseHistoryRecordWhere>;
  /** Return Cases where one of the related CaseHistoryRecords match this filter */
  history_SINGLE?: InputMaybe<CaseHistoryRecordWhere>;
  /** Return Cases where some of the related CaseHistoryRecords match this filter */
  history_SOME?: InputMaybe<CaseHistoryRecordWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indication?: InputMaybe<IndicationWhere>;
  indicationAggregate?: InputMaybe<CaseIndicationAggregateInput>;
  indicationConnection?: InputMaybe<CaseIndicationConnectionWhere>;
  indicationConnection_NOT?: InputMaybe<CaseIndicationConnectionWhere>;
  indication_NOT?: InputMaybe<IndicationWhere>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastStatusChangeDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastStatusChangeDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['Date']['input']>;
  lastUpdateDate_GT?: InputMaybe<Scalars['Date']['input']>;
  lastUpdateDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  lastUpdateDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  lastUpdateDate_LT?: InputMaybe<Scalars['Date']['input']>;
  lastUpdateDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  legalEntity?: InputMaybe<OrganizationWhere>;
  legalEntityAggregate?: InputMaybe<CaseLegalEntityAggregateInput>;
  legalEntityConnection?: InputMaybe<CaseLegalEntityConnectionWhere>;
  legalEntityConnection_NOT?: InputMaybe<CaseLegalEntityConnectionWhere>;
  legalEntity_NOT?: InputMaybe<OrganizationWhere>;
  matchedScopeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchedScopeIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<MessageWhere>;
  messageAggregate?: InputMaybe<CaseMessageAggregateInput>;
  messageConnection?: InputMaybe<CaseMessageConnectionWhere>;
  messageConnection_NOT?: InputMaybe<CaseMessageConnectionWhere>;
  message_NOT?: InputMaybe<MessageWhere>;
  negotiationRoundsAggregate?: InputMaybe<CaseNegotiationRoundsAggregateInput>;
  /** Return Cases where all of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_ALL?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where none of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_NONE?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where one of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_SINGLE?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where some of the related CaseNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_SOME?: InputMaybe<CaseNegotiationRoundsConnectionWhere>;
  /** Return Cases where all of the related NegotiationRounds match this filter */
  negotiationRounds_ALL?: InputMaybe<NegotiationRoundWhere>;
  /** Return Cases where none of the related NegotiationRounds match this filter */
  negotiationRounds_NONE?: InputMaybe<NegotiationRoundWhere>;
  /** Return Cases where one of the related NegotiationRounds match this filter */
  negotiationRounds_SINGLE?: InputMaybe<NegotiationRoundWhere>;
  /** Return Cases where some of the related NegotiationRounds match this filter */
  negotiationRounds_SOME?: InputMaybe<NegotiationRoundWhere>;
  patient?: InputMaybe<PatientWhere>;
  patientAggregate?: InputMaybe<CasePatientAggregateInput>;
  patientConnection?: InputMaybe<CasePatientConnectionWhere>;
  patientConnection_NOT?: InputMaybe<CasePatientConnectionWhere>;
  patientInitials?: InputMaybe<Scalars['String']['input']>;
  patientInitials_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientInitials_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientInitials_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientInitials_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientInitials_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  patientInsuranceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientInsuranceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patient_NOT?: InputMaybe<PatientWhere>;
  preparationBrandName?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationGenericName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationGenericName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationsAggregate?: InputMaybe<CasePreparationsAggregateInput>;
  /** Return Cases where all of the related CasePreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<CasePreparationsConnectionWhere>;
  /** Return Cases where none of the related CasePreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<CasePreparationsConnectionWhere>;
  /** Return Cases where one of the related CasePreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<CasePreparationsConnectionWhere>;
  /** Return Cases where some of the related CasePreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<CasePreparationsConnectionWhere>;
  /** Return Cases where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Cases where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Cases where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Cases where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
  rating?: InputMaybe<CoverageRequestRating>;
  rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
  refundsAggregate?: InputMaybe<CaseRefundsAggregateInput>;
  /** Return Cases where all of the related CaseRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where none of the related CaseRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where one of the related CaseRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where some of the related CaseRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<CaseRefundsConnectionWhere>;
  /** Return Cases where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return Cases where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return Cases where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return Cases where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  relevantArticle71Indication?: InputMaybe<Article71IndicationWhere>;
  relevantArticle71IndicationAggregate?: InputMaybe<CaseRelevantArticle71IndicationAggregateInput>;
  relevantArticle71IndicationConnection?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
  relevantArticle71IndicationConnection_NOT?: InputMaybe<CaseRelevantArticle71IndicationConnectionWhere>;
  relevantArticle71Indication_NOT?: InputMaybe<Article71IndicationWhere>;
  sourceTenantId?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceTenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CaseStatus>;
  status_IN?: InputMaybe<Array<CaseStatus>>;
  submissionDate?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  submissionDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suspensionReason_MATCHES?: InputMaybe<Scalars['String']['input']>;
  suspensionReason_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaselessAgreementReport = {
  __typename?: 'CaselessAgreementReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountDelta?: Maybe<Scalars['Float']['output']>;
  discountRatio?: Maybe<Scalars['Float']['output']>;
  discountRatioDelta?: Maybe<Scalars['Float']['output']>;
  expenditureDistributionDataPoints: Array<ExpenditureDistributionDataPoint>;
  financialReportDataPoints: Array<FinancialReportDataPoint>;
  financialSummaryRows: Array<FinancialSummaryRow>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  grossAmountDelta?: Maybe<Scalars['Float']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
};

export type CaselessAgreementReportAggregateSelection = {
  __typename?: 'CaselessAgreementReportAggregateSelection';
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNullable;
  discountAmountDelta: FloatAggregateSelectionNullable;
  discountRatio: FloatAggregateSelectionNullable;
  discountRatioDelta: FloatAggregateSelectionNullable;
  grossAmount: FloatAggregateSelectionNullable;
  grossAmountDelta: FloatAggregateSelectionNullable;
  netAmount: FloatAggregateSelectionNullable;
};

export type CaselessAgreementReportEdge = {
  __typename?: 'CaselessAgreementReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CaselessAgreementReport;
};

export type CaselessAgreementReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CaselessAgreementReportSort objects to sort CaselessAgreementReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CaselessAgreementReportSort>>;
};

/** Fields to sort CaselessAgreementReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one CaselessAgreementReportSort object. */
export type CaselessAgreementReportSort = {
  discountAmount?: InputMaybe<SortDirection>;
  discountAmountDelta?: InputMaybe<SortDirection>;
  discountRatio?: InputMaybe<SortDirection>;
  discountRatioDelta?: InputMaybe<SortDirection>;
  grossAmount?: InputMaybe<SortDirection>;
  grossAmountDelta?: InputMaybe<SortDirection>;
  netAmount?: InputMaybe<SortDirection>;
};

export type CaselessAgreementReportWhere = {
  AND?: InputMaybe<Array<CaselessAgreementReportWhere>>;
  NOT?: InputMaybe<CaselessAgreementReportWhere>;
  OR?: InputMaybe<Array<CaselessAgreementReportWhere>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatioDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatio_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  netAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type CaselessAgreementReportsConnection = {
  __typename?: 'CaselessAgreementReportsConnection';
  edges: Array<CaselessAgreementReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CasesConnection = {
  __typename?: 'CasesConnection';
  edges: Array<CaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CasesTableSourceFilterData = {
  __typename?: 'CasesTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementNames: Array<Scalars['String']['output']>;
  amountRanges: Array<AmountRange>;
  brandNames: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
  inReviewByNames: Array<Scalars['String']['output']>;
  indicationCodes: Array<Scalars['String']['output']>;
  initials: Array<Scalars['String']['output']>;
  patientIds: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  suspensionReasons: Array<Scalars['String']['output']>;
};

export type CasesTableSourceFilterDataAggregateSelection = {
  __typename?: 'CasesTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
};

export type CasesTableSourceFilterDataConnection = {
  __typename?: 'CasesTableSourceFilterDataConnection';
  edges: Array<CasesTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CasesTableSourceFilterDataEdge = {
  __typename?: 'CasesTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CasesTableSourceFilterData;
};

export type CasesTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CasesTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<CasesTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<CasesTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<CasesTableSourceFilterDataWhere>>;
  agreementNames?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  inReviewByNames?: InputMaybe<Array<Scalars['String']['input']>>;
  inReviewByNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  indicationCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  indicationCodes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Array<Scalars['String']['input']>>;
  initials_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  suspensionReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  suspensionReasons_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogueAttribute = {
  __typename?: 'CatalogueAttribute';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  arrayPossible?: Maybe<Scalars['Boolean']['output']>;
  attributeClasses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  caption: Scalars['String']['output'];
  customCondition?: Maybe<CustomCondition>;
  customConditionAggregate?: Maybe<CatalogueAttributeCustomConditionCustomConditionAggregationSelection>;
  customConditionConnection: CatalogueAttributeCustomConditionConnection;
  dataSubType?: Maybe<DataSubType>;
  dataType: DataType;
  decimalPrecision?: Maybe<Scalars['Int']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  dependsOn: Array<CatalogueAttribute>;
  dependsOnAggregate?: Maybe<CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection>;
  dependsOnConnection: CatalogueAttributeDependsOnConnection;
  expectedWidth?: Maybe<AttributeSize>;
  flexEntityTypes: Array<FlexEntityType>;
  flexEntityTypesAggregate?: Maybe<CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection>;
  flexEntityTypesConnection: CatalogueAttributeFlexEntityTypesConnection;
  hasDependant: Array<CatalogueAttribute>;
  hasDependantAggregate?: Maybe<CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection>;
  hasDependantConnection: CatalogueAttributeHasDependantConnection;
  id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  isNegotiable?: Maybe<Scalars['Boolean']['output']>;
  longLabelLocalizationKey: Scalars['String']['output'];
  maxLength?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  mutuallyRelevant: Array<CatalogueAttribute>;
  mutuallyRelevantAggregate?: Maybe<CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection>;
  mutuallyRelevantConnection: CatalogueAttributeMutuallyRelevantConnection;
  rules?: Maybe<Scalars['String']['output']>;
  shortLabelLocalizationKey: Scalars['String']['output'];
  type?: Maybe<CatalogueAttributeType>;
  validation?: Maybe<StatusHistorical>;
  values?: Maybe<Scalars['String']['output']>;
};


export type CatalogueAttributeCustomConditionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type CatalogueAttributeCustomConditionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type CatalogueAttributeCustomConditionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeCustomConditionConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
};


export type CatalogueAttributeDependsOnArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeDependsOnAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeDependsOnConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeDependsOnConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
};


export type CatalogueAttributeFlexEntityTypesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CatalogueAttributeFlexEntityTypesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CatalogueAttributeFlexEntityTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
};


export type CatalogueAttributeHasDependantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeHasDependantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeHasDependantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeHasDependantConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
};


export type CatalogueAttributeMutuallyRelevantArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeMutuallyRelevantAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CatalogueAttributeMutuallyRelevantConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantConnectionSort>>;
  where?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
};

export type CatalogueAttributeAggregateSelection = {
  __typename?: 'CatalogueAttributeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeDependsOnAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection>;
  node?: Maybe<CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection>;
};

export type CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeDependsOnEdgeAggregateSelection';
  comment: StringAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeDependsOnNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeHasDependantAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection>;
  node?: Maybe<CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection>;
};

export type CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeHasDependantEdgeAggregateSelection';
  comment: StringAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeHasDependantNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeMutuallyRelevantAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection>;
  node?: Maybe<CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection>;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeMutuallyRelevantEdgeAggregateSelection';
  comment: StringAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCatalogueAttributeMutuallyRelevantNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CatalogueAttributeCustomConditionAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeCustomConditionAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeCustomConditionAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeCustomConditionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CatalogueAttributeCustomConditionNodeAggregationWhereInput>;
};

export type CatalogueAttributeCustomConditionConnection = {
  __typename?: 'CatalogueAttributeCustomConditionConnection';
  edges: Array<CatalogueAttributeCustomConditionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeCustomConditionConnectionSort = {
  node?: InputMaybe<CustomConditionSort>;
};

export type CatalogueAttributeCustomConditionConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeCustomConditionConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeCustomConditionConnectionWhere>>;
  node?: InputMaybe<CustomConditionWhere>;
};

export type CatalogueAttributeCustomConditionCustomConditionAggregationSelection = {
  __typename?: 'CatalogueAttributeCustomConditionCustomConditionAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection>;
};

export type CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeCustomConditionCustomConditionNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type CatalogueAttributeCustomConditionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeCustomConditionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeCustomConditionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeCustomConditionNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeCustomConditionRelationship = {
  __typename?: 'CatalogueAttributeCustomConditionRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export type CatalogueAttributeDependsOnAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CatalogueAttributeDependsOnEdgeAggregationWhereInput>;
  node?: InputMaybe<CatalogueAttributeDependsOnNodeAggregationWhereInput>;
};

export type CatalogueAttributeDependsOnConnection = {
  __typename?: 'CatalogueAttributeDependsOnConnection';
  edges: Array<CatalogueAttributeDependsOnRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeDependsOnConnectionSort = {
  edge?: InputMaybe<DependencyAttributeSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CatalogueAttributeDependsOnConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnConnectionWhere>>;
  edge?: InputMaybe<DependencyAttributeWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CatalogueAttributeDependsOnEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnEdgeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeDependsOnNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeDependsOnNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeDependsOnNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeDependsOnNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeDependsOnRelationship = DependencyAttribute & {
  __typename?: 'CatalogueAttributeDependsOnRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
  rules?: Maybe<Scalars['String']['output']>;
};

export type CatalogueAttributeEdge = {
  __typename?: 'CatalogueAttributeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection = {
  __typename?: 'CatalogueAttributeFlexEntityTypeFlexEntityTypesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection>;
};

export type CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection = {
  __typename?: 'CatalogueAttributeFlexEntityTypeFlexEntityTypesNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type CatalogueAttributeFlexEntityTypesAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeFlexEntityTypesAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>;
};

export type CatalogueAttributeFlexEntityTypesConnection = {
  __typename?: 'CatalogueAttributeFlexEntityTypesConnection';
  edges: Array<CatalogueAttributeFlexEntityTypesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeFlexEntityTypesConnectionSort = {
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipSort>;
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type CatalogueAttributeFlexEntityTypesConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesConnectionWhere>>;
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipWhere>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeFlexEntityTypesNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeFlexEntityTypesRelationship = FlexEntityTypeCatalogueAttributeRelationship & {
  __typename?: 'CatalogueAttributeFlexEntityTypesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isDisplayedInCaseDetails?: Maybe<Scalars['Boolean']['output']>;
  isDisplayedInCaseTable?: Maybe<Scalars['Boolean']['output']>;
  node: FlexEntityType;
};

export type CatalogueAttributeHasDependantAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CatalogueAttributeHasDependantEdgeAggregationWhereInput>;
  node?: InputMaybe<CatalogueAttributeHasDependantNodeAggregationWhereInput>;
};

export type CatalogueAttributeHasDependantConnection = {
  __typename?: 'CatalogueAttributeHasDependantConnection';
  edges: Array<CatalogueAttributeHasDependantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeHasDependantConnectionSort = {
  edge?: InputMaybe<DependencyAttributeSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CatalogueAttributeHasDependantConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantConnectionWhere>>;
  edge?: InputMaybe<DependencyAttributeWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CatalogueAttributeHasDependantEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantEdgeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeHasDependantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeHasDependantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeHasDependantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeHasDependantNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeHasDependantRelationship = DependencyAttribute & {
  __typename?: 'CatalogueAttributeHasDependantRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
  rules?: Maybe<Scalars['String']['output']>;
};

export type CatalogueAttributeMutuallyRelevantAggregateInput = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantAggregateInput>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantAggregateInput>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>;
  node?: InputMaybe<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>;
};

export type CatalogueAttributeMutuallyRelevantConnection = {
  __typename?: 'CatalogueAttributeMutuallyRelevantConnection';
  edges: Array<CatalogueAttributeMutuallyRelevantRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CatalogueAttributeMutuallyRelevantConnectionSort = {
  edge?: InputMaybe<DependencyAttributeSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CatalogueAttributeMutuallyRelevantConnectionWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantConnectionWhere>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantConnectionWhere>>;
  edge?: InputMaybe<DependencyAttributeWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantEdgeAggregationWhereInput>>;
  comment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CatalogueAttributeMutuallyRelevantNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CatalogueAttributeMutuallyRelevantRelationship = DependencyAttribute & {
  __typename?: 'CatalogueAttributeMutuallyRelevantRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
  rules?: Maybe<Scalars['String']['output']>;
};

export type CatalogueAttributeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CatalogueAttributeSort objects to sort CatalogueAttributes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CatalogueAttributeSort>>;
};

/** Fields to sort CatalogueAttributes by. The order in which sorts are applied is not guaranteed when specifying many fields in one CatalogueAttributeSort object. */
export type CatalogueAttributeSort = {
  arrayPossible?: InputMaybe<SortDirection>;
  caption?: InputMaybe<SortDirection>;
  dataSubType?: InputMaybe<SortDirection>;
  dataType?: InputMaybe<SortDirection>;
  decimalPrecision?: InputMaybe<SortDirection>;
  defaultValue?: InputMaybe<SortDirection>;
  expectedWidth?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  identifier?: InputMaybe<SortDirection>;
  isNegotiable?: InputMaybe<SortDirection>;
  longLabelLocalizationKey?: InputMaybe<SortDirection>;
  maxLength?: InputMaybe<SortDirection>;
  minLength?: InputMaybe<SortDirection>;
  rules?: InputMaybe<SortDirection>;
  shortLabelLocalizationKey?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  validation?: InputMaybe<SortDirection>;
  values?: InputMaybe<SortDirection>;
};

export enum CatalogueAttributeType {
  Form = 'FORM',
  Patient = 'PATIENT',
  Record = 'RECORD'
}

export type CatalogueAttributeWhere = {
  AND?: InputMaybe<Array<CatalogueAttributeWhere>>;
  NOT?: InputMaybe<CatalogueAttributeWhere>;
  OR?: InputMaybe<Array<CatalogueAttributeWhere>>;
  arrayPossible?: InputMaybe<Scalars['Boolean']['input']>;
  attributeClasses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributeClasses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  caption_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caption_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caption_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  caption_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caption_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  customCondition?: InputMaybe<CustomConditionWhere>;
  customConditionAggregate?: InputMaybe<CatalogueAttributeCustomConditionAggregateInput>;
  customConditionConnection?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
  customConditionConnection_NOT?: InputMaybe<CatalogueAttributeCustomConditionConnectionWhere>;
  customCondition_NOT?: InputMaybe<CustomConditionWhere>;
  dataSubType?: InputMaybe<DataSubType>;
  dataSubType_IN?: InputMaybe<Array<InputMaybe<DataSubType>>>;
  dataType?: InputMaybe<DataType>;
  dataType_IN?: InputMaybe<Array<DataType>>;
  decimalPrecision?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  decimalPrecision_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  defaultValue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  defaultValue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  defaultValue_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultValue_MATCHES?: InputMaybe<Scalars['String']['input']>;
  defaultValue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dependsOnAggregate?: InputMaybe<CatalogueAttributeDependsOnAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_ALL?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_NONE?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_SINGLE?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeDependsOnConnections match this filter */
  dependsOnConnection_SOME?: InputMaybe<CatalogueAttributeDependsOnConnectionWhere>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributes match this filter */
  dependsOn_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributes match this filter */
  dependsOn_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributes match this filter */
  dependsOn_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributes match this filter */
  dependsOn_SOME?: InputMaybe<CatalogueAttributeWhere>;
  expectedWidth?: InputMaybe<AttributeSize>;
  expectedWidth_IN?: InputMaybe<Array<InputMaybe<AttributeSize>>>;
  flexEntityTypesAggregate?: InputMaybe<CatalogueAttributeFlexEntityTypesAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_ALL?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_NONE?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_SINGLE?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeFlexEntityTypesConnections match this filter */
  flexEntityTypesConnection_SOME?: InputMaybe<CatalogueAttributeFlexEntityTypesConnectionWhere>;
  /** Return CatalogueAttributes where all of the related FlexEntityTypes match this filter */
  flexEntityTypes_ALL?: InputMaybe<FlexEntityTypeWhere>;
  /** Return CatalogueAttributes where none of the related FlexEntityTypes match this filter */
  flexEntityTypes_NONE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return CatalogueAttributes where one of the related FlexEntityTypes match this filter */
  flexEntityTypes_SINGLE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return CatalogueAttributes where some of the related FlexEntityTypes match this filter */
  flexEntityTypes_SOME?: InputMaybe<FlexEntityTypeWhere>;
  hasDependantAggregate?: InputMaybe<CatalogueAttributeHasDependantAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_ALL?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_NONE?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_SINGLE?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeHasDependantConnections match this filter */
  hasDependantConnection_SOME?: InputMaybe<CatalogueAttributeHasDependantConnectionWhere>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributes match this filter */
  hasDependant_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributes match this filter */
  hasDependant_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributes match this filter */
  hasDependant_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributes match this filter */
  hasDependant_SOME?: InputMaybe<CatalogueAttributeWhere>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  identifier_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  identifier_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  identifier_MATCHES?: InputMaybe<Scalars['String']['input']>;
  identifier_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isNegotiable?: InputMaybe<Scalars['Boolean']['input']>;
  longLabelLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  longLabelLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  longLabelLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  maxLength_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  maxLength_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  minLength_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  minLength_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_LTE?: InputMaybe<Scalars['Int']['input']>;
  mutuallyRelevantAggregate?: InputMaybe<CatalogueAttributeMutuallyRelevantAggregateInput>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_ALL?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_NONE?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_SINGLE?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributeMutuallyRelevantConnections match this filter */
  mutuallyRelevantConnection_SOME?: InputMaybe<CatalogueAttributeMutuallyRelevantConnectionWhere>;
  /** Return CatalogueAttributes where all of the related CatalogueAttributes match this filter */
  mutuallyRelevant_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where none of the related CatalogueAttributes match this filter */
  mutuallyRelevant_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where one of the related CatalogueAttributes match this filter */
  mutuallyRelevant_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return CatalogueAttributes where some of the related CatalogueAttributes match this filter */
  mutuallyRelevant_SOME?: InputMaybe<CatalogueAttributeWhere>;
  rules?: InputMaybe<Scalars['String']['input']>;
  rules_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rules_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rules_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rules_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  shortLabelLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  shortLabelLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CatalogueAttributeType>;
  type_IN?: InputMaybe<Array<InputMaybe<CatalogueAttributeType>>>;
  validation?: InputMaybe<StatusHistorical>;
  validation_IN?: InputMaybe<Array<InputMaybe<StatusHistorical>>>;
  values?: InputMaybe<Scalars['String']['input']>;
  values_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  values_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  values_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  values_MATCHES?: InputMaybe<Scalars['String']['input']>;
  values_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CatalogueAttributesConnection = {
  __typename?: 'CatalogueAttributesConnection';
  edges: Array<CatalogueAttributeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChartRangeConfiguration = {
  __typename?: 'ChartRangeConfiguration';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  chartType: ConfigurableChartType;
};

export type ChartRangeConfigurationAggregateSelection = {
  __typename?: 'ChartRangeConfigurationAggregateSelection';
  count: Scalars['Int']['output'];
};

export type ChartRangeConfigurationEdge = {
  __typename?: 'ChartRangeConfigurationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ChartRangeConfiguration;
};

export type ChartRangeConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ChartRangeConfigurationSort objects to sort ChartRangeConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ChartRangeConfigurationSort>>;
};

export type ChartRangeConfigurationRelationship = {
  from: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
};

export type ChartRangeConfigurationRelationshipSort = {
  from?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
};

export type ChartRangeConfigurationRelationshipWhere = {
  AND?: InputMaybe<Array<ChartRangeConfigurationRelationshipWhere>>;
  NOT?: InputMaybe<ChartRangeConfigurationRelationshipWhere>;
  OR?: InputMaybe<Array<ChartRangeConfigurationRelationshipWhere>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  from_GT?: InputMaybe<Scalars['Int']['input']>;
  from_GTE?: InputMaybe<Scalars['Int']['input']>;
  from_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  from_LT?: InputMaybe<Scalars['Int']['input']>;
  from_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['Int']['input']>;
  to_GT?: InputMaybe<Scalars['Int']['input']>;
  to_GTE?: InputMaybe<Scalars['Int']['input']>;
  to_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  to_LT?: InputMaybe<Scalars['Int']['input']>;
  to_LTE?: InputMaybe<Scalars['Int']['input']>;
};

/** Fields to sort ChartRangeConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one ChartRangeConfigurationSort object. */
export type ChartRangeConfigurationSort = {
  chartType?: InputMaybe<SortDirection>;
};

export type ChartRangeConfigurationWhere = {
  AND?: InputMaybe<Array<ChartRangeConfigurationWhere>>;
  NOT?: InputMaybe<ChartRangeConfigurationWhere>;
  OR?: InputMaybe<Array<ChartRangeConfigurationWhere>>;
  chartType?: InputMaybe<ConfigurableChartType>;
  chartType_IN?: InputMaybe<Array<ConfigurableChartType>>;
};

export type ChartRangeConfigurationsConnection = {
  __typename?: 'ChartRangeConfigurationsConnection';
  edges: Array<ChartRangeConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CodeCategory {
  Din = 'DIN',
  Gtin = 'GTIN',
  Ndc = 'NDC',
  Pharmacode = 'PHARMACODE',
  Swissmedicno8 = 'SWISSMEDICNO8'
}

export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  edges: Array<CompanyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  archetype?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<CompanyImage>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyAggregateSelection = {
  __typename?: 'CompanyAggregateSelection';
  archetype: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Company;
};

export type CompanyImage = {
  __typename?: 'CompanyImage';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type CompanyImageAggregateSelection = {
  __typename?: 'CompanyImageAggregateSelection';
  count: Scalars['Int']['output'];
  fileName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  url: StringAggregateSelectionNullable;
};

export type CompanyImageEdge = {
  __typename?: 'CompanyImageEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CompanyImage;
};

export type CompanyImageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CompanyImageSort objects to sort CompanyImages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CompanyImageSort>>;
};

/** Fields to sort CompanyImages by. The order in which sorts are applied is not guaranteed when specifying many fields in one CompanyImageSort object. */
export type CompanyImageSort = {
  fileName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
};

export type CompanyImageWhere = {
  AND?: InputMaybe<Array<CompanyImageWhere>>;
  NOT?: InputMaybe<CompanyImageWhere>;
  OR?: InputMaybe<Array<CompanyImageWhere>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_MATCHES?: InputMaybe<Scalars['String']['input']>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyImagesConnection = {
  __typename?: 'CompanyImagesConnection';
  edges: Array<CompanyImageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CompanySort objects to sort Companies by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CompanySort>>;
};

/** Fields to sort Companies by. The order in which sorts are applied is not guaranteed when specifying many fields in one CompanySort object. */
export type CompanySort = {
  archetype?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type CompanyWhere = {
  AND?: InputMaybe<Array<CompanyWhere>>;
  NOT?: InputMaybe<CompanyWhere>;
  OR?: InputMaybe<Array<CompanyWhere>>;
  archetype?: InputMaybe<Scalars['String']['input']>;
  archetype_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  archetype_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  archetype_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archetype_MATCHES?: InputMaybe<Scalars['String']['input']>;
  archetype_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum ConditionConsideredRating {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  C = 'C',
  D = 'D',
  NoRating = 'NO_RATING'
}

export enum ConditionConsideredSecIntervention {
  PerCohort = 'PER_COHORT'
}

export enum ConditionLogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export enum ConditionType {
  ActiveIngredientQuantity = 'ACTIVE_INGREDIENT_QUANTITY',
  AdverseEvent = 'ADVERSE_EVENT',
  AmountOf = 'AMOUNT_OF',
  Article71Status = 'ARTICLE71_STATUS',
  Event = 'EVENT',
  LdlLevel = 'LDL_LEVEL',
  Patent = 'PATENT',
  PrescriptionNumber = 'PRESCRIPTION_NUMBER',
  Rating = 'RATING',
  Response = 'RESPONSE',
  SecondaryInterventionRate = 'SECONDARY_INTERVENTION_RATE',
  Surgery = 'SURGERY',
  TreatmentDuration = 'TREATMENT_DURATION'
}

export enum ConfigurableChartType {
  DoT = 'DoT',
  Ldl = 'LDL'
}

export enum ContractPartType {
  Aggregation = 'AGGREGATION',
  BasicInfo = 'BASIC_INFO',
  DataGuidance = 'DATA_GUIDANCE',
  Eligibility = 'ELIGIBILITY',
  Measurement = 'MEASUREMENT',
  Pricing = 'PRICING',
  Treatment = 'TREATMENT',
  TreatmentAndOutcome = 'TREATMENT_AND_OUTCOME'
}

export enum ContractStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InApproval = 'IN_APPROVAL',
  Open = 'OPEN',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Running = 'RUNNING',
  Terminated = 'TERMINATED'
}

export type ContractWorkflow = {
  __typename?: 'ContractWorkflow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  organizationAggregate?: Maybe<ContractWorkflowOrganizationOrganizationAggregationSelection>;
  organizationConnection: ContractWorkflowOrganizationConnection;
  status?: Maybe<ContractWorkflowStatus>;
  steps: Array<ContractWorkflowStep>;
  stepsAggregate?: Maybe<ContractWorkflowContractWorkflowStepStepsAggregationSelection>;
  stepsAreOrdered: Scalars['Boolean']['output'];
  stepsConnection: ContractWorkflowStepsConnection;
  workflowType: ContractWorkflowType;
};


export type ContractWorkflowOrganizationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type ContractWorkflowOrganizationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type ContractWorkflowOrganizationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractWorkflowOrganizationConnectionSort>>;
  where?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
};


export type ContractWorkflowStepsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ContractWorkflowStepOptions>;
  where?: InputMaybe<ContractWorkflowStepWhere>;
};


export type ContractWorkflowStepsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContractWorkflowStepWhere>;
};


export type ContractWorkflowStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractWorkflowStepsConnectionSort>>;
  where?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
};

export type ContractWorkflowAggregateSelection = {
  __typename?: 'ContractWorkflowAggregateSelection';
  count: Scalars['Int']['output'];
};

export type ContractWorkflowContractWorkflowStepStepsAggregationSelection = {
  __typename?: 'ContractWorkflowContractWorkflowStepStepsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ContractWorkflowContractWorkflowStepStepsNodeAggregateSelection>;
};

export type ContractWorkflowContractWorkflowStepStepsNodeAggregateSelection = {
  __typename?: 'ContractWorkflowContractWorkflowStepStepsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
  title: StringAggregateSelectionNonNullable;
};

export type ContractWorkflowEdge = {
  __typename?: 'ContractWorkflowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ContractWorkflow;
};

export type ContractWorkflowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ContractWorkflowSort objects to sort ContractWorkflows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ContractWorkflowSort>>;
};

export type ContractWorkflowOrganizationAggregateInput = {
  AND?: InputMaybe<Array<ContractWorkflowOrganizationAggregateInput>>;
  NOT?: InputMaybe<ContractWorkflowOrganizationAggregateInput>;
  OR?: InputMaybe<Array<ContractWorkflowOrganizationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContractWorkflowOrganizationNodeAggregationWhereInput>;
};

export type ContractWorkflowOrganizationConnection = {
  __typename?: 'ContractWorkflowOrganizationConnection';
  edges: Array<ContractWorkflowOrganizationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractWorkflowOrganizationConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type ContractWorkflowOrganizationConnectionWhere = {
  AND?: InputMaybe<Array<ContractWorkflowOrganizationConnectionWhere>>;
  NOT?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
  OR?: InputMaybe<Array<ContractWorkflowOrganizationConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type ContractWorkflowOrganizationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContractWorkflowOrganizationNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ContractWorkflowOrganizationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContractWorkflowOrganizationNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractWorkflowOrganizationOrganizationAggregationSelection = {
  __typename?: 'ContractWorkflowOrganizationOrganizationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ContractWorkflowOrganizationOrganizationNodeAggregateSelection>;
};

export type ContractWorkflowOrganizationOrganizationNodeAggregateSelection = {
  __typename?: 'ContractWorkflowOrganizationOrganizationNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type ContractWorkflowOrganizationRelationship = {
  __typename?: 'ContractWorkflowOrganizationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** Fields to sort ContractWorkflows by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContractWorkflowSort object. */
export type ContractWorkflowSort = {
  status?: InputMaybe<SortDirection>;
  stepsAreOrdered?: InputMaybe<SortDirection>;
  workflowType?: InputMaybe<SortDirection>;
};

export enum ContractWorkflowStatus {
  Approve = 'APPROVE',
  Pending = 'PENDING',
  Reject = 'REJECT'
}

export type ContractWorkflowStep = {
  __typename?: 'ContractWorkflowStep';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  contractPartType?: Maybe<ContractPartType>;
  contractWorkflowStepType: ContractWorkflowStepType;
  isAmended: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  responsiblePerson: User;
  responsiblePersonAggregate?: Maybe<ContractWorkflowStepUserResponsiblePersonAggregationSelection>;
  responsiblePersonConnection: ContractWorkflowStepResponsiblePersonConnection;
  status?: Maybe<ContractWorkflowStatus>;
  title: Scalars['String']['output'];
};


export type ContractWorkflowStepResponsiblePersonArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ContractWorkflowStepResponsiblePersonAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ContractWorkflowStepResponsiblePersonConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonConnectionSort>>;
  where?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
};

export type ContractWorkflowStepAggregateSelection = {
  __typename?: 'ContractWorkflowStepAggregateSelection';
  count: Scalars['Int']['output'];
  order: IntAggregateSelectionNonNullable;
  title: StringAggregateSelectionNonNullable;
};

export type ContractWorkflowStepEdge = {
  __typename?: 'ContractWorkflowStepEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ContractWorkflowStep;
};

export type ContractWorkflowStepOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ContractWorkflowStepSort objects to sort ContractWorkflowSteps by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ContractWorkflowStepSort>>;
};

export type ContractWorkflowStepResponsiblePersonAggregateInput = {
  AND?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonAggregateInput>>;
  NOT?: InputMaybe<ContractWorkflowStepResponsiblePersonAggregateInput>;
  OR?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>;
};

export type ContractWorkflowStepResponsiblePersonConnection = {
  __typename?: 'ContractWorkflowStepResponsiblePersonConnection';
  edges: Array<ContractWorkflowStepResponsiblePersonRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractWorkflowStepResponsiblePersonConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ContractWorkflowStepResponsiblePersonConnectionWhere = {
  AND?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonConnectionWhere>>;
  NOT?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
  OR?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContractWorkflowStepResponsiblePersonNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractWorkflowStepResponsiblePersonRelationship = {
  __typename?: 'ContractWorkflowStepResponsiblePersonRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

/** Fields to sort ContractWorkflowSteps by. The order in which sorts are applied is not guaranteed when specifying many fields in one ContractWorkflowStepSort object. */
export type ContractWorkflowStepSort = {
  contractPartType?: InputMaybe<SortDirection>;
  contractWorkflowStepType?: InputMaybe<SortDirection>;
  isAmended?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export enum ContractWorkflowStepType {
  Final = 'FINAL',
  Initial = 'INITIAL'
}

export type ContractWorkflowStepUserResponsiblePersonAggregationSelection = {
  __typename?: 'ContractWorkflowStepUserResponsiblePersonAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ContractWorkflowStepUserResponsiblePersonNodeAggregateSelection>;
};

export type ContractWorkflowStepUserResponsiblePersonNodeAggregateSelection = {
  __typename?: 'ContractWorkflowStepUserResponsiblePersonNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type ContractWorkflowStepWhere = {
  AND?: InputMaybe<Array<ContractWorkflowStepWhere>>;
  NOT?: InputMaybe<ContractWorkflowStepWhere>;
  OR?: InputMaybe<Array<ContractWorkflowStepWhere>>;
  contractPartType?: InputMaybe<ContractPartType>;
  contractPartType_IN?: InputMaybe<Array<InputMaybe<ContractPartType>>>;
  contractWorkflowStepType?: InputMaybe<ContractWorkflowStepType>;
  contractWorkflowStepType_IN?: InputMaybe<Array<ContractWorkflowStepType>>;
  isAmended?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  responsiblePerson?: InputMaybe<UserWhere>;
  responsiblePersonAggregate?: InputMaybe<ContractWorkflowStepResponsiblePersonAggregateInput>;
  responsiblePersonConnection?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
  responsiblePersonConnection_NOT?: InputMaybe<ContractWorkflowStepResponsiblePersonConnectionWhere>;
  responsiblePerson_NOT?: InputMaybe<UserWhere>;
  status?: InputMaybe<ContractWorkflowStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_MATCHES?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ContractWorkflowStepsAggregateInput = {
  AND?: InputMaybe<Array<ContractWorkflowStepsAggregateInput>>;
  NOT?: InputMaybe<ContractWorkflowStepsAggregateInput>;
  OR?: InputMaybe<Array<ContractWorkflowStepsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ContractWorkflowStepsNodeAggregationWhereInput>;
};

export type ContractWorkflowStepsConnection = {
  __typename?: 'ContractWorkflowStepsConnection';
  edges: Array<ContractWorkflowStepsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractWorkflowStepsConnectionSort = {
  node?: InputMaybe<ContractWorkflowStepSort>;
};

export type ContractWorkflowStepsConnectionWhere = {
  AND?: InputMaybe<Array<ContractWorkflowStepsConnectionWhere>>;
  NOT?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
  OR?: InputMaybe<Array<ContractWorkflowStepsConnectionWhere>>;
  node?: InputMaybe<ContractWorkflowStepWhere>;
};

export type ContractWorkflowStepsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ContractWorkflowStepsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ContractWorkflowStepsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ContractWorkflowStepsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ContractWorkflowStepsRelationship = {
  __typename?: 'ContractWorkflowStepsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ContractWorkflowStep;
};

export enum ContractWorkflowType {
  Approval = 'APPROVAL',
  Termination = 'TERMINATION'
}

export type ContractWorkflowWhere = {
  AND?: InputMaybe<Array<ContractWorkflowWhere>>;
  NOT?: InputMaybe<ContractWorkflowWhere>;
  OR?: InputMaybe<Array<ContractWorkflowWhere>>;
  organization?: InputMaybe<OrganizationWhere>;
  organizationAggregate?: InputMaybe<ContractWorkflowOrganizationAggregateInput>;
  organizationConnection?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
  organizationConnection_NOT?: InputMaybe<ContractWorkflowOrganizationConnectionWhere>;
  organization_NOT?: InputMaybe<OrganizationWhere>;
  status?: InputMaybe<ContractWorkflowStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ContractWorkflowStatus>>>;
  stepsAggregate?: InputMaybe<ContractWorkflowStepsAggregateInput>;
  stepsAreOrdered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return ContractWorkflows where all of the related ContractWorkflowStepsConnections match this filter */
  stepsConnection_ALL?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
  /** Return ContractWorkflows where none of the related ContractWorkflowStepsConnections match this filter */
  stepsConnection_NONE?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
  /** Return ContractWorkflows where one of the related ContractWorkflowStepsConnections match this filter */
  stepsConnection_SINGLE?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
  /** Return ContractWorkflows where some of the related ContractWorkflowStepsConnections match this filter */
  stepsConnection_SOME?: InputMaybe<ContractWorkflowStepsConnectionWhere>;
  /** Return ContractWorkflows where all of the related ContractWorkflowSteps match this filter */
  steps_ALL?: InputMaybe<ContractWorkflowStepWhere>;
  /** Return ContractWorkflows where none of the related ContractWorkflowSteps match this filter */
  steps_NONE?: InputMaybe<ContractWorkflowStepWhere>;
  /** Return ContractWorkflows where one of the related ContractWorkflowSteps match this filter */
  steps_SINGLE?: InputMaybe<ContractWorkflowStepWhere>;
  /** Return ContractWorkflows where some of the related ContractWorkflowSteps match this filter */
  steps_SOME?: InputMaybe<ContractWorkflowStepWhere>;
  workflowType?: InputMaybe<ContractWorkflowType>;
  workflowType_IN?: InputMaybe<Array<ContractWorkflowType>>;
};

export type ContractWorkflowsConnection = {
  __typename?: 'ContractWorkflowsConnection';
  edges: Array<ContractWorkflowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CoreConfigurationData = {
  __typename?: 'CoreConfigurationData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  coverageApprovalTypeIds: Array<Scalars['String']['output']>;
};

export type CoreConfigurationDataAggregateSelection = {
  __typename?: 'CoreConfigurationDataAggregateSelection';
  count: Scalars['Int']['output'];
};

export type CoreConfigurationDataConnection = {
  __typename?: 'CoreConfigurationDataConnection';
  edges: Array<CoreConfigurationDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CoreConfigurationDataEdge = {
  __typename?: 'CoreConfigurationDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CoreConfigurationData;
};

export type CoreConfigurationDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CoreConfigurationDataWhere = {
  AND?: InputMaybe<Array<CoreConfigurationDataWhere>>;
  NOT?: InputMaybe<CoreConfigurationDataWhere>;
  OR?: InputMaybe<Array<CoreConfigurationDataWhere>>;
  coverageApprovalTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  coverageApprovalTypeIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export enum CountdownOperator {
  Before = 'BEFORE',
  StartingFrom = 'STARTING_FROM'
}

export enum CountdownPoint {
  Earliest = 'EARLIEST',
  Highest = 'HIGHEST',
  Latest = 'LATEST'
}

export enum CounterpartyRole {
  Buyer = 'BUYER',
  Observer = 'OBSERVER',
  Seller = 'SELLER'
}

export type CounterpartyRoleRelationship = {
  role: CounterpartyRole;
};

export type CounterpartyRoleRelationshipSort = {
  role?: InputMaybe<SortDirection>;
};

export type CounterpartyRoleRelationshipWhere = {
  AND?: InputMaybe<Array<CounterpartyRoleRelationshipWhere>>;
  NOT?: InputMaybe<CounterpartyRoleRelationshipWhere>;
  OR?: InputMaybe<Array<CounterpartyRoleRelationshipWhere>>;
  role?: InputMaybe<CounterpartyRole>;
  role_IN?: InputMaybe<Array<CounterpartyRole>>;
};

export type CountriesConnection = {
  __typename?: 'CountriesConnection';
  edges: Array<CountryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountriesForDashboard = {
  __typename?: 'CountriesForDashboard';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<CountriesInAgreement>;
};

export type CountriesForDashboardAggregateSelection = {
  __typename?: 'CountriesForDashboardAggregateSelection';
  agreementCount: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type CountriesForDashboardEdge = {
  __typename?: 'CountriesForDashboardEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CountriesForDashboard;
};

export type CountriesForDashboardOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CountriesForDashboardSort objects to sort CountriesForDashboards by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CountriesForDashboardSort>>;
};

/** Fields to sort CountriesForDashboards by. The order in which sorts are applied is not guaranteed when specifying many fields in one CountriesForDashboardSort object. */
export type CountriesForDashboardSort = {
  agreementCount?: InputMaybe<SortDirection>;
};

export type CountriesForDashboardWhere = {
  AND?: InputMaybe<Array<CountriesForDashboardWhere>>;
  NOT?: InputMaybe<CountriesForDashboardWhere>;
  OR?: InputMaybe<Array<CountriesForDashboardWhere>>;
  agreementCount?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  agreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountriesForDashboardsConnection = {
  __typename?: 'CountriesForDashboardsConnection';
  edges: Array<CountriesForDashboardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountriesInAgreement = {
  __typename?: 'CountriesInAgreement';
  ISO_A3?: Maybe<Scalars['String']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  flag?: Maybe<Array<Maybe<SvgFlag>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type CountriesInAgreementAggregateSelection = {
  __typename?: 'CountriesInAgreementAggregateSelection';
  ISO_A3: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
  region: StringAggregateSelectionNullable;
};

export type CountriesInAgreementEdge = {
  __typename?: 'CountriesInAgreementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CountriesInAgreement;
};

export type CountriesInAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CountriesInAgreementSort objects to sort CountriesInAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CountriesInAgreementSort>>;
};

/** Fields to sort CountriesInAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one CountriesInAgreementSort object. */
export type CountriesInAgreementSort = {
  ISO_A3?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  region?: InputMaybe<SortDirection>;
};

export type CountriesInAgreementWhere = {
  AND?: InputMaybe<Array<CountriesInAgreementWhere>>;
  ISO_A3?: InputMaybe<Scalars['String']['input']>;
  ISO_A3_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ISO_A3_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ISO_A3_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ISO_A3_MATCHES?: InputMaybe<Scalars['String']['input']>;
  ISO_A3_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CountriesInAgreementWhere>;
  OR?: InputMaybe<Array<CountriesInAgreementWhere>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  region_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  region_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  region_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  region_MATCHES?: InputMaybe<Scalars['String']['input']>;
  region_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CountriesInAgreementsConnection = {
  __typename?: 'CountriesInAgreementsConnection';
  edges: Array<CountriesInAgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Country = {
  __typename?: 'Country';
  CallingCodes: Array<Scalars['String']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCount: Scalars['Int']['output'];
  alpha2Code: Scalars['String']['output'];
  alpha3Code: Scalars['String']['output'];
  codeCategories: Array<CodeCategory>;
  currencies: Array<Currency>;
  currenciesAggregate?: Maybe<CountryCurrencyCurrenciesAggregationSelection>;
  currenciesConnection: CountryCurrenciesConnection;
  currencyCount: Scalars['Int']['output'];
  flag: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numericCode: Scalars['String']['output'];
  organizationCount: Scalars['Int']['output'];
  organizations: Array<Organization>;
  organizationsAggregate?: Maybe<CountryOrganizationOrganizationsAggregationSelection>;
  organizationsConnection: CountryOrganizationsConnection;
  scopes: Array<AgreementScope>;
  scopesAggregate?: Maybe<CountryAgreementScopeScopesAggregationSelection>;
  scopesConnection: CountryScopesConnection;
  templateCount: Scalars['Int']['output'];
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<CountryTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: CountryTreatmentsConnection;
};


export type CountryCurrenciesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type CountryCurrenciesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type CountryCurrenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryCurrenciesConnectionSort>>;
  where?: InputMaybe<CountryCurrenciesConnectionWhere>;
};


export type CountryOrganizationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type CountryOrganizationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type CountryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryOrganizationsConnectionSort>>;
  where?: InputMaybe<CountryOrganizationsConnectionWhere>;
};


export type CountryScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CountryScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CountryScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryScopesConnectionSort>>;
  where?: InputMaybe<CountryScopesConnectionWhere>;
};


export type CountryTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CountryTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CountryTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CountryTreatmentsConnectionSort>>;
  where?: InputMaybe<CountryTreatmentsConnectionWhere>;
};

export type CountryAggregateSelection = {
  __typename?: 'CountryAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type CountryAgreementScopeScopesAggregationSelection = {
  __typename?: 'CountryAgreementScopeScopesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<CountryAgreementScopeScopesEdgeAggregateSelection>;
  node?: Maybe<CountryAgreementScopeScopesNodeAggregateSelection>;
};

export type CountryAgreementScopeScopesEdgeAggregateSelection = {
  __typename?: 'CountryAgreementScopeScopesEdgeAggregateSelection';
  countryScopeId: StringAggregateSelectionNonNullable;
};

export type CountryAgreementScopeScopesNodeAggregateSelection = {
  __typename?: 'CountryAgreementScopeScopesNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type CountryCurrenciesAggregateInput = {
  AND?: InputMaybe<Array<CountryCurrenciesAggregateInput>>;
  NOT?: InputMaybe<CountryCurrenciesAggregateInput>;
  OR?: InputMaybe<Array<CountryCurrenciesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CountryCurrenciesNodeAggregationWhereInput>;
};

export type CountryCurrenciesConnection = {
  __typename?: 'CountryCurrenciesConnection';
  edges: Array<CountryCurrenciesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryCurrenciesConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type CountryCurrenciesConnectionWhere = {
  AND?: InputMaybe<Array<CountryCurrenciesConnectionWhere>>;
  NOT?: InputMaybe<CountryCurrenciesConnectionWhere>;
  OR?: InputMaybe<Array<CountryCurrenciesConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type CountryCurrenciesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryCurrenciesNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CountryCurrenciesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CountryCurrenciesNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryCurrenciesRelationship = {
  __typename?: 'CountryCurrenciesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type CountryCurrencyCurrenciesAggregationSelection = {
  __typename?: 'CountryCurrencyCurrenciesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CountryCurrencyCurrenciesNodeAggregateSelection>;
};

export type CountryCurrencyCurrenciesNodeAggregateSelection = {
  __typename?: 'CountryCurrencyCurrenciesNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type CountryEdge = {
  __typename?: 'CountryEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type CountryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CountrySort objects to sort Countries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CountrySort>>;
};

export type CountryOrganizationOrganizationsAggregationSelection = {
  __typename?: 'CountryOrganizationOrganizationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CountryOrganizationOrganizationsNodeAggregateSelection>;
};

export type CountryOrganizationOrganizationsNodeAggregateSelection = {
  __typename?: 'CountryOrganizationOrganizationsNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type CountryOrganizationsAggregateInput = {
  AND?: InputMaybe<Array<CountryOrganizationsAggregateInput>>;
  NOT?: InputMaybe<CountryOrganizationsAggregateInput>;
  OR?: InputMaybe<Array<CountryOrganizationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CountryOrganizationsNodeAggregationWhereInput>;
};

export type CountryOrganizationsConnection = {
  __typename?: 'CountryOrganizationsConnection';
  edges: Array<CountryOrganizationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryOrganizationsConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type CountryOrganizationsConnectionWhere = {
  AND?: InputMaybe<Array<CountryOrganizationsConnectionWhere>>;
  NOT?: InputMaybe<CountryOrganizationsConnectionWhere>;
  OR?: InputMaybe<Array<CountryOrganizationsConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type CountryOrganizationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryOrganizationsNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CountryOrganizationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CountryOrganizationsNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryOrganizationsRelationship = {
  __typename?: 'CountryOrganizationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type CountryScopeRelationship = {
  countryScopeId: Scalars['String']['output'];
};

export type CountryScopeRelationshipSort = {
  countryScopeId?: InputMaybe<SortDirection>;
};

export type CountryScopeRelationshipWhere = {
  AND?: InputMaybe<Array<CountryScopeRelationshipWhere>>;
  NOT?: InputMaybe<CountryScopeRelationshipWhere>;
  OR?: InputMaybe<Array<CountryScopeRelationshipWhere>>;
  countryScopeId?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  countryScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CountryScopesAggregateInput = {
  AND?: InputMaybe<Array<CountryScopesAggregateInput>>;
  NOT?: InputMaybe<CountryScopesAggregateInput>;
  OR?: InputMaybe<Array<CountryScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<CountryScopesEdgeAggregationWhereInput>;
  node?: InputMaybe<CountryScopesNodeAggregationWhereInput>;
};

export type CountryScopesConnection = {
  __typename?: 'CountryScopesConnection';
  edges: Array<CountryScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryScopesConnectionSort = {
  edge?: InputMaybe<CountryScopeRelationshipSort>;
  node?: InputMaybe<AgreementScopeSort>;
};

export type CountryScopesConnectionWhere = {
  AND?: InputMaybe<Array<CountryScopesConnectionWhere>>;
  NOT?: InputMaybe<CountryScopesConnectionWhere>;
  OR?: InputMaybe<Array<CountryScopesConnectionWhere>>;
  edge?: InputMaybe<CountryScopeRelationshipWhere>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type CountryScopesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryScopesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<CountryScopesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<CountryScopesEdgeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryScopesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CountryScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CountryScopesNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryScopesRelationship = CountryScopeRelationship & {
  __typename?: 'CountryScopesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  countryScopeId: Scalars['String']['output'];
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

/** Fields to sort Countries by. The order in which sorts are applied is not guaranteed when specifying many fields in one CountrySort object. */
export type CountrySort = {
  agreementCount?: InputMaybe<SortDirection>;
  alpha2Code?: InputMaybe<SortDirection>;
  alpha3Code?: InputMaybe<SortDirection>;
  currencyCount?: InputMaybe<SortDirection>;
  flag?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  numericCode?: InputMaybe<SortDirection>;
  organizationCount?: InputMaybe<SortDirection>;
  templateCount?: InputMaybe<SortDirection>;
};

export type CountryTreatmentTreatmentsAggregationSelection = {
  __typename?: 'CountryTreatmentTreatmentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CountryTreatmentTreatmentsNodeAggregateSelection>;
};

export type CountryTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'CountryTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type CountryTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<CountryTreatmentsAggregateInput>>;
  NOT?: InputMaybe<CountryTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<CountryTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CountryTreatmentsNodeAggregationWhereInput>;
};

export type CountryTreatmentsConnection = {
  __typename?: 'CountryTreatmentsConnection';
  edges: Array<CountryTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type CountryTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<CountryTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<CountryTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<CountryTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type CountryTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CountryTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CountryTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CountryTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CountryTreatmentsRelationship = {
  __typename?: 'CountryTreatmentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type CountryWhere = {
  AND?: InputMaybe<Array<CountryWhere>>;
  CallingCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  CallingCodes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CountryWhere>;
  OR?: InputMaybe<Array<CountryWhere>>;
  alpha2Code?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  alpha2Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  alpha2Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  alpha3Code?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  alpha3Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  alpha3Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  codeCategories?: InputMaybe<Array<CodeCategory>>;
  codeCategories_INCLUDES?: InputMaybe<CodeCategory>;
  currenciesAggregate?: InputMaybe<CountryCurrenciesAggregateInput>;
  /** Return Countries where all of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_ALL?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where none of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_NONE?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where one of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_SINGLE?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where some of the related CountryCurrenciesConnections match this filter */
  currenciesConnection_SOME?: InputMaybe<CountryCurrenciesConnectionWhere>;
  /** Return Countries where all of the related Currencies match this filter */
  currencies_ALL?: InputMaybe<CurrencyWhere>;
  /** Return Countries where none of the related Currencies match this filter */
  currencies_NONE?: InputMaybe<CurrencyWhere>;
  /** Return Countries where one of the related Currencies match this filter */
  currencies_SINGLE?: InputMaybe<CurrencyWhere>;
  /** Return Countries where some of the related Currencies match this filter */
  currencies_SOME?: InputMaybe<CurrencyWhere>;
  flag?: InputMaybe<Scalars['String']['input']>;
  flag_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flag_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flag_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flag_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flag_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  numericCode?: InputMaybe<Scalars['String']['input']>;
  numericCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  numericCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  numericCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  numericCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  numericCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationsAggregate?: InputMaybe<CountryOrganizationsAggregateInput>;
  /** Return Countries where all of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_ALL?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where none of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_NONE?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where one of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_SINGLE?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where some of the related CountryOrganizationsConnections match this filter */
  organizationsConnection_SOME?: InputMaybe<CountryOrganizationsConnectionWhere>;
  /** Return Countries where all of the related Organizations match this filter */
  organizations_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Countries where none of the related Organizations match this filter */
  organizations_NONE?: InputMaybe<OrganizationWhere>;
  /** Return Countries where one of the related Organizations match this filter */
  organizations_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Countries where some of the related Organizations match this filter */
  organizations_SOME?: InputMaybe<OrganizationWhere>;
  scopesAggregate?: InputMaybe<CountryScopesAggregateInput>;
  /** Return Countries where all of the related CountryScopesConnections match this filter */
  scopesConnection_ALL?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where none of the related CountryScopesConnections match this filter */
  scopesConnection_NONE?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where one of the related CountryScopesConnections match this filter */
  scopesConnection_SINGLE?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where some of the related CountryScopesConnections match this filter */
  scopesConnection_SOME?: InputMaybe<CountryScopesConnectionWhere>;
  /** Return Countries where all of the related AgreementScopes match this filter */
  scopes_ALL?: InputMaybe<AgreementScopeWhere>;
  /** Return Countries where none of the related AgreementScopes match this filter */
  scopes_NONE?: InputMaybe<AgreementScopeWhere>;
  /** Return Countries where one of the related AgreementScopes match this filter */
  scopes_SINGLE?: InputMaybe<AgreementScopeWhere>;
  /** Return Countries where some of the related AgreementScopes match this filter */
  scopes_SOME?: InputMaybe<AgreementScopeWhere>;
  treatmentsAggregate?: InputMaybe<CountryTreatmentsAggregateInput>;
  /** Return Countries where all of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where none of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where one of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where some of the related CountryTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<CountryTreatmentsConnectionWhere>;
  /** Return Countries where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Countries where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Countries where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Countries where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
};

export enum CoverageRequestRating {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  C = 'C',
  D = 'D',
  NoRating = 'NO_RATING'
}

export enum CoverageRequestTherapyDecision {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Trial = 'TRIAL'
}

export type CreateDocumentInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<DocumentType>;
  refundIds: Array<Scalars['ID']['input']>;
};

export type CreateDocumentMessageInput = {
  agreementIds: Array<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<DocumentMessageAttachmentInput>>;
  caseIds: Array<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  isAssignment: Scalars['Boolean']['input'];
  mentionedUserEmails: Array<Scalars['ID']['input']>;
  refundIds: Array<Scalars['ID']['input']>;
  sharingType: DocumentMessageSharingType;
};

export type CreateDocumentMessageResult = {
  __typename?: 'CreateDocumentMessageResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<DocumentMessage>;
  pendingMessageId?: Maybe<Scalars['ID']['output']>;
};

export type CreateDocumentMessageResultAggregateSelection = {
  __typename?: 'CreateDocumentMessageResultAggregateSelection';
  count: Scalars['Int']['output'];
  pendingMessageId: IdAggregateSelectionNullable;
};

export type CreateDocumentMessageResultEdge = {
  __typename?: 'CreateDocumentMessageResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CreateDocumentMessageResult;
};

export type CreateDocumentMessageResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CreateDocumentMessageResultSort objects to sort CreateDocumentMessageResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CreateDocumentMessageResultSort>>;
};

/** Fields to sort CreateDocumentMessageResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one CreateDocumentMessageResultSort object. */
export type CreateDocumentMessageResultSort = {
  pendingMessageId?: InputMaybe<SortDirection>;
};

export type CreateDocumentMessageResultWhere = {
  AND?: InputMaybe<Array<CreateDocumentMessageResultWhere>>;
  NOT?: InputMaybe<CreateDocumentMessageResultWhere>;
  OR?: InputMaybe<Array<CreateDocumentMessageResultWhere>>;
  pendingMessageId?: InputMaybe<Scalars['ID']['input']>;
  pendingMessageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  pendingMessageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  pendingMessageId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pendingMessageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDocumentMessageResultsConnection = {
  __typename?: 'CreateDocumentMessageResultsConnection';
  edges: Array<CreateDocumentMessageResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreateDomainInput = {
  name: Scalars['String']['input'];
  parentDomainId: Scalars['ID']['input'];
};

export type CreateThreadMessageInput = {
  content: Scalars['String']['input'];
  externalFlowDocumentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isExternalFlow?: InputMaybe<Scalars['Boolean']['input']>;
  mentionsUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nodeLabel: SupportedMessageNodes;
  sentByUserId: Scalars['String']['input'];
};

export type CrossCountryPrice = {
  __typename?: 'CrossCountryPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
};

export type CrossCountryPriceAggregateSelection = {
  __typename?: 'CrossCountryPriceAggregateSelection';
  Price: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type CrossCountryPriceEdge = {
  __typename?: 'CrossCountryPriceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CrossCountryPrice;
};

export type CrossCountryPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CrossCountryPriceSort objects to sort CrossCountryPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CrossCountryPriceSort>>;
};

/** Fields to sort CrossCountryPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one CrossCountryPriceSort object. */
export type CrossCountryPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type CrossCountryPriceWhere = {
  AND?: InputMaybe<Array<CrossCountryPriceWhere>>;
  NOT?: InputMaybe<CrossCountryPriceWhere>;
  OR?: InputMaybe<Array<CrossCountryPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type CrossCountryPricesConnection = {
  __typename?: 'CrossCountryPricesConnection';
  edges: Array<CrossCountryPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrenciesConnection = {
  __typename?: 'CurrenciesConnection';
  edges: Array<CurrencyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  Code?: Maybe<Scalars['String']['output']>;
  Name?: Maybe<Scalars['String']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreements: Array<Agreement>;
  agreementsAggregate?: Maybe<CurrencyAgreementAgreementsAggregationSelection>;
  agreementsConnection: CurrencyAgreementsConnection;
  countries: Array<Country>;
  countriesAggregate?: Maybe<CurrencyCountryCountriesAggregationSelection>;
  countriesConnection: CurrencyCountriesConnection;
  prices: Array<Price>;
  pricesAggregate?: Maybe<CurrencyPricePricesAggregationSelection>;
  pricesConnection: CurrencyPricesConnection;
  symbol?: Maybe<Scalars['String']['output']>;
};


export type CurrencyAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type CurrencyAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type CurrencyAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurrencyAgreementsConnectionSort>>;
  where?: InputMaybe<CurrencyAgreementsConnectionWhere>;
};


export type CurrencyCountriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type CurrencyCountriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type CurrencyCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurrencyCountriesConnectionSort>>;
  where?: InputMaybe<CurrencyCountriesConnectionWhere>;
};


export type CurrencyPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PriceOptions>;
  where?: InputMaybe<PriceWhere>;
};


export type CurrencyPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PriceWhere>;
};


export type CurrencyPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CurrencyPricesConnectionSort>>;
  where?: InputMaybe<CurrencyPricesConnectionWhere>;
};

export type CurrencyAggregateSelection = {
  __typename?: 'CurrencyAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  symbol: StringAggregateSelectionNullable;
};

export type CurrencyAgreementAgreementsAggregationSelection = {
  __typename?: 'CurrencyAgreementAgreementsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CurrencyAgreementAgreementsNodeAggregateSelection>;
};

export type CurrencyAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'CurrencyAgreementAgreementsNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type CurrencyAgreementsAggregateInput = {
  AND?: InputMaybe<Array<CurrencyAgreementsAggregateInput>>;
  NOT?: InputMaybe<CurrencyAgreementsAggregateInput>;
  OR?: InputMaybe<Array<CurrencyAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurrencyAgreementsNodeAggregationWhereInput>;
};

export type CurrencyAgreementsConnection = {
  __typename?: 'CurrencyAgreementsConnection';
  edges: Array<CurrencyAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyAgreementsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type CurrencyAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<CurrencyAgreementsConnectionWhere>>;
  NOT?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<CurrencyAgreementsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type CurrencyAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurrencyAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurrencyAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurrencyAgreementsNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyAgreementsRelationship = {
  __typename?: 'CurrencyAgreementsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type CurrencyCountriesAggregateInput = {
  AND?: InputMaybe<Array<CurrencyCountriesAggregateInput>>;
  NOT?: InputMaybe<CurrencyCountriesAggregateInput>;
  OR?: InputMaybe<Array<CurrencyCountriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurrencyCountriesNodeAggregationWhereInput>;
};

export type CurrencyCountriesConnection = {
  __typename?: 'CurrencyCountriesConnection';
  edges: Array<CurrencyCountriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyCountriesConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type CurrencyCountriesConnectionWhere = {
  AND?: InputMaybe<Array<CurrencyCountriesConnectionWhere>>;
  NOT?: InputMaybe<CurrencyCountriesConnectionWhere>;
  OR?: InputMaybe<Array<CurrencyCountriesConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type CurrencyCountriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurrencyCountriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurrencyCountriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurrencyCountriesNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyCountriesRelationship = {
  __typename?: 'CurrencyCountriesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type CurrencyCountryCountriesAggregationSelection = {
  __typename?: 'CurrencyCountryCountriesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CurrencyCountryCountriesNodeAggregateSelection>;
};

export type CurrencyCountryCountriesNodeAggregateSelection = {
  __typename?: 'CurrencyCountryCountriesNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type CurrencyEdge = {
  __typename?: 'CurrencyEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type CurrencyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CurrencySort objects to sort Currencies by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CurrencySort>>;
};

export type CurrencyPricePricesAggregationSelection = {
  __typename?: 'CurrencyPricePricesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CurrencyPricePricesNodeAggregateSelection>;
};

export type CurrencyPricePricesNodeAggregateSelection = {
  __typename?: 'CurrencyPricePricesNodeAggregateSelection';
  Price: StringAggregateSelectionNonNullable;
  PriceChangeTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionIt: StringAggregateSelectionNullable;
  PriceTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceTypeDescriptionIt: StringAggregateSelectionNullable;
  countriesConsidered: StringAggregateSelectionNullable;
  uniqueCode: StringAggregateSelectionNonNullable;
};

export type CurrencyPricesAggregateInput = {
  AND?: InputMaybe<Array<CurrencyPricesAggregateInput>>;
  NOT?: InputMaybe<CurrencyPricesAggregateInput>;
  OR?: InputMaybe<Array<CurrencyPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CurrencyPricesNodeAggregationWhereInput>;
};

export type CurrencyPricesConnection = {
  __typename?: 'CurrencyPricesConnection';
  edges: Array<CurrencyPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurrencyPricesConnectionSort = {
  node?: InputMaybe<PriceSort>;
};

export type CurrencyPricesConnectionWhere = {
  AND?: InputMaybe<Array<CurrencyPricesConnectionWhere>>;
  NOT?: InputMaybe<CurrencyPricesConnectionWhere>;
  OR?: InputMaybe<Array<CurrencyPricesConnectionWhere>>;
  node?: InputMaybe<PriceWhere>;
};

export type CurrencyPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CurrencyPricesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CurrencyPricesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CurrencyPricesNodeAggregationWhereInput>>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Price_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CurrencyPricesRelationship = {
  __typename?: 'CurrencyPricesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Price;
};

/** Fields to sort Currencies by. The order in which sorts are applied is not guaranteed when specifying many fields in one CurrencySort object. */
export type CurrencySort = {
  Code?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
  symbol?: InputMaybe<SortDirection>;
};

export type CurrencyWhere = {
  AND?: InputMaybe<Array<CurrencyWhere>>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CurrencyWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<CurrencyWhere>>;
  agreementsAggregate?: InputMaybe<CurrencyAgreementsAggregateInput>;
  /** Return Currencies where all of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where none of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where one of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where some of the related CurrencyAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<CurrencyAgreementsConnectionWhere>;
  /** Return Currencies where all of the related Agreements match this filter */
  agreements_ALL?: InputMaybe<AgreementWhere>;
  /** Return Currencies where none of the related Agreements match this filter */
  agreements_NONE?: InputMaybe<AgreementWhere>;
  /** Return Currencies where one of the related Agreements match this filter */
  agreements_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return Currencies where some of the related Agreements match this filter */
  agreements_SOME?: InputMaybe<AgreementWhere>;
  countriesAggregate?: InputMaybe<CurrencyCountriesAggregateInput>;
  /** Return Currencies where all of the related CurrencyCountriesConnections match this filter */
  countriesConnection_ALL?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where none of the related CurrencyCountriesConnections match this filter */
  countriesConnection_NONE?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where one of the related CurrencyCountriesConnections match this filter */
  countriesConnection_SINGLE?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where some of the related CurrencyCountriesConnections match this filter */
  countriesConnection_SOME?: InputMaybe<CurrencyCountriesConnectionWhere>;
  /** Return Currencies where all of the related Countries match this filter */
  countries_ALL?: InputMaybe<CountryWhere>;
  /** Return Currencies where none of the related Countries match this filter */
  countries_NONE?: InputMaybe<CountryWhere>;
  /** Return Currencies where one of the related Countries match this filter */
  countries_SINGLE?: InputMaybe<CountryWhere>;
  /** Return Currencies where some of the related Countries match this filter */
  countries_SOME?: InputMaybe<CountryWhere>;
  pricesAggregate?: InputMaybe<CurrencyPricesAggregateInput>;
  /** Return Currencies where all of the related CurrencyPricesConnections match this filter */
  pricesConnection_ALL?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where none of the related CurrencyPricesConnections match this filter */
  pricesConnection_NONE?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where one of the related CurrencyPricesConnections match this filter */
  pricesConnection_SINGLE?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where some of the related CurrencyPricesConnections match this filter */
  pricesConnection_SOME?: InputMaybe<CurrencyPricesConnectionWhere>;
  /** Return Currencies where all of the related Prices match this filter */
  prices_ALL?: InputMaybe<PriceWhere>;
  /** Return Currencies where none of the related Prices match this filter */
  prices_NONE?: InputMaybe<PriceWhere>;
  /** Return Currencies where one of the related Prices match this filter */
  prices_SINGLE?: InputMaybe<PriceWhere>;
  /** Return Currencies where some of the related Prices match this filter */
  prices_SOME?: InputMaybe<PriceWhere>;
  symbol?: InputMaybe<Scalars['String']['input']>;
  symbol_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  symbol_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  symbol_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  symbol_MATCHES?: InputMaybe<Scalars['String']['input']>;
  symbol_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CustomCondition = {
  __typename?: 'CustomCondition';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCount: Scalars['Int']['output'];
  attribute: CatalogueAttribute;
  attributeAggregate?: Maybe<CustomConditionCatalogueAttributeAttributeAggregationSelection>;
  attributeConnection: CustomConditionAttributeConnection;
  conditionType: CustomConditionType;
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<CustomConditionUserCreatedByAggregationSelection>;
  createdByConnection: CustomConditionCreatedByConnection;
  createdOn: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fieldType: CustomConditionFieldType;
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  modelCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
};


export type CustomConditionAttributeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CustomConditionAttributeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type CustomConditionAttributeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CustomConditionAttributeConnectionSort>>;
  where?: InputMaybe<CustomConditionAttributeConnectionWhere>;
};


export type CustomConditionCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type CustomConditionCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type CustomConditionCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CustomConditionCreatedByConnectionSort>>;
  where?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
};

export type CustomConditionAggregateSelection = {
  __typename?: 'CustomConditionAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type CustomConditionAttributeAggregateInput = {
  AND?: InputMaybe<Array<CustomConditionAttributeAggregateInput>>;
  NOT?: InputMaybe<CustomConditionAttributeAggregateInput>;
  OR?: InputMaybe<Array<CustomConditionAttributeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CustomConditionAttributeNodeAggregationWhereInput>;
};

export type CustomConditionAttributeConnection = {
  __typename?: 'CustomConditionAttributeConnection';
  edges: Array<CustomConditionAttributeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomConditionAttributeConnectionSort = {
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type CustomConditionAttributeConnectionWhere = {
  AND?: InputMaybe<Array<CustomConditionAttributeConnectionWhere>>;
  NOT?: InputMaybe<CustomConditionAttributeConnectionWhere>;
  OR?: InputMaybe<Array<CustomConditionAttributeConnectionWhere>>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type CustomConditionAttributeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomConditionAttributeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CustomConditionAttributeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CustomConditionAttributeNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomConditionAttributeRelationship = {
  __typename?: 'CustomConditionAttributeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CatalogueAttribute;
};

export type CustomConditionCatalogueAttributeAttributeAggregationSelection = {
  __typename?: 'CustomConditionCatalogueAttributeAttributeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CustomConditionCatalogueAttributeAttributeNodeAggregateSelection>;
};

export type CustomConditionCatalogueAttributeAttributeNodeAggregateSelection = {
  __typename?: 'CustomConditionCatalogueAttributeAttributeNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type CustomConditionCreatedByAggregateInput = {
  AND?: InputMaybe<Array<CustomConditionCreatedByAggregateInput>>;
  NOT?: InputMaybe<CustomConditionCreatedByAggregateInput>;
  OR?: InputMaybe<Array<CustomConditionCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CustomConditionCreatedByNodeAggregationWhereInput>;
};

export type CustomConditionCreatedByConnection = {
  __typename?: 'CustomConditionCreatedByConnection';
  edges: Array<CustomConditionCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomConditionCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type CustomConditionCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<CustomConditionCreatedByConnectionWhere>>;
  NOT?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<CustomConditionCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type CustomConditionCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomConditionCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CustomConditionCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CustomConditionCreatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomConditionCreatedByRelationship = {
  __typename?: 'CustomConditionCreatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type CustomConditionEdge = {
  __typename?: 'CustomConditionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export enum CustomConditionEventFrequency {
  AtLeastOnce = 'AT_LEAST_ONCE'
}

export enum CustomConditionEventResult {
  WithAConcreteResultUnavailable = 'WITH_A_CONCRETE_RESULT_UNAVAILABLE'
}

export enum CustomConditionEventType {
  Occurred = 'OCCURRED'
}

export enum CustomConditionFieldType {
  Boolean = 'BOOLEAN',
  Dropdown = 'DROPDOWN'
}

export type CustomConditionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CustomConditionSort objects to sort CustomConditions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CustomConditionSort>>;
};

/** Fields to sort CustomConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one CustomConditionSort object. */
export type CustomConditionSort = {
  agreementCount?: InputMaybe<SortDirection>;
  conditionType?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  fieldType?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  modelCount?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export enum CustomConditionType {
  Conclusive = 'CONCLUSIVE',
  Enrolment = 'ENROLMENT'
}

export type CustomConditionUserCreatedByAggregationSelection = {
  __typename?: 'CustomConditionUserCreatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CustomConditionUserCreatedByNodeAggregateSelection>;
};

export type CustomConditionUserCreatedByNodeAggregateSelection = {
  __typename?: 'CustomConditionUserCreatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type CustomConditionWhere = {
  AND?: InputMaybe<Array<CustomConditionWhere>>;
  NOT?: InputMaybe<CustomConditionWhere>;
  OR?: InputMaybe<Array<CustomConditionWhere>>;
  attribute?: InputMaybe<CatalogueAttributeWhere>;
  attributeAggregate?: InputMaybe<CustomConditionAttributeAggregateInput>;
  attributeConnection?: InputMaybe<CustomConditionAttributeConnectionWhere>;
  attributeConnection_NOT?: InputMaybe<CustomConditionAttributeConnectionWhere>;
  attribute_NOT?: InputMaybe<CatalogueAttributeWhere>;
  conditionType?: InputMaybe<CustomConditionType>;
  conditionType_IN?: InputMaybe<Array<CustomConditionType>>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<CustomConditionCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<CustomConditionCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<CustomConditionFieldType>;
  fieldType_IN?: InputMaybe<Array<CustomConditionFieldType>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  options_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type CustomConditionsConnection = {
  __typename?: 'CustomConditionsConnection';
  edges: Array<CustomConditionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomIntegrityCheck = {
  __typename?: 'CustomIntegrityCheck';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  expression: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
};

export type CustomIntegrityCheckAggregateSelection = {
  __typename?: 'CustomIntegrityCheckAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  expression: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  typeName: StringAggregateSelectionNonNullable;
};

export type CustomIntegrityCheckEdge = {
  __typename?: 'CustomIntegrityCheckEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CustomIntegrityCheck;
};

export type CustomIntegrityCheckOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CustomIntegrityCheckSort objects to sort CustomIntegrityChecks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CustomIntegrityCheckSort>>;
};

/** Fields to sort CustomIntegrityChecks by. The order in which sorts are applied is not guaranteed when specifying many fields in one CustomIntegrityCheckSort object. */
export type CustomIntegrityCheckSort = {
  createdOn?: InputMaybe<SortDirection>;
  expression?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  typeName?: InputMaybe<SortDirection>;
};

export type CustomIntegrityCheckWhere = {
  AND?: InputMaybe<Array<CustomIntegrityCheckWhere>>;
  NOT?: InputMaybe<CustomIntegrityCheckWhere>;
  OR?: InputMaybe<Array<CustomIntegrityCheckWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  expression_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  expression_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  expression_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  expression_MATCHES?: InputMaybe<Scalars['String']['input']>;
  expression_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
  typeName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  typeName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  typeName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIntegrityChecksConnection = {
  __typename?: 'CustomIntegrityChecksConnection';
  edges: Array<CustomIntegrityCheckEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CycleAdherence {
  SemiStrict = 'SEMI_STRICT',
  Soft = 'SOFT',
  Strict = 'STRICT'
}

export type CycleConfiguration = {
  __typename?: 'CycleConfiguration';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cycleStartingPoint: CycleStartingPoint;
  lengthFrom: Scalars['Int']['output'];
  lengthTo?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  recordType?: Maybe<FlexEntityType>;
  recordTypeAggregate?: Maybe<CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection>;
  recordTypeConnection: CycleConfigurationRecordTypeConnection;
  scope: AgreementScope;
  scopeAggregate?: Maybe<CycleConfigurationAgreementScopeScopeAggregationSelection>;
  scopeConnection: CycleConfigurationScopeConnection;
  startingTreatment?: Maybe<Treatment>;
  startingTreatmentAggregate?: Maybe<CycleConfigurationTreatmentStartingTreatmentAggregationSelection>;
  startingTreatmentBrand?: Maybe<Brand>;
  startingTreatmentBrandAggregate?: Maybe<CycleConfigurationBrandStartingTreatmentBrandAggregationSelection>;
  startingTreatmentBrandConnection: CycleConfigurationStartingTreatmentBrandConnection;
  startingTreatmentConnection: CycleConfigurationStartingTreatmentConnection;
  startingTreatmentGeneric?: Maybe<Generic>;
  startingTreatmentGenericAggregate?: Maybe<CycleConfigurationGenericStartingTreatmentGenericAggregationSelection>;
  startingTreatmentGenericConnection: CycleConfigurationStartingTreatmentGenericConnection;
  therapies: Array<CycleTherapyConfiguration>;
  therapiesAggregate?: Maybe<CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection>;
  therapiesConnection: CycleConfigurationTherapiesConnection;
};


export type CycleConfigurationRecordTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CycleConfigurationRecordTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type CycleConfigurationRecordTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationRecordTypeConnectionSort>>;
  where?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
};


export type CycleConfigurationScopeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CycleConfigurationScopeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type CycleConfigurationScopeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationScopeConnectionSort>>;
  where?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
};


export type CycleConfigurationStartingTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CycleConfigurationStartingTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type CycleConfigurationStartingTreatmentBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type CycleConfigurationStartingTreatmentBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type CycleConfigurationStartingTreatmentBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandConnectionSort>>;
  where?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
};


export type CycleConfigurationStartingTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationStartingTreatmentConnectionSort>>;
  where?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
};


export type CycleConfigurationStartingTreatmentGenericArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type CycleConfigurationStartingTreatmentGenericAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type CycleConfigurationStartingTreatmentGenericConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericConnectionSort>>;
  where?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
};


export type CycleConfigurationTherapiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleTherapyConfigurationOptions>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type CycleConfigurationTherapiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type CycleConfigurationTherapiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleConfigurationTherapiesConnectionSort>>;
  where?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
};

export type CycleConfigurationAggregateSelection = {
  __typename?: 'CycleConfigurationAggregateSelection';
  count: Scalars['Int']['output'];
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type CycleConfigurationAgreementScopeScopeAggregationSelection = {
  __typename?: 'CycleConfigurationAgreementScopeScopeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationAgreementScopeScopeNodeAggregateSelection>;
};

export type CycleConfigurationAgreementScopeScopeNodeAggregateSelection = {
  __typename?: 'CycleConfigurationAgreementScopeScopeNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type CycleConfigurationBrandStartingTreatmentBrandAggregationSelection = {
  __typename?: 'CycleConfigurationBrandStartingTreatmentBrandAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection>;
};

export type CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection = {
  __typename?: 'CycleConfigurationBrandStartingTreatmentBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection = {
  __typename?: 'CycleConfigurationCycleTherapyConfigurationTherapiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection>;
};

export type CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection = {
  __typename?: 'CycleConfigurationCycleTherapyConfigurationTherapiesNodeAggregateSelection';
  cycleToleranceFrom: IntAggregateSelectionNullable;
  cycleToleranceTo: IntAggregateSelectionNullable;
  dosageFrom: FloatAggregateSelectionNullable;
  dosageTo: FloatAggregateSelectionNullable;
  packQuantityFrom: IntAggregateSelectionNullable;
  packQuantityTo: IntAggregateSelectionNullable;
  recordGapFrom: IntAggregateSelectionNullable;
  recordGapTo: IntAggregateSelectionNullable;
  recordQuantityFrom: IntAggregateSelectionNullable;
  recordQuantityTo: IntAggregateSelectionNullable;
};

export type CycleConfigurationEdge = {
  __typename?: 'CycleConfigurationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection = {
  __typename?: 'CycleConfigurationFlexEntityTypeRecordTypeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection>;
};

export type CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection = {
  __typename?: 'CycleConfigurationFlexEntityTypeRecordTypeNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type CycleConfigurationGenericStartingTreatmentGenericAggregationSelection = {
  __typename?: 'CycleConfigurationGenericStartingTreatmentGenericAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection>;
};

export type CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection = {
  __typename?: 'CycleConfigurationGenericStartingTreatmentGenericNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type CycleConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CycleConfigurationSort objects to sort CycleConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CycleConfigurationSort>>;
};

export type CycleConfigurationRecordTypeAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationRecordTypeAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationRecordTypeAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationRecordTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationRecordTypeNodeAggregationWhereInput>;
};

export type CycleConfigurationRecordTypeConnection = {
  __typename?: 'CycleConfigurationRecordTypeConnection';
  edges: Array<CycleConfigurationRecordTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationRecordTypeConnectionSort = {
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type CycleConfigurationRecordTypeConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationRecordTypeConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationRecordTypeConnectionWhere>>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type CycleConfigurationRecordTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationRecordTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationRecordTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleConfigurationRecordTypeNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationRecordTypeRelationship = {
  __typename?: 'CycleConfigurationRecordTypeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

export type CycleConfigurationScopeAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationScopeAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationScopeAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationScopeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationScopeNodeAggregationWhereInput>;
};

export type CycleConfigurationScopeConnection = {
  __typename?: 'CycleConfigurationScopeConnection';
  edges: Array<CycleConfigurationScopeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationScopeConnectionSort = {
  node?: InputMaybe<AgreementScopeSort>;
};

export type CycleConfigurationScopeConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationScopeConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationScopeConnectionWhere>>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type CycleConfigurationScopeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationScopeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationScopeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleConfigurationScopeNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationScopeRelationship = {
  __typename?: 'CycleConfigurationScopeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

/** Fields to sort CycleConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one CycleConfigurationSort object. */
export type CycleConfigurationSort = {
  cycleStartingPoint?: InputMaybe<SortDirection>;
  lengthFrom?: InputMaybe<SortDirection>;
  lengthTo?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type CycleConfigurationStartingTreatmentAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>;
};

export type CycleConfigurationStartingTreatmentBrandAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>;
};

export type CycleConfigurationStartingTreatmentBrandConnection = {
  __typename?: 'CycleConfigurationStartingTreatmentBrandConnection';
  edges: Array<CycleConfigurationStartingTreatmentBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationStartingTreatmentBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type CycleConfigurationStartingTreatmentBrandConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CycleConfigurationStartingTreatmentBrandRelationship = {
  __typename?: 'CycleConfigurationStartingTreatmentBrandRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type CycleConfigurationStartingTreatmentConnection = {
  __typename?: 'CycleConfigurationStartingTreatmentConnection';
  edges: Array<CycleConfigurationStartingTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationStartingTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type CycleConfigurationStartingTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type CycleConfigurationStartingTreatmentGenericAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>;
};

export type CycleConfigurationStartingTreatmentGenericConnection = {
  __typename?: 'CycleConfigurationStartingTreatmentGenericConnection';
  edges: Array<CycleConfigurationStartingTreatmentGenericRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationStartingTreatmentGenericConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type CycleConfigurationStartingTreatmentGenericConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentGenericNodeAggregationWhereInput>>;
};

export type CycleConfigurationStartingTreatmentGenericRelationship = {
  __typename?: 'CycleConfigurationStartingTreatmentGenericRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type CycleConfigurationStartingTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<CycleConfigurationStartingTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationStartingTreatmentRelationship = {
  __typename?: 'CycleConfigurationStartingTreatmentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type CycleConfigurationTherapiesAggregateInput = {
  AND?: InputMaybe<Array<CycleConfigurationTherapiesAggregateInput>>;
  NOT?: InputMaybe<CycleConfigurationTherapiesAggregateInput>;
  OR?: InputMaybe<Array<CycleConfigurationTherapiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleConfigurationTherapiesNodeAggregationWhereInput>;
};

export type CycleConfigurationTherapiesConnection = {
  __typename?: 'CycleConfigurationTherapiesConnection';
  edges: Array<CycleConfigurationTherapiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleConfigurationTherapiesConnectionSort = {
  node?: InputMaybe<CycleTherapyConfigurationSort>;
};

export type CycleConfigurationTherapiesConnectionWhere = {
  AND?: InputMaybe<Array<CycleConfigurationTherapiesConnectionWhere>>;
  NOT?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  OR?: InputMaybe<Array<CycleConfigurationTherapiesConnectionWhere>>;
  node?: InputMaybe<CycleTherapyConfigurationWhere>;
};

export type CycleConfigurationTherapiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleConfigurationTherapiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleConfigurationTherapiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleConfigurationTherapiesNodeAggregationWhereInput>>;
  cycleToleranceFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleToleranceTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  packQuantityTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordGapTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  recordQuantityTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleConfigurationTherapiesRelationship = {
  __typename?: 'CycleConfigurationTherapiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleTherapyConfiguration;
};

export type CycleConfigurationTreatmentStartingTreatmentAggregationSelection = {
  __typename?: 'CycleConfigurationTreatmentStartingTreatmentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection>;
};

export type CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection = {
  __typename?: 'CycleConfigurationTreatmentStartingTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type CycleConfigurationWhere = {
  AND?: InputMaybe<Array<CycleConfigurationWhere>>;
  NOT?: InputMaybe<CycleConfigurationWhere>;
  OR?: InputMaybe<Array<CycleConfigurationWhere>>;
  cycleStartingPoint?: InputMaybe<CycleStartingPoint>;
  cycleStartingPoint_IN?: InputMaybe<Array<CycleStartingPoint>>;
  lengthFrom?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  lengthFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lengthTo_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordType?: InputMaybe<FlexEntityTypeWhere>;
  recordTypeAggregate?: InputMaybe<CycleConfigurationRecordTypeAggregateInput>;
  recordTypeConnection?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
  recordTypeConnection_NOT?: InputMaybe<CycleConfigurationRecordTypeConnectionWhere>;
  recordType_NOT?: InputMaybe<FlexEntityTypeWhere>;
  scope?: InputMaybe<AgreementScopeWhere>;
  scopeAggregate?: InputMaybe<CycleConfigurationScopeAggregateInput>;
  scopeConnection?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
  scopeConnection_NOT?: InputMaybe<CycleConfigurationScopeConnectionWhere>;
  scope_NOT?: InputMaybe<AgreementScopeWhere>;
  startingTreatment?: InputMaybe<TreatmentWhere>;
  startingTreatmentAggregate?: InputMaybe<CycleConfigurationStartingTreatmentAggregateInput>;
  startingTreatmentBrand?: InputMaybe<BrandWhere>;
  startingTreatmentBrandAggregate?: InputMaybe<CycleConfigurationStartingTreatmentBrandAggregateInput>;
  startingTreatmentBrandConnection?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
  startingTreatmentBrandConnection_NOT?: InputMaybe<CycleConfigurationStartingTreatmentBrandConnectionWhere>;
  startingTreatmentBrand_NOT?: InputMaybe<BrandWhere>;
  startingTreatmentConnection?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
  startingTreatmentConnection_NOT?: InputMaybe<CycleConfigurationStartingTreatmentConnectionWhere>;
  startingTreatmentGeneric?: InputMaybe<GenericWhere>;
  startingTreatmentGenericAggregate?: InputMaybe<CycleConfigurationStartingTreatmentGenericAggregateInput>;
  startingTreatmentGenericConnection?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
  startingTreatmentGenericConnection_NOT?: InputMaybe<CycleConfigurationStartingTreatmentGenericConnectionWhere>;
  startingTreatmentGeneric_NOT?: InputMaybe<GenericWhere>;
  startingTreatment_NOT?: InputMaybe<TreatmentWhere>;
  therapiesAggregate?: InputMaybe<CycleConfigurationTherapiesAggregateInput>;
  /** Return CycleConfigurations where all of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_ALL?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where none of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_NONE?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where one of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_SINGLE?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where some of the related CycleConfigurationTherapiesConnections match this filter */
  therapiesConnection_SOME?: InputMaybe<CycleConfigurationTherapiesConnectionWhere>;
  /** Return CycleConfigurations where all of the related CycleTherapyConfigurations match this filter */
  therapies_ALL?: InputMaybe<CycleTherapyConfigurationWhere>;
  /** Return CycleConfigurations where none of the related CycleTherapyConfigurations match this filter */
  therapies_NONE?: InputMaybe<CycleTherapyConfigurationWhere>;
  /** Return CycleConfigurations where one of the related CycleTherapyConfigurations match this filter */
  therapies_SINGLE?: InputMaybe<CycleTherapyConfigurationWhere>;
  /** Return CycleConfigurations where some of the related CycleTherapyConfigurations match this filter */
  therapies_SOME?: InputMaybe<CycleTherapyConfigurationWhere>;
};

export type CycleConfigurationsConnection = {
  __typename?: 'CycleConfigurationsConnection';
  edges: Array<CycleConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum CycleStartingPoint {
  PreviousCycleFirstRecord = 'PREVIOUS_CYCLE_FIRST_RECORD',
  PreviousCycleLastRecord = 'PREVIOUS_CYCLE_LAST_RECORD'
}

export type CycleTherapyConfiguration = {
  __typename?: 'CycleTherapyConfiguration';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cycleToleranceFrom?: Maybe<Scalars['Int']['output']>;
  cycleToleranceTo?: Maybe<Scalars['Int']['output']>;
  dosageFrom?: Maybe<Scalars['Float']['output']>;
  dosageTo?: Maybe<Scalars['Float']['output']>;
  expectedDays?: Maybe<Array<Scalars['Int']['output']>>;
  packQuantityFrom?: Maybe<Scalars['Int']['output']>;
  packQuantityTo?: Maybe<Scalars['Int']['output']>;
  recordGapFrom?: Maybe<Scalars['Int']['output']>;
  recordGapTo?: Maybe<Scalars['Int']['output']>;
  recordQuantityFrom?: Maybe<Scalars['Int']['output']>;
  recordQuantityTo?: Maybe<Scalars['Int']['output']>;
  treatmentSet: TreatmentSet;
  treatmentSetAggregate?: Maybe<CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection>;
  treatmentSetConnection: CycleTherapyConfigurationTreatmentSetConnection;
};


export type CycleTherapyConfigurationTreatmentSetArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type CycleTherapyConfigurationTreatmentSetAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type CycleTherapyConfigurationTreatmentSetConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetConnectionSort>>;
  where?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
};

export type CycleTherapyConfigurationAggregateSelection = {
  __typename?: 'CycleTherapyConfigurationAggregateSelection';
  count: Scalars['Int']['output'];
  cycleToleranceFrom: IntAggregateSelectionNullable;
  cycleToleranceTo: IntAggregateSelectionNullable;
  dosageFrom: FloatAggregateSelectionNullable;
  dosageTo: FloatAggregateSelectionNullable;
  packQuantityFrom: IntAggregateSelectionNullable;
  packQuantityTo: IntAggregateSelectionNullable;
  recordGapFrom: IntAggregateSelectionNullable;
  recordGapTo: IntAggregateSelectionNullable;
  recordQuantityFrom: IntAggregateSelectionNullable;
  recordQuantityTo: IntAggregateSelectionNullable;
};

export type CycleTherapyConfigurationEdge = {
  __typename?: 'CycleTherapyConfigurationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleTherapyConfiguration;
};

export type CycleTherapyConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more CycleTherapyConfigurationSort objects to sort CycleTherapyConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<CycleTherapyConfigurationSort>>;
};

/** Fields to sort CycleTherapyConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one CycleTherapyConfigurationSort object. */
export type CycleTherapyConfigurationSort = {
  cycleToleranceFrom?: InputMaybe<SortDirection>;
  cycleToleranceTo?: InputMaybe<SortDirection>;
  dosageFrom?: InputMaybe<SortDirection>;
  dosageTo?: InputMaybe<SortDirection>;
  packQuantityFrom?: InputMaybe<SortDirection>;
  packQuantityTo?: InputMaybe<SortDirection>;
  recordGapFrom?: InputMaybe<SortDirection>;
  recordGapTo?: InputMaybe<SortDirection>;
  recordQuantityFrom?: InputMaybe<SortDirection>;
  recordQuantityTo?: InputMaybe<SortDirection>;
};

export type CycleTherapyConfigurationTreatmentSetAggregateInput = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetAggregateInput>>;
  NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetAggregateInput>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>;
};

export type CycleTherapyConfigurationTreatmentSetConnection = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetConnection';
  edges: Array<CycleTherapyConfigurationTreatmentSetRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CycleTherapyConfigurationTreatmentSetConnectionSort = {
  node?: InputMaybe<TreatmentSetSort>;
};

export type CycleTherapyConfigurationTreatmentSetConnectionWhere = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetConnectionWhere>>;
  NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetConnectionWhere>>;
  node?: InputMaybe<TreatmentSetWhere>;
};

export type CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>>;
  NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationTreatmentSetNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type CycleTherapyConfigurationTreatmentSetRelationship = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetTreatmentSetAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection>;
};

export type CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection = {
  __typename?: 'CycleTherapyConfigurationTreatmentSetTreatmentSetNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type CycleTherapyConfigurationWhere = {
  AND?: InputMaybe<Array<CycleTherapyConfigurationWhere>>;
  NOT?: InputMaybe<CycleTherapyConfigurationWhere>;
  OR?: InputMaybe<Array<CycleTherapyConfigurationWhere>>;
  cycleToleranceFrom?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleToleranceFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleToleranceTo_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleToleranceTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageFrom?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dosageFrom_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageFrom_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  dosageTo_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageTo_LTE?: InputMaybe<Scalars['Float']['input']>;
  expectedDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  expectedDays_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  packQuantityFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_GT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  packQuantityTo_LT?: InputMaybe<Scalars['Int']['input']>;
  packQuantityTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordGapFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_GT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordGapTo_LT?: InputMaybe<Scalars['Int']['input']>;
  recordGapTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordQuantityFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_GT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordQuantityTo_LT?: InputMaybe<Scalars['Int']['input']>;
  recordQuantityTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatmentSet?: InputMaybe<TreatmentSetWhere>;
  treatmentSetAggregate?: InputMaybe<CycleTherapyConfigurationTreatmentSetAggregateInput>;
  treatmentSetConnection?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
  treatmentSetConnection_NOT?: InputMaybe<CycleTherapyConfigurationTreatmentSetConnectionWhere>;
  treatmentSet_NOT?: InputMaybe<TreatmentSetWhere>;
};

export type CycleTherapyConfigurationsConnection = {
  __typename?: 'CycleTherapyConfigurationsConnection';
  edges: Array<CycleTherapyConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DashboardFieldDetails = {
  __typename?: 'DashboardFieldDetails';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DashboardFieldDetailsAggregateSelection = {
  __typename?: 'DashboardFieldDetailsAggregateSelection';
  agreementCount: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  name: StringAggregateSelectionNullable;
};

export type DashboardFieldDetailsConnection = {
  __typename?: 'DashboardFieldDetailsConnection';
  edges: Array<DashboardFieldDetailsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DashboardFieldDetailsEdge = {
  __typename?: 'DashboardFieldDetailsEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DashboardFieldDetails;
};

export type DashboardFieldDetailsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DashboardFieldDetailsSort objects to sort DashboardFieldDetails by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DashboardFieldDetailsSort>>;
};

/** Fields to sort DashboardFieldDetails by. The order in which sorts are applied is not guaranteed when specifying many fields in one DashboardFieldDetailsSort object. */
export type DashboardFieldDetailsSort = {
  agreementCount?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type DashboardFieldDetailsWhere = {
  AND?: InputMaybe<Array<DashboardFieldDetailsWhere>>;
  NOT?: InputMaybe<DashboardFieldDetailsWhere>;
  OR?: InputMaybe<Array<DashboardFieldDetailsWhere>>;
  agreementCount?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  agreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DataContainer = {
  __typename?: 'DataContainer';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  creationWays?: Maybe<Array<DataContainerCreationWay>>;
  entityTypeName: Scalars['String']['output'];
  isStartingPoint?: Maybe<Scalars['Boolean']['output']>;
  providers: Array<Organization>;
  providersAggregate?: Maybe<DataContainerOrganizationProvidersAggregationSelection>;
  providersConnection: DataContainerProvidersConnection;
  restrictedDataPointAttributes?: Maybe<Array<CatalogueAttribute>>;
  restrictedDataPointNames?: Maybe<Array<Scalars['String']['output']>>;
  sharedDataPointAttributes?: Maybe<Array<CatalogueAttribute>>;
  sharedDataPointNames?: Maybe<Array<Scalars['String']['output']>>;
  sharingTrigger: DataContainerSharingTrigger;
  subType: Scalars['String']['output'];
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
  timeframeStartingPoint?: Maybe<TimeframeStartingPoint>;
  type: FlexContainerType;
};


export type DataContainerProvidersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type DataContainerProvidersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type DataContainerProvidersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DataContainerProvidersConnectionSort>>;
  where?: InputMaybe<DataContainerProvidersConnectionWhere>;
};

export type DataContainerAggregateSelection = {
  __typename?: 'DataContainerAggregateSelection';
  count: Scalars['Int']['output'];
  subType: StringAggregateSelectionNonNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
};

export enum DataContainerCreationWay {
  ManualEntry = 'MANUAL_ENTRY',
  Upload = 'UPLOAD'
}

export type DataContainerEdge = {
  __typename?: 'DataContainerEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DataContainer;
};

export type DataContainerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DataContainerSort objects to sort DataContainers by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DataContainerSort>>;
};

export type DataContainerOrganizationProvidersAggregationSelection = {
  __typename?: 'DataContainerOrganizationProvidersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DataContainerOrganizationProvidersNodeAggregateSelection>;
};

export type DataContainerOrganizationProvidersNodeAggregateSelection = {
  __typename?: 'DataContainerOrganizationProvidersNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type DataContainerProvidersAggregateInput = {
  AND?: InputMaybe<Array<DataContainerProvidersAggregateInput>>;
  NOT?: InputMaybe<DataContainerProvidersAggregateInput>;
  OR?: InputMaybe<Array<DataContainerProvidersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DataContainerProvidersNodeAggregationWhereInput>;
};

export type DataContainerProvidersConnection = {
  __typename?: 'DataContainerProvidersConnection';
  edges: Array<DataContainerProvidersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataContainerProvidersConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type DataContainerProvidersConnectionWhere = {
  AND?: InputMaybe<Array<DataContainerProvidersConnectionWhere>>;
  NOT?: InputMaybe<DataContainerProvidersConnectionWhere>;
  OR?: InputMaybe<Array<DataContainerProvidersConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type DataContainerProvidersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DataContainerProvidersNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<DataContainerProvidersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DataContainerProvidersNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DataContainerProvidersRelationship = {
  __typename?: 'DataContainerProvidersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

export enum DataContainerSharingTrigger {
  AgreementInclusion = 'AGREEMENT_INCLUSION',
  InvoiceCreation = 'INVOICE_CREATION',
  Never = 'NEVER'
}

/** Fields to sort DataContainers by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataContainerSort object. */
export type DataContainerSort = {
  entityTypeName?: InputMaybe<SortDirection>;
  isStartingPoint?: InputMaybe<SortDirection>;
  sharingTrigger?: InputMaybe<SortDirection>;
  subType?: InputMaybe<SortDirection>;
  timeframeEnd?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeStart?: InputMaybe<SortDirection>;
  timeframeStartingPoint?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type DataContainerWhere = {
  AND?: InputMaybe<Array<DataContainerWhere>>;
  NOT?: InputMaybe<DataContainerWhere>;
  OR?: InputMaybe<Array<DataContainerWhere>>;
  creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
  creationWays_INCLUDES?: InputMaybe<DataContainerCreationWay>;
  providersAggregate?: InputMaybe<DataContainerProvidersAggregateInput>;
  /** Return DataContainers where all of the related DataContainerProvidersConnections match this filter */
  providersConnection_ALL?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where none of the related DataContainerProvidersConnections match this filter */
  providersConnection_NONE?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where one of the related DataContainerProvidersConnections match this filter */
  providersConnection_SINGLE?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where some of the related DataContainerProvidersConnections match this filter */
  providersConnection_SOME?: InputMaybe<DataContainerProvidersConnectionWhere>;
  /** Return DataContainers where all of the related Organizations match this filter */
  providers_ALL?: InputMaybe<OrganizationWhere>;
  /** Return DataContainers where none of the related Organizations match this filter */
  providers_NONE?: InputMaybe<OrganizationWhere>;
  /** Return DataContainers where one of the related Organizations match this filter */
  providers_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return DataContainers where some of the related Organizations match this filter */
  providers_SOME?: InputMaybe<OrganizationWhere>;
  restrictedDataPointNames?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedDataPointNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sharedDataPointNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedDataPointNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sharingTrigger?: InputMaybe<DataContainerSharingTrigger>;
  sharingTrigger_IN?: InputMaybe<Array<DataContainerSharingTrigger>>;
  subType?: InputMaybe<Scalars['String']['input']>;
  subType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  subType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  subType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  type?: InputMaybe<FlexContainerType>;
  type_IN?: InputMaybe<Array<FlexContainerType>>;
};

export type DataContainersConnection = {
  __typename?: 'DataContainersConnection';
  edges: Array<DataContainerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DataSource = {
  __typename?: 'DataSource';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DataSourceAggregateSelection = {
  __typename?: 'DataSourceAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type DataSourceEdge = {
  __typename?: 'DataSourceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DataSource;
};

export type DataSourceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DataSourceSort objects to sort DataSources by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DataSourceSort>>;
};

/** Fields to sort DataSources by. The order in which sorts are applied is not guaranteed when specifying many fields in one DataSourceSort object. */
export type DataSourceSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type DataSourceWhere = {
  AND?: InputMaybe<Array<DataSourceWhere>>;
  NOT?: InputMaybe<DataSourceWhere>;
  OR?: InputMaybe<Array<DataSourceWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DataSourcesConnection = {
  __typename?: 'DataSourcesConnection';
  edges: Array<DataSourceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum DataSubType {
  Chat = 'CHAT',
  Table = 'TABLE'
}

export enum DataType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT',
  Widget = 'WIDGET'
}

export type DatabaseCleanupJobInfo = {
  __typename?: 'DatabaseCleanupJobInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  completedQuests?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  deletedDataOlderThan: Scalars['DateTime']['output'];
  softDeletedData?: Maybe<Scalars['String']['output']>;
  unexposedViews?: Maybe<Scalars['String']['output']>;
};

export type DatabaseCleanupJobInfoAggregateSelection = {
  __typename?: 'DatabaseCleanupJobInfoAggregateSelection';
  completedQuests: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedDataOlderThan: DateTimeAggregateSelectionNonNullable;
  softDeletedData: StringAggregateSelectionNullable;
  unexposedViews: StringAggregateSelectionNullable;
};

export type DatabaseCleanupJobInfoEdge = {
  __typename?: 'DatabaseCleanupJobInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DatabaseCleanupJobInfo;
};

export type DatabaseCleanupJobInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DatabaseCleanupJobInfoSort objects to sort DatabaseCleanupJobInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DatabaseCleanupJobInfoSort>>;
};

/** Fields to sort DatabaseCleanupJobInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one DatabaseCleanupJobInfoSort object. */
export type DatabaseCleanupJobInfoSort = {
  completedQuests?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  deletedDataOlderThan?: InputMaybe<SortDirection>;
  softDeletedData?: InputMaybe<SortDirection>;
  unexposedViews?: InputMaybe<SortDirection>;
};

export type DatabaseCleanupJobInfoWhere = {
  AND?: InputMaybe<Array<DatabaseCleanupJobInfoWhere>>;
  NOT?: InputMaybe<DatabaseCleanupJobInfoWhere>;
  OR?: InputMaybe<Array<DatabaseCleanupJobInfoWhere>>;
  completedQuests?: InputMaybe<Scalars['String']['input']>;
  completedQuests_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  completedQuests_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  completedQuests_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  completedQuests_MATCHES?: InputMaybe<Scalars['String']['input']>;
  completedQuests_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedDataOlderThan?: InputMaybe<Scalars['DateTime']['input']>;
  deletedDataOlderThan_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedDataOlderThan_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedDataOlderThan_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  deletedDataOlderThan_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedDataOlderThan_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  softDeletedData?: InputMaybe<Scalars['String']['input']>;
  softDeletedData_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  softDeletedData_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  softDeletedData_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  softDeletedData_MATCHES?: InputMaybe<Scalars['String']['input']>;
  softDeletedData_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  unexposedViews?: InputMaybe<Scalars['String']['input']>;
  unexposedViews_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  unexposedViews_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  unexposedViews_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unexposedViews_MATCHES?: InputMaybe<Scalars['String']['input']>;
  unexposedViews_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DatabaseCleanupJobInfosConnection = {
  __typename?: 'DatabaseCleanupJobInfosConnection';
  edges: Array<DatabaseCleanupJobInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DateTimeAggregateSelectionNonNullable = {
  __typename?: 'DateTimeAggregateSelectionNonNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  max: Scalars['DateTime']['output'];
  min: Scalars['DateTime']['output'];
};

export type DateTimeAggregateSelectionNullable = {
  __typename?: 'DateTimeAggregateSelectionNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  max?: Maybe<Scalars['DateTime']['output']>;
  min?: Maybe<Scalars['DateTime']['output']>;
};

export enum Decision {
  Approve = 'APPROVE',
  Reject = 'REJECT'
}

export type DefaultAgreementRoleInfo = {
  __typename?: 'DefaultAgreementRoleInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  caseAssignee?: Maybe<AssigneeStatus>;
  documentAssignee?: Maybe<AssigneeStatus>;
  firstName?: Maybe<Scalars['String']['output']>;
  isAgreementAssignee?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  role: AgreementUserRole;
  tagName: Scalars['String']['output'];
  tagType: AgreementTagType;
  userId: Scalars['String']['output'];
};

export type DefaultAgreementRoleInfoAggregateSelection = {
  __typename?: 'DefaultAgreementRoleInfoAggregateSelection';
  count: Scalars['Int']['output'];
  firstName: StringAggregateSelectionNullable;
  lastName: StringAggregateSelectionNullable;
  tagName: StringAggregateSelectionNonNullable;
  userId: StringAggregateSelectionNonNullable;
};

export type DefaultAgreementRoleInfoEdge = {
  __typename?: 'DefaultAgreementRoleInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DefaultAgreementRoleInfo;
};

export type DefaultAgreementRoleInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DefaultAgreementRoleInfoSort objects to sort DefaultAgreementRoleInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DefaultAgreementRoleInfoSort>>;
};

/** Fields to sort DefaultAgreementRoleInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one DefaultAgreementRoleInfoSort object. */
export type DefaultAgreementRoleInfoSort = {
  caseAssignee?: InputMaybe<SortDirection>;
  documentAssignee?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  isAgreementAssignee?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  tagName?: InputMaybe<SortDirection>;
  tagType?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type DefaultAgreementRoleInfoWhere = {
  AND?: InputMaybe<Array<DefaultAgreementRoleInfoWhere>>;
  NOT?: InputMaybe<DefaultAgreementRoleInfoWhere>;
  OR?: InputMaybe<Array<DefaultAgreementRoleInfoWhere>>;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  caseAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee_IN?: InputMaybe<Array<InputMaybe<AssigneeStatus>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isAgreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
  tagName?: InputMaybe<Scalars['String']['input']>;
  tagName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tagName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tagName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tagName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<AgreementTagType>;
  tagType_IN?: InputMaybe<Array<AgreementTagType>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DefaultAgreementRoleInfosConnection = {
  __typename?: 'DefaultAgreementRoleInfosConnection';
  edges: Array<DefaultAgreementRoleInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DefaultReceiverProperties = {
  email: Scalars['String']['output'];
  notificationId: Scalars['Int']['output'];
  tagType: AgreementTagType;
};

export type DefaultReceiverPropertiesSort = {
  email?: InputMaybe<SortDirection>;
  notificationId?: InputMaybe<SortDirection>;
  tagType?: InputMaybe<SortDirection>;
};

export type DefaultReceiverPropertiesWhere = {
  AND?: InputMaybe<Array<DefaultReceiverPropertiesWhere>>;
  NOT?: InputMaybe<DefaultReceiverPropertiesWhere>;
  OR?: InputMaybe<Array<DefaultReceiverPropertiesWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  notificationId_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  notificationId_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_LTE?: InputMaybe<Scalars['Int']['input']>;
  tagType?: InputMaybe<AgreementTagType>;
  tagType_IN?: InputMaybe<Array<AgreementTagType>>;
};

export type DefaultUserRoleUpdateInput = {
  agreementAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  agreementTag: AgreementTagType;
  caseAssignee?: InputMaybe<AssigneeStatus>;
  documentAssignee?: InputMaybe<AssigneeStatus>;
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
};

export type DeleteThreadMessageInput = {
  createdOn: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  nodeLabel: SupportedMessageNodes;
};

export enum DeltaType {
  Any = 'ANY',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type DependencyAttribute = {
  comment?: Maybe<Scalars['String']['output']>;
  rules?: Maybe<Scalars['String']['output']>;
};

export type DependencyAttributeSort = {
  comment?: InputMaybe<SortDirection>;
  rules?: InputMaybe<SortDirection>;
};

export type DependencyAttributeWhere = {
  AND?: InputMaybe<Array<DependencyAttributeWhere>>;
  NOT?: InputMaybe<DependencyAttributeWhere>;
  OR?: InputMaybe<Array<DependencyAttributeWhere>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment_MATCHES?: InputMaybe<Scalars['String']['input']>;
  comment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Scalars['String']['input']>;
  rules_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rules_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rules_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rules_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rules_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceAlternative = {
  __typename?: 'DeviceAlternative';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  alternatives: Array<Treatment>;
  alternativesAggregate?: Maybe<DeviceAlternativeTreatmentAlternativesAggregationSelection>;
  alternativesConnection: DeviceAlternativeAlternativesConnection;
  code: Scalars['String']['output'];
  deviceProduct: Treatment;
  deviceProductAggregate?: Maybe<DeviceAlternativeTreatmentDeviceProductAggregationSelection>;
  deviceProductConnection: DeviceAlternativeDeviceProductConnection;
};


export type DeviceAlternativeAlternativesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeAlternativesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeAlternativesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionSort>>;
  where?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
};


export type DeviceAlternativeDeviceProductArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeDeviceProductAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type DeviceAlternativeDeviceProductConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionSort>>;
  where?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
};

export type DeviceAlternativeAggregateSelection = {
  __typename?: 'DeviceAlternativeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
};

export type DeviceAlternativeAlternativesAggregateInput = {
  AND?: InputMaybe<Array<DeviceAlternativeAlternativesAggregateInput>>;
  NOT?: InputMaybe<DeviceAlternativeAlternativesAggregateInput>;
  OR?: InputMaybe<Array<DeviceAlternativeAlternativesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DeviceAlternativeAlternativesNodeAggregationWhereInput>;
};

export type DeviceAlternativeAlternativesConnection = {
  __typename?: 'DeviceAlternativeAlternativesConnection';
  edges: Array<DeviceAlternativeAlternativesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceAlternativeAlternativesConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type DeviceAlternativeAlternativesConnectionWhere = {
  AND?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionWhere>>;
  NOT?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  OR?: InputMaybe<Array<DeviceAlternativeAlternativesConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeAlternativesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DeviceAlternativeAlternativesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<DeviceAlternativeAlternativesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<DeviceAlternativeAlternativesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceAlternativeAlternativesRelationship = {
  __typename?: 'DeviceAlternativeAlternativesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type DeviceAlternativeDeviceProductAggregateInput = {
  AND?: InputMaybe<Array<DeviceAlternativeDeviceProductAggregateInput>>;
  NOT?: InputMaybe<DeviceAlternativeDeviceProductAggregateInput>;
  OR?: InputMaybe<Array<DeviceAlternativeDeviceProductAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DeviceAlternativeDeviceProductNodeAggregationWhereInput>;
};

export type DeviceAlternativeDeviceProductConnection = {
  __typename?: 'DeviceAlternativeDeviceProductConnection';
  edges: Array<DeviceAlternativeDeviceProductRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceAlternativeDeviceProductConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type DeviceAlternativeDeviceProductConnectionWhere = {
  AND?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionWhere>>;
  NOT?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
  OR?: InputMaybe<Array<DeviceAlternativeDeviceProductConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativeDeviceProductNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DeviceAlternativeDeviceProductNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<DeviceAlternativeDeviceProductNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<DeviceAlternativeDeviceProductNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DeviceAlternativeDeviceProductRelationship = {
  __typename?: 'DeviceAlternativeDeviceProductRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type DeviceAlternativeEdge = {
  __typename?: 'DeviceAlternativeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DeviceAlternative;
};

export type DeviceAlternativeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DeviceAlternativeSort objects to sort DeviceAlternatives by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DeviceAlternativeSort>>;
};

/** Fields to sort DeviceAlternatives by. The order in which sorts are applied is not guaranteed when specifying many fields in one DeviceAlternativeSort object. */
export type DeviceAlternativeSort = {
  code?: InputMaybe<SortDirection>;
};

export type DeviceAlternativeTreatmentAlternativesAggregationSelection = {
  __typename?: 'DeviceAlternativeTreatmentAlternativesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DeviceAlternativeTreatmentAlternativesNodeAggregateSelection>;
};

export type DeviceAlternativeTreatmentAlternativesNodeAggregateSelection = {
  __typename?: 'DeviceAlternativeTreatmentAlternativesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type DeviceAlternativeTreatmentDeviceProductAggregationSelection = {
  __typename?: 'DeviceAlternativeTreatmentDeviceProductAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection>;
};

export type DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection = {
  __typename?: 'DeviceAlternativeTreatmentDeviceProductNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type DeviceAlternativeWhere = {
  AND?: InputMaybe<Array<DeviceAlternativeWhere>>;
  NOT?: InputMaybe<DeviceAlternativeWhere>;
  OR?: InputMaybe<Array<DeviceAlternativeWhere>>;
  alternativesAggregate?: InputMaybe<DeviceAlternativeAlternativesAggregateInput>;
  /** Return DeviceAlternatives where all of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_ALL?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where none of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_NONE?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where one of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_SINGLE?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where some of the related DeviceAlternativeAlternativesConnections match this filter */
  alternativesConnection_SOME?: InputMaybe<DeviceAlternativeAlternativesConnectionWhere>;
  /** Return DeviceAlternatives where all of the related Treatments match this filter */
  alternatives_ALL?: InputMaybe<TreatmentWhere>;
  /** Return DeviceAlternatives where none of the related Treatments match this filter */
  alternatives_NONE?: InputMaybe<TreatmentWhere>;
  /** Return DeviceAlternatives where one of the related Treatments match this filter */
  alternatives_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return DeviceAlternatives where some of the related Treatments match this filter */
  alternatives_SOME?: InputMaybe<TreatmentWhere>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deviceProduct?: InputMaybe<TreatmentWhere>;
  deviceProductAggregate?: InputMaybe<DeviceAlternativeDeviceProductAggregateInput>;
  deviceProductConnection?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
  deviceProductConnection_NOT?: InputMaybe<DeviceAlternativeDeviceProductConnectionWhere>;
  deviceProduct_NOT?: InputMaybe<TreatmentWhere>;
};

export type DeviceAlternativesConnection = {
  __typename?: 'DeviceAlternativesConnection';
  edges: Array<DeviceAlternativeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Disease = {
  __typename?: 'Disease';
  Icd10Code: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  therapeuticArea?: Maybe<Scalars['String']['output']>;
};

export type DiseaseAggregateSelection = {
  __typename?: 'DiseaseAggregateSelection';
  Icd10Code: StringAggregateSelectionNonNullable;
  Name: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
  therapeuticArea: StringAggregateSelectionNullable;
};

export type DiseaseEdge = {
  __typename?: 'DiseaseEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Disease;
};

export type DiseaseFilterData = {
  __typename?: 'DiseaseFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  indications: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DiseaseFilterDataAggregateSelection = {
  __typename?: 'DiseaseFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelectionNonNullable;
};

export type DiseaseFilterDataConnection = {
  __typename?: 'DiseaseFilterDataConnection';
  edges: Array<DiseaseFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DiseaseFilterDataEdge = {
  __typename?: 'DiseaseFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DiseaseFilterData;
};

export type DiseaseFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DiseaseFilterDataSort objects to sort DiseaseFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DiseaseFilterDataSort>>;
};

/** Fields to sort DiseaseFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one DiseaseFilterDataSort object. */
export type DiseaseFilterDataSort = {
  name?: InputMaybe<SortDirection>;
};

export type DiseaseFilterDataWhere = {
  AND?: InputMaybe<Array<DiseaseFilterDataWhere>>;
  NOT?: InputMaybe<DiseaseFilterDataWhere>;
  OR?: InputMaybe<Array<DiseaseFilterDataWhere>>;
  indications?: InputMaybe<Array<Scalars['String']['input']>>;
  indications_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DiseaseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DiseaseSort objects to sort Diseases by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DiseaseSort>>;
};

/** Fields to sort Diseases by. The order in which sorts are applied is not guaranteed when specifying many fields in one DiseaseSort object. */
export type DiseaseSort = {
  Icd10Code?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  therapeuticArea?: InputMaybe<SortDirection>;
};

export type DiseaseWhere = {
  AND?: InputMaybe<Array<DiseaseWhere>>;
  Icd10Code?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Icd10Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Icd10Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<DiseaseWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<DiseaseWhere>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  therapeuticArea_MATCHES?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DiseasesConnection = {
  __typename?: 'DiseasesConnection';
  edges: Array<DiseaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Document = {
  __typename?: 'Document';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedTransactionsInfo: Array<AddedTransactionsInfo>;
  addedTransactionsInfoAggregate?: Maybe<DocumentAddedTransactionsInfoAddedTransactionsInfoAggregationSelection>;
  addedTransactionsInfoConnection: DocumentAddedTransactionsInfoConnection;
  adjustedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  agreementBuyerInvoiceInfo?: Maybe<Organization>;
  agreementIds: Array<Scalars['String']['output']>;
  agreementSellerInvoiceInfo?: Maybe<Organization>;
  agreementsWithOnlyViewingFullAccess: Array<BaseAgreement>;
  agreementsWithoutUserAccess: Array<BaseAgreement>;
  approvedBy: Array<User>;
  approvedByAggregate?: Maybe<DocumentUserApprovedByAggregationSelection>;
  approvedByConnection: DocumentApprovedByConnection;
  areExportValuesSaved?: Maybe<Scalars['Boolean']['output']>;
  assignedTo: Array<User>;
  assignedToAggregate?: Maybe<DocumentUserAssignedToAggregationSelection>;
  assignedToConnection: DocumentAssignedToConnection;
  baseAgreements: Array<BaseAgreement>;
  beneficiary?: Maybe<DocumentBeneficiary>;
  canApprove?: Maybe<Scalars['Boolean']['output']>;
  canAssignUser?: Maybe<Scalars['Boolean']['output']>;
  canBeSentToSmartMip?: Maybe<Scalars['Boolean']['output']>;
  canConfirm?: Maybe<Scalars['Boolean']['output']>;
  canUserDelete: Scalars['Boolean']['output'];
  confirmedBy: Array<User>;
  confirmedByAggregate?: Maybe<DocumentUserConfirmedByAggregationSelection>;
  confirmedByConnection: DocumentConfirmedByConnection;
  counterParties?: Maybe<Scalars['String']['output']>;
  coveragePeriod?: Maybe<Scalars['String']['output']>;
  coveragePeriodEnd?: Maybe<Scalars['Date']['output']>;
  coveragePeriodStart?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<DocumentUserCreatedByAggregationSelection>;
  createdByConnection: DocumentCreatedByConnection;
  createdByEmail: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  creationMethod?: Maybe<DocumentCreationMethod>;
  creatorOrgName?: Maybe<Scalars['String']['output']>;
  creatorTenantId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currentReviewerOrganization?: Maybe<Scalars['String']['output']>;
  documentReceiverBillingAddress?: Maybe<Scalars['String']['output']>;
  documentReceiverDetails?: Maybe<Scalars['String']['output']>;
  documentReceiverLegalName?: Maybe<Scalars['String']['output']>;
  documentRefundGroups: Array<DocumentRefundGroup>;
  documentRefundGroupsAggregate?: Maybe<DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection>;
  documentRefundGroupsConnection: DocumentDocumentRefundGroupsConnection;
  documentSenderContactEmail?: Maybe<Scalars['String']['output']>;
  documentSenderContactFirstName?: Maybe<Scalars['String']['output']>;
  documentSenderContactLastName?: Maybe<Scalars['String']['output']>;
  documentSenderContactPhone?: Maybe<Scalars['String']['output']>;
  documentSenderDomicile?: Maybe<Scalars['String']['output']>;
  documentSenderFax?: Maybe<Scalars['String']['output']>;
  documentSenderPhone?: Maybe<Scalars['String']['output']>;
  dunningDate?: Maybe<Scalars['Date']['output']>;
  exposureLog?: Maybe<Scalars['String']['output']>;
  formattedTags: Scalars['String']['output'];
  hasAdjustedTransactions: Scalars['Boolean']['output'];
  hasCaselessTransactions: Scalars['Boolean']['output'];
  hasPatientTransactions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceAmount?: Maybe<Scalars['Float']['output']>;
  isAgreementBuyer?: Maybe<Scalars['Boolean']['output']>;
  isAgreementOwner?: Maybe<Scalars['Boolean']['output']>;
  isAgreementSeller?: Maybe<Scalars['Boolean']['output']>;
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  isCommentRequierd?: Maybe<Scalars['Boolean']['output']>;
  isConfirmedByBuyer?: Maybe<Scalars['Boolean']['output']>;
  isConfirmedByExternalParty?: Maybe<Scalars['Boolean']['output']>;
  isConfirmedBySeller?: Maybe<Scalars['Boolean']['output']>;
  isConfirmedBySender?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isSentForExternalReview?: Maybe<Scalars['Boolean']['output']>;
  isSentToSmartMip?: Maybe<Scalars['Boolean']['output']>;
  issuedOn?: Maybe<Scalars['DateTime']['output']>;
  lastChangedOn?: Maybe<Scalars['DateTime']['output']>;
  lastRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  lastSentForSmartMipReview?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  messages: Array<DocumentMessage>;
  messagesAggregate?: Maybe<DocumentDocumentMessageMessagesAggregationSelection>;
  messagesConnection: DocumentMessagesConnection;
  orderNo?: Maybe<Scalars['String']['output']>;
  paymentReceiptPayer?: Maybe<Scalars['Date']['output']>;
  paymentReferenceLyfegen?: Maybe<Scalars['String']['output']>;
  paymentReminderEmail?: Maybe<Scalars['String']['output']>;
  periodDateType?: Maybe<DocumentPeriodDateType>;
  product: Scalars['String']['output'];
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<DocumentRefundRefundsAggregationSelection>;
  refundsConnection: DocumentRefundsConnection;
  rejectedBy: Array<User>;
  rejectedByAggregate?: Maybe<DocumentUserRejectedByAggregationSelection>;
  rejectedByConnection: DocumentRejectedByConnection;
  reviewRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  senderLegalName?: Maybe<Scalars['String']['output']>;
  sentToReviewOn?: Maybe<Scalars['DateTime']['output']>;
  settledOn?: Maybe<Scalars['Date']['output']>;
  smartMipInvoiceFileId?: Maybe<Scalars['String']['output']>;
  smartMipInvoiceId?: Maybe<Scalars['String']['output']>;
  smartMipReimbursementId?: Maybe<Scalars['String']['output']>;
  smartMipStatus?: Maybe<SmartMipDocumentStatus>;
  status?: Maybe<DocumentStatus>;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<DocumentAgreementTagTagsAggregationSelection>;
  tagsConnection: DocumentTagsConnection;
  tenantIds: Array<Scalars['String']['output']>;
  type?: Maybe<DocumentType>;
  uploadedOn?: Maybe<Scalars['DateTime']['output']>;
  uploadedVariantKey?: Maybe<Scalars['String']['output']>;
};


export type DocumentAddedTransactionsInfoArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AddedTransactionsInfoOptions>;
  where?: InputMaybe<AddedTransactionsInfoWhere>;
};


export type DocumentAddedTransactionsInfoAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AddedTransactionsInfoWhere>;
};


export type DocumentAddedTransactionsInfoConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentAddedTransactionsInfoConnectionSort>>;
  where?: InputMaybe<DocumentAddedTransactionsInfoConnectionWhere>;
};


export type DocumentApprovedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentApprovedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentApprovedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentApprovedByConnectionSort>>;
  where?: InputMaybe<DocumentApprovedByConnectionWhere>;
};


export type DocumentAssignedToArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentAssignedToAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentAssignedToConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentAssignedToConnectionSort>>;
  where?: InputMaybe<DocumentAssignedToConnectionWhere>;
};


export type DocumentConfirmedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentConfirmedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentConfirmedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentConfirmedByConnectionSort>>;
  where?: InputMaybe<DocumentConfirmedByConnectionWhere>;
};


export type DocumentCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentCreatedByConnectionSort>>;
  where?: InputMaybe<DocumentCreatedByConnectionWhere>;
};


export type DocumentDocumentRefundGroupsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentRefundGroupOptions>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type DocumentDocumentRefundGroupsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type DocumentDocumentRefundGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentDocumentRefundGroupsConnectionSort>>;
  where?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
};


export type DocumentMessagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentMessageOptions>;
  where?: InputMaybe<DocumentMessageWhere>;
};


export type DocumentMessagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentMessageWhere>;
};


export type DocumentMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessagesConnectionSort>>;
  where?: InputMaybe<DocumentMessagesConnectionWhere>;
};


export type DocumentRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundsConnectionSort>>;
  where?: InputMaybe<DocumentRefundsConnectionWhere>;
};


export type DocumentRejectedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentRejectedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentRejectedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRejectedByConnectionSort>>;
  where?: InputMaybe<DocumentRejectedByConnectionWhere>;
};


export type DocumentTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type DocumentTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type DocumentTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentTagsConnectionSort>>;
  where?: InputMaybe<DocumentTagsConnectionWhere>;
};

export type DocumentAddedTransactionsInfoAddedTransactionsInfoAggregationSelection = {
  __typename?: 'DocumentAddedTransactionsInfoAddedTransactionsInfoAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentAddedTransactionsInfoAddedTransactionsInfoNodeAggregateSelection>;
};

export type DocumentAddedTransactionsInfoAddedTransactionsInfoNodeAggregateSelection = {
  __typename?: 'DocumentAddedTransactionsInfoAddedTransactionsInfoNodeAggregateSelection';
  addedByEmail: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNullable;
};

export type DocumentAddedTransactionsInfoAggregateInput = {
  AND?: InputMaybe<Array<DocumentAddedTransactionsInfoAggregateInput>>;
  NOT?: InputMaybe<DocumentAddedTransactionsInfoAggregateInput>;
  OR?: InputMaybe<Array<DocumentAddedTransactionsInfoAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentAddedTransactionsInfoNodeAggregationWhereInput>;
};

export type DocumentAddedTransactionsInfoConnection = {
  __typename?: 'DocumentAddedTransactionsInfoConnection';
  edges: Array<DocumentAddedTransactionsInfoRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentAddedTransactionsInfoConnectionSort = {
  node?: InputMaybe<AddedTransactionsInfoSort>;
};

export type DocumentAddedTransactionsInfoConnectionWhere = {
  AND?: InputMaybe<Array<DocumentAddedTransactionsInfoConnectionWhere>>;
  NOT?: InputMaybe<DocumentAddedTransactionsInfoConnectionWhere>;
  OR?: InputMaybe<Array<DocumentAddedTransactionsInfoConnectionWhere>>;
  node?: InputMaybe<AddedTransactionsInfoWhere>;
};

export type DocumentAddedTransactionsInfoNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentAddedTransactionsInfoNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentAddedTransactionsInfoNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentAddedTransactionsInfoNodeAggregationWhereInput>>;
  addedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentAddedTransactionsInfoRelationship = {
  __typename?: 'DocumentAddedTransactionsInfoRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AddedTransactionsInfo;
};

export type DocumentAggregateSelection = {
  __typename?: 'DocumentAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  creatorOrgName: StringAggregateSelectionNullable;
  creatorTenantId: StringAggregateSelectionNonNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  exposureLog: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastChangedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  lastSentForSmartMipReview: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  orderNo: StringAggregateSelectionNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  paymentReminderEmail: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipInvoiceFileId: StringAggregateSelectionNullable;
  smartMipInvoiceId: StringAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type DocumentAgreementTagTagsAggregationSelection = {
  __typename?: 'DocumentAgreementTagTagsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentAgreementTagTagsNodeAggregateSelection>;
};

export type DocumentAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'DocumentAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type DocumentApprovalUsersInfo = {
  __typename?: 'DocumentApprovalUsersInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  approverRole?: Maybe<InvoiceApprovalRole>;
  department?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type DocumentApprovalUsersInfoAggregateSelection = {
  __typename?: 'DocumentApprovalUsersInfoAggregateSelection';
  count: Scalars['Int']['output'];
  department: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNullable;
  lastName: StringAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  signature: StringAggregateSelectionNullable;
};

export type DocumentApprovalUsersInfoEdge = {
  __typename?: 'DocumentApprovalUsersInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentApprovalUsersInfo;
};

export type DocumentApprovalUsersInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentApprovalUsersInfoSort objects to sort DocumentApprovalUsersInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentApprovalUsersInfoSort>>;
};

/** Fields to sort DocumentApprovalUsersInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentApprovalUsersInfoSort object. */
export type DocumentApprovalUsersInfoSort = {
  approverRole?: InputMaybe<SortDirection>;
  department?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  signature?: InputMaybe<SortDirection>;
};

export type DocumentApprovalUsersInfoWhere = {
  AND?: InputMaybe<Array<DocumentApprovalUsersInfoWhere>>;
  NOT?: InputMaybe<DocumentApprovalUsersInfoWhere>;
  OR?: InputMaybe<Array<DocumentApprovalUsersInfoWhere>>;
  approverRole?: InputMaybe<InvoiceApprovalRole>;
  approverRole_IN?: InputMaybe<Array<InputMaybe<InvoiceApprovalRole>>>;
  department?: InputMaybe<Scalars['String']['input']>;
  department_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  department_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  department_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  department_MATCHES?: InputMaybe<Scalars['String']['input']>;
  department_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  position_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position_MATCHES?: InputMaybe<Scalars['String']['input']>;
  position_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signature_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  signature_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  signature_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signature_MATCHES?: InputMaybe<Scalars['String']['input']>;
  signature_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentApprovalUsersInfosConnection = {
  __typename?: 'DocumentApprovalUsersInfosConnection';
  edges: Array<DocumentApprovalUsersInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentApprovedByAggregateInput = {
  AND?: InputMaybe<Array<DocumentApprovedByAggregateInput>>;
  NOT?: InputMaybe<DocumentApprovedByAggregateInput>;
  OR?: InputMaybe<Array<DocumentApprovedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentApprovedByNodeAggregationWhereInput>;
};

export type DocumentApprovedByConnection = {
  __typename?: 'DocumentApprovedByConnection';
  edges: Array<DocumentApprovedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentApprovedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentApprovedByConnectionWhere = {
  AND?: InputMaybe<Array<DocumentApprovedByConnectionWhere>>;
  NOT?: InputMaybe<DocumentApprovedByConnectionWhere>;
  OR?: InputMaybe<Array<DocumentApprovedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentApprovedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentApprovedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentApprovedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentApprovedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentApprovedByRelationship = {
  __typename?: 'DocumentApprovedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DocumentAssignedToAggregateInput = {
  AND?: InputMaybe<Array<DocumentAssignedToAggregateInput>>;
  NOT?: InputMaybe<DocumentAssignedToAggregateInput>;
  OR?: InputMaybe<Array<DocumentAssignedToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentAssignedToNodeAggregationWhereInput>;
};

export type DocumentAssignedToConnection = {
  __typename?: 'DocumentAssignedToConnection';
  edges: Array<DocumentAssignedToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentAssignedToConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentAssignedToConnectionWhere = {
  AND?: InputMaybe<Array<DocumentAssignedToConnectionWhere>>;
  NOT?: InputMaybe<DocumentAssignedToConnectionWhere>;
  OR?: InputMaybe<Array<DocumentAssignedToConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentAssignedToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentAssignedToNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentAssignedToNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentAssignedToNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAssignedToRelationship = {
  __typename?: 'DocumentAssignedToRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DocumentAttachmentProgressEvent = {
  __typename?: 'DocumentAttachmentProgressEvent';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  attachmentFileNames?: Maybe<Array<Scalars['String']['output']>>;
  messageId: Scalars['ID']['output'];
  stage: AttachmentProgressStage;
  virusFoundInFiles?: Maybe<Array<Scalars['String']['output']>>;
};

export type DocumentAttachmentProgressEventAggregateSelection = {
  __typename?: 'DocumentAttachmentProgressEventAggregateSelection';
  count: Scalars['Int']['output'];
  messageId: IdAggregateSelectionNonNullable;
};

export type DocumentAttachmentProgressEventEdge = {
  __typename?: 'DocumentAttachmentProgressEventEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentAttachmentProgressEvent;
};

export type DocumentAttachmentProgressEventOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentAttachmentProgressEventSort objects to sort DocumentAttachmentProgressEvents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentAttachmentProgressEventSort>>;
};

/** Fields to sort DocumentAttachmentProgressEvents by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentAttachmentProgressEventSort object. */
export type DocumentAttachmentProgressEventSort = {
  messageId?: InputMaybe<SortDirection>;
  stage?: InputMaybe<SortDirection>;
};

export type DocumentAttachmentProgressEventWhere = {
  AND?: InputMaybe<Array<DocumentAttachmentProgressEventWhere>>;
  NOT?: InputMaybe<DocumentAttachmentProgressEventWhere>;
  OR?: InputMaybe<Array<DocumentAttachmentProgressEventWhere>>;
  attachmentFileNames?: InputMaybe<Array<Scalars['String']['input']>>;
  attachmentFileNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  messageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  messageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  messageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<AttachmentProgressStage>;
  stage_IN?: InputMaybe<Array<AttachmentProgressStage>>;
  virusFoundInFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  virusFoundInFiles_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentAttachmentProgressEventsConnection = {
  __typename?: 'DocumentAttachmentProgressEventsConnection';
  edges: Array<DocumentAttachmentProgressEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum DocumentBeneficiary {
  Lyfegen = 'Lyfegen',
  Payer = 'Payer'
}

export type DocumentConfirmedByAggregateInput = {
  AND?: InputMaybe<Array<DocumentConfirmedByAggregateInput>>;
  NOT?: InputMaybe<DocumentConfirmedByAggregateInput>;
  OR?: InputMaybe<Array<DocumentConfirmedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentConfirmedByNodeAggregationWhereInput>;
};

export type DocumentConfirmedByConnection = {
  __typename?: 'DocumentConfirmedByConnection';
  edges: Array<DocumentConfirmedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentConfirmedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentConfirmedByConnectionWhere = {
  AND?: InputMaybe<Array<DocumentConfirmedByConnectionWhere>>;
  NOT?: InputMaybe<DocumentConfirmedByConnectionWhere>;
  OR?: InputMaybe<Array<DocumentConfirmedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentConfirmedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentConfirmedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentConfirmedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentConfirmedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentConfirmedByRelationship = {
  __typename?: 'DocumentConfirmedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DocumentCreatedByAggregateInput = {
  AND?: InputMaybe<Array<DocumentCreatedByAggregateInput>>;
  NOT?: InputMaybe<DocumentCreatedByAggregateInput>;
  OR?: InputMaybe<Array<DocumentCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentCreatedByNodeAggregationWhereInput>;
};

export type DocumentCreatedByConnection = {
  __typename?: 'DocumentCreatedByConnection';
  edges: Array<DocumentCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<DocumentCreatedByConnectionWhere>>;
  NOT?: InputMaybe<DocumentCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<DocumentCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentCreatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentCreatedByRelationship = {
  __typename?: 'DocumentCreatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export enum DocumentCreationMethod {
  FromXlsxFile = 'FROM_XLSX_FILE',
  Manually = 'MANUALLY'
}

export type DocumentDocumentMessageMessagesAggregationSelection = {
  __typename?: 'DocumentDocumentMessageMessagesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentDocumentMessageMessagesNodeAggregateSelection>;
};

export type DocumentDocumentMessageMessagesNodeAggregateSelection = {
  __typename?: 'DocumentDocumentMessageMessagesNodeAggregateSelection';
  content: StringAggregateSelectionNonNullable;
  createdOn: FloatAggregateSelectionNonNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  externalMessageId: IntAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  resolvedOn: DateTimeAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  systemMessageName: StringAggregateSelectionNullable;
};

export type DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection = {
  __typename?: 'DocumentDocumentRefundGroupDocumentRefundGroupsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection>;
};

export type DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection = {
  __typename?: 'DocumentDocumentRefundGroupDocumentRefundGroupsNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type DocumentDocumentRefundGroupsAggregateInput = {
  AND?: InputMaybe<Array<DocumentDocumentRefundGroupsAggregateInput>>;
  NOT?: InputMaybe<DocumentDocumentRefundGroupsAggregateInput>;
  OR?: InputMaybe<Array<DocumentDocumentRefundGroupsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentDocumentRefundGroupsNodeAggregationWhereInput>;
};

export type DocumentDocumentRefundGroupsConnection = {
  __typename?: 'DocumentDocumentRefundGroupsConnection';
  edges: Array<DocumentDocumentRefundGroupsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentDocumentRefundGroupsConnectionSort = {
  node?: InputMaybe<DocumentRefundGroupSort>;
};

export type DocumentDocumentRefundGroupsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentDocumentRefundGroupsConnectionWhere>>;
  NOT?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentDocumentRefundGroupsConnectionWhere>>;
  node?: InputMaybe<DocumentRefundGroupWhere>;
};

export type DocumentDocumentRefundGroupsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentDocumentRefundGroupsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentDocumentRefundGroupsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentDocumentRefundGroupsNodeAggregationWhereInput>>;
};

export type DocumentDocumentRefundGroupsRelationship = {
  __typename?: 'DocumentDocumentRefundGroupsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentRefundGroup;
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentExportFieldDefaults = {
  __typename?: 'DocumentExportFieldDefaults';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  documentReceiverBillingAddress?: Maybe<Scalars['String']['output']>;
  documentReceiverDetails?: Maybe<Scalars['String']['output']>;
  documentReceiverLegalName?: Maybe<Scalars['String']['output']>;
  documentSenderContactEmail?: Maybe<Scalars['String']['output']>;
  documentSenderContactFirstName?: Maybe<Scalars['String']['output']>;
  documentSenderContactLastName?: Maybe<Scalars['String']['output']>;
  documentSenderContactPhone?: Maybe<Scalars['String']['output']>;
  documentSenderDomicile?: Maybe<Scalars['String']['output']>;
  documentSenderFax?: Maybe<Scalars['String']['output']>;
  documentSenderPhone?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  lastExportDate: Scalars['DateTime']['output'];
  orderNo?: Maybe<Scalars['String']['output']>;
  senderLegalName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type DocumentExportFieldDefaultsAggregateSelection = {
  __typename?: 'DocumentExportFieldDefaultsAggregateSelection';
  count: Scalars['Int']['output'];
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  key: StringAggregateSelectionNonNullable;
  lastExportDate: DateTimeAggregateSelectionNonNullable;
  orderNo: StringAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  tenantId: IdAggregateSelectionNonNullable;
};

export type DocumentExportFieldDefaultsConnection = {
  __typename?: 'DocumentExportFieldDefaultsConnection';
  edges: Array<DocumentExportFieldDefaultsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentExportFieldDefaultsEdge = {
  __typename?: 'DocumentExportFieldDefaultsEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentExportFieldDefaults;
};

export type DocumentExportFieldDefaultsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentExportFieldDefaultsSort objects to sort DocumentExportFieldDefaults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentExportFieldDefaultsSort>>;
};

/** Fields to sort DocumentExportFieldDefaults by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentExportFieldDefaultsSort object. */
export type DocumentExportFieldDefaultsSort = {
  documentReceiverBillingAddress?: InputMaybe<SortDirection>;
  documentReceiverDetails?: InputMaybe<SortDirection>;
  documentReceiverLegalName?: InputMaybe<SortDirection>;
  documentSenderContactEmail?: InputMaybe<SortDirection>;
  documentSenderContactFirstName?: InputMaybe<SortDirection>;
  documentSenderContactLastName?: InputMaybe<SortDirection>;
  documentSenderContactPhone?: InputMaybe<SortDirection>;
  documentSenderDomicile?: InputMaybe<SortDirection>;
  documentSenderFax?: InputMaybe<SortDirection>;
  documentSenderPhone?: InputMaybe<SortDirection>;
  key?: InputMaybe<SortDirection>;
  lastExportDate?: InputMaybe<SortDirection>;
  orderNo?: InputMaybe<SortDirection>;
  senderLegalName?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type DocumentExportFieldDefaultsWhere = {
  AND?: InputMaybe<Array<DocumentExportFieldDefaultsWhere>>;
  NOT?: InputMaybe<DocumentExportFieldDefaultsWhere>;
  OR?: InputMaybe<Array<DocumentExportFieldDefaultsWhere>>;
  documentReceiverBillingAddress?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReceiverBillingAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReceiverDetails_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReceiverLegalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactFirstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactLastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactPhone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderDomicile_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderFax_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderPhone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastExportDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastExportDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExportDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExportDate_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastExportDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExportDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  orderNo?: InputMaybe<Scalars['String']['input']>;
  orderNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  orderNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  orderNo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderNo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  orderNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  senderLegalName?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  senderLegalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentExportFieldsInput = {
  documentReceiverBillingAddress?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  orderNo?: InputMaybe<Scalars['String']['input']>;
  senderLegalName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMessage = {
  __typename?: 'DocumentMessage';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreements: Array<BaseAgreement>;
  agreementsAggregate?: Maybe<DocumentMessageBaseAgreementAgreementsAggregationSelection>;
  agreementsConnection: DocumentMessageAgreementsConnection;
  areFilesCleared?: Maybe<Scalars['Boolean']['output']>;
  attachmentBlobPaths?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachmentContentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attachmentFileNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cases: Array<Case>;
  casesAggregate?: Maybe<DocumentMessageCaseCasesAggregationSelection>;
  casesConnection: DocumentMessageCasesConnection;
  content: Scalars['String']['output'];
  createdOn: Scalars['Float']['output'];
  deletedOn?: Maybe<Scalars['DateTime']['output']>;
  document: Document;
  documentAggregate?: Maybe<DocumentMessageDocumentDocumentAggregationSelection>;
  documentConnection: DocumentMessageDocumentConnection;
  externalMessageId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isAssignment: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  mentions: Array<User>;
  mentionsAggregate?: Maybe<DocumentMessageUserMentionsAggregationSelection>;
  mentionsConnection: DocumentMessageMentionsConnection;
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<DocumentMessageRefundRefundsAggregationSelection>;
  refundsConnection: DocumentMessageRefundsConnection;
  resolvedBy?: Maybe<User>;
  resolvedByAggregate?: Maybe<DocumentMessageUserResolvedByAggregationSelection>;
  resolvedByConnection: DocumentMessageResolvedByConnection;
  resolvedOn?: Maybe<Scalars['DateTime']['output']>;
  sentBy?: Maybe<User>;
  sentByAggregate?: Maybe<DocumentMessageUserSentByAggregationSelection>;
  sentByConnection: DocumentMessageSentByConnection;
  sharingType: DocumentMessageSharingType;
  sourceTenantId: Scalars['String']['output'];
  systemMessageName?: Maybe<Scalars['String']['output']>;
  tenantIds: Array<Scalars['String']['output']>;
};


export type DocumentMessageAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type DocumentMessageAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type DocumentMessageAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageAgreementsConnectionSort>>;
  where?: InputMaybe<DocumentMessageAgreementsConnectionWhere>;
};


export type DocumentMessageCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type DocumentMessageCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type DocumentMessageCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageCasesConnectionSort>>;
  where?: InputMaybe<DocumentMessageCasesConnectionWhere>;
};


export type DocumentMessageDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentMessageDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentMessageDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageDocumentConnectionSort>>;
  where?: InputMaybe<DocumentMessageDocumentConnectionWhere>;
};


export type DocumentMessageMentionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentMessageMentionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentMessageMentionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageMentionsConnectionSort>>;
  where?: InputMaybe<DocumentMessageMentionsConnectionWhere>;
};


export type DocumentMessageRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentMessageRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentMessageRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageRefundsConnectionSort>>;
  where?: InputMaybe<DocumentMessageRefundsConnectionWhere>;
};


export type DocumentMessageResolvedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentMessageResolvedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentMessageResolvedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageResolvedByConnectionSort>>;
  where?: InputMaybe<DocumentMessageResolvedByConnectionWhere>;
};


export type DocumentMessageSentByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentMessageSentByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentMessageSentByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentMessageSentByConnectionSort>>;
  where?: InputMaybe<DocumentMessageSentByConnectionWhere>;
};

export type DocumentMessageAggregateSelection = {
  __typename?: 'DocumentMessageAggregateSelection';
  content: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  createdOn: FloatAggregateSelectionNonNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  externalMessageId: IntAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  resolvedOn: DateTimeAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  systemMessageName: StringAggregateSelectionNullable;
};

export type DocumentMessageAgreementsAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageAgreementsAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageAgreementsAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageAgreementsNodeAggregationWhereInput>;
};

export type DocumentMessageAgreementsConnection = {
  __typename?: 'DocumentMessageAgreementsConnection';
  edges: Array<DocumentMessageAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageAgreementsConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type DocumentMessageAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageAgreementsConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageAgreementsConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type DocumentMessageAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageAgreementsNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessageAgreementsRelationship = {
  __typename?: 'DocumentMessageAgreementsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type DocumentMessageAttachmentInput = {
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  fileName: Scalars['String']['input'];
};

export type DocumentMessageBaseAgreementAgreementsAggregationSelection = {
  __typename?: 'DocumentMessageBaseAgreementAgreementsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageBaseAgreementAgreementsNodeAggregateSelection>;
};

export type DocumentMessageBaseAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'DocumentMessageBaseAgreementAgreementsNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type DocumentMessageCaseCasesAggregationSelection = {
  __typename?: 'DocumentMessageCaseCasesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageCaseCasesNodeAggregateSelection>;
};

export type DocumentMessageCaseCasesNodeAggregateSelection = {
  __typename?: 'DocumentMessageCaseCasesNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type DocumentMessageCasesAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageCasesAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageCasesAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageCasesNodeAggregationWhereInput>;
};

export type DocumentMessageCasesConnection = {
  __typename?: 'DocumentMessageCasesConnection';
  edges: Array<DocumentMessageCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type DocumentMessageCasesConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageCasesConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageCasesConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type DocumentMessageCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageCasesNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentMessageCasesRelationship = {
  __typename?: 'DocumentMessageCasesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type DocumentMessageDocumentAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageDocumentAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageDocumentAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageDocumentNodeAggregationWhereInput>;
};

export type DocumentMessageDocumentConnection = {
  __typename?: 'DocumentMessageDocumentConnection';
  edges: Array<DocumentMessageDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type DocumentMessageDocumentConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageDocumentConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageDocumentConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type DocumentMessageDocumentDocumentAggregationSelection = {
  __typename?: 'DocumentMessageDocumentDocumentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageDocumentDocumentNodeAggregateSelection>;
};

export type DocumentMessageDocumentDocumentNodeAggregateSelection = {
  __typename?: 'DocumentMessageDocumentDocumentNodeAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  creatorOrgName: StringAggregateSelectionNullable;
  creatorTenantId: StringAggregateSelectionNonNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  exposureLog: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastChangedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  lastSentForSmartMipReview: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  orderNo: StringAggregateSelectionNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  paymentReminderEmail: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipInvoiceFileId: StringAggregateSelectionNullable;
  smartMipInvoiceId: StringAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type DocumentMessageDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageDocumentNodeAggregationWhereInput>>;
  adjustedInvoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creatorOrgName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  orderNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reviewRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  senderLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentToReviewOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessageDocumentRelationship = {
  __typename?: 'DocumentMessageDocumentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentMessageEdge = {
  __typename?: 'DocumentMessageEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentMessage;
};

export type DocumentMessageMentionsAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageMentionsAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageMentionsAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageMentionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageMentionsNodeAggregationWhereInput>;
};

export type DocumentMessageMentionsConnection = {
  __typename?: 'DocumentMessageMentionsConnection';
  edges: Array<DocumentMessageMentionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageMentionsConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentMessageMentionsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageMentionsConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageMentionsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageMentionsConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentMessageMentionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageMentionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageMentionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageMentionsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessageMentionsRelationship = {
  __typename?: 'DocumentMessageMentionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DocumentMessageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentMessageSort objects to sort DocumentMessages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentMessageSort>>;
};

export type DocumentMessageRefundRefundsAggregationSelection = {
  __typename?: 'DocumentMessageRefundRefundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageRefundRefundsNodeAggregateSelection>;
};

export type DocumentMessageRefundRefundsNodeAggregateSelection = {
  __typename?: 'DocumentMessageRefundRefundsNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type DocumentMessageRefundsAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageRefundsAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageRefundsAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageRefundsNodeAggregationWhereInput>;
};

export type DocumentMessageRefundsConnection = {
  __typename?: 'DocumentMessageRefundsConnection';
  edges: Array<DocumentMessageRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type DocumentMessageRefundsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageRefundsConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageRefundsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type DocumentMessageRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageRefundsNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentMessageRefundsRelationship = {
  __typename?: 'DocumentMessageRefundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type DocumentMessageResolvedByAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageResolvedByAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageResolvedByAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageResolvedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageResolvedByNodeAggregationWhereInput>;
};

export type DocumentMessageResolvedByConnection = {
  __typename?: 'DocumentMessageResolvedByConnection';
  edges: Array<DocumentMessageResolvedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageResolvedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentMessageResolvedByConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageResolvedByConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageResolvedByConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageResolvedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentMessageResolvedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageResolvedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageResolvedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageResolvedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessageResolvedByRelationship = {
  __typename?: 'DocumentMessageResolvedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DocumentMessageSentByAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessageSentByAggregateInput>>;
  NOT?: InputMaybe<DocumentMessageSentByAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessageSentByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessageSentByNodeAggregationWhereInput>;
};

export type DocumentMessageSentByConnection = {
  __typename?: 'DocumentMessageSentByConnection';
  edges: Array<DocumentMessageSentByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessageSentByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentMessageSentByConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessageSentByConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessageSentByConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessageSentByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentMessageSentByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessageSentByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessageSentByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessageSentByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessageSentByRelationship = {
  __typename?: 'DocumentMessageSentByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export enum DocumentMessageSharingType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

/** Fields to sort DocumentMessages by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentMessageSort object. */
export type DocumentMessageSort = {
  areFilesCleared?: InputMaybe<SortDirection>;
  content?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  deletedOn?: InputMaybe<SortDirection>;
  externalMessageId?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAssignment?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  resolvedOn?: InputMaybe<SortDirection>;
  sharingType?: InputMaybe<SortDirection>;
  sourceTenantId?: InputMaybe<SortDirection>;
  systemMessageName?: InputMaybe<SortDirection>;
};

export type DocumentMessageUserMentionsAggregationSelection = {
  __typename?: 'DocumentMessageUserMentionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageUserMentionsNodeAggregateSelection>;
};

export type DocumentMessageUserMentionsNodeAggregateSelection = {
  __typename?: 'DocumentMessageUserMentionsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentMessageUserResolvedByAggregationSelection = {
  __typename?: 'DocumentMessageUserResolvedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageUserResolvedByNodeAggregateSelection>;
};

export type DocumentMessageUserResolvedByNodeAggregateSelection = {
  __typename?: 'DocumentMessageUserResolvedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentMessageUserSentByAggregationSelection = {
  __typename?: 'DocumentMessageUserSentByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentMessageUserSentByNodeAggregateSelection>;
};

export type DocumentMessageUserSentByNodeAggregateSelection = {
  __typename?: 'DocumentMessageUserSentByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentMessageWhere = {
  AND?: InputMaybe<Array<DocumentMessageWhere>>;
  NOT?: InputMaybe<DocumentMessageWhere>;
  OR?: InputMaybe<Array<DocumentMessageWhere>>;
  agreementsAggregate?: InputMaybe<DocumentMessageAgreementsAggregateInput>;
  /** Return DocumentMessages where all of the related DocumentMessageAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<DocumentMessageAgreementsConnectionWhere>;
  /** Return DocumentMessages where none of the related DocumentMessageAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<DocumentMessageAgreementsConnectionWhere>;
  /** Return DocumentMessages where one of the related DocumentMessageAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<DocumentMessageAgreementsConnectionWhere>;
  /** Return DocumentMessages where some of the related DocumentMessageAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<DocumentMessageAgreementsConnectionWhere>;
  /** Return DocumentMessages where all of the related BaseAgreements match this filter */
  agreements_ALL?: InputMaybe<BaseAgreementWhere>;
  /** Return DocumentMessages where none of the related BaseAgreements match this filter */
  agreements_NONE?: InputMaybe<BaseAgreementWhere>;
  /** Return DocumentMessages where one of the related BaseAgreements match this filter */
  agreements_SINGLE?: InputMaybe<BaseAgreementWhere>;
  /** Return DocumentMessages where some of the related BaseAgreements match this filter */
  agreements_SOME?: InputMaybe<BaseAgreementWhere>;
  areFilesCleared?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentBlobPaths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attachmentBlobPaths_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  attachmentContentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attachmentContentTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  attachmentFileNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attachmentFileNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  casesAggregate?: InputMaybe<DocumentMessageCasesAggregateInput>;
  /** Return DocumentMessages where all of the related DocumentMessageCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<DocumentMessageCasesConnectionWhere>;
  /** Return DocumentMessages where none of the related DocumentMessageCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<DocumentMessageCasesConnectionWhere>;
  /** Return DocumentMessages where one of the related DocumentMessageCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<DocumentMessageCasesConnectionWhere>;
  /** Return DocumentMessages where some of the related DocumentMessageCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<DocumentMessageCasesConnectionWhere>;
  /** Return DocumentMessages where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return DocumentMessages where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return DocumentMessages where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return DocumentMessages where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  content_MATCHES?: InputMaybe<Scalars['String']['input']>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<DocumentMessageDocumentAggregateInput>;
  documentConnection?: InputMaybe<DocumentMessageDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<DocumentMessageDocumentConnectionWhere>;
  document_NOT?: InputMaybe<DocumentWhere>;
  externalMessageId?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  externalMessageId_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  mentionsAggregate?: InputMaybe<DocumentMessageMentionsAggregateInput>;
  /** Return DocumentMessages where all of the related DocumentMessageMentionsConnections match this filter */
  mentionsConnection_ALL?: InputMaybe<DocumentMessageMentionsConnectionWhere>;
  /** Return DocumentMessages where none of the related DocumentMessageMentionsConnections match this filter */
  mentionsConnection_NONE?: InputMaybe<DocumentMessageMentionsConnectionWhere>;
  /** Return DocumentMessages where one of the related DocumentMessageMentionsConnections match this filter */
  mentionsConnection_SINGLE?: InputMaybe<DocumentMessageMentionsConnectionWhere>;
  /** Return DocumentMessages where some of the related DocumentMessageMentionsConnections match this filter */
  mentionsConnection_SOME?: InputMaybe<DocumentMessageMentionsConnectionWhere>;
  /** Return DocumentMessages where all of the related Users match this filter */
  mentions_ALL?: InputMaybe<UserWhere>;
  /** Return DocumentMessages where none of the related Users match this filter */
  mentions_NONE?: InputMaybe<UserWhere>;
  /** Return DocumentMessages where one of the related Users match this filter */
  mentions_SINGLE?: InputMaybe<UserWhere>;
  /** Return DocumentMessages where some of the related Users match this filter */
  mentions_SOME?: InputMaybe<UserWhere>;
  refundsAggregate?: InputMaybe<DocumentMessageRefundsAggregateInput>;
  /** Return DocumentMessages where all of the related DocumentMessageRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<DocumentMessageRefundsConnectionWhere>;
  /** Return DocumentMessages where none of the related DocumentMessageRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<DocumentMessageRefundsConnectionWhere>;
  /** Return DocumentMessages where one of the related DocumentMessageRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<DocumentMessageRefundsConnectionWhere>;
  /** Return DocumentMessages where some of the related DocumentMessageRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<DocumentMessageRefundsConnectionWhere>;
  /** Return DocumentMessages where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return DocumentMessages where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return DocumentMessages where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return DocumentMessages where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  resolvedBy?: InputMaybe<UserWhere>;
  resolvedByAggregate?: InputMaybe<DocumentMessageResolvedByAggregateInput>;
  resolvedByConnection?: InputMaybe<DocumentMessageResolvedByConnectionWhere>;
  resolvedByConnection_NOT?: InputMaybe<DocumentMessageResolvedByConnectionWhere>;
  resolvedBy_NOT?: InputMaybe<UserWhere>;
  resolvedOn?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  resolvedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentBy?: InputMaybe<UserWhere>;
  sentByAggregate?: InputMaybe<DocumentMessageSentByAggregateInput>;
  sentByConnection?: InputMaybe<DocumentMessageSentByConnectionWhere>;
  sentByConnection_NOT?: InputMaybe<DocumentMessageSentByConnectionWhere>;
  sentBy_NOT?: InputMaybe<UserWhere>;
  sharingType?: InputMaybe<DocumentMessageSharingType>;
  sharingType_IN?: InputMaybe<Array<DocumentMessageSharingType>>;
  sourceTenantId?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceTenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceTenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  systemMessageName?: InputMaybe<Scalars['String']['input']>;
  systemMessageName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  systemMessageName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  systemMessageName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  systemMessageName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  systemMessageName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentMessagesAggregateInput = {
  AND?: InputMaybe<Array<DocumentMessagesAggregateInput>>;
  NOT?: InputMaybe<DocumentMessagesAggregateInput>;
  OR?: InputMaybe<Array<DocumentMessagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentMessagesNodeAggregationWhereInput>;
};

export type DocumentMessagesConnection = {
  __typename?: 'DocumentMessagesConnection';
  edges: Array<DocumentMessagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentMessagesConnectionSort = {
  node?: InputMaybe<DocumentMessageSort>;
};

export type DocumentMessagesConnectionWhere = {
  AND?: InputMaybe<Array<DocumentMessagesConnectionWhere>>;
  NOT?: InputMaybe<DocumentMessagesConnectionWhere>;
  OR?: InputMaybe<Array<DocumentMessagesConnectionWhere>>;
  node?: InputMaybe<DocumentMessageWhere>;
};

export type DocumentMessagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentMessagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentMessagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentMessagesNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  externalMessageId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resolvedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentMessagesRelationship = {
  __typename?: 'DocumentMessagesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentMessage;
};

export type DocumentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentSort objects to sort Documents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentSort>>;
};

export enum DocumentPeriodDateType {
  InvoiceDate = 'INVOICE_DATE',
  PrescriptionDate = 'PRESCRIPTION_DATE'
}

export type DocumentRefundFinancialDataPoint = {
  changedByUserId?: Maybe<Scalars['String']['output']>;
  changedOn?: Maybe<Scalars['DateTime']['output']>;
  connectionId: Scalars['ID']['output'];
  smartMipStatus?: Maybe<SmartMipPositionStatus>;
  status?: Maybe<FinancialDataPointStatus>;
};

export type DocumentRefundFinancialDataPointSort = {
  changedByUserId?: InputMaybe<SortDirection>;
  changedOn?: InputMaybe<SortDirection>;
  connectionId?: InputMaybe<SortDirection>;
  smartMipStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type DocumentRefundFinancialDataPointWhere = {
  AND?: InputMaybe<Array<DocumentRefundFinancialDataPointWhere>>;
  NOT?: InputMaybe<DocumentRefundFinancialDataPointWhere>;
  OR?: InputMaybe<Array<DocumentRefundFinancialDataPointWhere>>;
  changedByUserId?: InputMaybe<Scalars['String']['input']>;
  changedByUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  changedByUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  changedByUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  changedByUserId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  changedByUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  changedOn?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  changedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  connectionId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  connectionId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  connectionId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  connectionId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  smartMipStatus?: InputMaybe<SmartMipPositionStatus>;
  smartMipStatus_IN?: InputMaybe<Array<InputMaybe<SmartMipPositionStatus>>>;
  status?: InputMaybe<FinancialDataPointStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<FinancialDataPointStatus>>>;
  status_IS_NULL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentRefundGroup = {
  __typename?: 'DocumentRefundGroup';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<DocumentRefundGroupAgreementAgreementAggregationSelection>;
  agreementConnection: DocumentRefundGroupAgreementConnection;
  case?: Maybe<Case>;
  caseAggregate?: Maybe<DocumentRefundGroupCaseCaseAggregationSelection>;
  caseConnection: DocumentRefundGroupCaseConnection;
  document: Document;
  documentAggregate?: Maybe<DocumentRefundGroupDocumentDocumentAggregationSelection>;
  documentConnection: DocumentRefundGroupDocumentConnection;
  documentStatus?: Maybe<DocumentStatus>;
  id: Scalars['ID']['output'];
  message: Array<Message>;
  messageAggregate?: Maybe<DocumentRefundGroupMessageMessageAggregationSelection>;
  messageConnection: DocumentRefundGroupMessageConnection;
  messageCount?: Maybe<Scalars['Int']['output']>;
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<DocumentRefundGroupRefundRefundsAggregationSelection>;
  refundsConnection: DocumentRefundGroupRefundsConnection;
  tenantIds: Array<Scalars['String']['output']>;
  threadMessageCount: Scalars['Int']['output'];
};


export type DocumentRefundGroupAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type DocumentRefundGroupAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type DocumentRefundGroupAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupAgreementConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
};


export type DocumentRefundGroupCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type DocumentRefundGroupCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type DocumentRefundGroupCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupCaseConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
};


export type DocumentRefundGroupDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentRefundGroupDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type DocumentRefundGroupDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupDocumentConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
};


export type DocumentRefundGroupMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type DocumentRefundGroupMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type DocumentRefundGroupMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupMessageConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
};


export type DocumentRefundGroupRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundGroupRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type DocumentRefundGroupRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DocumentRefundGroupRefundsConnectionSort>>;
  where?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
};

export type DocumentRefundGroupAggregateSelection = {
  __typename?: 'DocumentRefundGroupAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type DocumentRefundGroupAgreementAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupAgreementAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupAgreementAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupAgreementNodeAggregationWhereInput>;
};

export type DocumentRefundGroupAgreementAgreementAggregationSelection = {
  __typename?: 'DocumentRefundGroupAgreementAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupAgreementAgreementNodeAggregateSelection>;
};

export type DocumentRefundGroupAgreementAgreementNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupAgreementAgreementNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type DocumentRefundGroupAgreementConnection = {
  __typename?: 'DocumentRefundGroupAgreementConnection';
  edges: Array<DocumentRefundGroupAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type DocumentRefundGroupAgreementConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupAgreementConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type DocumentRefundGroupAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupAgreementNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentRefundGroupAgreementRelationship = {
  __typename?: 'DocumentRefundGroupAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type DocumentRefundGroupCaseAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupCaseAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupCaseAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupCaseNodeAggregationWhereInput>;
};

export type DocumentRefundGroupCaseCaseAggregationSelection = {
  __typename?: 'DocumentRefundGroupCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupCaseCaseNodeAggregateSelection>;
};

export type DocumentRefundGroupCaseCaseNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type DocumentRefundGroupCaseConnection = {
  __typename?: 'DocumentRefundGroupCaseConnection';
  edges: Array<DocumentRefundGroupCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type DocumentRefundGroupCaseConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupCaseConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type DocumentRefundGroupCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentRefundGroupCaseRelationship = {
  __typename?: 'DocumentRefundGroupCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type DocumentRefundGroupDocumentAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupDocumentAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupDocumentAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupDocumentNodeAggregationWhereInput>;
};

export type DocumentRefundGroupDocumentConnection = {
  __typename?: 'DocumentRefundGroupDocumentConnection';
  edges: Array<DocumentRefundGroupDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type DocumentRefundGroupDocumentConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupDocumentConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type DocumentRefundGroupDocumentDocumentAggregationSelection = {
  __typename?: 'DocumentRefundGroupDocumentDocumentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupDocumentDocumentNodeAggregateSelection>;
};

export type DocumentRefundGroupDocumentDocumentNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupDocumentDocumentNodeAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  creatorOrgName: StringAggregateSelectionNullable;
  creatorTenantId: StringAggregateSelectionNonNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  exposureLog: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastChangedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  lastSentForSmartMipReview: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  orderNo: StringAggregateSelectionNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  paymentReminderEmail: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipInvoiceFileId: StringAggregateSelectionNullable;
  smartMipInvoiceId: StringAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type DocumentRefundGroupDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupDocumentNodeAggregationWhereInput>>;
  adjustedInvoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creatorOrgName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  orderNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reviewRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  senderLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentToReviewOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentRefundGroupDocumentRelationship = {
  __typename?: 'DocumentRefundGroupDocumentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentRefundGroupEdge = {
  __typename?: 'DocumentRefundGroupEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentRefundGroup;
};

export type DocumentRefundGroupMessageAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupMessageAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupMessageAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupMessageNodeAggregationWhereInput>;
};

export type DocumentRefundGroupMessageConnection = {
  __typename?: 'DocumentRefundGroupMessageConnection';
  edges: Array<DocumentRefundGroupMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupMessageConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type DocumentRefundGroupMessageConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupMessageConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupMessageConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type DocumentRefundGroupMessageMessageAggregationSelection = {
  __typename?: 'DocumentRefundGroupMessageMessageAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupMessageMessageNodeAggregateSelection>;
};

export type DocumentRefundGroupMessageMessageNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupMessageMessageNodeAggregateSelection';
  content: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
};

export type DocumentRefundGroupMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupMessageNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentRefundGroupMessageRelationship = {
  __typename?: 'DocumentRefundGroupMessageRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Message;
};

export type DocumentRefundGroupOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentRefundGroupSort objects to sort DocumentRefundGroups by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentRefundGroupSort>>;
};

export type DocumentRefundGroupRefundRefundsAggregationSelection = {
  __typename?: 'DocumentRefundGroupRefundRefundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentRefundGroupRefundRefundsNodeAggregateSelection>;
};

export type DocumentRefundGroupRefundRefundsNodeAggregateSelection = {
  __typename?: 'DocumentRefundGroupRefundRefundsNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type DocumentRefundGroupRefundsAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupRefundsAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundGroupRefundsAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRefundGroupRefundsNodeAggregationWhereInput>;
};

export type DocumentRefundGroupRefundsConnection = {
  __typename?: 'DocumentRefundGroupRefundsConnection';
  edges: Array<DocumentRefundGroupRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundGroupRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type DocumentRefundGroupRefundsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupRefundsConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type DocumentRefundGroupRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundGroupRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundGroupRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundGroupRefundsNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRefundGroupRefundsRelationship = {
  __typename?: 'DocumentRefundGroupRefundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

/** Fields to sort DocumentRefundGroups by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentRefundGroupSort object. */
export type DocumentRefundGroupSort = {
  documentStatus?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  messageCount?: InputMaybe<SortDirection>;
  threadMessageCount?: InputMaybe<SortDirection>;
};

export type DocumentRefundGroupWhere = {
  AND?: InputMaybe<Array<DocumentRefundGroupWhere>>;
  NOT?: InputMaybe<DocumentRefundGroupWhere>;
  OR?: InputMaybe<Array<DocumentRefundGroupWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<DocumentRefundGroupAgreementAggregateInput>;
  agreementConnection?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<DocumentRefundGroupAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<DocumentRefundGroupCaseAggregateInput>;
  caseConnection?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<DocumentRefundGroupCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<DocumentRefundGroupDocumentAggregateInput>;
  documentConnection?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<DocumentRefundGroupDocumentConnectionWhere>;
  document_NOT?: InputMaybe<DocumentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  messageAggregate?: InputMaybe<DocumentRefundGroupMessageAggregateInput>;
  /** Return DocumentRefundGroups where all of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_ALL?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where none of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_NONE?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where one of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_SINGLE?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where some of the related DocumentRefundGroupMessageConnections match this filter */
  messageConnection_SOME?: InputMaybe<DocumentRefundGroupMessageConnectionWhere>;
  /** Return DocumentRefundGroups where all of the related Messages match this filter */
  message_ALL?: InputMaybe<MessageWhere>;
  /** Return DocumentRefundGroups where none of the related Messages match this filter */
  message_NONE?: InputMaybe<MessageWhere>;
  /** Return DocumentRefundGroups where one of the related Messages match this filter */
  message_SINGLE?: InputMaybe<MessageWhere>;
  /** Return DocumentRefundGroups where some of the related Messages match this filter */
  message_SOME?: InputMaybe<MessageWhere>;
  refundsAggregate?: InputMaybe<DocumentRefundGroupRefundsAggregateInput>;
  /** Return DocumentRefundGroups where all of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where none of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where one of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where some of the related DocumentRefundGroupRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<DocumentRefundGroupRefundsConnectionWhere>;
  /** Return DocumentRefundGroups where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return DocumentRefundGroups where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return DocumentRefundGroups where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return DocumentRefundGroups where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentRefundGroupsConnection = {
  __typename?: 'DocumentRefundGroupsConnection';
  edges: Array<DocumentRefundGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundRefundsAggregationSelection = {
  __typename?: 'DocumentRefundRefundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<DocumentRefundRefundsEdgeAggregateSelection>;
  node?: Maybe<DocumentRefundRefundsNodeAggregateSelection>;
};

export type DocumentRefundRefundsEdgeAggregateSelection = {
  __typename?: 'DocumentRefundRefundsEdgeAggregateSelection';
  lastExternalMessageId: IntAggregateSelectionNullable;
  lastSmartMipQuestionReceivedOn: DateTimeAggregateSelectionNullable;
  originalId: IdAggregateSelectionNullable;
};

export type DocumentRefundRefundsNodeAggregateSelection = {
  __typename?: 'DocumentRefundRefundsNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type DocumentRefundRelationship = {
  lastExternalMessageId?: Maybe<Scalars['Int']['output']>;
  lastSmartMipQuestionReceivedOn?: Maybe<Scalars['DateTime']['output']>;
  originalId?: Maybe<Scalars['ID']['output']>;
};

export type DocumentRefundRelationshipSort = {
  lastExternalMessageId?: InputMaybe<SortDirection>;
  lastSmartMipQuestionReceivedOn?: InputMaybe<SortDirection>;
  originalId?: InputMaybe<SortDirection>;
};

export type DocumentRefundRelationshipWhere = {
  AND?: InputMaybe<Array<DocumentRefundRelationshipWhere>>;
  NOT?: InputMaybe<DocumentRefundRelationshipWhere>;
  OR?: InputMaybe<Array<DocumentRefundRelationshipWhere>>;
  lastExternalMessageId?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_GT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lastExternalMessageId_LT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastSmartMipQuestionReceivedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSmartMipQuestionReceivedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  originalId?: InputMaybe<Scalars['ID']['input']>;
  originalId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  originalId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  originalId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  originalId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentRefundsAggregateInput = {
  AND?: InputMaybe<Array<DocumentRefundsAggregateInput>>;
  NOT?: InputMaybe<DocumentRefundsAggregateInput>;
  OR?: InputMaybe<Array<DocumentRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<DocumentRefundsEdgeAggregationWhereInput>;
  node?: InputMaybe<DocumentRefundsNodeAggregationWhereInput>;
};

export type DocumentRefundsConnection = {
  __typename?: 'DocumentRefundsConnection';
  edges: Array<DocumentRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRefundsConnectionSort = {
  edge?: InputMaybe<DocumentRefundRelationshipSort>;
  node?: InputMaybe<RefundSort>;
};

export type DocumentRefundsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRefundsConnectionWhere>>;
  NOT?: InputMaybe<DocumentRefundsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRefundsConnectionWhere>>;
  edge?: InputMaybe<DocumentRefundRelationshipWhere>;
  node?: InputMaybe<RefundWhere>;
};

export type DocumentRefundsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundsEdgeAggregationWhereInput>>;
  lastExternalMessageId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastExternalMessageId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastExternalMessageId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastExternalMessageId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastExternalMessageId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastExternalMessageId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lastExternalMessageId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastSmartMipQuestionReceivedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSmartMipQuestionReceivedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRefundsNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRefundsRelationship = DocumentRefundRelationship & {
  __typename?: 'DocumentRefundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  lastExternalMessageId?: Maybe<Scalars['Int']['output']>;
  lastSmartMipQuestionReceivedOn?: Maybe<Scalars['DateTime']['output']>;
  node: Refund;
  originalId?: Maybe<Scalars['ID']['output']>;
};

export type DocumentRejectedByAggregateInput = {
  AND?: InputMaybe<Array<DocumentRejectedByAggregateInput>>;
  NOT?: InputMaybe<DocumentRejectedByAggregateInput>;
  OR?: InputMaybe<Array<DocumentRejectedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentRejectedByNodeAggregationWhereInput>;
};

export type DocumentRejectedByConnection = {
  __typename?: 'DocumentRejectedByConnection';
  edges: Array<DocumentRejectedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentRejectedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DocumentRejectedByConnectionWhere = {
  AND?: InputMaybe<Array<DocumentRejectedByConnectionWhere>>;
  NOT?: InputMaybe<DocumentRejectedByConnectionWhere>;
  OR?: InputMaybe<Array<DocumentRejectedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DocumentRejectedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentRejectedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentRejectedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentRejectedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentRejectedByRelationship = {
  __typename?: 'DocumentRejectedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

/** Fields to sort Documents by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentSort object. */
export type DocumentSort = {
  adjustedInvoiceAmount?: InputMaybe<SortDirection>;
  agreementBuyerInvoiceInfo?: InputMaybe<SortDirection>;
  agreementSellerInvoiceInfo?: InputMaybe<SortDirection>;
  areExportValuesSaved?: InputMaybe<SortDirection>;
  beneficiary?: InputMaybe<SortDirection>;
  canApprove?: InputMaybe<SortDirection>;
  canAssignUser?: InputMaybe<SortDirection>;
  canBeSentToSmartMip?: InputMaybe<SortDirection>;
  canConfirm?: InputMaybe<SortDirection>;
  canUserDelete?: InputMaybe<SortDirection>;
  counterParties?: InputMaybe<SortDirection>;
  coveragePeriod?: InputMaybe<SortDirection>;
  coveragePeriodEnd?: InputMaybe<SortDirection>;
  coveragePeriodStart?: InputMaybe<SortDirection>;
  createdByEmail?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  creationMethod?: InputMaybe<SortDirection>;
  creatorOrgName?: InputMaybe<SortDirection>;
  creatorTenantId?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  currentReviewerOrganization?: InputMaybe<SortDirection>;
  documentReceiverBillingAddress?: InputMaybe<SortDirection>;
  documentReceiverDetails?: InputMaybe<SortDirection>;
  documentReceiverLegalName?: InputMaybe<SortDirection>;
  documentSenderContactEmail?: InputMaybe<SortDirection>;
  documentSenderContactFirstName?: InputMaybe<SortDirection>;
  documentSenderContactLastName?: InputMaybe<SortDirection>;
  documentSenderContactPhone?: InputMaybe<SortDirection>;
  documentSenderDomicile?: InputMaybe<SortDirection>;
  documentSenderFax?: InputMaybe<SortDirection>;
  documentSenderPhone?: InputMaybe<SortDirection>;
  dunningDate?: InputMaybe<SortDirection>;
  exposureLog?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  hasAdjustedTransactions?: InputMaybe<SortDirection>;
  hasCaselessTransactions?: InputMaybe<SortDirection>;
  hasPatientTransactions?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  invoiceAmount?: InputMaybe<SortDirection>;
  isAgreementBuyer?: InputMaybe<SortDirection>;
  isAgreementOwner?: InputMaybe<SortDirection>;
  isAgreementSeller?: InputMaybe<SortDirection>;
  isAssignee?: InputMaybe<SortDirection>;
  isCommentRequierd?: InputMaybe<SortDirection>;
  isConfirmedByBuyer?: InputMaybe<SortDirection>;
  isConfirmedByExternalParty?: InputMaybe<SortDirection>;
  isConfirmedBySeller?: InputMaybe<SortDirection>;
  isConfirmedBySender?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isSentForExternalReview?: InputMaybe<SortDirection>;
  isSentToSmartMip?: InputMaybe<SortDirection>;
  issuedOn?: InputMaybe<SortDirection>;
  lastChangedOn?: InputMaybe<SortDirection>;
  lastRemindedOn?: InputMaybe<SortDirection>;
  lastSentForSmartMipReview?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  orderNo?: InputMaybe<SortDirection>;
  paymentReceiptPayer?: InputMaybe<SortDirection>;
  paymentReferenceLyfegen?: InputMaybe<SortDirection>;
  paymentReminderEmail?: InputMaybe<SortDirection>;
  periodDateType?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  reviewRemindedOn?: InputMaybe<SortDirection>;
  senderLegalName?: InputMaybe<SortDirection>;
  sentToReviewOn?: InputMaybe<SortDirection>;
  settledOn?: InputMaybe<SortDirection>;
  smartMipInvoiceFileId?: InputMaybe<SortDirection>;
  smartMipInvoiceId?: InputMaybe<SortDirection>;
  smartMipReimbursementId?: InputMaybe<SortDirection>;
  smartMipStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uploadedOn?: InputMaybe<SortDirection>;
  uploadedVariantKey?: InputMaybe<SortDirection>;
};

export enum DocumentStatus {
  InApproval = 'IN_APPROVAL',
  InReview = 'IN_REVIEW',
  Issued = 'ISSUED',
  Settled = 'SETTLED',
  WorkingDraft = 'WORKING_DRAFT'
}

export type DocumentTableRow = ITableRowView & {
  __typename?: 'DocumentTableRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adjustedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  agreementIds?: Maybe<Array<Scalars['String']['output']>>;
  agreementTagTypes?: Maybe<Array<Scalars['String']['output']>>;
  agreementWithoutUserAccessNames?: Maybe<Array<Scalars['String']['output']>>;
  beneficiary?: Maybe<DocumentBeneficiary>;
  counterParties?: Maybe<Scalars['String']['output']>;
  coveragePeriod?: Maybe<Scalars['String']['output']>;
  coveragePeriodEnd?: Maybe<Scalars['Date']['output']>;
  coveragePeriodStart?: Maybe<Scalars['Date']['output']>;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currentReviewerOrganization?: Maybe<Scalars['String']['output']>;
  currentReviewerOrganizationOrEmptyString?: Maybe<Scalars['String']['output']>;
  finalInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  formattedApprovers?: Maybe<Scalars['String']['output']>;
  formattedContent?: Maybe<Scalars['String']['output']>;
  formattedExposedToUserIds?: Maybe<Scalars['String']['output']>;
  formattedTags?: Maybe<Scalars['String']['output']>;
  hasAdjustedTransactions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoiceAmount?: Maybe<Scalars['Float']['output']>;
  isAgreementBuyer?: Maybe<Scalars['Boolean']['output']>;
  isConfirmedBySeller?: Maybe<Scalars['Boolean']['output']>;
  isSentToSmartMip?: Maybe<Scalars['Boolean']['output']>;
  issuedOn?: Maybe<Scalars['DateTime']['output']>;
  lastRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  order: Scalars['Int']['output'];
  paymentReceiptPayer?: Maybe<Scalars['Date']['output']>;
  paymentReferenceLyfegen?: Maybe<Scalars['String']['output']>;
  periodDateType?: Maybe<DocumentPeriodDateType>;
  product?: Maybe<Scalars['String']['output']>;
  reviewRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  sentToReviewOn?: Maybe<Scalars['DateTime']['output']>;
  smartMipReimbursementId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<DocumentStatus>;
  type?: Maybe<DocumentType>;
  users: Array<User>;
  usersAggregate?: Maybe<DocumentTableRowUserUsersAggregationSelection>;
  usersConnection: ITableRowViewUsersConnection;
};


export type DocumentTableRowUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentTableRowUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DocumentTableRowUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ITableRowViewUsersConnectionSort>>;
  where?: InputMaybe<ITableRowViewUsersConnectionWhere>;
};

export type DocumentTableRowAggregateSelection = {
  __typename?: 'DocumentTableRowAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  currentReviewerOrganizationOrEmptyString: StringAggregateSelectionNullable;
  finalInvoiceAmount: FloatAggregateSelectionNullable;
  formattedApprovers: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNullable;
  formattedExposedToUserIds: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
};

export type DocumentTableRowEdge = {
  __typename?: 'DocumentTableRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentTableRow;
};

export type DocumentTableRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentTableRowSort objects to sort DocumentTableRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentTableRowSort>>;
};

/** Fields to sort DocumentTableRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentTableRowSort object. */
export type DocumentTableRowSort = {
  adjustedInvoiceAmount?: InputMaybe<SortDirection>;
  beneficiary?: InputMaybe<SortDirection>;
  counterParties?: InputMaybe<SortDirection>;
  coveragePeriod?: InputMaybe<SortDirection>;
  coveragePeriodEnd?: InputMaybe<SortDirection>;
  coveragePeriodStart?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  currentReviewerOrganization?: InputMaybe<SortDirection>;
  currentReviewerOrganizationOrEmptyString?: InputMaybe<SortDirection>;
  finalInvoiceAmount?: InputMaybe<SortDirection>;
  formattedApprovers?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  formattedExposedToUserIds?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  hasAdjustedTransactions?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  invoiceAmount?: InputMaybe<SortDirection>;
  isAgreementBuyer?: InputMaybe<SortDirection>;
  isConfirmedBySeller?: InputMaybe<SortDirection>;
  isSentToSmartMip?: InputMaybe<SortDirection>;
  issuedOn?: InputMaybe<SortDirection>;
  lastRemindedOn?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  paymentReceiptPayer?: InputMaybe<SortDirection>;
  paymentReferenceLyfegen?: InputMaybe<SortDirection>;
  periodDateType?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  reviewRemindedOn?: InputMaybe<SortDirection>;
  sentToReviewOn?: InputMaybe<SortDirection>;
  smartMipReimbursementId?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type DocumentTableRowUserUsersAggregationSelection = {
  __typename?: 'DocumentTableRowUserUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentTableRowUserUsersNodeAggregateSelection>;
};

export type DocumentTableRowUserUsersNodeAggregateSelection = {
  __typename?: 'DocumentTableRowUserUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentTableRowUsersAggregateInput = {
  AND?: InputMaybe<Array<DocumentTableRowUsersAggregateInput>>;
  NOT?: InputMaybe<DocumentTableRowUsersAggregateInput>;
  OR?: InputMaybe<Array<DocumentTableRowUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentTableRowUsersNodeAggregationWhereInput>;
};

export type DocumentTableRowUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentTableRowUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentTableRowUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentTableRowUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentTableRowWhere = {
  AND?: InputMaybe<Array<DocumentTableRowWhere>>;
  NOT?: InputMaybe<DocumentTableRowWhere>;
  OR?: InputMaybe<Array<DocumentTableRowWhere>>;
  adjustedInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  adjustedInvoiceAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  agreementTagTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementTagTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  agreementWithoutUserAccessNames?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementWithoutUserAccessNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  beneficiary?: InputMaybe<DocumentBeneficiary>;
  beneficiary_IN?: InputMaybe<Array<InputMaybe<DocumentBeneficiary>>>;
  counterParties?: InputMaybe<Scalars['String']['input']>;
  counterParties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterParties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterParties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterParties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterParties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod?: InputMaybe<Scalars['String']['input']>;
  coveragePeriodEnd?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_GT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_GTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  coveragePeriodEnd_LT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_LTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_GT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_GTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  coveragePeriodStart_LT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_LTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coveragePeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganizationOrEmptyString?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganizationOrEmptyString_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganizationOrEmptyString_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganizationOrEmptyString_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentReviewerOrganizationOrEmptyString_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganizationOrEmptyString_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentReviewerOrganization_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  finalInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  finalInvoiceAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  finalInvoiceAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  finalInvoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  finalInvoiceAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  finalInvoiceAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedApprovers?: InputMaybe<Scalars['String']['input']>;
  formattedApprovers_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedApprovers_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedApprovers_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedApprovers_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedApprovers_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedExposedToUserIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasAdjustedTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  invoiceAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  isAgreementBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmedBySeller?: InputMaybe<Scalars['Boolean']['input']>;
  isSentToSmartMip?: InputMaybe<Scalars['Boolean']['input']>;
  issuedOn?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  issuedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReceiptPayer?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_GT?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_GTE?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  paymentReceiptPayer_LT?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_LTE?: InputMaybe<Scalars['Date']['input']>;
  paymentReferenceLyfegen?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentReferenceLyfegen_MATCHES?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  periodDateType?: InputMaybe<DocumentPeriodDateType>;
  periodDateType_IN?: InputMaybe<Array<InputMaybe<DocumentPeriodDateType>>>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  reviewRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  reviewRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sentToReviewOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  smartMipReimbursementId?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smartMipReimbursementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  type?: InputMaybe<DocumentType>;
  type_IN?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  usersAggregate?: InputMaybe<DocumentTableRowUsersAggregateInput>;
  /** Return DocumentTableRows where all of the related ITableRowViewUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return DocumentTableRows where none of the related ITableRowViewUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return DocumentTableRows where one of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return DocumentTableRows where some of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return DocumentTableRows where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return DocumentTableRows where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return DocumentTableRows where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return DocumentTableRows where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type DocumentTableRowsConnection = {
  __typename?: 'DocumentTableRowsConnection';
  edges: Array<DocumentTableRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentTagsAggregateInput = {
  AND?: InputMaybe<Array<DocumentTagsAggregateInput>>;
  NOT?: InputMaybe<DocumentTagsAggregateInput>;
  OR?: InputMaybe<Array<DocumentTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DocumentTagsNodeAggregationWhereInput>;
};

export type DocumentTagsConnection = {
  __typename?: 'DocumentTagsConnection';
  edges: Array<DocumentTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type DocumentTagsConnectionWhere = {
  AND?: InputMaybe<Array<DocumentTagsConnectionWhere>>;
  NOT?: InputMaybe<DocumentTagsConnectionWhere>;
  OR?: InputMaybe<Array<DocumentTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type DocumentTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DocumentTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DocumentTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DocumentTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentTagsRelationship = {
  __typename?: 'DocumentTagsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type DocumentThreadUpdate = {
  __typename?: 'DocumentThreadUpdate';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  deletedMessageId?: Maybe<Scalars['ID']['output']>;
  documentId: Scalars['ID']['output'];
  initiatorUserEmail: Scalars['String']['output'];
  message?: Maybe<DocumentMessage>;
};

export type DocumentThreadUpdateAggregateSelection = {
  __typename?: 'DocumentThreadUpdateAggregateSelection';
  count: Scalars['Int']['output'];
  deletedMessageId: IdAggregateSelectionNullable;
  documentId: IdAggregateSelectionNonNullable;
  initiatorUserEmail: StringAggregateSelectionNonNullable;
};

export type DocumentThreadUpdateEdge = {
  __typename?: 'DocumentThreadUpdateEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentThreadUpdate;
};

export type DocumentThreadUpdateOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentThreadUpdateSort objects to sort DocumentThreadUpdates by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentThreadUpdateSort>>;
};

/** Fields to sort DocumentThreadUpdates by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentThreadUpdateSort object. */
export type DocumentThreadUpdateSort = {
  deletedMessageId?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  initiatorUserEmail?: InputMaybe<SortDirection>;
};

export type DocumentThreadUpdateWhere = {
  AND?: InputMaybe<Array<DocumentThreadUpdateWhere>>;
  NOT?: InputMaybe<DocumentThreadUpdateWhere>;
  OR?: InputMaybe<Array<DocumentThreadUpdateWhere>>;
  deletedMessageId?: InputMaybe<Scalars['ID']['input']>;
  deletedMessageId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  deletedMessageId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  deletedMessageId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deletedMessageId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  documentId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initiatorUserEmail?: InputMaybe<Scalars['String']['input']>;
  initiatorUserEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initiatorUserEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initiatorUserEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  initiatorUserEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initiatorUserEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentThreadUpdatesConnection = {
  __typename?: 'DocumentThreadUpdatesConnection';
  edges: Array<DocumentThreadUpdateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum DocumentType {
  CreditNote = 'CREDIT_NOTE',
  FreeOfCharge = 'FREE_OF_CHARGE',
  Invoice = 'INVOICE'
}

export type DocumentUpdated = {
  __typename?: 'DocumentUpdated';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  documentId: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
  updatedById: Scalars['String']['output'];
};

export type DocumentUpdatedAggregateSelection = {
  __typename?: 'DocumentUpdatedAggregateSelection';
  count: Scalars['Int']['output'];
  documentId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
  updatedById: StringAggregateSelectionNonNullable;
};

export type DocumentUpdatedEdge = {
  __typename?: 'DocumentUpdatedEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentUpdated;
};

export type DocumentUpdatedOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentUpdatedSort objects to sort DocumentUpdateds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentUpdatedSort>>;
};

/** Fields to sort DocumentUpdateds by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentUpdatedSort object. */
export type DocumentUpdatedSort = {
  documentId?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  updatedById?: InputMaybe<SortDirection>;
};

export type DocumentUpdatedWhere = {
  AND?: InputMaybe<Array<DocumentUpdatedWhere>>;
  NOT?: InputMaybe<DocumentUpdatedWhere>;
  OR?: InputMaybe<Array<DocumentUpdatedWhere>>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  documentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedById?: InputMaybe<Scalars['String']['input']>;
  updatedById_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  updatedById_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedById_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedById_MATCHES?: InputMaybe<Scalars['String']['input']>;
  updatedById_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentUpdatedsConnection = {
  __typename?: 'DocumentUpdatedsConnection';
  edges: Array<DocumentUpdatedEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentUploadInfo = {
  __typename?: 'DocumentUploadInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  uploadedOn?: Maybe<Scalars['DateTime']['output']>;
  uploadedVariantKey?: Maybe<Scalars['String']['output']>;
};

export type DocumentUploadInfoAggregateSelection = {
  __typename?: 'DocumentUploadInfoAggregateSelection';
  count: Scalars['Int']['output'];
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type DocumentUploadInfoEdge = {
  __typename?: 'DocumentUploadInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentUploadInfo;
};

export type DocumentUploadInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentUploadInfoSort objects to sort DocumentUploadInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentUploadInfoSort>>;
};

/** Fields to sort DocumentUploadInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentUploadInfoSort object. */
export type DocumentUploadInfoSort = {
  uploadedOn?: InputMaybe<SortDirection>;
  uploadedVariantKey?: InputMaybe<SortDirection>;
};

export type DocumentUploadInfoWhere = {
  AND?: InputMaybe<Array<DocumentUploadInfoWhere>>;
  NOT?: InputMaybe<DocumentUploadInfoWhere>;
  OR?: InputMaybe<Array<DocumentUploadInfoWhere>>;
  uploadedOn?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uploadedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploadedVariantKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentUploadInfosConnection = {
  __typename?: 'DocumentUploadInfosConnection';
  edges: Array<DocumentUploadInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentUserApprovedByAggregationSelection = {
  __typename?: 'DocumentUserApprovedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentUserApprovedByNodeAggregateSelection>;
};

export type DocumentUserApprovedByNodeAggregateSelection = {
  __typename?: 'DocumentUserApprovedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentUserAssignedToAggregationSelection = {
  __typename?: 'DocumentUserAssignedToAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentUserAssignedToNodeAggregateSelection>;
};

export type DocumentUserAssignedToNodeAggregateSelection = {
  __typename?: 'DocumentUserAssignedToNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentUserConfirmedByAggregationSelection = {
  __typename?: 'DocumentUserConfirmedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentUserConfirmedByNodeAggregateSelection>;
};

export type DocumentUserConfirmedByNodeAggregateSelection = {
  __typename?: 'DocumentUserConfirmedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentUserCreatedByAggregationSelection = {
  __typename?: 'DocumentUserCreatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentUserCreatedByNodeAggregateSelection>;
};

export type DocumentUserCreatedByNodeAggregateSelection = {
  __typename?: 'DocumentUserCreatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentUserRejectedByAggregationSelection = {
  __typename?: 'DocumentUserRejectedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DocumentUserRejectedByNodeAggregateSelection>;
};

export type DocumentUserRejectedByNodeAggregateSelection = {
  __typename?: 'DocumentUserRejectedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DocumentWhere = {
  AND?: InputMaybe<Array<DocumentWhere>>;
  NOT?: InputMaybe<DocumentWhere>;
  OR?: InputMaybe<Array<DocumentWhere>>;
  addedTransactionsInfoAggregate?: InputMaybe<DocumentAddedTransactionsInfoAggregateInput>;
  /** Return Documents where all of the related DocumentAddedTransactionsInfoConnections match this filter */
  addedTransactionsInfoConnection_ALL?: InputMaybe<DocumentAddedTransactionsInfoConnectionWhere>;
  /** Return Documents where none of the related DocumentAddedTransactionsInfoConnections match this filter */
  addedTransactionsInfoConnection_NONE?: InputMaybe<DocumentAddedTransactionsInfoConnectionWhere>;
  /** Return Documents where one of the related DocumentAddedTransactionsInfoConnections match this filter */
  addedTransactionsInfoConnection_SINGLE?: InputMaybe<DocumentAddedTransactionsInfoConnectionWhere>;
  /** Return Documents where some of the related DocumentAddedTransactionsInfoConnections match this filter */
  addedTransactionsInfoConnection_SOME?: InputMaybe<DocumentAddedTransactionsInfoConnectionWhere>;
  /** Return Documents where all of the related AddedTransactionsInfos match this filter */
  addedTransactionsInfo_ALL?: InputMaybe<AddedTransactionsInfoWhere>;
  /** Return Documents where none of the related AddedTransactionsInfos match this filter */
  addedTransactionsInfo_NONE?: InputMaybe<AddedTransactionsInfoWhere>;
  /** Return Documents where one of the related AddedTransactionsInfos match this filter */
  addedTransactionsInfo_SINGLE?: InputMaybe<AddedTransactionsInfoWhere>;
  /** Return Documents where some of the related AddedTransactionsInfos match this filter */
  addedTransactionsInfo_SOME?: InputMaybe<AddedTransactionsInfoWhere>;
  adjustedInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  adjustedInvoiceAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  approvedByAggregate?: InputMaybe<DocumentApprovedByAggregateInput>;
  /** Return Documents where all of the related DocumentApprovedByConnections match this filter */
  approvedByConnection_ALL?: InputMaybe<DocumentApprovedByConnectionWhere>;
  /** Return Documents where none of the related DocumentApprovedByConnections match this filter */
  approvedByConnection_NONE?: InputMaybe<DocumentApprovedByConnectionWhere>;
  /** Return Documents where one of the related DocumentApprovedByConnections match this filter */
  approvedByConnection_SINGLE?: InputMaybe<DocumentApprovedByConnectionWhere>;
  /** Return Documents where some of the related DocumentApprovedByConnections match this filter */
  approvedByConnection_SOME?: InputMaybe<DocumentApprovedByConnectionWhere>;
  /** Return Documents where all of the related Users match this filter */
  approvedBy_ALL?: InputMaybe<UserWhere>;
  /** Return Documents where none of the related Users match this filter */
  approvedBy_NONE?: InputMaybe<UserWhere>;
  /** Return Documents where one of the related Users match this filter */
  approvedBy_SINGLE?: InputMaybe<UserWhere>;
  /** Return Documents where some of the related Users match this filter */
  approvedBy_SOME?: InputMaybe<UserWhere>;
  areExportValuesSaved?: InputMaybe<Scalars['Boolean']['input']>;
  assignedToAggregate?: InputMaybe<DocumentAssignedToAggregateInput>;
  /** Return Documents where all of the related DocumentAssignedToConnections match this filter */
  assignedToConnection_ALL?: InputMaybe<DocumentAssignedToConnectionWhere>;
  /** Return Documents where none of the related DocumentAssignedToConnections match this filter */
  assignedToConnection_NONE?: InputMaybe<DocumentAssignedToConnectionWhere>;
  /** Return Documents where one of the related DocumentAssignedToConnections match this filter */
  assignedToConnection_SINGLE?: InputMaybe<DocumentAssignedToConnectionWhere>;
  /** Return Documents where some of the related DocumentAssignedToConnections match this filter */
  assignedToConnection_SOME?: InputMaybe<DocumentAssignedToConnectionWhere>;
  /** Return Documents where all of the related Users match this filter */
  assignedTo_ALL?: InputMaybe<UserWhere>;
  /** Return Documents where none of the related Users match this filter */
  assignedTo_NONE?: InputMaybe<UserWhere>;
  /** Return Documents where one of the related Users match this filter */
  assignedTo_SINGLE?: InputMaybe<UserWhere>;
  /** Return Documents where some of the related Users match this filter */
  assignedTo_SOME?: InputMaybe<UserWhere>;
  beneficiary?: InputMaybe<DocumentBeneficiary>;
  beneficiary_IN?: InputMaybe<Array<InputMaybe<DocumentBeneficiary>>>;
  canApprove?: InputMaybe<Scalars['Boolean']['input']>;
  canBeSentToSmartMip?: InputMaybe<Scalars['Boolean']['input']>;
  canConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedByAggregate?: InputMaybe<DocumentConfirmedByAggregateInput>;
  /** Return Documents where all of the related DocumentConfirmedByConnections match this filter */
  confirmedByConnection_ALL?: InputMaybe<DocumentConfirmedByConnectionWhere>;
  /** Return Documents where none of the related DocumentConfirmedByConnections match this filter */
  confirmedByConnection_NONE?: InputMaybe<DocumentConfirmedByConnectionWhere>;
  /** Return Documents where one of the related DocumentConfirmedByConnections match this filter */
  confirmedByConnection_SINGLE?: InputMaybe<DocumentConfirmedByConnectionWhere>;
  /** Return Documents where some of the related DocumentConfirmedByConnections match this filter */
  confirmedByConnection_SOME?: InputMaybe<DocumentConfirmedByConnectionWhere>;
  /** Return Documents where all of the related Users match this filter */
  confirmedBy_ALL?: InputMaybe<UserWhere>;
  /** Return Documents where none of the related Users match this filter */
  confirmedBy_NONE?: InputMaybe<UserWhere>;
  /** Return Documents where one of the related Users match this filter */
  confirmedBy_SINGLE?: InputMaybe<UserWhere>;
  /** Return Documents where some of the related Users match this filter */
  confirmedBy_SOME?: InputMaybe<UserWhere>;
  counterParties?: InputMaybe<Scalars['String']['input']>;
  counterParties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterParties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterParties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterParties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterParties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod?: InputMaybe<Scalars['String']['input']>;
  coveragePeriodEnd?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_GT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_GTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  coveragePeriodEnd_LT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodEnd_LTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_GT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_GTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  coveragePeriodStart_LT?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriodStart_LTE?: InputMaybe<Scalars['Date']['input']>;
  coveragePeriod_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coveragePeriod_MATCHES?: InputMaybe<Scalars['String']['input']>;
  coveragePeriod_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<DocumentCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<DocumentCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<DocumentCreatedByConnectionWhere>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationMethod?: InputMaybe<DocumentCreationMethod>;
  creationMethod_IN?: InputMaybe<Array<InputMaybe<DocumentCreationMethod>>>;
  creatorOrgName?: InputMaybe<Scalars['String']['input']>;
  creatorOrgName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  creatorOrgName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatorOrgName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creatorOrgName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  creatorOrgName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatorTenantId?: InputMaybe<Scalars['String']['input']>;
  creatorTenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  creatorTenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatorTenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  creatorTenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  creatorTenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentReviewerOrganization_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReceiverBillingAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReceiverBillingAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReceiverDetails_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReceiverDetails_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReceiverLegalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReceiverLegalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentRefundGroupsAggregate?: InputMaybe<DocumentDocumentRefundGroupsAggregateInput>;
  /** Return Documents where all of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_ALL?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where none of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_NONE?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where one of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_SINGLE?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where some of the related DocumentDocumentRefundGroupsConnections match this filter */
  documentRefundGroupsConnection_SOME?: InputMaybe<DocumentDocumentRefundGroupsConnectionWhere>;
  /** Return Documents where all of the related DocumentRefundGroups match this filter */
  documentRefundGroups_ALL?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Documents where none of the related DocumentRefundGroups match this filter */
  documentRefundGroups_NONE?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Documents where one of the related DocumentRefundGroups match this filter */
  documentRefundGroups_SINGLE?: InputMaybe<DocumentRefundGroupWhere>;
  /** Return Documents where some of the related DocumentRefundGroups match this filter */
  documentRefundGroups_SOME?: InputMaybe<DocumentRefundGroupWhere>;
  documentSenderContactEmail?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactFirstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactFirstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactLastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactLastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderContactPhone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderContactPhone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderDomicile_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderDomicile_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderFax_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderFax_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSenderPhone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSenderPhone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dunningDate?: InputMaybe<Scalars['Date']['input']>;
  dunningDate_GT?: InputMaybe<Scalars['Date']['input']>;
  dunningDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  dunningDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  dunningDate_LT?: InputMaybe<Scalars['Date']['input']>;
  dunningDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  exposureLog?: InputMaybe<Scalars['String']['input']>;
  exposureLog_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  exposureLog_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  exposureLog_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exposureLog_MATCHES?: InputMaybe<Scalars['String']['input']>;
  exposureLog_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  invoiceAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  isConfirmedByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmedByExternalParty?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmedBySeller?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmedBySender?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSentForExternalReview?: InputMaybe<Scalars['Boolean']['input']>;
  isSentToSmartMip?: InputMaybe<Scalars['Boolean']['input']>;
  issuedOn?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  issuedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastChangedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastSentForSmartMipReview_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  messagesAggregate?: InputMaybe<DocumentMessagesAggregateInput>;
  /** Return Documents where all of the related DocumentMessagesConnections match this filter */
  messagesConnection_ALL?: InputMaybe<DocumentMessagesConnectionWhere>;
  /** Return Documents where none of the related DocumentMessagesConnections match this filter */
  messagesConnection_NONE?: InputMaybe<DocumentMessagesConnectionWhere>;
  /** Return Documents where one of the related DocumentMessagesConnections match this filter */
  messagesConnection_SINGLE?: InputMaybe<DocumentMessagesConnectionWhere>;
  /** Return Documents where some of the related DocumentMessagesConnections match this filter */
  messagesConnection_SOME?: InputMaybe<DocumentMessagesConnectionWhere>;
  /** Return Documents where all of the related DocumentMessages match this filter */
  messages_ALL?: InputMaybe<DocumentMessageWhere>;
  /** Return Documents where none of the related DocumentMessages match this filter */
  messages_NONE?: InputMaybe<DocumentMessageWhere>;
  /** Return Documents where one of the related DocumentMessages match this filter */
  messages_SINGLE?: InputMaybe<DocumentMessageWhere>;
  /** Return Documents where some of the related DocumentMessages match this filter */
  messages_SOME?: InputMaybe<DocumentMessageWhere>;
  orderNo?: InputMaybe<Scalars['String']['input']>;
  orderNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  orderNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  orderNo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderNo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  orderNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentReceiptPayer?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_GT?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_GTE?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  paymentReceiptPayer_LT?: InputMaybe<Scalars['Date']['input']>;
  paymentReceiptPayer_LTE?: InputMaybe<Scalars['Date']['input']>;
  paymentReferenceLyfegen?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentReferenceLyfegen_MATCHES?: InputMaybe<Scalars['String']['input']>;
  paymentReferenceLyfegen_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentReminderEmail?: InputMaybe<Scalars['String']['input']>;
  paymentReminderEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  paymentReminderEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentReminderEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  paymentReminderEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  paymentReminderEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  periodDateType?: InputMaybe<DocumentPeriodDateType>;
  periodDateType_IN?: InputMaybe<Array<InputMaybe<DocumentPeriodDateType>>>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundsAggregate?: InputMaybe<DocumentRefundsAggregateInput>;
  /** Return Documents where all of the related DocumentRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where none of the related DocumentRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where one of the related DocumentRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where some of the related DocumentRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<DocumentRefundsConnectionWhere>;
  /** Return Documents where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return Documents where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return Documents where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return Documents where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  rejectedByAggregate?: InputMaybe<DocumentRejectedByAggregateInput>;
  /** Return Documents where all of the related DocumentRejectedByConnections match this filter */
  rejectedByConnection_ALL?: InputMaybe<DocumentRejectedByConnectionWhere>;
  /** Return Documents where none of the related DocumentRejectedByConnections match this filter */
  rejectedByConnection_NONE?: InputMaybe<DocumentRejectedByConnectionWhere>;
  /** Return Documents where one of the related DocumentRejectedByConnections match this filter */
  rejectedByConnection_SINGLE?: InputMaybe<DocumentRejectedByConnectionWhere>;
  /** Return Documents where some of the related DocumentRejectedByConnections match this filter */
  rejectedByConnection_SOME?: InputMaybe<DocumentRejectedByConnectionWhere>;
  /** Return Documents where all of the related Users match this filter */
  rejectedBy_ALL?: InputMaybe<UserWhere>;
  /** Return Documents where none of the related Users match this filter */
  rejectedBy_NONE?: InputMaybe<UserWhere>;
  /** Return Documents where one of the related Users match this filter */
  rejectedBy_SINGLE?: InputMaybe<UserWhere>;
  /** Return Documents where some of the related Users match this filter */
  rejectedBy_SOME?: InputMaybe<UserWhere>;
  reviewRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  reviewRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  senderLegalName?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  senderLegalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  senderLegalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sentToReviewOn?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sentToReviewOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  settledOn?: InputMaybe<Scalars['Date']['input']>;
  settledOn_GT?: InputMaybe<Scalars['Date']['input']>;
  settledOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  settledOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  settledOn_LT?: InputMaybe<Scalars['Date']['input']>;
  settledOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  smartMipInvoiceFileId?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceFileId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceFileId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceFileId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smartMipInvoiceFileId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceFileId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceId?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smartMipInvoiceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  smartMipInvoiceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  smartMipReimbursementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipStatus?: InputMaybe<SmartMipDocumentStatus>;
  smartMipStatus_IN?: InputMaybe<Array<InputMaybe<SmartMipDocumentStatus>>>;
  status?: InputMaybe<DocumentStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  tagsAggregate?: InputMaybe<DocumentTagsAggregateInput>;
  /** Return Documents where all of the related DocumentTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<DocumentTagsConnectionWhere>;
  /** Return Documents where none of the related DocumentTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<DocumentTagsConnectionWhere>;
  /** Return Documents where one of the related DocumentTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<DocumentTagsConnectionWhere>;
  /** Return Documents where some of the related DocumentTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<DocumentTagsConnectionWhere>;
  /** Return Documents where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return Documents where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return Documents where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return Documents where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentType>;
  type_IN?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  uploadedOn?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uploadedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploadedVariantKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uploadedVariantKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentXmlReport = {
  __typename?: 'DocumentXmlReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  data: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type DocumentXmlReportAggregateSelection = {
  __typename?: 'DocumentXmlReportAggregateSelection';
  count: Scalars['Int']['output'];
  data: StringAggregateSelectionNonNullable;
  filename: StringAggregateSelectionNonNullable;
};

export type DocumentXmlReportEdge = {
  __typename?: 'DocumentXmlReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentXmlReport;
};

export type DocumentXmlReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentXmlReportSort objects to sort DocumentXmlReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentXmlReportSort>>;
};

/** Fields to sort DocumentXmlReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentXmlReportSort object. */
export type DocumentXmlReportSort = {
  data?: InputMaybe<SortDirection>;
  filename?: InputMaybe<SortDirection>;
};

export type DocumentXmlReportWhere = {
  AND?: InputMaybe<Array<DocumentXmlReportWhere>>;
  NOT?: InputMaybe<DocumentXmlReportWhere>;
  OR?: InputMaybe<Array<DocumentXmlReportWhere>>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filename_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  filename_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filename_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentXmlReportsConnection = {
  __typename?: 'DocumentXmlReportsConnection';
  edges: Array<DocumentXmlReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentsConnection = {
  __typename?: 'DocumentsConnection';
  edges: Array<DocumentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentsTableSourceFilterData = {
  __typename?: 'DocumentsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amountRanges: Array<AmountRange>;
  approvers: Array<Scalars['String']['output']>;
  approversOrganizations: Array<Scalars['String']['output']>;
  beneficiaries: Array<Scalars['String']['output']>;
  brandNames: Array<Scalars['String']['output']>;
  counterparties: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
  maxCoverageDate?: Maybe<Scalars['Date']['output']>;
  maxCreatedOn?: Maybe<Scalars['DateTime']['output']>;
  maxIssuedOn?: Maybe<Scalars['DateTime']['output']>;
  maxLastRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  maxPaymentReceiptPayer?: Maybe<Scalars['Date']['output']>;
  maxReviewRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  maxSentToReviewOn?: Maybe<Scalars['DateTime']['output']>;
  minCoverageDate?: Maybe<Scalars['Date']['output']>;
  minCreatedOn?: Maybe<Scalars['DateTime']['output']>;
  minIssuedOn?: Maybe<Scalars['DateTime']['output']>;
  minLastRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  minPaymentReceiptPayer?: Maybe<Scalars['Date']['output']>;
  minReviewRemindedOn?: Maybe<Scalars['DateTime']['output']>;
  minSentToReviewOn?: Maybe<Scalars['DateTime']['output']>;
  paymentReferenceLyfegens: Array<Scalars['String']['output']>;
  reviewersOrganizations: Array<Scalars['String']['output']>;
  smartMipReimbursementIds: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};

export type DocumentsTableSourceFilterDataAggregateSelection = {
  __typename?: 'DocumentsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  maxCreatedOn: DateTimeAggregateSelectionNullable;
  maxIssuedOn: DateTimeAggregateSelectionNullable;
  maxLastRemindedOn: DateTimeAggregateSelectionNullable;
  maxReviewRemindedOn: DateTimeAggregateSelectionNullable;
  maxSentToReviewOn: DateTimeAggregateSelectionNullable;
  minCreatedOn: DateTimeAggregateSelectionNullable;
  minIssuedOn: DateTimeAggregateSelectionNullable;
  minLastRemindedOn: DateTimeAggregateSelectionNullable;
  minReviewRemindedOn: DateTimeAggregateSelectionNullable;
  minSentToReviewOn: DateTimeAggregateSelectionNullable;
};

export type DocumentsTableSourceFilterDataConnection = {
  __typename?: 'DocumentsTableSourceFilterDataConnection';
  edges: Array<DocumentsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentsTableSourceFilterDataEdge = {
  __typename?: 'DocumentsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentsTableSourceFilterData;
};

export type DocumentsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DocumentsTableSourceFilterDataSort objects to sort DocumentsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DocumentsTableSourceFilterDataSort>>;
};

/** Fields to sort DocumentsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one DocumentsTableSourceFilterDataSort object. */
export type DocumentsTableSourceFilterDataSort = {
  maxCoverageDate?: InputMaybe<SortDirection>;
  maxCreatedOn?: InputMaybe<SortDirection>;
  maxIssuedOn?: InputMaybe<SortDirection>;
  maxLastRemindedOn?: InputMaybe<SortDirection>;
  maxPaymentReceiptPayer?: InputMaybe<SortDirection>;
  maxReviewRemindedOn?: InputMaybe<SortDirection>;
  maxSentToReviewOn?: InputMaybe<SortDirection>;
  minCoverageDate?: InputMaybe<SortDirection>;
  minCreatedOn?: InputMaybe<SortDirection>;
  minIssuedOn?: InputMaybe<SortDirection>;
  minLastRemindedOn?: InputMaybe<SortDirection>;
  minPaymentReceiptPayer?: InputMaybe<SortDirection>;
  minReviewRemindedOn?: InputMaybe<SortDirection>;
  minSentToReviewOn?: InputMaybe<SortDirection>;
};

export type DocumentsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<DocumentsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<DocumentsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<DocumentsTableSourceFilterDataWhere>>;
  approvers?: InputMaybe<Array<Scalars['String']['input']>>;
  approversOrganizations?: InputMaybe<Array<Scalars['String']['input']>>;
  approversOrganizations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  approvers_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  beneficiaries?: InputMaybe<Array<Scalars['String']['input']>>;
  beneficiaries_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  counterparties?: InputMaybe<Array<Scalars['String']['input']>>;
  counterparties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxCoverageDate?: InputMaybe<Scalars['Date']['input']>;
  maxCoverageDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxCoverageDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxCoverageDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxCoverageDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxCoverageDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  maxCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxCreatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxCreatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxCreatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxCreatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxCreatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxIssuedOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxIssuedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxIssuedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxIssuedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxIssuedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxIssuedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxLastRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxLastRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxLastRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxLastRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxLastRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxLastRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxPaymentReceiptPayer?: InputMaybe<Scalars['Date']['input']>;
  maxPaymentReceiptPayer_GT?: InputMaybe<Scalars['Date']['input']>;
  maxPaymentReceiptPayer_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxPaymentReceiptPayer_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxPaymentReceiptPayer_LT?: InputMaybe<Scalars['Date']['input']>;
  maxPaymentReceiptPayer_LTE?: InputMaybe<Scalars['Date']['input']>;
  maxReviewRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxReviewRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxReviewRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxReviewRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxReviewRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxReviewRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxSentToReviewOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxSentToReviewOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxSentToReviewOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxSentToReviewOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxSentToReviewOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxSentToReviewOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minCoverageDate?: InputMaybe<Scalars['Date']['input']>;
  minCoverageDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minCoverageDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minCoverageDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minCoverageDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minCoverageDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minCreatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  minCreatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minCreatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minCreatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minCreatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minCreatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minIssuedOn?: InputMaybe<Scalars['DateTime']['input']>;
  minIssuedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minIssuedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minIssuedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minIssuedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minIssuedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minLastRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  minLastRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minLastRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minLastRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minLastRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minLastRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minPaymentReceiptPayer?: InputMaybe<Scalars['Date']['input']>;
  minPaymentReceiptPayer_GT?: InputMaybe<Scalars['Date']['input']>;
  minPaymentReceiptPayer_GTE?: InputMaybe<Scalars['Date']['input']>;
  minPaymentReceiptPayer_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minPaymentReceiptPayer_LT?: InputMaybe<Scalars['Date']['input']>;
  minPaymentReceiptPayer_LTE?: InputMaybe<Scalars['Date']['input']>;
  minReviewRemindedOn?: InputMaybe<Scalars['DateTime']['input']>;
  minReviewRemindedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minReviewRemindedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minReviewRemindedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minReviewRemindedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minReviewRemindedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minSentToReviewOn?: InputMaybe<Scalars['DateTime']['input']>;
  minSentToReviewOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minSentToReviewOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minSentToReviewOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minSentToReviewOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minSentToReviewOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReferenceLyfegens?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentReferenceLyfegens_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  reviewersOrganizations?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewersOrganizations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  smartMipReimbursementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  types_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type Domain = {
  __typename?: 'Domain';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  children: Array<Domain>;
  childrenAggregate?: Maybe<DomainDomainChildrenAggregationSelection>;
  childrenConnection: DomainChildrenConnection;
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<DomainUserCreatedByAggregationSelection>;
  createdByConnection: DomainCreatedByConnection;
  createdOn: Scalars['DateTime']['output'];
  deletedByEmail?: Maybe<Scalars['String']['output']>;
  deletedOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Domain>;
  parentAggregate?: Maybe<DomainDomainParentAggregationSelection>;
  parentConnection: DomainParentConnection;
  productBlueprint: Array<ProductBlueprint>;
  productBlueprintAggregate?: Maybe<DomainProductBlueprintProductBlueprintAggregationSelection>;
  productBlueprintConnection: DomainProductBlueprintConnection;
  simulationCount: Scalars['Int']['output'];
  simulations: Array<Simulation>;
  simulationsAggregate?: Maybe<DomainSimulationSimulationsAggregationSelection>;
  simulationsConnection: DomainSimulationsConnection;
  tenantId: Scalars['String']['output'];
  userCount: Scalars['Int']['output'];
  users: Array<User>;
  usersAggregate?: Maybe<DomainUserUsersAggregationSelection>;
  usersConnection: DomainUsersConnection;
};


export type DomainChildrenArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainChildrenAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainChildrenConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainChildrenConnectionSort>>;
  where?: InputMaybe<DomainChildrenConnectionWhere>;
};


export type DomainCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DomainCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DomainCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainCreatedByConnectionSort>>;
  where?: InputMaybe<DomainCreatedByConnectionWhere>;
};


export type DomainParentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainParentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type DomainParentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainParentConnectionSort>>;
  where?: InputMaybe<DomainParentConnectionWhere>;
};


export type DomainProductBlueprintArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProductBlueprintOptions>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type DomainProductBlueprintAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type DomainProductBlueprintConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainProductBlueprintConnectionSort>>;
  where?: InputMaybe<DomainProductBlueprintConnectionWhere>;
};


export type DomainSimulationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SimulationOptions>;
  where?: InputMaybe<SimulationWhere>;
};


export type DomainSimulationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SimulationWhere>;
};


export type DomainSimulationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainSimulationsConnectionSort>>;
  where?: InputMaybe<DomainSimulationsConnectionWhere>;
};


export type DomainUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type DomainUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type DomainUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<DomainUsersConnectionSort>>;
  where?: InputMaybe<DomainUsersConnectionWhere>;
};

export type DomainAggregateSelection = {
  __typename?: 'DomainAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainChildrenAggregateInput = {
  AND?: InputMaybe<Array<DomainChildrenAggregateInput>>;
  NOT?: InputMaybe<DomainChildrenAggregateInput>;
  OR?: InputMaybe<Array<DomainChildrenAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainChildrenNodeAggregationWhereInput>;
};

export type DomainChildrenConnection = {
  __typename?: 'DomainChildrenConnection';
  edges: Array<DomainChildrenRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainChildrenConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type DomainChildrenConnectionWhere = {
  AND?: InputMaybe<Array<DomainChildrenConnectionWhere>>;
  NOT?: InputMaybe<DomainChildrenConnectionWhere>;
  OR?: InputMaybe<Array<DomainChildrenConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type DomainChildrenNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainChildrenNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainChildrenNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainChildrenNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainChildrenRelationship = {
  __typename?: 'DomainChildrenRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainCreatedByAggregateInput = {
  AND?: InputMaybe<Array<DomainCreatedByAggregateInput>>;
  NOT?: InputMaybe<DomainCreatedByAggregateInput>;
  OR?: InputMaybe<Array<DomainCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainCreatedByNodeAggregationWhereInput>;
};

export type DomainCreatedByConnection = {
  __typename?: 'DomainCreatedByConnection';
  edges: Array<DomainCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DomainCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<DomainCreatedByConnectionWhere>>;
  NOT?: InputMaybe<DomainCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<DomainCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DomainCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainCreatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainCreatedByRelationship = {
  __typename?: 'DomainCreatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DomainDomainChildrenAggregationSelection = {
  __typename?: 'DomainDomainChildrenAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DomainDomainChildrenNodeAggregateSelection>;
};

export type DomainDomainChildrenNodeAggregateSelection = {
  __typename?: 'DomainDomainChildrenNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainDomainParentAggregationSelection = {
  __typename?: 'DomainDomainParentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DomainDomainParentNodeAggregateSelection>;
};

export type DomainDomainParentNodeAggregateSelection = {
  __typename?: 'DomainDomainParentNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainEdge = {
  __typename?: 'DomainEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DomainSort objects to sort Domains by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DomainSort>>;
};

export type DomainParentAggregateInput = {
  AND?: InputMaybe<Array<DomainParentAggregateInput>>;
  NOT?: InputMaybe<DomainParentAggregateInput>;
  OR?: InputMaybe<Array<DomainParentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainParentNodeAggregationWhereInput>;
};

export type DomainParentConnection = {
  __typename?: 'DomainParentConnection';
  edges: Array<DomainParentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainParentConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type DomainParentConnectionWhere = {
  AND?: InputMaybe<Array<DomainParentConnectionWhere>>;
  NOT?: InputMaybe<DomainParentConnectionWhere>;
  OR?: InputMaybe<Array<DomainParentConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type DomainParentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainParentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainParentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainParentNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainParentRelationship = {
  __typename?: 'DomainParentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainProductBlueprintAggregateInput = {
  AND?: InputMaybe<Array<DomainProductBlueprintAggregateInput>>;
  NOT?: InputMaybe<DomainProductBlueprintAggregateInput>;
  OR?: InputMaybe<Array<DomainProductBlueprintAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainProductBlueprintNodeAggregationWhereInput>;
};

export type DomainProductBlueprintConnection = {
  __typename?: 'DomainProductBlueprintConnection';
  edges: Array<DomainProductBlueprintRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainProductBlueprintConnectionSort = {
  node?: InputMaybe<ProductBlueprintSort>;
};

export type DomainProductBlueprintConnectionWhere = {
  AND?: InputMaybe<Array<DomainProductBlueprintConnectionWhere>>;
  NOT?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  OR?: InputMaybe<Array<DomainProductBlueprintConnectionWhere>>;
  node?: InputMaybe<ProductBlueprintWhere>;
};

export type DomainProductBlueprintNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainProductBlueprintNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainProductBlueprintNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainProductBlueprintNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formValues_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indication_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  productName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DomainProductBlueprintProductBlueprintAggregationSelection = {
  __typename?: 'DomainProductBlueprintProductBlueprintAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DomainProductBlueprintProductBlueprintNodeAggregateSelection>;
};

export type DomainProductBlueprintProductBlueprintNodeAggregateSelection = {
  __typename?: 'DomainProductBlueprintProductBlueprintNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNonNullable;
  formValues: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indication: StringAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  productName: StringAggregateSelectionNonNullable;
  publishedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  updatedOn: DateTimeAggregateSelectionNonNullable;
};

export type DomainProductBlueprintRelationship = {
  __typename?: 'DomainProductBlueprintRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ProductBlueprint;
};

export type DomainSimulationSimulationsAggregationSelection = {
  __typename?: 'DomainSimulationSimulationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DomainSimulationSimulationsNodeAggregateSelection>;
};

export type DomainSimulationSimulationsNodeAggregateSelection = {
  __typename?: 'DomainSimulationSimulationsNodeAggregateSelection';
  businessCase: StringAggregateSelectionNullable;
  comments: StringAggregateSelectionNullable;
  configuration: StringAggregateSelectionNonNullable;
  counterparty: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  domainName: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  lastUpdatedByEmail: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  lockedSections: StringAggregateSelectionNullable;
  model: StringAggregateSelectionNonNullable;
  product: StringAggregateSelectionNonNullable;
  shortName: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  version: IntAggregateSelectionNonNullable;
};

export type DomainSimulationsAggregateInput = {
  AND?: InputMaybe<Array<DomainSimulationsAggregateInput>>;
  NOT?: InputMaybe<DomainSimulationsAggregateInput>;
  OR?: InputMaybe<Array<DomainSimulationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainSimulationsNodeAggregationWhereInput>;
};

export type DomainSimulationsConnection = {
  __typename?: 'DomainSimulationsConnection';
  edges: Array<DomainSimulationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainSimulationsConnectionSort = {
  node?: InputMaybe<SimulationSort>;
};

export type DomainSimulationsConnectionWhere = {
  AND?: InputMaybe<Array<DomainSimulationsConnectionWhere>>;
  NOT?: InputMaybe<DomainSimulationsConnectionWhere>;
  OR?: InputMaybe<Array<DomainSimulationsConnectionWhere>>;
  node?: InputMaybe<SimulationWhere>;
};

export type DomainSimulationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainSimulationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainSimulationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainSimulationsNodeAggregationWhereInput>>;
  businessCase_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domainName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSections_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  model_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainSimulationsRelationship = {
  __typename?: 'DomainSimulationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Simulation;
};

/** Fields to sort Domains by. The order in which sorts are applied is not guaranteed when specifying many fields in one DomainSort object. */
export type DomainSort = {
  createdOn?: InputMaybe<SortDirection>;
  deletedByEmail?: InputMaybe<SortDirection>;
  deletedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  level?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  simulationCount?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  userCount?: InputMaybe<SortDirection>;
};

export type DomainUserCreatedByAggregationSelection = {
  __typename?: 'DomainUserCreatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DomainUserCreatedByNodeAggregateSelection>;
};

export type DomainUserCreatedByNodeAggregateSelection = {
  __typename?: 'DomainUserCreatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainUserUsersAggregationSelection = {
  __typename?: 'DomainUserUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<DomainUserUsersNodeAggregateSelection>;
};

export type DomainUserUsersNodeAggregateSelection = {
  __typename?: 'DomainUserUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type DomainUsersAggregateInput = {
  AND?: InputMaybe<Array<DomainUsersAggregateInput>>;
  NOT?: InputMaybe<DomainUsersAggregateInput>;
  OR?: InputMaybe<Array<DomainUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<DomainUsersNodeAggregationWhereInput>;
};

export type DomainUsersConnection = {
  __typename?: 'DomainUsersConnection';
  edges: Array<DomainUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DomainUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type DomainUsersConnectionWhere = {
  AND?: InputMaybe<Array<DomainUsersConnectionWhere>>;
  NOT?: InputMaybe<DomainUsersConnectionWhere>;
  OR?: InputMaybe<Array<DomainUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type DomainUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<DomainUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<DomainUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<DomainUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type DomainUsersRelationship = {
  __typename?: 'DomainUsersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type DomainWhere = {
  AND?: InputMaybe<Array<DomainWhere>>;
  NOT?: InputMaybe<DomainWhere>;
  OR?: InputMaybe<Array<DomainWhere>>;
  childrenAggregate?: InputMaybe<DomainChildrenAggregateInput>;
  /** Return Domains where all of the related DomainChildrenConnections match this filter */
  childrenConnection_ALL?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where none of the related DomainChildrenConnections match this filter */
  childrenConnection_NONE?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where one of the related DomainChildrenConnections match this filter */
  childrenConnection_SINGLE?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where some of the related DomainChildrenConnections match this filter */
  childrenConnection_SOME?: InputMaybe<DomainChildrenConnectionWhere>;
  /** Return Domains where all of the related Domains match this filter */
  children_ALL?: InputMaybe<DomainWhere>;
  /** Return Domains where none of the related Domains match this filter */
  children_NONE?: InputMaybe<DomainWhere>;
  /** Return Domains where one of the related Domains match this filter */
  children_SINGLE?: InputMaybe<DomainWhere>;
  /** Return Domains where some of the related Domains match this filter */
  children_SOME?: InputMaybe<DomainWhere>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<DomainCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<DomainCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<DomainCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  deletedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  level_GT?: InputMaybe<Scalars['Int']['input']>;
  level_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  level_LT?: InputMaybe<Scalars['Int']['input']>;
  level_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<DomainWhere>;
  parentAggregate?: InputMaybe<DomainParentAggregateInput>;
  parentConnection?: InputMaybe<DomainParentConnectionWhere>;
  parentConnection_NOT?: InputMaybe<DomainParentConnectionWhere>;
  parent_NOT?: InputMaybe<DomainWhere>;
  productBlueprintAggregate?: InputMaybe<DomainProductBlueprintAggregateInput>;
  /** Return Domains where all of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_ALL?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where none of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_NONE?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where one of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_SINGLE?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where some of the related DomainProductBlueprintConnections match this filter */
  productBlueprintConnection_SOME?: InputMaybe<DomainProductBlueprintConnectionWhere>;
  /** Return Domains where all of the related ProductBlueprints match this filter */
  productBlueprint_ALL?: InputMaybe<ProductBlueprintWhere>;
  /** Return Domains where none of the related ProductBlueprints match this filter */
  productBlueprint_NONE?: InputMaybe<ProductBlueprintWhere>;
  /** Return Domains where one of the related ProductBlueprints match this filter */
  productBlueprint_SINGLE?: InputMaybe<ProductBlueprintWhere>;
  /** Return Domains where some of the related ProductBlueprints match this filter */
  productBlueprint_SOME?: InputMaybe<ProductBlueprintWhere>;
  simulationsAggregate?: InputMaybe<DomainSimulationsAggregateInput>;
  /** Return Domains where all of the related DomainSimulationsConnections match this filter */
  simulationsConnection_ALL?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where none of the related DomainSimulationsConnections match this filter */
  simulationsConnection_NONE?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where one of the related DomainSimulationsConnections match this filter */
  simulationsConnection_SINGLE?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where some of the related DomainSimulationsConnections match this filter */
  simulationsConnection_SOME?: InputMaybe<DomainSimulationsConnectionWhere>;
  /** Return Domains where all of the related Simulations match this filter */
  simulations_ALL?: InputMaybe<SimulationWhere>;
  /** Return Domains where none of the related Simulations match this filter */
  simulations_NONE?: InputMaybe<SimulationWhere>;
  /** Return Domains where one of the related Simulations match this filter */
  simulations_SINGLE?: InputMaybe<SimulationWhere>;
  /** Return Domains where some of the related Simulations match this filter */
  simulations_SOME?: InputMaybe<SimulationWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<DomainUsersAggregateInput>;
  /** Return Domains where all of the related DomainUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where none of the related DomainUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where one of the related DomainUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where some of the related DomainUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<DomainUsersConnectionWhere>;
  /** Return Domains where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return Domains where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return Domains where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return Domains where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type DomainsConnection = {
  __typename?: 'DomainsConnection';
  edges: Array<DomainEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DownloadSmartMipInvoicePdfInput = {
  documentId: Scalars['ID']['input'];
};

export type DownloadablePublicAgreement = {
  __typename?: 'DownloadablePublicAgreement';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  disease?: Maybe<Scalars['String']['output']>;
  indication?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  measures?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  sourceUrls?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  therapeuticArea?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type DownloadablePublicAgreementAggregateSelection = {
  __typename?: 'DownloadablePublicAgreementAggregateSelection';
  count: Scalars['Int']['output'];
  country: StringAggregateSelectionNullable;
  disease: StringAggregateSelectionNullable;
  indication: StringAggregateSelectionNullable;
  manufacturer: StringAggregateSelectionNullable;
  measures: StringAggregateSelectionNullable;
  models: StringAggregateSelectionNullable;
  payer: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNullable;
  productType: StringAggregateSelectionNullable;
  region: StringAggregateSelectionNullable;
  sourceUrls: StringAggregateSelectionNullable;
  status: StringAggregateSelectionNullable;
  summary: StringAggregateSelectionNullable;
  therapeuticArea: StringAggregateSelectionNullable;
  year: StringAggregateSelectionNullable;
};

export type DownloadablePublicAgreementEdge = {
  __typename?: 'DownloadablePublicAgreementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DownloadablePublicAgreement;
};

export type DownloadablePublicAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DownloadablePublicAgreementSort objects to sort DownloadablePublicAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DownloadablePublicAgreementSort>>;
};

/** Fields to sort DownloadablePublicAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one DownloadablePublicAgreementSort object. */
export type DownloadablePublicAgreementSort = {
  country?: InputMaybe<SortDirection>;
  disease?: InputMaybe<SortDirection>;
  indication?: InputMaybe<SortDirection>;
  manufacturer?: InputMaybe<SortDirection>;
  measures?: InputMaybe<SortDirection>;
  models?: InputMaybe<SortDirection>;
  payer?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  productType?: InputMaybe<SortDirection>;
  region?: InputMaybe<SortDirection>;
  sourceUrls?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  therapeuticArea?: InputMaybe<SortDirection>;
  year?: InputMaybe<SortDirection>;
};

export type DownloadablePublicAgreementWhere = {
  AND?: InputMaybe<Array<DownloadablePublicAgreementWhere>>;
  NOT?: InputMaybe<DownloadablePublicAgreementWhere>;
  OR?: InputMaybe<Array<DownloadablePublicAgreementWhere>>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  country_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  country_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  country_MATCHES?: InputMaybe<Scalars['String']['input']>;
  country_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  disease?: InputMaybe<Scalars['String']['input']>;
  disease_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  disease_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  disease_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disease_MATCHES?: InputMaybe<Scalars['String']['input']>;
  disease_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indication?: InputMaybe<Scalars['String']['input']>;
  indication_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indication_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indication_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indication_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indication_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  manufacturer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  manufacturer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manufacturer_MATCHES?: InputMaybe<Scalars['String']['input']>;
  manufacturer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  measures?: InputMaybe<Scalars['String']['input']>;
  measures_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  measures_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  measures_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  measures_MATCHES?: InputMaybe<Scalars['String']['input']>;
  measures_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  models?: InputMaybe<Scalars['String']['input']>;
  models_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  models_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  models_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  models_MATCHES?: InputMaybe<Scalars['String']['input']>;
  models_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  payer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  payer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  payer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payer_MATCHES?: InputMaybe<Scalars['String']['input']>;
  payer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  productType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  productType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  productType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  productType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  region_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  region_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  region_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  region_MATCHES?: InputMaybe<Scalars['String']['input']>;
  region_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUrls?: InputMaybe<Scalars['String']['input']>;
  sourceUrls_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceUrls_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUrls_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceUrls_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceUrls_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_MATCHES?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_MATCHES?: InputMaybe<Scalars['String']['input']>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  therapeuticArea_MATCHES?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  year_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  year_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  year_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  year_MATCHES?: InputMaybe<Scalars['String']['input']>;
  year_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadablePublicAgreementsConnection = {
  __typename?: 'DownloadablePublicAgreementsConnection';
  edges: Array<DownloadablePublicAgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DummyEnumReferences = {
  __typename?: 'DummyEnumReferences';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEvent?: Maybe<IrAdverseEvents>;
  adverseEventGrades?: Maybe<AdverseEventGrades>;
  canadianPriceType?: Maybe<CanadianPriceType>;
  cycleAdherence?: Maybe<CycleAdherence>;
  cycleStartingPoint?: Maybe<CycleStartingPoint>;
  decision?: Maybe<CoverageRequestTherapyDecision>;
  dosageModification?: Maybe<IrAdverseEventDoseModifications>;
  irAdverseEventGrade?: Maybe<IrAdverseEventGrades>;
  ldlTestUom?: Maybe<LdlTestUom>;
  pathologicalResponse?: Maybe<PathologicalResponseType>;
  physicianTitle?: Maybe<TreatingPhysicianTitle>;
  rating?: Maybe<CoverageRequestRating>;
  response?: Maybe<ResponseType>;
  responseType?: Maybe<ResponseType>;
  result?: Maybe<IrResultOptions>;
  scopeId?: Maybe<ScopeId>;
  smartMipReimbursementType?: Maybe<SmartMipReimbursementType>;
  testPurposeType?: Maybe<TestPurposeType>;
  testType?: Maybe<TestType>;
  testUoMType?: Maybe<TestUoMType>;
  transfusionType?: Maybe<TransfusionType>;
  unitedResponseType?: Maybe<UnitedResponseType>;
};

export type DummyEnumReferencesAggregateSelection = {
  __typename?: 'DummyEnumReferencesAggregateSelection';
  count: Scalars['Int']['output'];
};

export type DummyEnumReferencesConnection = {
  __typename?: 'DummyEnumReferencesConnection';
  edges: Array<DummyEnumReferencesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DummyEnumReferencesEdge = {
  __typename?: 'DummyEnumReferencesEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DummyEnumReferences;
};

export type DummyEnumReferencesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more DummyEnumReferencesSort objects to sort DummyEnumReferences by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<DummyEnumReferencesSort>>;
};

/** Fields to sort DummyEnumReferences by. The order in which sorts are applied is not guaranteed when specifying many fields in one DummyEnumReferencesSort object. */
export type DummyEnumReferencesSort = {
  adverseEvent?: InputMaybe<SortDirection>;
  adverseEventGrades?: InputMaybe<SortDirection>;
  canadianPriceType?: InputMaybe<SortDirection>;
  cycleAdherence?: InputMaybe<SortDirection>;
  cycleStartingPoint?: InputMaybe<SortDirection>;
  decision?: InputMaybe<SortDirection>;
  dosageModification?: InputMaybe<SortDirection>;
  irAdverseEventGrade?: InputMaybe<SortDirection>;
  ldlTestUom?: InputMaybe<SortDirection>;
  pathologicalResponse?: InputMaybe<SortDirection>;
  physicianTitle?: InputMaybe<SortDirection>;
  rating?: InputMaybe<SortDirection>;
  response?: InputMaybe<SortDirection>;
  responseType?: InputMaybe<SortDirection>;
  result?: InputMaybe<SortDirection>;
  scopeId?: InputMaybe<SortDirection>;
  smartMipReimbursementType?: InputMaybe<SortDirection>;
  testPurposeType?: InputMaybe<SortDirection>;
  testType?: InputMaybe<SortDirection>;
  testUoMType?: InputMaybe<SortDirection>;
  transfusionType?: InputMaybe<SortDirection>;
  unitedResponseType?: InputMaybe<SortDirection>;
};

export type DummyEnumReferencesWhere = {
  AND?: InputMaybe<Array<DummyEnumReferencesWhere>>;
  NOT?: InputMaybe<DummyEnumReferencesWhere>;
  OR?: InputMaybe<Array<DummyEnumReferencesWhere>>;
  adverseEvent?: InputMaybe<IrAdverseEvents>;
  adverseEventGrades?: InputMaybe<AdverseEventGrades>;
  adverseEventGrades_IN?: InputMaybe<Array<InputMaybe<AdverseEventGrades>>>;
  adverseEvent_IN?: InputMaybe<Array<InputMaybe<IrAdverseEvents>>>;
  canadianPriceType?: InputMaybe<CanadianPriceType>;
  canadianPriceType_IN?: InputMaybe<Array<InputMaybe<CanadianPriceType>>>;
  cycleAdherence?: InputMaybe<CycleAdherence>;
  cycleAdherence_IN?: InputMaybe<Array<InputMaybe<CycleAdherence>>>;
  cycleStartingPoint?: InputMaybe<CycleStartingPoint>;
  cycleStartingPoint_IN?: InputMaybe<Array<InputMaybe<CycleStartingPoint>>>;
  decision?: InputMaybe<CoverageRequestTherapyDecision>;
  decision_IN?: InputMaybe<Array<InputMaybe<CoverageRequestTherapyDecision>>>;
  dosageModification?: InputMaybe<IrAdverseEventDoseModifications>;
  dosageModification_IN?: InputMaybe<Array<InputMaybe<IrAdverseEventDoseModifications>>>;
  irAdverseEventGrade?: InputMaybe<IrAdverseEventGrades>;
  irAdverseEventGrade_IN?: InputMaybe<Array<InputMaybe<IrAdverseEventGrades>>>;
  ldlTestUom?: InputMaybe<LdlTestUom>;
  ldlTestUom_IN?: InputMaybe<Array<InputMaybe<LdlTestUom>>>;
  pathologicalResponse?: InputMaybe<PathologicalResponseType>;
  pathologicalResponse_IN?: InputMaybe<Array<InputMaybe<PathologicalResponseType>>>;
  physicianTitle?: InputMaybe<TreatingPhysicianTitle>;
  physicianTitle_IN?: InputMaybe<Array<InputMaybe<TreatingPhysicianTitle>>>;
  rating?: InputMaybe<CoverageRequestRating>;
  rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
  response?: InputMaybe<ResponseType>;
  responseType?: InputMaybe<ResponseType>;
  responseType_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
  response_IN?: InputMaybe<Array<InputMaybe<ResponseType>>>;
  result?: InputMaybe<IrResultOptions>;
  result_IN?: InputMaybe<Array<InputMaybe<IrResultOptions>>>;
  scopeId?: InputMaybe<ScopeId>;
  scopeId_IN?: InputMaybe<Array<InputMaybe<ScopeId>>>;
  smartMipReimbursementType?: InputMaybe<SmartMipReimbursementType>;
  smartMipReimbursementType_IN?: InputMaybe<Array<InputMaybe<SmartMipReimbursementType>>>;
  testPurposeType?: InputMaybe<TestPurposeType>;
  testPurposeType_IN?: InputMaybe<Array<InputMaybe<TestPurposeType>>>;
  testType?: InputMaybe<TestType>;
  testType_IN?: InputMaybe<Array<InputMaybe<TestType>>>;
  testUoMType?: InputMaybe<TestUoMType>;
  testUoMType_IN?: InputMaybe<Array<InputMaybe<TestUoMType>>>;
  transfusionType?: InputMaybe<TransfusionType>;
  transfusionType_IN?: InputMaybe<Array<InputMaybe<TransfusionType>>>;
  unitedResponseType?: InputMaybe<UnitedResponseType>;
  unitedResponseType_IN?: InputMaybe<Array<InputMaybe<UnitedResponseType>>>;
};

export type EligibilityConditionSet = {
  __typename?: 'EligibilityConditionSet';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  inputLabel?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<EligibilityConditionSetTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: EligibilityConditionSetTreatmentsConnection;
};


export type EligibilityConditionSetTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type EligibilityConditionSetTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type EligibilityConditionSetTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EligibilityConditionSetTreatmentsConnectionSort>>;
  where?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
};

export type EligibilityConditionSetAggregateSelection = {
  __typename?: 'EligibilityConditionSetAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  inputLabel: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
};

export type EligibilityConditionSetEdge = {
  __typename?: 'EligibilityConditionSetEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EligibilityConditionSet;
};

export type EligibilityConditionSetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EligibilityConditionSetSort objects to sort EligibilityConditionSets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EligibilityConditionSetSort>>;
};

/** Fields to sort EligibilityConditionSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one EligibilityConditionSetSort object. */
export type EligibilityConditionSetSort = {
  code?: InputMaybe<SortDirection>;
  inputLabel?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type EligibilityConditionSetTreatmentTreatmentsAggregationSelection = {
  __typename?: 'EligibilityConditionSetTreatmentTreatmentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection>;
};

export type EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'EligibilityConditionSetTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type EligibilityConditionSetTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<EligibilityConditionSetTreatmentsAggregateInput>>;
  NOT?: InputMaybe<EligibilityConditionSetTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<EligibilityConditionSetTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>;
};

export type EligibilityConditionSetTreatmentsConnection = {
  __typename?: 'EligibilityConditionSetTreatmentsConnection';
  edges: Array<EligibilityConditionSetTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EligibilityConditionSetTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type EligibilityConditionSetTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<EligibilityConditionSetTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<EligibilityConditionSetTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type EligibilityConditionSetTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<EligibilityConditionSetTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EligibilityConditionSetTreatmentsRelationship = {
  __typename?: 'EligibilityConditionSetTreatmentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type EligibilityConditionSetWhere = {
  AND?: InputMaybe<Array<EligibilityConditionSetWhere>>;
  NOT?: InputMaybe<EligibilityConditionSetWhere>;
  OR?: InputMaybe<Array<EligibilityConditionSetWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  inputLabel?: InputMaybe<Scalars['String']['input']>;
  inputLabel_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  inputLabel_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  inputLabel_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputLabel_MATCHES?: InputMaybe<Scalars['String']['input']>;
  inputLabel_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentsAggregate?: InputMaybe<EligibilityConditionSetTreatmentsAggregateInput>;
  /** Return EligibilityConditionSets where all of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where none of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where one of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where some of the related EligibilityConditionSetTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<EligibilityConditionSetTreatmentsConnectionWhere>;
  /** Return EligibilityConditionSets where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return EligibilityConditionSets where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return EligibilityConditionSets where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return EligibilityConditionSets where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
};

export type EligibilityConditionSetsConnection = {
  __typename?: 'EligibilityConditionSetsConnection';
  edges: Array<EligibilityConditionSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeature = {
  __typename?: 'EncapsulatedFeature';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EncapsulatedFeatureAggregateSelection = {
  __typename?: 'EncapsulatedFeatureAggregateSelection';
  count: Scalars['Int']['output'];
  key: StringAggregateSelectionNonNullable;
  title: StringAggregateSelectionNonNullable;
};

export type EncapsulatedFeatureConfiguration = {
  __typename?: 'EncapsulatedFeatureConfiguration';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  ofType: EncapsulatedFeature;
  ofTypeAggregate?: Maybe<EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection>;
  ofTypeConnection: EncapsulatedFeatureConfigurationOfTypeConnection;
  setFor: Organization;
  setForAggregate?: Maybe<EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection>;
  setForConnection: EncapsulatedFeatureConfigurationSetForConnection;
  value?: Maybe<Scalars['String']['output']>;
};


export type EncapsulatedFeatureConfigurationOfTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EncapsulatedFeatureOptions>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type EncapsulatedFeatureConfigurationOfTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type EncapsulatedFeatureConfigurationOfTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeConnectionSort>>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
};


export type EncapsulatedFeatureConfigurationSetForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type EncapsulatedFeatureConfigurationSetForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type EncapsulatedFeatureConfigurationSetForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForConnectionSort>>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
};

export type EncapsulatedFeatureConfigurationAggregateSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationAggregateSelection';
  count: Scalars['Int']['output'];
  value: StringAggregateSelectionNullable;
};

export type EncapsulatedFeatureConfigurationEdge = {
  __typename?: 'EncapsulatedFeatureConfigurationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeatureConfiguration;
};

export type EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection>;
};

export type EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationEncapsulatedFeatureOfTypeNodeAggregateSelection';
  key: StringAggregateSelectionNonNullable;
  title: StringAggregateSelectionNonNullable;
};

export type EncapsulatedFeatureConfigurationOfTypeAggregateInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeAggregateInput>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeAggregateInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>;
};

export type EncapsulatedFeatureConfigurationOfTypeConnection = {
  __typename?: 'EncapsulatedFeatureConfigurationOfTypeConnection';
  edges: Array<EncapsulatedFeatureConfigurationOfTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeatureConfigurationOfTypeConnectionSort = {
  node?: InputMaybe<EncapsulatedFeatureSort>;
};

export type EncapsulatedFeatureConfigurationOfTypeConnectionWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>>;
  node?: InputMaybe<EncapsulatedFeatureWhere>;
};

export type EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationOfTypeNodeAggregationWhereInput>>;
  key_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  key_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  key_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  key_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  title_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  title_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  title_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EncapsulatedFeatureConfigurationOfTypeRelationship = {
  __typename?: 'EncapsulatedFeatureConfigurationOfTypeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeature;
};

export type EncapsulatedFeatureConfigurationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EncapsulatedFeatureConfigurationSort objects to sort EncapsulatedFeatureConfigurations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EncapsulatedFeatureConfigurationSort>>;
};

export type EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationOrganizationSetForAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection>;
};

export type EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection = {
  __typename?: 'EncapsulatedFeatureConfigurationOrganizationSetForNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type EncapsulatedFeatureConfigurationSetForAggregateInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForAggregateInput>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForAggregateInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>;
};

export type EncapsulatedFeatureConfigurationSetForConnection = {
  __typename?: 'EncapsulatedFeatureConfigurationSetForConnection';
  edges: Array<EncapsulatedFeatureConfigurationSetForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeatureConfigurationSetForConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type EncapsulatedFeatureConfigurationSetForConnectionWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForConnectionWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationSetForNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EncapsulatedFeatureConfigurationSetForRelationship = {
  __typename?: 'EncapsulatedFeatureConfigurationSetForRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** Fields to sort EncapsulatedFeatureConfigurations by. The order in which sorts are applied is not guaranteed when specifying many fields in one EncapsulatedFeatureConfigurationSort object. */
export type EncapsulatedFeatureConfigurationSort = {
  isEnabled?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type EncapsulatedFeatureConfigurationWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureConfigurationWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureConfigurationWhere>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ofType?: InputMaybe<EncapsulatedFeatureWhere>;
  ofTypeAggregate?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeAggregateInput>;
  ofTypeConnection?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
  ofTypeConnection_NOT?: InputMaybe<EncapsulatedFeatureConfigurationOfTypeConnectionWhere>;
  ofType_NOT?: InputMaybe<EncapsulatedFeatureWhere>;
  setFor?: InputMaybe<OrganizationWhere>;
  setForAggregate?: InputMaybe<EncapsulatedFeatureConfigurationSetForAggregateInput>;
  setForConnection?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
  setForConnection_NOT?: InputMaybe<EncapsulatedFeatureConfigurationSetForConnectionWhere>;
  setFor_NOT?: InputMaybe<OrganizationWhere>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_MATCHES?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EncapsulatedFeatureConfigurationsConnection = {
  __typename?: 'EncapsulatedFeatureConfigurationsConnection';
  edges: Array<EncapsulatedFeatureConfigurationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EncapsulatedFeatureEdge = {
  __typename?: 'EncapsulatedFeatureEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeature;
};

export type EncapsulatedFeatureOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EncapsulatedFeatureSort objects to sort EncapsulatedFeatures by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EncapsulatedFeatureSort>>;
};

/** Fields to sort EncapsulatedFeatures by. The order in which sorts are applied is not guaranteed when specifying many fields in one EncapsulatedFeatureSort object. */
export type EncapsulatedFeatureSort = {
  key?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export type EncapsulatedFeatureWhere = {
  AND?: InputMaybe<Array<EncapsulatedFeatureWhere>>;
  NOT?: InputMaybe<EncapsulatedFeatureWhere>;
  OR?: InputMaybe<Array<EncapsulatedFeatureWhere>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  title_MATCHES?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EncapsulatedFeaturesConnection = {
  __typename?: 'EncapsulatedFeaturesConnection';
  edges: Array<EncapsulatedFeatureEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingCondition = {
  __typename?: 'EnrollingCondition';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  attributeValue?: Maybe<Scalars['String']['output']>;
  bothOperatorFirst?: Maybe<ArithmeticalOperator>;
  bothOperatorSecond?: Maybe<ArithmeticalOperator>;
  conditionType: EnrollingConditionType;
  countdownOperator?: Maybe<CountdownOperator>;
  customCondition?: Maybe<CustomCondition>;
  customConditionAggregate?: Maybe<EnrollingConditionCustomConditionCustomConditionAggregationSelection>;
  customConditionConnection: EnrollingConditionCustomConditionConnection;
  cycleLimitFrom?: Maybe<Scalars['Int']['output']>;
  cycleLimitTo?: Maybe<Scalars['Int']['output']>;
  includedGenerics: Array<Generic>;
  includedGenericsAggregate?: Maybe<EnrollingConditionGenericIncludedGenericsAggregationSelection>;
  includedGenericsConnection: EnrollingConditionIncludedGenericsConnection;
  inclusionType?: Maybe<InclusionType>;
  operator?: Maybe<ArithmeticalOperator>;
  rangeInputEnd?: Maybe<Scalars['Int']['output']>;
  rangeInputStart?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Array<CoverageRequestRating>>;
  resultSelectionType?: Maybe<ResultSelectionType>;
  therapyDecision?: Maybe<Array<CoverageRequestTherapyDecision>>;
  timeframeRangeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeStart?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeStartingPoint?: Maybe<TimeframeStartingPoint>;
};


export type EnrollingConditionCustomConditionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type EnrollingConditionCustomConditionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type EnrollingConditionCustomConditionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionCustomConditionConnectionSort>>;
  where?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
};


export type EnrollingConditionIncludedGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type EnrollingConditionIncludedGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type EnrollingConditionIncludedGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionIncludedGenericsConnectionSort>>;
  where?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
};

export type EnrollingConditionAggregateSelection = {
  __typename?: 'EnrollingConditionAggregateSelection';
  attributeValue: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  cycleLimitFrom: IntAggregateSelectionNullable;
  cycleLimitTo: IntAggregateSelectionNullable;
  rangeInputEnd: IntAggregateSelectionNullable;
  rangeInputStart: IntAggregateSelectionNullable;
  timeframeRangeEnd: IntAggregateSelectionNullable;
  timeframeRangeStart: IntAggregateSelectionNullable;
};

export type EnrollingConditionCustomConditionAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionCustomConditionAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionCustomConditionAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionCustomConditionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionCustomConditionNodeAggregationWhereInput>;
};

export type EnrollingConditionCustomConditionConnection = {
  __typename?: 'EnrollingConditionCustomConditionConnection';
  edges: Array<EnrollingConditionCustomConditionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionCustomConditionConnectionSort = {
  node?: InputMaybe<CustomConditionSort>;
};

export type EnrollingConditionCustomConditionConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionCustomConditionConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionCustomConditionConnectionWhere>>;
  node?: InputMaybe<CustomConditionWhere>;
};

export type EnrollingConditionCustomConditionCustomConditionAggregationSelection = {
  __typename?: 'EnrollingConditionCustomConditionCustomConditionAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection>;
};

export type EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection = {
  __typename?: 'EnrollingConditionCustomConditionCustomConditionNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type EnrollingConditionCustomConditionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionCustomConditionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionCustomConditionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionCustomConditionNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionCustomConditionRelationship = {
  __typename?: 'EnrollingConditionCustomConditionRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export type EnrollingConditionDiseaseRelationship = {
  Score?: Maybe<Scalars['Float']['output']>;
};

export type EnrollingConditionDiseaseRelationshipSort = {
  Score?: InputMaybe<SortDirection>;
};

export type EnrollingConditionDiseaseRelationshipWhere = {
  AND?: InputMaybe<Array<EnrollingConditionDiseaseRelationshipWhere>>;
  NOT?: InputMaybe<EnrollingConditionDiseaseRelationshipWhere>;
  OR?: InputMaybe<Array<EnrollingConditionDiseaseRelationshipWhere>>;
  Score?: InputMaybe<Scalars['Float']['input']>;
  Score_GT?: InputMaybe<Scalars['Float']['input']>;
  Score_GTE?: InputMaybe<Scalars['Float']['input']>;
  Score_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  Score_LT?: InputMaybe<Scalars['Float']['input']>;
  Score_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type EnrollingConditionEdge = {
  __typename?: 'EnrollingConditionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingCondition;
};

export type EnrollingConditionGenericIncludedGenericsAggregationSelection = {
  __typename?: 'EnrollingConditionGenericIncludedGenericsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionGenericIncludedGenericsNodeAggregateSelection>;
};

export type EnrollingConditionGenericIncludedGenericsNodeAggregateSelection = {
  __typename?: 'EnrollingConditionGenericIncludedGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type EnrollingConditionIncludedGenericsAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionIncludedGenericsAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionIncludedGenericsAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionIncludedGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>;
};

export type EnrollingConditionIncludedGenericsConnection = {
  __typename?: 'EnrollingConditionIncludedGenericsConnection';
  edges: Array<EnrollingConditionIncludedGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionIncludedGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type EnrollingConditionIncludedGenericsConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionIncludedGenericsConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionIncludedGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type EnrollingConditionIncludedGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<EnrollingConditionIncludedGenericsNodeAggregationWhereInput>>;
};

export type EnrollingConditionIncludedGenericsRelationship = {
  __typename?: 'EnrollingConditionIncludedGenericsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type EnrollingConditionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollingConditionSort objects to sort EnrollingConditions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollingConditionSort>>;
};

export type EnrollingConditionSet = {
  __typename?: 'EnrollingConditionSet';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<EnrollingConditionSetAgreementAgreementAggregationSelection>;
  agreementConnection: EnrollingConditionSetAgreementConnection;
  conditions: Array<EnrollingCondition>;
  conditionsAggregate?: Maybe<EnrollingConditionSetEnrollingConditionConditionsAggregationSelection>;
  conditionsConnection: EnrollingConditionSetConditionsConnection;
  isDiseaseNotEnrollingCondition?: Maybe<Scalars['Boolean']['output']>;
  isIndicationNotEnrollingCondition?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  scopes: Array<AgreementScope>;
  scopesAggregate?: Maybe<EnrollingConditionSetAgreementScopeScopesAggregationSelection>;
  scopesConnection: EnrollingConditionSetScopesConnection;
  template?: Maybe<AgreementTemplate>;
  templateAggregate?: Maybe<EnrollingConditionSetAgreementTemplateTemplateAggregationSelection>;
  templateConnection: EnrollingConditionSetTemplateConnection;
};


export type EnrollingConditionSetAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type EnrollingConditionSetAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type EnrollingConditionSetAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
};


export type EnrollingConditionSetConditionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EnrollingConditionOptions>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type EnrollingConditionSetConditionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type EnrollingConditionSetConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetConditionsConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
};


export type EnrollingConditionSetScopesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type EnrollingConditionSetScopesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type EnrollingConditionSetScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetScopesConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
};


export type EnrollingConditionSetTemplateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type EnrollingConditionSetTemplateAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type EnrollingConditionSetTemplateConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnrollingConditionSetTemplateConnectionSort>>;
  where?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
};

export type EnrollingConditionSetAggregateSelection = {
  __typename?: 'EnrollingConditionSetAggregateSelection';
  count: Scalars['Int']['output'];
  order: IntAggregateSelectionNonNullable;
};

export type EnrollingConditionSetAgreementAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetAgreementAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetAgreementAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetAgreementNodeAggregationWhereInput>;
};

export type EnrollingConditionSetAgreementAgreementAggregationSelection = {
  __typename?: 'EnrollingConditionSetAgreementAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetAgreementAgreementNodeAggregateSelection>;
};

export type EnrollingConditionSetAgreementAgreementNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetAgreementAgreementNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type EnrollingConditionSetAgreementConnection = {
  __typename?: 'EnrollingConditionSetAgreementConnection';
  edges: Array<EnrollingConditionSetAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type EnrollingConditionSetAgreementConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type EnrollingConditionSetAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetAgreementNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetAgreementRelationship = {
  __typename?: 'EnrollingConditionSetAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type EnrollingConditionSetAgreementScopeScopesAggregationSelection = {
  __typename?: 'EnrollingConditionSetAgreementScopeScopesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection>;
};

export type EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetAgreementScopeScopesNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type EnrollingConditionSetAgreementTemplateTemplateAggregationSelection = {
  __typename?: 'EnrollingConditionSetAgreementTemplateTemplateAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection>;
};

export type EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetAgreementTemplateTemplateNodeAggregateSelection';
  addedByName: StringAggregateSelectionNullable;
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: IdAggregateSelectionNonNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  treatments: StringAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type EnrollingConditionSetConditionsAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetConditionsAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetConditionsAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetConditionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetConditionsNodeAggregationWhereInput>;
};

export type EnrollingConditionSetConditionsConnection = {
  __typename?: 'EnrollingConditionSetConditionsConnection';
  edges: Array<EnrollingConditionSetConditionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetConditionsConnectionSort = {
  node?: InputMaybe<EnrollingConditionSort>;
};

export type EnrollingConditionSetConditionsConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetConditionsConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetConditionsConnectionWhere>>;
  node?: InputMaybe<EnrollingConditionWhere>;
};

export type EnrollingConditionSetConditionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetConditionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetConditionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetConditionsNodeAggregationWhereInput>>;
  attributeValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  cycleLimitTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  rangeInputStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeRangeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetConditionsRelationship = {
  __typename?: 'EnrollingConditionSetConditionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingCondition;
};

export type EnrollingConditionSetEdge = {
  __typename?: 'EnrollingConditionSetEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingConditionSet;
};

export type EnrollingConditionSetEnrollingConditionConditionsAggregationSelection = {
  __typename?: 'EnrollingConditionSetEnrollingConditionConditionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection>;
};

export type EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection = {
  __typename?: 'EnrollingConditionSetEnrollingConditionConditionsNodeAggregateSelection';
  attributeValue: StringAggregateSelectionNullable;
  cycleLimitFrom: IntAggregateSelectionNullable;
  cycleLimitTo: IntAggregateSelectionNullable;
  rangeInputEnd: IntAggregateSelectionNullable;
  rangeInputStart: IntAggregateSelectionNullable;
  timeframeRangeEnd: IntAggregateSelectionNullable;
  timeframeRangeStart: IntAggregateSelectionNullable;
};

export type EnrollingConditionSetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollingConditionSetSort objects to sort EnrollingConditionSets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollingConditionSetSort>>;
};

export type EnrollingConditionSetScopesAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetScopesAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetScopesAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetScopesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetScopesNodeAggregationWhereInput>;
};

export type EnrollingConditionSetScopesConnection = {
  __typename?: 'EnrollingConditionSetScopesConnection';
  edges: Array<EnrollingConditionSetScopesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetScopesConnectionSort = {
  edge?: InputMaybe<AgreementScopeRelationshipSort>;
  node?: InputMaybe<AgreementScopeSort>;
};

export type EnrollingConditionSetScopesConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetScopesConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetScopesConnectionWhere>>;
  edge?: InputMaybe<AgreementScopeRelationshipWhere>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type EnrollingConditionSetScopesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetScopesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetScopesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetScopesNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetScopesRelationship = AgreementScopeRelationship & {
  __typename?: 'EnrollingConditionSetScopesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  excludedOn?: Maybe<Scalars['Date']['output']>;
  isExtended?: Maybe<Scalars['Boolean']['output']>;
  node: AgreementScope;
};

/** Fields to sort EnrollingConditionSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingConditionSetSort object. */
export type EnrollingConditionSetSort = {
  isDiseaseNotEnrollingCondition?: InputMaybe<SortDirection>;
  isIndicationNotEnrollingCondition?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type EnrollingConditionSetTemplateAggregateInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetTemplateAggregateInput>>;
  NOT?: InputMaybe<EnrollingConditionSetTemplateAggregateInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetTemplateAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<EnrollingConditionSetTemplateNodeAggregationWhereInput>;
};

export type EnrollingConditionSetTemplateConnection = {
  __typename?: 'EnrollingConditionSetTemplateConnection';
  edges: Array<EnrollingConditionSetTemplateRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingConditionSetTemplateConnectionSort = {
  node?: InputMaybe<AgreementTemplateSort>;
};

export type EnrollingConditionSetTemplateConnectionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetTemplateConnectionWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetTemplateConnectionWhere>>;
  node?: InputMaybe<AgreementTemplateWhere>;
};

export type EnrollingConditionSetTemplateNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<EnrollingConditionSetTemplateNodeAggregationWhereInput>>;
  NOT?: InputMaybe<EnrollingConditionSetTemplateNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<EnrollingConditionSetTemplateNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  treatments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  treatments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  treatments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type EnrollingConditionSetTemplateRelationship = {
  __typename?: 'EnrollingConditionSetTemplateRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTemplate;
};

export type EnrollingConditionSetWhere = {
  AND?: InputMaybe<Array<EnrollingConditionSetWhere>>;
  NOT?: InputMaybe<EnrollingConditionSetWhere>;
  OR?: InputMaybe<Array<EnrollingConditionSetWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<EnrollingConditionSetAgreementAggregateInput>;
  agreementConnection?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<EnrollingConditionSetAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  conditionsAggregate?: InputMaybe<EnrollingConditionSetConditionsAggregateInput>;
  /** Return EnrollingConditionSets where all of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_ALL?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where none of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_NONE?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where one of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_SINGLE?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where some of the related EnrollingConditionSetConditionsConnections match this filter */
  conditionsConnection_SOME?: InputMaybe<EnrollingConditionSetConditionsConnectionWhere>;
  /** Return EnrollingConditionSets where all of the related EnrollingConditions match this filter */
  conditions_ALL?: InputMaybe<EnrollingConditionWhere>;
  /** Return EnrollingConditionSets where none of the related EnrollingConditions match this filter */
  conditions_NONE?: InputMaybe<EnrollingConditionWhere>;
  /** Return EnrollingConditionSets where one of the related EnrollingConditions match this filter */
  conditions_SINGLE?: InputMaybe<EnrollingConditionWhere>;
  /** Return EnrollingConditionSets where some of the related EnrollingConditions match this filter */
  conditions_SOME?: InputMaybe<EnrollingConditionWhere>;
  isDiseaseNotEnrollingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  isIndicationNotEnrollingCondition?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopesAggregate?: InputMaybe<EnrollingConditionSetScopesAggregateInput>;
  /** Return EnrollingConditionSets where all of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_ALL?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where none of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_NONE?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where one of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_SINGLE?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where some of the related EnrollingConditionSetScopesConnections match this filter */
  scopesConnection_SOME?: InputMaybe<EnrollingConditionSetScopesConnectionWhere>;
  /** Return EnrollingConditionSets where all of the related AgreementScopes match this filter */
  scopes_ALL?: InputMaybe<AgreementScopeWhere>;
  /** Return EnrollingConditionSets where none of the related AgreementScopes match this filter */
  scopes_NONE?: InputMaybe<AgreementScopeWhere>;
  /** Return EnrollingConditionSets where one of the related AgreementScopes match this filter */
  scopes_SINGLE?: InputMaybe<AgreementScopeWhere>;
  /** Return EnrollingConditionSets where some of the related AgreementScopes match this filter */
  scopes_SOME?: InputMaybe<AgreementScopeWhere>;
  template?: InputMaybe<AgreementTemplateWhere>;
  templateAggregate?: InputMaybe<EnrollingConditionSetTemplateAggregateInput>;
  templateConnection?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
  templateConnection_NOT?: InputMaybe<EnrollingConditionSetTemplateConnectionWhere>;
  template_NOT?: InputMaybe<AgreementTemplateWhere>;
};

export type EnrollingConditionSetsConnection = {
  __typename?: 'EnrollingConditionSetsConnection';
  edges: Array<EnrollingConditionSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort EnrollingConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingConditionSort object. */
export type EnrollingConditionSort = {
  attributeValue?: InputMaybe<SortDirection>;
  bothOperatorFirst?: InputMaybe<SortDirection>;
  bothOperatorSecond?: InputMaybe<SortDirection>;
  conditionType?: InputMaybe<SortDirection>;
  countdownOperator?: InputMaybe<SortDirection>;
  cycleLimitFrom?: InputMaybe<SortDirection>;
  cycleLimitTo?: InputMaybe<SortDirection>;
  inclusionType?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  rangeInputEnd?: InputMaybe<SortDirection>;
  rangeInputStart?: InputMaybe<SortDirection>;
  resultSelectionType?: InputMaybe<SortDirection>;
  timeframeRangeEnd?: InputMaybe<SortDirection>;
  timeframeRangeStart?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeStartingPoint?: InputMaybe<SortDirection>;
};

export enum EnrollingConditionType {
  CustomCondition = 'CUSTOM_CONDITION',
  CycleLimit = 'CYCLE_LIMIT',
  DataGuidance = 'DATA_GUIDANCE',
  LdlLevel = 'LDL_LEVEL',
  NotYetConfirmed = 'NOT_YET_CONFIRMED',
  OutsideValidityPeriod = 'OUTSIDE_VALIDITY_PERIOD',
  PatientAge = 'PATIENT_AGE',
  PreviousTherapy = 'PREVIOUS_THERAPY',
  Rating = 'RATING',
  Rejected = 'REJECTED',
  TherapyDecision = 'THERAPY_DECISION',
  Uncertain = 'UNCERTAIN',
  Unknown = 'UNKNOWN'
}

export type EnrollingConditionWhere = {
  AND?: InputMaybe<Array<EnrollingConditionWhere>>;
  NOT?: InputMaybe<EnrollingConditionWhere>;
  OR?: InputMaybe<Array<EnrollingConditionWhere>>;
  attributeValue?: InputMaybe<Scalars['String']['input']>;
  attributeValue_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  attributeValue_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  attributeValue_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributeValue_MATCHES?: InputMaybe<Scalars['String']['input']>;
  attributeValue_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  bothOperatorFirst?: InputMaybe<ArithmeticalOperator>;
  bothOperatorFirst_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  bothOperatorSecond?: InputMaybe<ArithmeticalOperator>;
  bothOperatorSecond_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  conditionType?: InputMaybe<EnrollingConditionType>;
  conditionType_IN?: InputMaybe<Array<EnrollingConditionType>>;
  countdownOperator?: InputMaybe<CountdownOperator>;
  countdownOperator_IN?: InputMaybe<Array<InputMaybe<CountdownOperator>>>;
  customCondition?: InputMaybe<CustomConditionWhere>;
  customConditionAggregate?: InputMaybe<EnrollingConditionCustomConditionAggregateInput>;
  customConditionConnection?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
  customConditionConnection_NOT?: InputMaybe<EnrollingConditionCustomConditionConnectionWhere>;
  customCondition_NOT?: InputMaybe<CustomConditionWhere>;
  cycleLimitFrom?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleLimitFrom_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitFrom_LTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_GT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_GTE?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cycleLimitTo_LT?: InputMaybe<Scalars['Int']['input']>;
  cycleLimitTo_LTE?: InputMaybe<Scalars['Int']['input']>;
  includedGenericsAggregate?: InputMaybe<EnrollingConditionIncludedGenericsAggregateInput>;
  /** Return EnrollingConditions where all of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_ALL?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where none of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_NONE?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where one of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_SINGLE?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where some of the related EnrollingConditionIncludedGenericsConnections match this filter */
  includedGenericsConnection_SOME?: InputMaybe<EnrollingConditionIncludedGenericsConnectionWhere>;
  /** Return EnrollingConditions where all of the related Generics match this filter */
  includedGenerics_ALL?: InputMaybe<GenericWhere>;
  /** Return EnrollingConditions where none of the related Generics match this filter */
  includedGenerics_NONE?: InputMaybe<GenericWhere>;
  /** Return EnrollingConditions where one of the related Generics match this filter */
  includedGenerics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return EnrollingConditions where some of the related Generics match this filter */
  includedGenerics_SOME?: InputMaybe<GenericWhere>;
  inclusionType?: InputMaybe<InclusionType>;
  inclusionType_IN?: InputMaybe<Array<InputMaybe<InclusionType>>>;
  operator?: InputMaybe<ArithmeticalOperator>;
  operator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  rangeInputEnd?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rangeInputEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_GT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rangeInputStart_LT?: InputMaybe<Scalars['Int']['input']>;
  rangeInputStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Array<CoverageRequestRating>>;
  rating_INCLUDES?: InputMaybe<CoverageRequestRating>;
  resultSelectionType?: InputMaybe<ResultSelectionType>;
  resultSelectionType_IN?: InputMaybe<Array<InputMaybe<ResultSelectionType>>>;
  therapyDecision?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
  therapyDecision_INCLUDES?: InputMaybe<CoverageRequestTherapyDecision>;
  timeframeRangeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeRangeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeRangeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  timeframeStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
};

export type EnrollingConditionsConnection = {
  __typename?: 'EnrollingConditionsConnection';
  edges: Array<EnrollingConditionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EnrollingPeriod = {
  __typename?: 'EnrollingPeriod';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
};

export type EnrollingPeriodAggregateSelection = {
  __typename?: 'EnrollingPeriodAggregateSelection';
  count: Scalars['Int']['output'];
};

export type EnrollingPeriodEdge = {
  __typename?: 'EnrollingPeriodEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnrollingPeriod;
};

export type EnrollingPeriodOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnrollingPeriodSort objects to sort EnrollingPeriods by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnrollingPeriodSort>>;
};

/** Fields to sort EnrollingPeriods by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnrollingPeriodSort object. */
export type EnrollingPeriodSort = {
  from?: InputMaybe<SortDirection>;
  to?: InputMaybe<SortDirection>;
};

export type EnrollingPeriodWhere = {
  AND?: InputMaybe<Array<EnrollingPeriodWhere>>;
  NOT?: InputMaybe<EnrollingPeriodWhere>;
  OR?: InputMaybe<Array<EnrollingPeriodWhere>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  from_GT?: InputMaybe<Scalars['Date']['input']>;
  from_GTE?: InputMaybe<Scalars['Date']['input']>;
  from_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  from_LT?: InputMaybe<Scalars['Date']['input']>;
  from_LTE?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  to_GT?: InputMaybe<Scalars['Date']['input']>;
  to_GTE?: InputMaybe<Scalars['Date']['input']>;
  to_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  to_LT?: InputMaybe<Scalars['Date']['input']>;
  to_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type EnrollingPeriodsConnection = {
  __typename?: 'EnrollingPeriodsConnection';
  edges: Array<EnrollingPeriodEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EnrolmentDateType {
  DiagnosisDate = 'DIAGNOSIS_DATE',
  FirstRecordDate = 'FIRST_RECORD_DATE',
  RecordDate = 'RECORD_DATE',
  RequestReceiptDate = 'REQUEST_RECEIPT_DATE'
}

export enum EntityPriceType {
  Case = 'CASE',
  Cycle = 'CYCLE',
  Gram = 'GRAM',
  Milligram = 'MILLIGRAM',
  Millilitre = 'MILLILITRE',
  Pack = 'PACK'
}

export type EntityTypeMappingRelationship = {
  data?: Maybe<Scalars['String']['output']>;
};

export type EntityTypeMappingRelationshipSort = {
  data?: InputMaybe<SortDirection>;
};

export type EntityTypeMappingRelationshipWhere = {
  AND?: InputMaybe<Array<EntityTypeMappingRelationshipWhere>>;
  NOT?: InputMaybe<EntityTypeMappingRelationshipWhere>;
  OR?: InputMaybe<Array<EntityTypeMappingRelationshipWhere>>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentImpact = {
  __typename?: 'EnvironmentImpact';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  kind: Scalars['String']['output'];
  transactionIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type EnvironmentImpactAggregateSelection = {
  __typename?: 'EnvironmentImpactAggregateSelection';
  count: Scalars['Int']['output'];
  kind: StringAggregateSelectionNonNullable;
};

export type EnvironmentImpactEdge = {
  __typename?: 'EnvironmentImpactEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EnvironmentImpact;
};

export type EnvironmentImpactOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more EnvironmentImpactSort objects to sort EnvironmentImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<EnvironmentImpactSort>>;
};

/** Fields to sort EnvironmentImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one EnvironmentImpactSort object. */
export type EnvironmentImpactSort = {
  kind?: InputMaybe<SortDirection>;
};

export type EnvironmentImpactWhere = {
  AND?: InputMaybe<Array<EnvironmentImpactWhere>>;
  NOT?: InputMaybe<EnvironmentImpactWhere>;
  OR?: InputMaybe<Array<EnvironmentImpactWhere>>;
  kind?: InputMaybe<Scalars['String']['input']>;
  kind_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  kind_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  kind_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  kind_MATCHES?: InputMaybe<Scalars['String']['input']>;
  kind_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentImpactsConnection = {
  __typename?: 'EnvironmentImpactsConnection';
  edges: Array<EnvironmentImpactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExFactoryPrice = {
  __typename?: 'ExFactoryPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
};

export type ExFactoryPriceAggregateSelection = {
  __typename?: 'ExFactoryPriceAggregateSelection';
  Price: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type ExFactoryPriceEdge = {
  __typename?: 'ExFactoryPriceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ExFactoryPrice;
};

export type ExFactoryPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExFactoryPriceSort objects to sort ExFactoryPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExFactoryPriceSort>>;
};

/** Fields to sort ExFactoryPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExFactoryPriceSort object. */
export type ExFactoryPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type ExFactoryPriceWhere = {
  AND?: InputMaybe<Array<ExFactoryPriceWhere>>;
  NOT?: InputMaybe<ExFactoryPriceWhere>;
  OR?: InputMaybe<Array<ExFactoryPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type ExFactoryPricesConnection = {
  __typename?: 'ExFactoryPricesConnection';
  edges: Array<ExFactoryPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpectedRunAgreement = {
  __typename?: 'ExpectedRunAgreement';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExpectedRunAgreementAggregateSelection = {
  __typename?: 'ExpectedRunAgreementAggregateSelection';
  count: Scalars['Int']['output'];
  id: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type ExpectedRunAgreementEdge = {
  __typename?: 'ExpectedRunAgreementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ExpectedRunAgreement;
};

export type ExpectedRunAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExpectedRunAgreementSort objects to sort ExpectedRunAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExpectedRunAgreementSort>>;
};

/** Fields to sort ExpectedRunAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExpectedRunAgreementSort object. */
export type ExpectedRunAgreementSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ExpectedRunAgreementWhere = {
  AND?: InputMaybe<Array<ExpectedRunAgreementWhere>>;
  NOT?: InputMaybe<ExpectedRunAgreementWhere>;
  OR?: InputMaybe<Array<ExpectedRunAgreementWhere>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ExpectedRunAgreementsConnection = {
  __typename?: 'ExpectedRunAgreementsConnection';
  edges: Array<ExpectedRunAgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpenditureDistributionDataPoint = {
  __typename?: 'ExpenditureDistributionDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  basePrice: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  foc: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  status: ExpenditureDistributionStatus;
};

export type ExpenditureDistributionDataPointAggregateSelection = {
  __typename?: 'ExpenditureDistributionDataPointAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNonNullable;
  foc: FloatAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  quantity: FloatAggregateSelectionNonNullable;
};

export type ExpenditureDistributionDataPointEdge = {
  __typename?: 'ExpenditureDistributionDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ExpenditureDistributionDataPoint;
};

export type ExpenditureDistributionDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExpenditureDistributionDataPointSort objects to sort ExpenditureDistributionDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExpenditureDistributionDataPointSort>>;
};

/** Fields to sort ExpenditureDistributionDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExpenditureDistributionDataPointSort object. */
export type ExpenditureDistributionDataPointSort = {
  basePrice?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  foc?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
};

export type ExpenditureDistributionDataPointWhere = {
  AND?: InputMaybe<Array<ExpenditureDistributionDataPointWhere>>;
  NOT?: InputMaybe<ExpenditureDistributionDataPointWhere>;
  OR?: InputMaybe<Array<ExpenditureDistributionDataPointWhere>>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  basePrice_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  basePrice_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  foc?: InputMaybe<Scalars['Float']['input']>;
  foc_GT?: InputMaybe<Scalars['Float']['input']>;
  foc_GTE?: InputMaybe<Scalars['Float']['input']>;
  foc_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  foc_LT?: InputMaybe<Scalars['Float']['input']>;
  foc_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ExpenditureDistributionDataPointsConnection = {
  __typename?: 'ExpenditureDistributionDataPointsConnection';
  edges: Array<ExpenditureDistributionDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpenditureDistributionStatus = {
  __typename?: 'ExpenditureDistributionStatus';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  invoicedProductUnits: Scalars['Float']['output'];
  openProductUnits: Scalars['Float']['output'];
};

export type ExpenditureDistributionStatusAggregateSelection = {
  __typename?: 'ExpenditureDistributionStatusAggregateSelection';
  count: Scalars['Int']['output'];
  invoicedProductUnits: FloatAggregateSelectionNonNullable;
  openProductUnits: FloatAggregateSelectionNonNullable;
};

export type ExpenditureDistributionStatusEdge = {
  __typename?: 'ExpenditureDistributionStatusEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ExpenditureDistributionStatus;
};

export type ExpenditureDistributionStatusOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExpenditureDistributionStatusSort objects to sort ExpenditureDistributionStatuses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExpenditureDistributionStatusSort>>;
};

/** Fields to sort ExpenditureDistributionStatuses by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExpenditureDistributionStatusSort object. */
export type ExpenditureDistributionStatusSort = {
  invoicedProductUnits?: InputMaybe<SortDirection>;
  openProductUnits?: InputMaybe<SortDirection>;
};

export type ExpenditureDistributionStatusWhere = {
  AND?: InputMaybe<Array<ExpenditureDistributionStatusWhere>>;
  NOT?: InputMaybe<ExpenditureDistributionStatusWhere>;
  OR?: InputMaybe<Array<ExpenditureDistributionStatusWhere>>;
  invoicedProductUnits?: InputMaybe<Scalars['Float']['input']>;
  invoicedProductUnits_GT?: InputMaybe<Scalars['Float']['input']>;
  invoicedProductUnits_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoicedProductUnits_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  invoicedProductUnits_LT?: InputMaybe<Scalars['Float']['input']>;
  invoicedProductUnits_LTE?: InputMaybe<Scalars['Float']['input']>;
  openProductUnits?: InputMaybe<Scalars['Float']['input']>;
  openProductUnits_GT?: InputMaybe<Scalars['Float']['input']>;
  openProductUnits_GTE?: InputMaybe<Scalars['Float']['input']>;
  openProductUnits_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  openProductUnits_LT?: InputMaybe<Scalars['Float']['input']>;
  openProductUnits_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ExpenditureDistributionStatusesConnection = {
  __typename?: 'ExpenditureDistributionStatusesConnection';
  edges: Array<ExpenditureDistributionStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalExposure = {
  __typename?: 'ExternalExposure';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  creatorEmail: Scalars['String']['output'];
  creatorName?: Maybe<Scalars['String']['output']>;
  exposedOn: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  lifetimeSeconds?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  receiverEmail: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  subType?: Maybe<Scalars['String']['output']>;
  useCC?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ExternalExposureAggregateSelection = {
  __typename?: 'ExternalExposureAggregateSelection';
  count: Scalars['Int']['output'];
  creatorEmail: StringAggregateSelectionNonNullable;
  creatorName: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  lifetimeSeconds: IntAggregateSelectionNullable;
  organizationId: StringAggregateSelectionNonNullable;
  organizationName: StringAggregateSelectionNonNullable;
  receiverEmail: StringAggregateSelectionNonNullable;
  resourceType: StringAggregateSelectionNonNullable;
  subType: StringAggregateSelectionNullable;
  userId: StringAggregateSelectionNullable;
};

export type ExternalExposureEdge = {
  __typename?: 'ExternalExposureEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ExternalExposure;
};

export type ExternalExposureOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ExternalExposureSort objects to sort ExternalExposures by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ExternalExposureSort>>;
};

/** Fields to sort ExternalExposures by. The order in which sorts are applied is not guaranteed when specifying many fields in one ExternalExposureSort object. */
export type ExternalExposureSort = {
  creatorEmail?: InputMaybe<SortDirection>;
  creatorName?: InputMaybe<SortDirection>;
  exposedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lifetimeSeconds?: InputMaybe<SortDirection>;
  organizationId?: InputMaybe<SortDirection>;
  organizationName?: InputMaybe<SortDirection>;
  receiverEmail?: InputMaybe<SortDirection>;
  resourceType?: InputMaybe<SortDirection>;
  subType?: InputMaybe<SortDirection>;
  useCC?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type ExternalExposureWhere = {
  AND?: InputMaybe<Array<ExternalExposureWhere>>;
  NOT?: InputMaybe<ExternalExposureWhere>;
  OR?: InputMaybe<Array<ExternalExposureWhere>>;
  creatorEmail?: InputMaybe<Scalars['String']['input']>;
  creatorEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  creatorEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatorEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  creatorEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  creatorEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatorName?: InputMaybe<Scalars['String']['input']>;
  creatorName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  creatorName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatorName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creatorName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  creatorName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  exposedOn?: InputMaybe<Scalars['Date']['input']>;
  exposedOn_GT?: InputMaybe<Scalars['Date']['input']>;
  exposedOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  exposedOn_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  exposedOn_LT?: InputMaybe<Scalars['Date']['input']>;
  exposedOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lifetimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  lifetimeSeconds_GT?: InputMaybe<Scalars['Int']['input']>;
  lifetimeSeconds_GTE?: InputMaybe<Scalars['Int']['input']>;
  lifetimeSeconds_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lifetimeSeconds_LT?: InputMaybe<Scalars['Int']['input']>;
  lifetimeSeconds_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  receiverEmail?: InputMaybe<Scalars['String']['input']>;
  receiverEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  receiverEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  receiverEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  receiverEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  receiverEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  resourceType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  resourceType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  resourceType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  resourceType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  resourceType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
  subType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  subType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  subType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  subType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  useCC?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalExposuresConnection = {
  __typename?: 'ExternalExposuresConnection';
  edges: Array<ExternalExposureEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FieldMappingInput = {
  derivedFrom?: InputMaybe<Scalars['String']['input']>;
  flexEntityField: Scalars['String']['input'];
  userField: Scalars['String']['input'];
};

export type FinancialDataPointInput = {
  adjustedAmount?: InputMaybe<Scalars['Float']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  generatedUuid: Scalars['String']['input'];
  status?: InputMaybe<FinancialDataPointStatus>;
};

export enum FinancialDataPointStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Removed = 'REMOVED',
  Undecided = 'UNDECIDED'
}

export type FinancialReportDataPoint = {
  __typename?: 'FinancialReportDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  date: Scalars['Date']['output'];
  discountAmount: Scalars['Float']['output'];
  grossAmount: Scalars['Float']['output'];
  netAmount: Scalars['Float']['output'];
  variableAmount: Scalars['Float']['output'];
};

export type FinancialReportDataPointAggregateSelection = {
  __typename?: 'FinancialReportDataPointAggregateSelection';
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNonNullable;
  grossAmount: FloatAggregateSelectionNonNullable;
  netAmount: FloatAggregateSelectionNonNullable;
  variableAmount: FloatAggregateSelectionNonNullable;
};

export type FinancialReportDataPointEdge = {
  __typename?: 'FinancialReportDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FinancialReportDataPoint;
};

export type FinancialReportDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FinancialReportDataPointSort objects to sort FinancialReportDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FinancialReportDataPointSort>>;
};

/** Fields to sort FinancialReportDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialReportDataPointSort object. */
export type FinancialReportDataPointSort = {
  date?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  grossAmount?: InputMaybe<SortDirection>;
  netAmount?: InputMaybe<SortDirection>;
  variableAmount?: InputMaybe<SortDirection>;
};

export type FinancialReportDataPointWhere = {
  AND?: InputMaybe<Array<FinancialReportDataPointWhere>>;
  NOT?: InputMaybe<FinancialReportDataPointWhere>;
  OR?: InputMaybe<Array<FinancialReportDataPointWhere>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  grossAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  netAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  variableAmount?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  variableAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialReportDataPointsConnection = {
  __typename?: 'FinancialReportDataPointsConnection';
  edges: Array<FinancialReportDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FinancialSummaryColumn = {
  __typename?: 'FinancialSummaryColumn';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: FinancialSummaryColumnName;
};

export type FinancialSummaryColumnAggregateSelection = {
  __typename?: 'FinancialSummaryColumnAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type FinancialSummaryColumnEdge = {
  __typename?: 'FinancialSummaryColumnEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FinancialSummaryColumn;
};

export enum FinancialSummaryColumnName {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  BaselinePrice = 'BASELINE_PRICE',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  Discounts = 'DISCOUNTS',
  ExFactoryPrice = 'EX_FACTORY_PRICE',
  GrossAmount = 'GROSS_AMOUNT',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  NetAmount = 'NET_AMOUNT',
  NetAvgDiscountRate = 'NET_AVG_DISCOUNT_RATE',
  NetAvgPrice = 'NET_AVG_PRICE',
  NetPrice = 'NET_PRICE',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  Product = 'PRODUCT',
  PublicPrice = 'PUBLIC_PRICE',
  Quantity = 'QUANTITY',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  TotalDiscounts = 'TOTAL_DISCOUNTS',
  VacListPrice = 'VAC_LIST_PRICE',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  Variable = 'VARIABLE',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE'
}

export type FinancialSummaryColumnOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FinancialSummaryColumnSort objects to sort FinancialSummaryColumns by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FinancialSummaryColumnSort>>;
};

/** Fields to sort FinancialSummaryColumns by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialSummaryColumnSort object. */
export type FinancialSummaryColumnSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type FinancialSummaryColumnWhere = {
  AND?: InputMaybe<Array<FinancialSummaryColumnWhere>>;
  NOT?: InputMaybe<FinancialSummaryColumnWhere>;
  OR?: InputMaybe<Array<FinancialSummaryColumnWhere>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<FinancialSummaryColumnName>;
  name_IN?: InputMaybe<Array<FinancialSummaryColumnName>>;
};

export type FinancialSummaryColumnsConnection = {
  __typename?: 'FinancialSummaryColumnsConnection';
  edges: Array<FinancialSummaryColumnEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FinancialSummaryRow = {
  __typename?: 'FinancialSummaryRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  albertaListPrice?: Maybe<Scalars['Float']['output']>;
  albertaMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  baselinePrice: Scalars['Float']['output'];
  britishColumbiaListPrice?: Maybe<Scalars['Float']['output']>;
  britishColumbiaMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  discountAmount: Scalars['Float']['output'];
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  exFactoryPrice: Scalars['Float']['output'];
  grossAmount: Scalars['Float']['output'];
  manitobaListPrice?: Maybe<Scalars['Float']['output']>;
  manitobaMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nestedRows: Array<FinancialSummaryRow>;
  netAmount: Scalars['Float']['output'];
  netAvgDiscountRate: Scalars['Float']['output'];
  netAvgPrice: Scalars['Float']['output'];
  netPrice?: Maybe<Scalars['Float']['output']>;
  newBrunswickListPrice?: Maybe<Scalars['Float']['output']>;
  newBrunswickMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  newfoundlandAndLabradorListPrice?: Maybe<Scalars['Float']['output']>;
  newfoundlandAndLabradorMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  nihbListPrice?: Maybe<Scalars['Float']['output']>;
  nihbMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  northwestTerritoriesListPrice?: Maybe<Scalars['Float']['output']>;
  northwestTerritoriesMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  novaScotiaListPrice?: Maybe<Scalars['Float']['output']>;
  novaScotiaMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  nunavutListPrice?: Maybe<Scalars['Float']['output']>;
  nunavutMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  ontarioListPrice?: Maybe<Scalars['Float']['output']>;
  ontarioMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  princeEdwardIslandListPrice?: Maybe<Scalars['Float']['output']>;
  princeEdwardIslandMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  publicPrice: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  quebecListPrice?: Maybe<Scalars['Float']['output']>;
  quebecMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  saskatchewanListPrice?: Maybe<Scalars['Float']['output']>;
  saskatchewanMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  vacListPrice?: Maybe<Scalars['Float']['output']>;
  vacMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
  variableAmount: Scalars['Float']['output'];
  yukonListPrice?: Maybe<Scalars['Float']['output']>;
  yukonMarkedUpPrice?: Maybe<Scalars['Float']['output']>;
};

export type FinancialSummaryRowAggregateSelection = {
  __typename?: 'FinancialSummaryRowAggregateSelection';
  albertaListPrice: FloatAggregateSelectionNullable;
  albertaMarkedUpPrice: FloatAggregateSelectionNullable;
  baselinePrice: FloatAggregateSelectionNonNullable;
  britishColumbiaListPrice: FloatAggregateSelectionNullable;
  britishColumbiaMarkedUpPrice: FloatAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNonNullable;
  discountPercentage: FloatAggregateSelectionNullable;
  exFactoryPrice: FloatAggregateSelectionNonNullable;
  grossAmount: FloatAggregateSelectionNonNullable;
  manitobaListPrice: FloatAggregateSelectionNullable;
  manitobaMarkedUpPrice: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  netAmount: FloatAggregateSelectionNonNullable;
  netAvgDiscountRate: FloatAggregateSelectionNonNullable;
  netAvgPrice: FloatAggregateSelectionNonNullable;
  netPrice: FloatAggregateSelectionNullable;
  newBrunswickListPrice: FloatAggregateSelectionNullable;
  newBrunswickMarkedUpPrice: FloatAggregateSelectionNullable;
  newfoundlandAndLabradorListPrice: FloatAggregateSelectionNullable;
  newfoundlandAndLabradorMarkedUpPrice: FloatAggregateSelectionNullable;
  nihbListPrice: FloatAggregateSelectionNullable;
  nihbMarkedUpPrice: FloatAggregateSelectionNullable;
  northwestTerritoriesListPrice: FloatAggregateSelectionNullable;
  northwestTerritoriesMarkedUpPrice: FloatAggregateSelectionNullable;
  novaScotiaListPrice: FloatAggregateSelectionNullable;
  novaScotiaMarkedUpPrice: FloatAggregateSelectionNullable;
  nunavutListPrice: FloatAggregateSelectionNullable;
  nunavutMarkedUpPrice: FloatAggregateSelectionNullable;
  ontarioListPrice: FloatAggregateSelectionNullable;
  ontarioMarkedUpPrice: FloatAggregateSelectionNullable;
  princeEdwardIslandListPrice: FloatAggregateSelectionNullable;
  princeEdwardIslandMarkedUpPrice: FloatAggregateSelectionNullable;
  publicPrice: FloatAggregateSelectionNonNullable;
  quantity: FloatAggregateSelectionNonNullable;
  quebecListPrice: FloatAggregateSelectionNullable;
  quebecMarkedUpPrice: FloatAggregateSelectionNullable;
  saskatchewanListPrice: FloatAggregateSelectionNullable;
  saskatchewanMarkedUpPrice: FloatAggregateSelectionNullable;
  vacListPrice: FloatAggregateSelectionNullable;
  vacMarkedUpPrice: FloatAggregateSelectionNullable;
  variableAmount: FloatAggregateSelectionNonNullable;
  yukonListPrice: FloatAggregateSelectionNullable;
  yukonMarkedUpPrice: FloatAggregateSelectionNullable;
};

export type FinancialSummaryRowEdge = {
  __typename?: 'FinancialSummaryRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FinancialSummaryRow;
};

export type FinancialSummaryRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FinancialSummaryRowSort objects to sort FinancialSummaryRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FinancialSummaryRowSort>>;
};

/** Fields to sort FinancialSummaryRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one FinancialSummaryRowSort object. */
export type FinancialSummaryRowSort = {
  albertaListPrice?: InputMaybe<SortDirection>;
  albertaMarkedUpPrice?: InputMaybe<SortDirection>;
  baselinePrice?: InputMaybe<SortDirection>;
  britishColumbiaListPrice?: InputMaybe<SortDirection>;
  britishColumbiaMarkedUpPrice?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  discountPercentage?: InputMaybe<SortDirection>;
  exFactoryPrice?: InputMaybe<SortDirection>;
  grossAmount?: InputMaybe<SortDirection>;
  manitobaListPrice?: InputMaybe<SortDirection>;
  manitobaMarkedUpPrice?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  netAmount?: InputMaybe<SortDirection>;
  netAvgDiscountRate?: InputMaybe<SortDirection>;
  netAvgPrice?: InputMaybe<SortDirection>;
  netPrice?: InputMaybe<SortDirection>;
  newBrunswickListPrice?: InputMaybe<SortDirection>;
  newBrunswickMarkedUpPrice?: InputMaybe<SortDirection>;
  newfoundlandAndLabradorListPrice?: InputMaybe<SortDirection>;
  newfoundlandAndLabradorMarkedUpPrice?: InputMaybe<SortDirection>;
  nihbListPrice?: InputMaybe<SortDirection>;
  nihbMarkedUpPrice?: InputMaybe<SortDirection>;
  northwestTerritoriesListPrice?: InputMaybe<SortDirection>;
  northwestTerritoriesMarkedUpPrice?: InputMaybe<SortDirection>;
  novaScotiaListPrice?: InputMaybe<SortDirection>;
  novaScotiaMarkedUpPrice?: InputMaybe<SortDirection>;
  nunavutListPrice?: InputMaybe<SortDirection>;
  nunavutMarkedUpPrice?: InputMaybe<SortDirection>;
  ontarioListPrice?: InputMaybe<SortDirection>;
  ontarioMarkedUpPrice?: InputMaybe<SortDirection>;
  princeEdwardIslandListPrice?: InputMaybe<SortDirection>;
  princeEdwardIslandMarkedUpPrice?: InputMaybe<SortDirection>;
  publicPrice?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  quebecListPrice?: InputMaybe<SortDirection>;
  quebecMarkedUpPrice?: InputMaybe<SortDirection>;
  saskatchewanListPrice?: InputMaybe<SortDirection>;
  saskatchewanMarkedUpPrice?: InputMaybe<SortDirection>;
  vacListPrice?: InputMaybe<SortDirection>;
  vacMarkedUpPrice?: InputMaybe<SortDirection>;
  variableAmount?: InputMaybe<SortDirection>;
  yukonListPrice?: InputMaybe<SortDirection>;
  yukonMarkedUpPrice?: InputMaybe<SortDirection>;
};

export type FinancialSummaryRowWhere = {
  AND?: InputMaybe<Array<FinancialSummaryRowWhere>>;
  NOT?: InputMaybe<FinancialSummaryRowWhere>;
  OR?: InputMaybe<Array<FinancialSummaryRowWhere>>;
  albertaListPrice?: InputMaybe<Scalars['Float']['input']>;
  albertaListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  albertaListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  albertaListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  albertaListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  albertaListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  albertaMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  albertaMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  albertaMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  albertaMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  albertaMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  albertaMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  baselinePrice?: InputMaybe<Scalars['Float']['input']>;
  baselinePrice_GT?: InputMaybe<Scalars['Float']['input']>;
  baselinePrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  baselinePrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  baselinePrice_LT?: InputMaybe<Scalars['Float']['input']>;
  baselinePrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaListPrice?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  britishColumbiaListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  britishColumbiaMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  britishColumbiaMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountPercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  discountPercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  exFactoryPrice?: InputMaybe<Scalars['Float']['input']>;
  exFactoryPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  exFactoryPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  exFactoryPrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  exFactoryPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  exFactoryPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  grossAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  manitobaListPrice?: InputMaybe<Scalars['Float']['input']>;
  manitobaListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  manitobaListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  manitobaListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  manitobaListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  manitobaListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  manitobaMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  manitobaMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  manitobaMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  manitobaMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  manitobaMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  manitobaMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  netAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAvgDiscountRate?: InputMaybe<Scalars['Float']['input']>;
  netAvgDiscountRate_GT?: InputMaybe<Scalars['Float']['input']>;
  netAvgDiscountRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAvgDiscountRate_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  netAvgDiscountRate_LT?: InputMaybe<Scalars['Float']['input']>;
  netAvgDiscountRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAvgPrice?: InputMaybe<Scalars['Float']['input']>;
  netAvgPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  netAvgPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAvgPrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  netAvgPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  netAvgPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrice?: InputMaybe<Scalars['Float']['input']>;
  netPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  netPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickListPrice?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  newBrunswickListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  newBrunswickMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  newBrunswickMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorListPrice?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  newfoundlandAndLabradorListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  newfoundlandAndLabradorMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  newfoundlandAndLabradorMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  nihbListPrice?: InputMaybe<Scalars['Float']['input']>;
  nihbListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  nihbListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  nihbListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nihbListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  nihbListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  nihbMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  nihbMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  nihbMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  nihbMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nihbMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  nihbMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesListPrice?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  northwestTerritoriesListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  northwestTerritoriesMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  northwestTerritoriesMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaListPrice?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  novaScotiaListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  novaScotiaMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  novaScotiaMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  nunavutListPrice?: InputMaybe<Scalars['Float']['input']>;
  nunavutListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  nunavutListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  nunavutListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nunavutListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  nunavutListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  nunavutMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  nunavutMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  nunavutMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  nunavutMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nunavutMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  nunavutMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  ontarioListPrice?: InputMaybe<Scalars['Float']['input']>;
  ontarioListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  ontarioListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  ontarioListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ontarioListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  ontarioListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  ontarioMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  ontarioMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  ontarioMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  ontarioMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ontarioMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  ontarioMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandListPrice?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  princeEdwardIslandListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  princeEdwardIslandMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  princeEdwardIslandMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  publicPrice?: InputMaybe<Scalars['Float']['input']>;
  publicPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  publicPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  publicPrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  publicPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  publicPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  quebecListPrice?: InputMaybe<Scalars['Float']['input']>;
  quebecListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  quebecListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  quebecListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quebecListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  quebecListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  quebecMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  quebecMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  quebecMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  quebecMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quebecMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  quebecMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanListPrice?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  saskatchewanListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  saskatchewanMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  saskatchewanMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  vacListPrice?: InputMaybe<Scalars['Float']['input']>;
  vacListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  vacListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  vacListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  vacListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  vacListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  vacMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  vacMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  vacMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  vacMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  vacMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  vacMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  variableAmount?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  variableAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  variableAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  yukonListPrice?: InputMaybe<Scalars['Float']['input']>;
  yukonListPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  yukonListPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  yukonListPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  yukonListPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  yukonListPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  yukonMarkedUpPrice?: InputMaybe<Scalars['Float']['input']>;
  yukonMarkedUpPrice_GT?: InputMaybe<Scalars['Float']['input']>;
  yukonMarkedUpPrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  yukonMarkedUpPrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  yukonMarkedUpPrice_LT?: InputMaybe<Scalars['Float']['input']>;
  yukonMarkedUpPrice_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FinancialSummaryRowsConnection = {
  __typename?: 'FinancialSummaryRowsConnection';
  edges: Array<FinancialSummaryRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum FlexContainerType {
  Form = 'FORM',
  Record = 'RECORD'
}

export type FlexEntitiesConnection = {
  __typename?: 'FlexEntitiesConnection';
  edges: Array<FlexEntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntity = {
  __typename?: 'FlexEntity';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  autogenerationTrigger?: Maybe<AutogenerationTrigger>;
  cases: Array<Case>;
  casesAggregate?: Maybe<FlexEntityCaseCasesAggregationSelection>;
  casesConnection: FlexEntityCasesConnection;
  containerType: FlexContainerType;
  coverageStartDate?: Maybe<Scalars['Date']['output']>;
  createdBy: User;
  createdByAggregate?: Maybe<FlexEntityUserCreatedByAggregationSelection>;
  createdByConnection: FlexEntityCreatedByConnection;
  createdByEmail: Scalars['String']['output'];
  createdByName: Scalars['String']['output'];
  createdOn: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  dataKeys: Scalars['String']['output'];
  date?: Maybe<Scalars['Date']['output']>;
  dateAttributeName?: Maybe<Scalars['String']['output']>;
  decisionTherapy?: Maybe<CoverageRequestTherapyDecision>;
  documentStatus?: Maybe<DocumentStatus>;
  externalFormId?: Maybe<Scalars['String']['output']>;
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: FlexEntityFinancialDataPointsConnection;
  firstPrescriptionDate?: Maybe<Scalars['Date']['output']>;
  flexEntityName: Scalars['String']['output'];
  generics: Array<Generic>;
  genericsAggregate?: Maybe<FlexEntityGenericGenericsAggregationSelection>;
  genericsConnection: FlexEntityGenericsConnection;
  hasRefunds: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indirectCases: Array<Case>;
  insuranceClaimId?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isAutogenerated: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isOrphaned: Scalars['Boolean']['output'];
  isRevoked: Scalars['Boolean']['output'];
  isUploaded: Scalars['Boolean']['output'];
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  occurrence?: Maybe<OccurrenceEnum>;
  otherLastFinancialDataPoints: Array<FlexFinancialDataPoint>;
  patient?: Maybe<Patient>;
  patientAggregate?: Maybe<FlexEntityPatientPatientAggregationSelection>;
  patientConnection: FlexEntityPatientConnection;
  patientId?: Maybe<Scalars['String']['output']>;
  patientIdKeys: Array<Scalars['String']['output']>;
  predecessor?: Maybe<FlexEntity>;
  predecessorAggregate?: Maybe<FlexEntityFlexEntityPredecessorAggregationSelection>;
  predecessorConnection: FlexEntityPredecessorConnection;
  preparationBrandNames?: Maybe<Scalars['String']['output']>;
  preparationGenericNames?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<Purchase>;
  purchaseAggregate?: Maybe<FlexEntityPurchasePurchaseAggregationSelection>;
  purchaseConnection: FlexEntityPurchaseConnection;
  purchaseId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<CoverageRequestRating>;
  refundStatus?: Maybe<RefundStatus>;
  source?: Maybe<FlexEntity>;
  sourceAggregate?: Maybe<FlexEntityFlexEntitySourceAggregationSelection>;
  sourceConnection: FlexEntitySourceConnection;
  sourced: Array<FlexEntity>;
  sourcedAggregate?: Maybe<FlexEntityFlexEntitySourcedAggregationSelection>;
  sourcedConnection: FlexEntitySourcedConnection;
  status?: Maybe<FlexFormStatus>;
  successor?: Maybe<FlexEntity>;
  successorAggregate?: Maybe<FlexEntityFlexEntitySuccessorAggregationSelection>;
  successorConnection: FlexEntitySuccessorConnection;
  tenantId: Scalars['String']['output'];
  therapyTrialStartDate?: Maybe<Scalars['Date']['output']>;
  type: FlexEntityType;
  typeAggregate?: Maybe<FlexEntityFlexEntityTypeTypeAggregationSelection>;
  typeConnection: FlexEntityTypeConnection;
  upload?: Maybe<Upload>;
  uploadAggregate?: Maybe<FlexEntityUploadUploadAggregationSelection>;
  uploadConnection: FlexEntityUploadConnection;
  uuid: Scalars['String']['output'];
  viewCaseId?: Maybe<Scalars['String']['output']>;
  viewCases?: Maybe<Scalars['String']['output']>;
  viewCreatedByName?: Maybe<Scalars['String']['output']>;
  viewDate?: Maybe<Scalars['Date']['output']>;
  viewFormattedContentDe?: Maybe<Scalars['String']['output']>;
  viewFormattedContentEn?: Maybe<Scalars['String']['output']>;
  viewSourceRefundStatus?: Maybe<RefundStatus>;
  viewSuccessorId?: Maybe<Scalars['String']['output']>;
};


export type FlexEntityCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexEntityCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexEntityCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityCasesConnectionSort>>;
  where?: InputMaybe<FlexEntityCasesConnectionWhere>;
};


export type FlexEntityCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityCreatedByConnectionSort>>;
  where?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
};


export type FlexEntityFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type FlexEntityFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type FlexEntityFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
};


export type FlexEntityGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type FlexEntityGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type FlexEntityGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityGenericsConnectionSort>>;
  where?: InputMaybe<FlexEntityGenericsConnectionWhere>;
};


export type FlexEntityIndirectCasesArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
};


export type FlexEntityOtherLastFinancialDataPointsArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
};


export type FlexEntityPatientArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PatientOptions>;
  where?: InputMaybe<PatientWhere>;
};


export type FlexEntityPatientAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientWhere>;
};


export type FlexEntityPatientConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityPatientConnectionSort>>;
  where?: InputMaybe<FlexEntityPatientConnectionWhere>;
};


export type FlexEntityPredecessorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityPredecessorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityPredecessorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityPredecessorConnectionSort>>;
  where?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
};


export type FlexEntityPurchaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PurchaseOptions>;
  where?: InputMaybe<PurchaseWhere>;
};


export type FlexEntityPurchaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PurchaseWhere>;
};


export type FlexEntityPurchaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityPurchaseConnectionSort>>;
  where?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
};


export type FlexEntitySourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntitySourceConnectionSort>>;
  where?: InputMaybe<FlexEntitySourceConnectionWhere>;
};


export type FlexEntitySourcedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourcedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySourcedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntitySourcedConnectionSort>>;
  where?: InputMaybe<FlexEntitySourcedConnectionWhere>;
};


export type FlexEntitySuccessorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySuccessorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntitySuccessorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntitySuccessorConnectionSort>>;
  where?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
};


export type FlexEntityTypeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeConnectionWhere>;
};


export type FlexEntityUploadArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UploadOptions>;
  where?: InputMaybe<UploadWhere>;
};


export type FlexEntityUploadAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UploadWhere>;
};


export type FlexEntityUploadConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityUploadConnectionSort>>;
  where?: InputMaybe<FlexEntityUploadConnectionWhere>;
};

export type FlexEntityAggregateSelection = {
  __typename?: 'FlexEntityAggregateSelection';
  count: Scalars['Int']['output'];
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityAttributeValidation = {
  __typename?: 'FlexEntityAttributeValidation';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  status: AttributeValidationStatus;
  valueIsPresent?: Maybe<Scalars['Boolean']['output']>;
};

export type FlexEntityAttributeValidationAggregateSelection = {
  __typename?: 'FlexEntityAttributeValidationAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelectionNonNullable;
};

export type FlexEntityAttributeValidationEdge = {
  __typename?: 'FlexEntityAttributeValidationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityAttributeValidation;
};

export type FlexEntityAttributeValidationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityAttributeValidationSort objects to sort FlexEntityAttributeValidations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityAttributeValidationSort>>;
};

/** Fields to sort FlexEntityAttributeValidations by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityAttributeValidationSort object. */
export type FlexEntityAttributeValidationSort = {
  name?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  valueIsPresent?: InputMaybe<SortDirection>;
};

export type FlexEntityAttributeValidationWhere = {
  AND?: InputMaybe<Array<FlexEntityAttributeValidationWhere>>;
  NOT?: InputMaybe<FlexEntityAttributeValidationWhere>;
  OR?: InputMaybe<Array<FlexEntityAttributeValidationWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AttributeValidationStatus>;
  status_IN?: InputMaybe<Array<AttributeValidationStatus>>;
  valueIsPresent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlexEntityAttributeValidationsConnection = {
  __typename?: 'FlexEntityAttributeValidationsConnection';
  edges: Array<FlexEntityAttributeValidationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityBulkProgress = {
  __typename?: 'FlexEntityBulkProgress';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  casesCreated?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  expectedRunAgreements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  formsCreated?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  patientsCreated?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  percentage?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  uploadedById?: Maybe<Scalars['String']['output']>;
};

export type FlexEntityBulkProgressAggregateSelection = {
  __typename?: 'FlexEntityBulkProgressAggregateSelection';
  count: Scalars['Int']['output'];
  percentage: IntAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  uploadedById: StringAggregateSelectionNullable;
};

export type FlexEntityBulkProgressEdge = {
  __typename?: 'FlexEntityBulkProgressEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityBulkProgress;
};

export type FlexEntityBulkProgressOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityBulkProgressSort objects to sort FlexEntityBulkProgresses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityBulkProgressSort>>;
};

/** Fields to sort FlexEntityBulkProgresses by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityBulkProgressSort object. */
export type FlexEntityBulkProgressSort = {
  percentage?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  uploadedById?: InputMaybe<SortDirection>;
};

export type FlexEntityBulkProgressWhere = {
  AND?: InputMaybe<Array<FlexEntityBulkProgressWhere>>;
  NOT?: InputMaybe<FlexEntityBulkProgressWhere>;
  OR?: InputMaybe<Array<FlexEntityBulkProgressWhere>>;
  casesCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  casesCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  expectedRunAgreements?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expectedRunAgreements_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  formsCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formsCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientsCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientsCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentage_GT?: InputMaybe<Scalars['Int']['input']>;
  percentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  percentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  percentage_LT?: InputMaybe<Scalars['Int']['input']>;
  percentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedById?: InputMaybe<Scalars['String']['input']>;
  uploadedById_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uploadedById_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedById_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploadedById_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uploadedById_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FlexEntityBulkProgressesConnection = {
  __typename?: 'FlexEntityBulkProgressesConnection';
  edges: Array<FlexEntityBulkProgressEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityCaseCasesAggregationSelection = {
  __typename?: 'FlexEntityCaseCasesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityCaseCasesNodeAggregateSelection>;
};

export type FlexEntityCaseCasesNodeAggregateSelection = {
  __typename?: 'FlexEntityCaseCasesNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type FlexEntityCasesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityCasesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityCasesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityCasesNodeAggregationWhereInput>;
};

export type FlexEntityCasesConnection = {
  __typename?: 'FlexEntityCasesConnection';
  edges: Array<FlexEntityCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityCasesConnectionSort = {
  edge?: InputMaybe<CaseFlexEntityRelationshipSort>;
  node?: InputMaybe<CaseSort>;
};

export type FlexEntityCasesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityCasesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityCasesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityCasesConnectionWhere>>;
  edge?: InputMaybe<CaseFlexEntityRelationshipWhere>;
  node?: InputMaybe<CaseWhere>;
};

export type FlexEntityCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityCasesNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexEntityCasesRelationship = CaseFlexEntityRelationship & {
  __typename?: 'FlexEntityCasesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isStartingPoint: Scalars['Boolean']['output'];
  node: Case;
};

export type FlexEntityCreatedByAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityCreatedByAggregateInput>>;
  NOT?: InputMaybe<FlexEntityCreatedByAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityCreatedByNodeAggregationWhereInput>;
};

export type FlexEntityCreatedByConnection = {
  __typename?: 'FlexEntityCreatedByConnection';
  edges: Array<FlexEntityCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexEntityCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityCreatedByConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexEntityCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityCreatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityCreatedByRelationship = {
  __typename?: 'FlexEntityCreatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexEntityEdge = {
  __typename?: 'FlexEntityEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export enum FlexEntityFeature {
  Deletion = 'DELETION',
  Editing = 'EDITING',
  Saving = 'SAVING',
  Submission = 'SUBMISSION'
}

export type FlexEntityFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<FlexEntityFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityFinancialDataPointsNodeAggregationWhereInput>;
};

export type FlexEntityFinancialDataPointsConnection = {
  __typename?: 'FlexEntityFinancialDataPointsConnection';
  edges: Array<FlexEntityFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type FlexEntityFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type FlexEntityFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexEntityFinancialDataPointsRelationship = {
  __typename?: 'FlexEntityFinancialDataPointsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type FlexEntityFlexEntityPredecessorAggregationSelection = {
  __typename?: 'FlexEntityFlexEntityPredecessorAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntityPredecessorNodeAggregateSelection>;
};

export type FlexEntityFlexEntityPredecessorNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntityPredecessorNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntitySourceAggregationSelection = {
  __typename?: 'FlexEntityFlexEntitySourceAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntitySourceNodeAggregateSelection>;
};

export type FlexEntityFlexEntitySourceNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntitySourceNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntitySourcedAggregationSelection = {
  __typename?: 'FlexEntityFlexEntitySourcedAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntitySourcedNodeAggregateSelection>;
};

export type FlexEntityFlexEntitySourcedNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntitySourcedNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntitySuccessorAggregationSelection = {
  __typename?: 'FlexEntityFlexEntitySuccessorAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntitySuccessorNodeAggregateSelection>;
};

export type FlexEntityFlexEntitySuccessorNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntitySuccessorNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityFlexEntityTypeTypeAggregationSelection = {
  __typename?: 'FlexEntityFlexEntityTypeTypeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexEntityTypeTypeNodeAggregateSelection>;
};

export type FlexEntityFlexEntityTypeTypeNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexEntityTypeTypeNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'FlexEntityFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'FlexEntityFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type FlexEntityGenericGenericsAggregationSelection = {
  __typename?: 'FlexEntityGenericGenericsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityGenericGenericsNodeAggregateSelection>;
};

export type FlexEntityGenericGenericsNodeAggregateSelection = {
  __typename?: 'FlexEntityGenericGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type FlexEntityGenericsAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityGenericsAggregateInput>>;
  NOT?: InputMaybe<FlexEntityGenericsAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityGenericsNodeAggregationWhereInput>;
};

export type FlexEntityGenericsConnection = {
  __typename?: 'FlexEntityGenericsConnection';
  edges: Array<FlexEntityGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type FlexEntityGenericsConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityGenericsConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type FlexEntityGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<FlexEntityGenericsNodeAggregationWhereInput>>;
};

export type FlexEntityGenericsRelationship = {
  __typename?: 'FlexEntityGenericsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type FlexEntityOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntitySort objects to sort FlexEntities by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntitySort>>;
};

export type FlexEntityPatientAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityPatientAggregateInput>>;
  NOT?: InputMaybe<FlexEntityPatientAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityPatientAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityPatientNodeAggregationWhereInput>;
};

export type FlexEntityPatientConnection = {
  __typename?: 'FlexEntityPatientConnection';
  edges: Array<FlexEntityPatientRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityPatientConnectionSort = {
  node?: InputMaybe<PatientSort>;
};

export type FlexEntityPatientConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityPatientConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityPatientConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityPatientConnectionWhere>>;
  node?: InputMaybe<PatientWhere>;
};

export type FlexEntityPatientNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityPatientNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityPatientNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityPatientNodeAggregationWhereInput>>;
  initials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdateDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityPatientPatientAggregationSelection = {
  __typename?: 'FlexEntityPatientPatientAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityPatientPatientNodeAggregateSelection>;
};

export type FlexEntityPatientPatientNodeAggregateSelection = {
  __typename?: 'FlexEntityPatientPatientNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  initials: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  yearOfBirth: IntAggregateSelectionNullable;
};

export type FlexEntityPatientRelationship = {
  __typename?: 'FlexEntityPatientRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type FlexEntityPredecessorAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityPredecessorAggregateInput>>;
  NOT?: InputMaybe<FlexEntityPredecessorAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityPredecessorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityPredecessorNodeAggregationWhereInput>;
};

export type FlexEntityPredecessorConnection = {
  __typename?: 'FlexEntityPredecessorConnection';
  edges: Array<FlexEntityPredecessorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityPredecessorConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityPredecessorConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityPredecessorConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityPredecessorConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityPredecessorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityPredecessorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityPredecessorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityPredecessorNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityPredecessorRelationship = {
  __typename?: 'FlexEntityPredecessorRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntityPurchaseAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityPurchaseAggregateInput>>;
  NOT?: InputMaybe<FlexEntityPurchaseAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityPurchaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityPurchaseNodeAggregationWhereInput>;
};

export type FlexEntityPurchaseConnection = {
  __typename?: 'FlexEntityPurchaseConnection';
  edges: Array<FlexEntityPurchaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityPurchaseConnectionSort = {
  node?: InputMaybe<PurchaseSort>;
};

export type FlexEntityPurchaseConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityPurchaseConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityPurchaseConnectionWhere>>;
  node?: InputMaybe<PurchaseWhere>;
};

export type FlexEntityPurchaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityPurchaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityPurchaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityPurchaseNodeAggregationWhereInput>>;
  lastUpdateDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexEntityPurchasePurchaseAggregationSelection = {
  __typename?: 'FlexEntityPurchasePurchaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityPurchasePurchaseNodeAggregateSelection>;
};

export type FlexEntityPurchasePurchaseNodeAggregateSelection = {
  __typename?: 'FlexEntityPurchasePurchaseNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  purchaseId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type FlexEntityPurchaseRelationship = {
  __typename?: 'FlexEntityPurchaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Purchase;
};

/** Fields to sort FlexEntities by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntitySort object. */
export type FlexEntitySort = {
  autogenerationTrigger?: InputMaybe<SortDirection>;
  containerType?: InputMaybe<SortDirection>;
  coverageStartDate?: InputMaybe<SortDirection>;
  createdByEmail?: InputMaybe<SortDirection>;
  createdByName?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  dataKeys?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  dateAttributeName?: InputMaybe<SortDirection>;
  decisionTherapy?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  externalFormId?: InputMaybe<SortDirection>;
  firstPrescriptionDate?: InputMaybe<SortDirection>;
  flexEntityName?: InputMaybe<SortDirection>;
  hasRefunds?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  insuranceClaimId?: InputMaybe<SortDirection>;
  invoiceDate?: InputMaybe<SortDirection>;
  invoiceNumber?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isAutogenerated?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isOrphaned?: InputMaybe<SortDirection>;
  isRevoked?: InputMaybe<SortDirection>;
  isUploaded?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  occurrence?: InputMaybe<SortDirection>;
  patientId?: InputMaybe<SortDirection>;
  preparationBrandNames?: InputMaybe<SortDirection>;
  preparationGenericNames?: InputMaybe<SortDirection>;
  purchaseId?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  rating?: InputMaybe<SortDirection>;
  refundStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  therapyTrialStartDate?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  viewCaseId?: InputMaybe<SortDirection>;
  viewCases?: InputMaybe<SortDirection>;
  viewCreatedByName?: InputMaybe<SortDirection>;
  viewDate?: InputMaybe<SortDirection>;
  viewFormattedContentDe?: InputMaybe<SortDirection>;
  viewFormattedContentEn?: InputMaybe<SortDirection>;
  viewSourceRefundStatus?: InputMaybe<SortDirection>;
  viewSuccessorId?: InputMaybe<SortDirection>;
};

export type FlexEntitySourceAggregateInput = {
  AND?: InputMaybe<Array<FlexEntitySourceAggregateInput>>;
  NOT?: InputMaybe<FlexEntitySourceAggregateInput>;
  OR?: InputMaybe<Array<FlexEntitySourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntitySourceNodeAggregationWhereInput>;
};

export type FlexEntitySourceConnection = {
  __typename?: 'FlexEntitySourceConnection';
  edges: Array<FlexEntitySourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntitySourceConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySourceConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntitySourceConnectionWhere>>;
  NOT?: InputMaybe<FlexEntitySourceConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntitySourceConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntitySourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntitySourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntitySourceNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntitySourceRelationship = {
  __typename?: 'FlexEntitySourceRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntitySourcedAggregateInput = {
  AND?: InputMaybe<Array<FlexEntitySourcedAggregateInput>>;
  NOT?: InputMaybe<FlexEntitySourcedAggregateInput>;
  OR?: InputMaybe<Array<FlexEntitySourcedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntitySourcedNodeAggregationWhereInput>;
};

export type FlexEntitySourcedConnection = {
  __typename?: 'FlexEntitySourcedConnection';
  edges: Array<FlexEntitySourcedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntitySourcedConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySourcedConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntitySourcedConnectionWhere>>;
  NOT?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntitySourcedConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySourcedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntitySourcedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntitySourcedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntitySourcedNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntitySourcedRelationship = {
  __typename?: 'FlexEntitySourcedRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntitySuccessorAggregateInput = {
  AND?: InputMaybe<Array<FlexEntitySuccessorAggregateInput>>;
  NOT?: InputMaybe<FlexEntitySuccessorAggregateInput>;
  OR?: InputMaybe<Array<FlexEntitySuccessorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntitySuccessorNodeAggregationWhereInput>;
};

export type FlexEntitySuccessorConnection = {
  __typename?: 'FlexEntitySuccessorConnection';
  edges: Array<FlexEntitySuccessorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntitySuccessorConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntitySuccessorConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntitySuccessorConnectionWhere>>;
  NOT?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntitySuccessorConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntitySuccessorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntitySuccessorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntitySuccessorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntitySuccessorNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntitySuccessorRelationship = {
  __typename?: 'FlexEntitySuccessorRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntityType = {
  __typename?: 'FlexEntityType';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedBy: User;
  addedByAggregate?: Maybe<FlexEntityTypeUserAddedByAggregationSelection>;
  addedByConnection: FlexEntityTypeAddedByConnection;
  addedByName: Scalars['String']['output'];
  agreementCount: Scalars['Int']['output'];
  attributeCount: Scalars['Int']['output'];
  catalogueAttributes: Array<CatalogueAttribute>;
  catalogueAttributesAggregate?: Maybe<FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection>;
  catalogueAttributesConnection: FlexEntityTypeCatalogueAttributesConnection;
  containerType: FlexContainerType;
  createdOn: Scalars['DateTime']['output'];
  creationWays: Array<DataContainerCreationWay>;
  data: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Array<FlexEntityFeature>;
  id: Scalars['ID']['output'];
  idPrefix: Scalars['String']['output'];
  ignoredAttributes: Array<Scalars['String']['output']>;
  instances: Array<FlexEntity>;
  instancesAggregate?: Maybe<FlexEntityTypeFlexEntityInstancesAggregationSelection>;
  instancesConnection: FlexEntityTypeInstancesConnection;
  isArchived: Scalars['Boolean']['output'];
  isOptional: Scalars['Boolean']['output'];
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  isStartingPoint: Scalars['Boolean']['output'];
  localizationKey: Scalars['String']['output'];
  mappingInstances: Array<Organization>;
  mappingInstancesAggregate?: Maybe<FlexEntityTypeOrganizationMappingInstancesAggregationSelection>;
  mappingInstancesConnection: FlexEntityTypeMappingInstancesConnection;
  name: Scalars['String']['output'];
  orgDataMappings?: Maybe<Array<Scalars['String']['output']>>;
  recordTypes: Array<FlexEntityType>;
  recordTypesAggregate?: Maybe<FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection>;
  recordTypesConnection: FlexEntityTypeRecordTypesConnection;
  tooltipText?: Maybe<Scalars['String']['output']>;
};


export type FlexEntityTypeAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityTypeAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type FlexEntityTypeAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeAddedByConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
};


export type FlexEntityTypeCatalogueAttributesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type FlexEntityTypeCatalogueAttributesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type FlexEntityTypeCatalogueAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
};


export type FlexEntityTypeInstancesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityTypeInstancesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexEntityTypeInstancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeInstancesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
};


export type FlexEntityTypeMappingInstancesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type FlexEntityTypeMappingInstancesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type FlexEntityTypeMappingInstancesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeMappingInstancesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
};


export type FlexEntityTypeRecordTypesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeRecordTypesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type FlexEntityTypeRecordTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexEntityTypeRecordTypesConnectionSort>>;
  where?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
};

export type FlexEntityTypeAddedByAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeAddedByAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeAddedByAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeAddedByNodeAggregationWhereInput>;
};

export type FlexEntityTypeAddedByConnection = {
  __typename?: 'FlexEntityTypeAddedByConnection';
  edges: Array<FlexEntityTypeAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type FlexEntityTypeAddedByConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeAddedByConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type FlexEntityTypeAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeAddedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeAddedByRelationship = {
  __typename?: 'FlexEntityTypeAddedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type FlexEntityTypeAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeNodeAggregationWhereInput>;
};

export type FlexEntityTypeAggregateSelection = {
  __typename?: 'FlexEntityTypeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection = {
  __typename?: 'FlexEntityTypeCatalogueAttributeCatalogueAttributesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection>;
};

export type FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeCatalogueAttributeCatalogueAttributesNodeAggregateSelection';
  caption: StringAggregateSelectionNonNullable;
  decimalPrecision: IntAggregateSelectionNullable;
  defaultValue: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  identifier: StringAggregateSelectionNonNullable;
  longLabelLocalizationKey: StringAggregateSelectionNonNullable;
  maxLength: IntAggregateSelectionNullable;
  minLength: IntAggregateSelectionNullable;
  rules: StringAggregateSelectionNullable;
  shortLabelLocalizationKey: StringAggregateSelectionNonNullable;
  values: StringAggregateSelectionNullable;
};

export type FlexEntityTypeCatalogueAttributeRelationship = {
  isDisplayedInCaseDetails?: Maybe<Scalars['Boolean']['output']>;
  isDisplayedInCaseTable?: Maybe<Scalars['Boolean']['output']>;
};

export type FlexEntityTypeCatalogueAttributeRelationshipSort = {
  isDisplayedInCaseDetails?: InputMaybe<SortDirection>;
  isDisplayedInCaseTable?: InputMaybe<SortDirection>;
};

export type FlexEntityTypeCatalogueAttributeRelationshipWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributeRelationshipWhere>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributeRelationshipWhere>>;
  isDisplayedInCaseDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayedInCaseTable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlexEntityTypeCatalogueAttributesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>;
};

export type FlexEntityTypeCatalogueAttributesConnection = {
  __typename?: 'FlexEntityTypeCatalogueAttributesConnection';
  edges: Array<FlexEntityTypeCatalogueAttributesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeCatalogueAttributesConnectionSort = {
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipSort>;
  node?: InputMaybe<CatalogueAttributeSort>;
};

export type FlexEntityTypeCatalogueAttributesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesConnectionWhere>>;
  edge?: InputMaybe<FlexEntityTypeCatalogueAttributeRelationshipWhere>;
  node?: InputMaybe<CatalogueAttributeWhere>;
};

export type FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeCatalogueAttributesNodeAggregationWhereInput>>;
  caption_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caption_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caption_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caption_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  decimalPrecision_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  decimalPrecision_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultValue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  defaultValue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  identifier_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  identifier_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  identifier_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  longLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  maxLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  maxLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  maxLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  minLength_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  minLength_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  minLength_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rules_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rules_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rules_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortLabelLocalizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  values_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  values_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  values_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeCatalogueAttributesRelationship = FlexEntityTypeCatalogueAttributeRelationship & {
  __typename?: 'FlexEntityTypeCatalogueAttributesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isDisplayedInCaseDetails?: Maybe<Scalars['Boolean']['output']>;
  isDisplayedInCaseTable?: Maybe<Scalars['Boolean']['output']>;
  node: CatalogueAttribute;
};

export type FlexEntityTypeConnection = {
  __typename?: 'FlexEntityTypeConnection';
  edges: Array<FlexEntityTypeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeConnectionSort = {
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type FlexEntityTypeConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeConnectionWhere>>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type FlexEntityTypeEdge = {
  __typename?: 'FlexEntityTypeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

export type FlexEntityTypeFlexEntityInstancesAggregationSelection = {
  __typename?: 'FlexEntityTypeFlexEntityInstancesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeFlexEntityInstancesNodeAggregateSelection>;
};

export type FlexEntityTypeFlexEntityInstancesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeFlexEntityInstancesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection = {
  __typename?: 'FlexEntityTypeFlexEntityTypeRecordTypesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection>;
};

export type FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeFlexEntityTypeRecordTypesNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type FlexEntityTypeInstancesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeInstancesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeInstancesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeInstancesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeInstancesNodeAggregationWhereInput>;
};

export type FlexEntityTypeInstancesConnection = {
  __typename?: 'FlexEntityTypeInstancesConnection';
  edges: Array<FlexEntityTypeInstancesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeInstancesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexEntityTypeInstancesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeInstancesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeInstancesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexEntityTypeInstancesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeInstancesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeInstancesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeInstancesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeInstancesRelationship = {
  __typename?: 'FlexEntityTypeInstancesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexEntityTypeMappingInstancesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>;
  node?: InputMaybe<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>;
};

export type FlexEntityTypeMappingInstancesConnection = {
  __typename?: 'FlexEntityTypeMappingInstancesConnection';
  edges: Array<FlexEntityTypeMappingInstancesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeMappingInstancesConnectionSort = {
  edge?: InputMaybe<EntityTypeMappingRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type FlexEntityTypeMappingInstancesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesConnectionWhere>>;
  edge?: InputMaybe<EntityTypeMappingRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type FlexEntityTypeMappingInstancesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesEdgeAggregationWhereInput>>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeMappingInstancesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeMappingInstancesNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeMappingInstancesRelationship = EntityTypeMappingRelationship & {
  __typename?: 'FlexEntityTypeMappingInstancesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  node: Organization;
};

export type FlexEntityTypeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityTypeSort objects to sort FlexEntityTypes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityTypeSort>>;
};

export type FlexEntityTypeOrganizationMappingInstancesAggregationSelection = {
  __typename?: 'FlexEntityTypeOrganizationMappingInstancesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection>;
  node?: Maybe<FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection>;
};

export type FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection = {
  __typename?: 'FlexEntityTypeOrganizationMappingInstancesEdgeAggregateSelection';
  data: StringAggregateSelectionNullable;
};

export type FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeOrganizationMappingInstancesNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type FlexEntityTypeRecordTypesAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityTypeRecordTypesAggregateInput>>;
  NOT?: InputMaybe<FlexEntityTypeRecordTypesAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityTypeRecordTypesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityTypeRecordTypesNodeAggregationWhereInput>;
};

export type FlexEntityTypeRecordTypesConnection = {
  __typename?: 'FlexEntityTypeRecordTypesConnection';
  edges: Array<FlexEntityTypeRecordTypesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityTypeRecordTypesConnectionSort = {
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type FlexEntityTypeRecordTypesConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeRecordTypesConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeRecordTypesConnectionWhere>>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type FlexEntityTypeRecordTypesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityTypeRecordTypesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityTypeRecordTypesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityTypeRecordTypesNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityTypeRecordTypesRelationship = {
  __typename?: 'FlexEntityTypeRecordTypesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

export type FlexEntityTypeRelationship = {
  __typename?: 'FlexEntityTypeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityType;
};

/** Fields to sort FlexEntityTypes by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityTypeSort object. */
export type FlexEntityTypeSort = {
  addedByName?: InputMaybe<SortDirection>;
  agreementCount?: InputMaybe<SortDirection>;
  attributeCount?: InputMaybe<SortDirection>;
  containerType?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  idPrefix?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isOptional?: InputMaybe<SortDirection>;
  isReadOnly?: InputMaybe<SortDirection>;
  isStartingPoint?: InputMaybe<SortDirection>;
  localizationKey?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  tooltipText?: InputMaybe<SortDirection>;
};

export type FlexEntityTypeUserAddedByAggregationSelection = {
  __typename?: 'FlexEntityTypeUserAddedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityTypeUserAddedByNodeAggregateSelection>;
};

export type FlexEntityTypeUserAddedByNodeAggregateSelection = {
  __typename?: 'FlexEntityTypeUserAddedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type FlexEntityTypeWhere = {
  AND?: InputMaybe<Array<FlexEntityTypeWhere>>;
  NOT?: InputMaybe<FlexEntityTypeWhere>;
  OR?: InputMaybe<Array<FlexEntityTypeWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<FlexEntityTypeAddedByAggregateInput>;
  addedByConnection?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<FlexEntityTypeAddedByConnectionWhere>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  attributeCount?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  attributeCount_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  catalogueAttributesAggregate?: InputMaybe<FlexEntityTypeCatalogueAttributesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_ALL?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_NONE?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_SINGLE?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeCatalogueAttributesConnections match this filter */
  catalogueAttributesConnection_SOME?: InputMaybe<FlexEntityTypeCatalogueAttributesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related CatalogueAttributes match this filter */
  catalogueAttributes_ALL?: InputMaybe<CatalogueAttributeWhere>;
  /** Return FlexEntityTypes where none of the related CatalogueAttributes match this filter */
  catalogueAttributes_NONE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return FlexEntityTypes where one of the related CatalogueAttributes match this filter */
  catalogueAttributes_SINGLE?: InputMaybe<CatalogueAttributeWhere>;
  /** Return FlexEntityTypes where some of the related CatalogueAttributes match this filter */
  catalogueAttributes_SOME?: InputMaybe<CatalogueAttributeWhere>;
  containerType?: InputMaybe<FlexContainerType>;
  containerType_IN?: InputMaybe<Array<FlexContainerType>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creationWays?: InputMaybe<Array<DataContainerCreationWay>>;
  creationWays_INCLUDES?: InputMaybe<DataContainerCreationWay>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<FlexEntityFeature>>;
  features_INCLUDES?: InputMaybe<FlexEntityFeature>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idPrefix?: InputMaybe<Scalars['String']['input']>;
  idPrefix_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  idPrefix_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  idPrefix_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  idPrefix_MATCHES?: InputMaybe<Scalars['String']['input']>;
  idPrefix_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  ignoredAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoredAttributes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  instancesAggregate?: InputMaybe<FlexEntityTypeInstancesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_ALL?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_NONE?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_SINGLE?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeInstancesConnections match this filter */
  instancesConnection_SOME?: InputMaybe<FlexEntityTypeInstancesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related FlexEntities match this filter */
  instances_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntities match this filter */
  instances_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntities match this filter */
  instances_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntities match this filter */
  instances_SOME?: InputMaybe<FlexEntityWhere>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isStartingPoint?: InputMaybe<Scalars['Boolean']['input']>;
  localizationKey?: InputMaybe<Scalars['String']['input']>;
  localizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  localizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  localizationKey_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  localizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  localizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mappingInstancesAggregate?: InputMaybe<FlexEntityTypeMappingInstancesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_ALL?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_NONE?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_SINGLE?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeMappingInstancesConnections match this filter */
  mappingInstancesConnection_SOME?: InputMaybe<FlexEntityTypeMappingInstancesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related Organizations match this filter */
  mappingInstances_ALL?: InputMaybe<OrganizationWhere>;
  /** Return FlexEntityTypes where none of the related Organizations match this filter */
  mappingInstances_NONE?: InputMaybe<OrganizationWhere>;
  /** Return FlexEntityTypes where one of the related Organizations match this filter */
  mappingInstances_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return FlexEntityTypes where some of the related Organizations match this filter */
  mappingInstances_SOME?: InputMaybe<OrganizationWhere>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  orgDataMappings?: InputMaybe<Array<Scalars['String']['input']>>;
  orgDataMappings_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordTypesAggregate?: InputMaybe<FlexEntityTypeRecordTypesAggregateInput>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_ALL?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_NONE?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_SINGLE?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypeRecordTypesConnections match this filter */
  recordTypesConnection_SOME?: InputMaybe<FlexEntityTypeRecordTypesConnectionWhere>;
  /** Return FlexEntityTypes where all of the related FlexEntityTypes match this filter */
  recordTypes_ALL?: InputMaybe<FlexEntityTypeWhere>;
  /** Return FlexEntityTypes where none of the related FlexEntityTypes match this filter */
  recordTypes_NONE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return FlexEntityTypes where one of the related FlexEntityTypes match this filter */
  recordTypes_SINGLE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return FlexEntityTypes where some of the related FlexEntityTypes match this filter */
  recordTypes_SOME?: InputMaybe<FlexEntityTypeWhere>;
  tooltipText?: InputMaybe<Scalars['String']['input']>;
  tooltipText_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tooltipText_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tooltipText_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tooltipText_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tooltipText_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FlexEntityTypesConnection = {
  __typename?: 'FlexEntityTypesConnection';
  edges: Array<FlexEntityTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadAggregateInput = {
  AND?: InputMaybe<Array<FlexEntityUploadAggregateInput>>;
  NOT?: InputMaybe<FlexEntityUploadAggregateInput>;
  OR?: InputMaybe<Array<FlexEntityUploadAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexEntityUploadNodeAggregationWhereInput>;
};

export type FlexEntityUploadConnection = {
  __typename?: 'FlexEntityUploadConnection';
  edges: Array<FlexEntityUploadRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadConnectionSort = {
  node?: InputMaybe<UploadSort>;
};

export type FlexEntityUploadConnectionWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadConnectionWhere>>;
  NOT?: InputMaybe<FlexEntityUploadConnectionWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadConnectionWhere>>;
  node?: InputMaybe<UploadWhere>;
};

export type FlexEntityUploadNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexEntityUploadNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexEntityUploadNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexEntityUploadNodeAggregationWhereInput>>;
  timestamp_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexEntityUploadPatientResult = {
  __typename?: 'FlexEntityUploadPatientResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  numberOfEntities: Scalars['Int']['output'];
  patientIds: Array<Scalars['String']['output']>;
};

export type FlexEntityUploadPatientResultAggregateSelection = {
  __typename?: 'FlexEntityUploadPatientResultAggregateSelection';
  count: Scalars['Int']['output'];
  numberOfEntities: IntAggregateSelectionNonNullable;
};

export type FlexEntityUploadPatientResultEdge = {
  __typename?: 'FlexEntityUploadPatientResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityUploadPatientResult;
};

export type FlexEntityUploadPatientResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityUploadPatientResultSort objects to sort FlexEntityUploadPatientResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityUploadPatientResultSort>>;
};

/** Fields to sort FlexEntityUploadPatientResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityUploadPatientResultSort object. */
export type FlexEntityUploadPatientResultSort = {
  numberOfEntities?: InputMaybe<SortDirection>;
};

export type FlexEntityUploadPatientResultWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadPatientResultWhere>>;
  NOT?: InputMaybe<FlexEntityUploadPatientResultWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadPatientResultWhere>>;
  numberOfEntities?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntities_GT?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntities_GTE?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntities_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  numberOfEntities_LT?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntities_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type FlexEntityUploadPatientResultsConnection = {
  __typename?: 'FlexEntityUploadPatientResultsConnection';
  edges: Array<FlexEntityUploadPatientResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadProgress = {
  __typename?: 'FlexEntityUploadProgress';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  casesCreated: Array<Scalars['String']['output']>;
  completedAgreementIds?: Maybe<Array<Scalars['String']['output']>>;
  error?: Maybe<Scalars['String']['output']>;
  expectedRunAgreements?: Maybe<Array<ExpectedRunAgreement>>;
  filePath?: Maybe<Scalars['String']['output']>;
  flexEntityTypeId: Scalars['String']['output'];
  isFinal: Scalars['Boolean']['output'];
  mappedFields: Array<UploadFieldMapping>;
  organizationName: Scalars['String']['output'];
  patientsCreated: Array<Scalars['String']['output']>;
  percentage: Scalars['Int']['output'];
  report?: Maybe<Scalars['String']['output']>;
  sourceFileName?: Maybe<Scalars['String']['output']>;
  sourceKeys: Array<Scalars['String']['output']>;
  status: UploadStatus;
  tenantId: Scalars['String']['output'];
  uploadedById: Scalars['String']['output'];
};

export type FlexEntityUploadProgressAggregateSelection = {
  __typename?: 'FlexEntityUploadProgressAggregateSelection';
  count: Scalars['Int']['output'];
  error: StringAggregateSelectionNullable;
  filePath: StringAggregateSelectionNullable;
  flexEntityTypeId: StringAggregateSelectionNonNullable;
  organizationName: StringAggregateSelectionNonNullable;
  percentage: IntAggregateSelectionNonNullable;
  report: StringAggregateSelectionNullable;
  sourceFileName: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uploadedById: StringAggregateSelectionNonNullable;
};

export type FlexEntityUploadProgressEdge = {
  __typename?: 'FlexEntityUploadProgressEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityUploadProgress;
};

export type FlexEntityUploadProgressOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityUploadProgressSort objects to sort FlexEntityUploadProgresses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityUploadProgressSort>>;
};

/** Fields to sort FlexEntityUploadProgresses by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityUploadProgressSort object. */
export type FlexEntityUploadProgressSort = {
  error?: InputMaybe<SortDirection>;
  filePath?: InputMaybe<SortDirection>;
  flexEntityTypeId?: InputMaybe<SortDirection>;
  isFinal?: InputMaybe<SortDirection>;
  organizationName?: InputMaybe<SortDirection>;
  percentage?: InputMaybe<SortDirection>;
  report?: InputMaybe<SortDirection>;
  sourceFileName?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  uploadedById?: InputMaybe<SortDirection>;
};

export type FlexEntityUploadProgressWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadProgressWhere>>;
  NOT?: InputMaybe<FlexEntityUploadProgressWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadProgressWhere>>;
  casesCreated?: InputMaybe<Array<Scalars['String']['input']>>;
  casesCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  completedAgreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  completedAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  error_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  error_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  error_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  error_MATCHES?: InputMaybe<Scalars['String']['input']>;
  error_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  filePath_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filePath_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filePath_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filePath_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filePath_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeId?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flexEntityTypeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isFinal?: InputMaybe<Scalars['Boolean']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientsCreated?: InputMaybe<Array<Scalars['String']['input']>>;
  patientsCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentage_GT?: InputMaybe<Scalars['Int']['input']>;
  percentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  percentage_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  percentage_LT?: InputMaybe<Scalars['Int']['input']>;
  percentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  report?: InputMaybe<Scalars['String']['input']>;
  report_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  report_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  report_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  report_MATCHES?: InputMaybe<Scalars['String']['input']>;
  report_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceFileName?: InputMaybe<Scalars['String']['input']>;
  sourceFileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceFileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceFileName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceFileName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceFileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceKeys_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UploadStatus>;
  status_IN?: InputMaybe<Array<UploadStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedById?: InputMaybe<Scalars['String']['input']>;
  uploadedById_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uploadedById_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uploadedById_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  uploadedById_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uploadedById_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FlexEntityUploadProgressesConnection = {
  __typename?: 'FlexEntityUploadProgressesConnection';
  edges: Array<FlexEntityUploadProgressEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadRelationship = {
  __typename?: 'FlexEntityUploadRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Upload;
};

export type FlexEntityUploadReport = {
  __typename?: 'FlexEntityUploadReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  casesCreated: Array<Scalars['String']['output']>;
  completedIn: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  draftedEntities?: Maybe<Array<FlexEntityUploadReportInvalidAttribute>>;
  failedToAdd?: Maybe<Scalars['String']['output']>;
  failedToCreate: Array<FlexEntityUploadReportInvalidAttribute>;
  failedToRevoke: Array<FlexEntityUploadReportBasicEntry>;
  failedToUpdate?: Maybe<Array<FlexEntityUploadReportBasicEntry>>;
  fileName?: Maybe<Scalars['String']['output']>;
  ignoredRecords?: Maybe<Scalars['String']['output']>;
  isCaselessRecord?: Maybe<Scalars['Boolean']['output']>;
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  patientsCreated: Array<Scalars['String']['output']>;
  percentageSourceFile: Scalars['Int']['output'];
  responseType: FlexContainerType;
  revokedEntities: Array<FlexEntityUploadReportBasicEntry>;
  submittedEntities: Array<FlexEntityUploadReportBasicEntry>;
  updatedEntities?: Maybe<Array<FlexEntityUploadReportUpdatedEntity>>;
};

export type FlexEntityUploadReportAggregateSelection = {
  __typename?: 'FlexEntityUploadReportAggregateSelection';
  completedIn: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  failedToAdd: StringAggregateSelectionNullable;
  fileName: StringAggregateSelectionNullable;
  ignoredRecords: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  percentageSourceFile: IntAggregateSelectionNonNullable;
};

export type FlexEntityUploadReportBasicEntriesConnection = {
  __typename?: 'FlexEntityUploadReportBasicEntriesConnection';
  edges: Array<FlexEntityUploadReportBasicEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadReportBasicEntry = {
  __typename?: 'FlexEntityUploadReportBasicEntry';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  patientId: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

export type FlexEntityUploadReportBasicEntryAggregateSelection = {
  __typename?: 'FlexEntityUploadReportBasicEntryAggregateSelection';
  count: Scalars['Int']['output'];
  patientId: StringAggregateSelectionNonNullable;
  rowNumber: IntAggregateSelectionNullable;
};

export type FlexEntityUploadReportBasicEntryEdge = {
  __typename?: 'FlexEntityUploadReportBasicEntryEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityUploadReportBasicEntry;
};

export type FlexEntityUploadReportBasicEntryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityUploadReportBasicEntrySort objects to sort FlexEntityUploadReportBasicEntries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityUploadReportBasicEntrySort>>;
};

/** Fields to sort FlexEntityUploadReportBasicEntries by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityUploadReportBasicEntrySort object. */
export type FlexEntityUploadReportBasicEntrySort = {
  patientId?: InputMaybe<SortDirection>;
  rowNumber?: InputMaybe<SortDirection>;
};

export type FlexEntityUploadReportBasicEntryWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadReportBasicEntryWhere>>;
  NOT?: InputMaybe<FlexEntityUploadReportBasicEntryWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadReportBasicEntryWhere>>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rowNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityUploadReportEdge = {
  __typename?: 'FlexEntityUploadReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityUploadReport;
};

export type FlexEntityUploadReportInvalidAttribute = {
  __typename?: 'FlexEntityUploadReportInvalidAttribute';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  hasImpossibleHighQuantity?: Maybe<Scalars['Boolean']['output']>;
  hasNoValidDate?: Maybe<Scalars['Boolean']['output']>;
  hasNoValidRelevantIndication?: Maybe<Scalars['Boolean']['output']>;
  hasNoValidScope?: Maybe<Scalars['Boolean']['output']>;
  invalidAttributes: Array<FlexEntityAttributeValidation>;
  patientId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

export type FlexEntityUploadReportInvalidAttributeAggregateSelection = {
  __typename?: 'FlexEntityUploadReportInvalidAttributeAggregateSelection';
  count: Scalars['Int']['output'];
  patientId: StringAggregateSelectionNonNullable;
  quantity: FloatAggregateSelectionNullable;
  rowNumber: IntAggregateSelectionNullable;
};

export type FlexEntityUploadReportInvalidAttributeEdge = {
  __typename?: 'FlexEntityUploadReportInvalidAttributeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityUploadReportInvalidAttribute;
};

export type FlexEntityUploadReportInvalidAttributeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityUploadReportInvalidAttributeSort objects to sort FlexEntityUploadReportInvalidAttributes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityUploadReportInvalidAttributeSort>>;
};

/** Fields to sort FlexEntityUploadReportInvalidAttributes by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityUploadReportInvalidAttributeSort object. */
export type FlexEntityUploadReportInvalidAttributeSort = {
  hasImpossibleHighQuantity?: InputMaybe<SortDirection>;
  hasNoValidDate?: InputMaybe<SortDirection>;
  hasNoValidRelevantIndication?: InputMaybe<SortDirection>;
  hasNoValidScope?: InputMaybe<SortDirection>;
  patientId?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  rowNumber?: InputMaybe<SortDirection>;
};

export type FlexEntityUploadReportInvalidAttributeWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadReportInvalidAttributeWhere>>;
  NOT?: InputMaybe<FlexEntityUploadReportInvalidAttributeWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadReportInvalidAttributeWhere>>;
  hasImpossibleHighQuantity?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoValidDate?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoValidRelevantIndication?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoValidScope?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rowNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityUploadReportInvalidAttributesConnection = {
  __typename?: 'FlexEntityUploadReportInvalidAttributesConnection';
  edges: Array<FlexEntityUploadReportInvalidAttributeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityUploadReportSort objects to sort FlexEntityUploadReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityUploadReportSort>>;
};

/** Fields to sort FlexEntityUploadReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityUploadReportSort object. */
export type FlexEntityUploadReportSort = {
  completedIn?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  failedToAdd?: InputMaybe<SortDirection>;
  fileName?: InputMaybe<SortDirection>;
  ignoredRecords?: InputMaybe<SortDirection>;
  isCaselessRecord?: InputMaybe<SortDirection>;
  isComplete?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  percentageSourceFile?: InputMaybe<SortDirection>;
  responseType?: InputMaybe<SortDirection>;
};

export type FlexEntityUploadReportUpdatedEntitiesConnection = {
  __typename?: 'FlexEntityUploadReportUpdatedEntitiesConnection';
  edges: Array<FlexEntityUploadReportUpdatedEntityEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadReportUpdatedEntity = {
  __typename?: 'FlexEntityUploadReportUpdatedEntity';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  attributesUpdated: Scalars['Int']['output'];
  hasNoValidRelevantIndication?: Maybe<Scalars['Boolean']['output']>;
  isSubmitted: Scalars['Boolean']['output'];
  patientId: Scalars['String']['output'];
  rowNumber?: Maybe<Scalars['Int']['output']>;
};

export type FlexEntityUploadReportUpdatedEntityAggregateSelection = {
  __typename?: 'FlexEntityUploadReportUpdatedEntityAggregateSelection';
  attributesUpdated: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  patientId: StringAggregateSelectionNonNullable;
  rowNumber: IntAggregateSelectionNullable;
};

export type FlexEntityUploadReportUpdatedEntityEdge = {
  __typename?: 'FlexEntityUploadReportUpdatedEntityEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntityUploadReportUpdatedEntity;
};

export type FlexEntityUploadReportUpdatedEntityOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexEntityUploadReportUpdatedEntitySort objects to sort FlexEntityUploadReportUpdatedEntities by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexEntityUploadReportUpdatedEntitySort>>;
};

/** Fields to sort FlexEntityUploadReportUpdatedEntities by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexEntityUploadReportUpdatedEntitySort object. */
export type FlexEntityUploadReportUpdatedEntitySort = {
  attributesUpdated?: InputMaybe<SortDirection>;
  hasNoValidRelevantIndication?: InputMaybe<SortDirection>;
  isSubmitted?: InputMaybe<SortDirection>;
  patientId?: InputMaybe<SortDirection>;
  rowNumber?: InputMaybe<SortDirection>;
};

export type FlexEntityUploadReportUpdatedEntityWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadReportUpdatedEntityWhere>>;
  NOT?: InputMaybe<FlexEntityUploadReportUpdatedEntityWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadReportUpdatedEntityWhere>>;
  attributesUpdated?: InputMaybe<Scalars['Int']['input']>;
  attributesUpdated_GT?: InputMaybe<Scalars['Int']['input']>;
  attributesUpdated_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributesUpdated_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  attributesUpdated_LT?: InputMaybe<Scalars['Int']['input']>;
  attributesUpdated_LTE?: InputMaybe<Scalars['Int']['input']>;
  hasNoValidRelevantIndication?: InputMaybe<Scalars['Boolean']['input']>;
  isSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rowNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  rowNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexEntityUploadReportWhere = {
  AND?: InputMaybe<Array<FlexEntityUploadReportWhere>>;
  NOT?: InputMaybe<FlexEntityUploadReportWhere>;
  OR?: InputMaybe<Array<FlexEntityUploadReportWhere>>;
  casesCreated?: InputMaybe<Array<Scalars['String']['input']>>;
  casesCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  completedIn?: InputMaybe<Scalars['Int']['input']>;
  completedIn_GT?: InputMaybe<Scalars['Int']['input']>;
  completedIn_GTE?: InputMaybe<Scalars['Int']['input']>;
  completedIn_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  completedIn_LT?: InputMaybe<Scalars['Int']['input']>;
  completedIn_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  failedToAdd?: InputMaybe<Scalars['String']['input']>;
  failedToAdd_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  failedToAdd_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  failedToAdd_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  failedToAdd_MATCHES?: InputMaybe<Scalars['String']['input']>;
  failedToAdd_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ignoredRecords?: InputMaybe<Scalars['String']['input']>;
  ignoredRecords_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ignoredRecords_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ignoredRecords_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ignoredRecords_MATCHES?: InputMaybe<Scalars['String']['input']>;
  ignoredRecords_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isCaselessRecord?: InputMaybe<Scalars['Boolean']['input']>;
  isComplete?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientsCreated?: InputMaybe<Array<Scalars['String']['input']>>;
  patientsCreated_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  percentageSourceFile?: InputMaybe<Scalars['Int']['input']>;
  percentageSourceFile_GT?: InputMaybe<Scalars['Int']['input']>;
  percentageSourceFile_GTE?: InputMaybe<Scalars['Int']['input']>;
  percentageSourceFile_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  percentageSourceFile_LT?: InputMaybe<Scalars['Int']['input']>;
  percentageSourceFile_LTE?: InputMaybe<Scalars['Int']['input']>;
  responseType?: InputMaybe<FlexContainerType>;
  responseType_IN?: InputMaybe<Array<FlexContainerType>>;
};

export type FlexEntityUploadReportsConnection = {
  __typename?: 'FlexEntityUploadReportsConnection';
  edges: Array<FlexEntityUploadReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexEntityUploadUploadAggregationSelection = {
  __typename?: 'FlexEntityUploadUploadAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityUploadUploadNodeAggregateSelection>;
};

export type FlexEntityUploadUploadNodeAggregateSelection = {
  __typename?: 'FlexEntityUploadUploadNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  timestamp: DateTimeAggregateSelectionNonNullable;
};

export type FlexEntityUserCreatedByAggregationSelection = {
  __typename?: 'FlexEntityUserCreatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexEntityUserCreatedByNodeAggregateSelection>;
};

export type FlexEntityUserCreatedByNodeAggregateSelection = {
  __typename?: 'FlexEntityUserCreatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type FlexEntityWhere = {
  AND?: InputMaybe<Array<FlexEntityWhere>>;
  NOT?: InputMaybe<FlexEntityWhere>;
  OR?: InputMaybe<Array<FlexEntityWhere>>;
  autogenerationTrigger?: InputMaybe<AutogenerationTrigger>;
  autogenerationTrigger_IN?: InputMaybe<Array<InputMaybe<AutogenerationTrigger>>>;
  casesAggregate?: InputMaybe<FlexEntityCasesAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntityCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntityCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntityCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntityCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<FlexEntityCasesConnectionWhere>;
  /** Return FlexEntities where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return FlexEntities where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return FlexEntities where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return FlexEntities where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  containerType?: InputMaybe<FlexContainerType>;
  containerType_IN?: InputMaybe<Array<FlexContainerType>>;
  coverageStartDate?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_GT?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  coverageStartDate_LT?: InputMaybe<Scalars['Date']['input']>;
  coverageStartDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<FlexEntityCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<FlexEntityCreatedByConnectionWhere>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Scalars['String']['input']>;
  createdByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  dataKeys?: InputMaybe<Scalars['String']['input']>;
  dataKeys_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dataKeys_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dataKeys_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  dataKeys_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dataKeys_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  decisionTherapy?: InputMaybe<CoverageRequestTherapyDecision>;
  decisionTherapy_IN?: InputMaybe<Array<InputMaybe<CoverageRequestTherapyDecision>>>;
  externalFormId?: InputMaybe<Scalars['String']['input']>;
  externalFormId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  externalFormId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  externalFormId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalFormId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  externalFormId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  financialDataPointsAggregate?: InputMaybe<FlexEntityFinancialDataPointsAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntityFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<FlexEntityFinancialDataPointsConnectionWhere>;
  /** Return FlexEntities where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return FlexEntities where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return FlexEntities where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return FlexEntities where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  flexEntityName?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flexEntityName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  genericsAggregate?: InputMaybe<FlexEntityGenericsAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_ALL?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_NONE?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_SINGLE?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntityGenericsConnections match this filter */
  genericsConnection_SOME?: InputMaybe<FlexEntityGenericsConnectionWhere>;
  /** Return FlexEntities where all of the related Generics match this filter */
  generics_ALL?: InputMaybe<GenericWhere>;
  /** Return FlexEntities where none of the related Generics match this filter */
  generics_NONE?: InputMaybe<GenericWhere>;
  /** Return FlexEntities where one of the related Generics match this filter */
  generics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return FlexEntities where some of the related Generics match this filter */
  generics_SOME?: InputMaybe<GenericWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  insuranceClaimId?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceClaimId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  invoiceDate_LT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAutogenerated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurrence?: InputMaybe<OccurrenceEnum>;
  occurrence_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
  patient?: InputMaybe<PatientWhere>;
  patientAggregate?: InputMaybe<FlexEntityPatientAggregateInput>;
  patientConnection?: InputMaybe<FlexEntityPatientConnectionWhere>;
  patientConnection_NOT?: InputMaybe<FlexEntityPatientConnectionWhere>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientIdKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIdKeys_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patient_NOT?: InputMaybe<PatientWhere>;
  predecessor?: InputMaybe<FlexEntityWhere>;
  predecessorAggregate?: InputMaybe<FlexEntityPredecessorAggregateInput>;
  predecessorConnection?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
  predecessorConnection_NOT?: InputMaybe<FlexEntityPredecessorConnectionWhere>;
  predecessor_NOT?: InputMaybe<FlexEntityWhere>;
  preparationBrandNames?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationGenericNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<PurchaseWhere>;
  purchaseAggregate?: InputMaybe<FlexEntityPurchaseAggregateInput>;
  purchaseConnection?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
  purchaseConnection_NOT?: InputMaybe<FlexEntityPurchaseConnectionWhere>;
  purchaseId?: InputMaybe<Scalars['String']['input']>;
  purchaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase_NOT?: InputMaybe<PurchaseWhere>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  rating?: InputMaybe<CoverageRequestRating>;
  rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
  source?: InputMaybe<FlexEntityWhere>;
  sourceAggregate?: InputMaybe<FlexEntitySourceAggregateInput>;
  sourceConnection?: InputMaybe<FlexEntitySourceConnectionWhere>;
  sourceConnection_NOT?: InputMaybe<FlexEntitySourceConnectionWhere>;
  source_NOT?: InputMaybe<FlexEntityWhere>;
  sourcedAggregate?: InputMaybe<FlexEntitySourcedAggregateInput>;
  /** Return FlexEntities where all of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_ALL?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where none of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_NONE?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where one of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_SINGLE?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where some of the related FlexEntitySourcedConnections match this filter */
  sourcedConnection_SOME?: InputMaybe<FlexEntitySourcedConnectionWhere>;
  /** Return FlexEntities where all of the related FlexEntities match this filter */
  sourced_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntities where none of the related FlexEntities match this filter */
  sourced_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntities where one of the related FlexEntities match this filter */
  sourced_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return FlexEntities where some of the related FlexEntities match this filter */
  sourced_SOME?: InputMaybe<FlexEntityWhere>;
  status?: InputMaybe<FlexFormStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
  successor?: InputMaybe<FlexEntityWhere>;
  successorAggregate?: InputMaybe<FlexEntitySuccessorAggregateInput>;
  successorConnection?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
  successorConnection_NOT?: InputMaybe<FlexEntitySuccessorConnectionWhere>;
  successor_NOT?: InputMaybe<FlexEntityWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapyTrialStartDate?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_GT?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  therapyTrialStartDate_LT?: InputMaybe<Scalars['Date']['input']>;
  therapyTrialStartDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<FlexEntityTypeWhere>;
  typeAggregate?: InputMaybe<FlexEntityTypeAggregateInput>;
  typeConnection?: InputMaybe<FlexEntityTypeConnectionWhere>;
  typeConnection_NOT?: InputMaybe<FlexEntityTypeConnectionWhere>;
  type_NOT?: InputMaybe<FlexEntityTypeWhere>;
  upload?: InputMaybe<UploadWhere>;
  uploadAggregate?: InputMaybe<FlexEntityUploadAggregateInput>;
  uploadConnection?: InputMaybe<FlexEntityUploadConnectionWhere>;
  uploadConnection_NOT?: InputMaybe<FlexEntityUploadConnectionWhere>;
  upload_NOT?: InputMaybe<UploadWhere>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  uuid_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCaseId?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCases?: InputMaybe<Scalars['String']['input']>;
  viewCases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCreatedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCreatedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewDate?: InputMaybe<Scalars['Date']['input']>;
  viewDate_GT?: InputMaybe<Scalars['Date']['input']>;
  viewDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  viewDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  viewDate_LT?: InputMaybe<Scalars['Date']['input']>;
  viewDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  viewFormattedContentDe?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewFormattedContentDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewFormattedContentEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewSourceRefundStatus?: InputMaybe<RefundStatus>;
  viewSourceRefundStatus_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
  viewSuccessorId?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewSuccessorId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FlexFinancialDataPoint = {
  __typename?: 'FlexFinancialDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<FlexFinancialDataPointAgreementAgreementAggregationSelection>;
  agreementConnection: FlexFinancialDataPointAgreementConnection;
  basePrice: Scalars['Float']['output'];
  basePriceType?: Maybe<PriceType>;
  cannotBeSourceOfRefund?: Maybe<Scalars['Boolean']['output']>;
  createdOn: Scalars['DateTime']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  documentStatus?: Maybe<DocumentStatus>;
  evaluates: FlexEntity;
  evaluatesAggregate?: Maybe<FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection>;
  evaluatesConnection: FlexFinancialDataPointEvaluatesConnection;
  evaluationSnapshot?: Maybe<Scalars['String']['output']>;
  failReason?: Maybe<ScenarioActionFailure>;
  generatedFor?: Maybe<Case>;
  generatedForAggregate?: Maybe<FlexFinancialDataPointCaseGeneratedForAggregationSelection>;
  generatedForConnection: FlexFinancialDataPointGeneratedForConnection;
  generatedUuid: Scalars['ID']['output'];
  isDefaultPriceRateApplied?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isDelta: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  netPrices?: Maybe<Scalars['String']['output']>;
  payable: Scalars['Float']['output'];
  payablePercentage?: Maybe<Scalars['Float']['output']>;
  prescriptionDate: Scalars['Date']['output'];
  quantity: Scalars['Float']['output'];
  refundDeltaNumber: Scalars['Int']['output'];
  refundable: Scalars['Float']['output'];
  refundablePercentage?: Maybe<Scalars['Float']['output']>;
  revokedOn?: Maybe<Scalars['DateTime']['output']>;
  scenarioZeroMainNetPrices?: Maybe<Scalars['String']['output']>;
  scenarioZeroNetPrices?: Maybe<Scalars['String']['output']>;
  scenarioZeroRelevantNetPrices?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<Refund>;
  sourceDocumentAggregate?: Maybe<FlexFinancialDataPointRefundSourceDocumentAggregationSelection>;
  sourceDocumentConnection: FlexFinancialDataPointSourceDocumentConnection;
  sourceDocumentState?: Maybe<Document>;
  sourceRefund?: Maybe<Refund>;
  sourceRefundAggregate?: Maybe<FlexFinancialDataPointRefundSourceRefundAggregationSelection>;
  sourceRefundConnection: FlexFinancialDataPointSourceRefundConnection;
  treatment: Treatment;
  treatmentAggregate?: Maybe<FlexFinancialDataPointTreatmentTreatmentAggregationSelection>;
  treatmentConnection: FlexFinancialDataPointTreatmentConnection;
  uuid: Scalars['ID']['output'];
  variable: Scalars['Float']['output'];
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};


export type FlexFinancialDataPointAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type FlexFinancialDataPointAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type FlexFinancialDataPointAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
};


export type FlexFinancialDataPointEvaluatesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexFinancialDataPointEvaluatesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type FlexFinancialDataPointEvaluatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
};


export type FlexFinancialDataPointGeneratedForArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexFinancialDataPointGeneratedForAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type FlexFinancialDataPointGeneratedForConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointGeneratedForConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
};


export type FlexFinancialDataPointSourceDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
};


export type FlexFinancialDataPointSourceRefundArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceRefundAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type FlexFinancialDataPointSourceRefundConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
};


export type FlexFinancialDataPointTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type FlexFinancialDataPointTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type FlexFinancialDataPointTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionSort>>;
  where?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
};

export type FlexFinancialDataPointAggregateSelection = {
  __typename?: 'FlexFinancialDataPointAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type FlexFinancialDataPointAgreementAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointAgreementAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointAgreementAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointAgreementNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointAgreementAgreementAggregationSelection = {
  __typename?: 'FlexFinancialDataPointAgreementAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointAgreementAgreementNodeAggregateSelection>;
};

export type FlexFinancialDataPointAgreementAgreementNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointAgreementAgreementNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type FlexFinancialDataPointAgreementConnection = {
  __typename?: 'FlexFinancialDataPointAgreementConnection';
  edges: Array<FlexFinancialDataPointAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type FlexFinancialDataPointAgreementConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type FlexFinancialDataPointAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointAgreementNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointAgreementRelationship = {
  __typename?: 'FlexFinancialDataPointAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type FlexFinancialDataPointCaseGeneratedForAggregationSelection = {
  __typename?: 'FlexFinancialDataPointCaseGeneratedForAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection>;
};

export type FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointCaseGeneratedForNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type FlexFinancialDataPointEdge = {
  __typename?: 'FlexFinancialDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type FlexFinancialDataPointEvaluatesAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointEvaluatesAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointEvaluatesConnection = {
  __typename?: 'FlexFinancialDataPointEvaluatesConnection';
  edges: Array<FlexFinancialDataPointEvaluatesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointEvaluatesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type FlexFinancialDataPointEvaluatesConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type FlexFinancialDataPointEvaluatesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointEvaluatesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointEvaluatesRelationship = {
  __typename?: 'FlexFinancialDataPointEvaluatesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection = {
  __typename?: 'FlexFinancialDataPointFlexEntityEvaluatesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection>;
};

export type FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointFlexEntityEvaluatesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type FlexFinancialDataPointGeneratedForAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointGeneratedForAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointGeneratedForAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointGeneratedForAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointGeneratedForConnection = {
  __typename?: 'FlexFinancialDataPointGeneratedForConnection';
  edges: Array<FlexFinancialDataPointGeneratedForRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointGeneratedForConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type FlexFinancialDataPointGeneratedForConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointGeneratedForConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointGeneratedForConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type FlexFinancialDataPointGeneratedForNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointGeneratedForNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexFinancialDataPointGeneratedForRelationship = {
  __typename?: 'FlexFinancialDataPointGeneratedForRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type FlexFinancialDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FlexFinancialDataPointSort objects to sort FlexFinancialDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FlexFinancialDataPointSort>>;
};

export type FlexFinancialDataPointRefundSourceDocumentAggregationSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceDocumentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection>;
};

export type FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceDocumentNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type FlexFinancialDataPointRefundSourceRefundAggregationSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceRefundAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection>;
};

export type FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointRefundSourceRefundNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

/** Fields to sort FlexFinancialDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one FlexFinancialDataPointSort object. */
export type FlexFinancialDataPointSort = {
  basePrice?: InputMaybe<SortDirection>;
  basePriceType?: InputMaybe<SortDirection>;
  cannotBeSourceOfRefund?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  currencyCode?: InputMaybe<SortDirection>;
  date?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  evaluationSnapshot?: InputMaybe<SortDirection>;
  failReason?: InputMaybe<SortDirection>;
  generatedUuid?: InputMaybe<SortDirection>;
  isDefaultPriceRateApplied?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isDelta?: InputMaybe<SortDirection>;
  isLast?: InputMaybe<SortDirection>;
  netPrices?: InputMaybe<SortDirection>;
  payable?: InputMaybe<SortDirection>;
  payablePercentage?: InputMaybe<SortDirection>;
  prescriptionDate?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  refundDeltaNumber?: InputMaybe<SortDirection>;
  refundable?: InputMaybe<SortDirection>;
  refundablePercentage?: InputMaybe<SortDirection>;
  revokedOn?: InputMaybe<SortDirection>;
  scenarioZeroMainNetPrices?: InputMaybe<SortDirection>;
  scenarioZeroNetPrices?: InputMaybe<SortDirection>;
  scenarioZeroRelevantNetPrices?: InputMaybe<SortDirection>;
  sourceDocumentState?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  variable?: InputMaybe<SortDirection>;
  variablePercentage?: InputMaybe<SortDirection>;
};

export type FlexFinancialDataPointSourceDocumentAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointSourceDocumentConnection = {
  __typename?: 'FlexFinancialDataPointSourceDocumentConnection';
  edges: Array<FlexFinancialDataPointSourceDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointSourceDocumentConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type FlexFinancialDataPointSourceDocumentConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceDocumentNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexFinancialDataPointSourceDocumentRelationship = {
  __typename?: 'FlexFinancialDataPointSourceDocumentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type FlexFinancialDataPointSourceRefundAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceRefundAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointSourceRefundConnection = {
  __typename?: 'FlexFinancialDataPointSourceRefundConnection';
  edges: Array<FlexFinancialDataPointSourceRefundRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointSourceRefundConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type FlexFinancialDataPointSourceRefundConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type FlexFinancialDataPointSourceRefundNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointSourceRefundNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FlexFinancialDataPointSourceRefundRelationship = {
  __typename?: 'FlexFinancialDataPointSourceRefundRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type FlexFinancialDataPointTreatmentAggregateInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentAggregateInput>>;
  NOT?: InputMaybe<FlexFinancialDataPointTreatmentAggregateInput>;
  OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>;
};

export type FlexFinancialDataPointTreatmentConnection = {
  __typename?: 'FlexFinancialDataPointTreatmentConnection';
  edges: Array<FlexFinancialDataPointTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlexFinancialDataPointTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type FlexFinancialDataPointTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type FlexFinancialDataPointTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<FlexFinancialDataPointTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type FlexFinancialDataPointTreatmentRelationship = {
  __typename?: 'FlexFinancialDataPointTreatmentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type FlexFinancialDataPointTreatmentTreatmentAggregationSelection = {
  __typename?: 'FlexFinancialDataPointTreatmentTreatmentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection>;
};

export type FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection = {
  __typename?: 'FlexFinancialDataPointTreatmentTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type FlexFinancialDataPointWhere = {
  AND?: InputMaybe<Array<FlexFinancialDataPointWhere>>;
  NOT?: InputMaybe<FlexFinancialDataPointWhere>;
  OR?: InputMaybe<Array<FlexFinancialDataPointWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<FlexFinancialDataPointAgreementAggregateInput>;
  agreementConnection?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<FlexFinancialDataPointAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  basePriceType?: InputMaybe<PriceType>;
  basePriceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  basePrice_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  basePrice_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  cannotBeSourceOfRefund?: InputMaybe<Scalars['Boolean']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  evaluates?: InputMaybe<FlexEntityWhere>;
  evaluatesAggregate?: InputMaybe<FlexFinancialDataPointEvaluatesAggregateInput>;
  evaluatesConnection?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
  evaluatesConnection_NOT?: InputMaybe<FlexFinancialDataPointEvaluatesConnectionWhere>;
  evaluates_NOT?: InputMaybe<FlexEntityWhere>;
  evaluationSnapshot?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  evaluationSnapshot_MATCHES?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  failReason?: InputMaybe<ScenarioActionFailure>;
  failReason_IN?: InputMaybe<Array<InputMaybe<ScenarioActionFailure>>>;
  generatedFor?: InputMaybe<CaseWhere>;
  generatedForAggregate?: InputMaybe<FlexFinancialDataPointGeneratedForAggregateInput>;
  generatedForConnection?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
  generatedForConnection_NOT?: InputMaybe<FlexFinancialDataPointGeneratedForConnectionWhere>;
  generatedFor_NOT?: InputMaybe<CaseWhere>;
  generatedUuid?: InputMaybe<Scalars['ID']['input']>;
  generatedUuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  generatedUuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  generatedUuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  generatedUuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDefaultPriceRateApplied?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDelta?: InputMaybe<Scalars['Boolean']['input']>;
  isLast?: InputMaybe<Scalars['Boolean']['input']>;
  netPrices?: InputMaybe<Scalars['String']['input']>;
  netPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  netPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  netPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  netPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  netPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  payable?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  payablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  payable_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_LTE?: InputMaybe<Scalars['Float']['input']>;
  prescriptionDate?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  prescriptionDate_LT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  refundDeltaNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundable?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  refundablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundable_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  revokedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarioZeroMainNetPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroMainNetPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarioZeroNetPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroNetPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenarioZeroRelevantNetPrices_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenarioZeroRelevantNetPrices_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceDocument?: InputMaybe<RefundWhere>;
  sourceDocumentAggregate?: InputMaybe<FlexFinancialDataPointSourceDocumentAggregateInput>;
  sourceDocumentConnection?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
  sourceDocumentConnection_NOT?: InputMaybe<FlexFinancialDataPointSourceDocumentConnectionWhere>;
  sourceDocument_NOT?: InputMaybe<RefundWhere>;
  sourceRefund?: InputMaybe<RefundWhere>;
  sourceRefundAggregate?: InputMaybe<FlexFinancialDataPointSourceRefundAggregateInput>;
  sourceRefundConnection?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
  sourceRefundConnection_NOT?: InputMaybe<FlexFinancialDataPointSourceRefundConnectionWhere>;
  sourceRefund_NOT?: InputMaybe<RefundWhere>;
  treatment?: InputMaybe<TreatmentWhere>;
  treatmentAggregate?: InputMaybe<FlexFinancialDataPointTreatmentAggregateInput>;
  treatmentConnection?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
  treatmentConnection_NOT?: InputMaybe<FlexFinancialDataPointTreatmentConnectionWhere>;
  treatment_NOT?: InputMaybe<TreatmentWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  variable?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  variablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  variable_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexFinancialDataPointsConnection = {
  __typename?: 'FlexFinancialDataPointsConnection';
  edges: Array<FlexFinancialDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum FlexFormStatus {
  CoolingPeriod = 'COOLING_PERIOD',
  Draft = 'DRAFT',
  Matched = 'MATCHED',
  Revoked = 'REVOKED',
  Submitted = 'SUBMITTED',
  Unmatched = 'UNMATCHED'
}

export type FloatAggregateSelectionNonNullable = {
  __typename?: 'FloatAggregateSelectionNonNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  average: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type FloatAggregateSelectionNullable = {
  __typename?: 'FloatAggregateSelectionNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  sum?: Maybe<Scalars['Float']['output']>;
};

export type FocStatus = {
  __typename?: 'FocStatus';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  approved: Scalars['Float']['output'];
  declined: Scalars['Float']['output'];
};

export type FocStatusAggregateSelection = {
  __typename?: 'FocStatusAggregateSelection';
  approved: FloatAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  declined: FloatAggregateSelectionNonNullable;
};

export type FocStatusEdge = {
  __typename?: 'FocStatusEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FocStatus;
};

export type FocStatusOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FocStatusSort objects to sort FocStatuses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FocStatusSort>>;
};

/** Fields to sort FocStatuses by. The order in which sorts are applied is not guaranteed when specifying many fields in one FocStatusSort object. */
export type FocStatusSort = {
  approved?: InputMaybe<SortDirection>;
  declined?: InputMaybe<SortDirection>;
};

export type FocStatusWhere = {
  AND?: InputMaybe<Array<FocStatusWhere>>;
  NOT?: InputMaybe<FocStatusWhere>;
  OR?: InputMaybe<Array<FocStatusWhere>>;
  approved?: InputMaybe<Scalars['Float']['input']>;
  approved_GT?: InputMaybe<Scalars['Float']['input']>;
  approved_GTE?: InputMaybe<Scalars['Float']['input']>;
  approved_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  approved_LT?: InputMaybe<Scalars['Float']['input']>;
  approved_LTE?: InputMaybe<Scalars['Float']['input']>;
  declined?: InputMaybe<Scalars['Float']['input']>;
  declined_GT?: InputMaybe<Scalars['Float']['input']>;
  declined_GTE?: InputMaybe<Scalars['Float']['input']>;
  declined_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  declined_LT?: InputMaybe<Scalars['Float']['input']>;
  declined_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type FocStatusesConnection = {
  __typename?: 'FocStatusesConnection';
  edges: Array<FocStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FocTableData = {
  __typename?: 'FocTableData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  discount: Scalars['Float']['output'];
  foc: Scalars['Float']['output'];
  focStatus: FocStatus;
  product: Scalars['String']['output'];
};

export type FocTableDataAggregateSelection = {
  __typename?: 'FocTableDataAggregateSelection';
  count: Scalars['Int']['output'];
  discount: FloatAggregateSelectionNonNullable;
  foc: FloatAggregateSelectionNonNullable;
  product: StringAggregateSelectionNonNullable;
};

export type FocTableDataConnection = {
  __typename?: 'FocTableDataConnection';
  edges: Array<FocTableDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FocTableDataEdge = {
  __typename?: 'FocTableDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FocTableData;
};

export type FocTableDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FocTableDataSort objects to sort FocTableData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FocTableDataSort>>;
};

/** Fields to sort FocTableData by. The order in which sorts are applied is not guaranteed when specifying many fields in one FocTableDataSort object. */
export type FocTableDataSort = {
  discount?: InputMaybe<SortDirection>;
  foc?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
};

export type FocTableDataWhere = {
  AND?: InputMaybe<Array<FocTableDataWhere>>;
  NOT?: InputMaybe<FocTableDataWhere>;
  OR?: InputMaybe<Array<FocTableDataWhere>>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discount_GT?: InputMaybe<Scalars['Float']['input']>;
  discount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  discount_LT?: InputMaybe<Scalars['Float']['input']>;
  discount_LTE?: InputMaybe<Scalars['Float']['input']>;
  foc?: InputMaybe<Scalars['Float']['input']>;
  foc_GT?: InputMaybe<Scalars['Float']['input']>;
  foc_GTE?: InputMaybe<Scalars['Float']['input']>;
  foc_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  foc_LT?: InputMaybe<Scalars['Float']['input']>;
  foc_LTE?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type FormsTableSourceFilterData = {
  __typename?: 'FormsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedByNames: Array<Scalars['String']['output']>;
  brandNames: Array<Scalars['String']['output']>;
  externalFormIds: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
  maxAddedOn?: Maybe<Scalars['DateTime']['output']>;
  minAddedOn?: Maybe<Scalars['DateTime']['output']>;
  occurrences: Array<Scalars['String']['output']>;
  patientIds: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  therapyDecisions: Array<CoverageRequestTherapyDecision>;
  types: Array<Scalars['String']['output']>;
};

export type FormsTableSourceFilterDataAggregateSelection = {
  __typename?: 'FormsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  maxAddedOn: DateTimeAggregateSelectionNullable;
  minAddedOn: DateTimeAggregateSelectionNullable;
};

export type FormsTableSourceFilterDataConnection = {
  __typename?: 'FormsTableSourceFilterDataConnection';
  edges: Array<FormsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FormsTableSourceFilterDataEdge = {
  __typename?: 'FormsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FormsTableSourceFilterData;
};

export type FormsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more FormsTableSourceFilterDataSort objects to sort FormsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<FormsTableSourceFilterDataSort>>;
};

/** Fields to sort FormsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one FormsTableSourceFilterDataSort object. */
export type FormsTableSourceFilterDataSort = {
  maxAddedOn?: InputMaybe<SortDirection>;
  minAddedOn?: InputMaybe<SortDirection>;
};

export type FormsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<FormsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<FormsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<FormsTableSourceFilterDataWhere>>;
  addedByNames?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  externalFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  externalFormIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxAddedOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxAddedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minAddedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  occurrences?: InputMaybe<Array<Scalars['String']['input']>>;
  occurrences_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  therapyDecisions?: InputMaybe<Array<CoverageRequestTherapyDecision>>;
  therapyDecisions_INCLUDES?: InputMaybe<CoverageRequestTherapyDecision>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  types_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type GqlBaseResponse = {
  message?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<GqlResponseStatus>;
};

export enum GqlResponseStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type Generic = {
  __typename?: 'Generic';
  Name: Scalars['String']['output'];
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCount: Scalars['Int']['output'];
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<GenericUserCreatedByAggregationSelection>;
  createdByConnection: GenericCreatedByConnection;
  creationWay: MasterDataCreationWay;
  id: Scalars['ID']['output'];
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<GenericPreparationPreparationsAggregationSelection>;
  preparationsConnection: GenericPreparationsConnection;
  treatmentSets: Array<TreatmentSet>;
  treatmentSetsAggregate?: Maybe<GenericTreatmentSetTreatmentSetsAggregationSelection>;
  treatmentSetsConnection: GenericTreatmentSetsConnection;
  usedInRecordOrForms: Scalars['Boolean']['output'];
};


export type GenericCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type GenericCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type GenericCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GenericCreatedByConnectionSort>>;
  where?: InputMaybe<GenericCreatedByConnectionWhere>;
};


export type GenericPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type GenericPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type GenericPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GenericPreparationsConnectionSort>>;
  where?: InputMaybe<GenericPreparationsConnectionWhere>;
};


export type GenericTreatmentSetsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type GenericTreatmentSetsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type GenericTreatmentSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GenericTreatmentSetsConnectionSort>>;
  where?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
};

export type GenericAggregateSelection = {
  __typename?: 'GenericAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type GenericCreatedByAggregateInput = {
  AND?: InputMaybe<Array<GenericCreatedByAggregateInput>>;
  NOT?: InputMaybe<GenericCreatedByAggregateInput>;
  OR?: InputMaybe<Array<GenericCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GenericCreatedByNodeAggregationWhereInput>;
};

export type GenericCreatedByConnection = {
  __typename?: 'GenericCreatedByConnection';
  edges: Array<GenericCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type GenericCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<GenericCreatedByConnectionWhere>>;
  NOT?: InputMaybe<GenericCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<GenericCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type GenericCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GenericCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GenericCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GenericCreatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericCreatedByRelationship = {
  __typename?: 'GenericCreatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type GenericEdge = {
  __typename?: 'GenericEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type GenericOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GenericSort objects to sort Generics by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GenericSort>>;
};

export type GenericPreparationPreparationsAggregationSelection = {
  __typename?: 'GenericPreparationPreparationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<GenericPreparationPreparationsNodeAggregateSelection>;
};

export type GenericPreparationPreparationsNodeAggregateSelection = {
  __typename?: 'GenericPreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type GenericPreparationsAggregateInput = {
  AND?: InputMaybe<Array<GenericPreparationsAggregateInput>>;
  NOT?: InputMaybe<GenericPreparationsAggregateInput>;
  OR?: InputMaybe<Array<GenericPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GenericPreparationsNodeAggregationWhereInput>;
};

export type GenericPreparationsConnection = {
  __typename?: 'GenericPreparationsConnection';
  edges: Array<GenericPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type GenericPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<GenericPreparationsConnectionWhere>>;
  NOT?: InputMaybe<GenericPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<GenericPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type GenericPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GenericPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<GenericPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GenericPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericPreparationsRelationship = {
  __typename?: 'GenericPreparationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

/** Fields to sort Generics by. The order in which sorts are applied is not guaranteed when specifying many fields in one GenericSort object. */
export type GenericSort = {
  Name?: InputMaybe<SortDirection>;
  agreementCount?: InputMaybe<SortDirection>;
  creationWay?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  usedInRecordOrForms?: InputMaybe<SortDirection>;
};

export type GenericTreatmentSetTreatmentSetsAggregationSelection = {
  __typename?: 'GenericTreatmentSetTreatmentSetsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<GenericTreatmentSetTreatmentSetsNodeAggregateSelection>;
};

export type GenericTreatmentSetTreatmentSetsNodeAggregateSelection = {
  __typename?: 'GenericTreatmentSetTreatmentSetsNodeAggregateSelection';
  order: IntAggregateSelectionNonNullable;
};

export type GenericTreatmentSetsAggregateInput = {
  AND?: InputMaybe<Array<GenericTreatmentSetsAggregateInput>>;
  NOT?: InputMaybe<GenericTreatmentSetsAggregateInput>;
  OR?: InputMaybe<Array<GenericTreatmentSetsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GenericTreatmentSetsNodeAggregationWhereInput>;
};

export type GenericTreatmentSetsConnection = {
  __typename?: 'GenericTreatmentSetsConnection';
  edges: Array<GenericTreatmentSetsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GenericTreatmentSetsConnectionSort = {
  node?: InputMaybe<TreatmentSetSort>;
};

export type GenericTreatmentSetsConnectionWhere = {
  AND?: InputMaybe<Array<GenericTreatmentSetsConnectionWhere>>;
  NOT?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  OR?: InputMaybe<Array<GenericTreatmentSetsConnectionWhere>>;
  node?: InputMaybe<TreatmentSetWhere>;
};

export type GenericTreatmentSetsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GenericTreatmentSetsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GenericTreatmentSetsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GenericTreatmentSetsNodeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericTreatmentSetsRelationship = {
  __typename?: 'GenericTreatmentSetsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type GenericUserCreatedByAggregationSelection = {
  __typename?: 'GenericUserCreatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<GenericUserCreatedByNodeAggregateSelection>;
};

export type GenericUserCreatedByNodeAggregateSelection = {
  __typename?: 'GenericUserCreatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type GenericWhere = {
  AND?: InputMaybe<Array<GenericWhere>>;
  NOT?: InputMaybe<GenericWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<GenericWhere>>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<GenericCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<GenericCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<GenericCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  creationWay?: InputMaybe<MasterDataCreationWay>;
  creationWay_IN?: InputMaybe<Array<MasterDataCreationWay>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  preparationsAggregate?: InputMaybe<GenericPreparationsAggregateInput>;
  /** Return Generics where all of the related GenericPreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where none of the related GenericPreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where one of the related GenericPreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where some of the related GenericPreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<GenericPreparationsConnectionWhere>;
  /** Return Generics where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Generics where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Generics where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Generics where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
  treatmentSetsAggregate?: InputMaybe<GenericTreatmentSetsAggregateInput>;
  /** Return Generics where all of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_ALL?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where none of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_NONE?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where one of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SINGLE?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where some of the related GenericTreatmentSetsConnections match this filter */
  treatmentSetsConnection_SOME?: InputMaybe<GenericTreatmentSetsConnectionWhere>;
  /** Return Generics where all of the related TreatmentSets match this filter */
  treatmentSets_ALL?: InputMaybe<TreatmentSetWhere>;
  /** Return Generics where none of the related TreatmentSets match this filter */
  treatmentSets_NONE?: InputMaybe<TreatmentSetWhere>;
  /** Return Generics where one of the related TreatmentSets match this filter */
  treatmentSets_SINGLE?: InputMaybe<TreatmentSetWhere>;
  /** Return Generics where some of the related TreatmentSets match this filter */
  treatmentSets_SOME?: InputMaybe<TreatmentSetWhere>;
};

export type GenericsConnection = {
  __typename?: 'GenericsConnection';
  edges: Array<GenericEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GetSmartMipInvoicesAvailableInput = {
  documentId: Scalars['ID']['input'];
};

export type GetUserCreatedSimulationsCountArgsDto = {
  domainIds: Array<Scalars['String']['input']>;
  userEmail: Scalars['String']['input'];
};

export type GlobalLock = {
  __typename?: 'GlobalLock';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorAggregate?: Maybe<GlobalLockUserCreatorAggregationSelection>;
  creatorConnection: GlobalLockCreatorConnection;
  heldBy: Scalars['DateTime']['output'];
  lockType: LockType;
  resourceId?: Maybe<Scalars['String']['output']>;
};


export type GlobalLockCreatorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type GlobalLockCreatorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type GlobalLockCreatorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<GlobalLockCreatorConnectionSort>>;
  where?: InputMaybe<GlobalLockCreatorConnectionWhere>;
};

export type GlobalLockAggregateSelection = {
  __typename?: 'GlobalLockAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  heldBy: DateTimeAggregateSelectionNonNullable;
  resourceId: StringAggregateSelectionNullable;
};

export type GlobalLockCreatorAggregateInput = {
  AND?: InputMaybe<Array<GlobalLockCreatorAggregateInput>>;
  NOT?: InputMaybe<GlobalLockCreatorAggregateInput>;
  OR?: InputMaybe<Array<GlobalLockCreatorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<GlobalLockCreatorNodeAggregationWhereInput>;
};

export type GlobalLockCreatorConnection = {
  __typename?: 'GlobalLockCreatorConnection';
  edges: Array<GlobalLockCreatorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GlobalLockCreatorConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type GlobalLockCreatorConnectionWhere = {
  AND?: InputMaybe<Array<GlobalLockCreatorConnectionWhere>>;
  NOT?: InputMaybe<GlobalLockCreatorConnectionWhere>;
  OR?: InputMaybe<Array<GlobalLockCreatorConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type GlobalLockCreatorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<GlobalLockCreatorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<GlobalLockCreatorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<GlobalLockCreatorNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalLockCreatorRelationship = {
  __typename?: 'GlobalLockCreatorRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type GlobalLockEdge = {
  __typename?: 'GlobalLockEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: GlobalLock;
};

export type GlobalLockOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more GlobalLockSort objects to sort GlobalLocks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<GlobalLockSort>>;
};

/** Fields to sort GlobalLocks by. The order in which sorts are applied is not guaranteed when specifying many fields in one GlobalLockSort object. */
export type GlobalLockSort = {
  createdOn?: InputMaybe<SortDirection>;
  heldBy?: InputMaybe<SortDirection>;
  lockType?: InputMaybe<SortDirection>;
  resourceId?: InputMaybe<SortDirection>;
};

export type GlobalLockUserCreatorAggregationSelection = {
  __typename?: 'GlobalLockUserCreatorAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<GlobalLockUserCreatorNodeAggregateSelection>;
};

export type GlobalLockUserCreatorNodeAggregateSelection = {
  __typename?: 'GlobalLockUserCreatorNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type GlobalLockWhere = {
  AND?: InputMaybe<Array<GlobalLockWhere>>;
  NOT?: InputMaybe<GlobalLockWhere>;
  OR?: InputMaybe<Array<GlobalLockWhere>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creator?: InputMaybe<UserWhere>;
  creatorAggregate?: InputMaybe<GlobalLockCreatorAggregateInput>;
  creatorConnection?: InputMaybe<GlobalLockCreatorConnectionWhere>;
  creatorConnection_NOT?: InputMaybe<GlobalLockCreatorConnectionWhere>;
  creator_NOT?: InputMaybe<UserWhere>;
  heldBy?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_GT?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  heldBy_LT?: InputMaybe<Scalars['DateTime']['input']>;
  heldBy_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockType?: InputMaybe<LockType>;
  lockType_IN?: InputMaybe<Array<LockType>>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  resourceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  resourceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  resourceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalLocksConnection = {
  __typename?: 'GlobalLocksConnection';
  edges: Array<GlobalLockEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IdAggregateSelectionNonNullable = {
  __typename?: 'IDAggregateSelectionNonNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  longest: Scalars['ID']['output'];
  shortest: Scalars['ID']['output'];
};

export type IdAggregateSelectionNullable = {
  __typename?: 'IDAggregateSelectionNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  longest?: Maybe<Scalars['ID']['output']>;
  shortest?: Maybe<Scalars['ID']['output']>;
};

export enum IrAdverseEventDoseModifications {
  NoModification = 'NO_MODIFICATION',
  PermanentlyDiscontinue = 'PERMANENTLY_DISCONTINUE',
  ReduceDose = 'REDUCE_DOSE',
  WithholdDose = 'WITHHOLD_DOSE'
}

export enum IrAdverseEventGrades {
  I = 'I',
  Ii = 'II',
  Iii = 'III',
  Iv = 'IV',
  NoInfo = 'NO_INFO'
}

export enum IrAdverseEvents {
  AcuteHepatitis = 'ACUTE_HEPATITIS',
  AltIncreased = 'ALT_INCREASED',
  AstIncreased = 'AST_INCREASED',
  Colitis = 'COLITIS',
  Diarrhoea = 'DIARRHOEA',
  Hypopituitarism = 'HYPOPITUITARISM',
  InterstitialLungDisease = 'INTERSTITIAL_LUNG_DISEASE',
  Pneumonitis = 'PNEUMONITIS',
  Pyrexia = 'PYREXIA'
}

export enum IrResultOptions {
  CompleteResponse = 'COMPLETE_RESPONSE',
  PartialResponse = 'PARTIAL_RESPONSE',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  StableDisease = 'STABLE_DISEASE'
}

export type ITableRowView = {
  formattedContent?: Maybe<Scalars['String']['output']>;
  formattedExposedToUserIds?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  users: Array<User>;
};

export type ITableRowViewUsersConnection = {
  __typename?: 'ITableRowViewUsersConnection';
  edges: Array<ITableRowViewUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ITableRowViewUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ITableRowViewUsersConnectionWhere = {
  AND?: InputMaybe<Array<ITableRowViewUsersConnectionWhere>>;
  NOT?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  OR?: InputMaybe<Array<ITableRowViewUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ITableRowViewUsersRelationship = {
  __typename?: 'ITableRowViewUsersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type ITimeframe = {
  rollingRangeType?: Maybe<RollingRangeType>;
  startingPoint?: Maybe<TimeframeStartingPoint>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeRelation?: Maybe<TimeframeRelation>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
};

export type ITreatmentCondition = {
  brands?: Maybe<Array<Brand>>;
  generics?: Maybe<Array<Generic>>;
  treatments?: Maybe<Array<Treatment>>;
};

export type Image = {
  __typename?: 'Image';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ImageAggregateSelection = {
  __typename?: 'ImageAggregateSelection';
  count: Scalars['Int']['output'];
  url: StringAggregateSelectionNullable;
};

export type ImageEdge = {
  __typename?: 'ImageEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Image;
};

export type ImageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ImageSort objects to sort Images by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ImageSort>>;
};

/** Fields to sort Images by. The order in which sorts are applied is not guaranteed when specifying many fields in one ImageSort object. */
export type ImageSort = {
  url?: InputMaybe<SortDirection>;
};

export type ImageWhere = {
  AND?: InputMaybe<Array<ImageWhere>>;
  NOT?: InputMaybe<ImageWhere>;
  OR?: InputMaybe<Array<ImageWhere>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_MATCHES?: InputMaybe<Scalars['String']['input']>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ImagesConnection = {
  __typename?: 'ImagesConnection';
  edges: Array<ImageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImpossibleToEditAttribute = {
  __typename?: 'ImpossibleToEditAttribute';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  identifier: Scalars['String']['output'];
  row?: Maybe<Scalars['Int']['output']>;
};

export type ImpossibleToEditAttributeAggregateSelection = {
  __typename?: 'ImpossibleToEditAttributeAggregateSelection';
  count: Scalars['Int']['output'];
  identifier: StringAggregateSelectionNonNullable;
  row: IntAggregateSelectionNullable;
};

export type ImpossibleToEditAttributeEdge = {
  __typename?: 'ImpossibleToEditAttributeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ImpossibleToEditAttribute;
};

export type ImpossibleToEditAttributeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ImpossibleToEditAttributeSort objects to sort ImpossibleToEditAttributes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ImpossibleToEditAttributeSort>>;
};

/** Fields to sort ImpossibleToEditAttributes by. The order in which sorts are applied is not guaranteed when specifying many fields in one ImpossibleToEditAttributeSort object. */
export type ImpossibleToEditAttributeSort = {
  identifier?: InputMaybe<SortDirection>;
  row?: InputMaybe<SortDirection>;
};

export type ImpossibleToEditAttributeWhere = {
  AND?: InputMaybe<Array<ImpossibleToEditAttributeWhere>>;
  NOT?: InputMaybe<ImpossibleToEditAttributeWhere>;
  OR?: InputMaybe<Array<ImpossibleToEditAttributeWhere>>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  identifier_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  identifier_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  identifier_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  identifier_MATCHES?: InputMaybe<Scalars['String']['input']>;
  identifier_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  row?: InputMaybe<Scalars['Int']['input']>;
  row_GT?: InputMaybe<Scalars['Int']['input']>;
  row_GTE?: InputMaybe<Scalars['Int']['input']>;
  row_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  row_LT?: InputMaybe<Scalars['Int']['input']>;
  row_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ImpossibleToEditAttributesConnection = {
  __typename?: 'ImpossibleToEditAttributesConnection';
  edges: Array<ImpossibleToEditAttributeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InboxQuest = {
  __typename?: 'InboxQuest';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  caseInfo?: Maybe<CaseInfo>;
  completionStatus: QuestCompletionStatus;
  id: Scalars['ID']['output'];
  isAutoCompleted: Scalars['Boolean']['output'];
  owner?: Maybe<BaseUserInfo>;
  questContentDe?: Maybe<Scalars['String']['output']>;
  questContentEn?: Maybe<Scalars['String']['output']>;
  questStatus: TaskStatus;
  resolvedBy?: Maybe<BaseUserInfo>;
  threshold?: Maybe<Scalars['Int']['output']>;
  timeStamp: Scalars['Float']['output'];
  triggerEventId: Scalars['Int']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type InboxQuestAggregateSelection = {
  __typename?: 'InboxQuestAggregateSelection';
  brandName: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  questContentDe: StringAggregateSelectionNullable;
  questContentEn: StringAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
  timeStamp: FloatAggregateSelectionNonNullable;
  triggerEventId: IntAggregateSelectionNonNullable;
  value: FloatAggregateSelectionNullable;
};

export type InboxQuestEdge = {
  __typename?: 'InboxQuestEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: InboxQuest;
};

export type InboxQuestOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more InboxQuestSort objects to sort InboxQuests by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InboxQuestSort>>;
};

/** Fields to sort InboxQuests by. The order in which sorts are applied is not guaranteed when specifying many fields in one InboxQuestSort object. */
export type InboxQuestSort = {
  brandName?: InputMaybe<SortDirection>;
  completionStatus?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAutoCompleted?: InputMaybe<SortDirection>;
  questContentDe?: InputMaybe<SortDirection>;
  questContentEn?: InputMaybe<SortDirection>;
  questStatus?: InputMaybe<SortDirection>;
  threshold?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
  triggerEventId?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type InboxQuestWhere = {
  AND?: InputMaybe<Array<InboxQuestWhere>>;
  NOT?: InputMaybe<InboxQuestWhere>;
  OR?: InputMaybe<Array<InboxQuestWhere>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  brandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  completionStatus?: InputMaybe<QuestCompletionStatus>;
  completionStatus_IN?: InputMaybe<Array<QuestCompletionStatus>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAutoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  questContentDe?: InputMaybe<Scalars['String']['input']>;
  questContentDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  questContentDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  questContentDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questContentDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  questContentDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questContentEn?: InputMaybe<Scalars['String']['input']>;
  questContentEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  questContentEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  questContentEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questContentEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  questContentEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questStatus?: InputMaybe<TaskStatus>;
  questStatus_IN?: InputMaybe<Array<TaskStatus>>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  threshold_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  threshold_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeStamp?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeStamp_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  triggerEventId_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_LTE?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type InboxQuestsConnection = {
  __typename?: 'InboxQuestsConnection';
  edges: Array<InboxQuestEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum InclusionType {
  Included = 'INCLUDED',
  NotIncluded = 'NOT_INCLUDED'
}

export type Indication = {
  __typename?: 'Indication';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  intentLocalizationKey?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  line?: Maybe<Scalars['String']['output']>;
  lineLocalizationKey?: Maybe<Scalars['String']['output']>;
  modelCount: Scalars['Int']['output'];
  mutation?: Maybe<Scalars['String']['output']>;
  mutationLocalizationKey?: Maybe<Scalars['String']['output']>;
  organizations: Array<Organization>;
  type?: Maybe<Scalars['String']['output']>;
  typeLocalizationKey?: Maybe<Scalars['String']['output']>;
};

export type IndicationAggregateSelection = {
  __typename?: 'IndicationAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  intent: StringAggregateSelectionNullable;
  intentLocalizationKey: StringAggregateSelectionNullable;
  line: StringAggregateSelectionNullable;
  lineLocalizationKey: StringAggregateSelectionNullable;
  mutation: StringAggregateSelectionNullable;
  mutationLocalizationKey: StringAggregateSelectionNullable;
  type: StringAggregateSelectionNullable;
  typeLocalizationKey: StringAggregateSelectionNullable;
};

export type IndicationEdge = {
  __typename?: 'IndicationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Indication;
};

export type IndicationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more IndicationSort objects to sort Indications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<IndicationSort>>;
};

/** Fields to sort Indications by. The order in which sorts are applied is not guaranteed when specifying many fields in one IndicationSort object. */
export type IndicationSort = {
  agreementCount?: InputMaybe<SortDirection>;
  code?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  intent?: InputMaybe<SortDirection>;
  intentLocalizationKey?: InputMaybe<SortDirection>;
  isCustom?: InputMaybe<SortDirection>;
  line?: InputMaybe<SortDirection>;
  lineLocalizationKey?: InputMaybe<SortDirection>;
  modelCount?: InputMaybe<SortDirection>;
  mutation?: InputMaybe<SortDirection>;
  mutationLocalizationKey?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  typeLocalizationKey?: InputMaybe<SortDirection>;
};

export type IndicationWhere = {
  AND?: InputMaybe<Array<IndicationWhere>>;
  NOT?: InputMaybe<IndicationWhere>;
  OR?: InputMaybe<Array<IndicationWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  intent?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intentLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  intentLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  intent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  intent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  intent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  intent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  line?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lineLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lineLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  line_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  line_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  line_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  line_MATCHES?: InputMaybe<Scalars['String']['input']>;
  line_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutation?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutationLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  mutationLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mutation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mutation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mutation_MATCHES?: InputMaybe<Scalars['String']['input']>;
  mutation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  typeLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type IndicationsConnection = {
  __typename?: 'IndicationsConnection';
  edges: Array<IndicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InitialResponseReviewReport = {
  __typename?: 'InitialResponseReviewReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<UnitedResponseType>;
};

export type InitialResponseReviewReportAggregateSelection = {
  __typename?: 'InitialResponseReviewReportAggregateSelection';
  count: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNullable;
  rate: FloatAggregateSelectionNullable;
};

export type InitialResponseReviewReportEdge = {
  __typename?: 'InitialResponseReviewReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: InitialResponseReviewReport;
};

export type InitialResponseReviewReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more InitialResponseReviewReportSort objects to sort InitialResponseReviewReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InitialResponseReviewReportSort>>;
};

/** Fields to sort InitialResponseReviewReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one InitialResponseReviewReportSort object. */
export type InitialResponseReviewReportSort = {
  count?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  rate?: InputMaybe<SortDirection>;
  result?: InputMaybe<SortDirection>;
};

export type InitialResponseReviewReportWhere = {
  AND?: InputMaybe<Array<InitialResponseReviewReportWhere>>;
  NOT?: InputMaybe<InitialResponseReviewReportWhere>;
  OR?: InputMaybe<Array<InitialResponseReviewReportWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rate_GT?: InputMaybe<Scalars['Float']['input']>;
  rate_GTE?: InputMaybe<Scalars['Float']['input']>;
  rate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  rate_LT?: InputMaybe<Scalars['Float']['input']>;
  rate_LTE?: InputMaybe<Scalars['Float']['input']>;
  result?: InputMaybe<UnitedResponseType>;
  result_IN?: InputMaybe<Array<InputMaybe<UnitedResponseType>>>;
};

export type InitialResponseReviewReportsConnection = {
  __typename?: 'InitialResponseReviewReportsConnection';
  edges: Array<InitialResponseReviewReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IntAggregateSelectionNonNullable = {
  __typename?: 'IntAggregateSelectionNonNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  average: Scalars['Float']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  sum: Scalars['Int']['output'];
};

export type IntAggregateSelectionNullable = {
  __typename?: 'IntAggregateSelectionNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  sum?: Maybe<Scalars['Int']['output']>;
};

export enum InterventionOccurrence {
  FirstSurgeryDate = 'FIRST_SURGERY_DATE'
}

export type InterventionReportStatusResponse = GqlBaseResponse & {
  __typename?: 'InterventionReportStatusResponse';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<GqlResponseStatus>;
};

export type InterventionReportStatusResponseAggregateSelection = {
  __typename?: 'InterventionReportStatusResponseAggregateSelection';
  count: Scalars['Int']['output'];
  message: StringAggregateSelectionNullable;
};

export type InterventionReportStatusResponseEdge = {
  __typename?: 'InterventionReportStatusResponseEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: InterventionReportStatusResponse;
};

export type InterventionReportStatusResponseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more InterventionReportStatusResponseSort objects to sort InterventionReportStatusResponses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InterventionReportStatusResponseSort>>;
};

/** Fields to sort InterventionReportStatusResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one InterventionReportStatusResponseSort object. */
export type InterventionReportStatusResponseSort = {
  message?: InputMaybe<SortDirection>;
  responseStatus?: InputMaybe<SortDirection>;
};

export type InterventionReportStatusResponseWhere = {
  AND?: InputMaybe<Array<InterventionReportStatusResponseWhere>>;
  NOT?: InputMaybe<InterventionReportStatusResponseWhere>;
  OR?: InputMaybe<Array<InterventionReportStatusResponseWhere>>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  message_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  message_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_MATCHES?: InputMaybe<Scalars['String']['input']>;
  message_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  responseStatus?: InputMaybe<GqlResponseStatus>;
  responseStatus_IN?: InputMaybe<Array<InputMaybe<GqlResponseStatus>>>;
};

export type InterventionReportStatusResponsesConnection = {
  __typename?: 'InterventionReportStatusResponsesConnection';
  edges: Array<InterventionReportStatusResponseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InterventionReportStatusUpdateInput = {
  formId: Scalars['String']['input'];
  reportStatus: RefundStatus;
};

export enum InterventionType {
  RelatedToPaf = 'RELATED_TO_PAF'
}

export enum InvoiceApprovalRole {
  Approver = 'APPROVER',
  Confirmor = 'CONFIRMOR'
}

export type IsFlexEntityDeletable = {
  __typename?: 'IsFlexEntityDeletable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  deletable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type IsFlexEntityDeletableAggregateSelection = {
  __typename?: 'IsFlexEntityDeletableAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type IsFlexEntityDeletableEdge = {
  __typename?: 'IsFlexEntityDeletableEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: IsFlexEntityDeletable;
};

export type IsFlexEntityDeletableOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more IsFlexEntityDeletableSort objects to sort IsFlexEntityDeletables by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<IsFlexEntityDeletableSort>>;
};

/** Fields to sort IsFlexEntityDeletables by. The order in which sorts are applied is not guaranteed when specifying many fields in one IsFlexEntityDeletableSort object. */
export type IsFlexEntityDeletableSort = {
  deletable?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type IsFlexEntityDeletableWhere = {
  AND?: InputMaybe<Array<IsFlexEntityDeletableWhere>>;
  NOT?: InputMaybe<IsFlexEntityDeletableWhere>;
  OR?: InputMaybe<Array<IsFlexEntityDeletableWhere>>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type IsFlexEntityDeletablesConnection = {
  __typename?: 'IsFlexEntityDeletablesConnection';
  edges: Array<IsFlexEntityDeletableEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IssueInvoiceWithoutReviewInput = {
  adjustedInvoiceAmount: Scalars['Float']['input'];
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coveragePeriod?: InputMaybe<Scalars['String']['input']>;
  deletedRefunds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentType: DocumentType;
  financialDataPoints: Array<FinancialDataPointInput>;
  invoiceAmount: Scalars['Float']['input'];
  invoiceId: Scalars['ID']['input'];
  invoiceStatus: DocumentStatus;
  isAdjusted: Scalars['Boolean']['input'];
  operation?: InputMaybe<Scalars['String']['input']>;
};

export enum ItemScope {
  All = 'ALL',
  Last = 'LAST',
  Repetingitems = 'REPETINGITEMS',
  Specific = 'SPECIFIC'
}

export type ItemUsedDataPoint = {
  __typename?: 'ItemUsedDataPoint';
  PICount: Scalars['Int']['output'];
  SICount: Scalars['Int']['output'];
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  item: Scalars['String']['output'];
  patientPopulation: ReportItemsUsedFilter;
};

export type ItemUsedDataPointAggregateSelection = {
  __typename?: 'ItemUsedDataPointAggregateSelection';
  PICount: IntAggregateSelectionNonNullable;
  SICount: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  item: StringAggregateSelectionNonNullable;
};

export type ItemUsedDataPointEdge = {
  __typename?: 'ItemUsedDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ItemUsedDataPoint;
};

export type ItemUsedDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ItemUsedDataPointSort objects to sort ItemUsedDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ItemUsedDataPointSort>>;
};

/** Fields to sort ItemUsedDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one ItemUsedDataPointSort object. */
export type ItemUsedDataPointSort = {
  PICount?: InputMaybe<SortDirection>;
  SICount?: InputMaybe<SortDirection>;
  item?: InputMaybe<SortDirection>;
  patientPopulation?: InputMaybe<SortDirection>;
};

export type ItemUsedDataPointWhere = {
  AND?: InputMaybe<Array<ItemUsedDataPointWhere>>;
  NOT?: InputMaybe<ItemUsedDataPointWhere>;
  OR?: InputMaybe<Array<ItemUsedDataPointWhere>>;
  PICount?: InputMaybe<Scalars['Int']['input']>;
  PICount_GT?: InputMaybe<Scalars['Int']['input']>;
  PICount_GTE?: InputMaybe<Scalars['Int']['input']>;
  PICount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  PICount_LT?: InputMaybe<Scalars['Int']['input']>;
  PICount_LTE?: InputMaybe<Scalars['Int']['input']>;
  SICount?: InputMaybe<Scalars['Int']['input']>;
  SICount_GT?: InputMaybe<Scalars['Int']['input']>;
  SICount_GTE?: InputMaybe<Scalars['Int']['input']>;
  SICount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  SICount_LT?: InputMaybe<Scalars['Int']['input']>;
  SICount_LTE?: InputMaybe<Scalars['Int']['input']>;
  item?: InputMaybe<Scalars['String']['input']>;
  item_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  item_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  item_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  item_MATCHES?: InputMaybe<Scalars['String']['input']>;
  item_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientPopulation?: InputMaybe<ReportItemsUsedFilter>;
  patientPopulation_IN?: InputMaybe<Array<ReportItemsUsedFilter>>;
};

export type ItemUsedDataPointsConnection = {
  __typename?: 'ItemUsedDataPointsConnection';
  edges: Array<ItemUsedDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LdLReportingDataPoint = {
  __typename?: 'LdLReportingDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  discountAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  upperLimit?: Maybe<Scalars['Float']['output']>;
};

export type LdLReportingDataPointAggregateSelection = {
  __typename?: 'LdLReportingDataPointAggregateSelection';
  count: IntAggregateSelectionNonNullable;
  discountAmount: FloatAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  upperLimit: FloatAggregateSelectionNullable;
};

export type LdLReportingDataPointEdge = {
  __typename?: 'LdLReportingDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: LdLReportingDataPoint;
};

export type LdLReportingDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LdLReportingDataPointSort objects to sort LdLReportingDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LdLReportingDataPointSort>>;
};

/** Fields to sort LdLReportingDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one LdLReportingDataPointSort object. */
export type LdLReportingDataPointSort = {
  count?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  upperLimit?: InputMaybe<SortDirection>;
};

export type LdLReportingDataPointWhere = {
  AND?: InputMaybe<Array<LdLReportingDataPointWhere>>;
  NOT?: InputMaybe<LdLReportingDataPointWhere>;
  OR?: InputMaybe<Array<LdLReportingDataPointWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  upperLimit?: InputMaybe<Scalars['Float']['input']>;
  upperLimit_GT?: InputMaybe<Scalars['Float']['input']>;
  upperLimit_GTE?: InputMaybe<Scalars['Float']['input']>;
  upperLimit_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  upperLimit_LT?: InputMaybe<Scalars['Float']['input']>;
  upperLimit_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type LdLReportingDataPointsConnection = {
  __typename?: 'LdLReportingDataPointsConnection';
  edges: Array<LdLReportingDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum LdlTestUom {
  MgPerDl = 'MG_PER_DL',
  MmolPerL = 'MMOL_PER_L'
}

export type Limitation = {
  __typename?: 'Limitation';
  Code?: Maybe<Scalars['String']['output']>;
  DescriptionDe?: Maybe<Scalars['String']['output']>;
  DescriptionEn?: Maybe<Scalars['String']['output']>;
  HasPriceModel: Scalars['Boolean']['output'];
  Niveau?: Maybe<Scalars['String']['output']>;
  Type?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
  ValidThruDate?: Maybe<Scalars['Date']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  limitsPreparations: Array<Preparation>;
  limitsPreparationsAggregate?: Maybe<LimitationPreparationLimitsPreparationsAggregationSelection>;
  limitsPreparationsConnection: LimitationLimitsPreparationsConnection;
  limitsTreatment: Array<Treatment>;
  limitsTreatmentAggregate?: Maybe<LimitationTreatmentLimitsTreatmentAggregationSelection>;
  limitsTreatmentConnection: LimitationLimitsTreatmentConnection;
  uuid: Scalars['ID']['output'];
};


export type LimitationLimitsPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type LimitationLimitsPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type LimitationLimitsPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LimitationLimitsPreparationsConnectionSort>>;
  where?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
};


export type LimitationLimitsTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type LimitationLimitsTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type LimitationLimitsTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<LimitationLimitsTreatmentConnectionSort>>;
  where?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
};

export type LimitationAggregateSelection = {
  __typename?: 'LimitationAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  uuid: IdAggregateSelectionNonNullable;
};

export type LimitationEdge = {
  __typename?: 'LimitationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type LimitationLimitsPreparationsAggregateInput = {
  AND?: InputMaybe<Array<LimitationLimitsPreparationsAggregateInput>>;
  NOT?: InputMaybe<LimitationLimitsPreparationsAggregateInput>;
  OR?: InputMaybe<Array<LimitationLimitsPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LimitationLimitsPreparationsNodeAggregationWhereInput>;
};

export type LimitationLimitsPreparationsConnection = {
  __typename?: 'LimitationLimitsPreparationsConnection';
  edges: Array<LimitationLimitsPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LimitationLimitsPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type LimitationLimitsPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<LimitationLimitsPreparationsConnectionWhere>>;
  NOT?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<LimitationLimitsPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type LimitationLimitsPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LimitationLimitsPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<LimitationLimitsPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<LimitationLimitsPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitationLimitsPreparationsRelationship = {
  __typename?: 'LimitationLimitsPreparationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type LimitationLimitsTreatmentAggregateInput = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentAggregateInput>>;
  NOT?: InputMaybe<LimitationLimitsTreatmentAggregateInput>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<LimitationLimitsTreatmentNodeAggregationWhereInput>;
};

export type LimitationLimitsTreatmentConnection = {
  __typename?: 'LimitationLimitsTreatmentConnection';
  edges: Array<LimitationLimitsTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LimitationLimitsTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type LimitationLimitsTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentConnectionWhere>>;
  NOT?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type LimitationLimitsTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<LimitationLimitsTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<LimitationLimitsTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<LimitationLimitsTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type LimitationLimitsTreatmentRelationship = {
  __typename?: 'LimitationLimitsTreatmentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type LimitationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more LimitationSort objects to sort Limitations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<LimitationSort>>;
};

export type LimitationPreparationLimitsPreparationsAggregationSelection = {
  __typename?: 'LimitationPreparationLimitsPreparationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<LimitationPreparationLimitsPreparationsNodeAggregateSelection>;
};

export type LimitationPreparationLimitsPreparationsNodeAggregateSelection = {
  __typename?: 'LimitationPreparationLimitsPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

/** Fields to sort Limitations by. The order in which sorts are applied is not guaranteed when specifying many fields in one LimitationSort object. */
export type LimitationSort = {
  Code?: InputMaybe<SortDirection>;
  DescriptionDe?: InputMaybe<SortDirection>;
  DescriptionEn?: InputMaybe<SortDirection>;
  HasPriceModel?: InputMaybe<SortDirection>;
  Niveau?: InputMaybe<SortDirection>;
  Type?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
  ValidThruDate?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
};

export type LimitationTreatmentLimitsTreatmentAggregationSelection = {
  __typename?: 'LimitationTreatmentLimitsTreatmentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<LimitationTreatmentLimitsTreatmentNodeAggregateSelection>;
};

export type LimitationTreatmentLimitsTreatmentNodeAggregateSelection = {
  __typename?: 'LimitationTreatmentLimitsTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type LimitationWhere = {
  AND?: InputMaybe<Array<LimitationWhere>>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  HasPriceModel?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<LimitationWhere>;
  Niveau?: InputMaybe<Scalars['String']['input']>;
  Niveau_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Niveau_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Niveau_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Niveau_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Niveau_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<LimitationWhere>>;
  Type?: InputMaybe<Scalars['String']['input']>;
  Type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidThruDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  limitsPreparationsAggregate?: InputMaybe<LimitationLimitsPreparationsAggregateInput>;
  /** Return Limitations where all of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_ALL?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where none of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_NONE?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where one of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_SINGLE?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where some of the related LimitationLimitsPreparationsConnections match this filter */
  limitsPreparationsConnection_SOME?: InputMaybe<LimitationLimitsPreparationsConnectionWhere>;
  /** Return Limitations where all of the related Preparations match this filter */
  limitsPreparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return Limitations where none of the related Preparations match this filter */
  limitsPreparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return Limitations where one of the related Preparations match this filter */
  limitsPreparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return Limitations where some of the related Preparations match this filter */
  limitsPreparations_SOME?: InputMaybe<PreparationWhere>;
  limitsTreatmentAggregate?: InputMaybe<LimitationLimitsTreatmentAggregateInput>;
  /** Return Limitations where all of the related LimitationLimitsTreatmentConnections match this filter */
  limitsTreatmentConnection_ALL?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
  /** Return Limitations where none of the related LimitationLimitsTreatmentConnections match this filter */
  limitsTreatmentConnection_NONE?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
  /** Return Limitations where one of the related LimitationLimitsTreatmentConnections match this filter */
  limitsTreatmentConnection_SINGLE?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
  /** Return Limitations where some of the related LimitationLimitsTreatmentConnections match this filter */
  limitsTreatmentConnection_SOME?: InputMaybe<LimitationLimitsTreatmentConnectionWhere>;
  /** Return Limitations where all of the related Treatments match this filter */
  limitsTreatment_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where none of the related Treatments match this filter */
  limitsTreatment_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where one of the related Treatments match this filter */
  limitsTreatment_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Limitations where some of the related Treatments match this filter */
  limitsTreatment_SOME?: InputMaybe<TreatmentWhere>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  uuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type LimitationsConnection = {
  __typename?: 'LimitationsConnection';
  edges: Array<LimitationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum LockType {
  CoreCacheClean = 'CORE_CACHE_CLEAN',
  DocumentAutoReminder = 'DOCUMENT_AUTO_REMINDER',
  LibraryCacheClean = 'LIBRARY_CACHE_CLEAN',
  QuestAutoCompletion = 'QUEST_AUTO_COMPLETION',
  RunDataQualityChecks = 'RUN_DATA_QUALITY_CHECKS',
  SimulatorMigration = 'SIMULATOR_MIGRATION'
}

export type MainIndication = {
  __typename?: 'MainIndication';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  article71Indication: Article71Indication;
  article71IndicationAggregate?: Maybe<MainIndicationArticle71IndicationArticle71IndicationAggregationSelection>;
  article71IndicationConnection: MainIndicationArticle71IndicationConnection;
  brand: Brand;
  brandAggregate?: Maybe<MainIndicationBrandBrandAggregationSelection>;
  brandConnection: MainIndicationBrandConnection;
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  validFromDate?: Maybe<Scalars['Date']['output']>;
  validToDate?: Maybe<Scalars['Date']['output']>;
};


export type MainIndicationArticle71IndicationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type MainIndicationArticle71IndicationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type MainIndicationArticle71IndicationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MainIndicationArticle71IndicationConnectionSort>>;
  where?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
};


export type MainIndicationBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type MainIndicationBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type MainIndicationBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MainIndicationBrandConnectionSort>>;
  where?: InputMaybe<MainIndicationBrandConnectionWhere>;
};

export type MainIndicationAggregateSelection = {
  __typename?: 'MainIndicationAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
};

export type MainIndicationArticle71IndicationAggregateInput = {
  AND?: InputMaybe<Array<MainIndicationArticle71IndicationAggregateInput>>;
  NOT?: InputMaybe<MainIndicationArticle71IndicationAggregateInput>;
  OR?: InputMaybe<Array<MainIndicationArticle71IndicationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MainIndicationArticle71IndicationNodeAggregationWhereInput>;
};

export type MainIndicationArticle71IndicationArticle71IndicationAggregationSelection = {
  __typename?: 'MainIndicationArticle71IndicationArticle71IndicationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection>;
};

export type MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection = {
  __typename?: 'MainIndicationArticle71IndicationArticle71IndicationNodeAggregateSelection';
  countryScopeId: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  notes: StringAggregateSelectionNullable;
};

export type MainIndicationArticle71IndicationConnection = {
  __typename?: 'MainIndicationArticle71IndicationConnection';
  edges: Array<MainIndicationArticle71IndicationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MainIndicationArticle71IndicationConnectionSort = {
  node?: InputMaybe<Article71IndicationSort>;
};

export type MainIndicationArticle71IndicationConnectionWhere = {
  AND?: InputMaybe<Array<MainIndicationArticle71IndicationConnectionWhere>>;
  NOT?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
  OR?: InputMaybe<Array<MainIndicationArticle71IndicationConnectionWhere>>;
  node?: InputMaybe<Article71IndicationWhere>;
};

export type MainIndicationArticle71IndicationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MainIndicationArticle71IndicationNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MainIndicationArticle71IndicationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MainIndicationArticle71IndicationNodeAggregationWhereInput>>;
  countryScopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countryScopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countryScopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  notes_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  notes_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  notes_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MainIndicationArticle71IndicationRelationship = {
  __typename?: 'MainIndicationArticle71IndicationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Article71Indication;
};

export type MainIndicationBrandAggregateInput = {
  AND?: InputMaybe<Array<MainIndicationBrandAggregateInput>>;
  NOT?: InputMaybe<MainIndicationBrandAggregateInput>;
  OR?: InputMaybe<Array<MainIndicationBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MainIndicationBrandNodeAggregationWhereInput>;
};

export type MainIndicationBrandBrandAggregationSelection = {
  __typename?: 'MainIndicationBrandBrandAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<MainIndicationBrandBrandNodeAggregateSelection>;
};

export type MainIndicationBrandBrandNodeAggregateSelection = {
  __typename?: 'MainIndicationBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type MainIndicationBrandConnection = {
  __typename?: 'MainIndicationBrandConnection';
  edges: Array<MainIndicationBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MainIndicationBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type MainIndicationBrandConnectionWhere = {
  AND?: InputMaybe<Array<MainIndicationBrandConnectionWhere>>;
  NOT?: InputMaybe<MainIndicationBrandConnectionWhere>;
  OR?: InputMaybe<Array<MainIndicationBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type MainIndicationBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MainIndicationBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MainIndicationBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<MainIndicationBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MainIndicationBrandRelationship = {
  __typename?: 'MainIndicationBrandRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type MainIndicationEdge = {
  __typename?: 'MainIndicationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: MainIndication;
};

export type MainIndicationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MainIndicationSort objects to sort MainIndications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MainIndicationSort>>;
};

/** Fields to sort MainIndications by. The order in which sorts are applied is not guaranteed when specifying many fields in one MainIndicationSort object. */
export type MainIndicationSort = {
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  validFromDate?: InputMaybe<SortDirection>;
  validToDate?: InputMaybe<SortDirection>;
};

export type MainIndicationWhere = {
  AND?: InputMaybe<Array<MainIndicationWhere>>;
  NOT?: InputMaybe<MainIndicationWhere>;
  OR?: InputMaybe<Array<MainIndicationWhere>>;
  article71Indication?: InputMaybe<Article71IndicationWhere>;
  article71IndicationAggregate?: InputMaybe<MainIndicationArticle71IndicationAggregateInput>;
  article71IndicationConnection?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
  article71IndicationConnection_NOT?: InputMaybe<MainIndicationArticle71IndicationConnectionWhere>;
  article71Indication_NOT?: InputMaybe<Article71IndicationWhere>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<MainIndicationBrandAggregateInput>;
  brandConnection?: InputMaybe<MainIndicationBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<MainIndicationBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  validFromDate?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  validToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  validToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  validToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type MainIndicationsConnection = {
  __typename?: 'MainIndicationsConnection';
  edges: Array<MainIndicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MasterDataCreationWay {
  Imported = 'IMPORTED',
  ManualEntry = 'MANUAL_ENTRY'
}

export type Message = {
  __typename?: 'Message';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  case: Case;
  caseAggregate?: Maybe<MessageCaseCaseAggregationSelection>;
  caseConnection: MessageCaseConnection;
  content?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['Float']['output']>;
  mentions: Array<User>;
  mentionsAggregate?: Maybe<MessageUserMentionsAggregationSelection>;
  mentionsConnection: MessageMentionsConnection;
  sentBy: User;
  sentByAggregate?: Maybe<MessageUserSentByAggregationSelection>;
  sentByConnection: MessageSentByConnection;
  tenantIds: Array<Scalars['String']['output']>;
};


export type MessageCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type MessageCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type MessageCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageCaseConnectionSort>>;
  where?: InputMaybe<MessageCaseConnectionWhere>;
};


export type MessageMentionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type MessageMentionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type MessageMentionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageMentionsConnectionSort>>;
  where?: InputMaybe<MessageMentionsConnectionWhere>;
};


export type MessageSentByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type MessageSentByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type MessageSentByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<MessageSentByConnectionSort>>;
  where?: InputMaybe<MessageSentByConnectionWhere>;
};

export type MessageAggregateSelection = {
  __typename?: 'MessageAggregateSelection';
  content: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  createdOn: FloatAggregateSelectionNullable;
};

export type MessageCaseAggregateInput = {
  AND?: InputMaybe<Array<MessageCaseAggregateInput>>;
  NOT?: InputMaybe<MessageCaseAggregateInput>;
  OR?: InputMaybe<Array<MessageCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageCaseNodeAggregationWhereInput>;
};

export type MessageCaseCaseAggregationSelection = {
  __typename?: 'MessageCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<MessageCaseCaseNodeAggregateSelection>;
};

export type MessageCaseCaseNodeAggregateSelection = {
  __typename?: 'MessageCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type MessageCaseConnection = {
  __typename?: 'MessageCaseConnection';
  edges: Array<MessageCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type MessageCaseConnectionWhere = {
  AND?: InputMaybe<Array<MessageCaseConnectionWhere>>;
  NOT?: InputMaybe<MessageCaseConnectionWhere>;
  OR?: InputMaybe<Array<MessageCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type MessageCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type MessageCaseRelationship = {
  __typename?: 'MessageCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Message;
};

export type MessageMentionsAggregateInput = {
  AND?: InputMaybe<Array<MessageMentionsAggregateInput>>;
  NOT?: InputMaybe<MessageMentionsAggregateInput>;
  OR?: InputMaybe<Array<MessageMentionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageMentionsNodeAggregationWhereInput>;
};

export type MessageMentionsConnection = {
  __typename?: 'MessageMentionsConnection';
  edges: Array<MessageMentionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageMentionsConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type MessageMentionsConnectionWhere = {
  AND?: InputMaybe<Array<MessageMentionsConnectionWhere>>;
  NOT?: InputMaybe<MessageMentionsConnectionWhere>;
  OR?: InputMaybe<Array<MessageMentionsConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type MessageMentionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageMentionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageMentionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageMentionsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageMentionsRelationship = {
  __typename?: 'MessageMentionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type MessageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MessageSort objects to sort Messages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MessageSort>>;
};

export type MessageSentByAggregateInput = {
  AND?: InputMaybe<Array<MessageSentByAggregateInput>>;
  NOT?: InputMaybe<MessageSentByAggregateInput>;
  OR?: InputMaybe<Array<MessageSentByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<MessageSentByNodeAggregationWhereInput>;
};

export type MessageSentByConnection = {
  __typename?: 'MessageSentByConnection';
  edges: Array<MessageSentByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageSentByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type MessageSentByConnectionWhere = {
  AND?: InputMaybe<Array<MessageSentByConnectionWhere>>;
  NOT?: InputMaybe<MessageSentByConnectionWhere>;
  OR?: InputMaybe<Array<MessageSentByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type MessageSentByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<MessageSentByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<MessageSentByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<MessageSentByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageSentByRelationship = {
  __typename?: 'MessageSentByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

/** Fields to sort Messages by. The order in which sorts are applied is not guaranteed when specifying many fields in one MessageSort object. */
export type MessageSort = {
  content?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
};

export type MessageUserMentionsAggregationSelection = {
  __typename?: 'MessageUserMentionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<MessageUserMentionsNodeAggregateSelection>;
};

export type MessageUserMentionsNodeAggregateSelection = {
  __typename?: 'MessageUserMentionsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type MessageUserSentByAggregationSelection = {
  __typename?: 'MessageUserSentByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<MessageUserSentByNodeAggregateSelection>;
};

export type MessageUserSentByNodeAggregateSelection = {
  __typename?: 'MessageUserSentByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type MessageWhere = {
  AND?: InputMaybe<Array<MessageWhere>>;
  NOT?: InputMaybe<MessageWhere>;
  OR?: InputMaybe<Array<MessageWhere>>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<MessageCaseAggregateInput>;
  caseConnection?: InputMaybe<MessageCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<MessageCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  content?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  content_MATCHES?: InputMaybe<Scalars['String']['input']>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  mentionsAggregate?: InputMaybe<MessageMentionsAggregateInput>;
  /** Return Messages where all of the related MessageMentionsConnections match this filter */
  mentionsConnection_ALL?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where none of the related MessageMentionsConnections match this filter */
  mentionsConnection_NONE?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where one of the related MessageMentionsConnections match this filter */
  mentionsConnection_SINGLE?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where some of the related MessageMentionsConnections match this filter */
  mentionsConnection_SOME?: InputMaybe<MessageMentionsConnectionWhere>;
  /** Return Messages where all of the related Users match this filter */
  mentions_ALL?: InputMaybe<UserWhere>;
  /** Return Messages where none of the related Users match this filter */
  mentions_NONE?: InputMaybe<UserWhere>;
  /** Return Messages where one of the related Users match this filter */
  mentions_SINGLE?: InputMaybe<UserWhere>;
  /** Return Messages where some of the related Users match this filter */
  mentions_SOME?: InputMaybe<UserWhere>;
  sentBy?: InputMaybe<UserWhere>;
  sentByAggregate?: InputMaybe<MessageSentByAggregateInput>;
  sentByConnection?: InputMaybe<MessageSentByConnectionWhere>;
  sentByConnection_NOT?: InputMaybe<MessageSentByConnectionWhere>;
  sentBy_NOT?: InputMaybe<UserWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type MessagesConnection = {
  __typename?: 'MessagesConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MicroContent = {
  __typename?: 'MicroContent';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['Int']['output'];
  type: MicroContentType;
};

export type MicroContentAggregateSelection = {
  __typename?: 'MicroContentAggregateSelection';
  amount: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
};

export type MicroContentEdge = {
  __typename?: 'MicroContentEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: MicroContent;
};

export type MicroContentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MicroContentSort objects to sort MicroContents by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MicroContentSort>>;
};

/** Fields to sort MicroContents by. The order in which sorts are applied is not guaranteed when specifying many fields in one MicroContentSort object. */
export type MicroContentSort = {
  amount?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export enum MicroContentType {
  NewCases = 'NEW_CASES',
  TherapyTrials = 'THERAPY_TRIALS',
  TreatmentContinuation = 'TREATMENT_CONTINUATION'
}

export type MicroContentWhere = {
  AND?: InputMaybe<Array<MicroContentWhere>>;
  NOT?: InputMaybe<MicroContentWhere>;
  OR?: InputMaybe<Array<MicroContentWhere>>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  amount_GT?: InputMaybe<Scalars['Int']['input']>;
  amount_GTE?: InputMaybe<Scalars['Int']['input']>;
  amount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  amount_LT?: InputMaybe<Scalars['Int']['input']>;
  amount_LTE?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MicroContentType>;
  type_IN?: InputMaybe<Array<MicroContentType>>;
};

export type MicroContentsConnection = {
  __typename?: 'MicroContentsConnection';
  edges: Array<MicroContentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Model = {
  __typename?: 'Model';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  caseExamples: Scalars['String']['output'];
  challenges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dataTypes: Array<Scalars['String']['output']>;
  details: Scalars['String']['output'];
  financialFlows: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Array<ModelImage>;
  isComparable: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  measures: Array<Scalars['String']['output']>;
  measuresAndMilestones: Scalars['String']['output'];
  milestones: Array<Scalars['String']['output']>;
  modelBlobImage?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publicAgreementIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  relatedModelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  scopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  summary: Scalars['String']['output'];
  therapeuticAreas: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ModelAggregateSelection = {
  __typename?: 'ModelAggregateSelection';
  caseExamples: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  details: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  measuresAndMilestones: StringAggregateSelectionNonNullable;
  modelBlobImage: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  summary: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNonNullable;
};

export type ModelEdge = {
  __typename?: 'ModelEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Model;
};

export type ModelImage = {
  __typename?: 'ModelImage';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ModelImageAggregateSelection = {
  __typename?: 'ModelImageAggregateSelection';
  count: Scalars['Int']['output'];
  fileName: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  url: StringAggregateSelectionNullable;
};

export type ModelImageEdge = {
  __typename?: 'ModelImageEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ModelImage;
};

export type ModelImageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ModelImageSort objects to sort ModelImages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ModelImageSort>>;
};

/** Fields to sort ModelImages by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModelImageSort object. */
export type ModelImageSort = {
  fileName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
};

export type ModelImageWhere = {
  AND?: InputMaybe<Array<ModelImageWhere>>;
  NOT?: InputMaybe<ModelImageWhere>;
  OR?: InputMaybe<Array<ModelImageWhere>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_MATCHES?: InputMaybe<Scalars['String']['input']>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ModelImagesConnection = {
  __typename?: 'ModelImagesConnection';
  edges: Array<ModelImageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModelInAgreement = {
  __typename?: 'ModelInAgreement';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ModelInAgreementAggregateSelection = {
  __typename?: 'ModelInAgreementAggregateSelection';
  count: Scalars['Int']['output'];
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
};

export type ModelInAgreementEdge = {
  __typename?: 'ModelInAgreementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ModelInAgreement;
};

export type ModelInAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ModelInAgreementSort objects to sort ModelInAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ModelInAgreementSort>>;
};

/** Fields to sort ModelInAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModelInAgreementSort object. */
export type ModelInAgreementSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ModelInAgreementWhere = {
  AND?: InputMaybe<Array<ModelInAgreementWhere>>;
  NOT?: InputMaybe<ModelInAgreementWhere>;
  OR?: InputMaybe<Array<ModelInAgreementWhere>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ModelInAgreementsConnection = {
  __typename?: 'ModelInAgreementsConnection';
  edges: Array<ModelInAgreementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModelOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ModelSort objects to sort Models by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ModelSort>>;
};

/** Fields to sort Models by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModelSort object. */
export type ModelSort = {
  caseExamples?: InputMaybe<SortDirection>;
  details?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isComparable?: InputMaybe<SortDirection>;
  isFavorite?: InputMaybe<SortDirection>;
  measuresAndMilestones?: InputMaybe<SortDirection>;
  modelBlobImage?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type ModelWhere = {
  AND?: InputMaybe<Array<ModelWhere>>;
  NOT?: InputMaybe<ModelWhere>;
  OR?: InputMaybe<Array<ModelWhere>>;
  caseExamples?: InputMaybe<Scalars['String']['input']>;
  caseExamples_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caseExamples_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseExamples_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  caseExamples_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caseExamples_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  challenges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  challenges_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  dataTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  dataTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  details_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  details_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  details_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  details_MATCHES?: InputMaybe<Scalars['String']['input']>;
  details_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  financialFlows?: InputMaybe<Array<Scalars['String']['input']>>;
  financialFlows_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isComparable?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  measures?: InputMaybe<Array<Scalars['String']['input']>>;
  measuresAndMilestones?: InputMaybe<Scalars['String']['input']>;
  measuresAndMilestones_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  measuresAndMilestones_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  measuresAndMilestones_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  measuresAndMilestones_MATCHES?: InputMaybe<Scalars['String']['input']>;
  measuresAndMilestones_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  measures_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  milestones?: InputMaybe<Array<Scalars['String']['input']>>;
  milestones_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  modelBlobImage?: InputMaybe<Scalars['String']['input']>;
  modelBlobImage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  modelBlobImage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  modelBlobImage_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modelBlobImage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  modelBlobImage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAgreementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publicAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  relatedModelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedModelIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  summary_MATCHES?: InputMaybe<Scalars['String']['input']>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  therapeuticAreas_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type Models = {
  __typename?: 'Models';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedToCompareCount?: Maybe<Scalars['Int']['output']>;
  filteredModelsCount?: Maybe<Scalars['Int']['output']>;
  models: Array<Model>;
};

export type ModelsConnection = {
  __typename?: 'ModelsConnection';
  edges: Array<ModelEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModelsSourceFilterData = {
  __typename?: 'ModelsSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  challenges: Array<Scalars['String']['output']>;
  dataTypes: Array<Scalars['String']['output']>;
  financialFlows: Array<Scalars['String']['output']>;
  measures: Array<Scalars['String']['output']>;
  scopes: Array<Scalars['String']['output']>;
  therapeuticAreas: Array<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};

export type ModelsSourceFilterDataAggregateSelection = {
  __typename?: 'ModelsSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
};

export type ModelsSourceFilterDataConnection = {
  __typename?: 'ModelsSourceFilterDataConnection';
  edges: Array<ModelsSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ModelsSourceFilterDataEdge = {
  __typename?: 'ModelsSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ModelsSourceFilterData;
};

export type ModelsSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelsSourceFilterDataWhere = {
  AND?: InputMaybe<Array<ModelsSourceFilterDataWhere>>;
  NOT?: InputMaybe<ModelsSourceFilterDataWhere>;
  OR?: InputMaybe<Array<ModelsSourceFilterDataWhere>>;
  challenges?: InputMaybe<Array<Scalars['String']['input']>>;
  challenges_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  dataTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  dataTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  financialFlows?: InputMaybe<Array<Scalars['String']['input']>>;
  financialFlows_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  measures?: InputMaybe<Array<Scalars['String']['input']>>;
  measures_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  scopes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  therapeuticAreas_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  types_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type Module = {
  __typename?: 'Module';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ModuleAggregateSelection = {
  __typename?: 'ModuleAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNullable;
};

export type ModuleEdge = {
  __typename?: 'ModuleEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Module;
};

export type ModuleInput = {
  code: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ModuleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ModuleSort objects to sort Modules by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ModuleSort>>;
};

/** Fields to sort Modules by. The order in which sorts are applied is not guaranteed when specifying many fields in one ModuleSort object. */
export type ModuleSort = {
  code?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type ModuleWhere = {
  AND?: InputMaybe<Array<ModuleWhere>>;
  NOT?: InputMaybe<ModuleWhere>;
  OR?: InputMaybe<Array<ModuleWhere>>;
  code?: InputMaybe<Scalars['String']['input']>;
  code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ModulesConnection = {
  __typename?: 'ModulesConnection';
  edges: Array<ModuleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MonitoringType {
  ChangedBetween = 'CHANGED_BETWEEN'
}

export type Mutation = {
  __typename?: 'Mutation';
  AddAgreementDecision?: Maybe<Scalars['Int']['output']>;
  AddModule?: Maybe<Scalars['Boolean']['output']>;
  AddOrRemoveModelToCompare?: Maybe<Scalars['ID']['output']>;
  AddOrRemoveModelToFavorites?: Maybe<Scalars['ID']['output']>;
  AddRefundsToExistingDocument?: Maybe<Scalars['ID']['output']>;
  AddUserSubscribed?: Maybe<Scalars['Int']['output']>;
  AddUserSubscribedNotifications?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  ApplyDefaultUserRolesToAll?: Maybe<Scalars['Boolean']['output']>;
  ApproveDocument?: Maybe<Scalars['Int']['output']>;
  AssignInvoiceToUser?: Maybe<Scalars['ID']['output']>;
  AssignUserToDomain?: Maybe<Scalars['Boolean']['output']>;
  BookDemo?: Maybe<Scalars['Boolean']['output']>;
  CancelAttachmentUpload?: Maybe<Scalars['Boolean']['output']>;
  CancelUpload?: Maybe<Scalars['Int']['output']>;
  ChangeQuestStatus?: Maybe<Scalars['Int']['output']>;
  ConfirmInvoice?: Maybe<Scalars['ID']['output']>;
  CreateDocument?: Maybe<Scalars['ID']['output']>;
  CreateDocumentMessage: CreateDocumentMessageResult;
  CreateDomain?: Maybe<Scalars['ID']['output']>;
  CreateThreadMessage?: Maybe<Message>;
  DeleteDocumentMessage?: Maybe<Scalars['Int']['output']>;
  DeleteDomain?: Maybe<Scalars['Boolean']['output']>;
  DeleteFlexEntity?: Maybe<Scalars['Boolean']['output']>;
  DeleteInvoice?: Maybe<Scalars['ID']['output']>;
  DeleteSimulation?: Maybe<Scalars['Boolean']['output']>;
  DeleteThreadMessage?: Maybe<Scalars['Float']['output']>;
  ExecuteBaseAgreement?: Maybe<Scalars['Int']['output']>;
  IssueInvoice?: Maybe<Scalars['ID']['output']>;
  IssueInvoiceWithoutReview?: Maybe<Scalars['ID']['output']>;
  ReadOrUnreadQuest?: Maybe<Scalars['Int']['output']>;
  ReadOrUnreadTask?: Maybe<Scalars['Int']['output']>;
  RecallToDraft?: Maybe<Scalars['ID']['output']>;
  RejectInvoice?: Maybe<Scalars['ID']['output']>;
  RemoveModule?: Maybe<Scalars['Boolean']['output']>;
  RemoveQuestOwnership?: Maybe<Scalars['Int']['output']>;
  RemoveUserSubscribed?: Maybe<Scalars['Int']['output']>;
  RemoveUserSubscribedNotifications?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  ResendDocumentToSmartMip?: Maybe<SendDocumentToSmartMipResult>;
  ResendInvoiceForReview?: Maybe<Scalars['ID']['output']>;
  ResolveAssignment: DocumentMessage;
  RevokeRecord?: Maybe<Scalars['Boolean']['output']>;
  SaveAdjustedAmount?: Maybe<Scalars['Boolean']['output']>;
  SaveDraftInvoice?: Maybe<Scalars['ID']['output']>;
  SaveFlexEntities: Array<EnvironmentImpact>;
  SaveFlexEntity: Array<EnvironmentImpact>;
  SaveInvoiceForInternalReview?: Maybe<Scalars['ID']['output']>;
  SaveReviewedInvoice?: Maybe<Scalars['ID']['output']>;
  SaveSimulation?: Maybe<SaveSimulationResult>;
  SendDecisionsToSmartMip?: Maybe<Scalars['Boolean']['output']>;
  SendDocumentForExternalReview?: Maybe<Scalars['ID']['output']>;
  SendDocumentToSmartMip?: Maybe<SendDocumentToSmartMipResult>;
  SendInvoiceForReview?: Maybe<Scalars['ID']['output']>;
  SendPaymentReminder?: Maybe<Scalars['Boolean']['output']>;
  SetDunningDate?: Maybe<Scalars['Int']['output']>;
  SetPublicAgreementView: Scalars['Int']['output'];
  StartFinalUpload?: Maybe<Scalars['Int']['output']>;
  StartPreliminaryUpload?: Maybe<Scalars['Int']['output']>;
  SyncSmartMipResult?: Maybe<Scalars['Boolean']['output']>;
  TakeQuestOwnership?: Maybe<Scalars['Int']['output']>;
  UndeleteDocumentMessage?: Maybe<Scalars['Int']['output']>;
  UnresolveAssignment: DocumentMessage;
  UnverifyRecordsInQuest?: Maybe<Scalars['Int']['output']>;
  UpdateAgreementAssignee?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  UpdateAgreementUserRoles?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  UpdateAgreementsTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateCaseAssignee?: Maybe<Case>;
  UpdateCurrentUserPersonalInfo?: Maybe<UserPersonalInfo>;
  UpdateCurrentUserPersonalProductsInfo?: Maybe<UserPersonalInfo>;
  UpdateDefaultUserRole?: Maybe<Scalars['Boolean']['output']>;
  UpdateDocumentExportFields?: Maybe<Scalars['Int']['output']>;
  UpdateDocumentPaymentFields?: Maybe<Scalars['Int']['output']>;
  UpdateDocumentsTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateDomain?: Maybe<Scalars['Boolean']['output']>;
  UpdateFormsTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateInterventionReportStatus?: Maybe<InterventionReportStatusResponse>;
  UpdateNegotiationRound: NegotiationRound;
  UpdateProfilePictureOrSignature?: Maybe<ProfileDataInfo>;
  UpdateRecordsTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateScenarioInsightsUserContext?: Maybe<Scalars['Int']['output']>;
  UpdateSimulationBusinessCase?: Maybe<Scalars['ID']['output']>;
  UpdateSimulationUom?: Maybe<Scalars['ID']['output']>;
  UpdateSimulationsTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateSimulatorRole?: Maybe<Scalars['Boolean']['output']>;
  UpdateTransactionsInCreditNoteDocumentTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateTransactionsInFreeOfChargeDocumentTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateTransactionsInRefundInvoiceDocumentTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateTransactionsTableColumns?: Maybe<Scalars['Int']['output']>;
  UpdateUserComparisonSimulations?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersAgreements?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersCaseEventLogs?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersCases?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersDataForms?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersDataQuests?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersDataRecords?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersDocuments?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersInboxNotification?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersModels?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersOrganizationSettings?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextFiltersRefunds?: Maybe<Scalars['Int']['output']>;
  UpdateUserContextTimePeriodFilterReporting?: Maybe<Scalars['Int']['output']>;
  UpdateUserFiltersPublicAgreements?: Maybe<Scalars['Int']['output']>;
  UpdateUserFiltersSimulations?: Maybe<Scalars['Int']['output']>;
  UpdateUserRole?: Maybe<Scalars['Boolean']['output']>;
  UploadClaims?: Maybe<Scalars['Int']['output']>;
  UploadFile?: Maybe<Scalars['Int']['output']>;
  UploadToSftp: DocumentUploadInfo;
  VerifyRecordsInQuest?: Maybe<Scalars['Boolean']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
};


export type MutationAddAgreementDecisionArgs = {
  input: AgreementDecisionInput;
};


export type MutationAddModuleArgs = {
  id: Scalars['String']['input'];
  input?: InputMaybe<ModuleInput>;
};


export type MutationAddOrRemoveModelToCompareArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddOrRemoveModelToFavoritesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddRefundsToExistingDocumentArgs = {
  request?: InputMaybe<CreateDocumentInput>;
};


export type MutationAddUserSubscribedArgs = {
  notificationId: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAddUserSubscribedNotificationsArgs = {
  notificationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId: Scalars['ID']['input'];
};


export type MutationApplyDefaultUserRolesToAllArgs = {
  input?: InputMaybe<ApplyUserRolesToAllInput>;
};


export type MutationApproveDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationAssignInvoiceToUserArgs = {
  request?: InputMaybe<AssignInvoiceToUserInput>;
};


export type MutationAssignUserToDomainArgs = {
  input: AssignUserToDomainInput;
};


export type MutationBookDemoArgs = {
  request?: InputMaybe<BookDemoInput>;
};


export type MutationCancelAttachmentUploadArgs = {
  pendingMessageId: Scalars['ID']['input'];
};


export type MutationChangeQuestStatusArgs = {
  ownerId?: InputMaybe<Scalars['String']['input']>;
  questCompletionStatus: QuestCompletionStatus;
  questId: Scalars['ID']['input'];
};


export type MutationConfirmInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateDocumentArgs = {
  request?: InputMaybe<CreateDocumentInput>;
};


export type MutationCreateDocumentMessageArgs = {
  input: CreateDocumentMessageInput;
};


export type MutationCreateDomainArgs = {
  input: CreateDomainInput;
};


export type MutationCreateThreadMessageArgs = {
  input?: InputMaybe<CreateThreadMessageInput>;
};


export type MutationDeleteDocumentMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteDomainArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFlexEntityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInvoiceArgs = {
  request?: InputMaybe<DeleteInvoiceInput>;
};


export type MutationDeleteSimulationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteThreadMessageArgs = {
  input?: InputMaybe<DeleteThreadMessageInput>;
};


export type MutationExecuteBaseAgreementArgs = {
  executionDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAgreementRunSubscriptionActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCaseless?: InputMaybe<Scalars['Boolean']['input']>;
  triggeredByEmail: Scalars['String']['input'];
};


export type MutationIssueInvoiceArgs = {
  request?: InputMaybe<SaveReviewedInvoiceInput>;
};


export type MutationIssueInvoiceWithoutReviewArgs = {
  request?: InputMaybe<IssueInvoiceWithoutReviewInput>;
};


export type MutationReadOrUnreadQuestArgs = {
  questId: Scalars['ID']['input'];
  questStatus: TaskStatus;
};


export type MutationReadOrUnreadTaskArgs = {
  taskId: Scalars['ID']['input'];
  taskStatus: TaskStatus;
};


export type MutationRecallToDraftArgs = {
  request?: InputMaybe<RecallToDraftInput>;
};


export type MutationRejectInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveModuleArgs = {
  id: Scalars['String']['input'];
  moduleId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveQuestOwnershipArgs = {
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  questId: Scalars['ID']['input'];
};


export type MutationRemoveUserSubscribedArgs = {
  notificationId: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRemoveUserSubscribedNotificationsArgs = {
  notificationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId: Scalars['ID']['input'];
};


export type MutationResendDocumentToSmartMipArgs = {
  input: ResendDocumentToSmartMipInput;
};


export type MutationResendInvoiceForReviewArgs = {
  request?: InputMaybe<ResendInvoiceForReviewInput>;
};


export type MutationResolveAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeRecordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveAdjustedAmountArgs = {
  request: Array<SaveAdjustedAmountInput>;
};


export type MutationSaveDraftInvoiceArgs = {
  request?: InputMaybe<SaveDraftInvoiceInput>;
};


export type MutationSaveFlexEntitiesArgs = {
  caseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isCaseDeletionAllowed: Scalars['Boolean']['input'];
  status: FlexFormStatus;
  typeId: Scalars['ID']['input'];
};


export type MutationSaveFlexEntityArgs = {
  caseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isCaseDeletionAllowed: Scalars['Boolean']['input'];
  status: FlexFormStatus;
  typeId: Scalars['ID']['input'];
};


export type MutationSaveInvoiceForInternalReviewArgs = {
  request?: InputMaybe<SaveInvoiceForInternalReviewInput>;
};


export type MutationSaveReviewedInvoiceArgs = {
  request?: InputMaybe<SaveReviewedInvoiceInput>;
};


export type MutationSaveSimulationArgs = {
  request: SimulationInput;
};


export type MutationSendDecisionsToSmartMipArgs = {
  input: SendDecisionsToSmartMipInput;
};


export type MutationSendDocumentForExternalReviewArgs = {
  request: SendDocumentForExternalReviewInput;
};


export type MutationSendDocumentToSmartMipArgs = {
  input: SendDocumentToSmartMipInput;
};


export type MutationSendInvoiceForReviewArgs = {
  request?: InputMaybe<UpdateInvoiceForReviewInput>;
};


export type MutationSendPaymentReminderArgs = {
  request: SendDocumentForExternalReviewInput;
};


export type MutationSetDunningDateArgs = {
  documentId: Scalars['ID']['input'];
  dunningDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationSetPublicAgreementViewArgs = {
  view: PublicAgreementView;
};


export type MutationStartFinalUploadArgs = {
  input?: InputMaybe<UploadFlexEntityInput>;
};


export type MutationStartPreliminaryUploadArgs = {
  input?: InputMaybe<UploadFlexEntityInput>;
};


export type MutationSyncSmartMipResultArgs = {
  input: SyncSmartMipResultInput;
};


export type MutationTakeQuestOwnershipArgs = {
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  questId: Scalars['ID']['input'];
};


export type MutationUndeleteDocumentMessageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUnresolveAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnverifyRecordsInQuestArgs = {
  recordsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateAgreementAssigneeArgs = {
  agreementId: Scalars['String']['input'];
  isAssignee: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateAgreementUserRolesArgs = {
  input?: InputMaybe<UserRoleRequestUpdateInput>;
};


export type MutationUpdateAgreementsTableColumnsArgs = {
  agreementsColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateCaseAssigneeArgs = {
  req: UpdateCaseAssigneeInput;
};


export type MutationUpdateCurrentUserPersonalInfoArgs = {
  personalInfo?: InputMaybe<UserPersonalInfoInput>;
};


export type MutationUpdateCurrentUserPersonalProductsInfoArgs = {
  personalInfo?: InputMaybe<UserPersonalInfoInput>;
};


export type MutationUpdateDefaultUserRoleArgs = {
  input?: InputMaybe<DefaultUserRoleUpdateInput>;
};


export type MutationUpdateDocumentExportFieldsArgs = {
  input: DocumentExportFieldsInput;
};


export type MutationUpdateDocumentPaymentFieldsArgs = {
  input: UpdateDocumentPaymentFieldsInput;
};


export type MutationUpdateDocumentsTableColumnsArgs = {
  documentsColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateDomainArgs = {
  input: UpdateDomainInput;
};


export type MutationUpdateFormsTableColumnsArgs = {
  formsColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateInterventionReportStatusArgs = {
  input: InterventionReportStatusUpdateInput;
};


export type MutationUpdateNegotiationRoundArgs = {
  input: NegotiationRoundInput;
};


export type MutationUpdateProfilePictureOrSignatureArgs = {
  userProfileOrSignatureInput?: InputMaybe<UserProfileOrSignatureInput>;
};


export type MutationUpdateRecordsTableColumnsArgs = {
  recordsColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateScenarioInsightsUserContextArgs = {
  agreementId: Scalars['ID']['input'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  input?: InputMaybe<ScenarioInsightsUserContextInput>;
  timeframeLabel?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSimulationBusinessCaseArgs = {
  request: SimulationBusinessCaseInput;
};


export type MutationUpdateSimulationUomArgs = {
  request: SimulationUnitsInput;
};


export type MutationUpdateSimulationsTableColumnsArgs = {
  simulationsColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateSimulatorRoleArgs = {
  request: SimulationRoleInput;
};


export type MutationUpdateTransactionsInCreditNoteDocumentTableColumnsArgs = {
  transactionsInCreditNoteDocumentTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateTransactionsInFreeOfChargeDocumentTableColumnsArgs = {
  transactionsInFreeOfChargeDocumentTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateTransactionsInRefundInvoiceDocumentTableColumnsArgs = {
  transactionsInRefundInvoiceDocumentTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateTransactionsTableColumnsArgs = {
  transactionsColumns?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateUserComparisonSimulationsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersAgreementsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersCaseEventLogsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersCasesArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersDataFormsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersDataQuestsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersDataRecordsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersDocumentsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersInboxNotificationArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersModelsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersOrganizationSettingsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextFiltersRefundsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserContextTimePeriodFilterReportingArgs = {
  agreementId: Scalars['ID']['input'];
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserFiltersPublicAgreementsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserFiltersSimulationsArgs = {
  req?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserRoleArgs = {
  id: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUploadClaimsArgs = {
  claims?: InputMaybe<Array<InputMaybe<UploadClaimsInput>>>;
};


export type MutationUploadFileArgs = {
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};


export type MutationUploadToSftpArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationVerifyRecordsInQuestArgs = {
  recordsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};

export type MyRoleProfile = {
  __typename?: 'MyRoleProfile';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementSpecificRoles?: Maybe<Array<AgreementSpecificUserRole>>;
  agreementTagRoles?: Maybe<Array<AgreementTagRole>>;
  hasOperativeDataAccess?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type MyRoleProfileAggregateSelection = {
  __typename?: 'MyRoleProfileAggregateSelection';
  count: Scalars['Int']['output'];
  role: StringAggregateSelectionNullable;
};

export type MyRoleProfileEdge = {
  __typename?: 'MyRoleProfileEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: MyRoleProfile;
};

export type MyRoleProfileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more MyRoleProfileSort objects to sort MyRoleProfiles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<MyRoleProfileSort>>;
};

/** Fields to sort MyRoleProfiles by. The order in which sorts are applied is not guaranteed when specifying many fields in one MyRoleProfileSort object. */
export type MyRoleProfileSort = {
  hasOperativeDataAccess?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type MyRoleProfileWhere = {
  AND?: InputMaybe<Array<MyRoleProfileWhere>>;
  NOT?: InputMaybe<MyRoleProfileWhere>;
  OR?: InputMaybe<Array<MyRoleProfileWhere>>;
  hasOperativeDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type MyRoleProfilesConnection = {
  __typename?: 'MyRoleProfilesConnection';
  edges: Array<MyRoleProfileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRound = {
  __typename?: 'NegotiationRound';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  case: Case;
  caseAggregate?: Maybe<NegotiationRoundCaseCaseAggregationSelection>;
  caseConnection: NegotiationRoundCaseConnection;
  changedOn: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastProposedBy: Scalars['String']['output'];
  proposedBy: Organization;
  proposedByAggregate?: Maybe<NegotiationRoundOrganizationProposedByAggregationSelection>;
  proposedByConnection: NegotiationRoundProposedByConnection;
  source: FlexEntity;
  sourceAggregate?: Maybe<NegotiationRoundFlexEntitySourceAggregationSelection>;
  sourceConnection: NegotiationRoundSourceConnection;
  status: NegotiationRoundStatus;
  updatedBy: Array<User>;
  updatedByAggregate?: Maybe<NegotiationRoundUserUpdatedByAggregationSelection>;
  updatedByConnection: NegotiationRoundUpdatedByConnection;
};


export type NegotiationRoundCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type NegotiationRoundCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type NegotiationRoundCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundCaseConnectionSort>>;
  where?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
};


export type NegotiationRoundProposedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type NegotiationRoundProposedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type NegotiationRoundProposedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundProposedByConnectionSort>>;
  where?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
};


export type NegotiationRoundSourceArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type NegotiationRoundSourceAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type NegotiationRoundSourceConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundSourceConnectionSort>>;
  where?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
};


export type NegotiationRoundUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NegotiationRoundUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NegotiationRoundUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NegotiationRoundUpdatedByConnectionSort>>;
  where?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
};

export type NegotiationRoundAggregateSelection = {
  __typename?: 'NegotiationRoundAggregateSelection';
  changedOn: DateTimeAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  data: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type NegotiationRoundCaseAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundCaseAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundCaseAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundCaseNodeAggregationWhereInput>;
};

export type NegotiationRoundCaseCaseAggregationSelection = {
  __typename?: 'NegotiationRoundCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundCaseCaseNodeAggregateSelection>;
};

export type NegotiationRoundCaseCaseNodeAggregateSelection = {
  __typename?: 'NegotiationRoundCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type NegotiationRoundCaseConnection = {
  __typename?: 'NegotiationRoundCaseConnection';
  edges: Array<NegotiationRoundCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type NegotiationRoundCaseConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundCaseConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type NegotiationRoundCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NegotiationRoundCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type NegotiationRoundCaseRelationship = {
  __typename?: 'NegotiationRoundCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type NegotiationRoundEdge = {
  __typename?: 'NegotiationRoundEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NegotiationRound;
};

export type NegotiationRoundFlexEntitySourceAggregationSelection = {
  __typename?: 'NegotiationRoundFlexEntitySourceAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundFlexEntitySourceNodeAggregateSelection>;
};

export type NegotiationRoundFlexEntitySourceNodeAggregateSelection = {
  __typename?: 'NegotiationRoundFlexEntitySourceNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type NegotiationRoundInput = {
  caseId: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: NegotiationRoundStatus;
};

export type NegotiationRoundOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NegotiationRoundSort objects to sort NegotiationRounds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NegotiationRoundSort>>;
};

export type NegotiationRoundOrganizationProposedByAggregationSelection = {
  __typename?: 'NegotiationRoundOrganizationProposedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundOrganizationProposedByNodeAggregateSelection>;
};

export type NegotiationRoundOrganizationProposedByNodeAggregateSelection = {
  __typename?: 'NegotiationRoundOrganizationProposedByNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type NegotiationRoundProposedByAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundProposedByAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundProposedByAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundProposedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundProposedByNodeAggregationWhereInput>;
};

export type NegotiationRoundProposedByConnection = {
  __typename?: 'NegotiationRoundProposedByConnection';
  edges: Array<NegotiationRoundProposedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundProposedByConnectionSort = {
  node?: InputMaybe<OrganizationSort>;
};

export type NegotiationRoundProposedByConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundProposedByConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundProposedByConnectionWhere>>;
  node?: InputMaybe<OrganizationWhere>;
};

export type NegotiationRoundProposedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundProposedByNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<NegotiationRoundProposedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundProposedByNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NegotiationRoundProposedByRelationship = {
  __typename?: 'NegotiationRoundProposedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** Fields to sort NegotiationRounds by. The order in which sorts are applied is not guaranteed when specifying many fields in one NegotiationRoundSort object. */
export type NegotiationRoundSort = {
  changedOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastProposedBy?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
};

export type NegotiationRoundSourceAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundSourceAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundSourceAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundSourceAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundSourceNodeAggregationWhereInput>;
};

export type NegotiationRoundSourceConnection = {
  __typename?: 'NegotiationRoundSourceConnection';
  edges: Array<NegotiationRoundSourceRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundSourceConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type NegotiationRoundSourceConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundSourceConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundSourceConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type NegotiationRoundSourceNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundSourceNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NegotiationRoundSourceNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundSourceNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NegotiationRoundSourceRelationship = {
  __typename?: 'NegotiationRoundSourceRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export enum NegotiationRoundStatus {
  Accepted = 'ACCEPTED',
  AcceptedWithoutReview = 'ACCEPTED_WITHOUT_REVIEW',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export type NegotiationRoundUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<NegotiationRoundUpdatedByAggregateInput>>;
  NOT?: InputMaybe<NegotiationRoundUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<NegotiationRoundUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NegotiationRoundUpdatedByNodeAggregationWhereInput>;
};

export type NegotiationRoundUpdatedByConnection = {
  __typename?: 'NegotiationRoundUpdatedByConnection';
  edges: Array<NegotiationRoundUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NegotiationRoundUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NegotiationRoundUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<NegotiationRoundUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<NegotiationRoundUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NegotiationRoundUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NegotiationRoundUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NegotiationRoundUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NegotiationRoundUpdatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NegotiationRoundUpdatedByRelationship = {
  __typename?: 'NegotiationRoundUpdatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type NegotiationRoundUserUpdatedByAggregationSelection = {
  __typename?: 'NegotiationRoundUserUpdatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<NegotiationRoundUserUpdatedByNodeAggregateSelection>;
};

export type NegotiationRoundUserUpdatedByNodeAggregateSelection = {
  __typename?: 'NegotiationRoundUserUpdatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type NegotiationRoundWhere = {
  AND?: InputMaybe<Array<NegotiationRoundWhere>>;
  NOT?: InputMaybe<NegotiationRoundWhere>;
  OR?: InputMaybe<Array<NegotiationRoundWhere>>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<NegotiationRoundCaseAggregateInput>;
  caseConnection?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<NegotiationRoundCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  changedOn?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  changedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  proposedBy?: InputMaybe<OrganizationWhere>;
  proposedByAggregate?: InputMaybe<NegotiationRoundProposedByAggregateInput>;
  proposedByConnection?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
  proposedByConnection_NOT?: InputMaybe<NegotiationRoundProposedByConnectionWhere>;
  proposedBy_NOT?: InputMaybe<OrganizationWhere>;
  source?: InputMaybe<FlexEntityWhere>;
  sourceAggregate?: InputMaybe<NegotiationRoundSourceAggregateInput>;
  sourceConnection?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
  sourceConnection_NOT?: InputMaybe<NegotiationRoundSourceConnectionWhere>;
  source_NOT?: InputMaybe<FlexEntityWhere>;
  status?: InputMaybe<NegotiationRoundStatus>;
  status_IN?: InputMaybe<Array<NegotiationRoundStatus>>;
  updatedByAggregate?: InputMaybe<NegotiationRoundUpdatedByAggregateInput>;
  /** Return NegotiationRounds where all of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_ALL?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where none of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_NONE?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where one of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_SINGLE?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where some of the related NegotiationRoundUpdatedByConnections match this filter */
  updatedByConnection_SOME?: InputMaybe<NegotiationRoundUpdatedByConnectionWhere>;
  /** Return NegotiationRounds where all of the related Users match this filter */
  updatedBy_ALL?: InputMaybe<UserWhere>;
  /** Return NegotiationRounds where none of the related Users match this filter */
  updatedBy_NONE?: InputMaybe<UserWhere>;
  /** Return NegotiationRounds where one of the related Users match this filter */
  updatedBy_SINGLE?: InputMaybe<UserWhere>;
  /** Return NegotiationRounds where some of the related Users match this filter */
  updatedBy_SOME?: InputMaybe<UserWhere>;
};

export type NegotiationRoundsConnection = {
  __typename?: 'NegotiationRoundsConnection';
  edges: Array<NegotiationRoundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NetRevenueByOrganization = {
  __typename?: 'NetRevenueByOrganization';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  netAmount: Scalars['Float']['output'];
};

export type NetRevenueByOrganizationAggregateSelection = {
  __typename?: 'NetRevenueByOrganizationAggregateSelection';
  count: Scalars['Int']['output'];
  name: StringAggregateSelectionNonNullable;
  netAmount: FloatAggregateSelectionNonNullable;
};

export type NetRevenueByOrganizationEdge = {
  __typename?: 'NetRevenueByOrganizationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NetRevenueByOrganization;
};

export type NetRevenueByOrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NetRevenueByOrganizationSort objects to sort NetRevenueByOrganizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NetRevenueByOrganizationSort>>;
};

/** Fields to sort NetRevenueByOrganizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one NetRevenueByOrganizationSort object. */
export type NetRevenueByOrganizationSort = {
  name?: InputMaybe<SortDirection>;
  netAmount?: InputMaybe<SortDirection>;
};

export type NetRevenueByOrganizationWhere = {
  AND?: InputMaybe<Array<NetRevenueByOrganizationWhere>>;
  NOT?: InputMaybe<NetRevenueByOrganizationWhere>;
  OR?: InputMaybe<Array<NetRevenueByOrganizationWhere>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  netAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type NetRevenueByOrganizationsConnection = {
  __typename?: 'NetRevenueByOrganizationsConnection';
  edges: Array<NetRevenueByOrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NinjaQueriesConnection = {
  __typename?: 'NinjaQueriesConnection';
  edges: Array<NinjaQueryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NinjaQuery = {
  __typename?: 'NinjaQuery';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  createdByEmail: Scalars['String']['output'];
  createdOn: Scalars['Float']['output'];
  cypherQuery: Scalars['String']['output'];
  serializedCypherParams?: Maybe<Scalars['String']['output']>;
};

export type NinjaQueryAggregateSelection = {
  __typename?: 'NinjaQueryAggregateSelection';
  count: Scalars['Int']['output'];
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: FloatAggregateSelectionNonNullable;
  cypherQuery: StringAggregateSelectionNonNullable;
  serializedCypherParams: StringAggregateSelectionNullable;
};

export type NinjaQueryEdge = {
  __typename?: 'NinjaQueryEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NinjaQuery;
};

export type NinjaQueryImpact = {
  __typename?: 'NinjaQueryImpact';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  constraintsAdded: Scalars['Int']['output'];
  constraintsRemoved: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  indexesAdded: Scalars['Int']['output'];
  indexesRemoved: Scalars['Int']['output'];
  isValid: Scalars['Boolean']['output'];
  labelsAdded: Scalars['Int']['output'];
  labelsRemoved: Scalars['Int']['output'];
  nodesCreated: Scalars['Int']['output'];
  nodesDeleted: Scalars['Int']['output'];
  propertiesSet: Scalars['Int']['output'];
  queryResult?: Maybe<Scalars['String']['output']>;
  relationshipsCreated: Scalars['Int']['output'];
  relationshipsDeleted: Scalars['Int']['output'];
};

export type NinjaQueryImpactAggregateSelection = {
  __typename?: 'NinjaQueryImpactAggregateSelection';
  constraintsAdded: IntAggregateSelectionNonNullable;
  constraintsRemoved: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  errorMessage: StringAggregateSelectionNullable;
  indexesAdded: IntAggregateSelectionNonNullable;
  indexesRemoved: IntAggregateSelectionNonNullable;
  labelsAdded: IntAggregateSelectionNonNullable;
  labelsRemoved: IntAggregateSelectionNonNullable;
  nodesCreated: IntAggregateSelectionNonNullable;
  nodesDeleted: IntAggregateSelectionNonNullable;
  propertiesSet: IntAggregateSelectionNonNullable;
  queryResult: StringAggregateSelectionNullable;
  relationshipsCreated: IntAggregateSelectionNonNullable;
  relationshipsDeleted: IntAggregateSelectionNonNullable;
};

export type NinjaQueryImpactEdge = {
  __typename?: 'NinjaQueryImpactEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NinjaQueryImpact;
};

export type NinjaQueryImpactOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NinjaQueryImpactSort objects to sort NinjaQueryImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NinjaQueryImpactSort>>;
};

/** Fields to sort NinjaQueryImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one NinjaQueryImpactSort object. */
export type NinjaQueryImpactSort = {
  constraintsAdded?: InputMaybe<SortDirection>;
  constraintsRemoved?: InputMaybe<SortDirection>;
  errorMessage?: InputMaybe<SortDirection>;
  indexesAdded?: InputMaybe<SortDirection>;
  indexesRemoved?: InputMaybe<SortDirection>;
  isValid?: InputMaybe<SortDirection>;
  labelsAdded?: InputMaybe<SortDirection>;
  labelsRemoved?: InputMaybe<SortDirection>;
  nodesCreated?: InputMaybe<SortDirection>;
  nodesDeleted?: InputMaybe<SortDirection>;
  propertiesSet?: InputMaybe<SortDirection>;
  queryResult?: InputMaybe<SortDirection>;
  relationshipsCreated?: InputMaybe<SortDirection>;
  relationshipsDeleted?: InputMaybe<SortDirection>;
};

export type NinjaQueryImpactWhere = {
  AND?: InputMaybe<Array<NinjaQueryImpactWhere>>;
  NOT?: InputMaybe<NinjaQueryImpactWhere>;
  OR?: InputMaybe<Array<NinjaQueryImpactWhere>>;
  constraintsAdded?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_GT?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  constraintsAdded_LT?: InputMaybe<Scalars['Int']['input']>;
  constraintsAdded_LTE?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_GT?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_GTE?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  constraintsRemoved_LT?: InputMaybe<Scalars['Int']['input']>;
  constraintsRemoved_LTE?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorMessage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  errorMessage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  errorMessage_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  errorMessage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  errorMessage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indexesAdded?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_GT?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_GTE?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  indexesAdded_LT?: InputMaybe<Scalars['Int']['input']>;
  indexesAdded_LTE?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_GT?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_GTE?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  indexesRemoved_LT?: InputMaybe<Scalars['Int']['input']>;
  indexesRemoved_LTE?: InputMaybe<Scalars['Int']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  labelsAdded?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_GT?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_GTE?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  labelsAdded_LT?: InputMaybe<Scalars['Int']['input']>;
  labelsAdded_LTE?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_GT?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_GTE?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  labelsRemoved_LT?: InputMaybe<Scalars['Int']['input']>;
  labelsRemoved_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_GT?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nodesCreated_LT?: InputMaybe<Scalars['Int']['input']>;
  nodesCreated_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_GT?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nodesDeleted_LT?: InputMaybe<Scalars['Int']['input']>;
  nodesDeleted_LTE?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_GT?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_GTE?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  propertiesSet_LT?: InputMaybe<Scalars['Int']['input']>;
  propertiesSet_LTE?: InputMaybe<Scalars['Int']['input']>;
  queryResult?: InputMaybe<Scalars['String']['input']>;
  queryResult_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  queryResult_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  queryResult_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  queryResult_MATCHES?: InputMaybe<Scalars['String']['input']>;
  queryResult_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  relationshipsCreated?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_GT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_GTE?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationshipsCreated_LT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsCreated_LTE?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_GT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_GTE?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationshipsDeleted_LT?: InputMaybe<Scalars['Int']['input']>;
  relationshipsDeleted_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NinjaQueryImpactsConnection = {
  __typename?: 'NinjaQueryImpactsConnection';
  edges: Array<NinjaQueryImpactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NinjaQueryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NinjaQuerySort objects to sort NinjaQueries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NinjaQuerySort>>;
};

/** Fields to sort NinjaQueries by. The order in which sorts are applied is not guaranteed when specifying many fields in one NinjaQuerySort object. */
export type NinjaQuerySort = {
  createdByEmail?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  cypherQuery?: InputMaybe<SortDirection>;
  serializedCypherParams?: InputMaybe<SortDirection>;
};

export type NinjaQuerySubmitResult = {
  __typename?: 'NinjaQuerySubmitResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  impact: NinjaQueryImpact;
  query: NinjaQuery;
};

export type NinjaQuerySubmitResultAggregateSelection = {
  __typename?: 'NinjaQuerySubmitResultAggregateSelection';
  count: Scalars['Int']['output'];
};

export type NinjaQuerySubmitResultEdge = {
  __typename?: 'NinjaQuerySubmitResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NinjaQuerySubmitResult;
};

export type NinjaQuerySubmitResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type NinjaQuerySubmitResultWhere = {
  AND?: InputMaybe<Array<NinjaQuerySubmitResultWhere>>;
  NOT?: InputMaybe<NinjaQuerySubmitResultWhere>;
  OR?: InputMaybe<Array<NinjaQuerySubmitResultWhere>>;
};

export type NinjaQuerySubmitResultsConnection = {
  __typename?: 'NinjaQuerySubmitResultsConnection';
  edges: Array<NinjaQuerySubmitResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NinjaQueryWhere = {
  AND?: InputMaybe<Array<NinjaQueryWhere>>;
  NOT?: InputMaybe<NinjaQueryWhere>;
  OR?: InputMaybe<Array<NinjaQueryWhere>>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  cypherQuery?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  cypherQuery_MATCHES?: InputMaybe<Scalars['String']['input']>;
  cypherQuery_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serializedCypherParams_MATCHES?: InputMaybe<Scalars['String']['input']>;
  serializedCypherParams_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type NonEligibleReason = {
  __typename?: 'NonEligibleReason';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  missedConditionType: Scalars['String']['output'];
  patientCount: Scalars['Int']['output'];
};

export type NonEligibleReasonAggregateSelection = {
  __typename?: 'NonEligibleReasonAggregateSelection';
  count: Scalars['Int']['output'];
  missedConditionType: StringAggregateSelectionNonNullable;
  patientCount: IntAggregateSelectionNonNullable;
};

export type NonEligibleReasonEdge = {
  __typename?: 'NonEligibleReasonEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NonEligibleReason;
};

export type NonEligibleReasonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NonEligibleReasonSort objects to sort NonEligibleReasons by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NonEligibleReasonSort>>;
};

/** Fields to sort NonEligibleReasons by. The order in which sorts are applied is not guaranteed when specifying many fields in one NonEligibleReasonSort object. */
export type NonEligibleReasonSort = {
  missedConditionType?: InputMaybe<SortDirection>;
  patientCount?: InputMaybe<SortDirection>;
};

export type NonEligibleReasonWhere = {
  AND?: InputMaybe<Array<NonEligibleReasonWhere>>;
  NOT?: InputMaybe<NonEligibleReasonWhere>;
  OR?: InputMaybe<Array<NonEligibleReasonWhere>>;
  missedConditionType?: InputMaybe<Scalars['String']['input']>;
  missedConditionType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  missedConditionType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  missedConditionType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  missedConditionType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  missedConditionType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientCount?: InputMaybe<Scalars['Int']['input']>;
  patientCount_GT?: InputMaybe<Scalars['Int']['input']>;
  patientCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  patientCount_LT?: InputMaybe<Scalars['Int']['input']>;
  patientCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NonEligibleReasonsConnection = {
  __typename?: 'NonEligibleReasonsConnection';
  edges: Array<NonEligibleReasonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NonEnrolledReason = {
  __typename?: 'NonEnrolledReason';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  missedConditionType: EnrollingConditionType;
  patientCount: Scalars['Int']['output'];
};

export type NonEnrolledReasonAggregateSelection = {
  __typename?: 'NonEnrolledReasonAggregateSelection';
  count: Scalars['Int']['output'];
  patientCount: IntAggregateSelectionNonNullable;
};

export type NonEnrolledReasonEdge = {
  __typename?: 'NonEnrolledReasonEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NonEnrolledReason;
};

export type NonEnrolledReasonOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NonEnrolledReasonSort objects to sort NonEnrolledReasons by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NonEnrolledReasonSort>>;
};

/** Fields to sort NonEnrolledReasons by. The order in which sorts are applied is not guaranteed when specifying many fields in one NonEnrolledReasonSort object. */
export type NonEnrolledReasonSort = {
  missedConditionType?: InputMaybe<SortDirection>;
  patientCount?: InputMaybe<SortDirection>;
};

export type NonEnrolledReasonWhere = {
  AND?: InputMaybe<Array<NonEnrolledReasonWhere>>;
  NOT?: InputMaybe<NonEnrolledReasonWhere>;
  OR?: InputMaybe<Array<NonEnrolledReasonWhere>>;
  missedConditionType?: InputMaybe<EnrollingConditionType>;
  missedConditionType_IN?: InputMaybe<Array<EnrollingConditionType>>;
  patientCount?: InputMaybe<Scalars['Int']['input']>;
  patientCount_GT?: InputMaybe<Scalars['Int']['input']>;
  patientCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  patientCount_LT?: InputMaybe<Scalars['Int']['input']>;
  patientCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NonEnrolledReasonsConnection = {
  __typename?: 'NonEnrolledReasonsConnection';
  edges: Array<NonEnrolledReasonEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subscribed: Array<User>;
  subscribedAggregate?: Maybe<NotificationUserSubscribedAggregationSelection>;
  subscribedConnection: NotificationSubscribedConnection;
  type: NotificationType;
};


export type NotificationSubscribedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type NotificationSubscribedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type NotificationSubscribedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<NotificationSubscribedConnectionSort>>;
  where?: InputMaybe<NotificationSubscribedConnectionWhere>;
};

export type NotificationAggregateSelection = {
  __typename?: 'NotificationAggregateSelection';
  count: Scalars['Int']['output'];
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type NotificationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NotificationSort objects to sort Notifications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NotificationSort>>;
};

/** Fields to sort Notifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one NotificationSort object. */
export type NotificationSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type NotificationSubscribedAggregateInput = {
  AND?: InputMaybe<Array<NotificationSubscribedAggregateInput>>;
  NOT?: InputMaybe<NotificationSubscribedAggregateInput>;
  OR?: InputMaybe<Array<NotificationSubscribedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<NotificationSubscribedNodeAggregationWhereInput>;
};

export type NotificationSubscribedConnection = {
  __typename?: 'NotificationSubscribedConnection';
  edges: Array<NotificationSubscribedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationSubscribedConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type NotificationSubscribedConnectionWhere = {
  AND?: InputMaybe<Array<NotificationSubscribedConnectionWhere>>;
  NOT?: InputMaybe<NotificationSubscribedConnectionWhere>;
  OR?: InputMaybe<Array<NotificationSubscribedConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type NotificationSubscribedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<NotificationSubscribedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<NotificationSubscribedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<NotificationSubscribedNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NotificationSubscribedRelationship = {
  __typename?: 'NotificationSubscribedRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export enum NotificationType {
  Individual = 'INDIVIDUAL'
}

export type NotificationUserSubscribedAggregationSelection = {
  __typename?: 'NotificationUserSubscribedAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<NotificationUserSubscribedNodeAggregateSelection>;
};

export type NotificationUserSubscribedNodeAggregateSelection = {
  __typename?: 'NotificationUserSubscribedNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type NotificationWhere = {
  AND?: InputMaybe<Array<NotificationWhere>>;
  NOT?: InputMaybe<NotificationWhere>;
  OR?: InputMaybe<Array<NotificationWhere>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subscribedAggregate?: InputMaybe<NotificationSubscribedAggregateInput>;
  /** Return Notifications where all of the related NotificationSubscribedConnections match this filter */
  subscribedConnection_ALL?: InputMaybe<NotificationSubscribedConnectionWhere>;
  /** Return Notifications where none of the related NotificationSubscribedConnections match this filter */
  subscribedConnection_NONE?: InputMaybe<NotificationSubscribedConnectionWhere>;
  /** Return Notifications where one of the related NotificationSubscribedConnections match this filter */
  subscribedConnection_SINGLE?: InputMaybe<NotificationSubscribedConnectionWhere>;
  /** Return Notifications where some of the related NotificationSubscribedConnections match this filter */
  subscribedConnection_SOME?: InputMaybe<NotificationSubscribedConnectionWhere>;
  /** Return Notifications where all of the related Users match this filter */
  subscribed_ALL?: InputMaybe<UserWhere>;
  /** Return Notifications where none of the related Users match this filter */
  subscribed_NONE?: InputMaybe<UserWhere>;
  /** Return Notifications where one of the related Users match this filter */
  subscribed_SINGLE?: InputMaybe<UserWhere>;
  /** Return Notifications where some of the related Users match this filter */
  subscribed_SOME?: InputMaybe<UserWhere>;
  type?: InputMaybe<NotificationType>;
  type_IN?: InputMaybe<Array<NotificationType>>;
};

export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NumericRange = {
  __typename?: 'NumericRange';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type NumericRangeAggregateSelection = {
  __typename?: 'NumericRangeAggregateSelection';
  count: IntAggregateSelectionNonNullable;
  end: IntAggregateSelectionNonNullable;
  start: IntAggregateSelectionNonNullable;
};

export type NumericRangeEdge = {
  __typename?: 'NumericRangeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NumericRange;
};

export type NumericRangeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more NumericRangeSort objects to sort NumericRanges by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<NumericRangeSort>>;
};

/** Fields to sort NumericRanges by. The order in which sorts are applied is not guaranteed when specifying many fields in one NumericRangeSort object. */
export type NumericRangeSort = {
  count?: InputMaybe<SortDirection>;
  end?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
};

export type NumericRangeWhere = {
  AND?: InputMaybe<Array<NumericRangeWhere>>;
  NOT?: InputMaybe<NumericRangeWhere>;
  OR?: InputMaybe<Array<NumericRangeWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  end_GT?: InputMaybe<Scalars['Int']['input']>;
  end_GTE?: InputMaybe<Scalars['Int']['input']>;
  end_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  end_LT?: InputMaybe<Scalars['Int']['input']>;
  end_LTE?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  start_GT?: InputMaybe<Scalars['Int']['input']>;
  start_GTE?: InputMaybe<Scalars['Int']['input']>;
  start_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  start_LT?: InputMaybe<Scalars['Int']['input']>;
  start_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type NumericRangesConnection = {
  __typename?: 'NumericRangesConnection';
  edges: Array<NumericRangeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum Occurrence {
  ForTheFirstTime = 'FOR_THE_FIRST_TIME',
  ForTheFourthTime = 'FOR_THE_FOURTH_TIME',
  ForTheSecondTime = 'FOR_THE_SECOND_TIME',
  ForTheThirdTime = 'FOR_THE_THIRD_TIME'
}

export enum OccurrenceEnum {
  AutoGenerated = 'AUTO_GENERATED',
  FormEntry = 'FORM_ENTRY',
  FormUpload = 'FORM_UPLOAD',
  RecordEntry = 'RECORD_ENTRY',
  RecordImport = 'RECORD_IMPORT',
  RecordUpload = 'RECORD_UPLOAD'
}

export type OrgSettingsDataFilterInput = {
  domains: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']>;
  users: Array<Scalars['String']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  BIC?: Maybe<Scalars['String']['output']>;
  IBAN?: Maybe<Scalars['String']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  aggregationPriority?: Maybe<Scalars['Int']['output']>;
  agreementRunAttempts: Array<AgreementRunAttemptInfo>;
  agreementRunAttemptsAggregate?: Maybe<OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection>;
  agreementRunAttemptsConnection: OrganizationAgreementRunAttemptsConnection;
  agreementRunTriggers: Array<AgreementRunTrigger>;
  agreementTagNames: Array<Scalars['String']['output']>;
  agreements: Array<Agreement>;
  agreementsAggregate?: Maybe<OrganizationAgreementAgreementsAggregationSelection>;
  agreementsConnection: OrganizationAgreementsConnection;
  autoIssuanceDelay?: Maybe<Scalars['Float']['output']>;
  autoIssuanceThreshold?: Maybe<Scalars['Float']['output']>;
  automatedRunFrequency: AgreementRunFrequency;
  billingAddress?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactOccupation?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryAggregate?: Maybe<OrganizationCountryCountryAggregationSelection>;
  countryConnection: OrganizationCountryConnection;
  createdOn?: Maybe<Scalars['Float']['output']>;
  currencyCodes: Array<Currency>;
  customTranslations?: Maybe<Array<Maybe<Translations>>>;
  defaultReceivers: Array<Organization>;
  defaultReceiversAggregate?: Maybe<OrganizationOrganizationDefaultReceiversAggregationSelection>;
  defaultReceiversConnection: OrganizationDefaultReceiversConnection;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  documentReviewReminderDelay?: Maybe<Scalars['Float']['output']>;
  documentReviewReminderRecurrentStep?: Maybe<Scalars['Float']['output']>;
  documentSftpSavePath?: Maybe<Scalars['String']['output']>;
  domicile?: Maybe<Scalars['String']['output']>;
  downloadPAFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  dualApprovalThreshold?: Maybe<Scalars['Int']['output']>;
  eIN?: Maybe<Scalars['String']['output']>;
  encapsulatedFeatures: Array<EncapsulatedFeatureConfiguration>;
  encapsulatedFeaturesAggregate?: Maybe<OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection>;
  encapsulatedFeaturesConnection: OrganizationEncapsulatedFeaturesConnection;
  fax?: Maybe<Scalars['String']['output']>;
  flexEntityTypeMappings: Array<FlexEntityType>;
  flexEntityTypeMappingsAggregate?: Maybe<OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection>;
  flexEntityTypeMappingsConnection: OrganizationFlexEntityTypeMappingsConnection;
  id: Scalars['ID']['output'];
  isCaseAutomaticDiscontinuationAllowed?: Maybe<Scalars['Boolean']['output']>;
  isExternalExposureAllowed?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  libraryGPTFeatureEnabled?: Maybe<Scalars['Boolean']['output']>;
  libraryNavlinPricesEnabled?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  paymentTerms: Scalars['Int']['output'];
  pharmaId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  questNotifications: Array<QuestNotification>;
  questNotificationsAggregate?: Maybe<OrganizationQuestNotificationQuestNotificationsAggregationSelection>;
  questNotificationsConnection: OrganizationQuestNotificationsConnection;
  rebateProcessorId?: Maybe<Scalars['String']['output']>;
  simulatorBreakdownEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorModelValidityEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorPVThresholdsEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorProductInputEnabled?: Maybe<Scalars['Boolean']['output']>;
  simulatorWasteReportingEnabled?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  validityCoverageEnabled?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type OrganizationAgreementRunAttemptsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementRunAttemptInfoOptions>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type OrganizationAgreementRunAttemptsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type OrganizationAgreementRunAttemptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationAgreementRunAttemptsConnectionSort>>;
  where?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
};


export type OrganizationAgreementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type OrganizationAgreementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type OrganizationAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationAgreementsConnectionSort>>;
  where?: InputMaybe<OrganizationAgreementsConnectionWhere>;
};


export type OrganizationCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type OrganizationCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type OrganizationCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationCountryConnectionSort>>;
  where?: InputMaybe<OrganizationCountryConnectionWhere>;
};


export type OrganizationDefaultReceiversArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type OrganizationDefaultReceiversAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type OrganizationDefaultReceiversConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationDefaultReceiversConnectionSort>>;
  where?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
};


export type OrganizationEncapsulatedFeaturesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<EncapsulatedFeatureConfigurationOptions>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type OrganizationEncapsulatedFeaturesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type OrganizationEncapsulatedFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationEncapsulatedFeaturesConnectionSort>>;
  where?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
};


export type OrganizationFlexEntityTypeMappingsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type OrganizationFlexEntityTypeMappingsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type OrganizationFlexEntityTypeMappingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsConnectionSort>>;
  where?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
};


export type OrganizationQuestNotificationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestNotificationOptions>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type OrganizationQuestNotificationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type OrganizationQuestNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<OrganizationQuestNotificationsConnectionSort>>;
  where?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
};

export type OrganizationAggregateSelection = {
  __typename?: 'OrganizationAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type OrganizationAgreementAgreementsAggregationSelection = {
  __typename?: 'OrganizationAgreementAgreementsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationAgreementAgreementsNodeAggregateSelection>;
};

export type OrganizationAgreementAgreementsNodeAggregateSelection = {
  __typename?: 'OrganizationAgreementAgreementsNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection = {
  __typename?: 'OrganizationAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection>;
};

export type OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection = {
  __typename?: 'OrganizationAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection';
  attemptedAgreementCount: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  filtersAppliedForRun: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  nonAttemptedAgreementCount: IntAggregateSelectionNullable;
  runEnd: DateTimeAggregateSelectionNullable;
  runStart: DateTimeAggregateSelectionNullable;
  succeededCount: IntAggregateSelectionNullable;
};

export type OrganizationAgreementRunAttemptsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationAgreementRunAttemptsAggregateInput>>;
  NOT?: InputMaybe<OrganizationAgreementRunAttemptsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationAgreementRunAttemptsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>;
};

export type OrganizationAgreementRunAttemptsConnection = {
  __typename?: 'OrganizationAgreementRunAttemptsConnection';
  edges: Array<OrganizationAgreementRunAttemptsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationAgreementRunAttemptsConnectionSort = {
  node?: InputMaybe<AgreementRunAttemptInfoSort>;
};

export type OrganizationAgreementRunAttemptsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationAgreementRunAttemptsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationAgreementRunAttemptsConnectionWhere>>;
  node?: InputMaybe<AgreementRunAttemptInfoWhere>;
};

export type OrganizationAgreementRunAttemptsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationAgreementRunAttemptsNodeAggregationWhereInput>>;
  attemptedAgreementCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  runEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  succeededCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationAgreementRunAttemptsRelationship = {
  __typename?: 'OrganizationAgreementRunAttemptsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementRunAttemptInfo;
};

export type OrganizationAgreementsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationAgreementsAggregateInput>>;
  NOT?: InputMaybe<OrganizationAgreementsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationAgreementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationAgreementsNodeAggregationWhereInput>;
};

export type OrganizationAgreementsConnection = {
  __typename?: 'OrganizationAgreementsConnection';
  edges: Array<OrganizationAgreementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationAgreementsConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type OrganizationAgreementsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationAgreementsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationAgreementsConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type OrganizationAgreementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationAgreementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationAgreementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationAgreementsNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationAgreementsRelationship = {
  __typename?: 'OrganizationAgreementsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type OrganizationCaselessAgreementStatus = {
  __typename?: 'OrganizationCaselessAgreementStatus';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  hasOnlyCaselessAgreements: Scalars['Boolean']['output'];
  hasOnlyPatientAgreements: Scalars['Boolean']['output'];
};

export type OrganizationCaselessAgreementStatusAggregateSelection = {
  __typename?: 'OrganizationCaselessAgreementStatusAggregateSelection';
  count: Scalars['Int']['output'];
};

export type OrganizationCaselessAgreementStatusEdge = {
  __typename?: 'OrganizationCaselessAgreementStatusEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: OrganizationCaselessAgreementStatus;
};

export type OrganizationCaselessAgreementStatusOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationCaselessAgreementStatusSort objects to sort OrganizationCaselessAgreementStatuses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationCaselessAgreementStatusSort>>;
};

/** Fields to sort OrganizationCaselessAgreementStatuses by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationCaselessAgreementStatusSort object. */
export type OrganizationCaselessAgreementStatusSort = {
  hasOnlyCaselessAgreements?: InputMaybe<SortDirection>;
  hasOnlyPatientAgreements?: InputMaybe<SortDirection>;
};

export type OrganizationCaselessAgreementStatusWhere = {
  AND?: InputMaybe<Array<OrganizationCaselessAgreementStatusWhere>>;
  NOT?: InputMaybe<OrganizationCaselessAgreementStatusWhere>;
  OR?: InputMaybe<Array<OrganizationCaselessAgreementStatusWhere>>;
  hasOnlyCaselessAgreements?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnlyPatientAgreements?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationCaselessAgreementStatusesConnection = {
  __typename?: 'OrganizationCaselessAgreementStatusesConnection';
  edges: Array<OrganizationCaselessAgreementStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationCountryAggregateInput = {
  AND?: InputMaybe<Array<OrganizationCountryAggregateInput>>;
  NOT?: InputMaybe<OrganizationCountryAggregateInput>;
  OR?: InputMaybe<Array<OrganizationCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationCountryNodeAggregationWhereInput>;
};

export type OrganizationCountryConnection = {
  __typename?: 'OrganizationCountryConnection';
  edges: Array<OrganizationCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type OrganizationCountryConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationCountryConnectionWhere>>;
  NOT?: InputMaybe<OrganizationCountryConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type OrganizationCountryCountryAggregationSelection = {
  __typename?: 'OrganizationCountryCountryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationCountryCountryNodeAggregateSelection>;
};

export type OrganizationCountryCountryNodeAggregateSelection = {
  __typename?: 'OrganizationCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type OrganizationCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationCountryRelationship = {
  __typename?: 'OrganizationCountryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type OrganizationDefaultReceiversAggregateInput = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversAggregateInput>>;
  NOT?: InputMaybe<OrganizationDefaultReceiversAggregateInput>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrganizationDefaultReceiversEdgeAggregationWhereInput>;
  node?: InputMaybe<OrganizationDefaultReceiversNodeAggregationWhereInput>;
};

export type OrganizationDefaultReceiversConnection = {
  __typename?: 'OrganizationDefaultReceiversConnection';
  edges: Array<OrganizationDefaultReceiversRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationDefaultReceiversConnectionSort = {
  edge?: InputMaybe<DefaultReceiverPropertiesSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type OrganizationDefaultReceiversConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversConnectionWhere>>;
  NOT?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversConnectionWhere>>;
  edge?: InputMaybe<DefaultReceiverPropertiesWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type OrganizationDefaultReceiversEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationDefaultReceiversEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversEdgeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  notificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  notificationId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationDefaultReceiversNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationDefaultReceiversNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<OrganizationDefaultReceiversNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationDefaultReceiversNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationDefaultReceiversRelationship = DefaultReceiverProperties & {
  __typename?: 'OrganizationDefaultReceiversRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  email: Scalars['String']['output'];
  node: Organization;
  notificationId: Scalars['Int']['output'];
  tagType: AgreementTagType;
};

export type OrganizationDomainsWithCounters = {
  __typename?: 'OrganizationDomainsWithCounters';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  domains: Array<Domain>;
  names: Array<Scalars['String']['output']>;
};

export type OrganizationDomainsWithCountersAggregateSelection = {
  __typename?: 'OrganizationDomainsWithCountersAggregateSelection';
  count: Scalars['Int']['output'];
};

export type OrganizationDomainsWithCountersConnection = {
  __typename?: 'OrganizationDomainsWithCountersConnection';
  edges: Array<OrganizationDomainsWithCountersEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationDomainsWithCountersEdge = {
  __typename?: 'OrganizationDomainsWithCountersEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: OrganizationDomainsWithCounters;
};

export type OrganizationDomainsWithCountersOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationDomainsWithCountersWhere = {
  AND?: InputMaybe<Array<OrganizationDomainsWithCountersWhere>>;
  NOT?: InputMaybe<OrganizationDomainsWithCountersWhere>;
  OR?: InputMaybe<Array<OrganizationDomainsWithCountersWhere>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  names_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection = {
  __typename?: 'OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection>;
};

export type OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection = {
  __typename?: 'OrganizationEncapsulatedFeatureConfigurationEncapsulatedFeaturesNodeAggregateSelection';
  value: StringAggregateSelectionNullable;
};

export type OrganizationEncapsulatedFeaturesAggregateInput = {
  AND?: InputMaybe<Array<OrganizationEncapsulatedFeaturesAggregateInput>>;
  NOT?: InputMaybe<OrganizationEncapsulatedFeaturesAggregateInput>;
  OR?: InputMaybe<Array<OrganizationEncapsulatedFeaturesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>;
};

export type OrganizationEncapsulatedFeaturesConnection = {
  __typename?: 'OrganizationEncapsulatedFeaturesConnection';
  edges: Array<OrganizationEncapsulatedFeaturesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEncapsulatedFeaturesConnectionSort = {
  node?: InputMaybe<EncapsulatedFeatureConfigurationSort>;
};

export type OrganizationEncapsulatedFeaturesConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationEncapsulatedFeaturesConnectionWhere>>;
  NOT?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationEncapsulatedFeaturesConnectionWhere>>;
  node?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};

export type OrganizationEncapsulatedFeaturesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationEncapsulatedFeaturesNodeAggregationWhereInput>>;
  value_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  value_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationEncapsulatedFeaturesRelationship = {
  __typename?: 'OrganizationEncapsulatedFeaturesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: EncapsulatedFeatureConfiguration;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection = {
  __typename?: 'OrganizationFlexEntityTypeFlexEntityTypeMappingsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection>;
  node?: Maybe<OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection>;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection = {
  __typename?: 'OrganizationFlexEntityTypeFlexEntityTypeMappingsEdgeAggregateSelection';
  data: StringAggregateSelectionNullable;
};

export type OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection = {
  __typename?: 'OrganizationFlexEntityTypeFlexEntityTypeMappingsNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  attributeCount: IntAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  idPrefix: StringAggregateSelectionNonNullable;
  localizationKey: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tooltipText: StringAggregateSelectionNullable;
};

export type OrganizationFlexEntityTypeMappingsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsAggregateInput>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>;
  node?: InputMaybe<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>;
};

export type OrganizationFlexEntityTypeMappingsConnection = {
  __typename?: 'OrganizationFlexEntityTypeMappingsConnection';
  edges: Array<OrganizationFlexEntityTypeMappingsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationFlexEntityTypeMappingsConnectionSort = {
  edge?: InputMaybe<EntityTypeMappingRelationshipSort>;
  node?: InputMaybe<FlexEntityTypeSort>;
};

export type OrganizationFlexEntityTypeMappingsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsConnectionWhere>>;
  edge?: InputMaybe<EntityTypeMappingRelationshipWhere>;
  node?: InputMaybe<FlexEntityTypeWhere>;
};

export type OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsEdgeAggregationWhereInput>>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationFlexEntityTypeMappingsNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attributeCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attributeCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  idPrefix_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  idPrefix_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  localizationKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  localizationKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tooltipText_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tooltipText_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationFlexEntityTypeMappingsRelationship = EntityTypeMappingRelationship & {
  __typename?: 'OrganizationFlexEntityTypeMappingsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  node: FlexEntityType;
};

export type OrganizationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationSort objects to sort Organizations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationSort>>;
};

export type OrganizationOrganizationDefaultReceiversAggregationSelection = {
  __typename?: 'OrganizationOrganizationDefaultReceiversAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<OrganizationOrganizationDefaultReceiversEdgeAggregateSelection>;
  node?: Maybe<OrganizationOrganizationDefaultReceiversNodeAggregateSelection>;
};

export type OrganizationOrganizationDefaultReceiversEdgeAggregateSelection = {
  __typename?: 'OrganizationOrganizationDefaultReceiversEdgeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  notificationId: IntAggregateSelectionNonNullable;
};

export type OrganizationOrganizationDefaultReceiversNodeAggregateSelection = {
  __typename?: 'OrganizationOrganizationDefaultReceiversNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

export type OrganizationQuestNotificationQuestNotificationsAggregationSelection = {
  __typename?: 'OrganizationQuestNotificationQuestNotificationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection>;
  node?: Maybe<OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection>;
};

export type OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection = {
  __typename?: 'OrganizationQuestNotificationQuestNotificationsEdgeAggregateSelection';
  autocompletionThreshold: IntAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
};

export type OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection = {
  __typename?: 'OrganizationQuestNotificationQuestNotificationsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type OrganizationQuestNotificationsAggregateInput = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsAggregateInput>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsAggregateInput>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<OrganizationQuestNotificationsEdgeAggregationWhereInput>;
  node?: InputMaybe<OrganizationQuestNotificationsNodeAggregationWhereInput>;
};

export type OrganizationQuestNotificationsConnection = {
  __typename?: 'OrganizationQuestNotificationsConnection';
  edges: Array<OrganizationQuestNotificationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationQuestNotificationsConnectionSort = {
  edge?: InputMaybe<OrganizationQuestRelationshipSort>;
  node?: InputMaybe<QuestNotificationSort>;
};

export type OrganizationQuestNotificationsConnectionWhere = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsConnectionWhere>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsConnectionWhere>>;
  edge?: InputMaybe<OrganizationQuestRelationshipWhere>;
  node?: InputMaybe<QuestNotificationWhere>;
};

export type OrganizationQuestNotificationsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsEdgeAggregationWhereInput>>;
  autocompletionThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationQuestNotificationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrganizationQuestNotificationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<OrganizationQuestNotificationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<OrganizationQuestNotificationsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationQuestNotificationsRelationship = OrganizationQuestRelationship & {
  __typename?: 'OrganizationQuestNotificationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  amountType?: Maybe<AmountsType>;
  autocompletionThreshold?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isAutocompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  node: QuestNotification;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationQuestRelationship = {
  active?: Maybe<Scalars['Boolean']['output']>;
  amountType?: Maybe<AmountsType>;
  autocompletionThreshold?: Maybe<Scalars['Int']['output']>;
  isAutocompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type OrganizationQuestRelationshipSort = {
  active?: InputMaybe<SortDirection>;
  amountType?: InputMaybe<SortDirection>;
  autocompletionThreshold?: InputMaybe<SortDirection>;
  isAutocompletionEnabled?: InputMaybe<SortDirection>;
  threshold?: InputMaybe<SortDirection>;
};

export type OrganizationQuestRelationshipWhere = {
  AND?: InputMaybe<Array<OrganizationQuestRelationshipWhere>>;
  NOT?: InputMaybe<OrganizationQuestRelationshipWhere>;
  OR?: InputMaybe<Array<OrganizationQuestRelationshipWhere>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amountType?: InputMaybe<AmountsType>;
  amountType_IN?: InputMaybe<Array<InputMaybe<AmountsType>>>;
  autocompletionThreshold?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  autocompletionThreshold_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_LTE?: InputMaybe<Scalars['Int']['input']>;
  isAutocompletionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  threshold_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  threshold_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationScope = {
  __typename?: 'OrganizationScope';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  orgId: Scalars['String']['output'];
  organizationScopeId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationScopeAggregateSelection = {
  __typename?: 'OrganizationScopeAggregateSelection';
  count: Scalars['Int']['output'];
  orgId: StringAggregateSelectionNonNullable;
  organizationScopeId: StringAggregateSelectionNullable;
};

export type OrganizationScopeEdge = {
  __typename?: 'OrganizationScopeEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: OrganizationScope;
};

export type OrganizationScopeOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OrganizationScopeSort objects to sort OrganizationScopes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OrganizationScopeSort>>;
};

export type OrganizationScopeRelationship = {
  organizationScopeId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationScopeRelationshipSort = {
  organizationScopeId?: InputMaybe<SortDirection>;
};

export type OrganizationScopeRelationshipWhere = {
  AND?: InputMaybe<Array<OrganizationScopeRelationshipWhere>>;
  NOT?: InputMaybe<OrganizationScopeRelationshipWhere>;
  OR?: InputMaybe<Array<OrganizationScopeRelationshipWhere>>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

/** Fields to sort OrganizationScopes by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationScopeSort object. */
export type OrganizationScopeSort = {
  orgId?: InputMaybe<SortDirection>;
  organizationScopeId?: InputMaybe<SortDirection>;
};

export type OrganizationScopeWhere = {
  AND?: InputMaybe<Array<OrganizationScopeWhere>>;
  NOT?: InputMaybe<OrganizationScopeWhere>;
  OR?: InputMaybe<Array<OrganizationScopeWhere>>;
  orgId?: InputMaybe<Scalars['String']['input']>;
  orgId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  orgId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  orgId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  orgId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  orgId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationScopesConnection = {
  __typename?: 'OrganizationScopesConnection';
  edges: Array<OrganizationScopeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Organizations by. The order in which sorts are applied is not guaranteed when specifying many fields in one OrganizationSort object. */
export type OrganizationSort = {
  BIC?: InputMaybe<SortDirection>;
  IBAN?: InputMaybe<SortDirection>;
  accountName?: InputMaybe<SortDirection>;
  accountNumber?: InputMaybe<SortDirection>;
  aggregationPriority?: InputMaybe<SortDirection>;
  autoIssuanceDelay?: InputMaybe<SortDirection>;
  autoIssuanceThreshold?: InputMaybe<SortDirection>;
  automatedRunFrequency?: InputMaybe<SortDirection>;
  billingAddress?: InputMaybe<SortDirection>;
  contactEmail?: InputMaybe<SortDirection>;
  contactFirstName?: InputMaybe<SortDirection>;
  contactLastName?: InputMaybe<SortDirection>;
  contactOccupation?: InputMaybe<SortDirection>;
  contactPhone?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  deliveryAddress?: InputMaybe<SortDirection>;
  documentReviewReminderDelay?: InputMaybe<SortDirection>;
  documentReviewReminderRecurrentStep?: InputMaybe<SortDirection>;
  documentSftpSavePath?: InputMaybe<SortDirection>;
  domicile?: InputMaybe<SortDirection>;
  downloadPAFeatureEnabled?: InputMaybe<SortDirection>;
  dualApprovalThreshold?: InputMaybe<SortDirection>;
  eIN?: InputMaybe<SortDirection>;
  fax?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isCaseAutomaticDiscontinuationAllowed?: InputMaybe<SortDirection>;
  isExternalExposureAllowed?: InputMaybe<SortDirection>;
  legalName?: InputMaybe<SortDirection>;
  libraryGPTFeatureEnabled?: InputMaybe<SortDirection>;
  libraryNavlinPricesEnabled?: InputMaybe<SortDirection>;
  logo?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  organizationId?: InputMaybe<SortDirection>;
  paymentTerms?: InputMaybe<SortDirection>;
  pharmaId?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
  rebateProcessorId?: InputMaybe<SortDirection>;
  simulatorBreakdownEnabled?: InputMaybe<SortDirection>;
  simulatorModelValidityEnabled?: InputMaybe<SortDirection>;
  simulatorPVThresholdsEnabled?: InputMaybe<SortDirection>;
  simulatorProductInputEnabled?: InputMaybe<SortDirection>;
  simulatorWasteReportingEnabled?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  validityCoverageEnabled?: InputMaybe<SortDirection>;
  website?: InputMaybe<SortDirection>;
};

export type OrganizationWhere = {
  AND?: InputMaybe<Array<OrganizationWhere>>;
  BIC?: InputMaybe<Scalars['String']['input']>;
  BIC_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  BIC_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  BIC_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  BIC_MATCHES?: InputMaybe<Scalars['String']['input']>;
  BIC_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  IBAN?: InputMaybe<Scalars['String']['input']>;
  IBAN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  IBAN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  IBAN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  IBAN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  IBAN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<OrganizationWhere>;
  OR?: InputMaybe<Array<OrganizationWhere>>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  accountName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  accountName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  accountName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  accountNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  accountNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  accountNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accountNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  accountNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  aggregationPriority?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  aggregationPriority_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementRunAttemptsAggregate?: InputMaybe<OrganizationAgreementRunAttemptsAggregateInput>;
  /** Return Organizations where all of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_ALL?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_NONE?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_SINGLE?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_SOME?: InputMaybe<OrganizationAgreementRunAttemptsConnectionWhere>;
  /** Return Organizations where all of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_ALL?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Organizations where none of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_NONE?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Organizations where one of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_SINGLE?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Organizations where some of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_SOME?: InputMaybe<AgreementRunAttemptInfoWhere>;
  agreementRunTriggers?: InputMaybe<Array<AgreementRunTrigger>>;
  agreementRunTriggers_INCLUDES?: InputMaybe<AgreementRunTrigger>;
  agreementsAggregate?: InputMaybe<OrganizationAgreementsAggregateInput>;
  /** Return Organizations where all of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_ALL?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_NONE?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_SINGLE?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationAgreementsConnections match this filter */
  agreementsConnection_SOME?: InputMaybe<OrganizationAgreementsConnectionWhere>;
  /** Return Organizations where all of the related Agreements match this filter */
  agreements_ALL?: InputMaybe<AgreementWhere>;
  /** Return Organizations where none of the related Agreements match this filter */
  agreements_NONE?: InputMaybe<AgreementWhere>;
  /** Return Organizations where one of the related Agreements match this filter */
  agreements_SINGLE?: InputMaybe<AgreementWhere>;
  /** Return Organizations where some of the related Agreements match this filter */
  agreements_SOME?: InputMaybe<AgreementWhere>;
  autoIssuanceDelay?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  autoIssuanceDelay_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  autoIssuanceThreshold_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_LTE?: InputMaybe<Scalars['Float']['input']>;
  automatedRunFrequency?: InputMaybe<AgreementRunFrequency>;
  automatedRunFrequency_IN?: InputMaybe<Array<AgreementRunFrequency>>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  billingAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  billingAddress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  billingAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactFirstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactFirstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactLastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactLastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactLastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactLastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactLastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactOccupation?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactOccupation_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactOccupation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  contactPhone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contactPhone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contactPhone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactPhone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contactPhone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<OrganizationCountryAggregateInput>;
  countryConnection?: InputMaybe<OrganizationCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<OrganizationCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  createdOn?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Float']['input']>;
  customTranslations?: InputMaybe<Array<InputMaybe<Translations>>>;
  customTranslations_INCLUDES?: InputMaybe<Translations>;
  defaultReceiversAggregate?: InputMaybe<OrganizationDefaultReceiversAggregateInput>;
  /** Return Organizations where all of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_ALL?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where none of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_NONE?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where one of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_SINGLE?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where some of the related OrganizationDefaultReceiversConnections match this filter */
  defaultReceiversConnection_SOME?: InputMaybe<OrganizationDefaultReceiversConnectionWhere>;
  /** Return Organizations where all of the related Organizations match this filter */
  defaultReceivers_ALL?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where none of the related Organizations match this filter */
  defaultReceivers_NONE?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where one of the related Organizations match this filter */
  defaultReceivers_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return Organizations where some of the related Organizations match this filter */
  defaultReceivers_SOME?: InputMaybe<OrganizationWhere>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryAddress_MATCHES?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewReminderDelay?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  documentReviewReminderDelay_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  documentReviewReminderRecurrentStep_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentSftpSavePath_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentSftpSavePath_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  domicile?: InputMaybe<Scalars['String']['input']>;
  domicile_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domicile_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domicile_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domicile_MATCHES?: InputMaybe<Scalars['String']['input']>;
  domicile_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  downloadPAFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dualApprovalThreshold?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dualApprovalThreshold_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN?: InputMaybe<Scalars['String']['input']>;
  eIN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  eIN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  eIN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eIN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  eIN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  encapsulatedFeaturesAggregate?: InputMaybe<OrganizationEncapsulatedFeaturesAggregateInput>;
  /** Return Organizations where all of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_ALL?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where none of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_NONE?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where one of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_SINGLE?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where some of the related OrganizationEncapsulatedFeaturesConnections match this filter */
  encapsulatedFeaturesConnection_SOME?: InputMaybe<OrganizationEncapsulatedFeaturesConnectionWhere>;
  /** Return Organizations where all of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_ALL?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  /** Return Organizations where none of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_NONE?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  /** Return Organizations where one of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_SINGLE?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  /** Return Organizations where some of the related EncapsulatedFeatureConfigurations match this filter */
  encapsulatedFeatures_SOME?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fax_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fax_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fax_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fax_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fax_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityTypeMappingsAggregate?: InputMaybe<OrganizationFlexEntityTypeMappingsAggregateInput>;
  /** Return Organizations where all of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_ALL?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_NONE?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_SINGLE?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationFlexEntityTypeMappingsConnections match this filter */
  flexEntityTypeMappingsConnection_SOME?: InputMaybe<OrganizationFlexEntityTypeMappingsConnectionWhere>;
  /** Return Organizations where all of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_ALL?: InputMaybe<FlexEntityTypeWhere>;
  /** Return Organizations where none of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_NONE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return Organizations where one of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_SINGLE?: InputMaybe<FlexEntityTypeWhere>;
  /** Return Organizations where some of the related FlexEntityTypes match this filter */
  flexEntityTypeMappings_SOME?: InputMaybe<FlexEntityTypeWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isCaseAutomaticDiscontinuationAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalExposureAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  legalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  legalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  libraryGPTFeatureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  libraryNavlinPricesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  logo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  logo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  logo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  logo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  organizationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  organizationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  organizationId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  organizationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  paymentTerms?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  paymentTerms_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId?: InputMaybe<Scalars['String']['input']>;
  pharmaId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pharmaId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pharmaId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pharmaId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  pharmaId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  phone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questNotificationsAggregate?: InputMaybe<OrganizationQuestNotificationsAggregateInput>;
  /** Return Organizations where all of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_ALL?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where none of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_NONE?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where one of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_SINGLE?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where some of the related OrganizationQuestNotificationsConnections match this filter */
  questNotificationsConnection_SOME?: InputMaybe<OrganizationQuestNotificationsConnectionWhere>;
  /** Return Organizations where all of the related QuestNotifications match this filter */
  questNotifications_ALL?: InputMaybe<QuestNotificationWhere>;
  /** Return Organizations where none of the related QuestNotifications match this filter */
  questNotifications_NONE?: InputMaybe<QuestNotificationWhere>;
  /** Return Organizations where one of the related QuestNotifications match this filter */
  questNotifications_SINGLE?: InputMaybe<QuestNotificationWhere>;
  /** Return Organizations where some of the related QuestNotifications match this filter */
  questNotifications_SOME?: InputMaybe<QuestNotificationWhere>;
  rebateProcessorId?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rebateProcessorId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rebateProcessorId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  simulatorBreakdownEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorModelValidityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorPVThresholdsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorProductInputEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  simulatorWasteReportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  validityCoverageEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  website_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  website_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  website_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  website_MATCHES?: InputMaybe<Scalars['String']['input']>;
  website_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum OutcomeBasedStatus {
  NonTreatmentRelated = 'NON_TREATMENT_RELATED',
  TreatmentRelated = 'TREATMENT_RELATED'
}

export type OutcomebasedAgreementReport = {
  __typename?: 'OutcomebasedAgreementReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEventsOccurenceData: Array<AdverseEventsOccurenceReport>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountDelta?: Maybe<Scalars['Float']['output']>;
  discountRatio?: Maybe<Scalars['Float']['output']>;
  discountRatioDelta?: Maybe<Scalars['Float']['output']>;
  discountsPerCase?: Maybe<Scalars['Float']['output']>;
  discountsPerCaseDiscontinued?: Maybe<Scalars['Float']['output']>;
  durationMonths?: Maybe<Scalars['Int']['output']>;
  durationMonthsDiscontinued?: Maybe<Scalars['Int']['output']>;
  financialSummaryRows: Array<FinancialSummaryRow>;
  grossAmountPerCase?: Maybe<Scalars['Float']['output']>;
  grossAmountPerCaseDiscontinued?: Maybe<Scalars['Float']['output']>;
  initialResponseReviewData: Array<InitialResponseReviewReport>;
  netAmountPerCase?: Maybe<Scalars['Float']['output']>;
  netAmountPerCaseDiscontinued?: Maybe<Scalars['Float']['output']>;
  patientReportDataPoints: Array<PatientReportDataPoint>;
  patientsWithAE?: Maybe<Scalars['Float']['output']>;
  progressionFreePatients?: Maybe<Scalars['Float']['output']>;
  reasonOfTreatmentDiscontinuationData: Array<ReasonOfTreatmentDiscontinuationReport>;
  totalPatients?: Maybe<Scalars['Int']['output']>;
  totalResponse?: Maybe<Scalars['Int']['output']>;
  treatmentDurationData: Array<CaseReportDataPoint>;
};

export type OutcomebasedAgreementReportAggregateSelection = {
  __typename?: 'OutcomebasedAgreementReportAggregateSelection';
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNullable;
  discountAmountDelta: FloatAggregateSelectionNullable;
  discountRatio: FloatAggregateSelectionNullable;
  discountRatioDelta: FloatAggregateSelectionNullable;
  discountsPerCase: FloatAggregateSelectionNullable;
  discountsPerCaseDiscontinued: FloatAggregateSelectionNullable;
  durationMonths: IntAggregateSelectionNullable;
  durationMonthsDiscontinued: IntAggregateSelectionNullable;
  grossAmountPerCase: FloatAggregateSelectionNullable;
  grossAmountPerCaseDiscontinued: FloatAggregateSelectionNullable;
  netAmountPerCase: FloatAggregateSelectionNullable;
  netAmountPerCaseDiscontinued: FloatAggregateSelectionNullable;
  patientsWithAE: FloatAggregateSelectionNullable;
  progressionFreePatients: FloatAggregateSelectionNullable;
  totalPatients: IntAggregateSelectionNullable;
  totalResponse: IntAggregateSelectionNullable;
};

export type OutcomebasedAgreementReportEdge = {
  __typename?: 'OutcomebasedAgreementReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: OutcomebasedAgreementReport;
};

export type OutcomebasedAgreementReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more OutcomebasedAgreementReportSort objects to sort OutcomebasedAgreementReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<OutcomebasedAgreementReportSort>>;
};

/** Fields to sort OutcomebasedAgreementReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one OutcomebasedAgreementReportSort object. */
export type OutcomebasedAgreementReportSort = {
  discountAmount?: InputMaybe<SortDirection>;
  discountAmountDelta?: InputMaybe<SortDirection>;
  discountRatio?: InputMaybe<SortDirection>;
  discountRatioDelta?: InputMaybe<SortDirection>;
  discountsPerCase?: InputMaybe<SortDirection>;
  discountsPerCaseDiscontinued?: InputMaybe<SortDirection>;
  durationMonths?: InputMaybe<SortDirection>;
  durationMonthsDiscontinued?: InputMaybe<SortDirection>;
  grossAmountPerCase?: InputMaybe<SortDirection>;
  grossAmountPerCaseDiscontinued?: InputMaybe<SortDirection>;
  netAmountPerCase?: InputMaybe<SortDirection>;
  netAmountPerCaseDiscontinued?: InputMaybe<SortDirection>;
  patientsWithAE?: InputMaybe<SortDirection>;
  progressionFreePatients?: InputMaybe<SortDirection>;
  totalPatients?: InputMaybe<SortDirection>;
  totalResponse?: InputMaybe<SortDirection>;
};

export type OutcomebasedAgreementReportWhere = {
  AND?: InputMaybe<Array<OutcomebasedAgreementReportWhere>>;
  NOT?: InputMaybe<OutcomebasedAgreementReportWhere>;
  OR?: InputMaybe<Array<OutcomebasedAgreementReportWhere>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatioDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatio_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCase?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCaseDiscontinued?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCaseDiscontinued_GT?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCaseDiscontinued_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountsPerCaseDiscontinued_LT?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCaseDiscontinued_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCase_GT?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCase_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountsPerCase_LT?: InputMaybe<Scalars['Float']['input']>;
  discountsPerCase_LTE?: InputMaybe<Scalars['Float']['input']>;
  durationMonths?: InputMaybe<Scalars['Int']['input']>;
  durationMonthsDiscontinued?: InputMaybe<Scalars['Int']['input']>;
  durationMonthsDiscontinued_GT?: InputMaybe<Scalars['Int']['input']>;
  durationMonthsDiscontinued_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationMonthsDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationMonthsDiscontinued_LT?: InputMaybe<Scalars['Int']['input']>;
  durationMonthsDiscontinued_LTE?: InputMaybe<Scalars['Int']['input']>;
  durationMonths_GT?: InputMaybe<Scalars['Int']['input']>;
  durationMonths_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationMonths_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationMonths_LT?: InputMaybe<Scalars['Int']['input']>;
  durationMonths_LTE?: InputMaybe<Scalars['Int']['input']>;
  grossAmountPerCase?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCaseDiscontinued?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCaseDiscontinued_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCaseDiscontinued_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmountPerCaseDiscontinued_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCaseDiscontinued_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCase_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCase_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmountPerCase_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountPerCase_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCase?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCaseDiscontinued?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCaseDiscontinued_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCaseDiscontinued_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCaseDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  netAmountPerCaseDiscontinued_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCaseDiscontinued_LTE?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCase_GT?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCase_GTE?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  netAmountPerCase_LT?: InputMaybe<Scalars['Float']['input']>;
  netAmountPerCase_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_GT?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  patientsWithAE_LT?: InputMaybe<Scalars['Float']['input']>;
  patientsWithAE_LTE?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_GT?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_GTE?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  progressionFreePatients_LT?: InputMaybe<Scalars['Float']['input']>;
  progressionFreePatients_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalPatients?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_GT?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalPatients_LT?: InputMaybe<Scalars['Int']['input']>;
  totalPatients_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalResponse?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_GT?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalResponse_LT?: InputMaybe<Scalars['Int']['input']>;
  totalResponse_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type OutcomebasedAgreementReportsConnection = {
  __typename?: 'OutcomebasedAgreementReportsConnection';
  edges: Array<OutcomebasedAgreementReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PiRecurrenceSiDataPoint = {
  __typename?: 'PIRecurrenceSIDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  averagePIToRecurrence: Scalars['Float']['output'];
  averageRecurrenceToSI: Scalars['Float']['output'];
  isConditionMet: Scalars['Boolean']['output'];
};

export type PiRecurrenceSiDataPointAggregateSelection = {
  __typename?: 'PIRecurrenceSIDataPointAggregateSelection';
  averagePIToRecurrence: FloatAggregateSelectionNonNullable;
  averageRecurrenceToSI: FloatAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
};

export type PiRecurrenceSiDataPointEdge = {
  __typename?: 'PIRecurrenceSIDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PiRecurrenceSiDataPoint;
};

export type PiRecurrenceSiDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PIRecurrenceSIDataPointSort objects to sort PiRecurrenceSiDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PiRecurrenceSiDataPointSort>>;
};

/** Fields to sort PiRecurrenceSiDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PIRecurrenceSIDataPointSort object. */
export type PiRecurrenceSiDataPointSort = {
  averagePIToRecurrence?: InputMaybe<SortDirection>;
  averageRecurrenceToSI?: InputMaybe<SortDirection>;
  isConditionMet?: InputMaybe<SortDirection>;
};

export type PiRecurrenceSiDataPointWhere = {
  AND?: InputMaybe<Array<PiRecurrenceSiDataPointWhere>>;
  NOT?: InputMaybe<PiRecurrenceSiDataPointWhere>;
  OR?: InputMaybe<Array<PiRecurrenceSiDataPointWhere>>;
  averagePIToRecurrence?: InputMaybe<Scalars['Float']['input']>;
  averagePIToRecurrence_GT?: InputMaybe<Scalars['Float']['input']>;
  averagePIToRecurrence_GTE?: InputMaybe<Scalars['Float']['input']>;
  averagePIToRecurrence_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  averagePIToRecurrence_LT?: InputMaybe<Scalars['Float']['input']>;
  averagePIToRecurrence_LTE?: InputMaybe<Scalars['Float']['input']>;
  averageRecurrenceToSI?: InputMaybe<Scalars['Float']['input']>;
  averageRecurrenceToSI_GT?: InputMaybe<Scalars['Float']['input']>;
  averageRecurrenceToSI_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageRecurrenceToSI_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  averageRecurrenceToSI_LT?: InputMaybe<Scalars['Float']['input']>;
  averageRecurrenceToSI_LTE?: InputMaybe<Scalars['Float']['input']>;
  isConditionMet?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PackOptionType {
  Specific = 'SPECIFIC',
  Whole = 'WHOLE'
}

export enum PackVolumeUoMType {
  Stk = 'Stk'
}

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  Description?: Maybe<Scalars['String']['output']>;
  PartnerType?: Maybe<Scalars['String']['output']>;
  Phone?: Maybe<Scalars['String']['output']>;
  Place?: Maybe<Scalars['String']['output']>;
  Street?: Maybe<Scalars['String']['output']>;
  ZipCode?: Maybe<Scalars['Int']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentAggregate?: Maybe<PartnerTreatmentTreatmentAggregationSelection>;
  treatmentConnection: PartnerTreatmentConnection;
};


export type PartnerTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PartnerTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PartnerTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PartnerTreatmentConnectionSort>>;
  where?: InputMaybe<PartnerTreatmentConnectionWhere>;
};

export type PartnerAggregateSelection = {
  __typename?: 'PartnerAggregateSelection';
  Description: StringAggregateSelectionNullable;
  PartnerType: StringAggregateSelectionNullable;
  Phone: StringAggregateSelectionNullable;
  Place: StringAggregateSelectionNullable;
  Street: StringAggregateSelectionNullable;
  ZipCode: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Partner;
};

export type PartnerOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PartnerSort objects to sort Partners by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PartnerSort>>;
};

/** Fields to sort Partners by. The order in which sorts are applied is not guaranteed when specifying many fields in one PartnerSort object. */
export type PartnerSort = {
  Description?: InputMaybe<SortDirection>;
  PartnerType?: InputMaybe<SortDirection>;
  Phone?: InputMaybe<SortDirection>;
  Place?: InputMaybe<SortDirection>;
  Street?: InputMaybe<SortDirection>;
  ZipCode?: InputMaybe<SortDirection>;
};

export type PartnerTreatmentAggregateInput = {
  AND?: InputMaybe<Array<PartnerTreatmentAggregateInput>>;
  NOT?: InputMaybe<PartnerTreatmentAggregateInput>;
  OR?: InputMaybe<Array<PartnerTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PartnerTreatmentNodeAggregationWhereInput>;
};

export type PartnerTreatmentConnection = {
  __typename?: 'PartnerTreatmentConnection';
  edges: Array<PartnerTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PartnerTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type PartnerTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<PartnerTreatmentConnectionWhere>>;
  NOT?: InputMaybe<PartnerTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<PartnerTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type PartnerTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PartnerTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PartnerTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PartnerTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PartnerTreatmentRelationship = {
  __typename?: 'PartnerTreatmentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type PartnerTreatmentTreatmentAggregationSelection = {
  __typename?: 'PartnerTreatmentTreatmentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PartnerTreatmentTreatmentNodeAggregateSelection>;
};

export type PartnerTreatmentTreatmentNodeAggregateSelection = {
  __typename?: 'PartnerTreatmentTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type PartnerWhere = {
  AND?: InputMaybe<Array<PartnerWhere>>;
  Description?: InputMaybe<Scalars['String']['input']>;
  Description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<PartnerWhere>;
  OR?: InputMaybe<Array<PartnerWhere>>;
  PartnerType?: InputMaybe<Scalars['String']['input']>;
  PartnerType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PartnerType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PartnerType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PartnerType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PartnerType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Phone?: InputMaybe<Scalars['String']['input']>;
  Phone_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Phone_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Phone_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Phone_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Phone_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Place?: InputMaybe<Scalars['String']['input']>;
  Place_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Place_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Place_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Place_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Place_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Street?: InputMaybe<Scalars['String']['input']>;
  Street_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Street_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Street_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Street_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Street_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ZipCode?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ZipCode_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatment?: InputMaybe<TreatmentWhere>;
  treatmentAggregate?: InputMaybe<PartnerTreatmentAggregateInput>;
  treatmentConnection?: InputMaybe<PartnerTreatmentConnectionWhere>;
  treatmentConnection_NOT?: InputMaybe<PartnerTreatmentConnectionWhere>;
  treatment_NOT?: InputMaybe<TreatmentWhere>;
};

export type PartnersConnection = {
  __typename?: 'PartnersConnection';
  edges: Array<PartnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum PatentStatus {
  NotValid = 'NOT_VALID',
  Valid = 'VALID'
}

export enum PathologicalResponseType {
  NoPcr = 'NO_PCR',
  Pcr = 'PCR'
}

export type Patient = {
  __typename?: 'Patient';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  assignedFlexEntities: Array<FlexEntity>;
  assignedFlexEntitiesAggregate?: Maybe<PatientFlexEntityAssignedFlexEntitiesAggregationSelection>;
  assignedFlexEntitiesConnection: PatientAssignedFlexEntitiesConnection;
  cases: Array<Case>;
  casesAggregate?: Maybe<PatientCaseCasesAggregationSelection>;
  casesConnection: PatientCasesConnection;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  insuranceId?: Maybe<Scalars['String']['output']>;
  lastUpdateDate: Scalars['DateTime']['output'];
  maxCoverageStartDate?: Maybe<Scalars['Date']['output']>;
  maxTherapyTrialStartDate?: Maybe<Scalars['Date']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  yearOfBirth?: Maybe<Scalars['Int']['output']>;
};


export type PatientAssignedFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PatientAssignedFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PatientAssignedFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionSort>>;
  where?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
};


export type PatientCasesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type PatientCasesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type PatientCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PatientCasesConnectionSort>>;
  where?: InputMaybe<PatientCasesConnectionWhere>;
};

export type PatientAggregateSelection = {
  __typename?: 'PatientAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  initials: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  yearOfBirth: IntAggregateSelectionNullable;
};

export type PatientAssignedFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<PatientAssignedFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<PatientAssignedFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<PatientAssignedFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PatientAssignedFlexEntitiesNodeAggregationWhereInput>;
};

export type PatientAssignedFlexEntitiesConnection = {
  __typename?: 'PatientAssignedFlexEntitiesConnection';
  edges: Array<PatientAssignedFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientAssignedFlexEntitiesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type PatientAssignedFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<PatientAssignedFlexEntitiesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type PatientAssignedFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PatientAssignedFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PatientAssignedFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PatientAssignedFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientAssignedFlexEntitiesRelationship = {
  __typename?: 'PatientAssignedFlexEntitiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type PatientCaseCasesAggregationSelection = {
  __typename?: 'PatientCaseCasesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PatientCaseCasesNodeAggregateSelection>;
};

export type PatientCaseCasesNodeAggregateSelection = {
  __typename?: 'PatientCaseCasesNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type PatientCasesAggregateInput = {
  AND?: InputMaybe<Array<PatientCasesAggregateInput>>;
  NOT?: InputMaybe<PatientCasesAggregateInput>;
  OR?: InputMaybe<Array<PatientCasesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PatientCasesNodeAggregationWhereInput>;
};

export type PatientCasesConnection = {
  __typename?: 'PatientCasesConnection';
  edges: Array<PatientCasesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientCasesConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type PatientCasesConnectionWhere = {
  AND?: InputMaybe<Array<PatientCasesConnectionWhere>>;
  NOT?: InputMaybe<PatientCasesConnectionWhere>;
  OR?: InputMaybe<Array<PatientCasesConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type PatientCasesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PatientCasesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PatientCasesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PatientCasesNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PatientCasesRelationship = {
  __typename?: 'PatientCasesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type PatientCountDataPoint = {
  __typename?: 'PatientCountDataPoint';
  PIAndSIPatientCount: Scalars['Int']['output'];
  PIOnlyPatientCount: Scalars['Int']['output'];
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  isConditionMet: Scalars['Boolean']['output'];
};

export type PatientCountDataPointAggregateSelection = {
  __typename?: 'PatientCountDataPointAggregateSelection';
  PIAndSIPatientCount: IntAggregateSelectionNonNullable;
  PIOnlyPatientCount: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
};

export type PatientCountDataPointEdge = {
  __typename?: 'PatientCountDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PatientCountDataPoint;
};

export type PatientCountDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientCountDataPointSort objects to sort PatientCountDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientCountDataPointSort>>;
};

/** Fields to sort PatientCountDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientCountDataPointSort object. */
export type PatientCountDataPointSort = {
  PIAndSIPatientCount?: InputMaybe<SortDirection>;
  PIOnlyPatientCount?: InputMaybe<SortDirection>;
  isConditionMet?: InputMaybe<SortDirection>;
};

export type PatientCountDataPointWhere = {
  AND?: InputMaybe<Array<PatientCountDataPointWhere>>;
  NOT?: InputMaybe<PatientCountDataPointWhere>;
  OR?: InputMaybe<Array<PatientCountDataPointWhere>>;
  PIAndSIPatientCount?: InputMaybe<Scalars['Int']['input']>;
  PIAndSIPatientCount_GT?: InputMaybe<Scalars['Int']['input']>;
  PIAndSIPatientCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  PIAndSIPatientCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  PIAndSIPatientCount_LT?: InputMaybe<Scalars['Int']['input']>;
  PIAndSIPatientCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  PIOnlyPatientCount?: InputMaybe<Scalars['Int']['input']>;
  PIOnlyPatientCount_GT?: InputMaybe<Scalars['Int']['input']>;
  PIOnlyPatientCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  PIOnlyPatientCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  PIOnlyPatientCount_LT?: InputMaybe<Scalars['Int']['input']>;
  PIOnlyPatientCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  isConditionMet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PatientCountDataPointsConnection = {
  __typename?: 'PatientCountDataPointsConnection';
  edges: Array<PatientCountDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientEdge = {
  __typename?: 'PatientEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type PatientFlexEntityAssignedFlexEntitiesAggregationSelection = {
  __typename?: 'PatientFlexEntityAssignedFlexEntitiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection>;
};

export type PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection = {
  __typename?: 'PatientFlexEntityAssignedFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type PatientOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientSort objects to sort Patients by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientSort>>;
};

export type PatientReportDataPoint = {
  __typename?: 'PatientReportDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  date: Scalars['Date']['output'];
  enrolledNumber: Scalars['Int']['output'];
};

export type PatientReportDataPointAggregateSelection = {
  __typename?: 'PatientReportDataPointAggregateSelection';
  count: Scalars['Int']['output'];
  enrolledNumber: IntAggregateSelectionNonNullable;
};

export type PatientReportDataPointEdge = {
  __typename?: 'PatientReportDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PatientReportDataPoint;
};

export type PatientReportDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientReportDataPointSort objects to sort PatientReportDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientReportDataPointSort>>;
};

/** Fields to sort PatientReportDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientReportDataPointSort object. */
export type PatientReportDataPointSort = {
  date?: InputMaybe<SortDirection>;
  enrolledNumber?: InputMaybe<SortDirection>;
};

export type PatientReportDataPointWhere = {
  AND?: InputMaybe<Array<PatientReportDataPointWhere>>;
  NOT?: InputMaybe<PatientReportDataPointWhere>;
  OR?: InputMaybe<Array<PatientReportDataPointWhere>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  date_GT?: InputMaybe<Scalars['Date']['input']>;
  date_GTE?: InputMaybe<Scalars['Date']['input']>;
  date_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  date_LT?: InputMaybe<Scalars['Date']['input']>;
  date_LTE?: InputMaybe<Scalars['Date']['input']>;
  enrolledNumber?: InputMaybe<Scalars['Int']['input']>;
  enrolledNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  enrolledNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  enrolledNumber_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  enrolledNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  enrolledNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientReportDataPointsConnection = {
  __typename?: 'PatientReportDataPointsConnection';
  edges: Array<PatientReportDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientReviewData = {
  __typename?: 'PatientReviewData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  eligiblePatients: Scalars['Int']['output'];
  enrolledPatients: Scalars['Int']['output'];
  nonEligiblePatients: Scalars['Int']['output'];
  nonEligibleReasons: Array<NonEligibleReason>;
  nonEnrolledPatients: Scalars['Int']['output'];
  nonEnrolledReasons: Array<NonEnrolledReason>;
};

export type PatientReviewDataAggregateSelection = {
  __typename?: 'PatientReviewDataAggregateSelection';
  count: Scalars['Int']['output'];
  eligiblePatients: IntAggregateSelectionNonNullable;
  enrolledPatients: IntAggregateSelectionNonNullable;
  nonEligiblePatients: IntAggregateSelectionNonNullable;
  nonEnrolledPatients: IntAggregateSelectionNonNullable;
};

export type PatientReviewDataConnection = {
  __typename?: 'PatientReviewDataConnection';
  edges: Array<PatientReviewDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientReviewDataEdge = {
  __typename?: 'PatientReviewDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PatientReviewData;
};

export type PatientReviewDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientReviewDataSort objects to sort PatientReviewData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientReviewDataSort>>;
};

/** Fields to sort PatientReviewData by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientReviewDataSort object. */
export type PatientReviewDataSort = {
  eligiblePatients?: InputMaybe<SortDirection>;
  enrolledPatients?: InputMaybe<SortDirection>;
  nonEligiblePatients?: InputMaybe<SortDirection>;
  nonEnrolledPatients?: InputMaybe<SortDirection>;
};

export type PatientReviewDataWhere = {
  AND?: InputMaybe<Array<PatientReviewDataWhere>>;
  NOT?: InputMaybe<PatientReviewDataWhere>;
  OR?: InputMaybe<Array<PatientReviewDataWhere>>;
  eligiblePatients?: InputMaybe<Scalars['Int']['input']>;
  eligiblePatients_GT?: InputMaybe<Scalars['Int']['input']>;
  eligiblePatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  eligiblePatients_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  eligiblePatients_LT?: InputMaybe<Scalars['Int']['input']>;
  eligiblePatients_LTE?: InputMaybe<Scalars['Int']['input']>;
  enrolledPatients?: InputMaybe<Scalars['Int']['input']>;
  enrolledPatients_GT?: InputMaybe<Scalars['Int']['input']>;
  enrolledPatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  enrolledPatients_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  enrolledPatients_LT?: InputMaybe<Scalars['Int']['input']>;
  enrolledPatients_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonEligiblePatients?: InputMaybe<Scalars['Int']['input']>;
  nonEligiblePatients_GT?: InputMaybe<Scalars['Int']['input']>;
  nonEligiblePatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonEligiblePatients_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nonEligiblePatients_LT?: InputMaybe<Scalars['Int']['input']>;
  nonEligiblePatients_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonEnrolledPatients?: InputMaybe<Scalars['Int']['input']>;
  nonEnrolledPatients_GT?: InputMaybe<Scalars['Int']['input']>;
  nonEnrolledPatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonEnrolledPatients_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  nonEnrolledPatients_LT?: InputMaybe<Scalars['Int']['input']>;
  nonEnrolledPatients_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export enum PatientScope {
  PerAgreement = 'PER_AGREEMENT',
  PerPatient = 'PER_PATIENT'
}

/** Fields to sort Patients by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientSort object. */
export type PatientSort = {
  id?: InputMaybe<SortDirection>;
  initials?: InputMaybe<SortDirection>;
  insuranceId?: InputMaybe<SortDirection>;
  lastUpdateDate?: InputMaybe<SortDirection>;
  maxCoverageStartDate?: InputMaybe<SortDirection>;
  maxTherapyTrialStartDate?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  yearOfBirth?: InputMaybe<SortDirection>;
};

export type PatientStatusDistribution = {
  __typename?: 'PatientStatusDistribution';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  conditionsMissedCount: Scalars['Int']['output'];
  outcomeNotReachedCount: Scalars['Int']['output'];
  outcomeReachedCount: Scalars['Int']['output'];
  possibleToReachOutcomeCount: Scalars['Int']['output'];
};

export type PatientStatusDistributionAggregateSelection = {
  __typename?: 'PatientStatusDistributionAggregateSelection';
  conditionsMissedCount: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  outcomeNotReachedCount: IntAggregateSelectionNonNullable;
  outcomeReachedCount: IntAggregateSelectionNonNullable;
  possibleToReachOutcomeCount: IntAggregateSelectionNonNullable;
};

export type PatientStatusDistributionEdge = {
  __typename?: 'PatientStatusDistributionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PatientStatusDistribution;
};

export type PatientStatusDistributionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientStatusDistributionSort objects to sort PatientStatusDistributions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientStatusDistributionSort>>;
};

/** Fields to sort PatientStatusDistributions by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientStatusDistributionSort object. */
export type PatientStatusDistributionSort = {
  conditionsMissedCount?: InputMaybe<SortDirection>;
  outcomeNotReachedCount?: InputMaybe<SortDirection>;
  outcomeReachedCount?: InputMaybe<SortDirection>;
  possibleToReachOutcomeCount?: InputMaybe<SortDirection>;
};

export type PatientStatusDistributionWhere = {
  AND?: InputMaybe<Array<PatientStatusDistributionWhere>>;
  NOT?: InputMaybe<PatientStatusDistributionWhere>;
  OR?: InputMaybe<Array<PatientStatusDistributionWhere>>;
  conditionsMissedCount?: InputMaybe<Scalars['Int']['input']>;
  conditionsMissedCount_GT?: InputMaybe<Scalars['Int']['input']>;
  conditionsMissedCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditionsMissedCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  conditionsMissedCount_LT?: InputMaybe<Scalars['Int']['input']>;
  conditionsMissedCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  outcomeNotReachedCount?: InputMaybe<Scalars['Int']['input']>;
  outcomeNotReachedCount_GT?: InputMaybe<Scalars['Int']['input']>;
  outcomeNotReachedCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  outcomeNotReachedCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  outcomeNotReachedCount_LT?: InputMaybe<Scalars['Int']['input']>;
  outcomeNotReachedCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  outcomeReachedCount?: InputMaybe<Scalars['Int']['input']>;
  outcomeReachedCount_GT?: InputMaybe<Scalars['Int']['input']>;
  outcomeReachedCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  outcomeReachedCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  outcomeReachedCount_LT?: InputMaybe<Scalars['Int']['input']>;
  outcomeReachedCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  possibleToReachOutcomeCount?: InputMaybe<Scalars['Int']['input']>;
  possibleToReachOutcomeCount_GT?: InputMaybe<Scalars['Int']['input']>;
  possibleToReachOutcomeCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  possibleToReachOutcomeCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  possibleToReachOutcomeCount_LT?: InputMaybe<Scalars['Int']['input']>;
  possibleToReachOutcomeCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientStatusDistributionsConnection = {
  __typename?: 'PatientStatusDistributionsConnection';
  edges: Array<PatientStatusDistributionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientWhere = {
  AND?: InputMaybe<Array<PatientWhere>>;
  NOT?: InputMaybe<PatientWhere>;
  OR?: InputMaybe<Array<PatientWhere>>;
  assignedFlexEntitiesAggregate?: InputMaybe<PatientAssignedFlexEntitiesAggregateInput>;
  /** Return Patients where all of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_ALL?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where none of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_NONE?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where one of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SINGLE?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where some of the related PatientAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SOME?: InputMaybe<PatientAssignedFlexEntitiesConnectionWhere>;
  /** Return Patients where all of the related FlexEntities match this filter */
  assignedFlexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Patients where none of the related FlexEntities match this filter */
  assignedFlexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Patients where one of the related FlexEntities match this filter */
  assignedFlexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Patients where some of the related FlexEntities match this filter */
  assignedFlexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  casesAggregate?: InputMaybe<PatientCasesAggregateInput>;
  /** Return Patients where all of the related PatientCasesConnections match this filter */
  casesConnection_ALL?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where none of the related PatientCasesConnections match this filter */
  casesConnection_NONE?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where one of the related PatientCasesConnections match this filter */
  casesConnection_SINGLE?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where some of the related PatientCasesConnections match this filter */
  casesConnection_SOME?: InputMaybe<PatientCasesConnectionWhere>;
  /** Return Patients where all of the related Cases match this filter */
  cases_ALL?: InputMaybe<CaseWhere>;
  /** Return Patients where none of the related Cases match this filter */
  cases_NONE?: InputMaybe<CaseWhere>;
  /** Return Patients where one of the related Cases match this filter */
  cases_SINGLE?: InputMaybe<CaseWhere>;
  /** Return Patients where some of the related Cases match this filter */
  cases_SOME?: InputMaybe<CaseWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  initials_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initials_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initials_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  initials_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initials_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceId?: InputMaybe<Scalars['String']['input']>;
  insuranceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdateDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  yearOfBirth?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  yearOfBirth_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientsConnection = {
  __typename?: 'PatientsConnection';
  edges: Array<PatientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PatientsPerMonthDataPoint = {
  __typename?: 'PatientsPerMonthDataPoint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  month: Scalars['String']['output'];
  patientCount: Scalars['Int']['output'];
};

export type PatientsPerMonthDataPointAggregateSelection = {
  __typename?: 'PatientsPerMonthDataPointAggregateSelection';
  count: Scalars['Int']['output'];
  month: StringAggregateSelectionNonNullable;
  patientCount: IntAggregateSelectionNonNullable;
};

export type PatientsPerMonthDataPointEdge = {
  __typename?: 'PatientsPerMonthDataPointEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PatientsPerMonthDataPoint;
};

export type PatientsPerMonthDataPointOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PatientsPerMonthDataPointSort objects to sort PatientsPerMonthDataPoints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PatientsPerMonthDataPointSort>>;
};

/** Fields to sort PatientsPerMonthDataPoints by. The order in which sorts are applied is not guaranteed when specifying many fields in one PatientsPerMonthDataPointSort object. */
export type PatientsPerMonthDataPointSort = {
  month?: InputMaybe<SortDirection>;
  patientCount?: InputMaybe<SortDirection>;
};

export type PatientsPerMonthDataPointWhere = {
  AND?: InputMaybe<Array<PatientsPerMonthDataPointWhere>>;
  NOT?: InputMaybe<PatientsPerMonthDataPointWhere>;
  OR?: InputMaybe<Array<PatientsPerMonthDataPointWhere>>;
  month?: InputMaybe<Scalars['String']['input']>;
  month_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  month_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  month_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  month_MATCHES?: InputMaybe<Scalars['String']['input']>;
  month_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientCount?: InputMaybe<Scalars['Int']['input']>;
  patientCount_GT?: InputMaybe<Scalars['Int']['input']>;
  patientCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  patientCount_LT?: InputMaybe<Scalars['Int']['input']>;
  patientCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientsPerMonthDataPointsConnection = {
  __typename?: 'PatientsPerMonthDataPointsConnection';
  edges: Array<PatientsPerMonthDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PdfReportFile = {
  __typename?: 'PdfReportFile';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  data: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type PdfReportFileAggregateSelection = {
  __typename?: 'PdfReportFileAggregateSelection';
  count: Scalars['Int']['output'];
  data: StringAggregateSelectionNonNullable;
  filename: StringAggregateSelectionNonNullable;
};

export type PdfReportFileEdge = {
  __typename?: 'PdfReportFileEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PdfReportFile;
};

export type PdfReportFileOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PdfReportFileSort objects to sort PdfReportFiles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PdfReportFileSort>>;
};

/** Fields to sort PdfReportFiles by. The order in which sorts are applied is not guaranteed when specifying many fields in one PdfReportFileSort object. */
export type PdfReportFileSort = {
  data?: InputMaybe<SortDirection>;
  filename?: InputMaybe<SortDirection>;
};

export type PdfReportFileWhere = {
  AND?: InputMaybe<Array<PdfReportFileWhere>>;
  NOT?: InputMaybe<PdfReportFileWhere>;
  OR?: InputMaybe<Array<PdfReportFileWhere>>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filename_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filename_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  filename_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filename_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PdfReportFilesConnection = {
  __typename?: 'PdfReportFilesConnection';
  edges: Array<PdfReportFileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PdfToken = {
  __typename?: 'PdfToken';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  token: Scalars['String']['output'];
};

export type PdfTokenAggregateSelection = {
  __typename?: 'PdfTokenAggregateSelection';
  count: Scalars['Int']['output'];
  token: StringAggregateSelectionNonNullable;
};

export type PdfTokenEdge = {
  __typename?: 'PdfTokenEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PdfToken;
};

export type PdfTokenOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PdfTokenSort objects to sort PdfTokens by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PdfTokenSort>>;
};

/** Fields to sort PdfTokens by. The order in which sorts are applied is not guaranteed when specifying many fields in one PdfTokenSort object. */
export type PdfTokenSort = {
  token?: InputMaybe<SortDirection>;
};

export type PdfTokenWhere = {
  AND?: InputMaybe<Array<PdfTokenWhere>>;
  NOT?: InputMaybe<PdfTokenWhere>;
  OR?: InputMaybe<Array<PdfTokenWhere>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  token_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  token_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  token_MATCHES?: InputMaybe<Scalars['String']['input']>;
  token_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PdfTokensConnection = {
  __typename?: 'PdfTokensConnection';
  edges: Array<PdfTokenEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceCounter = {
  __typename?: 'PerformanceCounter';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PerformanceCounterAggregateSelection = {
  __typename?: 'PerformanceCounterAggregateSelection';
  conditions: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type PerformanceCounterEdge = {
  __typename?: 'PerformanceCounterEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceCounter;
};

export type PerformanceCounterOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PerformanceCounterSort objects to sort PerformanceCounters by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PerformanceCounterSort>>;
};

/** Fields to sort PerformanceCounters by. The order in which sorts are applied is not guaranteed when specifying many fields in one PerformanceCounterSort object. */
export type PerformanceCounterSort = {
  conditions?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type PerformanceCounterWhere = {
  AND?: InputMaybe<Array<PerformanceCounterWhere>>;
  NOT?: InputMaybe<PerformanceCounterWhere>;
  OR?: InputMaybe<Array<PerformanceCounterWhere>>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  conditions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  conditions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  conditions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions_MATCHES?: InputMaybe<Scalars['String']['input']>;
  conditions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceCountersConnection = {
  __typename?: 'PerformanceCountersConnection';
  edges: Array<PerformanceCounterEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurement = {
  __typename?: 'PerformanceMeasurement';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  counter: PerformanceCounter;
  counterAggregate?: Maybe<PerformanceMeasurementPerformanceCounterCounterAggregationSelection>;
  counterConnection: PerformanceMeasurementCounterConnection;
  id: Scalars['ID']['output'];
  isAverage?: Maybe<Scalars['Boolean']['output']>;
  nestedMeasurements: Array<PerformanceMeasurement>;
  nestedMeasurementsAggregate?: Maybe<PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection>;
  nestedMeasurementsConnection: PerformanceMeasurementNestedMeasurementsConnection;
  parent?: Maybe<PerformanceMeasurement>;
  parentAggregate?: Maybe<PerformanceMeasurementPerformanceMeasurementParentAggregationSelection>;
  parentConnection: PerformanceMeasurementParentConnection;
  payload?: Maybe<Scalars['String']['output']>;
  startedOn: Scalars['DateTime']['output'];
};


export type PerformanceMeasurementCounterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceCounterOptions>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceMeasurementCounterAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceMeasurementCounterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceMeasurementCounterConnectionSort>>;
  where?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
};


export type PerformanceMeasurementNestedMeasurementsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceMeasurementOptions>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementNestedMeasurementsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementNestedMeasurementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsConnectionSort>>;
  where?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
};


export type PerformanceMeasurementParentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceMeasurementOptions>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementParentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type PerformanceMeasurementParentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceMeasurementParentConnectionSort>>;
  where?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
};

export type PerformanceMeasurementAggregateSelection = {
  __typename?: 'PerformanceMeasurementAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  payload: StringAggregateSelectionNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
};

export type PerformanceMeasurementCounterAggregateInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementCounterAggregateInput>>;
  NOT?: InputMaybe<PerformanceMeasurementCounterAggregateInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementCounterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceMeasurementCounterNodeAggregationWhereInput>;
};

export type PerformanceMeasurementCounterConnection = {
  __typename?: 'PerformanceMeasurementCounterConnection';
  edges: Array<PerformanceMeasurementCounterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurementCounterConnectionSort = {
  node?: InputMaybe<PerformanceCounterSort>;
};

export type PerformanceMeasurementCounterConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementCounterConnectionWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementCounterConnectionWhere>>;
  node?: InputMaybe<PerformanceCounterWhere>;
};

export type PerformanceMeasurementCounterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementCounterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceMeasurementCounterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementCounterNodeAggregationWhereInput>>;
  conditions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceMeasurementCounterRelationship = {
  __typename?: 'PerformanceMeasurementCounterRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceCounter;
};

export type PerformanceMeasurementEdge = {
  __typename?: 'PerformanceMeasurementEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceMeasurement;
};

export type PerformanceMeasurementNestedMeasurementsAggregateInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsAggregateInput>>;
  NOT?: InputMaybe<PerformanceMeasurementNestedMeasurementsAggregateInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>;
};

export type PerformanceMeasurementNestedMeasurementsConnection = {
  __typename?: 'PerformanceMeasurementNestedMeasurementsConnection';
  edges: Array<PerformanceMeasurementNestedMeasurementsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurementNestedMeasurementsConnectionSort = {
  node?: InputMaybe<PerformanceMeasurementSort>;
};

export type PerformanceMeasurementNestedMeasurementsConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsConnectionWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsConnectionWhere>>;
  node?: InputMaybe<PerformanceMeasurementWhere>;
};

export type PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementNestedMeasurementsNodeAggregationWhereInput>>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  payload_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  payload_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PerformanceMeasurementNestedMeasurementsRelationship = {
  __typename?: 'PerformanceMeasurementNestedMeasurementsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceMeasurement;
};

export type PerformanceMeasurementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PerformanceMeasurementSort objects to sort PerformanceMeasurements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PerformanceMeasurementSort>>;
};

export type PerformanceMeasurementParentAggregateInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementParentAggregateInput>>;
  NOT?: InputMaybe<PerformanceMeasurementParentAggregateInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementParentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceMeasurementParentNodeAggregationWhereInput>;
};

export type PerformanceMeasurementParentConnection = {
  __typename?: 'PerformanceMeasurementParentConnection';
  edges: Array<PerformanceMeasurementParentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceMeasurementParentConnectionSort = {
  node?: InputMaybe<PerformanceMeasurementSort>;
};

export type PerformanceMeasurementParentConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementParentConnectionWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementParentConnectionWhere>>;
  node?: InputMaybe<PerformanceMeasurementWhere>;
};

export type PerformanceMeasurementParentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceMeasurementParentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceMeasurementParentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceMeasurementParentNodeAggregationWhereInput>>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  payload_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  payload_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  payload_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payload_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  startedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PerformanceMeasurementParentRelationship = {
  __typename?: 'PerformanceMeasurementParentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceMeasurement;
};

export type PerformanceMeasurementPerformanceCounterCounterAggregationSelection = {
  __typename?: 'PerformanceMeasurementPerformanceCounterCounterAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection>;
};

export type PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection = {
  __typename?: 'PerformanceMeasurementPerformanceCounterCounterNodeAggregateSelection';
  conditions: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementNestedMeasurementsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection>;
};

export type PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementNestedMeasurementsNodeAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  payload: StringAggregateSelectionNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
};

export type PerformanceMeasurementPerformanceMeasurementParentAggregationSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementParentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection>;
};

export type PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection = {
  __typename?: 'PerformanceMeasurementPerformanceMeasurementParentNodeAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  payload: StringAggregateSelectionNullable;
  startedOn: DateTimeAggregateSelectionNonNullable;
};

/** Fields to sort PerformanceMeasurements by. The order in which sorts are applied is not guaranteed when specifying many fields in one PerformanceMeasurementSort object. */
export type PerformanceMeasurementSort = {
  completedOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isAverage?: InputMaybe<SortDirection>;
  payload?: InputMaybe<SortDirection>;
  startedOn?: InputMaybe<SortDirection>;
};

export type PerformanceMeasurementWhere = {
  AND?: InputMaybe<Array<PerformanceMeasurementWhere>>;
  NOT?: InputMaybe<PerformanceMeasurementWhere>;
  OR?: InputMaybe<Array<PerformanceMeasurementWhere>>;
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  counter?: InputMaybe<PerformanceCounterWhere>;
  counterAggregate?: InputMaybe<PerformanceMeasurementCounterAggregateInput>;
  counterConnection?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
  counterConnection_NOT?: InputMaybe<PerformanceMeasurementCounterConnectionWhere>;
  counter_NOT?: InputMaybe<PerformanceCounterWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isAverage?: InputMaybe<Scalars['Boolean']['input']>;
  nestedMeasurementsAggregate?: InputMaybe<PerformanceMeasurementNestedMeasurementsAggregateInput>;
  /** Return PerformanceMeasurements where all of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_ALL?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where none of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_NONE?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where one of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_SINGLE?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where some of the related PerformanceMeasurementNestedMeasurementsConnections match this filter */
  nestedMeasurementsConnection_SOME?: InputMaybe<PerformanceMeasurementNestedMeasurementsConnectionWhere>;
  /** Return PerformanceMeasurements where all of the related PerformanceMeasurements match this filter */
  nestedMeasurements_ALL?: InputMaybe<PerformanceMeasurementWhere>;
  /** Return PerformanceMeasurements where none of the related PerformanceMeasurements match this filter */
  nestedMeasurements_NONE?: InputMaybe<PerformanceMeasurementWhere>;
  /** Return PerformanceMeasurements where one of the related PerformanceMeasurements match this filter */
  nestedMeasurements_SINGLE?: InputMaybe<PerformanceMeasurementWhere>;
  /** Return PerformanceMeasurements where some of the related PerformanceMeasurements match this filter */
  nestedMeasurements_SOME?: InputMaybe<PerformanceMeasurementWhere>;
  parent?: InputMaybe<PerformanceMeasurementWhere>;
  parentAggregate?: InputMaybe<PerformanceMeasurementParentAggregateInput>;
  parentConnection?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
  parentConnection_NOT?: InputMaybe<PerformanceMeasurementParentConnectionWhere>;
  parent_NOT?: InputMaybe<PerformanceMeasurementWhere>;
  payload?: InputMaybe<Scalars['String']['input']>;
  payload_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  payload_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  payload_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payload_MATCHES?: InputMaybe<Scalars['String']['input']>;
  payload_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  startedOn?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  startedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  startedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PerformanceMeasurementsConnection = {
  __typename?: 'PerformanceMeasurementsConnection';
  edges: Array<PerformanceMeasurementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceThreshold = {
  __typename?: 'PerformanceThreshold';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  conditions?: Maybe<Scalars['String']['output']>;
  counter: PerformanceCounter;
  counterAggregate?: Maybe<PerformanceThresholdPerformanceCounterCounterAggregationSelection>;
  counterConnection: PerformanceThresholdCounterConnection;
  dataSizeQuotient?: Maybe<Scalars['String']['output']>;
  notifiedUsers: Array<User>;
  notifiedUsersAggregate?: Maybe<PerformanceThresholdUserNotifiedUsersAggregationSelection>;
  notifiedUsersConnection: PerformanceThresholdNotifiedUsersConnection;
  percentage?: Maybe<Scalars['Int']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};


export type PerformanceThresholdCounterArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PerformanceCounterOptions>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceThresholdCounterAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type PerformanceThresholdCounterConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceThresholdCounterConnectionSort>>;
  where?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
};


export type PerformanceThresholdNotifiedUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type PerformanceThresholdNotifiedUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type PerformanceThresholdNotifiedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformanceThresholdNotifiedUsersConnectionSort>>;
  where?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
};

export type PerformanceThresholdAggregateSelection = {
  __typename?: 'PerformanceThresholdAggregateSelection';
  conditions: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  dataSizeQuotient: StringAggregateSelectionNullable;
  percentage: IntAggregateSelectionNullable;
  property: StringAggregateSelectionNullable;
};

export type PerformanceThresholdCounterAggregateInput = {
  AND?: InputMaybe<Array<PerformanceThresholdCounterAggregateInput>>;
  NOT?: InputMaybe<PerformanceThresholdCounterAggregateInput>;
  OR?: InputMaybe<Array<PerformanceThresholdCounterAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceThresholdCounterNodeAggregationWhereInput>;
};

export type PerformanceThresholdCounterConnection = {
  __typename?: 'PerformanceThresholdCounterConnection';
  edges: Array<PerformanceThresholdCounterRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceThresholdCounterConnectionSort = {
  node?: InputMaybe<PerformanceCounterSort>;
};

export type PerformanceThresholdCounterConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceThresholdCounterConnectionWhere>>;
  NOT?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceThresholdCounterConnectionWhere>>;
  node?: InputMaybe<PerformanceCounterWhere>;
};

export type PerformanceThresholdCounterNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceThresholdCounterNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceThresholdCounterNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceThresholdCounterNodeAggregationWhereInput>>;
  conditions_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  conditions_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  conditions_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  conditions_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceThresholdCounterRelationship = {
  __typename?: 'PerformanceThresholdCounterRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceCounter;
};

export type PerformanceThresholdEdge = {
  __typename?: 'PerformanceThresholdEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PerformanceThreshold;
};

export type PerformanceThresholdNotifiedUsersAggregateInput = {
  AND?: InputMaybe<Array<PerformanceThresholdNotifiedUsersAggregateInput>>;
  NOT?: InputMaybe<PerformanceThresholdNotifiedUsersAggregateInput>;
  OR?: InputMaybe<Array<PerformanceThresholdNotifiedUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>;
};

export type PerformanceThresholdNotifiedUsersConnection = {
  __typename?: 'PerformanceThresholdNotifiedUsersConnection';
  edges: Array<PerformanceThresholdNotifiedUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PerformanceThresholdNotifiedUsersConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type PerformanceThresholdNotifiedUsersConnectionWhere = {
  AND?: InputMaybe<Array<PerformanceThresholdNotifiedUsersConnectionWhere>>;
  NOT?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  OR?: InputMaybe<Array<PerformanceThresholdNotifiedUsersConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type PerformanceThresholdNotifiedUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PerformanceThresholdNotifiedUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceThresholdNotifiedUsersRelationship = {
  __typename?: 'PerformanceThresholdNotifiedUsersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type PerformanceThresholdOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PerformanceThresholdSort objects to sort PerformanceThresholds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PerformanceThresholdSort>>;
};

export type PerformanceThresholdPerformanceCounterCounterAggregationSelection = {
  __typename?: 'PerformanceThresholdPerformanceCounterCounterAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection>;
};

export type PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection = {
  __typename?: 'PerformanceThresholdPerformanceCounterCounterNodeAggregateSelection';
  conditions: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

/** Fields to sort PerformanceThresholds by. The order in which sorts are applied is not guaranteed when specifying many fields in one PerformanceThresholdSort object. */
export type PerformanceThresholdSort = {
  conditions?: InputMaybe<SortDirection>;
  dataSizeQuotient?: InputMaybe<SortDirection>;
  percentage?: InputMaybe<SortDirection>;
  property?: InputMaybe<SortDirection>;
};

export type PerformanceThresholdUserNotifiedUsersAggregationSelection = {
  __typename?: 'PerformanceThresholdUserNotifiedUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PerformanceThresholdUserNotifiedUsersNodeAggregateSelection>;
};

export type PerformanceThresholdUserNotifiedUsersNodeAggregateSelection = {
  __typename?: 'PerformanceThresholdUserNotifiedUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type PerformanceThresholdWhere = {
  AND?: InputMaybe<Array<PerformanceThresholdWhere>>;
  NOT?: InputMaybe<PerformanceThresholdWhere>;
  OR?: InputMaybe<Array<PerformanceThresholdWhere>>;
  conditions?: InputMaybe<Scalars['String']['input']>;
  conditions_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  conditions_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  conditions_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  conditions_MATCHES?: InputMaybe<Scalars['String']['input']>;
  conditions_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  counter?: InputMaybe<PerformanceCounterWhere>;
  counterAggregate?: InputMaybe<PerformanceThresholdCounterAggregateInput>;
  counterConnection?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
  counterConnection_NOT?: InputMaybe<PerformanceThresholdCounterConnectionWhere>;
  counter_NOT?: InputMaybe<PerformanceCounterWhere>;
  dataSizeQuotient?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataSizeQuotient_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dataSizeQuotient_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  notifiedUsersAggregate?: InputMaybe<PerformanceThresholdNotifiedUsersAggregateInput>;
  /** Return PerformanceThresholds where all of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_ALL?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where none of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_NONE?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where one of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_SINGLE?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where some of the related PerformanceThresholdNotifiedUsersConnections match this filter */
  notifiedUsersConnection_SOME?: InputMaybe<PerformanceThresholdNotifiedUsersConnectionWhere>;
  /** Return PerformanceThresholds where all of the related Users match this filter */
  notifiedUsers_ALL?: InputMaybe<UserWhere>;
  /** Return PerformanceThresholds where none of the related Users match this filter */
  notifiedUsers_NONE?: InputMaybe<UserWhere>;
  /** Return PerformanceThresholds where one of the related Users match this filter */
  notifiedUsers_SINGLE?: InputMaybe<UserWhere>;
  /** Return PerformanceThresholds where some of the related Users match this filter */
  notifiedUsers_SOME?: InputMaybe<UserWhere>;
  percentage?: InputMaybe<Scalars['Int']['input']>;
  percentage_GT?: InputMaybe<Scalars['Int']['input']>;
  percentage_GTE?: InputMaybe<Scalars['Int']['input']>;
  percentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  percentage_LT?: InputMaybe<Scalars['Int']['input']>;
  percentage_LTE?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  property_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  property_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  property_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_MATCHES?: InputMaybe<Scalars['String']['input']>;
  property_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceThresholdsConnection = {
  __typename?: 'PerformanceThresholdsConnection';
  edges: Array<PerformanceThresholdEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PiRecurrenceSiDataPointsConnection = {
  __typename?: 'PiRecurrenceSiDataPointsConnection';
  edges: Array<PiRecurrenceSiDataPointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PlannedAgreementRun = {
  __typename?: 'PlannedAgreementRun';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  ids: Array<Scalars['String']['output']>;
  initiatorUserId: Scalars['String']['output'];
  isAgreementRunSubscriptionActive?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
};

export type PlannedAgreementRunAggregateSelection = {
  __typename?: 'PlannedAgreementRunAggregateSelection';
  count: Scalars['Int']['output'];
  initiatorUserId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
};

export type PlannedAgreementRunEdge = {
  __typename?: 'PlannedAgreementRunEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PlannedAgreementRun;
};

export type PlannedAgreementRunOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PlannedAgreementRunSort objects to sort PlannedAgreementRuns by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PlannedAgreementRunSort>>;
};

/** Fields to sort PlannedAgreementRuns by. The order in which sorts are applied is not guaranteed when specifying many fields in one PlannedAgreementRunSort object. */
export type PlannedAgreementRunSort = {
  initiatorUserId?: InputMaybe<SortDirection>;
  isAgreementRunSubscriptionActive?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type PlannedAgreementRunWhere = {
  AND?: InputMaybe<Array<PlannedAgreementRunWhere>>;
  NOT?: InputMaybe<PlannedAgreementRunWhere>;
  OR?: InputMaybe<Array<PlannedAgreementRunWhere>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  initiatorUserId?: InputMaybe<Scalars['String']['input']>;
  initiatorUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  initiatorUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  initiatorUserId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  initiatorUserId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  initiatorUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isAgreementRunSubscriptionActive?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PlannedAgreementRunsConnection = {
  __typename?: 'PlannedAgreementRunsConnection';
  edges: Array<PlannedAgreementRunEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Preparation = {
  __typename?: 'Preparation';
  AtcCode?: Maybe<Scalars['String']['output']>;
  BrandName: Scalars['String']['output'];
  DescriptionDe?: Maybe<Scalars['String']['output']>;
  DescriptionFr?: Maybe<Scalars['String']['output']>;
  DescriptionIt?: Maybe<Scalars['String']['output']>;
  GenericName?: Maybe<Scalars['String']['output']>;
  ReleaseDate?: Maybe<Scalars['Date']['output']>;
  SubjectMatter: AgreementSubjectMatter;
  SwissmedicNo5?: Maybe<Scalars['String']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  brand: Brand;
  brandAggregate?: Maybe<PreparationBrandBrandAggregationSelection>;
  brandConnection: PreparationBrandConnection;
  countries: Array<Country>;
  countriesAggregate?: Maybe<PreparationCountryCountriesAggregationSelection>;
  countriesConnection: PreparationCountriesConnection;
  generic?: Maybe<Generic>;
  genericAggregate?: Maybe<PreparationGenericGenericAggregationSelection>;
  genericConnection: PreparationGenericConnection;
  hasLimitation: Scalars['Boolean']['output'];
  hasLimitations: Array<Limitation>;
  hasLimitationsAggregate?: Maybe<PreparationLimitationHasLimitationsAggregationSelection>;
  hasLimitationsConnection: PreparationHasLimitationsConnection;
  id: Scalars['ID']['output'];
  regulates: Array<Treatment>;
  regulatesAggregate?: Maybe<PreparationTreatmentRegulatesAggregationSelection>;
  regulatesConnection: PreparationRegulatesConnection;
};


export type PreparationBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type PreparationBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type PreparationBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationBrandConnectionSort>>;
  where?: InputMaybe<PreparationBrandConnectionWhere>;
};


export type PreparationCountriesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type PreparationCountriesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type PreparationCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationCountriesConnectionSort>>;
  where?: InputMaybe<PreparationCountriesConnectionWhere>;
};


export type PreparationGenericArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type PreparationGenericAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type PreparationGenericConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationGenericConnectionSort>>;
  where?: InputMaybe<PreparationGenericConnectionWhere>;
};


export type PreparationHasLimitationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type PreparationHasLimitationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type PreparationHasLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationHasLimitationsConnectionSort>>;
  where?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
};


export type PreparationRegulatesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PreparationRegulatesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PreparationRegulatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationRegulatesConnectionSort>>;
  where?: InputMaybe<PreparationRegulatesConnectionWhere>;
};

export type PreparationAggregateSelection = {
  __typename?: 'PreparationAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type PreparationBrandAggregateInput = {
  AND?: InputMaybe<Array<PreparationBrandAggregateInput>>;
  NOT?: InputMaybe<PreparationBrandAggregateInput>;
  OR?: InputMaybe<Array<PreparationBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationBrandNodeAggregationWhereInput>;
};

export type PreparationBrandBrandAggregationSelection = {
  __typename?: 'PreparationBrandBrandAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationBrandBrandNodeAggregateSelection>;
};

export type PreparationBrandBrandNodeAggregateSelection = {
  __typename?: 'PreparationBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PreparationBrandConnection = {
  __typename?: 'PreparationBrandConnection';
  edges: Array<PreparationBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type PreparationBrandConnectionWhere = {
  AND?: InputMaybe<Array<PreparationBrandConnectionWhere>>;
  NOT?: InputMaybe<PreparationBrandConnectionWhere>;
  OR?: InputMaybe<Array<PreparationBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type PreparationBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreparationBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PreparationBrandRelationship = {
  __typename?: 'PreparationBrandRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type PreparationCountriesAggregateInput = {
  AND?: InputMaybe<Array<PreparationCountriesAggregateInput>>;
  NOT?: InputMaybe<PreparationCountriesAggregateInput>;
  OR?: InputMaybe<Array<PreparationCountriesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationCountriesNodeAggregationWhereInput>;
};

export type PreparationCountriesConnection = {
  __typename?: 'PreparationCountriesConnection';
  edges: Array<PreparationCountriesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationCountriesConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type PreparationCountriesConnectionWhere = {
  AND?: InputMaybe<Array<PreparationCountriesConnectionWhere>>;
  NOT?: InputMaybe<PreparationCountriesConnectionWhere>;
  OR?: InputMaybe<Array<PreparationCountriesConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type PreparationCountriesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationCountriesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreparationCountriesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PreparationCountriesNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationCountriesRelationship = {
  __typename?: 'PreparationCountriesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export type PreparationCountryCountriesAggregationSelection = {
  __typename?: 'PreparationCountryCountriesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationCountryCountriesNodeAggregateSelection>;
};

export type PreparationCountryCountriesNodeAggregateSelection = {
  __typename?: 'PreparationCountryCountriesNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type PreparationEdge = {
  __typename?: 'PreparationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type PreparationGenericAggregateInput = {
  AND?: InputMaybe<Array<PreparationGenericAggregateInput>>;
  NOT?: InputMaybe<PreparationGenericAggregateInput>;
  OR?: InputMaybe<Array<PreparationGenericAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationGenericNodeAggregationWhereInput>;
};

export type PreparationGenericConnection = {
  __typename?: 'PreparationGenericConnection';
  edges: Array<PreparationGenericRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationGenericConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type PreparationGenericConnectionWhere = {
  AND?: InputMaybe<Array<PreparationGenericConnectionWhere>>;
  NOT?: InputMaybe<PreparationGenericConnectionWhere>;
  OR?: InputMaybe<Array<PreparationGenericConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type PreparationGenericGenericAggregationSelection = {
  __typename?: 'PreparationGenericGenericAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationGenericGenericNodeAggregateSelection>;
};

export type PreparationGenericGenericNodeAggregateSelection = {
  __typename?: 'PreparationGenericGenericNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PreparationGenericNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationGenericNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PreparationGenericNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationGenericNodeAggregationWhereInput>>;
};

export type PreparationGenericRelationship = {
  __typename?: 'PreparationGenericRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type PreparationHasLimitationsAggregateInput = {
  AND?: InputMaybe<Array<PreparationHasLimitationsAggregateInput>>;
  NOT?: InputMaybe<PreparationHasLimitationsAggregateInput>;
  OR?: InputMaybe<Array<PreparationHasLimitationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationHasLimitationsNodeAggregationWhereInput>;
};

export type PreparationHasLimitationsConnection = {
  __typename?: 'PreparationHasLimitationsConnection';
  edges: Array<PreparationHasLimitationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationHasLimitationsConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type PreparationHasLimitationsConnectionWhere = {
  AND?: InputMaybe<Array<PreparationHasLimitationsConnectionWhere>>;
  NOT?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  OR?: InputMaybe<Array<PreparationHasLimitationsConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type PreparationHasLimitationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationHasLimitationsNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PreparationHasLimitationsNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationHasLimitationsNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationHasLimitationsRelationship = {
  __typename?: 'PreparationHasLimitationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type PreparationLimitationHasLimitationsAggregationSelection = {
  __typename?: 'PreparationLimitationHasLimitationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationLimitationHasLimitationsNodeAggregateSelection>;
};

export type PreparationLimitationHasLimitationsNodeAggregateSelection = {
  __typename?: 'PreparationLimitationHasLimitationsNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type PreparationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PreparationSort objects to sort Preparations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PreparationSort>>;
};

export type PreparationRegulatesAggregateInput = {
  AND?: InputMaybe<Array<PreparationRegulatesAggregateInput>>;
  NOT?: InputMaybe<PreparationRegulatesAggregateInput>;
  OR?: InputMaybe<Array<PreparationRegulatesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationRegulatesNodeAggregationWhereInput>;
};

export type PreparationRegulatesConnection = {
  __typename?: 'PreparationRegulatesConnection';
  edges: Array<PreparationRegulatesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationRegulatesConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type PreparationRegulatesConnectionWhere = {
  AND?: InputMaybe<Array<PreparationRegulatesConnectionWhere>>;
  NOT?: InputMaybe<PreparationRegulatesConnectionWhere>;
  OR?: InputMaybe<Array<PreparationRegulatesConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type PreparationRegulatesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationRegulatesNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PreparationRegulatesNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PreparationRegulatesNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationRegulatesRelationship = {
  __typename?: 'PreparationRegulatesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

/** Fields to sort Preparations by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreparationSort object. */
export type PreparationSort = {
  AtcCode?: InputMaybe<SortDirection>;
  BrandName?: InputMaybe<SortDirection>;
  DescriptionDe?: InputMaybe<SortDirection>;
  DescriptionFr?: InputMaybe<SortDirection>;
  DescriptionIt?: InputMaybe<SortDirection>;
  GenericName?: InputMaybe<SortDirection>;
  ReleaseDate?: InputMaybe<SortDirection>;
  SubjectMatter?: InputMaybe<SortDirection>;
  SwissmedicNo5?: InputMaybe<SortDirection>;
  hasLimitation?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type PreparationStatus = {
  __typename?: 'PreparationStatus';
  FlagApd?: Maybe<Scalars['String']['output']>;
  IntegrationDate: Scalars['Date']['output'];
  StatusTypeCodeSl?: Maybe<Scalars['String']['output']>;
  StatusTypeDescriptionSl?: Maybe<Scalars['String']['output']>;
  ValidFromDate: Scalars['Date']['output'];
  ValidThruDate: Scalars['Date']['output'];
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  preparation?: Maybe<Preparation>;
  preparationAggregate?: Maybe<PreparationStatusPreparationPreparationAggregationSelection>;
  preparationConnection: PreparationStatusPreparationConnection;
};


export type PreparationStatusPreparationArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type PreparationStatusPreparationAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type PreparationStatusPreparationConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PreparationStatusPreparationConnectionSort>>;
  where?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
};

export type PreparationStatusAggregateSelection = {
  __typename?: 'PreparationStatusAggregateSelection';
  FlagApd: StringAggregateSelectionNullable;
  StatusTypeCodeSl: StringAggregateSelectionNullable;
  StatusTypeDescriptionSl: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type PreparationStatusEdge = {
  __typename?: 'PreparationStatusEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PreparationStatus;
};

export type PreparationStatusOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PreparationStatusSort objects to sort PreparationStatuses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PreparationStatusSort>>;
};

export type PreparationStatusPreparationAggregateInput = {
  AND?: InputMaybe<Array<PreparationStatusPreparationAggregateInput>>;
  NOT?: InputMaybe<PreparationStatusPreparationAggregateInput>;
  OR?: InputMaybe<Array<PreparationStatusPreparationAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PreparationStatusPreparationNodeAggregationWhereInput>;
};

export type PreparationStatusPreparationConnection = {
  __typename?: 'PreparationStatusPreparationConnection';
  edges: Array<PreparationStatusPreparationRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationStatusPreparationConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type PreparationStatusPreparationConnectionWhere = {
  AND?: InputMaybe<Array<PreparationStatusPreparationConnectionWhere>>;
  NOT?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
  OR?: InputMaybe<Array<PreparationStatusPreparationConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type PreparationStatusPreparationNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PreparationStatusPreparationNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PreparationStatusPreparationNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PreparationStatusPreparationNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PreparationStatusPreparationPreparationAggregationSelection = {
  __typename?: 'PreparationStatusPreparationPreparationAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationStatusPreparationPreparationNodeAggregateSelection>;
};

export type PreparationStatusPreparationPreparationNodeAggregateSelection = {
  __typename?: 'PreparationStatusPreparationPreparationNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type PreparationStatusPreparationRelationship = {
  __typename?: 'PreparationStatusPreparationRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

/** Fields to sort PreparationStatuses by. The order in which sorts are applied is not guaranteed when specifying many fields in one PreparationStatusSort object. */
export type PreparationStatusSort = {
  FlagApd?: InputMaybe<SortDirection>;
  IntegrationDate?: InputMaybe<SortDirection>;
  StatusTypeCodeSl?: InputMaybe<SortDirection>;
  StatusTypeDescriptionSl?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
  ValidThruDate?: InputMaybe<SortDirection>;
};

export type PreparationStatusWhere = {
  AND?: InputMaybe<Array<PreparationStatusWhere>>;
  FlagApd?: InputMaybe<Scalars['String']['input']>;
  FlagApd_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  FlagApd_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagApd_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FlagApd_MATCHES?: InputMaybe<Scalars['String']['input']>;
  FlagApd_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  IntegrationDate?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  IntegrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  IntegrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  NOT?: InputMaybe<PreparationStatusWhere>;
  OR?: InputMaybe<Array<PreparationStatusWhere>>;
  StatusTypeCodeSl?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  StatusTypeCodeSl_MATCHES?: InputMaybe<Scalars['String']['input']>;
  StatusTypeCodeSl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  StatusTypeDescriptionSl_MATCHES?: InputMaybe<Scalars['String']['input']>;
  StatusTypeDescriptionSl_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  ValidThruDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidThruDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  preparation?: InputMaybe<PreparationWhere>;
  preparationAggregate?: InputMaybe<PreparationStatusPreparationAggregateInput>;
  preparationConnection?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
  preparationConnection_NOT?: InputMaybe<PreparationStatusPreparationConnectionWhere>;
  preparation_NOT?: InputMaybe<PreparationWhere>;
};

export type PreparationStatusesConnection = {
  __typename?: 'PreparationStatusesConnection';
  edges: Array<PreparationStatusEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PreparationTreatmentRegulatesAggregationSelection = {
  __typename?: 'PreparationTreatmentRegulatesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PreparationTreatmentRegulatesNodeAggregateSelection>;
};

export type PreparationTreatmentRegulatesNodeAggregateSelection = {
  __typename?: 'PreparationTreatmentRegulatesNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type PreparationWhere = {
  AND?: InputMaybe<Array<PreparationWhere>>;
  AtcCode?: InputMaybe<Scalars['String']['input']>;
  AtcCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  AtcCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  AtcCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  AtcCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  AtcCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  BrandName?: InputMaybe<Scalars['String']['input']>;
  BrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  BrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  BrandName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  BrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  BrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  GenericName?: InputMaybe<Scalars['String']['input']>;
  GenericName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  GenericName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  GenericName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GenericName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  GenericName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<PreparationWhere>;
  OR?: InputMaybe<Array<PreparationWhere>>;
  ReleaseDate?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ReleaseDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ReleaseDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  SubjectMatter?: InputMaybe<AgreementSubjectMatter>;
  SubjectMatter_IN?: InputMaybe<Array<AgreementSubjectMatter>>;
  SwissmedicNo5?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SwissmedicNo5_MATCHES?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo5_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<PreparationBrandAggregateInput>;
  brandConnection?: InputMaybe<PreparationBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<PreparationBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  countriesAggregate?: InputMaybe<PreparationCountriesAggregateInput>;
  /** Return Preparations where all of the related PreparationCountriesConnections match this filter */
  countriesConnection_ALL?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where none of the related PreparationCountriesConnections match this filter */
  countriesConnection_NONE?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where one of the related PreparationCountriesConnections match this filter */
  countriesConnection_SINGLE?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where some of the related PreparationCountriesConnections match this filter */
  countriesConnection_SOME?: InputMaybe<PreparationCountriesConnectionWhere>;
  /** Return Preparations where all of the related Countries match this filter */
  countries_ALL?: InputMaybe<CountryWhere>;
  /** Return Preparations where none of the related Countries match this filter */
  countries_NONE?: InputMaybe<CountryWhere>;
  /** Return Preparations where one of the related Countries match this filter */
  countries_SINGLE?: InputMaybe<CountryWhere>;
  /** Return Preparations where some of the related Countries match this filter */
  countries_SOME?: InputMaybe<CountryWhere>;
  generic?: InputMaybe<GenericWhere>;
  genericAggregate?: InputMaybe<PreparationGenericAggregateInput>;
  genericConnection?: InputMaybe<PreparationGenericConnectionWhere>;
  genericConnection_NOT?: InputMaybe<PreparationGenericConnectionWhere>;
  generic_NOT?: InputMaybe<GenericWhere>;
  hasLimitationsAggregate?: InputMaybe<PreparationHasLimitationsAggregateInput>;
  /** Return Preparations where all of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_ALL?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where none of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_NONE?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where one of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_SINGLE?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where some of the related PreparationHasLimitationsConnections match this filter */
  hasLimitationsConnection_SOME?: InputMaybe<PreparationHasLimitationsConnectionWhere>;
  /** Return Preparations where all of the related Limitations match this filter */
  hasLimitations_ALL?: InputMaybe<LimitationWhere>;
  /** Return Preparations where none of the related Limitations match this filter */
  hasLimitations_NONE?: InputMaybe<LimitationWhere>;
  /** Return Preparations where one of the related Limitations match this filter */
  hasLimitations_SINGLE?: InputMaybe<LimitationWhere>;
  /** Return Preparations where some of the related Limitations match this filter */
  hasLimitations_SOME?: InputMaybe<LimitationWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  regulatesAggregate?: InputMaybe<PreparationRegulatesAggregateInput>;
  /** Return Preparations where all of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_ALL?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where none of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_NONE?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where one of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_SINGLE?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where some of the related PreparationRegulatesConnections match this filter */
  regulatesConnection_SOME?: InputMaybe<PreparationRegulatesConnectionWhere>;
  /** Return Preparations where all of the related Treatments match this filter */
  regulates_ALL?: InputMaybe<TreatmentWhere>;
  /** Return Preparations where none of the related Treatments match this filter */
  regulates_NONE?: InputMaybe<TreatmentWhere>;
  /** Return Preparations where one of the related Treatments match this filter */
  regulates_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return Preparations where some of the related Treatments match this filter */
  regulates_SOME?: InputMaybe<TreatmentWhere>;
};

export type PreparationsConnection = {
  __typename?: 'PreparationsConnection';
  edges: Array<PreparationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Price = {
  __typename?: 'Price';
  Price: Scalars['String']['output'];
  PriceChangeTypeDescriptionDe?: Maybe<Scalars['String']['output']>;
  PriceChangeTypeDescriptionFr?: Maybe<Scalars['String']['output']>;
  PriceChangeTypeDescriptionIt?: Maybe<Scalars['String']['output']>;
  PriceTypeDescriptionDe?: Maybe<Scalars['String']['output']>;
  PriceTypeDescriptionFr?: Maybe<Scalars['String']['output']>;
  PriceTypeDescriptionIt?: Maybe<Scalars['String']['output']>;
  ValidFromDate: Scalars['Date']['output'];
  ValidToDate?: Maybe<Scalars['Date']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  countriesConsidered?: Maybe<Scalars['String']['output']>;
  currency: Currency;
  currencyAggregate?: Maybe<PriceCurrencyCurrencyAggregationSelection>;
  currencyConnection: PriceCurrencyConnection;
  priceType: PriceCategory;
  treatment?: Maybe<Treatment>;
  treatmentAggregate?: Maybe<PriceTreatmentTreatmentAggregationSelection>;
  treatmentConnection: PriceTreatmentConnection;
  uniqueCode: Scalars['String']['output'];
};


export type PriceCurrencyArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type PriceCurrencyAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CurrencyWhere>;
};


export type PriceCurrencyConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PriceCurrencyConnectionSort>>;
  where?: InputMaybe<PriceCurrencyConnectionWhere>;
};


export type PriceTreatmentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PriceTreatmentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type PriceTreatmentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PriceTreatmentConnectionSort>>;
  where?: InputMaybe<PriceTreatmentConnectionWhere>;
};

export type PriceAggregateSelection = {
  __typename?: 'PriceAggregateSelection';
  Price: StringAggregateSelectionNonNullable;
  PriceChangeTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionIt: StringAggregateSelectionNullable;
  PriceTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceTypeDescriptionIt: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  countriesConsidered: StringAggregateSelectionNullable;
  uniqueCode: StringAggregateSelectionNonNullable;
};

export enum PriceCategory {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  AverageGeneric = 'AVERAGE_GENERIC',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  CrossCountry = 'CROSS_COUNTRY',
  Internal = 'INTERNAL',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  OriginalDrugExFactoryPrice = 'ORIGINAL_DRUG_EX_FACTORY_PRICE',
  Pexf = 'PEXF',
  Ppub = 'PPUB',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  VacListPrice = 'VAC_LIST_PRICE',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE'
}

export type PriceCurrencyAggregateInput = {
  AND?: InputMaybe<Array<PriceCurrencyAggregateInput>>;
  NOT?: InputMaybe<PriceCurrencyAggregateInput>;
  OR?: InputMaybe<Array<PriceCurrencyAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PriceCurrencyNodeAggregationWhereInput>;
};

export type PriceCurrencyConnection = {
  __typename?: 'PriceCurrencyConnection';
  edges: Array<PriceCurrencyRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PriceCurrencyConnectionSort = {
  node?: InputMaybe<CurrencySort>;
};

export type PriceCurrencyConnectionWhere = {
  AND?: InputMaybe<Array<PriceCurrencyConnectionWhere>>;
  NOT?: InputMaybe<PriceCurrencyConnectionWhere>;
  OR?: InputMaybe<Array<PriceCurrencyConnectionWhere>>;
  node?: InputMaybe<CurrencyWhere>;
};

export type PriceCurrencyCurrencyAggregationSelection = {
  __typename?: 'PriceCurrencyCurrencyAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PriceCurrencyCurrencyNodeAggregateSelection>;
};

export type PriceCurrencyCurrencyNodeAggregateSelection = {
  __typename?: 'PriceCurrencyCurrencyNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNullable;
  symbol: StringAggregateSelectionNullable;
};

export type PriceCurrencyNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PriceCurrencyNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PriceCurrencyNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PriceCurrencyNodeAggregationWhereInput>>;
  symbol_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  symbol_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  symbol_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  symbol_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceCurrencyRelationship = {
  __typename?: 'PriceCurrencyRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Currency;
};

export type PriceData = {
  __typename?: 'PriceData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  effectiveStartDate?: Maybe<Scalars['String']['output']>;
  hosp?: Maybe<Scalars['String']['output']>;
  isoCountryCode: Scalars['String']['output'];
  mnf?: Maybe<Scalars['String']['output']>;
  ppeVat?: Maybe<Scalars['String']['output']>;
};

export type PriceDataAggregateSelection = {
  __typename?: 'PriceDataAggregateSelection';
  count: Scalars['Int']['output'];
  effectiveStartDate: StringAggregateSelectionNullable;
  hosp: StringAggregateSelectionNullable;
  isoCountryCode: StringAggregateSelectionNonNullable;
  mnf: StringAggregateSelectionNullable;
  ppeVat: StringAggregateSelectionNullable;
};

export type PriceDataConnection = {
  __typename?: 'PriceDataConnection';
  edges: Array<PriceDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PriceDataEdge = {
  __typename?: 'PriceDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PriceData;
};

export type PriceDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PriceDataSort objects to sort PriceData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PriceDataSort>>;
};

/** Fields to sort PriceData by. The order in which sorts are applied is not guaranteed when specifying many fields in one PriceDataSort object. */
export type PriceDataSort = {
  effectiveStartDate?: InputMaybe<SortDirection>;
  hosp?: InputMaybe<SortDirection>;
  isoCountryCode?: InputMaybe<SortDirection>;
  mnf?: InputMaybe<SortDirection>;
  ppeVat?: InputMaybe<SortDirection>;
};

export type PriceDataWhere = {
  AND?: InputMaybe<Array<PriceDataWhere>>;
  NOT?: InputMaybe<PriceDataWhere>;
  OR?: InputMaybe<Array<PriceDataWhere>>;
  effectiveStartDate?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDate_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDate_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDate_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  effectiveStartDate_MATCHES?: InputMaybe<Scalars['String']['input']>;
  effectiveStartDate_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hosp?: InputMaybe<Scalars['String']['input']>;
  hosp_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  hosp_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  hosp_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hosp_MATCHES?: InputMaybe<Scalars['String']['input']>;
  hosp_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isoCountryCode?: InputMaybe<Scalars['String']['input']>;
  isoCountryCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  isoCountryCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  isoCountryCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  isoCountryCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  isoCountryCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mnf?: InputMaybe<Scalars['String']['input']>;
  mnf_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mnf_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mnf_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mnf_MATCHES?: InputMaybe<Scalars['String']['input']>;
  mnf_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ppeVat?: InputMaybe<Scalars['String']['input']>;
  ppeVat_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ppeVat_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ppeVat_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppeVat_MATCHES?: InputMaybe<Scalars['String']['input']>;
  ppeVat_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PriceEdge = {
  __typename?: 'PriceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Price;
};

export type PriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PriceSort objects to sort Prices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PriceSort>>;
};

/** Fields to sort Prices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PriceSort object. */
export type PriceSort = {
  Price?: InputMaybe<SortDirection>;
  PriceChangeTypeDescriptionDe?: InputMaybe<SortDirection>;
  PriceChangeTypeDescriptionFr?: InputMaybe<SortDirection>;
  PriceChangeTypeDescriptionIt?: InputMaybe<SortDirection>;
  PriceTypeDescriptionDe?: InputMaybe<SortDirection>;
  PriceTypeDescriptionFr?: InputMaybe<SortDirection>;
  PriceTypeDescriptionIt?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
  ValidToDate?: InputMaybe<SortDirection>;
  countriesConsidered?: InputMaybe<SortDirection>;
  priceType?: InputMaybe<SortDirection>;
  uniqueCode?: InputMaybe<SortDirection>;
};

export type PriceTreatmentAggregateInput = {
  AND?: InputMaybe<Array<PriceTreatmentAggregateInput>>;
  NOT?: InputMaybe<PriceTreatmentAggregateInput>;
  OR?: InputMaybe<Array<PriceTreatmentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PriceTreatmentNodeAggregationWhereInput>;
};

export type PriceTreatmentConnection = {
  __typename?: 'PriceTreatmentConnection';
  edges: Array<PriceTreatmentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PriceTreatmentConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type PriceTreatmentConnectionWhere = {
  AND?: InputMaybe<Array<PriceTreatmentConnectionWhere>>;
  NOT?: InputMaybe<PriceTreatmentConnectionWhere>;
  OR?: InputMaybe<Array<PriceTreatmentConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type PriceTreatmentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PriceTreatmentNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PriceTreatmentNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<PriceTreatmentNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PriceTreatmentRelationship = {
  __typename?: 'PriceTreatmentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type PriceTreatmentTreatmentAggregationSelection = {
  __typename?: 'PriceTreatmentTreatmentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PriceTreatmentTreatmentNodeAggregateSelection>;
};

export type PriceTreatmentTreatmentNodeAggregateSelection = {
  __typename?: 'PriceTreatmentTreatmentNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export enum PriceType {
  AlbertaListPrice = 'ALBERTA_LIST_PRICE',
  AlbertaListPricePercent = 'ALBERTA_LIST_PRICE_PERCENT',
  AlbertaMarkedUpPrice = 'ALBERTA_MARKED_UP_PRICE',
  AlbertaMarkedUpPricePercent = 'ALBERTA_MARKED_UP_PRICE_PERCENT',
  AvgGenericPercent = 'AVG_GENERIC_PERCENT',
  BritishColumbiaListPrice = 'BRITISH_COLUMBIA_LIST_PRICE',
  BritishColumbiaListPricePercent = 'BRITISH_COLUMBIA_LIST_PRICE_PERCENT',
  BritishColumbiaMarkedUpPrice = 'BRITISH_COLUMBIA_MARKED_UP_PRICE',
  BritishColumbiaMarkedUpPricePercent = 'BRITISH_COLUMBIA_MARKED_UP_PRICE_PERCENT',
  CrossCountryPercent = 'CROSS_COUNTRY_PERCENT',
  CustomPrice = 'CUSTOM_PRICE',
  CustomPricePercent = 'CUSTOM_PRICE_PERCENT',
  DiffBetweenExFactoryAndCrossCountry = 'DIFF_BETWEEN_EX_FACTORY_AND_CROSS_COUNTRY',
  ExFactoryPrice = 'EX_FACTORY_PRICE',
  ExFactoryPricePercent = 'EX_FACTORY_PRICE_PERCENT',
  ManitobaListPrice = 'MANITOBA_LIST_PRICE',
  ManitobaListPricePercent = 'MANITOBA_LIST_PRICE_PERCENT',
  ManitobaMarkedUpPrice = 'MANITOBA_MARKED_UP_PRICE',
  ManitobaMarkedUpPricePercent = 'MANITOBA_MARKED_UP_PRICE_PERCENT',
  NetPrice = 'NET_PRICE',
  NetPricePercent = 'NET_PRICE_PERCENT',
  NewfoundlandAndLabradorListPrice = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE',
  NewfoundlandAndLabradorListPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_LIST_PRICE_PERCENT',
  NewfoundlandAndLabradorMarkedUpPrice = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE',
  NewfoundlandAndLabradorMarkedUpPricePercent = 'NEWFOUNDLAND_AND_LABRADOR_MARKED_UP_PRICE_PERCENT',
  NewBrunswickListPrice = 'NEW_BRUNSWICK_LIST_PRICE',
  NewBrunswickListPricePercent = 'NEW_BRUNSWICK_LIST_PRICE_PERCENT',
  NewBrunswickMarkedUpPrice = 'NEW_BRUNSWICK_MARKED_UP_PRICE',
  NewBrunswickMarkedUpPricePercent = 'NEW_BRUNSWICK_MARKED_UP_PRICE_PERCENT',
  NihbListPrice = 'NIHB_LIST_PRICE',
  NihbListPricePercent = 'NIHB_LIST_PRICE_PERCENT',
  NihbMarkedUpPrice = 'NIHB_MARKED_UP_PRICE',
  NihbMarkedUpPricePercent = 'NIHB_MARKED_UP_PRICE_PERCENT',
  NorthwestTerritoriesListPrice = 'NORTHWEST_TERRITORIES_LIST_PRICE',
  NorthwestTerritoriesListPricePercent = 'NORTHWEST_TERRITORIES_LIST_PRICE_PERCENT',
  NorthwestTerritoriesMarkedUpPrice = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE',
  NorthwestTerritoriesMarkedUpPricePercent = 'NORTHWEST_TERRITORIES_MARKED_UP_PRICE_PERCENT',
  NovaScotiaListPrice = 'NOVA_SCOTIA_LIST_PRICE',
  NovaScotiaListPricePercent = 'NOVA_SCOTIA_LIST_PRICE_PERCENT',
  NovaScotiaMarkedUpPrice = 'NOVA_SCOTIA_MARKED_UP_PRICE',
  NovaScotiaMarkedUpPricePercent = 'NOVA_SCOTIA_MARKED_UP_PRICE_PERCENT',
  NunavutListPrice = 'NUNAVUT_LIST_PRICE',
  NunavutListPricePercent = 'NUNAVUT_LIST_PRICE_PERCENT',
  NunavutMarkedUpPrice = 'NUNAVUT_MARKED_UP_PRICE',
  NunavutMarkedUpPricePercent = 'NUNAVUT_MARKED_UP_PRICE_PERCENT',
  OntarioListPrice = 'ONTARIO_LIST_PRICE',
  OntarioListPricePercent = 'ONTARIO_LIST_PRICE_PERCENT',
  OntarioMarkedUpPrice = 'ONTARIO_MARKED_UP_PRICE',
  OntarioMarkedUpPricePercent = 'ONTARIO_MARKED_UP_PRICE_PERCENT',
  OriginalDrugExFactoryPricePercent = 'ORIGINAL_DRUG_EX_FACTORY_PRICE_PERCENT',
  PrinceEdwardIslandListPrice = 'PRINCE_EDWARD_ISLAND_LIST_PRICE',
  PrinceEdwardIslandListPricePercent = 'PRINCE_EDWARD_ISLAND_LIST_PRICE_PERCENT',
  PrinceEdwardIslandMarkedUpPrice = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE',
  PrinceEdwardIslandMarkedUpPricePercent = 'PRINCE_EDWARD_ISLAND_MARKED_UP_PRICE_PERCENT',
  PublicPrice = 'PUBLIC_PRICE',
  PublicPricePercent = 'PUBLIC_PRICE_PERCENT',
  QuebecListPrice = 'QUEBEC_LIST_PRICE',
  QuebecListPricePercent = 'QUEBEC_LIST_PRICE_PERCENT',
  QuebecMarkedUpPrice = 'QUEBEC_MARKED_UP_PRICE',
  QuebecMarkedUpPricePercent = 'QUEBEC_MARKED_UP_PRICE_PERCENT',
  RecordDiscountPercent = 'RECORD_DISCOUNT_PERCENT',
  RecordPricePercent = 'RECORD_PRICE_PERCENT',
  SaskatchewanListPrice = 'SASKATCHEWAN_LIST_PRICE',
  SaskatchewanListPricePercent = 'SASKATCHEWAN_LIST_PRICE_PERCENT',
  SaskatchewanMarkedUpPrice = 'SASKATCHEWAN_MARKED_UP_PRICE',
  SaskatchewanMarkedUpPricePercent = 'SASKATCHEWAN_MARKED_UP_PRICE_PERCENT',
  ScenarioZeroMainNetPrice = 'SCENARIO_ZERO_MAIN_NET_PRICE',
  ScenarioZeroMainNetPricePercent = 'SCENARIO_ZERO_MAIN_NET_PRICE_PERCENT',
  ScenarioZeroNetPrice = 'SCENARIO_ZERO_NET_PRICE',
  ScenarioZeroNetPricePercent = 'SCENARIO_ZERO_NET_PRICE_PERCENT',
  ScenarioZeroRelevantNetPrice = 'SCENARIO_ZERO_RELEVANT_NET_PRICE',
  ScenarioZeroRelevantNetPricePercent = 'SCENARIO_ZERO_RELEVANT_NET_PRICE_PERCENT',
  VacListPrice = 'VAC_LIST_PRICE',
  VacListPricePercent = 'VAC_LIST_PRICE_PERCENT',
  VacMarkedUpPrice = 'VAC_MARKED_UP_PRICE',
  VacMarkedUpPricePercent = 'VAC_MARKED_UP_PRICE_PERCENT',
  YukonListPrice = 'YUKON_LIST_PRICE',
  YukonListPricePercent = 'YUKON_LIST_PRICE_PERCENT',
  YukonMarkedUpPrice = 'YUKON_MARKED_UP_PRICE',
  YukonMarkedUpPricePercent = 'YUKON_MARKED_UP_PRICE_PERCENT'
}

export type PriceWhere = {
  AND?: InputMaybe<Array<PriceWhere>>;
  NOT?: InputMaybe<PriceWhere>;
  OR?: InputMaybe<Array<PriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceChangeTypeDescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceChangeTypeDescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceChangeTypeDescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceChangeTypeDescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceTypeDescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceTypeDescriptionFr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionFr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PriceTypeDescriptionIt_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PriceTypeDescriptionIt_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidToDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidToDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  countriesConsidered?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countriesConsidered_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countriesConsidered_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyWhere>;
  currencyAggregate?: InputMaybe<PriceCurrencyAggregateInput>;
  currencyConnection?: InputMaybe<PriceCurrencyConnectionWhere>;
  currencyConnection_NOT?: InputMaybe<PriceCurrencyConnectionWhere>;
  currency_NOT?: InputMaybe<CurrencyWhere>;
  priceType?: InputMaybe<PriceCategory>;
  priceType_IN?: InputMaybe<Array<PriceCategory>>;
  treatment?: InputMaybe<TreatmentWhere>;
  treatmentAggregate?: InputMaybe<PriceTreatmentAggregateInput>;
  treatmentConnection?: InputMaybe<PriceTreatmentConnectionWhere>;
  treatmentConnection_NOT?: InputMaybe<PriceTreatmentConnectionWhere>;
  treatment_NOT?: InputMaybe<TreatmentWhere>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  uniqueCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uniqueCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PricesConnection = {
  __typename?: 'PricesConnection';
  edges: Array<PriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprint = {
  __typename?: 'ProductBlueprint';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedBy: User;
  addedByAggregate?: Maybe<ProductBlueprintUserAddedByAggregationSelection>;
  addedByConnection: ProductBlueprintAddedByConnection;
  addedByName: Scalars['String']['output'];
  addedOn: Scalars['DateTime']['output'];
  domains: Array<Domain>;
  domainsAggregate?: Maybe<ProductBlueprintDomainDomainsAggregationSelection>;
  domainsConnection: ProductBlueprintDomainsConnection;
  formValues: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  indication: Scalars['String']['output'];
  indications: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  publishedBy?: Maybe<User>;
  publishedByAggregate?: Maybe<ProductBlueprintUserPublishedByAggregationSelection>;
  publishedByConnection: ProductBlueprintPublishedByConnection;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  simulationCount?: Maybe<Scalars['Int']['output']>;
  simulations?: Maybe<Simulation>;
  simulationsAggregate?: Maybe<ProductBlueprintSimulationSimulationsAggregationSelection>;
  simulationsConnection: ProductBlueprintSimulationsConnection;
  status: ProductBlueprintStatus;
  tenantId: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
  updatedByAggregate?: Maybe<ProductBlueprintUserUpdatedByAggregationSelection>;
  updatedByConnection: ProductBlueprintUpdatedByConnection;
  updatedOn: Scalars['DateTime']['output'];
};


export type ProductBlueprintAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintAddedByConnectionSort>>;
  where?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
};


export type ProductBlueprintDomainsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type ProductBlueprintDomainsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type ProductBlueprintDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintDomainsConnectionSort>>;
  where?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
};


export type ProductBlueprintPublishedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintPublishedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintPublishedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintPublishedByConnectionSort>>;
  where?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
};


export type ProductBlueprintSimulationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<SimulationOptions>;
  where?: InputMaybe<SimulationWhere>;
};


export type ProductBlueprintSimulationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SimulationWhere>;
};


export type ProductBlueprintSimulationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintSimulationsConnectionSort>>;
  where?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
};


export type ProductBlueprintUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type ProductBlueprintUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ProductBlueprintUpdatedByConnectionSort>>;
  where?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
};

export type ProductBlueprintAddedByAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintAddedByAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintAddedByAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintAddedByNodeAggregationWhereInput>;
};

export type ProductBlueprintAddedByConnection = {
  __typename?: 'ProductBlueprintAddedByConnection';
  edges: Array<ProductBlueprintAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProductBlueprintAddedByConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintAddedByConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProductBlueprintAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintAddedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintAddedByRelationship = {
  __typename?: 'ProductBlueprintAddedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProductBlueprintAggregateSelection = {
  __typename?: 'ProductBlueprintAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  formValues: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indication: StringAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  productName: StringAggregateSelectionNonNullable;
  publishedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  updatedOn: DateTimeAggregateSelectionNonNullable;
};

export type ProductBlueprintDomainDomainsAggregationSelection = {
  __typename?: 'ProductBlueprintDomainDomainsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintDomainDomainsNodeAggregateSelection>;
};

export type ProductBlueprintDomainDomainsNodeAggregateSelection = {
  __typename?: 'ProductBlueprintDomainDomainsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type ProductBlueprintDomainsAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintDomainsAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintDomainsAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintDomainsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintDomainsNodeAggregationWhereInput>;
};

export type ProductBlueprintDomainsConnection = {
  __typename?: 'ProductBlueprintDomainsConnection';
  edges: Array<ProductBlueprintDomainsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintDomainsConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type ProductBlueprintDomainsConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintDomainsConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintDomainsConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type ProductBlueprintDomainsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintDomainsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintDomainsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintDomainsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintDomainsRelationship = {
  __typename?: 'ProductBlueprintDomainsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type ProductBlueprintEdge = {
  __typename?: 'ProductBlueprintEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ProductBlueprint;
};

export type ProductBlueprintOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProductBlueprintSort objects to sort ProductBlueprints by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProductBlueprintSort>>;
};

export type ProductBlueprintPublishedByAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintPublishedByAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintPublishedByAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintPublishedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintPublishedByNodeAggregationWhereInput>;
};

export type ProductBlueprintPublishedByConnection = {
  __typename?: 'ProductBlueprintPublishedByConnection';
  edges: Array<ProductBlueprintPublishedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintPublishedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProductBlueprintPublishedByConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintPublishedByConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintPublishedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProductBlueprintPublishedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintPublishedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintPublishedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintPublishedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintPublishedByRelationship = {
  __typename?: 'ProductBlueprintPublishedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProductBlueprintSimulationSimulationsAggregationSelection = {
  __typename?: 'ProductBlueprintSimulationSimulationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintSimulationSimulationsNodeAggregateSelection>;
};

export type ProductBlueprintSimulationSimulationsNodeAggregateSelection = {
  __typename?: 'ProductBlueprintSimulationSimulationsNodeAggregateSelection';
  businessCase: StringAggregateSelectionNullable;
  comments: StringAggregateSelectionNullable;
  configuration: StringAggregateSelectionNonNullable;
  counterparty: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  domainName: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  lastUpdatedByEmail: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  lockedSections: StringAggregateSelectionNullable;
  model: StringAggregateSelectionNonNullable;
  product: StringAggregateSelectionNonNullable;
  shortName: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  version: IntAggregateSelectionNonNullable;
};

export type ProductBlueprintSimulationsAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintSimulationsAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintSimulationsAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintSimulationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintSimulationsNodeAggregationWhereInput>;
};

export type ProductBlueprintSimulationsConnection = {
  __typename?: 'ProductBlueprintSimulationsConnection';
  edges: Array<ProductBlueprintSimulationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintSimulationsConnectionSort = {
  node?: InputMaybe<SimulationSort>;
};

export type ProductBlueprintSimulationsConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintSimulationsConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintSimulationsConnectionWhere>>;
  node?: InputMaybe<SimulationWhere>;
};

export type ProductBlueprintSimulationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintSimulationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintSimulationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintSimulationsNodeAggregationWhereInput>>;
  businessCase_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  businessCase_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  businessCase_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  businessCase_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  comments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  comments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  comments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  configuration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  configuration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  configuration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterparty_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterparty_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterparty_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domainName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domainName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domainName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domainName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedContent_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSections_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lockedSections_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lockedSections_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  model_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  model_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  model_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  shortName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  shortName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  shortName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintSimulationsRelationship = {
  __typename?: 'ProductBlueprintSimulationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Simulation;
};

/** Fields to sort ProductBlueprints by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProductBlueprintSort object. */
export type ProductBlueprintSort = {
  addedByName?: InputMaybe<SortDirection>;
  addedOn?: InputMaybe<SortDirection>;
  formValues?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indication?: InputMaybe<SortDirection>;
  indications?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  productName?: InputMaybe<SortDirection>;
  publishedOn?: InputMaybe<SortDirection>;
  simulationCount?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  updatedOn?: InputMaybe<SortDirection>;
};

export enum ProductBlueprintStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type ProductBlueprintUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<ProductBlueprintUpdatedByAggregateInput>>;
  NOT?: InputMaybe<ProductBlueprintUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<ProductBlueprintUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ProductBlueprintUpdatedByNodeAggregationWhereInput>;
};

export type ProductBlueprintUpdatedByConnection = {
  __typename?: 'ProductBlueprintUpdatedByConnection';
  edges: Array<ProductBlueprintUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProductBlueprintUpdatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type ProductBlueprintUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<ProductBlueprintUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<ProductBlueprintUpdatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type ProductBlueprintUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductBlueprintUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ProductBlueprintUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ProductBlueprintUpdatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductBlueprintUpdatedByRelationship = {
  __typename?: 'ProductBlueprintUpdatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProductBlueprintUserAddedByAggregationSelection = {
  __typename?: 'ProductBlueprintUserAddedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintUserAddedByNodeAggregateSelection>;
};

export type ProductBlueprintUserAddedByNodeAggregateSelection = {
  __typename?: 'ProductBlueprintUserAddedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type ProductBlueprintUserPublishedByAggregationSelection = {
  __typename?: 'ProductBlueprintUserPublishedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintUserPublishedByNodeAggregateSelection>;
};

export type ProductBlueprintUserPublishedByNodeAggregateSelection = {
  __typename?: 'ProductBlueprintUserPublishedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type ProductBlueprintUserUpdatedByAggregationSelection = {
  __typename?: 'ProductBlueprintUserUpdatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ProductBlueprintUserUpdatedByNodeAggregateSelection>;
};

export type ProductBlueprintUserUpdatedByNodeAggregateSelection = {
  __typename?: 'ProductBlueprintUserUpdatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type ProductBlueprintWhere = {
  AND?: InputMaybe<Array<ProductBlueprintWhere>>;
  NOT?: InputMaybe<ProductBlueprintWhere>;
  OR?: InputMaybe<Array<ProductBlueprintWhere>>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<ProductBlueprintAddedByAggregateInput>;
  addedByConnection?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<ProductBlueprintAddedByConnectionWhere>;
  addedByName?: InputMaybe<Scalars['String']['input']>;
  addedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedByName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  addedOn?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  addedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domainsAggregate?: InputMaybe<ProductBlueprintDomainsAggregateInput>;
  /** Return ProductBlueprints where all of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_ALL?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where none of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_NONE?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where one of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_SINGLE?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where some of the related ProductBlueprintDomainsConnections match this filter */
  domainsConnection_SOME?: InputMaybe<ProductBlueprintDomainsConnectionWhere>;
  /** Return ProductBlueprints where all of the related Domains match this filter */
  domains_ALL?: InputMaybe<DomainWhere>;
  /** Return ProductBlueprints where none of the related Domains match this filter */
  domains_NONE?: InputMaybe<DomainWhere>;
  /** Return ProductBlueprints where one of the related Domains match this filter */
  domains_SINGLE?: InputMaybe<DomainWhere>;
  /** Return ProductBlueprints where some of the related Domains match this filter */
  domains_SOME?: InputMaybe<DomainWhere>;
  formValues?: InputMaybe<Scalars['String']['input']>;
  formValues_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formValues_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formValues_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formValues_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formValues_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indication?: InputMaybe<Scalars['String']['input']>;
  indication_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indication_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indication_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indication_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indication_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications?: InputMaybe<Scalars['String']['input']>;
  indications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  productName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  productName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  productName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  productName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publishedBy?: InputMaybe<UserWhere>;
  publishedByAggregate?: InputMaybe<ProductBlueprintPublishedByAggregateInput>;
  publishedByConnection?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
  publishedByConnection_NOT?: InputMaybe<ProductBlueprintPublishedByConnectionWhere>;
  publishedBy_NOT?: InputMaybe<UserWhere>;
  publishedOn?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  simulations?: InputMaybe<SimulationWhere>;
  simulationsAggregate?: InputMaybe<ProductBlueprintSimulationsAggregateInput>;
  simulationsConnection?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
  simulationsConnection_NOT?: InputMaybe<ProductBlueprintSimulationsConnectionWhere>;
  simulations_NOT?: InputMaybe<SimulationWhere>;
  status?: InputMaybe<ProductBlueprintStatus>;
  status_IN?: InputMaybe<Array<ProductBlueprintStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<UserWhere>;
  updatedByAggregate?: InputMaybe<ProductBlueprintUpdatedByAggregateInput>;
  updatedByConnection?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
  updatedByConnection_NOT?: InputMaybe<ProductBlueprintUpdatedByConnectionWhere>;
  updatedBy_NOT?: InputMaybe<UserWhere>;
  updatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductBlueprintsConnection = {
  __typename?: 'ProductBlueprintsConnection';
  edges: Array<ProductBlueprintEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileDataInfo = {
  __typename?: 'ProfileDataInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  country?: Maybe<Country>;
  defaultMessageSharingType?: Maybe<DocumentMessageSharingType>;
  documentsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  editedUserPicture?: Maybe<Scalars['String']['output']>;
  editedUserSignature?: Maybe<Scalars['String']['output']>;
  formsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  isSignatureCreationDraw?: Maybe<Scalars['Boolean']['output']>;
  notificationCount?: Maybe<Scalars['Int']['output']>;
  questsCount?: Maybe<Scalars['Int']['output']>;
  recordsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  simulationsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  sourceUserPicture?: Maybe<Scalars['String']['output']>;
  sourceUserSignature?: Maybe<Scalars['String']['output']>;
  transactionsInCreditNoteDocumentTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  transactionsInFreeOfChargeDocumentTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  transactionsInRefundInvoiceDocumentTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  transactionsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProfileDataInfoAggregateSelection = {
  __typename?: 'ProfileDataInfoAggregateSelection';
  count: Scalars['Int']['output'];
  editedUserPicture: StringAggregateSelectionNullable;
  editedUserSignature: StringAggregateSelectionNullable;
  notificationCount: IntAggregateSelectionNullable;
  questsCount: IntAggregateSelectionNullable;
  sourceUserPicture: StringAggregateSelectionNullable;
  sourceUserSignature: StringAggregateSelectionNullable;
};

export type ProfileDataInfoEdge = {
  __typename?: 'ProfileDataInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ProfileDataInfo;
};

export type ProfileDataInfoInput = {
  currentLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isQuerySourceImage?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  notificationCount?: InputMaybe<Scalars['Int']['input']>;
  questsCount?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProfileDataInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProfileDataInfoSort objects to sort ProfileDataInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProfileDataInfoSort>>;
};

/** Fields to sort ProfileDataInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProfileDataInfoSort object. */
export type ProfileDataInfoSort = {
  defaultMessageSharingType?: InputMaybe<SortDirection>;
  editedUserPicture?: InputMaybe<SortDirection>;
  editedUserSignature?: InputMaybe<SortDirection>;
  isSignatureCreationDraw?: InputMaybe<SortDirection>;
  notificationCount?: InputMaybe<SortDirection>;
  questsCount?: InputMaybe<SortDirection>;
  sourceUserPicture?: InputMaybe<SortDirection>;
  sourceUserSignature?: InputMaybe<SortDirection>;
};

export type ProfileDataInfoWhere = {
  AND?: InputMaybe<Array<ProfileDataInfoWhere>>;
  NOT?: InputMaybe<ProfileDataInfoWhere>;
  OR?: InputMaybe<Array<ProfileDataInfoWhere>>;
  agreementsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  defaultMessageSharingType?: InputMaybe<DocumentMessageSharingType>;
  defaultMessageSharingType_IN?: InputMaybe<Array<InputMaybe<DocumentMessageSharingType>>>;
  documentsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  documentsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editedUserPicture_MATCHES?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  editedUserSignature?: InputMaybe<Scalars['String']['input']>;
  editedUserSignature_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  editedUserSignature_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  editedUserSignature_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editedUserSignature_MATCHES?: InputMaybe<Scalars['String']['input']>;
  editedUserSignature_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  formsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  isSignatureCreationDraw?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCount?: InputMaybe<Scalars['Int']['input']>;
  notificationCount_GT?: InputMaybe<Scalars['Int']['input']>;
  notificationCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  notificationCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notificationCount_LT?: InputMaybe<Scalars['Int']['input']>;
  notificationCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  questsCount?: InputMaybe<Scalars['Int']['input']>;
  questsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  questsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  questsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  questsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  questsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  recordsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  recordsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  simulationsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  simulationsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceUserPicture_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUserSignature?: InputMaybe<Scalars['String']['input']>;
  sourceUserSignature_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceUserSignature_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUserSignature_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceUserSignature_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceUserSignature_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInCreditNoteDocumentTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionsInCreditNoteDocumentTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionsInFreeOfChargeDocumentTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  transactionsInRefundInvoiceDocumentTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionsInRefundInvoiceDocumentTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  transactionsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileDataInfosConnection = {
  __typename?: 'ProfileDataInfosConnection';
  edges: Array<ProfileDataInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  editedUserPicture?: Maybe<Scalars['String']['output']>;
  sourceUserPicture?: Maybe<Scalars['String']['output']>;
};

export type ProfileImageAggregateSelection = {
  __typename?: 'ProfileImageAggregateSelection';
  count: Scalars['Int']['output'];
  editedUserPicture: StringAggregateSelectionNullable;
  sourceUserPicture: StringAggregateSelectionNullable;
};

export type ProfileImageEdge = {
  __typename?: 'ProfileImageEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ProfileImage;
};

export type ProfileImageOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ProfileImageSort objects to sort ProfileImages by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ProfileImageSort>>;
};

/** Fields to sort ProfileImages by. The order in which sorts are applied is not guaranteed when specifying many fields in one ProfileImageSort object. */
export type ProfileImageSort = {
  editedUserPicture?: InputMaybe<SortDirection>;
  sourceUserPicture?: InputMaybe<SortDirection>;
};

export type ProfileImageWhere = {
  AND?: InputMaybe<Array<ProfileImageWhere>>;
  NOT?: InputMaybe<ProfileImageWhere>;
  OR?: InputMaybe<Array<ProfileImageWhere>>;
  editedUserPicture?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editedUserPicture_MATCHES?: InputMaybe<Scalars['String']['input']>;
  editedUserPicture_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceUserPicture_MATCHES?: InputMaybe<Scalars['String']['input']>;
  sourceUserPicture_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileImagesConnection = {
  __typename?: 'ProfileImagesConnection';
  edges: Array<ProfileImageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreement = {
  __typename?: 'PublicAgreement';
  TADI?: Maybe<Array<Maybe<Tadi>>>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedOn?: Maybe<Scalars['String']['output']>;
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  archetype?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountriesInAgreement>;
  countryAggregate?: Maybe<PublicAgreementCountriesInAgreementCountryAggregationSelection>;
  countryConnection: PublicAgreementCountryConnection;
  diseaseNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  diseases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  formattedCountry?: Maybe<Scalars['String']['output']>;
  formattedDiseaseNames?: Maybe<Scalars['String']['output']>;
  formattedManufacturers?: Maybe<Scalars['String']['output']>;
  formattedMeasures?: Maybe<Scalars['String']['output']>;
  formattedModels?: Maybe<Scalars['String']['output']>;
  formattedRegion?: Maybe<Scalars['String']['output']>;
  formattedTherapeuticAreas?: Maybe<Scalars['String']['output']>;
  hasRenegotiations?: Maybe<Scalars['Boolean']['output']>;
  hta?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  indication?: Maybe<Scalars['String']['output']>;
  manufacturers?: Maybe<Array<Scalars['String']['output']>>;
  manufacturersReference?: Maybe<Array<Scalars['String']['output']>>;
  measures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mechanismOfAction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  models: Array<Scalars['String']['output']>;
  payer?: Maybe<Scalars['String']['output']>;
  payerReference?: Maybe<Array<Scalars['String']['output']>>;
  payerType?: Maybe<Scalars['String']['output']>;
  product: Scalars['String']['output'];
  productType?: Maybe<Scalars['String']['output']>;
  renegotiations: Array<PublicAgreement>;
  renegotiationsAggregate?: Maybe<PublicAgreementPublicAgreementRenegotiationsAggregationSelection>;
  renegotiationsConnection: PublicAgreementRenegotiationsConnection;
  sources: Array<Maybe<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  therapeuticAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uncertainties: Array<Uncertainty>;
  uncertaintiesAggregate?: Maybe<PublicAgreementUncertaintyUncertaintiesAggregationSelection>;
  uncertaintiesConnection: PublicAgreementUncertaintiesConnection;
  uncertaintiesReference?: Maybe<Array<Scalars['String']['output']>>;
  year?: Maybe<Scalars['Int']['output']>;
};


export type PublicAgreementCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountriesInAgreementOptions>;
  where?: InputMaybe<CountriesInAgreementWhere>;
};


export type PublicAgreementCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountriesInAgreementWhere>;
};


export type PublicAgreementCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PublicAgreementCountryConnectionSort>>;
  where?: InputMaybe<PublicAgreementCountryConnectionWhere>;
};


export type PublicAgreementRenegotiationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PublicAgreementOptions>;
  where?: InputMaybe<PublicAgreementWhere>;
};


export type PublicAgreementRenegotiationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PublicAgreementWhere>;
};


export type PublicAgreementRenegotiationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PublicAgreementRenegotiationsConnectionSort>>;
  where?: InputMaybe<PublicAgreementRenegotiationsConnectionWhere>;
};


export type PublicAgreementUncertaintiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UncertaintyOptions>;
  where?: InputMaybe<UncertaintyWhere>;
};


export type PublicAgreementUncertaintiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UncertaintyWhere>;
};


export type PublicAgreementUncertaintiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PublicAgreementUncertaintiesConnectionSort>>;
  where?: InputMaybe<PublicAgreementUncertaintiesConnectionWhere>;
};

export type PublicAgreementCountriesInAgreementCountryAggregationSelection = {
  __typename?: 'PublicAgreementCountriesInAgreementCountryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PublicAgreementCountriesInAgreementCountryNodeAggregateSelection>;
};

export type PublicAgreementCountriesInAgreementCountryNodeAggregateSelection = {
  __typename?: 'PublicAgreementCountriesInAgreementCountryNodeAggregateSelection';
  ISO_A3: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
  region: StringAggregateSelectionNullable;
};

export type PublicAgreementCountryAggregateInput = {
  AND?: InputMaybe<Array<PublicAgreementCountryAggregateInput>>;
  NOT?: InputMaybe<PublicAgreementCountryAggregateInput>;
  OR?: InputMaybe<Array<PublicAgreementCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PublicAgreementCountryNodeAggregationWhereInput>;
};

export type PublicAgreementCountryConnection = {
  __typename?: 'PublicAgreementCountryConnection';
  edges: Array<PublicAgreementCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementCountryConnectionSort = {
  node?: InputMaybe<CountriesInAgreementSort>;
};

export type PublicAgreementCountryConnectionWhere = {
  AND?: InputMaybe<Array<PublicAgreementCountryConnectionWhere>>;
  NOT?: InputMaybe<PublicAgreementCountryConnectionWhere>;
  OR?: InputMaybe<Array<PublicAgreementCountryConnectionWhere>>;
  node?: InputMaybe<CountriesInAgreementWhere>;
};

export type PublicAgreementCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PublicAgreementCountryNodeAggregationWhereInput>>;
  ISO_A3_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ISO_A3_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  ISO_A3_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  ISO_A3_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  ISO_A3_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  ISO_A3_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  ISO_A3_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<PublicAgreementCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PublicAgreementCountryNodeAggregationWhereInput>>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  region_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  region_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  region_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  region_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  region_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  region_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  region_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  region_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  region_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  region_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  region_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  region_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  region_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  region_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  region_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreementCountryRelationship = {
  __typename?: 'PublicAgreementCountryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CountriesInAgreement;
};

export type PublicAgreementOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicAgreementSort objects to sort PublicAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicAgreementSort>>;
};

export type PublicAgreementProductPrice = {
  __typename?: 'PublicAgreementProductPrice';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  company: Scalars['String']['output'];
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  hospclass?: Maybe<Scalars['String']['output']>;
  mnfclass?: Maybe<Scalars['String']['output']>;
  pcid: Scalars['String']['output'];
  ppeVatclass?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<PriceData>>>;
  productGroup: Scalars['String']['output'];
};

export type PublicAgreementProductPriceAggregateSelection = {
  __typename?: 'PublicAgreementProductPriceAggregateSelection';
  company: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  country: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNonNullable;
  description: StringAggregateSelectionNonNullable;
  hospclass: StringAggregateSelectionNullable;
  mnfclass: StringAggregateSelectionNullable;
  pcid: StringAggregateSelectionNonNullable;
  ppeVatclass: StringAggregateSelectionNullable;
  productGroup: StringAggregateSelectionNonNullable;
};

export type PublicAgreementProductPriceEdge = {
  __typename?: 'PublicAgreementProductPriceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicAgreementProductPrice;
};

export type PublicAgreementProductPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicAgreementProductPriceSort objects to sort PublicAgreementProductPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicAgreementProductPriceSort>>;
};

/** Fields to sort PublicAgreementProductPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementProductPriceSort object. */
export type PublicAgreementProductPriceSort = {
  company?: InputMaybe<SortDirection>;
  country?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  hospclass?: InputMaybe<SortDirection>;
  mnfclass?: InputMaybe<SortDirection>;
  pcid?: InputMaybe<SortDirection>;
  ppeVatclass?: InputMaybe<SortDirection>;
  productGroup?: InputMaybe<SortDirection>;
};

export type PublicAgreementProductPriceWhere = {
  AND?: InputMaybe<Array<PublicAgreementProductPriceWhere>>;
  NOT?: InputMaybe<PublicAgreementProductPriceWhere>;
  OR?: InputMaybe<Array<PublicAgreementProductPriceWhere>>;
  company?: InputMaybe<Scalars['String']['input']>;
  company_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  company_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  company_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  company_MATCHES?: InputMaybe<Scalars['String']['input']>;
  company_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  country_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  country_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  country_MATCHES?: InputMaybe<Scalars['String']['input']>;
  country_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hospclass?: InputMaybe<Scalars['String']['input']>;
  hospclass_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  hospclass_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  hospclass_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hospclass_MATCHES?: InputMaybe<Scalars['String']['input']>;
  hospclass_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  mnfclass?: InputMaybe<Scalars['String']['input']>;
  mnfclass_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  mnfclass_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  mnfclass_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mnfclass_MATCHES?: InputMaybe<Scalars['String']['input']>;
  mnfclass_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pcid?: InputMaybe<Scalars['String']['input']>;
  pcid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pcid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pcid_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  pcid_MATCHES?: InputMaybe<Scalars['String']['input']>;
  pcid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ppeVatclass?: InputMaybe<Scalars['String']['input']>;
  ppeVatclass_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  ppeVatclass_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  ppeVatclass_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ppeVatclass_MATCHES?: InputMaybe<Scalars['String']['input']>;
  ppeVatclass_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  productGroup?: InputMaybe<Scalars['String']['input']>;
  productGroup_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  productGroup_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  productGroup_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  productGroup_MATCHES?: InputMaybe<Scalars['String']['input']>;
  productGroup_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type PublicAgreementProductPricesConnection = {
  __typename?: 'PublicAgreementProductPricesConnection';
  edges: Array<PublicAgreementProductPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementPublicAgreementRenegotiationsAggregationSelection = {
  __typename?: 'PublicAgreementPublicAgreementRenegotiationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PublicAgreementPublicAgreementRenegotiationsNodeAggregateSelection>;
};

export type PublicAgreementPublicAgreementRenegotiationsNodeAggregateSelection = {
  __typename?: 'PublicAgreementPublicAgreementRenegotiationsNodeAggregateSelection';
  addedOn: StringAggregateSelectionNullable;
  archetype: StringAggregateSelectionNullable;
  formattedCountry: StringAggregateSelectionNullable;
  formattedDiseaseNames: StringAggregateSelectionNullable;
  formattedManufacturers: StringAggregateSelectionNullable;
  formattedMeasures: StringAggregateSelectionNullable;
  formattedModels: StringAggregateSelectionNullable;
  formattedRegion: StringAggregateSelectionNullable;
  formattedTherapeuticAreas: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  indication: StringAggregateSelectionNullable;
  payer: StringAggregateSelectionNullable;
  payerType: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  productType: StringAggregateSelectionNullable;
  status: StringAggregateSelectionNullable;
  summary: StringAggregateSelectionNullable;
  year: IntAggregateSelectionNullable;
};

export type PublicAgreementRenegotiationsAggregateInput = {
  AND?: InputMaybe<Array<PublicAgreementRenegotiationsAggregateInput>>;
  NOT?: InputMaybe<PublicAgreementRenegotiationsAggregateInput>;
  OR?: InputMaybe<Array<PublicAgreementRenegotiationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PublicAgreementRenegotiationsNodeAggregationWhereInput>;
};

export type PublicAgreementRenegotiationsConnection = {
  __typename?: 'PublicAgreementRenegotiationsConnection';
  edges: Array<PublicAgreementRenegotiationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementRenegotiationsConnectionSort = {
  node?: InputMaybe<PublicAgreementSort>;
};

export type PublicAgreementRenegotiationsConnectionWhere = {
  AND?: InputMaybe<Array<PublicAgreementRenegotiationsConnectionWhere>>;
  NOT?: InputMaybe<PublicAgreementRenegotiationsConnectionWhere>;
  OR?: InputMaybe<Array<PublicAgreementRenegotiationsConnectionWhere>>;
  node?: InputMaybe<PublicAgreementWhere>;
};

export type PublicAgreementRenegotiationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PublicAgreementRenegotiationsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PublicAgreementRenegotiationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PublicAgreementRenegotiationsNodeAggregationWhereInput>>;
  addedOn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedOn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedOn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedOn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedOn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedOn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedOn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedOn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedOn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedOn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedOn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedOn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  archetype_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  archetype_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  archetype_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  archetype_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  archetype_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  archetype_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  archetype_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  archetype_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  archetype_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  archetype_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  archetype_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  archetype_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  archetype_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  archetype_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  archetype_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCountry_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCountry_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCountry_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCountry_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCountry_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCountry_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseaseNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseaseNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseaseNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseaseNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseaseNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseaseNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedManufacturers_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedManufacturers_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedManufacturers_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedManufacturers_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedManufacturers_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedManufacturers_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedMeasures_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedMeasures_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedMeasures_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedMeasures_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedMeasures_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedMeasures_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedModels_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedModels_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedModels_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedModels_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedModels_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedModels_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedRegion_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedRegion_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedRegion_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedRegion_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedRegion_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedRegion_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTherapeuticAreas_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTherapeuticAreas_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTherapeuticAreas_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTherapeuticAreas_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTherapeuticAreas_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTherapeuticAreas_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indication_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payerType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payerType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  payerType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  payerType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  payerType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  payerType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payerType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payerType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payerType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payerType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payerType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payerType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payerType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payerType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payerType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payer_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payer_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  payer_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  payer_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  payer_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  payer_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payer_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payer_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payer_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payer_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payer_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  payer_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  payer_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  payer_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  payer_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  productType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  productType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  productType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  productType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  productType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  status_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  status_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  status_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  summary_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  summary_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  summary_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  year_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  year_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  year_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  year_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreementRenegotiationsRelationship = {
  __typename?: 'PublicAgreementRenegotiationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicAgreement;
};

/** Fields to sort PublicAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementSort object. */
export type PublicAgreementSort = {
  addedOn?: InputMaybe<SortDirection>;
  archetype?: InputMaybe<SortDirection>;
  formattedCountry?: InputMaybe<SortDirection>;
  formattedDiseaseNames?: InputMaybe<SortDirection>;
  formattedManufacturers?: InputMaybe<SortDirection>;
  formattedMeasures?: InputMaybe<SortDirection>;
  formattedModels?: InputMaybe<SortDirection>;
  formattedRegion?: InputMaybe<SortDirection>;
  formattedTherapeuticAreas?: InputMaybe<SortDirection>;
  hasRenegotiations?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indication?: InputMaybe<SortDirection>;
  payer?: InputMaybe<SortDirection>;
  payerType?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  productType?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  summary?: InputMaybe<SortDirection>;
  year?: InputMaybe<SortDirection>;
};

export type PublicAgreementUncertaintiesAggregateInput = {
  AND?: InputMaybe<Array<PublicAgreementUncertaintiesAggregateInput>>;
  NOT?: InputMaybe<PublicAgreementUncertaintiesAggregateInput>;
  OR?: InputMaybe<Array<PublicAgreementUncertaintiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PublicAgreementUncertaintiesNodeAggregationWhereInput>;
};

export type PublicAgreementUncertaintiesConnection = {
  __typename?: 'PublicAgreementUncertaintiesConnection';
  edges: Array<PublicAgreementUncertaintiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementUncertaintiesConnectionSort = {
  node?: InputMaybe<UncertaintySort>;
};

export type PublicAgreementUncertaintiesConnectionWhere = {
  AND?: InputMaybe<Array<PublicAgreementUncertaintiesConnectionWhere>>;
  NOT?: InputMaybe<PublicAgreementUncertaintiesConnectionWhere>;
  OR?: InputMaybe<Array<PublicAgreementUncertaintiesConnectionWhere>>;
  node?: InputMaybe<UncertaintyWhere>;
};

export type PublicAgreementUncertaintiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PublicAgreementUncertaintiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PublicAgreementUncertaintiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PublicAgreementUncertaintiesNodeAggregationWhereInput>>;
  explanation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  explanation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  explanation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  explanation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreementUncertaintiesRelationship = {
  __typename?: 'PublicAgreementUncertaintiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Uncertainty;
};

export type PublicAgreementUncertaintyUncertaintiesAggregationSelection = {
  __typename?: 'PublicAgreementUncertaintyUncertaintiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PublicAgreementUncertaintyUncertaintiesNodeAggregateSelection>;
};

export type PublicAgreementUncertaintyUncertaintiesNodeAggregateSelection = {
  __typename?: 'PublicAgreementUncertaintyUncertaintiesNodeAggregateSelection';
  explanation: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
};

export enum PublicAgreementView {
  Dashboard = 'DASHBOARD',
  List = 'LIST'
}

export type PublicAgreementWhere = {
  AND?: InputMaybe<Array<PublicAgreementWhere>>;
  NOT?: InputMaybe<PublicAgreementWhere>;
  OR?: InputMaybe<Array<PublicAgreementWhere>>;
  addedOn?: InputMaybe<Scalars['String']['input']>;
  addedOn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  addedOn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  addedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  addedOn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  addedOn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aliases_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  archetype?: InputMaybe<Scalars['String']['input']>;
  archetype_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  archetype_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  archetype_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archetype_MATCHES?: InputMaybe<Scalars['String']['input']>;
  archetype_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountriesInAgreementWhere>;
  countryAggregate?: InputMaybe<PublicAgreementCountryAggregateInput>;
  countryConnection?: InputMaybe<PublicAgreementCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<PublicAgreementCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountriesInAgreementWhere>;
  diseaseNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  diseaseNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  diseases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  diseases_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  formattedCountry?: InputMaybe<Scalars['String']['input']>;
  formattedCountry_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedCountry_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedCountry_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedCountry_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedCountry_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseaseNames?: InputMaybe<Scalars['String']['input']>;
  formattedDiseaseNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedDiseaseNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedDiseaseNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedDiseaseNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedDiseaseNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedManufacturers?: InputMaybe<Scalars['String']['input']>;
  formattedManufacturers_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedManufacturers_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedManufacturers_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedManufacturers_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedManufacturers_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedMeasures?: InputMaybe<Scalars['String']['input']>;
  formattedMeasures_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedMeasures_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedMeasures_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedMeasures_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedMeasures_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedModels?: InputMaybe<Scalars['String']['input']>;
  formattedModels_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedModels_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedModels_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedModels_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedModels_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedRegion?: InputMaybe<Scalars['String']['input']>;
  formattedRegion_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedRegion_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedRegion_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedRegion_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedRegion_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTherapeuticAreas?: InputMaybe<Scalars['String']['input']>;
  formattedTherapeuticAreas_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTherapeuticAreas_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTherapeuticAreas_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTherapeuticAreas_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTherapeuticAreas_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasRenegotiations?: InputMaybe<Scalars['Boolean']['input']>;
  hta?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hta_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indication?: InputMaybe<Scalars['String']['input']>;
  indication_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indication_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indication_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indication_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indication_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturersReference?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturersReference_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  manufacturers_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  measures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  measures_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  mechanismOfAction?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mechanismOfAction_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  models_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  payer?: InputMaybe<Scalars['String']['input']>;
  payerReference?: InputMaybe<Array<Scalars['String']['input']>>;
  payerReference_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  payerType?: InputMaybe<Scalars['String']['input']>;
  payerType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  payerType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  payerType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  payerType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  payer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  payer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  payer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payer_MATCHES?: InputMaybe<Scalars['String']['input']>;
  payer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  productType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  productType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  productType_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  productType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  renegotiationsAggregate?: InputMaybe<PublicAgreementRenegotiationsAggregateInput>;
  /** Return PublicAgreements where all of the related PublicAgreementRenegotiationsConnections match this filter */
  renegotiationsConnection_ALL?: InputMaybe<PublicAgreementRenegotiationsConnectionWhere>;
  /** Return PublicAgreements where none of the related PublicAgreementRenegotiationsConnections match this filter */
  renegotiationsConnection_NONE?: InputMaybe<PublicAgreementRenegotiationsConnectionWhere>;
  /** Return PublicAgreements where one of the related PublicAgreementRenegotiationsConnections match this filter */
  renegotiationsConnection_SINGLE?: InputMaybe<PublicAgreementRenegotiationsConnectionWhere>;
  /** Return PublicAgreements where some of the related PublicAgreementRenegotiationsConnections match this filter */
  renegotiationsConnection_SOME?: InputMaybe<PublicAgreementRenegotiationsConnectionWhere>;
  /** Return PublicAgreements where all of the related PublicAgreements match this filter */
  renegotiations_ALL?: InputMaybe<PublicAgreementWhere>;
  /** Return PublicAgreements where none of the related PublicAgreements match this filter */
  renegotiations_NONE?: InputMaybe<PublicAgreementWhere>;
  /** Return PublicAgreements where one of the related PublicAgreements match this filter */
  renegotiations_SINGLE?: InputMaybe<PublicAgreementWhere>;
  /** Return PublicAgreements where some of the related PublicAgreements match this filter */
  renegotiations_SOME?: InputMaybe<PublicAgreementWhere>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sources_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  status_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  status_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_MATCHES?: InputMaybe<Scalars['String']['input']>;
  status_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  summary_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  summary_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  summary_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  summary_MATCHES?: InputMaybe<Scalars['String']['input']>;
  summary_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticAreas?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  therapeuticAreas_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  uncertaintiesAggregate?: InputMaybe<PublicAgreementUncertaintiesAggregateInput>;
  /** Return PublicAgreements where all of the related PublicAgreementUncertaintiesConnections match this filter */
  uncertaintiesConnection_ALL?: InputMaybe<PublicAgreementUncertaintiesConnectionWhere>;
  /** Return PublicAgreements where none of the related PublicAgreementUncertaintiesConnections match this filter */
  uncertaintiesConnection_NONE?: InputMaybe<PublicAgreementUncertaintiesConnectionWhere>;
  /** Return PublicAgreements where one of the related PublicAgreementUncertaintiesConnections match this filter */
  uncertaintiesConnection_SINGLE?: InputMaybe<PublicAgreementUncertaintiesConnectionWhere>;
  /** Return PublicAgreements where some of the related PublicAgreementUncertaintiesConnections match this filter */
  uncertaintiesConnection_SOME?: InputMaybe<PublicAgreementUncertaintiesConnectionWhere>;
  uncertaintiesReference?: InputMaybe<Array<Scalars['String']['input']>>;
  uncertaintiesReference_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  /** Return PublicAgreements where all of the related Uncertainties match this filter */
  uncertainties_ALL?: InputMaybe<UncertaintyWhere>;
  /** Return PublicAgreements where none of the related Uncertainties match this filter */
  uncertainties_NONE?: InputMaybe<UncertaintyWhere>;
  /** Return PublicAgreements where one of the related Uncertainties match this filter */
  uncertainties_SINGLE?: InputMaybe<UncertaintyWhere>;
  /** Return PublicAgreements where some of the related Uncertainties match this filter */
  uncertainties_SOME?: InputMaybe<UncertaintyWhere>;
  year?: InputMaybe<Scalars['Int']['input']>;
  year_GT?: InputMaybe<Scalars['Int']['input']>;
  year_GTE?: InputMaybe<Scalars['Int']['input']>;
  year_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  year_LT?: InputMaybe<Scalars['Int']['input']>;
  year_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreements = {
  __typename?: 'PublicAgreements';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  displayedPublicAgreements?: Maybe<Array<PublicAgreement>>;
  filteredPublicAgreementsCount?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PublicAgreementsAggregateSelection = {
  __typename?: 'PublicAgreementsAggregateSelection';
  count: Scalars['Int']['output'];
  filteredPublicAgreementsCount: IntAggregateSelectionNullable;
  totalCount: IntAggregateSelectionNullable;
};

export type PublicAgreementsConnection = {
  __typename?: 'PublicAgreementsConnection';
  edges: Array<PublicAgreementsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementsCount = {
  __typename?: 'PublicAgreementsCount';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  oldestAgreementYear?: Maybe<Scalars['Int']['output']>;
  publicAgreementsCount?: Maybe<Scalars['Int']['output']>;
};

export type PublicAgreementsCountAggregateSelection = {
  __typename?: 'PublicAgreementsCountAggregateSelection';
  count: Scalars['Int']['output'];
  oldestAgreementYear: IntAggregateSelectionNullable;
  publicAgreementsCount: IntAggregateSelectionNullable;
};

export type PublicAgreementsCountEdge = {
  __typename?: 'PublicAgreementsCountEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicAgreementsCount;
};

export type PublicAgreementsCountOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicAgreementsCountSort objects to sort PublicAgreementsCounts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicAgreementsCountSort>>;
};

/** Fields to sort PublicAgreementsCounts by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementsCountSort object. */
export type PublicAgreementsCountSort = {
  oldestAgreementYear?: InputMaybe<SortDirection>;
  publicAgreementsCount?: InputMaybe<SortDirection>;
};

export type PublicAgreementsCountWhere = {
  AND?: InputMaybe<Array<PublicAgreementsCountWhere>>;
  NOT?: InputMaybe<PublicAgreementsCountWhere>;
  OR?: InputMaybe<Array<PublicAgreementsCountWhere>>;
  oldestAgreementYear?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_GT?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  oldestAgreementYear_LT?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_LTE?: InputMaybe<Scalars['Int']['input']>;
  publicAgreementsCount?: InputMaybe<Scalars['Int']['input']>;
  publicAgreementsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  publicAgreementsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  publicAgreementsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publicAgreementsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  publicAgreementsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreementsCountsConnection = {
  __typename?: 'PublicAgreementsCountsConnection';
  edges: Array<PublicAgreementsCountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementsDashboardResult = {
  __typename?: 'PublicAgreementsDashboardResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  countries: Array<CountriesForDashboard>;
  latestAgreements: Array<PublicAgreement>;
  manufacturers: Array<DashboardFieldDetails>;
  models: Array<DashboardFieldDetails>;
  oldestAgreementYear?: Maybe<Scalars['Int']['output']>;
  payers: Array<DashboardFieldDetails>;
  productTypes: Array<DashboardFieldDetails>;
  runningAgreementCount: Scalars['Int']['output'];
  therapeuticAreas: Array<DashboardFieldDetails>;
  totalAgreementCount: Scalars['Int']['output'];
};

export type PublicAgreementsDashboardResultAggregateSelection = {
  __typename?: 'PublicAgreementsDashboardResultAggregateSelection';
  count: Scalars['Int']['output'];
  oldestAgreementYear: IntAggregateSelectionNullable;
  runningAgreementCount: IntAggregateSelectionNonNullable;
  totalAgreementCount: IntAggregateSelectionNonNullable;
};

export type PublicAgreementsDashboardResultEdge = {
  __typename?: 'PublicAgreementsDashboardResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicAgreementsDashboardResult;
};

export type PublicAgreementsDashboardResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicAgreementsDashboardResultSort objects to sort PublicAgreementsDashboardResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicAgreementsDashboardResultSort>>;
};

/** Fields to sort PublicAgreementsDashboardResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementsDashboardResultSort object. */
export type PublicAgreementsDashboardResultSort = {
  oldestAgreementYear?: InputMaybe<SortDirection>;
  runningAgreementCount?: InputMaybe<SortDirection>;
  totalAgreementCount?: InputMaybe<SortDirection>;
};

export type PublicAgreementsDashboardResultWhere = {
  AND?: InputMaybe<Array<PublicAgreementsDashboardResultWhere>>;
  NOT?: InputMaybe<PublicAgreementsDashboardResultWhere>;
  OR?: InputMaybe<Array<PublicAgreementsDashboardResultWhere>>;
  oldestAgreementYear?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_GT?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_GTE?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  oldestAgreementYear_LT?: InputMaybe<Scalars['Int']['input']>;
  oldestAgreementYear_LTE?: InputMaybe<Scalars['Int']['input']>;
  runningAgreementCount?: InputMaybe<Scalars['Int']['input']>;
  runningAgreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  runningAgreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  runningAgreementCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  runningAgreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  runningAgreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAgreementCount?: InputMaybe<Scalars['Int']['input']>;
  totalAgreementCount_GT?: InputMaybe<Scalars['Int']['input']>;
  totalAgreementCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalAgreementCount_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalAgreementCount_LT?: InputMaybe<Scalars['Int']['input']>;
  totalAgreementCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreementsDashboardResultsConnection = {
  __typename?: 'PublicAgreementsDashboardResultsConnection';
  edges: Array<PublicAgreementsDashboardResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementsEdge = {
  __typename?: 'PublicAgreementsEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicAgreements;
};

export type PublicAgreementsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicAgreementsSort objects to sort PublicAgreements by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicAgreementsSort>>;
};

/** Fields to sort PublicAgreements by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementsSort object. */
export type PublicAgreementsSort = {
  filteredPublicAgreementsCount?: InputMaybe<SortDirection>;
  totalCount?: InputMaybe<SortDirection>;
};

export type PublicAgreementsTableSourceFilterData = {
  __typename?: 'PublicAgreementsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  countries: Array<Scalars['String']['output']>;
  diseases: Array<Scalars['String']['output']>;
  hasRenegotiations?: Maybe<Scalars['Boolean']['output']>;
  hta: Array<Maybe<Scalars['String']['output']>>;
  manufacturers: Array<Scalars['String']['output']>;
  measures: Array<Scalars['String']['output']>;
  mechanismsOfAction: Array<Scalars['String']['output']>;
  models: Array<Scalars['String']['output']>;
  payers: Array<Scalars['String']['output']>;
  productTypes: Array<Scalars['String']['output']>;
  products: Array<Scalars['String']['output']>;
  regions: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  therapeuticAreas: Array<Scalars['String']['output']>;
  uncertainties: Array<Scalars['String']['output']>;
  years: Array<Scalars['Int']['output']>;
};

export type PublicAgreementsTableSourceFilterDataAggregateSelection = {
  __typename?: 'PublicAgreementsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
};

export type PublicAgreementsTableSourceFilterDataConnection = {
  __typename?: 'PublicAgreementsTableSourceFilterDataConnection';
  edges: Array<PublicAgreementsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PublicAgreementsTableSourceFilterDataEdge = {
  __typename?: 'PublicAgreementsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicAgreementsTableSourceFilterData;
};

export type PublicAgreementsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicAgreementsTableSourceFilterDataSort objects to sort PublicAgreementsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicAgreementsTableSourceFilterDataSort>>;
};

/** Fields to sort PublicAgreementsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicAgreementsTableSourceFilterDataSort object. */
export type PublicAgreementsTableSourceFilterDataSort = {
  hasRenegotiations?: InputMaybe<SortDirection>;
};

export type PublicAgreementsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<PublicAgreementsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<PublicAgreementsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<PublicAgreementsTableSourceFilterDataWhere>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  countries_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  diseases?: InputMaybe<Array<Scalars['String']['input']>>;
  diseases_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  hasRenegotiations?: InputMaybe<Scalars['Boolean']['input']>;
  hta?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hta_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  manufacturers?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturers_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  measures?: InputMaybe<Array<Scalars['String']['input']>>;
  measures_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  mechanismsOfAction?: InputMaybe<Array<Scalars['String']['input']>>;
  mechanismsOfAction_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  models_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  payers?: InputMaybe<Array<Scalars['String']['input']>>;
  payers_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  productTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  products_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
  regions_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  therapeuticAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  therapeuticAreas_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  uncertainties?: InputMaybe<Array<Scalars['String']['input']>>;
  uncertainties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  years?: InputMaybe<Array<Scalars['Int']['input']>>;
  years_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicAgreementsWhere = {
  AND?: InputMaybe<Array<PublicAgreementsWhere>>;
  NOT?: InputMaybe<PublicAgreementsWhere>;
  OR?: InputMaybe<Array<PublicAgreementsWhere>>;
  filteredPublicAgreementsCount?: InputMaybe<Scalars['Int']['input']>;
  filteredPublicAgreementsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  filteredPublicAgreementsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  filteredPublicAgreementsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filteredPublicAgreementsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  filteredPublicAgreementsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  totalCount_GT?: InputMaybe<Scalars['Int']['input']>;
  totalCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  totalCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalCount_LT?: InputMaybe<Scalars['Int']['input']>;
  totalCount_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicPrice = {
  __typename?: 'PublicPrice';
  Price?: Maybe<Scalars['String']['output']>;
  ValidFromDate?: Maybe<Scalars['Date']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
};

export type PublicPriceAggregateSelection = {
  __typename?: 'PublicPriceAggregateSelection';
  Price: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
};

export type PublicPriceEdge = {
  __typename?: 'PublicPriceEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PublicPrice;
};

export type PublicPriceOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PublicPriceSort objects to sort PublicPrices by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PublicPriceSort>>;
};

/** Fields to sort PublicPrices by. The order in which sorts are applied is not guaranteed when specifying many fields in one PublicPriceSort object. */
export type PublicPriceSort = {
  Price?: InputMaybe<SortDirection>;
  ValidFromDate?: InputMaybe<SortDirection>;
};

export type PublicPriceWhere = {
  AND?: InputMaybe<Array<PublicPriceWhere>>;
  NOT?: InputMaybe<PublicPriceWhere>;
  OR?: InputMaybe<Array<PublicPriceWhere>>;
  Price?: InputMaybe<Scalars['String']['input']>;
  Price_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Price_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Price_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  Price_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Price_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  ValidFromDate?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  ValidFromDate_LT?: InputMaybe<Scalars['Date']['input']>;
  ValidFromDate_LTE?: InputMaybe<Scalars['Date']['input']>;
};

export type PublicPricesConnection = {
  __typename?: 'PublicPricesConnection';
  edges: Array<PublicPriceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Purchase = {
  __typename?: 'Purchase';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  assignedFlexEntities: Array<FlexEntity>;
  assignedFlexEntitiesAggregate?: Maybe<PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection>;
  assignedFlexEntitiesConnection: PurchaseAssignedFlexEntitiesConnection;
  id: Scalars['ID']['output'];
  lastUpdateDate: Scalars['DateTime']['output'];
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  purchaseId: Scalars['String']['output'];
  refunds: Array<Refund>;
  refundsAggregate?: Maybe<PurchaseRefundRefundsAggregationSelection>;
  refundsConnection: PurchaseRefundsConnection;
  tenantId?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};


export type PurchaseAssignedFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PurchaseAssignedFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type PurchaseAssignedFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PurchaseAssignedFlexEntitiesConnectionSort>>;
  where?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
};


export type PurchaseRefundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type PurchaseRefundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RefundWhere>;
};


export type PurchaseRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PurchaseRefundsConnectionSort>>;
  where?: InputMaybe<PurchaseRefundsConnectionWhere>;
};

export type PurchaseAggregateSelection = {
  __typename?: 'PurchaseAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  purchaseId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type PurchaseAssignedFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<PurchaseAssignedFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<PurchaseAssignedFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<PurchaseAssignedFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>;
};

export type PurchaseAssignedFlexEntitiesConnection = {
  __typename?: 'PurchaseAssignedFlexEntitiesConnection';
  edges: Array<PurchaseAssignedFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchaseAssignedFlexEntitiesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type PurchaseAssignedFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<PurchaseAssignedFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<PurchaseAssignedFlexEntitiesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type PurchaseAssignedFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PurchaseAssignedFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type PurchaseAssignedFlexEntitiesRelationship = {
  __typename?: 'PurchaseAssignedFlexEntitiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Purchase;
};

export type PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection = {
  __typename?: 'PurchaseFlexEntityAssignedFlexEntitiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection>;
};

export type PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection = {
  __typename?: 'PurchaseFlexEntityAssignedFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type PurchaseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more PurchaseSort objects to sort Purchases by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<PurchaseSort>>;
};

export type PurchaseRefundRefundsAggregationSelection = {
  __typename?: 'PurchaseRefundRefundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<PurchaseRefundRefundsNodeAggregateSelection>;
};

export type PurchaseRefundRefundsNodeAggregateSelection = {
  __typename?: 'PurchaseRefundRefundsNodeAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type PurchaseRefundsAggregateInput = {
  AND?: InputMaybe<Array<PurchaseRefundsAggregateInput>>;
  NOT?: InputMaybe<PurchaseRefundsAggregateInput>;
  OR?: InputMaybe<Array<PurchaseRefundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<PurchaseRefundsNodeAggregationWhereInput>;
};

export type PurchaseRefundsConnection = {
  __typename?: 'PurchaseRefundsConnection';
  edges: Array<PurchaseRefundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PurchaseRefundsConnectionSort = {
  node?: InputMaybe<RefundSort>;
};

export type PurchaseRefundsConnectionWhere = {
  AND?: InputMaybe<Array<PurchaseRefundsConnectionWhere>>;
  NOT?: InputMaybe<PurchaseRefundsConnectionWhere>;
  OR?: InputMaybe<Array<PurchaseRefundsConnectionWhere>>;
  node?: InputMaybe<RefundWhere>;
};

export type PurchaseRefundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PurchaseRefundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<PurchaseRefundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<PurchaseRefundsNodeAggregationWhereInput>>;
  adjustedAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  adjustmentComment_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  amount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caseOrAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  iin_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  iin_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  iin_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastAdjustedAt_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  removedFromDocumentId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PurchaseRefundsRelationship = {
  __typename?: 'PurchaseRefundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

/** Fields to sort Purchases by. The order in which sorts are applied is not guaranteed when specifying many fields in one PurchaseSort object. */
export type PurchaseSort = {
  id?: InputMaybe<SortDirection>;
  lastUpdateDate?: InputMaybe<SortDirection>;
  purchaseDate?: InputMaybe<SortDirection>;
  purchaseId?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  totalAmount?: InputMaybe<SortDirection>;
};

export type PurchaseWhere = {
  AND?: InputMaybe<Array<PurchaseWhere>>;
  NOT?: InputMaybe<PurchaseWhere>;
  OR?: InputMaybe<Array<PurchaseWhere>>;
  assignedFlexEntitiesAggregate?: InputMaybe<PurchaseAssignedFlexEntitiesAggregateInput>;
  /** Return Purchases where all of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_ALL?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where none of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_NONE?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where one of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SINGLE?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where some of the related PurchaseAssignedFlexEntitiesConnections match this filter */
  assignedFlexEntitiesConnection_SOME?: InputMaybe<PurchaseAssignedFlexEntitiesConnectionWhere>;
  /** Return Purchases where all of the related FlexEntities match this filter */
  assignedFlexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Purchases where none of the related FlexEntities match this filter */
  assignedFlexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Purchases where one of the related FlexEntities match this filter */
  assignedFlexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Purchases where some of the related FlexEntities match this filter */
  assignedFlexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdateDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdateDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_GT?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  purchaseDate_LT?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  purchaseId?: InputMaybe<Scalars['String']['input']>;
  purchaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundsAggregate?: InputMaybe<PurchaseRefundsAggregateInput>;
  /** Return Purchases where all of the related PurchaseRefundsConnections match this filter */
  refundsConnection_ALL?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where none of the related PurchaseRefundsConnections match this filter */
  refundsConnection_NONE?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where one of the related PurchaseRefundsConnections match this filter */
  refundsConnection_SINGLE?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where some of the related PurchaseRefundsConnections match this filter */
  refundsConnection_SOME?: InputMaybe<PurchaseRefundsConnectionWhere>;
  /** Return Purchases where all of the related Refunds match this filter */
  refunds_ALL?: InputMaybe<RefundWhere>;
  /** Return Purchases where none of the related Refunds match this filter */
  refunds_NONE?: InputMaybe<RefundWhere>;
  /** Return Purchases where one of the related Refunds match this filter */
  refunds_SINGLE?: InputMaybe<RefundWhere>;
  /** Return Purchases where some of the related Refunds match this filter */
  refunds_SOME?: InputMaybe<RefundWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type PurchasesConnection = {
  __typename?: 'PurchasesConnection';
  edges: Array<PurchaseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  CanDeleteFlexEntities: CanDeleteFlexEntityOutput;
  CurrentOrganization: Organization;
  DownloadSmartMipInvoicePdf?: Maybe<SmartMipInvoicePdfResult>;
  GetAdverseEventData?: Maybe<AdverseEventReport>;
  GetAgreementIdFromInvoiceId?: Maybe<Scalars['ID']['output']>;
  GetAgreementRelatedOrganizationsByEnrolledEntityId: Array<Organization>;
  GetAgreementUserRoles: Array<TenantSpecificAgreementUserRole>;
  GetAgreementsTableSourceFilterData: AgreementsTableSourceFilterData;
  GetAllAgreementsSpecificRoles: Array<AgreementSpecificRole>;
  GetAllDataPointsByDate?: Maybe<Array<FlexFinancialDataPoint>>;
  GetAllDataPointsByPrescriptionDate?: Maybe<Array<FlexFinancialDataPoint>>;
  GetAllModels: Array<Model>;
  GetAllUsersFromOrganization: Array<UserOrganizationInfo>;
  GetApproverSignaturesAndInfo: Array<DocumentApprovalUsersInfo>;
  GetAssignee?: Maybe<Array<Maybe<User>>>;
  GetAvailableCaseAssignees?: Maybe<Array<Maybe<User>>>;
  GetBlobImage?: Maybe<Scalars['String']['output']>;
  GetCasesTableSourceFilterData: CasesTableSourceFilterData;
  GetComparableModels: Array<Model>;
  GetCoreConfiguration?: Maybe<CoreConfigurationData>;
  GetCounterpartiesInReview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GetDefaultAgreementRoles: Array<DefaultAgreementRoleInfo>;
  GetDefaultReceiver?: Maybe<Scalars['String']['output']>;
  GetDiscontinuationNoteAdministrations: AdministrationsDiscontinuationNote;
  GetDocumentCounterpartyOrganization?: Maybe<Organization>;
  GetDocumentCreatorOrganization?: Maybe<Organization>;
  GetDocumentExportFieldDefaults?: Maybe<DocumentExportFieldDefaults>;
  GetDocumentMessageAttachment?: Maybe<Scalars['String']['output']>;
  GetDocumentXmlReport: DocumentXmlReport;
  GetDocumentsPendingSmartMipReview: Array<SmartMipPendingDocument>;
  GetDocumentsTableSourceFilterData: DocumentsTableSourceFilterData;
  GetDuplicateClaims?: Maybe<Array<Maybe<Record>>>;
  GetExternalExposures: Array<ExternalExposure>;
  GetExternalExposuresByDocumentId: Array<ExternalExposure>;
  GetFavoriteModels: Array<Model>;
  GetFilteredModelsCount: Scalars['Int']['output'];
  GetFlexEntitiesCount?: Maybe<Scalars['Int']['output']>;
  GetFocDataFromInvoiceId: Array<FocTableData>;
  GetFormsTableSourceFilterData: FormsTableSourceFilterData;
  GetGeneralConfiguration: Array<UserOrgSettingsData>;
  GetGeneralConfigurationWithDomains: Array<UserOrgSettingsData>;
  GetImpossibleToEditAttributes: Array<ImpossibleToEditAttribute>;
  GetInboxQuests?: Maybe<Array<InboxQuest>>;
  GetIsSourceKeysUnique?: Maybe<Scalars['Boolean']['output']>;
  GetLibraryUsersWithDomain: Array<User>;
  GetMessages?: Maybe<Array<Maybe<Message>>>;
  GetMissingKeys?: Maybe<Scalars['String']['output']>;
  GetModelById?: Maybe<Model>;
  GetModels: Models;
  GetModelsCount: Scalars['Int']['output'];
  GetModelsSourceFilterData: ModelsSourceFilterData;
  GetNotificationCount?: Maybe<ProfileDataInfo>;
  GetOrganizationAgreementTags: Array<Scalars['String']['output']>;
  GetOrganizationCaselessAgreementStatus: OrganizationCaselessAgreementStatus;
  GetOrganizationDomainsWithCounters: OrganizationDomainsWithCounters;
  GetPdfReportFile: PdfReportFile;
  GetPdfToken: PdfToken;
  GetPotentialCounterparties: Array<Organization>;
  GetProductBlueprintsForCurrentUser: Array<Maybe<ProductBlueprint>>;
  GetPublicAgreementById?: Maybe<PublicAgreement>;
  GetPublicAgreementPrices: Array<Maybe<PublicAgreementProductPrice>>;
  GetPublicAgreementUnfurlData?: Maybe<UnfurlUrl>;
  GetPublicAgreementView?: Maybe<PublicAgreementView>;
  GetPublicAgreements: PublicAgreements;
  GetPublicAgreementsForDashboard: PublicAgreementsDashboardResult;
  GetPublicAgreementsForDownload?: Maybe<Array<Maybe<DownloadablePublicAgreement>>>;
  GetPublicAgreementsSourceFilterData: PublicAgreementsTableSourceFilterData;
  GetQuestViewTableSourceFilterData: QuestViewTableSourceFilterData;
  GetQuestsTableSourceFilterData: QuestsTableSourceFilterData;
  GetRecordsTableSourceFilterData: RecordsTableSourceFilterData;
  GetRefundsTableSourceFilterData: RefundsTableSourceFilterData;
  GetRelatedModels: Array<Model>;
  GetRevokableRecords: RevokableRecordsReport;
  GetSanitizedCaseEventLogs: Array<CaseEventLog>;
  GetSimilarCases: Array<Case>;
  GetSimulationUserRoles: Array<Maybe<SimulationUserWithRole>>;
  GetSimulationsTableSourceFilterData: SimulationsTableSourceFilterData;
  GetSmartMipInvoicesAvailable: Scalars['Boolean']['output'];
  GetThreadMessageCount: Scalars['Int']['output'];
  GetTranslations: TranslationsResult;
  GetUnknownPreparationIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  GetUploadReport?: Maybe<FlexEntityUploadReport>;
  GetUploadState?: Maybe<FlexEntityUploadProgress>;
  GetUserComparisonSimulations?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersAgreements?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersCaseEventLogs?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersCases?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersDataForms?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersDataQuests?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersDataRecords?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersDocuments?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersInboxNotification?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersOrganizationSettings?: Maybe<Scalars['String']['output']>;
  GetUserContextFiltersRefunds?: Maybe<Scalars['String']['output']>;
  GetUserContextTimePeriodFilterReporting?: Maybe<Scalars['String']['output']>;
  GetUserCreatedSimulationsCount?: Maybe<SimulationCountResult>;
  GetUserDomainName: Array<Scalars['String']['output']>;
  GetUserDomainsTree: Array<Domain>;
  GetUserFieldsForUpload: Array<Scalars['String']['output']>;
  GetUserFiltersDataSimulations?: Maybe<Scalars['String']['output']>;
  GetUserFiltersModels?: Maybe<Scalars['String']['output']>;
  GetUserFiltersPublicAgreements?: Maybe<Scalars['String']['output']>;
  GetUserLoginDates?: Maybe<UserLoginDates>;
  GetUserProfileInfoData?: Maybe<ProfileDataInfo>;
  GetUserProfilePicture?: Maybe<ProfileImage>;
  GetUserRoles?: Maybe<MyRoleProfile>;
  GetUsersToMentionOnCaseMessage: Array<User>;
  GetUsersToMentionOnDocumentMessage: Array<User>;
  GetValidatedComparison: ValidatedComparisonResponse;
  GetWorkflows?: Maybe<Array<ContractWorkflow>>;
  InvoiceCounterPartiesUsers?: Maybe<Array<Maybe<User>>>;
  IsDualApprovalSupportedForDocument: Scalars['Boolean']['output'];
  OrganizationFromTenantId: Organization;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedTransactionsInfos: Array<AddedTransactionsInfo>;
  addedTransactionsInfosAggregate: AddedTransactionsInfoAggregateSelection;
  addedTransactionsInfosConnection: AddedTransactionsInfosConnection;
  administrationsDiscontinuationNotes: Array<AdministrationsDiscontinuationNote>;
  administrationsDiscontinuationNotesAggregate: AdministrationsDiscontinuationNoteAggregateSelection;
  administrationsDiscontinuationNotesConnection: AdministrationsDiscontinuationNotesConnection;
  adverseEventCounterparties: Array<AdverseEventCounterparties>;
  adverseEventCounterpartiesAggregate: AdverseEventCounterpartiesAggregateSelection;
  adverseEventCounterpartiesConnection: AdverseEventCounterpartiesConnection;
  adverseEventReportItems: Array<AdverseEventReportItem>;
  adverseEventReportItemsAggregate: AdverseEventReportItemAggregateSelection;
  adverseEventReportItemsConnection: AdverseEventReportItemsConnection;
  adverseEventReports: Array<AdverseEventReport>;
  adverseEventReportsAggregate: AdverseEventReportAggregateSelection;
  adverseEventReportsConnection: AdverseEventReportsConnection;
  adverseEventsOccurenceReports: Array<AdverseEventsOccurenceReport>;
  adverseEventsOccurenceReportsAggregate: AdverseEventsOccurenceReportAggregateSelection;
  adverseEventsOccurenceReportsConnection: AdverseEventsOccurenceReportsConnection;
  agreementDecisions: Array<AgreementDecision>;
  agreementDecisionsAggregate: AgreementDecisionAggregateSelection;
  agreementDecisionsConnection: AgreementDecisionsConnection;
  agreementReports: Array<AgreementReport>;
  agreementReportsAggregate: AgreementReportAggregateSelection;
  agreementReportsConnection: AgreementReportsConnection;
  agreementRunAttemptInfos: Array<AgreementRunAttemptInfo>;
  agreementRunAttemptInfosAggregate: AgreementRunAttemptInfoAggregateSelection;
  agreementRunAttemptInfosConnection: AgreementRunAttemptInfosConnection;
  agreementRuns: Array<AgreementRun>;
  agreementRunsAggregate: AgreementRunAggregateSelection;
  agreementRunsConnection: AgreementRunsConnection;
  agreementScopeCountryScopes: Array<AgreementScopeCountryScope>;
  agreementScopeCountryScopesAggregate: AgreementScopeCountryScopeAggregateSelection;
  agreementScopeCountryScopesConnection: AgreementScopeCountryScopesConnection;
  agreementScopeOrganizationScopes: Array<AgreementScopeOrganizationScope>;
  agreementScopeOrganizationScopesAggregate: AgreementScopeOrganizationScopeAggregateSelection;
  agreementScopeOrganizationScopesConnection: AgreementScopeOrganizationScopesConnection;
  agreementScopes: Array<AgreementScope>;
  agreementScopesAggregate: AgreementScopeAggregateSelection;
  agreementScopesConnection: AgreementScopesConnection;
  agreementSpecificRoles: Array<AgreementSpecificRole>;
  agreementSpecificRolesAggregate: AgreementSpecificRoleAggregateSelection;
  agreementSpecificRolesConnection: AgreementSpecificRolesConnection;
  agreementSpecificUserRoles: Array<AgreementSpecificUserRole>;
  agreementSpecificUserRolesAggregate: AgreementSpecificUserRoleAggregateSelection;
  agreementSpecificUserRolesConnection: AgreementSpecificUserRolesConnection;
  agreementStatusTransitions: Array<AgreementStatusTransition>;
  agreementStatusTransitionsAggregate: AgreementStatusTransitionAggregateSelection;
  agreementStatusTransitionsConnection: AgreementStatusTransitionsConnection;
  agreementTableRows: Array<AgreementTableRow>;
  agreementTableRowsAggregate: AgreementTableRowAggregateSelection;
  agreementTableRowsConnection: AgreementTableRowsConnection;
  agreementTagRoles: Array<AgreementTagRole>;
  agreementTagRolesAggregate: AgreementTagRoleAggregateSelection;
  agreementTagRolesConnection: AgreementTagRolesConnection;
  agreementTags: Array<AgreementTag>;
  agreementTagsAggregate: AgreementTagAggregateSelection;
  agreementTagsConnection: AgreementTagsConnection;
  agreementTemplates: Array<AgreementTemplate>;
  agreementTemplatesAggregate: AgreementTemplateAggregateSelection;
  agreementTemplatesConnection: AgreementTemplatesConnection;
  agreements: Array<Agreement>;
  agreementsAggregate: AgreementAggregateSelection;
  agreementsConnection: AgreementsConnection;
  agreementsTableSourceFilterData: Array<AgreementsTableSourceFilterData>;
  agreementsTableSourceFilterDataAggregate: AgreementsTableSourceFilterDataAggregateSelection;
  agreementsTableSourceFilterDataConnection: AgreementsTableSourceFilterDataConnection;
  amountRanges: Array<AmountRange>;
  amountRangesAggregate: AmountRangeAggregateSelection;
  amountRangesConnection: AmountRangesConnection;
  article71Indications: Array<Article71Indication>;
  article71IndicationsAggregate: Article71IndicationAggregateSelection;
  article71IndicationsConnection: Article71IndicationsConnection;
  authOrganizations: Array<AuthOrganization>;
  authOrganizationsAggregate: AuthOrganizationAggregateSelection;
  authOrganizationsConnection: AuthOrganizationsConnection;
  averageGenericPrices: Array<AverageGenericPrice>;
  averageGenericPricesAggregate: AverageGenericPriceAggregateSelection;
  averageGenericPricesConnection: AverageGenericPricesConnection;
  averageLaPressureAndLaVolumeRows: Array<AverageLaPressureAndLaVolumeRow>;
  averageLaPressureAndLaVolumeRowsAggregate: AverageLaPressureAndLaVolumeRowAggregateSelection;
  averageLaPressureAndLaVolumeRowsConnection: AverageLaPressureAndLaVolumeRowsConnection;
  baseAgreements: Array<BaseAgreement>;
  baseAgreementsAggregate: BaseAgreementAggregateSelection;
  baseAgreementsConnection: BaseAgreementsConnection;
  baseUserInfos: Array<BaseUserInfo>;
  baseUserInfosAggregate: BaseUserInfoAggregateSelection;
  baseUserInfosConnection: BaseUserInfosConnection;
  brands: Array<Brand>;
  brandsAggregate: BrandAggregateSelection;
  brandsConnection: BrandsConnection;
  canDeleteFlexEntityOutputs: Array<CanDeleteFlexEntityOutput>;
  canDeleteFlexEntityOutputsAggregate: CanDeleteFlexEntityOutputAggregateSelection;
  canDeleteFlexEntityOutputsConnection: CanDeleteFlexEntityOutputsConnection;
  caseEventLogs: Array<CaseEventLog>;
  caseEventLogsAggregate: CaseEventLogAggregateSelection;
  caseEventLogsConnection: CaseEventLogsConnection;
  caseHistoryRecords: Array<CaseHistoryRecord>;
  caseHistoryRecordsAggregate: CaseHistoryRecordAggregateSelection;
  caseHistoryRecordsConnection: CaseHistoryRecordsConnection;
  caseInfos: Array<CaseInfo>;
  caseInfosAggregate: CaseInfoAggregateSelection;
  caseInfosConnection: CaseInfosConnection;
  caseReportDataPoints: Array<CaseReportDataPoint>;
  caseReportDataPointsAggregate: CaseReportDataPointAggregateSelection;
  caseReportDataPointsConnection: CaseReportDataPointsConnection;
  caseReportingData: Array<CaseReportingData>;
  caseReportingDataAggregate: CaseReportingDataAggregateSelection;
  caseReportingDataConnection: CaseReportingDataConnection;
  caseTableRows: Array<CaseTableRow>;
  caseTableRowsAggregate: CaseTableRowAggregateSelection;
  caseTableRowsConnection: CaseTableRowsConnection;
  caselessAgreementReports: Array<CaselessAgreementReport>;
  caselessAgreementReportsAggregate: CaselessAgreementReportAggregateSelection;
  caselessAgreementReportsConnection: CaselessAgreementReportsConnection;
  cases: Array<Case>;
  casesAggregate: CaseAggregateSelection;
  casesConnection: CasesConnection;
  casesTableSourceFilterData: Array<CasesTableSourceFilterData>;
  casesTableSourceFilterDataAggregate: CasesTableSourceFilterDataAggregateSelection;
  casesTableSourceFilterDataConnection: CasesTableSourceFilterDataConnection;
  catalogueAttributes: Array<CatalogueAttribute>;
  catalogueAttributesAggregate: CatalogueAttributeAggregateSelection;
  catalogueAttributesConnection: CatalogueAttributesConnection;
  chartRangeConfigurations: Array<ChartRangeConfiguration>;
  chartRangeConfigurationsAggregate: ChartRangeConfigurationAggregateSelection;
  chartRangeConfigurationsConnection: ChartRangeConfigurationsConnection;
  companies: Array<Company>;
  companiesAggregate: CompanyAggregateSelection;
  companiesConnection: CompaniesConnection;
  companyImages: Array<CompanyImage>;
  companyImagesAggregate: CompanyImageAggregateSelection;
  companyImagesConnection: CompanyImagesConnection;
  contractWorkflowSteps: Array<ContractWorkflowStep>;
  contractWorkflowStepsAggregate: ContractWorkflowStepAggregateSelection;
  contractWorkflowStepsConnection: ContractWorkflowStepsConnection;
  contractWorkflows: Array<ContractWorkflow>;
  contractWorkflowsAggregate: ContractWorkflowAggregateSelection;
  contractWorkflowsConnection: ContractWorkflowsConnection;
  coreConfigurationData: Array<CoreConfigurationData>;
  coreConfigurationDataAggregate: CoreConfigurationDataAggregateSelection;
  coreConfigurationDataConnection: CoreConfigurationDataConnection;
  countries: Array<Country>;
  countriesAggregate: CountryAggregateSelection;
  countriesConnection: CountriesConnection;
  countriesForDashboards: Array<CountriesForDashboard>;
  countriesForDashboardsAggregate: CountriesForDashboardAggregateSelection;
  countriesForDashboardsConnection: CountriesForDashboardsConnection;
  countriesInAgreements: Array<CountriesInAgreement>;
  countriesInAgreementsAggregate: CountriesInAgreementAggregateSelection;
  countriesInAgreementsConnection: CountriesInAgreementsConnection;
  createDocumentMessageResults: Array<CreateDocumentMessageResult>;
  createDocumentMessageResultsAggregate: CreateDocumentMessageResultAggregateSelection;
  createDocumentMessageResultsConnection: CreateDocumentMessageResultsConnection;
  crossCountryPrices: Array<CrossCountryPrice>;
  crossCountryPricesAggregate: CrossCountryPriceAggregateSelection;
  crossCountryPricesConnection: CrossCountryPricesConnection;
  currencies: Array<Currency>;
  currenciesAggregate: CurrencyAggregateSelection;
  currenciesConnection: CurrenciesConnection;
  customConditions: Array<CustomCondition>;
  customConditionsAggregate: CustomConditionAggregateSelection;
  customConditionsConnection: CustomConditionsConnection;
  customIntegrityChecks: Array<CustomIntegrityCheck>;
  customIntegrityChecksAggregate: CustomIntegrityCheckAggregateSelection;
  customIntegrityChecksConnection: CustomIntegrityChecksConnection;
  cycleConfigurations: Array<CycleConfiguration>;
  cycleConfigurationsAggregate: CycleConfigurationAggregateSelection;
  cycleConfigurationsConnection: CycleConfigurationsConnection;
  cycleTherapyConfigurations: Array<CycleTherapyConfiguration>;
  cycleTherapyConfigurationsAggregate: CycleTherapyConfigurationAggregateSelection;
  cycleTherapyConfigurationsConnection: CycleTherapyConfigurationsConnection;
  dashboardFieldDetails: Array<DashboardFieldDetails>;
  dashboardFieldDetailsAggregate: DashboardFieldDetailsAggregateSelection;
  dashboardFieldDetailsConnection: DashboardFieldDetailsConnection;
  dataContainers: Array<DataContainer>;
  dataContainersAggregate: DataContainerAggregateSelection;
  dataContainersConnection: DataContainersConnection;
  dataSources: Array<DataSource>;
  dataSourcesAggregate: DataSourceAggregateSelection;
  dataSourcesConnection: DataSourcesConnection;
  databaseCleanupJobInfos: Array<DatabaseCleanupJobInfo>;
  databaseCleanupJobInfosAggregate: DatabaseCleanupJobInfoAggregateSelection;
  databaseCleanupJobInfosConnection: DatabaseCleanupJobInfosConnection;
  defaultAgreementRoleInfos: Array<DefaultAgreementRoleInfo>;
  defaultAgreementRoleInfosAggregate: DefaultAgreementRoleInfoAggregateSelection;
  defaultAgreementRoleInfosConnection: DefaultAgreementRoleInfosConnection;
  deviceAlternatives: Array<DeviceAlternative>;
  deviceAlternativesAggregate: DeviceAlternativeAggregateSelection;
  deviceAlternativesConnection: DeviceAlternativesConnection;
  diseaseFilterData: Array<DiseaseFilterData>;
  diseaseFilterDataAggregate: DiseaseFilterDataAggregateSelection;
  diseaseFilterDataConnection: DiseaseFilterDataConnection;
  diseases: Array<Disease>;
  diseasesAggregate: DiseaseAggregateSelection;
  diseasesConnection: DiseasesConnection;
  documentApprovalUsersInfos: Array<DocumentApprovalUsersInfo>;
  documentApprovalUsersInfosAggregate: DocumentApprovalUsersInfoAggregateSelection;
  documentApprovalUsersInfosConnection: DocumentApprovalUsersInfosConnection;
  documentAttachmentProgressEvents: Array<DocumentAttachmentProgressEvent>;
  documentAttachmentProgressEventsAggregate: DocumentAttachmentProgressEventAggregateSelection;
  documentAttachmentProgressEventsConnection: DocumentAttachmentProgressEventsConnection;
  documentExportFieldDefaults: Array<DocumentExportFieldDefaults>;
  documentExportFieldDefaultsAggregate: DocumentExportFieldDefaultsAggregateSelection;
  documentExportFieldDefaultsConnection: DocumentExportFieldDefaultsConnection;
  documentMessages: Array<DocumentMessage>;
  documentMessagesAggregate: DocumentMessageAggregateSelection;
  documentMessagesConnection: DocumentMessagesConnection;
  documentRefundGroups: Array<DocumentRefundGroup>;
  documentRefundGroupsAggregate: DocumentRefundGroupAggregateSelection;
  documentRefundGroupsConnection: DocumentRefundGroupsConnection;
  documentTableRows: Array<DocumentTableRow>;
  documentTableRowsAggregate: DocumentTableRowAggregateSelection;
  documentTableRowsConnection: DocumentTableRowsConnection;
  documentThreadUpdates: Array<DocumentThreadUpdate>;
  documentThreadUpdatesAggregate: DocumentThreadUpdateAggregateSelection;
  documentThreadUpdatesConnection: DocumentThreadUpdatesConnection;
  documentUpdateds: Array<DocumentUpdated>;
  documentUpdatedsAggregate: DocumentUpdatedAggregateSelection;
  documentUpdatedsConnection: DocumentUpdatedsConnection;
  documentUploadInfos: Array<DocumentUploadInfo>;
  documentUploadInfosAggregate: DocumentUploadInfoAggregateSelection;
  documentUploadInfosConnection: DocumentUploadInfosConnection;
  documentXmlReports: Array<DocumentXmlReport>;
  documentXmlReportsAggregate: DocumentXmlReportAggregateSelection;
  documentXmlReportsConnection: DocumentXmlReportsConnection;
  documents: Array<Document>;
  documentsAggregate: DocumentAggregateSelection;
  documentsConnection: DocumentsConnection;
  documentsTableSourceFilterData: Array<DocumentsTableSourceFilterData>;
  documentsTableSourceFilterDataAggregate: DocumentsTableSourceFilterDataAggregateSelection;
  documentsTableSourceFilterDataConnection: DocumentsTableSourceFilterDataConnection;
  domains: Array<Domain>;
  domainsAggregate: DomainAggregateSelection;
  domainsConnection: DomainsConnection;
  downloadablePublicAgreements: Array<DownloadablePublicAgreement>;
  downloadablePublicAgreementsAggregate: DownloadablePublicAgreementAggregateSelection;
  downloadablePublicAgreementsConnection: DownloadablePublicAgreementsConnection;
  dummyEnumReferences: Array<DummyEnumReferences>;
  dummyEnumReferencesAggregate: DummyEnumReferencesAggregateSelection;
  dummyEnumReferencesConnection: DummyEnumReferencesConnection;
  eligibilityConditionSets: Array<EligibilityConditionSet>;
  eligibilityConditionSetsAggregate: EligibilityConditionSetAggregateSelection;
  eligibilityConditionSetsConnection: EligibilityConditionSetsConnection;
  encapsulatedFeatureConfigurations: Array<EncapsulatedFeatureConfiguration>;
  encapsulatedFeatureConfigurationsAggregate: EncapsulatedFeatureConfigurationAggregateSelection;
  encapsulatedFeatureConfigurationsConnection: EncapsulatedFeatureConfigurationsConnection;
  encapsulatedFeatures: Array<EncapsulatedFeature>;
  encapsulatedFeaturesAggregate: EncapsulatedFeatureAggregateSelection;
  encapsulatedFeaturesConnection: EncapsulatedFeaturesConnection;
  enrollingConditionSets: Array<EnrollingConditionSet>;
  enrollingConditionSetsAggregate: EnrollingConditionSetAggregateSelection;
  enrollingConditionSetsConnection: EnrollingConditionSetsConnection;
  enrollingConditions: Array<EnrollingCondition>;
  enrollingConditionsAggregate: EnrollingConditionAggregateSelection;
  enrollingConditionsConnection: EnrollingConditionsConnection;
  enrollingPeriods: Array<EnrollingPeriod>;
  enrollingPeriodsAggregate: EnrollingPeriodAggregateSelection;
  enrollingPeriodsConnection: EnrollingPeriodsConnection;
  environmentImpacts: Array<EnvironmentImpact>;
  environmentImpactsAggregate: EnvironmentImpactAggregateSelection;
  environmentImpactsConnection: EnvironmentImpactsConnection;
  exFactoryPrices: Array<ExFactoryPrice>;
  exFactoryPricesAggregate: ExFactoryPriceAggregateSelection;
  exFactoryPricesConnection: ExFactoryPricesConnection;
  expectedRunAgreements: Array<ExpectedRunAgreement>;
  expectedRunAgreementsAggregate: ExpectedRunAgreementAggregateSelection;
  expectedRunAgreementsConnection: ExpectedRunAgreementsConnection;
  expenditureDistributionDataPoints: Array<ExpenditureDistributionDataPoint>;
  expenditureDistributionDataPointsAggregate: ExpenditureDistributionDataPointAggregateSelection;
  expenditureDistributionDataPointsConnection: ExpenditureDistributionDataPointsConnection;
  expenditureDistributionStatuses: Array<ExpenditureDistributionStatus>;
  expenditureDistributionStatusesAggregate: ExpenditureDistributionStatusAggregateSelection;
  expenditureDistributionStatusesConnection: ExpenditureDistributionStatusesConnection;
  externalExposures: Array<ExternalExposure>;
  externalExposuresAggregate: ExternalExposureAggregateSelection;
  externalExposuresConnection: ExternalExposuresConnection;
  financialReportDataPoints: Array<FinancialReportDataPoint>;
  financialReportDataPointsAggregate: FinancialReportDataPointAggregateSelection;
  financialReportDataPointsConnection: FinancialReportDataPointsConnection;
  financialSummaryColumns: Array<FinancialSummaryColumn>;
  financialSummaryColumnsAggregate: FinancialSummaryColumnAggregateSelection;
  financialSummaryColumnsConnection: FinancialSummaryColumnsConnection;
  financialSummaryRows: Array<FinancialSummaryRow>;
  financialSummaryRowsAggregate: FinancialSummaryRowAggregateSelection;
  financialSummaryRowsConnection: FinancialSummaryRowsConnection;
  flexEntities: Array<FlexEntity>;
  flexEntitiesAggregate: FlexEntityAggregateSelection;
  flexEntitiesConnection: FlexEntitiesConnection;
  flexEntityAttributeValidations: Array<FlexEntityAttributeValidation>;
  flexEntityAttributeValidationsAggregate: FlexEntityAttributeValidationAggregateSelection;
  flexEntityAttributeValidationsConnection: FlexEntityAttributeValidationsConnection;
  flexEntityBulkProgresses: Array<FlexEntityBulkProgress>;
  flexEntityBulkProgressesAggregate: FlexEntityBulkProgressAggregateSelection;
  flexEntityBulkProgressesConnection: FlexEntityBulkProgressesConnection;
  flexEntityTypes: Array<FlexEntityType>;
  flexEntityTypesAggregate: FlexEntityTypeAggregateSelection;
  flexEntityTypesConnection: FlexEntityTypesConnection;
  flexEntityUploadPatientResults: Array<FlexEntityUploadPatientResult>;
  flexEntityUploadPatientResultsAggregate: FlexEntityUploadPatientResultAggregateSelection;
  flexEntityUploadPatientResultsConnection: FlexEntityUploadPatientResultsConnection;
  flexEntityUploadProgresses: Array<FlexEntityUploadProgress>;
  flexEntityUploadProgressesAggregate: FlexEntityUploadProgressAggregateSelection;
  flexEntityUploadProgressesConnection: FlexEntityUploadProgressesConnection;
  flexEntityUploadReportBasicEntries: Array<FlexEntityUploadReportBasicEntry>;
  flexEntityUploadReportBasicEntriesAggregate: FlexEntityUploadReportBasicEntryAggregateSelection;
  flexEntityUploadReportBasicEntriesConnection: FlexEntityUploadReportBasicEntriesConnection;
  flexEntityUploadReportInvalidAttributes: Array<FlexEntityUploadReportInvalidAttribute>;
  flexEntityUploadReportInvalidAttributesAggregate: FlexEntityUploadReportInvalidAttributeAggregateSelection;
  flexEntityUploadReportInvalidAttributesConnection: FlexEntityUploadReportInvalidAttributesConnection;
  flexEntityUploadReportUpdatedEntities: Array<FlexEntityUploadReportUpdatedEntity>;
  flexEntityUploadReportUpdatedEntitiesAggregate: FlexEntityUploadReportUpdatedEntityAggregateSelection;
  flexEntityUploadReportUpdatedEntitiesConnection: FlexEntityUploadReportUpdatedEntitiesConnection;
  flexEntityUploadReports: Array<FlexEntityUploadReport>;
  flexEntityUploadReportsAggregate: FlexEntityUploadReportAggregateSelection;
  flexEntityUploadReportsConnection: FlexEntityUploadReportsConnection;
  flexFinancialDataPoints: Array<FlexFinancialDataPoint>;
  flexFinancialDataPointsAggregate: FlexFinancialDataPointAggregateSelection;
  flexFinancialDataPointsConnection: FlexFinancialDataPointsConnection;
  focStatuses: Array<FocStatus>;
  focStatusesAggregate: FocStatusAggregateSelection;
  focStatusesConnection: FocStatusesConnection;
  focTableData: Array<FocTableData>;
  focTableDataAggregate: FocTableDataAggregateSelection;
  focTableDataConnection: FocTableDataConnection;
  formsTableSourceFilterData: Array<FormsTableSourceFilterData>;
  formsTableSourceFilterDataAggregate: FormsTableSourceFilterDataAggregateSelection;
  formsTableSourceFilterDataConnection: FormsTableSourceFilterDataConnection;
  generics: Array<Generic>;
  genericsAggregate: GenericAggregateSelection;
  genericsConnection: GenericsConnection;
  globalLocks: Array<GlobalLock>;
  globalLocksAggregate: GlobalLockAggregateSelection;
  globalLocksConnection: GlobalLocksConnection;
  images: Array<Image>;
  imagesAggregate: ImageAggregateSelection;
  imagesConnection: ImagesConnection;
  impossibleToEditAttributes: Array<ImpossibleToEditAttribute>;
  impossibleToEditAttributesAggregate: ImpossibleToEditAttributeAggregateSelection;
  impossibleToEditAttributesConnection: ImpossibleToEditAttributesConnection;
  inboxQuests: Array<InboxQuest>;
  inboxQuestsAggregate: InboxQuestAggregateSelection;
  inboxQuestsConnection: InboxQuestsConnection;
  indications: Array<Indication>;
  indicationsAggregate: IndicationAggregateSelection;
  indicationsConnection: IndicationsConnection;
  initialResponseReviewReports: Array<InitialResponseReviewReport>;
  initialResponseReviewReportsAggregate: InitialResponseReviewReportAggregateSelection;
  initialResponseReviewReportsConnection: InitialResponseReviewReportsConnection;
  interventionReportStatusResponses: Array<InterventionReportStatusResponse>;
  interventionReportStatusResponsesAggregate: InterventionReportStatusResponseAggregateSelection;
  interventionReportStatusResponsesConnection: InterventionReportStatusResponsesConnection;
  isFlexEntityDeletables: Array<IsFlexEntityDeletable>;
  isFlexEntityDeletablesAggregate: IsFlexEntityDeletableAggregateSelection;
  isFlexEntityDeletablesConnection: IsFlexEntityDeletablesConnection;
  itemUsedDataPoints: Array<ItemUsedDataPoint>;
  itemUsedDataPointsAggregate: ItemUsedDataPointAggregateSelection;
  itemUsedDataPointsConnection: ItemUsedDataPointsConnection;
  ldLReportingDataPoints: Array<LdLReportingDataPoint>;
  ldLReportingDataPointsAggregate: LdLReportingDataPointAggregateSelection;
  ldLReportingDataPointsConnection: LdLReportingDataPointsConnection;
  limitations: Array<Limitation>;
  limitationsAggregate: LimitationAggregateSelection;
  limitationsConnection: LimitationsConnection;
  mainIndications: Array<MainIndication>;
  mainIndicationsAggregate: MainIndicationAggregateSelection;
  mainIndicationsConnection: MainIndicationsConnection;
  messages: Array<Message>;
  messagesAggregate: MessageAggregateSelection;
  messagesConnection: MessagesConnection;
  microContents: Array<MicroContent>;
  microContentsAggregate: MicroContentAggregateSelection;
  microContentsConnection: MicroContentsConnection;
  modelImages: Array<ModelImage>;
  modelImagesAggregate: ModelImageAggregateSelection;
  modelImagesConnection: ModelImagesConnection;
  modelInAgreements: Array<ModelInAgreement>;
  modelInAgreementsAggregate: ModelInAgreementAggregateSelection;
  modelInAgreementsConnection: ModelInAgreementsConnection;
  models: Array<Model>;
  modelsAggregate: ModelAggregateSelection;
  modelsConnection: ModelsConnection;
  modelsSourceFilterData: Array<ModelsSourceFilterData>;
  modelsSourceFilterDataAggregate: ModelsSourceFilterDataAggregateSelection;
  modelsSourceFilterDataConnection: ModelsSourceFilterDataConnection;
  modules: Array<Module>;
  modulesAggregate: ModuleAggregateSelection;
  modulesConnection: ModulesConnection;
  myRoleProfiles: Array<MyRoleProfile>;
  myRoleProfilesAggregate: MyRoleProfileAggregateSelection;
  myRoleProfilesConnection: MyRoleProfilesConnection;
  negotiationRounds: Array<NegotiationRound>;
  negotiationRoundsAggregate: NegotiationRoundAggregateSelection;
  negotiationRoundsConnection: NegotiationRoundsConnection;
  netRevenueByOrganizations: Array<NetRevenueByOrganization>;
  netRevenueByOrganizationsAggregate: NetRevenueByOrganizationAggregateSelection;
  netRevenueByOrganizationsConnection: NetRevenueByOrganizationsConnection;
  ninjaQueries: Array<NinjaQuery>;
  ninjaQueriesAggregate: NinjaQueryAggregateSelection;
  ninjaQueriesConnection: NinjaQueriesConnection;
  ninjaQueryImpacts: Array<NinjaQueryImpact>;
  ninjaQueryImpactsAggregate: NinjaQueryImpactAggregateSelection;
  ninjaQueryImpactsConnection: NinjaQueryImpactsConnection;
  ninjaQuerySubmitResults: Array<NinjaQuerySubmitResult>;
  ninjaQuerySubmitResultsAggregate: NinjaQuerySubmitResultAggregateSelection;
  ninjaQuerySubmitResultsConnection: NinjaQuerySubmitResultsConnection;
  nonEligibleReasons: Array<NonEligibleReason>;
  nonEligibleReasonsAggregate: NonEligibleReasonAggregateSelection;
  nonEligibleReasonsConnection: NonEligibleReasonsConnection;
  nonEnrolledReasons: Array<NonEnrolledReason>;
  nonEnrolledReasonsAggregate: NonEnrolledReasonAggregateSelection;
  nonEnrolledReasonsConnection: NonEnrolledReasonsConnection;
  notifications: Array<Notification>;
  notificationsAggregate: NotificationAggregateSelection;
  notificationsConnection: NotificationsConnection;
  numericRanges: Array<NumericRange>;
  numericRangesAggregate: NumericRangeAggregateSelection;
  numericRangesConnection: NumericRangesConnection;
  organizationCaselessAgreementStatuses: Array<OrganizationCaselessAgreementStatus>;
  organizationCaselessAgreementStatusesAggregate: OrganizationCaselessAgreementStatusAggregateSelection;
  organizationCaselessAgreementStatusesConnection: OrganizationCaselessAgreementStatusesConnection;
  organizationDomainsWithCounters: Array<OrganizationDomainsWithCounters>;
  organizationDomainsWithCountersAggregate: OrganizationDomainsWithCountersAggregateSelection;
  organizationDomainsWithCountersConnection: OrganizationDomainsWithCountersConnection;
  organizationScopes: Array<OrganizationScope>;
  organizationScopesAggregate: OrganizationScopeAggregateSelection;
  organizationScopesConnection: OrganizationScopesConnection;
  organizations: Array<Organization>;
  organizationsAggregate: OrganizationAggregateSelection;
  organizationsConnection: OrganizationsConnection;
  outcomebasedAgreementReports: Array<OutcomebasedAgreementReport>;
  outcomebasedAgreementReportsAggregate: OutcomebasedAgreementReportAggregateSelection;
  outcomebasedAgreementReportsConnection: OutcomebasedAgreementReportsConnection;
  partners: Array<Partner>;
  partnersAggregate: PartnerAggregateSelection;
  partnersConnection: PartnersConnection;
  patientCountDataPoints: Array<PatientCountDataPoint>;
  patientCountDataPointsAggregate: PatientCountDataPointAggregateSelection;
  patientCountDataPointsConnection: PatientCountDataPointsConnection;
  patientReportDataPoints: Array<PatientReportDataPoint>;
  patientReportDataPointsAggregate: PatientReportDataPointAggregateSelection;
  patientReportDataPointsConnection: PatientReportDataPointsConnection;
  patientReviewData: Array<PatientReviewData>;
  patientReviewDataAggregate: PatientReviewDataAggregateSelection;
  patientReviewDataConnection: PatientReviewDataConnection;
  patientStatusDistributions: Array<PatientStatusDistribution>;
  patientStatusDistributionsAggregate: PatientStatusDistributionAggregateSelection;
  patientStatusDistributionsConnection: PatientStatusDistributionsConnection;
  patients: Array<Patient>;
  patientsAggregate: PatientAggregateSelection;
  patientsConnection: PatientsConnection;
  patientsPerMonthDataPoints: Array<PatientsPerMonthDataPoint>;
  patientsPerMonthDataPointsAggregate: PatientsPerMonthDataPointAggregateSelection;
  patientsPerMonthDataPointsConnection: PatientsPerMonthDataPointsConnection;
  pdfReportFiles: Array<PdfReportFile>;
  pdfReportFilesAggregate: PdfReportFileAggregateSelection;
  pdfReportFilesConnection: PdfReportFilesConnection;
  pdfTokens: Array<PdfToken>;
  pdfTokensAggregate: PdfTokenAggregateSelection;
  pdfTokensConnection: PdfTokensConnection;
  performanceCounters: Array<PerformanceCounter>;
  performanceCountersAggregate: PerformanceCounterAggregateSelection;
  performanceCountersConnection: PerformanceCountersConnection;
  performanceMeasurements: Array<PerformanceMeasurement>;
  performanceMeasurementsAggregate: PerformanceMeasurementAggregateSelection;
  performanceMeasurementsConnection: PerformanceMeasurementsConnection;
  performanceThresholds: Array<PerformanceThreshold>;
  performanceThresholdsAggregate: PerformanceThresholdAggregateSelection;
  performanceThresholdsConnection: PerformanceThresholdsConnection;
  piRecurrenceSiDataPoints: Array<PiRecurrenceSiDataPoint>;
  piRecurrenceSiDataPointsAggregate: PiRecurrenceSiDataPointAggregateSelection;
  piRecurrenceSiDataPointsConnection: PiRecurrenceSiDataPointsConnection;
  plannedAgreementRuns: Array<PlannedAgreementRun>;
  plannedAgreementRunsAggregate: PlannedAgreementRunAggregateSelection;
  plannedAgreementRunsConnection: PlannedAgreementRunsConnection;
  preparationStatuses: Array<PreparationStatus>;
  preparationStatusesAggregate: PreparationStatusAggregateSelection;
  preparationStatusesConnection: PreparationStatusesConnection;
  preparations: Array<Preparation>;
  preparationsAggregate: PreparationAggregateSelection;
  preparationsConnection: PreparationsConnection;
  priceData: Array<PriceData>;
  priceDataAggregate: PriceDataAggregateSelection;
  priceDataConnection: PriceDataConnection;
  prices: Array<Price>;
  pricesAggregate: PriceAggregateSelection;
  pricesConnection: PricesConnection;
  productBlueprints: Array<ProductBlueprint>;
  productBlueprintsAggregate: ProductBlueprintAggregateSelection;
  productBlueprintsConnection: ProductBlueprintsConnection;
  profileDataInfos: Array<ProfileDataInfo>;
  profileDataInfosAggregate: ProfileDataInfoAggregateSelection;
  profileDataInfosConnection: ProfileDataInfosConnection;
  profileImages: Array<ProfileImage>;
  profileImagesAggregate: ProfileImageAggregateSelection;
  profileImagesConnection: ProfileImagesConnection;
  publicAgreementProductPrices: Array<PublicAgreementProductPrice>;
  publicAgreementProductPricesAggregate: PublicAgreementProductPriceAggregateSelection;
  publicAgreementProductPricesConnection: PublicAgreementProductPricesConnection;
  publicAgreements: Array<PublicAgreements>;
  publicAgreementsAggregate: PublicAgreementsAggregateSelection;
  publicAgreementsConnection: PublicAgreementsConnection;
  publicAgreementsCounts: Array<PublicAgreementsCount>;
  publicAgreementsCountsAggregate: PublicAgreementsCountAggregateSelection;
  publicAgreementsCountsConnection: PublicAgreementsCountsConnection;
  publicAgreementsDashboardResults: Array<PublicAgreementsDashboardResult>;
  publicAgreementsDashboardResultsAggregate: PublicAgreementsDashboardResultAggregateSelection;
  publicAgreementsDashboardResultsConnection: PublicAgreementsDashboardResultsConnection;
  publicAgreementsTableSourceFilterData: Array<PublicAgreementsTableSourceFilterData>;
  publicAgreementsTableSourceFilterDataAggregate: PublicAgreementsTableSourceFilterDataAggregateSelection;
  publicAgreementsTableSourceFilterDataConnection: PublicAgreementsTableSourceFilterDataConnection;
  publicPrices: Array<PublicPrice>;
  publicPricesAggregate: PublicPriceAggregateSelection;
  publicPricesConnection: PublicPricesConnection;
  purchases: Array<Purchase>;
  purchasesAggregate: PurchaseAggregateSelection;
  purchasesConnection: PurchasesConnection;
  questNotifications: Array<QuestNotification>;
  questNotificationsAggregate: QuestNotificationAggregateSelection;
  questNotificationsConnection: QuestNotificationsConnection;
  questTableRows: Array<QuestTableRow>;
  questTableRowsAggregate: QuestTableRowAggregateSelection;
  questTableRowsConnection: QuestTableRowsConnection;
  questViewTableSourceFilterData: Array<QuestViewTableSourceFilterData>;
  questViewTableSourceFilterDataAggregate: QuestViewTableSourceFilterDataAggregateSelection;
  questViewTableSourceFilterDataConnection: QuestViewTableSourceFilterDataConnection;
  quests: Array<Quest>;
  questsAggregate: QuestAggregateSelection;
  questsConnection: QuestsConnection;
  questsTableSourceFilterData: Array<QuestsTableSourceFilterData>;
  questsTableSourceFilterDataAggregate: QuestsTableSourceFilterDataAggregateSelection;
  questsTableSourceFilterDataConnection: QuestsTableSourceFilterDataConnection;
  randomMicrocontentContents: Array<RandomMicrocontentContent>;
  randomMicrocontentContentsAggregate: RandomMicrocontentContentAggregateSelection;
  randomMicrocontentContentsConnection: RandomMicrocontentContentsConnection;
  reasonOfTreatmentDiscontinuationReports: Array<ReasonOfTreatmentDiscontinuationReport>;
  reasonOfTreatmentDiscontinuationReportsAggregate: ReasonOfTreatmentDiscontinuationReportAggregateSelection;
  reasonOfTreatmentDiscontinuationReportsConnection: ReasonOfTreatmentDiscontinuationReportsConnection;
  records: Array<Record>;
  recordsAggregate: RecordAggregateSelection;
  recordsConnection: RecordsConnection;
  recordsTableSourceFilterData: Array<RecordsTableSourceFilterData>;
  recordsTableSourceFilterDataAggregate: RecordsTableSourceFilterDataAggregateSelection;
  recordsTableSourceFilterDataConnection: RecordsTableSourceFilterDataConnection;
  refundTableRows: Array<RefundTableRow>;
  refundTableRowsAggregate: RefundTableRowAggregateSelection;
  refundTableRowsConnection: RefundTableRowsConnection;
  refundXmlReportData: Array<RefundXmlReportData>;
  refundXmlReportDataAggregate: RefundXmlReportDataAggregateSelection;
  refundXmlReportDataConnection: RefundXmlReportDataConnection;
  refunds: Array<Refund>;
  refundsAggregate: RefundAggregateSelection;
  refundsConnection: RefundsConnection;
  refundsTableSourceFilterData: Array<RefundsTableSourceFilterData>;
  refundsTableSourceFilterDataAggregate: RefundsTableSourceFilterDataAggregateSelection;
  refundsTableSourceFilterDataConnection: RefundsTableSourceFilterDataConnection;
  reportingDashboardSummaries: Array<ReportingDashboardSummary>;
  reportingDashboardSummariesAggregate: ReportingDashboardSummaryAggregateSelection;
  reportingDashboardSummariesConnection: ReportingDashboardSummariesConnection;
  reportingSummaries: Array<ReportingSummary>;
  reportingSummariesAggregate: ReportingSummaryAggregateSelection;
  reportingSummariesConnection: ReportingSummariesConnection;
  revokableRecordsReports: Array<RevokableRecordsReport>;
  revokableRecordsReportsAggregate: RevokableRecordsReportAggregateSelection;
  revokableRecordsReportsConnection: RevokableRecordsReportsConnection;
  saveSimulationResults: Array<SaveSimulationResult>;
  saveSimulationResultsAggregate: SaveSimulationResultAggregateSelection;
  saveSimulationResultsConnection: SaveSimulationResultsConnection;
  scenarioActions: Array<ScenarioAction>;
  scenarioActionsAggregate: ScenarioActionAggregateSelection;
  scenarioActionsConnection: ScenarioActionsConnection;
  scenarioConditions: Array<ScenarioCondition>;
  scenarioConditionsAggregate: ScenarioConditionAggregateSelection;
  scenarioConditionsConnection: ScenarioConditionsConnection;
  scenarios: Array<Scenario>;
  scenariosAggregate: ScenarioAggregateSelection;
  scenariosConnection: ScenariosConnection;
  scheduledAgreementRuns: Array<ScheduledAgreementRun>;
  scheduledAgreementRunsAggregate: ScheduledAgreementRunAggregateSelection;
  scheduledAgreementRunsConnection: ScheduledAgreementRunsConnection;
  sendDocumentToSmartMipResults: Array<SendDocumentToSmartMipResult>;
  sendDocumentToSmartMipResultsAggregate: SendDocumentToSmartMipResultAggregateSelection;
  sendDocumentToSmartMipResultsConnection: SendDocumentToSmartMipResultsConnection;
  simulationCountResults: Array<SimulationCountResult>;
  simulationCountResultsAggregate: SimulationCountResultAggregateSelection;
  simulationCountResultsConnection: SimulationCountResultsConnection;
  simulationUserWithRoles: Array<SimulationUserWithRole>;
  simulationUserWithRolesAggregate: SimulationUserWithRoleAggregateSelection;
  simulationUserWithRolesConnection: SimulationUserWithRolesConnection;
  simulations: Array<Simulation>;
  simulationsAggregate: SimulationAggregateSelection;
  simulationsConnection: SimulationsConnection;
  simulationsTableSourceFilterData: Array<SimulationsTableSourceFilterData>;
  simulationsTableSourceFilterDataAggregate: SimulationsTableSourceFilterDataAggregateSelection;
  simulationsTableSourceFilterDataConnection: SimulationsTableSourceFilterDataConnection;
  smartMipInvoicePdfResults: Array<SmartMipInvoicePdfResult>;
  smartMipInvoicePdfResultsAggregate: SmartMipInvoicePdfResultAggregateSelection;
  smartMipInvoicePdfResultsConnection: SmartMipInvoicePdfResultsConnection;
  smartMipPendingDocuments: Array<SmartMipPendingDocument>;
  smartMipPendingDocumentsAggregate: SmartMipPendingDocumentAggregateSelection;
  smartMipPendingDocumentsConnection: SmartMipPendingDocumentsConnection;
  sources: Array<Sources>;
  sourcesAggregate: SourcesAggregateSelection;
  sourcesConnection: SourcesConnection;
  svgFlags: Array<SvgFlag>;
  svgFlagsAggregate: SvgFlagAggregateSelection;
  svgFlagsConnection: SvgFlagsConnection;
  syncRefundImpacts: Array<SyncRefundImpact>;
  syncRefundImpactsAggregate: SyncRefundImpactAggregateSelection;
  syncRefundImpactsConnection: SyncRefundImpactsConnection;
  syncResponses: Array<SyncResponse>;
  syncResponsesAggregate: SyncResponseAggregateSelection;
  syncResponsesConnection: SyncResponsesConnection;
  tadis: Array<Tadi>;
  tadisAggregate: TadiAggregateSelection;
  tadisConnection: TadisConnection;
  tasks: Array<Task>;
  tasksAggregate: TaskAggregateSelection;
  tasksConnection: TasksConnection;
  tenantSpecificAgreementUserRoles: Array<TenantSpecificAgreementUserRole>;
  tenantSpecificAgreementUserRolesAggregate: TenantSpecificAgreementUserRoleAggregateSelection;
  tenantSpecificAgreementUserRolesConnection: TenantSpecificAgreementUserRolesConnection;
  translations: Array<Translation>;
  translationsAggregate: TranslationAggregateSelection;
  translationsConnection: TranslationsConnection;
  translationsResults: Array<TranslationsResult>;
  translationsResultsAggregate: TranslationsResultAggregateSelection;
  translationsResultsConnection: TranslationsResultsConnection;
  treatingPhysicians: Array<TreatingPhysician>;
  treatingPhysiciansAggregate: TreatingPhysicianAggregateSelection;
  treatingPhysiciansConnection: TreatingPhysiciansConnection;
  treatmentPatients: Array<TreatmentPatient>;
  treatmentPatientsAggregate: TreatmentPatientAggregateSelection;
  treatmentPatientsConnection: TreatmentPatientsConnection;
  treatmentSets: Array<TreatmentSet>;
  treatmentSetsAggregate: TreatmentSetAggregateSelection;
  treatmentSetsConnection: TreatmentSetsConnection;
  treatments: Array<Treatment>;
  treatmentsAggregate: TreatmentAggregateSelection;
  treatmentsConnection: TreatmentsConnection;
  uncertainties: Array<Uncertainty>;
  uncertaintiesAggregate: UncertaintyAggregateSelection;
  uncertaintiesConnection: UncertaintiesConnection;
  unfurlUrls: Array<UnfurlUrl>;
  unfurlUrlsAggregate: UnfurlUrlAggregateSelection;
  unfurlUrlsConnection: UnfurlUrlsConnection;
  uniqueModulesColumns: Array<UniqueModulesColumns>;
  uniqueModulesColumnsAggregate: UniqueModulesColumnsAggregateSelection;
  uniqueModulesColumnsConnection: UniqueModulesColumnsConnection;
  uploadFieldMappings: Array<UploadFieldMapping>;
  uploadFieldMappingsAggregate: UploadFieldMappingAggregateSelection;
  uploadFieldMappingsConnection: UploadFieldMappingsConnection;
  uploadLimitations: Array<UploadLimitation>;
  uploadLimitationsAggregate: UploadLimitationAggregateSelection;
  uploadLimitationsConnection: UploadLimitationsConnection;
  uploads: Array<Upload>;
  uploadsAggregate: UploadAggregateSelection;
  uploadsConnection: UploadsConnection;
  userContexts: Array<UserContext>;
  userContextsAggregate: UserContextAggregateSelection;
  userContextsConnection: UserContextsConnection;
  userLoginDates: Array<UserLoginDates>;
  userLoginDatesAggregate: UserLoginDatesAggregateSelection;
  userLoginDatesConnection: UserLoginDatesConnection;
  userOrgSettingsData: Array<UserOrgSettingsData>;
  userOrgSettingsDataAggregate: UserOrgSettingsDataAggregateSelection;
  userOrgSettingsDataConnection: UserOrgSettingsDataConnection;
  userOrganizationInfos: Array<UserOrganizationInfo>;
  userOrganizationInfosAggregate: UserOrganizationInfoAggregateSelection;
  userOrganizationInfosConnection: UserOrganizationInfosConnection;
  userPersonalInfos: Array<UserPersonalInfo>;
  userPersonalInfosAggregate: UserPersonalInfoAggregateSelection;
  userPersonalInfosConnection: UserPersonalInfosConnection;
  users: Array<User>;
  usersAggregate: UserAggregateSelection;
  usersConnection: UsersConnection;
  validatedComparisonResponses: Array<ValidatedComparisonResponse>;
  validatedComparisonResponsesAggregate: ValidatedComparisonResponseAggregateSelection;
  validatedComparisonResponsesConnection: ValidatedComparisonResponsesConnection;
};


export type QueryCanDeleteFlexEntitiesArgs = {
  input: Array<Scalars['String']['input']>;
};


export type QueryDownloadSmartMipInvoicePdfArgs = {
  input: DownloadSmartMipInvoicePdfInput;
};


export type QueryGetAdverseEventDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAgreementIdFromInvoiceIdArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryGetAgreementRelatedOrganizationsByEnrolledEntityIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAgreementUserRolesArgs = {
  agreementId: Scalars['ID']['input'];
};


export type QueryGetAllAgreementsSpecificRolesArgs = {
  input?: InputMaybe<OrgSettingsDataFilterInput>;
};


export type QueryGetAllDataPointsByDateArgs = {
  endDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetAllDataPointsByPrescriptionDateArgs = {
  endDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryGetAllModelsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryGetApproverSignaturesAndInfoArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryGetAssigneeArgs = {
  invoiceId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};


export type QueryGetAvailableCaseAssigneesArgs = {
  caseId: Scalars['ID']['input'];
};


export type QueryGetBlobImageArgs = {
  blobContainerType: Scalars['String']['input'];
  blobName: Scalars['String']['input'];
};


export type QueryGetDefaultAgreementRolesArgs = {
  input?: InputMaybe<OrgSettingsDataFilterInput>;
};


export type QueryGetDefaultReceiverArgs = {
  documentId: Scalars['ID']['input'];
  notificationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDiscontinuationNoteAdministrationsArgs = {
  caseId: Scalars['ID']['input'];
  discontinuationDate: Scalars['Date']['input'];
};


export type QueryGetDocumentCounterpartyOrganizationArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryGetDocumentCreatorOrganizationArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryGetDocumentExportFieldDefaultsArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryGetDocumentMessageAttachmentArgs = {
  attachmentIndex: Scalars['Int']['input'];
  messageId: Scalars['ID']['input'];
};


export type QueryGetDocumentXmlReportArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryGetDuplicateClaimsArgs = {
  ids?: InputMaybe<Array<InputMaybe<UniqueClaimsIdentifiers>>>;
};


export type QueryGetExternalExposuresByDocumentIdArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryGetFilteredModelsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ModelWhere>;
};


export type QueryGetFocDataFromInvoiceIdArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryGetGeneralConfigurationArgs = {
  input?: InputMaybe<OrgSettingsDataFilterInput>;
};


export type QueryGetGeneralConfigurationWithDomainsArgs = {
  input?: InputMaybe<OrgSettingsDataFilterInput>;
};


export type QueryGetImpossibleToEditAttributesArgs = {
  formId: Scalars['ID']['input'];
};


export type QueryGetIsSourceKeysUniqueArgs = {
  components: Array<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['FileUpload']['input']>;
};


export type QueryGetMessagesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  nodeLabel?: InputMaybe<SupportedMessageNodes>;
};


export type QueryGetMissingKeysArgs = {
  environment: Scalars['String']['input'];
};


export type QueryGetModelByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetModelsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ModelWhere>;
};


export type QueryGetModelsCountArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<ModelWhere>;
};


export type QueryGetOrganizationAgreementTagsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPdfReportFileArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryGetPdfTokenArgs = {
  documentId: Scalars['ID']['input'];
};


export type QueryGetProductBlueprintsForCurrentUserArgs = {
  domainId: Scalars['ID']['input'];
};


export type QueryGetPublicAgreementByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPublicAgreementPricesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPublicAgreementUnfurlDataArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPublicAgreementsArgs = {
  options?: InputMaybe<PublicAgreementOptions>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PublicAgreementWhere>;
};


export type QueryGetPublicAgreementsForDashboardArgs = {
  options?: InputMaybe<PublicAgreementOptions>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PublicAgreementWhere>;
};


export type QueryGetPublicAgreementsForDownloadArgs = {
  options?: InputMaybe<PublicAgreementOptions>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PublicAgreementWhere>;
};


export type QueryGetRelatedModelsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRevokableRecordsArgs = {
  caseId: Scalars['ID']['input'];
};


export type QueryGetSanitizedCaseEventLogsArgs = {
  caseId: Scalars['ID']['input'];
};


export type QueryGetSimilarCasesArgs = {
  caseId: Scalars['ID']['input'];
  diseaseIcd10Code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSimulationUserRolesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSmartMipInvoicesAvailableArgs = {
  input: GetSmartMipInvoicesAvailableInput;
};


export type QueryGetThreadMessageCountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  nodeLabel?: InputMaybe<SupportedMessageNodes>;
};


export type QueryGetUnknownPreparationIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetUserContextTimePeriodFilterReportingArgs = {
  agreementId: Scalars['ID']['input'];
};


export type QueryGetUserCreatedSimulationsCountArgs = {
  getUserCreatedSimulationsCountArgsDto: GetUserCreatedSimulationsCountArgsDto;
};


export type QueryGetUserFieldsForUploadArgs = {
  entityType: FlexContainerType;
  file?: InputMaybe<Scalars['FileUpload']['input']>;
};


export type QueryGetUserLoginDatesArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetUserProfileInfoDataArgs = {
  input?: InputMaybe<ProfileDataInfoInput>;
};


export type QueryGetUserProfilePictureArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isQuerySourceImage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetUsersToMentionOnCaseMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUsersToMentionOnDocumentMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetValidatedComparisonArgs = {
  simulationIds: Array<Scalars['ID']['input']>;
};


export type QueryGetWorkflowsArgs = {
  contractId: Scalars['String']['input'];
};


export type QueryInvoiceCounterPartiesUsersArgs = {
  input?: InputMaybe<SearchUserEmailByNameInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIsDualApprovalSupportedForDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationFromTenantIdArgs = {
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAddedTransactionsInfosArgs = {
  options?: InputMaybe<AddedTransactionsInfoOptions>;
  where?: InputMaybe<AddedTransactionsInfoWhere>;
};


export type QueryAddedTransactionsInfosAggregateArgs = {
  where?: InputMaybe<AddedTransactionsInfoWhere>;
};


export type QueryAddedTransactionsInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AddedTransactionsInfoSort>>>;
  where?: InputMaybe<AddedTransactionsInfoWhere>;
};


export type QueryAdministrationsDiscontinuationNotesArgs = {
  options?: InputMaybe<AdministrationsDiscontinuationNoteOptions>;
  where?: InputMaybe<AdministrationsDiscontinuationNoteWhere>;
};


export type QueryAdministrationsDiscontinuationNotesAggregateArgs = {
  where?: InputMaybe<AdministrationsDiscontinuationNoteWhere>;
};


export type QueryAdministrationsDiscontinuationNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdministrationsDiscontinuationNoteSort>>>;
  where?: InputMaybe<AdministrationsDiscontinuationNoteWhere>;
};


export type QueryAdverseEventCounterpartiesArgs = {
  options?: InputMaybe<AdverseEventCounterpartiesOptions>;
  where?: InputMaybe<AdverseEventCounterpartiesWhere>;
};


export type QueryAdverseEventCounterpartiesAggregateArgs = {
  where?: InputMaybe<AdverseEventCounterpartiesWhere>;
};


export type QueryAdverseEventCounterpartiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdverseEventCounterpartiesSort>>>;
  where?: InputMaybe<AdverseEventCounterpartiesWhere>;
};


export type QueryAdverseEventReportItemsArgs = {
  options?: InputMaybe<AdverseEventReportItemOptions>;
  where?: InputMaybe<AdverseEventReportItemWhere>;
};


export type QueryAdverseEventReportItemsAggregateArgs = {
  where?: InputMaybe<AdverseEventReportItemWhere>;
};


export type QueryAdverseEventReportItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdverseEventReportItemSort>>>;
  where?: InputMaybe<AdverseEventReportItemWhere>;
};


export type QueryAdverseEventReportsArgs = {
  options?: InputMaybe<AdverseEventReportOptions>;
  where?: InputMaybe<AdverseEventReportWhere>;
};


export type QueryAdverseEventReportsAggregateArgs = {
  where?: InputMaybe<AdverseEventReportWhere>;
};


export type QueryAdverseEventReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdverseEventReportSort>>>;
  where?: InputMaybe<AdverseEventReportWhere>;
};


export type QueryAdverseEventsOccurenceReportsArgs = {
  options?: InputMaybe<AdverseEventsOccurenceReportOptions>;
  where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};


export type QueryAdverseEventsOccurenceReportsAggregateArgs = {
  where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};


export type QueryAdverseEventsOccurenceReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AdverseEventsOccurenceReportSort>>>;
  where?: InputMaybe<AdverseEventsOccurenceReportWhere>;
};


export type QueryAgreementDecisionsArgs = {
  options?: InputMaybe<AgreementDecisionOptions>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type QueryAgreementDecisionsAggregateArgs = {
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type QueryAgreementDecisionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementDecisionSort>>>;
  where?: InputMaybe<AgreementDecisionWhere>;
};


export type QueryAgreementReportsArgs = {
  options?: InputMaybe<AgreementReportOptions>;
  where?: InputMaybe<AgreementReportWhere>;
};


export type QueryAgreementReportsAggregateArgs = {
  where?: InputMaybe<AgreementReportWhere>;
};


export type QueryAgreementReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementReportSort>>>;
  where?: InputMaybe<AgreementReportWhere>;
};


export type QueryAgreementRunAttemptInfosArgs = {
  options?: InputMaybe<AgreementRunAttemptInfoOptions>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type QueryAgreementRunAttemptInfosAggregateArgs = {
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type QueryAgreementRunAttemptInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementRunAttemptInfoSort>>>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type QueryAgreementRunsArgs = {
  options?: InputMaybe<AgreementRunOptions>;
  where?: InputMaybe<AgreementRunWhere>;
};


export type QueryAgreementRunsAggregateArgs = {
  where?: InputMaybe<AgreementRunWhere>;
};


export type QueryAgreementRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementRunSort>>>;
  where?: InputMaybe<AgreementRunWhere>;
};


export type QueryAgreementScopeCountryScopesArgs = {
  options?: InputMaybe<AgreementScopeCountryScopeOptions>;
  where?: InputMaybe<AgreementScopeCountryScopeWhere>;
};


export type QueryAgreementScopeCountryScopesAggregateArgs = {
  where?: InputMaybe<AgreementScopeCountryScopeWhere>;
};


export type QueryAgreementScopeCountryScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementScopeCountryScopeSort>>>;
  where?: InputMaybe<AgreementScopeCountryScopeWhere>;
};


export type QueryAgreementScopeOrganizationScopesArgs = {
  options?: InputMaybe<AgreementScopeOrganizationScopeOptions>;
  where?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
};


export type QueryAgreementScopeOrganizationScopesAggregateArgs = {
  where?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
};


export type QueryAgreementScopeOrganizationScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementScopeOrganizationScopeSort>>>;
  where?: InputMaybe<AgreementScopeOrganizationScopeWhere>;
};


export type QueryAgreementScopesArgs = {
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type QueryAgreementScopesAggregateArgs = {
  where?: InputMaybe<AgreementScopeWhere>;
};


export type QueryAgreementScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementScopeSort>>>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type QueryAgreementSpecificRolesArgs = {
  options?: InputMaybe<AgreementSpecificRoleOptions>;
  where?: InputMaybe<AgreementSpecificRoleWhere>;
};


export type QueryAgreementSpecificRolesAggregateArgs = {
  where?: InputMaybe<AgreementSpecificRoleWhere>;
};


export type QueryAgreementSpecificRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementSpecificRoleSort>>>;
  where?: InputMaybe<AgreementSpecificRoleWhere>;
};


export type QueryAgreementSpecificUserRolesArgs = {
  options?: InputMaybe<AgreementSpecificUserRoleOptions>;
  where?: InputMaybe<AgreementSpecificUserRoleWhere>;
};


export type QueryAgreementSpecificUserRolesAggregateArgs = {
  where?: InputMaybe<AgreementSpecificUserRoleWhere>;
};


export type QueryAgreementSpecificUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementSpecificUserRoleSort>>>;
  where?: InputMaybe<AgreementSpecificUserRoleWhere>;
};


export type QueryAgreementStatusTransitionsArgs = {
  options?: InputMaybe<AgreementStatusTransitionOptions>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type QueryAgreementStatusTransitionsAggregateArgs = {
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type QueryAgreementStatusTransitionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementStatusTransitionSort>>>;
  where?: InputMaybe<AgreementStatusTransitionWhere>;
};


export type QueryAgreementTableRowsArgs = {
  options?: InputMaybe<AgreementTableRowOptions>;
  where?: InputMaybe<AgreementTableRowWhere>;
};


export type QueryAgreementTableRowsAggregateArgs = {
  where?: InputMaybe<AgreementTableRowWhere>;
};


export type QueryAgreementTableRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTableRowSort>>>;
  where?: InputMaybe<AgreementTableRowWhere>;
};


export type QueryAgreementTagRolesArgs = {
  options?: InputMaybe<AgreementTagRoleOptions>;
  where?: InputMaybe<AgreementTagRoleWhere>;
};


export type QueryAgreementTagRolesAggregateArgs = {
  where?: InputMaybe<AgreementTagRoleWhere>;
};


export type QueryAgreementTagRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTagRoleSort>>>;
  where?: InputMaybe<AgreementTagRoleWhere>;
};


export type QueryAgreementTagsArgs = {
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type QueryAgreementTagsAggregateArgs = {
  where?: InputMaybe<AgreementTagWhere>;
};


export type QueryAgreementTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTagSort>>>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type QueryAgreementTemplatesArgs = {
  options?: InputMaybe<AgreementTemplateOptions>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type QueryAgreementTemplatesAggregateArgs = {
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type QueryAgreementTemplatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementTemplateSort>>>;
  where?: InputMaybe<AgreementTemplateWhere>;
};


export type QueryAgreementsArgs = {
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type QueryAgreementsAggregateArgs = {
  where?: InputMaybe<AgreementWhere>;
};


export type QueryAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementSort>>>;
  where?: InputMaybe<AgreementWhere>;
};


export type QueryAgreementsTableSourceFilterDataArgs = {
  options?: InputMaybe<AgreementsTableSourceFilterDataOptions>;
  where?: InputMaybe<AgreementsTableSourceFilterDataWhere>;
};


export type QueryAgreementsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<AgreementsTableSourceFilterDataWhere>;
};


export type QueryAgreementsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AgreementsTableSourceFilterDataSort>>>;
  where?: InputMaybe<AgreementsTableSourceFilterDataWhere>;
};


export type QueryAmountRangesArgs = {
  options?: InputMaybe<AmountRangeOptions>;
  where?: InputMaybe<AmountRangeWhere>;
};


export type QueryAmountRangesAggregateArgs = {
  where?: InputMaybe<AmountRangeWhere>;
};


export type QueryAmountRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AmountRangeSort>>>;
  where?: InputMaybe<AmountRangeWhere>;
};


export type QueryArticle71IndicationsArgs = {
  options?: InputMaybe<Article71IndicationOptions>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type QueryArticle71IndicationsAggregateArgs = {
  where?: InputMaybe<Article71IndicationWhere>;
};


export type QueryArticle71IndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Article71IndicationSort>>>;
  where?: InputMaybe<Article71IndicationWhere>;
};


export type QueryAuthOrganizationsArgs = {
  options?: InputMaybe<AuthOrganizationOptions>;
  where?: InputMaybe<AuthOrganizationWhere>;
};


export type QueryAuthOrganizationsAggregateArgs = {
  where?: InputMaybe<AuthOrganizationWhere>;
};


export type QueryAuthOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AuthOrganizationSort>>>;
  where?: InputMaybe<AuthOrganizationWhere>;
};


export type QueryAverageGenericPricesArgs = {
  options?: InputMaybe<AverageGenericPriceOptions>;
  where?: InputMaybe<AverageGenericPriceWhere>;
};


export type QueryAverageGenericPricesAggregateArgs = {
  where?: InputMaybe<AverageGenericPriceWhere>;
};


export type QueryAverageGenericPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AverageGenericPriceSort>>>;
  where?: InputMaybe<AverageGenericPriceWhere>;
};


export type QueryAverageLaPressureAndLaVolumeRowsArgs = {
  options?: InputMaybe<AverageLaPressureAndLaVolumeRowOptions>;
  where?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
};


export type QueryAverageLaPressureAndLaVolumeRowsAggregateArgs = {
  where?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
};


export type QueryAverageLaPressureAndLaVolumeRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AverageLaPressureAndLaVolumeRowSort>>>;
  where?: InputMaybe<AverageLaPressureAndLaVolumeRowWhere>;
};


export type QueryBaseAgreementsArgs = {
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type QueryBaseAgreementsAggregateArgs = {
  where?: InputMaybe<BaseAgreementWhere>;
};


export type QueryBaseAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BaseAgreementSort>>>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type QueryBaseUserInfosArgs = {
  options?: InputMaybe<BaseUserInfoOptions>;
  where?: InputMaybe<BaseUserInfoWhere>;
};


export type QueryBaseUserInfosAggregateArgs = {
  where?: InputMaybe<BaseUserInfoWhere>;
};


export type QueryBaseUserInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BaseUserInfoSort>>>;
  where?: InputMaybe<BaseUserInfoWhere>;
};


export type QueryBrandsArgs = {
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type QueryBrandsAggregateArgs = {
  where?: InputMaybe<BrandWhere>;
};


export type QueryBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<BrandSort>>>;
  where?: InputMaybe<BrandWhere>;
};


export type QueryCanDeleteFlexEntityOutputsArgs = {
  options?: InputMaybe<CanDeleteFlexEntityOutputOptions>;
  where?: InputMaybe<CanDeleteFlexEntityOutputWhere>;
};


export type QueryCanDeleteFlexEntityOutputsAggregateArgs = {
  where?: InputMaybe<CanDeleteFlexEntityOutputWhere>;
};


export type QueryCanDeleteFlexEntityOutputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CanDeleteFlexEntityOutputWhere>;
};


export type QueryCaseEventLogsArgs = {
  options?: InputMaybe<CaseEventLogOptions>;
  where?: InputMaybe<CaseEventLogWhere>;
};


export type QueryCaseEventLogsAggregateArgs = {
  where?: InputMaybe<CaseEventLogWhere>;
};


export type QueryCaseEventLogsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseEventLogSort>>>;
  where?: InputMaybe<CaseEventLogWhere>;
};


export type QueryCaseHistoryRecordsArgs = {
  options?: InputMaybe<CaseHistoryRecordOptions>;
  where?: InputMaybe<CaseHistoryRecordWhere>;
};


export type QueryCaseHistoryRecordsAggregateArgs = {
  where?: InputMaybe<CaseHistoryRecordWhere>;
};


export type QueryCaseHistoryRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseHistoryRecordSort>>>;
  where?: InputMaybe<CaseHistoryRecordWhere>;
};


export type QueryCaseInfosArgs = {
  options?: InputMaybe<CaseInfoOptions>;
  where?: InputMaybe<CaseInfoWhere>;
};


export type QueryCaseInfosAggregateArgs = {
  where?: InputMaybe<CaseInfoWhere>;
};


export type QueryCaseInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseInfoSort>>>;
  where?: InputMaybe<CaseInfoWhere>;
};


export type QueryCaseReportDataPointsArgs = {
  options?: InputMaybe<CaseReportDataPointOptions>;
  where?: InputMaybe<CaseReportDataPointWhere>;
};


export type QueryCaseReportDataPointsAggregateArgs = {
  where?: InputMaybe<CaseReportDataPointWhere>;
};


export type QueryCaseReportDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseReportDataPointSort>>>;
  where?: InputMaybe<CaseReportDataPointWhere>;
};


export type QueryCaseReportingDataArgs = {
  options?: InputMaybe<CaseReportingDataOptions>;
  where?: InputMaybe<CaseReportingDataWhere>;
};


export type QueryCaseReportingDataAggregateArgs = {
  where?: InputMaybe<CaseReportingDataWhere>;
};


export type QueryCaseReportingDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseReportingDataSort>>>;
  where?: InputMaybe<CaseReportingDataWhere>;
};


export type QueryCaseTableRowsArgs = {
  options?: InputMaybe<CaseTableRowOptions>;
  where?: InputMaybe<CaseTableRowWhere>;
};


export type QueryCaseTableRowsAggregateArgs = {
  where?: InputMaybe<CaseTableRowWhere>;
};


export type QueryCaseTableRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseTableRowSort>>>;
  where?: InputMaybe<CaseTableRowWhere>;
};


export type QueryCaselessAgreementReportsArgs = {
  options?: InputMaybe<CaselessAgreementReportOptions>;
  where?: InputMaybe<CaselessAgreementReportWhere>;
};


export type QueryCaselessAgreementReportsAggregateArgs = {
  where?: InputMaybe<CaselessAgreementReportWhere>;
};


export type QueryCaselessAgreementReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaselessAgreementReportSort>>>;
  where?: InputMaybe<CaselessAgreementReportWhere>;
};


export type QueryCasesArgs = {
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type QueryCasesAggregateArgs = {
  where?: InputMaybe<CaseWhere>;
};


export type QueryCasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CaseSort>>>;
  where?: InputMaybe<CaseWhere>;
};


export type QueryCasesTableSourceFilterDataArgs = {
  options?: InputMaybe<CasesTableSourceFilterDataOptions>;
  where?: InputMaybe<CasesTableSourceFilterDataWhere>;
};


export type QueryCasesTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<CasesTableSourceFilterDataWhere>;
};


export type QueryCasesTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CasesTableSourceFilterDataWhere>;
};


export type QueryCatalogueAttributesArgs = {
  options?: InputMaybe<CatalogueAttributeOptions>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type QueryCatalogueAttributesAggregateArgs = {
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type QueryCatalogueAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CatalogueAttributeSort>>>;
  where?: InputMaybe<CatalogueAttributeWhere>;
};


export type QueryChartRangeConfigurationsArgs = {
  options?: InputMaybe<ChartRangeConfigurationOptions>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type QueryChartRangeConfigurationsAggregateArgs = {
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type QueryChartRangeConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ChartRangeConfigurationSort>>>;
  where?: InputMaybe<ChartRangeConfigurationWhere>;
};


export type QueryCompaniesArgs = {
  options?: InputMaybe<CompanyOptions>;
  where?: InputMaybe<CompanyWhere>;
};


export type QueryCompaniesAggregateArgs = {
  where?: InputMaybe<CompanyWhere>;
};


export type QueryCompaniesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanySort>>>;
  where?: InputMaybe<CompanyWhere>;
};


export type QueryCompanyImagesArgs = {
  options?: InputMaybe<CompanyImageOptions>;
  where?: InputMaybe<CompanyImageWhere>;
};


export type QueryCompanyImagesAggregateArgs = {
  where?: InputMaybe<CompanyImageWhere>;
};


export type QueryCompanyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CompanyImageSort>>>;
  where?: InputMaybe<CompanyImageWhere>;
};


export type QueryContractWorkflowStepsArgs = {
  options?: InputMaybe<ContractWorkflowStepOptions>;
  where?: InputMaybe<ContractWorkflowStepWhere>;
};


export type QueryContractWorkflowStepsAggregateArgs = {
  where?: InputMaybe<ContractWorkflowStepWhere>;
};


export type QueryContractWorkflowStepsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ContractWorkflowStepSort>>>;
  where?: InputMaybe<ContractWorkflowStepWhere>;
};


export type QueryContractWorkflowsArgs = {
  options?: InputMaybe<ContractWorkflowOptions>;
  where?: InputMaybe<ContractWorkflowWhere>;
};


export type QueryContractWorkflowsAggregateArgs = {
  where?: InputMaybe<ContractWorkflowWhere>;
};


export type QueryContractWorkflowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ContractWorkflowSort>>>;
  where?: InputMaybe<ContractWorkflowWhere>;
};


export type QueryCoreConfigurationDataArgs = {
  options?: InputMaybe<CoreConfigurationDataOptions>;
  where?: InputMaybe<CoreConfigurationDataWhere>;
};


export type QueryCoreConfigurationDataAggregateArgs = {
  where?: InputMaybe<CoreConfigurationDataWhere>;
};


export type QueryCoreConfigurationDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CoreConfigurationDataWhere>;
};


export type QueryCountriesArgs = {
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type QueryCountriesAggregateArgs = {
  where?: InputMaybe<CountryWhere>;
};


export type QueryCountriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CountrySort>>>;
  where?: InputMaybe<CountryWhere>;
};


export type QueryCountriesForDashboardsArgs = {
  options?: InputMaybe<CountriesForDashboardOptions>;
  where?: InputMaybe<CountriesForDashboardWhere>;
};


export type QueryCountriesForDashboardsAggregateArgs = {
  where?: InputMaybe<CountriesForDashboardWhere>;
};


export type QueryCountriesForDashboardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CountriesForDashboardSort>>>;
  where?: InputMaybe<CountriesForDashboardWhere>;
};


export type QueryCountriesInAgreementsArgs = {
  options?: InputMaybe<CountriesInAgreementOptions>;
  where?: InputMaybe<CountriesInAgreementWhere>;
};


export type QueryCountriesInAgreementsAggregateArgs = {
  where?: InputMaybe<CountriesInAgreementWhere>;
};


export type QueryCountriesInAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CountriesInAgreementSort>>>;
  where?: InputMaybe<CountriesInAgreementWhere>;
};


export type QueryCreateDocumentMessageResultsArgs = {
  options?: InputMaybe<CreateDocumentMessageResultOptions>;
  where?: InputMaybe<CreateDocumentMessageResultWhere>;
};


export type QueryCreateDocumentMessageResultsAggregateArgs = {
  where?: InputMaybe<CreateDocumentMessageResultWhere>;
};


export type QueryCreateDocumentMessageResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CreateDocumentMessageResultSort>>>;
  where?: InputMaybe<CreateDocumentMessageResultWhere>;
};


export type QueryCrossCountryPricesArgs = {
  options?: InputMaybe<CrossCountryPriceOptions>;
  where?: InputMaybe<CrossCountryPriceWhere>;
};


export type QueryCrossCountryPricesAggregateArgs = {
  where?: InputMaybe<CrossCountryPriceWhere>;
};


export type QueryCrossCountryPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CrossCountryPriceSort>>>;
  where?: InputMaybe<CrossCountryPriceWhere>;
};


export type QueryCurrenciesArgs = {
  options?: InputMaybe<CurrencyOptions>;
  where?: InputMaybe<CurrencyWhere>;
};


export type QueryCurrenciesAggregateArgs = {
  where?: InputMaybe<CurrencyWhere>;
};


export type QueryCurrenciesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CurrencySort>>>;
  where?: InputMaybe<CurrencyWhere>;
};


export type QueryCustomConditionsArgs = {
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type QueryCustomConditionsAggregateArgs = {
  where?: InputMaybe<CustomConditionWhere>;
};


export type QueryCustomConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CustomConditionSort>>>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type QueryCustomIntegrityChecksArgs = {
  options?: InputMaybe<CustomIntegrityCheckOptions>;
  where?: InputMaybe<CustomIntegrityCheckWhere>;
};


export type QueryCustomIntegrityChecksAggregateArgs = {
  where?: InputMaybe<CustomIntegrityCheckWhere>;
};


export type QueryCustomIntegrityChecksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CustomIntegrityCheckSort>>>;
  where?: InputMaybe<CustomIntegrityCheckWhere>;
};


export type QueryCycleConfigurationsArgs = {
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type QueryCycleConfigurationsAggregateArgs = {
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type QueryCycleConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CycleConfigurationSort>>>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type QueryCycleTherapyConfigurationsArgs = {
  options?: InputMaybe<CycleTherapyConfigurationOptions>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type QueryCycleTherapyConfigurationsAggregateArgs = {
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type QueryCycleTherapyConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<CycleTherapyConfigurationSort>>>;
  where?: InputMaybe<CycleTherapyConfigurationWhere>;
};


export type QueryDashboardFieldDetailsArgs = {
  options?: InputMaybe<DashboardFieldDetailsOptions>;
  where?: InputMaybe<DashboardFieldDetailsWhere>;
};


export type QueryDashboardFieldDetailsAggregateArgs = {
  where?: InputMaybe<DashboardFieldDetailsWhere>;
};


export type QueryDashboardFieldDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DashboardFieldDetailsSort>>>;
  where?: InputMaybe<DashboardFieldDetailsWhere>;
};


export type QueryDataContainersArgs = {
  options?: InputMaybe<DataContainerOptions>;
  where?: InputMaybe<DataContainerWhere>;
};


export type QueryDataContainersAggregateArgs = {
  where?: InputMaybe<DataContainerWhere>;
};


export type QueryDataContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DataContainerSort>>>;
  where?: InputMaybe<DataContainerWhere>;
};


export type QueryDataSourcesArgs = {
  options?: InputMaybe<DataSourceOptions>;
  where?: InputMaybe<DataSourceWhere>;
};


export type QueryDataSourcesAggregateArgs = {
  where?: InputMaybe<DataSourceWhere>;
};


export type QueryDataSourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DataSourceSort>>>;
  where?: InputMaybe<DataSourceWhere>;
};


export type QueryDatabaseCleanupJobInfosArgs = {
  options?: InputMaybe<DatabaseCleanupJobInfoOptions>;
  where?: InputMaybe<DatabaseCleanupJobInfoWhere>;
};


export type QueryDatabaseCleanupJobInfosAggregateArgs = {
  where?: InputMaybe<DatabaseCleanupJobInfoWhere>;
};


export type QueryDatabaseCleanupJobInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DatabaseCleanupJobInfoSort>>>;
  where?: InputMaybe<DatabaseCleanupJobInfoWhere>;
};


export type QueryDefaultAgreementRoleInfosArgs = {
  options?: InputMaybe<DefaultAgreementRoleInfoOptions>;
  where?: InputMaybe<DefaultAgreementRoleInfoWhere>;
};


export type QueryDefaultAgreementRoleInfosAggregateArgs = {
  where?: InputMaybe<DefaultAgreementRoleInfoWhere>;
};


export type QueryDefaultAgreementRoleInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DefaultAgreementRoleInfoSort>>>;
  where?: InputMaybe<DefaultAgreementRoleInfoWhere>;
};


export type QueryDeviceAlternativesArgs = {
  options?: InputMaybe<DeviceAlternativeOptions>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type QueryDeviceAlternativesAggregateArgs = {
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type QueryDeviceAlternativesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DeviceAlternativeSort>>>;
  where?: InputMaybe<DeviceAlternativeWhere>;
};


export type QueryDiseaseFilterDataArgs = {
  options?: InputMaybe<DiseaseFilterDataOptions>;
  where?: InputMaybe<DiseaseFilterDataWhere>;
};


export type QueryDiseaseFilterDataAggregateArgs = {
  where?: InputMaybe<DiseaseFilterDataWhere>;
};


export type QueryDiseaseFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DiseaseFilterDataSort>>>;
  where?: InputMaybe<DiseaseFilterDataWhere>;
};


export type QueryDiseasesArgs = {
  options?: InputMaybe<DiseaseOptions>;
  where?: InputMaybe<DiseaseWhere>;
};


export type QueryDiseasesAggregateArgs = {
  where?: InputMaybe<DiseaseWhere>;
};


export type QueryDiseasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DiseaseSort>>>;
  where?: InputMaybe<DiseaseWhere>;
};


export type QueryDocumentApprovalUsersInfosArgs = {
  options?: InputMaybe<DocumentApprovalUsersInfoOptions>;
  where?: InputMaybe<DocumentApprovalUsersInfoWhere>;
};


export type QueryDocumentApprovalUsersInfosAggregateArgs = {
  where?: InputMaybe<DocumentApprovalUsersInfoWhere>;
};


export type QueryDocumentApprovalUsersInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentApprovalUsersInfoSort>>>;
  where?: InputMaybe<DocumentApprovalUsersInfoWhere>;
};


export type QueryDocumentAttachmentProgressEventsArgs = {
  options?: InputMaybe<DocumentAttachmentProgressEventOptions>;
  where?: InputMaybe<DocumentAttachmentProgressEventWhere>;
};


export type QueryDocumentAttachmentProgressEventsAggregateArgs = {
  where?: InputMaybe<DocumentAttachmentProgressEventWhere>;
};


export type QueryDocumentAttachmentProgressEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentAttachmentProgressEventSort>>>;
  where?: InputMaybe<DocumentAttachmentProgressEventWhere>;
};


export type QueryDocumentExportFieldDefaultsArgs = {
  options?: InputMaybe<DocumentExportFieldDefaultsOptions>;
  where?: InputMaybe<DocumentExportFieldDefaultsWhere>;
};


export type QueryDocumentExportFieldDefaultsAggregateArgs = {
  where?: InputMaybe<DocumentExportFieldDefaultsWhere>;
};


export type QueryDocumentExportFieldDefaultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentExportFieldDefaultsSort>>>;
  where?: InputMaybe<DocumentExportFieldDefaultsWhere>;
};


export type QueryDocumentMessagesArgs = {
  options?: InputMaybe<DocumentMessageOptions>;
  where?: InputMaybe<DocumentMessageWhere>;
};


export type QueryDocumentMessagesAggregateArgs = {
  where?: InputMaybe<DocumentMessageWhere>;
};


export type QueryDocumentMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentMessageSort>>>;
  where?: InputMaybe<DocumentMessageWhere>;
};


export type QueryDocumentRefundGroupsArgs = {
  options?: InputMaybe<DocumentRefundGroupOptions>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type QueryDocumentRefundGroupsAggregateArgs = {
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type QueryDocumentRefundGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentRefundGroupSort>>>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type QueryDocumentTableRowsArgs = {
  options?: InputMaybe<DocumentTableRowOptions>;
  where?: InputMaybe<DocumentTableRowWhere>;
};


export type QueryDocumentTableRowsAggregateArgs = {
  where?: InputMaybe<DocumentTableRowWhere>;
};


export type QueryDocumentTableRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentTableRowSort>>>;
  where?: InputMaybe<DocumentTableRowWhere>;
};


export type QueryDocumentThreadUpdatesArgs = {
  options?: InputMaybe<DocumentThreadUpdateOptions>;
  where?: InputMaybe<DocumentThreadUpdateWhere>;
};


export type QueryDocumentThreadUpdatesAggregateArgs = {
  where?: InputMaybe<DocumentThreadUpdateWhere>;
};


export type QueryDocumentThreadUpdatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentThreadUpdateSort>>>;
  where?: InputMaybe<DocumentThreadUpdateWhere>;
};


export type QueryDocumentUpdatedsArgs = {
  options?: InputMaybe<DocumentUpdatedOptions>;
  where?: InputMaybe<DocumentUpdatedWhere>;
};


export type QueryDocumentUpdatedsAggregateArgs = {
  where?: InputMaybe<DocumentUpdatedWhere>;
};


export type QueryDocumentUpdatedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentUpdatedSort>>>;
  where?: InputMaybe<DocumentUpdatedWhere>;
};


export type QueryDocumentUploadInfosArgs = {
  options?: InputMaybe<DocumentUploadInfoOptions>;
  where?: InputMaybe<DocumentUploadInfoWhere>;
};


export type QueryDocumentUploadInfosAggregateArgs = {
  where?: InputMaybe<DocumentUploadInfoWhere>;
};


export type QueryDocumentUploadInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentUploadInfoSort>>>;
  where?: InputMaybe<DocumentUploadInfoWhere>;
};


export type QueryDocumentXmlReportsArgs = {
  options?: InputMaybe<DocumentXmlReportOptions>;
  where?: InputMaybe<DocumentXmlReportWhere>;
};


export type QueryDocumentXmlReportsAggregateArgs = {
  where?: InputMaybe<DocumentXmlReportWhere>;
};


export type QueryDocumentXmlReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentXmlReportSort>>>;
  where?: InputMaybe<DocumentXmlReportWhere>;
};


export type QueryDocumentsArgs = {
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type QueryDocumentsAggregateArgs = {
  where?: InputMaybe<DocumentWhere>;
};


export type QueryDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentSort>>>;
  where?: InputMaybe<DocumentWhere>;
};


export type QueryDocumentsTableSourceFilterDataArgs = {
  options?: InputMaybe<DocumentsTableSourceFilterDataOptions>;
  where?: InputMaybe<DocumentsTableSourceFilterDataWhere>;
};


export type QueryDocumentsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<DocumentsTableSourceFilterDataWhere>;
};


export type QueryDocumentsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DocumentsTableSourceFilterDataSort>>>;
  where?: InputMaybe<DocumentsTableSourceFilterDataWhere>;
};


export type QueryDomainsArgs = {
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type QueryDomainsAggregateArgs = {
  where?: InputMaybe<DomainWhere>;
};


export type QueryDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DomainSort>>>;
  where?: InputMaybe<DomainWhere>;
};


export type QueryDownloadablePublicAgreementsArgs = {
  options?: InputMaybe<DownloadablePublicAgreementOptions>;
  where?: InputMaybe<DownloadablePublicAgreementWhere>;
};


export type QueryDownloadablePublicAgreementsAggregateArgs = {
  where?: InputMaybe<DownloadablePublicAgreementWhere>;
};


export type QueryDownloadablePublicAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DownloadablePublicAgreementSort>>>;
  where?: InputMaybe<DownloadablePublicAgreementWhere>;
};


export type QueryDummyEnumReferencesArgs = {
  options?: InputMaybe<DummyEnumReferencesOptions>;
  where?: InputMaybe<DummyEnumReferencesWhere>;
};


export type QueryDummyEnumReferencesAggregateArgs = {
  where?: InputMaybe<DummyEnumReferencesWhere>;
};


export type QueryDummyEnumReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DummyEnumReferencesSort>>>;
  where?: InputMaybe<DummyEnumReferencesWhere>;
};


export type QueryEligibilityConditionSetsArgs = {
  options?: InputMaybe<EligibilityConditionSetOptions>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type QueryEligibilityConditionSetsAggregateArgs = {
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type QueryEligibilityConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EligibilityConditionSetSort>>>;
  where?: InputMaybe<EligibilityConditionSetWhere>;
};


export type QueryEncapsulatedFeatureConfigurationsArgs = {
  options?: InputMaybe<EncapsulatedFeatureConfigurationOptions>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type QueryEncapsulatedFeatureConfigurationsAggregateArgs = {
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type QueryEncapsulatedFeatureConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EncapsulatedFeatureConfigurationSort>>>;
  where?: InputMaybe<EncapsulatedFeatureConfigurationWhere>;
};


export type QueryEncapsulatedFeaturesArgs = {
  options?: InputMaybe<EncapsulatedFeatureOptions>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type QueryEncapsulatedFeaturesAggregateArgs = {
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type QueryEncapsulatedFeaturesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EncapsulatedFeatureSort>>>;
  where?: InputMaybe<EncapsulatedFeatureWhere>;
};


export type QueryEnrollingConditionSetsArgs = {
  options?: InputMaybe<EnrollingConditionSetOptions>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type QueryEnrollingConditionSetsAggregateArgs = {
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type QueryEnrollingConditionSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnrollingConditionSetSort>>>;
  where?: InputMaybe<EnrollingConditionSetWhere>;
};


export type QueryEnrollingConditionsArgs = {
  options?: InputMaybe<EnrollingConditionOptions>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type QueryEnrollingConditionsAggregateArgs = {
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type QueryEnrollingConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnrollingConditionSort>>>;
  where?: InputMaybe<EnrollingConditionWhere>;
};


export type QueryEnrollingPeriodsArgs = {
  options?: InputMaybe<EnrollingPeriodOptions>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type QueryEnrollingPeriodsAggregateArgs = {
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type QueryEnrollingPeriodsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnrollingPeriodSort>>>;
  where?: InputMaybe<EnrollingPeriodWhere>;
};


export type QueryEnvironmentImpactsArgs = {
  options?: InputMaybe<EnvironmentImpactOptions>;
  where?: InputMaybe<EnvironmentImpactWhere>;
};


export type QueryEnvironmentImpactsAggregateArgs = {
  where?: InputMaybe<EnvironmentImpactWhere>;
};


export type QueryEnvironmentImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<EnvironmentImpactSort>>>;
  where?: InputMaybe<EnvironmentImpactWhere>;
};


export type QueryExFactoryPricesArgs = {
  options?: InputMaybe<ExFactoryPriceOptions>;
  where?: InputMaybe<ExFactoryPriceWhere>;
};


export type QueryExFactoryPricesAggregateArgs = {
  where?: InputMaybe<ExFactoryPriceWhere>;
};


export type QueryExFactoryPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExFactoryPriceSort>>>;
  where?: InputMaybe<ExFactoryPriceWhere>;
};


export type QueryExpectedRunAgreementsArgs = {
  options?: InputMaybe<ExpectedRunAgreementOptions>;
  where?: InputMaybe<ExpectedRunAgreementWhere>;
};


export type QueryExpectedRunAgreementsAggregateArgs = {
  where?: InputMaybe<ExpectedRunAgreementWhere>;
};


export type QueryExpectedRunAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExpectedRunAgreementSort>>>;
  where?: InputMaybe<ExpectedRunAgreementWhere>;
};


export type QueryExpenditureDistributionDataPointsArgs = {
  options?: InputMaybe<ExpenditureDistributionDataPointOptions>;
  where?: InputMaybe<ExpenditureDistributionDataPointWhere>;
};


export type QueryExpenditureDistributionDataPointsAggregateArgs = {
  where?: InputMaybe<ExpenditureDistributionDataPointWhere>;
};


export type QueryExpenditureDistributionDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExpenditureDistributionDataPointSort>>>;
  where?: InputMaybe<ExpenditureDistributionDataPointWhere>;
};


export type QueryExpenditureDistributionStatusesArgs = {
  options?: InputMaybe<ExpenditureDistributionStatusOptions>;
  where?: InputMaybe<ExpenditureDistributionStatusWhere>;
};


export type QueryExpenditureDistributionStatusesAggregateArgs = {
  where?: InputMaybe<ExpenditureDistributionStatusWhere>;
};


export type QueryExpenditureDistributionStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExpenditureDistributionStatusSort>>>;
  where?: InputMaybe<ExpenditureDistributionStatusWhere>;
};


export type QueryExternalExposuresArgs = {
  options?: InputMaybe<ExternalExposureOptions>;
  where?: InputMaybe<ExternalExposureWhere>;
};


export type QueryExternalExposuresAggregateArgs = {
  where?: InputMaybe<ExternalExposureWhere>;
};


export type QueryExternalExposuresConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ExternalExposureSort>>>;
  where?: InputMaybe<ExternalExposureWhere>;
};


export type QueryFinancialReportDataPointsArgs = {
  options?: InputMaybe<FinancialReportDataPointOptions>;
  where?: InputMaybe<FinancialReportDataPointWhere>;
};


export type QueryFinancialReportDataPointsAggregateArgs = {
  where?: InputMaybe<FinancialReportDataPointWhere>;
};


export type QueryFinancialReportDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FinancialReportDataPointSort>>>;
  where?: InputMaybe<FinancialReportDataPointWhere>;
};


export type QueryFinancialSummaryColumnsArgs = {
  options?: InputMaybe<FinancialSummaryColumnOptions>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type QueryFinancialSummaryColumnsAggregateArgs = {
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type QueryFinancialSummaryColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FinancialSummaryColumnSort>>>;
  where?: InputMaybe<FinancialSummaryColumnWhere>;
};


export type QueryFinancialSummaryRowsArgs = {
  options?: InputMaybe<FinancialSummaryRowOptions>;
  where?: InputMaybe<FinancialSummaryRowWhere>;
};


export type QueryFinancialSummaryRowsAggregateArgs = {
  where?: InputMaybe<FinancialSummaryRowWhere>;
};


export type QueryFinancialSummaryRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FinancialSummaryRowSort>>>;
  where?: InputMaybe<FinancialSummaryRowWhere>;
};


export type QueryFlexEntitiesArgs = {
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type QueryFlexEntitiesAggregateArgs = {
  where?: InputMaybe<FlexEntityWhere>;
};


export type QueryFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntitySort>>>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type QueryFlexEntityAttributeValidationsArgs = {
  options?: InputMaybe<FlexEntityAttributeValidationOptions>;
  where?: InputMaybe<FlexEntityAttributeValidationWhere>;
};


export type QueryFlexEntityAttributeValidationsAggregateArgs = {
  where?: InputMaybe<FlexEntityAttributeValidationWhere>;
};


export type QueryFlexEntityAttributeValidationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityAttributeValidationSort>>>;
  where?: InputMaybe<FlexEntityAttributeValidationWhere>;
};


export type QueryFlexEntityBulkProgressesArgs = {
  options?: InputMaybe<FlexEntityBulkProgressOptions>;
  where?: InputMaybe<FlexEntityBulkProgressWhere>;
};


export type QueryFlexEntityBulkProgressesAggregateArgs = {
  where?: InputMaybe<FlexEntityBulkProgressWhere>;
};


export type QueryFlexEntityBulkProgressesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityBulkProgressSort>>>;
  where?: InputMaybe<FlexEntityBulkProgressWhere>;
};


export type QueryFlexEntityTypesArgs = {
  options?: InputMaybe<FlexEntityTypeOptions>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type QueryFlexEntityTypesAggregateArgs = {
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type QueryFlexEntityTypesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityTypeSort>>>;
  where?: InputMaybe<FlexEntityTypeWhere>;
};


export type QueryFlexEntityUploadPatientResultsArgs = {
  options?: InputMaybe<FlexEntityUploadPatientResultOptions>;
  where?: InputMaybe<FlexEntityUploadPatientResultWhere>;
};


export type QueryFlexEntityUploadPatientResultsAggregateArgs = {
  where?: InputMaybe<FlexEntityUploadPatientResultWhere>;
};


export type QueryFlexEntityUploadPatientResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityUploadPatientResultSort>>>;
  where?: InputMaybe<FlexEntityUploadPatientResultWhere>;
};


export type QueryFlexEntityUploadProgressesArgs = {
  options?: InputMaybe<FlexEntityUploadProgressOptions>;
  where?: InputMaybe<FlexEntityUploadProgressWhere>;
};


export type QueryFlexEntityUploadProgressesAggregateArgs = {
  where?: InputMaybe<FlexEntityUploadProgressWhere>;
};


export type QueryFlexEntityUploadProgressesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityUploadProgressSort>>>;
  where?: InputMaybe<FlexEntityUploadProgressWhere>;
};


export type QueryFlexEntityUploadReportBasicEntriesArgs = {
  options?: InputMaybe<FlexEntityUploadReportBasicEntryOptions>;
  where?: InputMaybe<FlexEntityUploadReportBasicEntryWhere>;
};


export type QueryFlexEntityUploadReportBasicEntriesAggregateArgs = {
  where?: InputMaybe<FlexEntityUploadReportBasicEntryWhere>;
};


export type QueryFlexEntityUploadReportBasicEntriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityUploadReportBasicEntrySort>>>;
  where?: InputMaybe<FlexEntityUploadReportBasicEntryWhere>;
};


export type QueryFlexEntityUploadReportInvalidAttributesArgs = {
  options?: InputMaybe<FlexEntityUploadReportInvalidAttributeOptions>;
  where?: InputMaybe<FlexEntityUploadReportInvalidAttributeWhere>;
};


export type QueryFlexEntityUploadReportInvalidAttributesAggregateArgs = {
  where?: InputMaybe<FlexEntityUploadReportInvalidAttributeWhere>;
};


export type QueryFlexEntityUploadReportInvalidAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityUploadReportInvalidAttributeSort>>>;
  where?: InputMaybe<FlexEntityUploadReportInvalidAttributeWhere>;
};


export type QueryFlexEntityUploadReportUpdatedEntitiesArgs = {
  options?: InputMaybe<FlexEntityUploadReportUpdatedEntityOptions>;
  where?: InputMaybe<FlexEntityUploadReportUpdatedEntityWhere>;
};


export type QueryFlexEntityUploadReportUpdatedEntitiesAggregateArgs = {
  where?: InputMaybe<FlexEntityUploadReportUpdatedEntityWhere>;
};


export type QueryFlexEntityUploadReportUpdatedEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityUploadReportUpdatedEntitySort>>>;
  where?: InputMaybe<FlexEntityUploadReportUpdatedEntityWhere>;
};


export type QueryFlexEntityUploadReportsArgs = {
  options?: InputMaybe<FlexEntityUploadReportOptions>;
  where?: InputMaybe<FlexEntityUploadReportWhere>;
};


export type QueryFlexEntityUploadReportsAggregateArgs = {
  where?: InputMaybe<FlexEntityUploadReportWhere>;
};


export type QueryFlexEntityUploadReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexEntityUploadReportSort>>>;
  where?: InputMaybe<FlexEntityUploadReportWhere>;
};


export type QueryFlexFinancialDataPointsArgs = {
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type QueryFlexFinancialDataPointsAggregateArgs = {
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type QueryFlexFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FlexFinancialDataPointSort>>>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type QueryFocStatusesArgs = {
  options?: InputMaybe<FocStatusOptions>;
  where?: InputMaybe<FocStatusWhere>;
};


export type QueryFocStatusesAggregateArgs = {
  where?: InputMaybe<FocStatusWhere>;
};


export type QueryFocStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FocStatusSort>>>;
  where?: InputMaybe<FocStatusWhere>;
};


export type QueryFocTableDataArgs = {
  options?: InputMaybe<FocTableDataOptions>;
  where?: InputMaybe<FocTableDataWhere>;
};


export type QueryFocTableDataAggregateArgs = {
  where?: InputMaybe<FocTableDataWhere>;
};


export type QueryFocTableDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FocTableDataSort>>>;
  where?: InputMaybe<FocTableDataWhere>;
};


export type QueryFormsTableSourceFilterDataArgs = {
  options?: InputMaybe<FormsTableSourceFilterDataOptions>;
  where?: InputMaybe<FormsTableSourceFilterDataWhere>;
};


export type QueryFormsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<FormsTableSourceFilterDataWhere>;
};


export type QueryFormsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FormsTableSourceFilterDataSort>>>;
  where?: InputMaybe<FormsTableSourceFilterDataWhere>;
};


export type QueryGenericsArgs = {
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type QueryGenericsAggregateArgs = {
  where?: InputMaybe<GenericWhere>;
};


export type QueryGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GenericSort>>>;
  where?: InputMaybe<GenericWhere>;
};


export type QueryGlobalLocksArgs = {
  options?: InputMaybe<GlobalLockOptions>;
  where?: InputMaybe<GlobalLockWhere>;
};


export type QueryGlobalLocksAggregateArgs = {
  where?: InputMaybe<GlobalLockWhere>;
};


export type QueryGlobalLocksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<GlobalLockSort>>>;
  where?: InputMaybe<GlobalLockWhere>;
};


export type QueryImagesArgs = {
  options?: InputMaybe<ImageOptions>;
  where?: InputMaybe<ImageWhere>;
};


export type QueryImagesAggregateArgs = {
  where?: InputMaybe<ImageWhere>;
};


export type QueryImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ImageSort>>>;
  where?: InputMaybe<ImageWhere>;
};


export type QueryImpossibleToEditAttributesArgs = {
  options?: InputMaybe<ImpossibleToEditAttributeOptions>;
  where?: InputMaybe<ImpossibleToEditAttributeWhere>;
};


export type QueryImpossibleToEditAttributesAggregateArgs = {
  where?: InputMaybe<ImpossibleToEditAttributeWhere>;
};


export type QueryImpossibleToEditAttributesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ImpossibleToEditAttributeSort>>>;
  where?: InputMaybe<ImpossibleToEditAttributeWhere>;
};


export type QueryInboxQuestsArgs = {
  options?: InputMaybe<InboxQuestOptions>;
  where?: InputMaybe<InboxQuestWhere>;
};


export type QueryInboxQuestsAggregateArgs = {
  where?: InputMaybe<InboxQuestWhere>;
};


export type QueryInboxQuestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<InboxQuestSort>>>;
  where?: InputMaybe<InboxQuestWhere>;
};


export type QueryIndicationsArgs = {
  options?: InputMaybe<IndicationOptions>;
  where?: InputMaybe<IndicationWhere>;
};


export type QueryIndicationsAggregateArgs = {
  where?: InputMaybe<IndicationWhere>;
};


export type QueryIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<IndicationSort>>>;
  where?: InputMaybe<IndicationWhere>;
};


export type QueryInitialResponseReviewReportsArgs = {
  options?: InputMaybe<InitialResponseReviewReportOptions>;
  where?: InputMaybe<InitialResponseReviewReportWhere>;
};


export type QueryInitialResponseReviewReportsAggregateArgs = {
  where?: InputMaybe<InitialResponseReviewReportWhere>;
};


export type QueryInitialResponseReviewReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<InitialResponseReviewReportSort>>>;
  where?: InputMaybe<InitialResponseReviewReportWhere>;
};


export type QueryInterventionReportStatusResponsesArgs = {
  options?: InputMaybe<InterventionReportStatusResponseOptions>;
  where?: InputMaybe<InterventionReportStatusResponseWhere>;
};


export type QueryInterventionReportStatusResponsesAggregateArgs = {
  where?: InputMaybe<InterventionReportStatusResponseWhere>;
};


export type QueryInterventionReportStatusResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<InterventionReportStatusResponseSort>>>;
  where?: InputMaybe<InterventionReportStatusResponseWhere>;
};


export type QueryIsFlexEntityDeletablesArgs = {
  options?: InputMaybe<IsFlexEntityDeletableOptions>;
  where?: InputMaybe<IsFlexEntityDeletableWhere>;
};


export type QueryIsFlexEntityDeletablesAggregateArgs = {
  where?: InputMaybe<IsFlexEntityDeletableWhere>;
};


export type QueryIsFlexEntityDeletablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<IsFlexEntityDeletableSort>>>;
  where?: InputMaybe<IsFlexEntityDeletableWhere>;
};


export type QueryItemUsedDataPointsArgs = {
  options?: InputMaybe<ItemUsedDataPointOptions>;
  where?: InputMaybe<ItemUsedDataPointWhere>;
};


export type QueryItemUsedDataPointsAggregateArgs = {
  where?: InputMaybe<ItemUsedDataPointWhere>;
};


export type QueryItemUsedDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ItemUsedDataPointSort>>>;
  where?: InputMaybe<ItemUsedDataPointWhere>;
};


export type QueryLdLReportingDataPointsArgs = {
  options?: InputMaybe<LdLReportingDataPointOptions>;
  where?: InputMaybe<LdLReportingDataPointWhere>;
};


export type QueryLdLReportingDataPointsAggregateArgs = {
  where?: InputMaybe<LdLReportingDataPointWhere>;
};


export type QueryLdLReportingDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LdLReportingDataPointSort>>>;
  where?: InputMaybe<LdLReportingDataPointWhere>;
};


export type QueryLimitationsArgs = {
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type QueryLimitationsAggregateArgs = {
  where?: InputMaybe<LimitationWhere>;
};


export type QueryLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<LimitationSort>>>;
  where?: InputMaybe<LimitationWhere>;
};


export type QueryMainIndicationsArgs = {
  options?: InputMaybe<MainIndicationOptions>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type QueryMainIndicationsAggregateArgs = {
  where?: InputMaybe<MainIndicationWhere>;
};


export type QueryMainIndicationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MainIndicationSort>>>;
  where?: InputMaybe<MainIndicationWhere>;
};


export type QueryMessagesArgs = {
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type QueryMessagesAggregateArgs = {
  where?: InputMaybe<MessageWhere>;
};


export type QueryMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MessageSort>>>;
  where?: InputMaybe<MessageWhere>;
};


export type QueryMicroContentsArgs = {
  options?: InputMaybe<MicroContentOptions>;
  where?: InputMaybe<MicroContentWhere>;
};


export type QueryMicroContentsAggregateArgs = {
  where?: InputMaybe<MicroContentWhere>;
};


export type QueryMicroContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MicroContentSort>>>;
  where?: InputMaybe<MicroContentWhere>;
};


export type QueryModelImagesArgs = {
  options?: InputMaybe<ModelImageOptions>;
  where?: InputMaybe<ModelImageWhere>;
};


export type QueryModelImagesAggregateArgs = {
  where?: InputMaybe<ModelImageWhere>;
};


export type QueryModelImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ModelImageSort>>>;
  where?: InputMaybe<ModelImageWhere>;
};


export type QueryModelInAgreementsArgs = {
  options?: InputMaybe<ModelInAgreementOptions>;
  where?: InputMaybe<ModelInAgreementWhere>;
};


export type QueryModelInAgreementsAggregateArgs = {
  where?: InputMaybe<ModelInAgreementWhere>;
};


export type QueryModelInAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ModelInAgreementSort>>>;
  where?: InputMaybe<ModelInAgreementWhere>;
};


export type QueryModelsArgs = {
  options?: InputMaybe<ModelOptions>;
  where?: InputMaybe<ModelWhere>;
};


export type QueryModelsAggregateArgs = {
  where?: InputMaybe<ModelWhere>;
};


export type QueryModelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ModelSort>>>;
  where?: InputMaybe<ModelWhere>;
};


export type QueryModelsSourceFilterDataArgs = {
  options?: InputMaybe<ModelsSourceFilterDataOptions>;
  where?: InputMaybe<ModelsSourceFilterDataWhere>;
};


export type QueryModelsSourceFilterDataAggregateArgs = {
  where?: InputMaybe<ModelsSourceFilterDataWhere>;
};


export type QueryModelsSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ModelsSourceFilterDataWhere>;
};


export type QueryModulesArgs = {
  options?: InputMaybe<ModuleOptions>;
  where?: InputMaybe<ModuleWhere>;
};


export type QueryModulesAggregateArgs = {
  where?: InputMaybe<ModuleWhere>;
};


export type QueryModulesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ModuleSort>>>;
  where?: InputMaybe<ModuleWhere>;
};


export type QueryMyRoleProfilesArgs = {
  options?: InputMaybe<MyRoleProfileOptions>;
  where?: InputMaybe<MyRoleProfileWhere>;
};


export type QueryMyRoleProfilesAggregateArgs = {
  where?: InputMaybe<MyRoleProfileWhere>;
};


export type QueryMyRoleProfilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<MyRoleProfileSort>>>;
  where?: InputMaybe<MyRoleProfileWhere>;
};


export type QueryNegotiationRoundsArgs = {
  options?: InputMaybe<NegotiationRoundOptions>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type QueryNegotiationRoundsAggregateArgs = {
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type QueryNegotiationRoundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NegotiationRoundSort>>>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type QueryNetRevenueByOrganizationsArgs = {
  options?: InputMaybe<NetRevenueByOrganizationOptions>;
  where?: InputMaybe<NetRevenueByOrganizationWhere>;
};


export type QueryNetRevenueByOrganizationsAggregateArgs = {
  where?: InputMaybe<NetRevenueByOrganizationWhere>;
};


export type QueryNetRevenueByOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NetRevenueByOrganizationSort>>>;
  where?: InputMaybe<NetRevenueByOrganizationWhere>;
};


export type QueryNinjaQueriesArgs = {
  options?: InputMaybe<NinjaQueryOptions>;
  where?: InputMaybe<NinjaQueryWhere>;
};


export type QueryNinjaQueriesAggregateArgs = {
  where?: InputMaybe<NinjaQueryWhere>;
};


export type QueryNinjaQueriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NinjaQuerySort>>>;
  where?: InputMaybe<NinjaQueryWhere>;
};


export type QueryNinjaQueryImpactsArgs = {
  options?: InputMaybe<NinjaQueryImpactOptions>;
  where?: InputMaybe<NinjaQueryImpactWhere>;
};


export type QueryNinjaQueryImpactsAggregateArgs = {
  where?: InputMaybe<NinjaQueryImpactWhere>;
};


export type QueryNinjaQueryImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NinjaQueryImpactSort>>>;
  where?: InputMaybe<NinjaQueryImpactWhere>;
};


export type QueryNinjaQuerySubmitResultsArgs = {
  options?: InputMaybe<NinjaQuerySubmitResultOptions>;
  where?: InputMaybe<NinjaQuerySubmitResultWhere>;
};


export type QueryNinjaQuerySubmitResultsAggregateArgs = {
  where?: InputMaybe<NinjaQuerySubmitResultWhere>;
};


export type QueryNinjaQuerySubmitResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NinjaQuerySubmitResultWhere>;
};


export type QueryNonEligibleReasonsArgs = {
  options?: InputMaybe<NonEligibleReasonOptions>;
  where?: InputMaybe<NonEligibleReasonWhere>;
};


export type QueryNonEligibleReasonsAggregateArgs = {
  where?: InputMaybe<NonEligibleReasonWhere>;
};


export type QueryNonEligibleReasonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NonEligibleReasonSort>>>;
  where?: InputMaybe<NonEligibleReasonWhere>;
};


export type QueryNonEnrolledReasonsArgs = {
  options?: InputMaybe<NonEnrolledReasonOptions>;
  where?: InputMaybe<NonEnrolledReasonWhere>;
};


export type QueryNonEnrolledReasonsAggregateArgs = {
  where?: InputMaybe<NonEnrolledReasonWhere>;
};


export type QueryNonEnrolledReasonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NonEnrolledReasonSort>>>;
  where?: InputMaybe<NonEnrolledReasonWhere>;
};


export type QueryNotificationsArgs = {
  options?: InputMaybe<NotificationOptions>;
  where?: InputMaybe<NotificationWhere>;
};


export type QueryNotificationsAggregateArgs = {
  where?: InputMaybe<NotificationWhere>;
};


export type QueryNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NotificationSort>>>;
  where?: InputMaybe<NotificationWhere>;
};


export type QueryNumericRangesArgs = {
  options?: InputMaybe<NumericRangeOptions>;
  where?: InputMaybe<NumericRangeWhere>;
};


export type QueryNumericRangesAggregateArgs = {
  where?: InputMaybe<NumericRangeWhere>;
};


export type QueryNumericRangesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<NumericRangeSort>>>;
  where?: InputMaybe<NumericRangeWhere>;
};


export type QueryOrganizationCaselessAgreementStatusesArgs = {
  options?: InputMaybe<OrganizationCaselessAgreementStatusOptions>;
  where?: InputMaybe<OrganizationCaselessAgreementStatusWhere>;
};


export type QueryOrganizationCaselessAgreementStatusesAggregateArgs = {
  where?: InputMaybe<OrganizationCaselessAgreementStatusWhere>;
};


export type QueryOrganizationCaselessAgreementStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationCaselessAgreementStatusSort>>>;
  where?: InputMaybe<OrganizationCaselessAgreementStatusWhere>;
};


export type QueryOrganizationDomainsWithCountersArgs = {
  options?: InputMaybe<OrganizationDomainsWithCountersOptions>;
  where?: InputMaybe<OrganizationDomainsWithCountersWhere>;
};


export type QueryOrganizationDomainsWithCountersAggregateArgs = {
  where?: InputMaybe<OrganizationDomainsWithCountersWhere>;
};


export type QueryOrganizationDomainsWithCountersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrganizationDomainsWithCountersWhere>;
};


export type QueryOrganizationScopesArgs = {
  options?: InputMaybe<OrganizationScopeOptions>;
  where?: InputMaybe<OrganizationScopeWhere>;
};


export type QueryOrganizationScopesAggregateArgs = {
  where?: InputMaybe<OrganizationScopeWhere>;
};


export type QueryOrganizationScopesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationScopeSort>>>;
  where?: InputMaybe<OrganizationScopeWhere>;
};


export type QueryOrganizationsArgs = {
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QueryOrganizationsAggregateArgs = {
  where?: InputMaybe<OrganizationWhere>;
};


export type QueryOrganizationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrganizationSort>>>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QueryOutcomebasedAgreementReportsArgs = {
  options?: InputMaybe<OutcomebasedAgreementReportOptions>;
  where?: InputMaybe<OutcomebasedAgreementReportWhere>;
};


export type QueryOutcomebasedAgreementReportsAggregateArgs = {
  where?: InputMaybe<OutcomebasedAgreementReportWhere>;
};


export type QueryOutcomebasedAgreementReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OutcomebasedAgreementReportSort>>>;
  where?: InputMaybe<OutcomebasedAgreementReportWhere>;
};


export type QueryPartnersArgs = {
  options?: InputMaybe<PartnerOptions>;
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPartnersAggregateArgs = {
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PartnerSort>>>;
  where?: InputMaybe<PartnerWhere>;
};


export type QueryPatientCountDataPointsArgs = {
  options?: InputMaybe<PatientCountDataPointOptions>;
  where?: InputMaybe<PatientCountDataPointWhere>;
};


export type QueryPatientCountDataPointsAggregateArgs = {
  where?: InputMaybe<PatientCountDataPointWhere>;
};


export type QueryPatientCountDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientCountDataPointSort>>>;
  where?: InputMaybe<PatientCountDataPointWhere>;
};


export type QueryPatientReportDataPointsArgs = {
  options?: InputMaybe<PatientReportDataPointOptions>;
  where?: InputMaybe<PatientReportDataPointWhere>;
};


export type QueryPatientReportDataPointsAggregateArgs = {
  where?: InputMaybe<PatientReportDataPointWhere>;
};


export type QueryPatientReportDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientReportDataPointSort>>>;
  where?: InputMaybe<PatientReportDataPointWhere>;
};


export type QueryPatientReviewDataArgs = {
  options?: InputMaybe<PatientReviewDataOptions>;
  where?: InputMaybe<PatientReviewDataWhere>;
};


export type QueryPatientReviewDataAggregateArgs = {
  where?: InputMaybe<PatientReviewDataWhere>;
};


export type QueryPatientReviewDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientReviewDataSort>>>;
  where?: InputMaybe<PatientReviewDataWhere>;
};


export type QueryPatientStatusDistributionsArgs = {
  options?: InputMaybe<PatientStatusDistributionOptions>;
  where?: InputMaybe<PatientStatusDistributionWhere>;
};


export type QueryPatientStatusDistributionsAggregateArgs = {
  where?: InputMaybe<PatientStatusDistributionWhere>;
};


export type QueryPatientStatusDistributionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientStatusDistributionSort>>>;
  where?: InputMaybe<PatientStatusDistributionWhere>;
};


export type QueryPatientsArgs = {
  options?: InputMaybe<PatientOptions>;
  where?: InputMaybe<PatientWhere>;
};


export type QueryPatientsAggregateArgs = {
  where?: InputMaybe<PatientWhere>;
};


export type QueryPatientsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientSort>>>;
  where?: InputMaybe<PatientWhere>;
};


export type QueryPatientsPerMonthDataPointsArgs = {
  options?: InputMaybe<PatientsPerMonthDataPointOptions>;
  where?: InputMaybe<PatientsPerMonthDataPointWhere>;
};


export type QueryPatientsPerMonthDataPointsAggregateArgs = {
  where?: InputMaybe<PatientsPerMonthDataPointWhere>;
};


export type QueryPatientsPerMonthDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PatientsPerMonthDataPointSort>>>;
  where?: InputMaybe<PatientsPerMonthDataPointWhere>;
};


export type QueryPdfReportFilesArgs = {
  options?: InputMaybe<PdfReportFileOptions>;
  where?: InputMaybe<PdfReportFileWhere>;
};


export type QueryPdfReportFilesAggregateArgs = {
  where?: InputMaybe<PdfReportFileWhere>;
};


export type QueryPdfReportFilesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PdfReportFileSort>>>;
  where?: InputMaybe<PdfReportFileWhere>;
};


export type QueryPdfTokensArgs = {
  options?: InputMaybe<PdfTokenOptions>;
  where?: InputMaybe<PdfTokenWhere>;
};


export type QueryPdfTokensAggregateArgs = {
  where?: InputMaybe<PdfTokenWhere>;
};


export type QueryPdfTokensConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PdfTokenSort>>>;
  where?: InputMaybe<PdfTokenWhere>;
};


export type QueryPerformanceCountersArgs = {
  options?: InputMaybe<PerformanceCounterOptions>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type QueryPerformanceCountersAggregateArgs = {
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type QueryPerformanceCountersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PerformanceCounterSort>>>;
  where?: InputMaybe<PerformanceCounterWhere>;
};


export type QueryPerformanceMeasurementsArgs = {
  options?: InputMaybe<PerformanceMeasurementOptions>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type QueryPerformanceMeasurementsAggregateArgs = {
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type QueryPerformanceMeasurementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PerformanceMeasurementSort>>>;
  where?: InputMaybe<PerformanceMeasurementWhere>;
};


export type QueryPerformanceThresholdsArgs = {
  options?: InputMaybe<PerformanceThresholdOptions>;
  where?: InputMaybe<PerformanceThresholdWhere>;
};


export type QueryPerformanceThresholdsAggregateArgs = {
  where?: InputMaybe<PerformanceThresholdWhere>;
};


export type QueryPerformanceThresholdsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PerformanceThresholdSort>>>;
  where?: InputMaybe<PerformanceThresholdWhere>;
};


export type QueryPiRecurrenceSiDataPointsArgs = {
  options?: InputMaybe<PiRecurrenceSiDataPointOptions>;
  where?: InputMaybe<PiRecurrenceSiDataPointWhere>;
};


export type QueryPiRecurrenceSiDataPointsAggregateArgs = {
  where?: InputMaybe<PiRecurrenceSiDataPointWhere>;
};


export type QueryPiRecurrenceSiDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PiRecurrenceSiDataPointSort>>>;
  where?: InputMaybe<PiRecurrenceSiDataPointWhere>;
};


export type QueryPlannedAgreementRunsArgs = {
  options?: InputMaybe<PlannedAgreementRunOptions>;
  where?: InputMaybe<PlannedAgreementRunWhere>;
};


export type QueryPlannedAgreementRunsAggregateArgs = {
  where?: InputMaybe<PlannedAgreementRunWhere>;
};


export type QueryPlannedAgreementRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PlannedAgreementRunSort>>>;
  where?: InputMaybe<PlannedAgreementRunWhere>;
};


export type QueryPreparationStatusesArgs = {
  options?: InputMaybe<PreparationStatusOptions>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type QueryPreparationStatusesAggregateArgs = {
  where?: InputMaybe<PreparationStatusWhere>;
};


export type QueryPreparationStatusesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PreparationStatusSort>>>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type QueryPreparationsArgs = {
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type QueryPreparationsAggregateArgs = {
  where?: InputMaybe<PreparationWhere>;
};


export type QueryPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PreparationSort>>>;
  where?: InputMaybe<PreparationWhere>;
};


export type QueryPriceDataArgs = {
  options?: InputMaybe<PriceDataOptions>;
  where?: InputMaybe<PriceDataWhere>;
};


export type QueryPriceDataAggregateArgs = {
  where?: InputMaybe<PriceDataWhere>;
};


export type QueryPriceDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PriceDataSort>>>;
  where?: InputMaybe<PriceDataWhere>;
};


export type QueryPricesArgs = {
  options?: InputMaybe<PriceOptions>;
  where?: InputMaybe<PriceWhere>;
};


export type QueryPricesAggregateArgs = {
  where?: InputMaybe<PriceWhere>;
};


export type QueryPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PriceSort>>>;
  where?: InputMaybe<PriceWhere>;
};


export type QueryProductBlueprintsArgs = {
  options?: InputMaybe<ProductBlueprintOptions>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type QueryProductBlueprintsAggregateArgs = {
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type QueryProductBlueprintsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProductBlueprintSort>>>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type QueryProfileDataInfosArgs = {
  options?: InputMaybe<ProfileDataInfoOptions>;
  where?: InputMaybe<ProfileDataInfoWhere>;
};


export type QueryProfileDataInfosAggregateArgs = {
  where?: InputMaybe<ProfileDataInfoWhere>;
};


export type QueryProfileDataInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProfileDataInfoSort>>>;
  where?: InputMaybe<ProfileDataInfoWhere>;
};


export type QueryProfileImagesArgs = {
  options?: InputMaybe<ProfileImageOptions>;
  where?: InputMaybe<ProfileImageWhere>;
};


export type QueryProfileImagesAggregateArgs = {
  where?: InputMaybe<ProfileImageWhere>;
};


export type QueryProfileImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProfileImageSort>>>;
  where?: InputMaybe<ProfileImageWhere>;
};


export type QueryPublicAgreementProductPricesArgs = {
  options?: InputMaybe<PublicAgreementProductPriceOptions>;
  where?: InputMaybe<PublicAgreementProductPriceWhere>;
};


export type QueryPublicAgreementProductPricesAggregateArgs = {
  where?: InputMaybe<PublicAgreementProductPriceWhere>;
};


export type QueryPublicAgreementProductPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicAgreementProductPriceSort>>>;
  where?: InputMaybe<PublicAgreementProductPriceWhere>;
};


export type QueryPublicAgreementsArgs = {
  options?: InputMaybe<PublicAgreementsOptions>;
  where?: InputMaybe<PublicAgreementsWhere>;
};


export type QueryPublicAgreementsAggregateArgs = {
  where?: InputMaybe<PublicAgreementsWhere>;
};


export type QueryPublicAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicAgreementsSort>>>;
  where?: InputMaybe<PublicAgreementsWhere>;
};


export type QueryPublicAgreementsCountsArgs = {
  options?: InputMaybe<PublicAgreementsCountOptions>;
  where?: InputMaybe<PublicAgreementsCountWhere>;
};


export type QueryPublicAgreementsCountsAggregateArgs = {
  where?: InputMaybe<PublicAgreementsCountWhere>;
};


export type QueryPublicAgreementsCountsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicAgreementsCountSort>>>;
  where?: InputMaybe<PublicAgreementsCountWhere>;
};


export type QueryPublicAgreementsDashboardResultsArgs = {
  options?: InputMaybe<PublicAgreementsDashboardResultOptions>;
  where?: InputMaybe<PublicAgreementsDashboardResultWhere>;
};


export type QueryPublicAgreementsDashboardResultsAggregateArgs = {
  where?: InputMaybe<PublicAgreementsDashboardResultWhere>;
};


export type QueryPublicAgreementsDashboardResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicAgreementsDashboardResultSort>>>;
  where?: InputMaybe<PublicAgreementsDashboardResultWhere>;
};


export type QueryPublicAgreementsTableSourceFilterDataArgs = {
  options?: InputMaybe<PublicAgreementsTableSourceFilterDataOptions>;
  where?: InputMaybe<PublicAgreementsTableSourceFilterDataWhere>;
};


export type QueryPublicAgreementsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<PublicAgreementsTableSourceFilterDataWhere>;
};


export type QueryPublicAgreementsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicAgreementsTableSourceFilterDataSort>>>;
  where?: InputMaybe<PublicAgreementsTableSourceFilterDataWhere>;
};


export type QueryPublicPricesArgs = {
  options?: InputMaybe<PublicPriceOptions>;
  where?: InputMaybe<PublicPriceWhere>;
};


export type QueryPublicPricesAggregateArgs = {
  where?: InputMaybe<PublicPriceWhere>;
};


export type QueryPublicPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PublicPriceSort>>>;
  where?: InputMaybe<PublicPriceWhere>;
};


export type QueryPurchasesArgs = {
  options?: InputMaybe<PurchaseOptions>;
  where?: InputMaybe<PurchaseWhere>;
};


export type QueryPurchasesAggregateArgs = {
  where?: InputMaybe<PurchaseWhere>;
};


export type QueryPurchasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<PurchaseSort>>>;
  where?: InputMaybe<PurchaseWhere>;
};


export type QueryQuestNotificationsArgs = {
  options?: InputMaybe<QuestNotificationOptions>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type QueryQuestNotificationsAggregateArgs = {
  where?: InputMaybe<QuestNotificationWhere>;
};


export type QueryQuestNotificationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestNotificationSort>>>;
  where?: InputMaybe<QuestNotificationWhere>;
};


export type QueryQuestTableRowsArgs = {
  options?: InputMaybe<QuestTableRowOptions>;
  where?: InputMaybe<QuestTableRowWhere>;
};


export type QueryQuestTableRowsAggregateArgs = {
  where?: InputMaybe<QuestTableRowWhere>;
};


export type QueryQuestTableRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestTableRowSort>>>;
  where?: InputMaybe<QuestTableRowWhere>;
};


export type QueryQuestViewTableSourceFilterDataArgs = {
  options?: InputMaybe<QuestViewTableSourceFilterDataOptions>;
  where?: InputMaybe<QuestViewTableSourceFilterDataWhere>;
};


export type QueryQuestViewTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<QuestViewTableSourceFilterDataWhere>;
};


export type QueryQuestViewTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestViewTableSourceFilterDataSort>>>;
  where?: InputMaybe<QuestViewTableSourceFilterDataWhere>;
};


export type QueryQuestsArgs = {
  options?: InputMaybe<QuestOptions>;
  where?: InputMaybe<QuestWhere>;
};


export type QueryQuestsAggregateArgs = {
  where?: InputMaybe<QuestWhere>;
};


export type QueryQuestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestSort>>>;
  where?: InputMaybe<QuestWhere>;
};


export type QueryQuestsTableSourceFilterDataArgs = {
  options?: InputMaybe<QuestsTableSourceFilterDataOptions>;
  where?: InputMaybe<QuestsTableSourceFilterDataWhere>;
};


export type QueryQuestsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<QuestsTableSourceFilterDataWhere>;
};


export type QueryQuestsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<QuestsTableSourceFilterDataSort>>>;
  where?: InputMaybe<QuestsTableSourceFilterDataWhere>;
};


export type QueryRandomMicrocontentContentsArgs = {
  options?: InputMaybe<RandomMicrocontentContentOptions>;
  where?: InputMaybe<RandomMicrocontentContentWhere>;
};


export type QueryRandomMicrocontentContentsAggregateArgs = {
  where?: InputMaybe<RandomMicrocontentContentWhere>;
};


export type QueryRandomMicrocontentContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RandomMicrocontentContentWhere>;
};


export type QueryReasonOfTreatmentDiscontinuationReportsArgs = {
  options?: InputMaybe<ReasonOfTreatmentDiscontinuationReportOptions>;
  where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};


export type QueryReasonOfTreatmentDiscontinuationReportsAggregateArgs = {
  where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};


export type QueryReasonOfTreatmentDiscontinuationReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ReasonOfTreatmentDiscontinuationReportSort>>>;
  where?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
};


export type QueryRecordsArgs = {
  options?: InputMaybe<RecordOptions>;
  where?: InputMaybe<RecordWhere>;
};


export type QueryRecordsAggregateArgs = {
  where?: InputMaybe<RecordWhere>;
};


export type QueryRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RecordSort>>>;
  where?: InputMaybe<RecordWhere>;
};


export type QueryRecordsTableSourceFilterDataArgs = {
  options?: InputMaybe<RecordsTableSourceFilterDataOptions>;
  where?: InputMaybe<RecordsTableSourceFilterDataWhere>;
};


export type QueryRecordsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<RecordsTableSourceFilterDataWhere>;
};


export type QueryRecordsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RecordsTableSourceFilterDataSort>>>;
  where?: InputMaybe<RecordsTableSourceFilterDataWhere>;
};


export type QueryRefundTableRowsArgs = {
  options?: InputMaybe<RefundTableRowOptions>;
  where?: InputMaybe<RefundTableRowWhere>;
};


export type QueryRefundTableRowsAggregateArgs = {
  where?: InputMaybe<RefundTableRowWhere>;
};


export type QueryRefundTableRowsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RefundTableRowSort>>>;
  where?: InputMaybe<RefundTableRowWhere>;
};


export type QueryRefundXmlReportDataArgs = {
  options?: InputMaybe<RefundXmlReportDataOptions>;
  where?: InputMaybe<RefundXmlReportDataWhere>;
};


export type QueryRefundXmlReportDataAggregateArgs = {
  where?: InputMaybe<RefundXmlReportDataWhere>;
};


export type QueryRefundXmlReportDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RefundXmlReportDataSort>>>;
  where?: InputMaybe<RefundXmlReportDataWhere>;
};


export type QueryRefundsArgs = {
  options?: InputMaybe<RefundOptions>;
  where?: InputMaybe<RefundWhere>;
};


export type QueryRefundsAggregateArgs = {
  where?: InputMaybe<RefundWhere>;
};


export type QueryRefundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RefundSort>>>;
  where?: InputMaybe<RefundWhere>;
};


export type QueryRefundsTableSourceFilterDataArgs = {
  options?: InputMaybe<RefundsTableSourceFilterDataOptions>;
  where?: InputMaybe<RefundsTableSourceFilterDataWhere>;
};


export type QueryRefundsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<RefundsTableSourceFilterDataWhere>;
};


export type QueryRefundsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<RefundsTableSourceFilterDataSort>>>;
  where?: InputMaybe<RefundsTableSourceFilterDataWhere>;
};


export type QueryReportingDashboardSummariesArgs = {
  options?: InputMaybe<ReportingDashboardSummaryOptions>;
  where?: InputMaybe<ReportingDashboardSummaryWhere>;
};


export type QueryReportingDashboardSummariesAggregateArgs = {
  where?: InputMaybe<ReportingDashboardSummaryWhere>;
};


export type QueryReportingDashboardSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ReportingDashboardSummarySort>>>;
  where?: InputMaybe<ReportingDashboardSummaryWhere>;
};


export type QueryReportingSummariesArgs = {
  options?: InputMaybe<ReportingSummaryOptions>;
  where?: InputMaybe<ReportingSummaryWhere>;
};


export type QueryReportingSummariesAggregateArgs = {
  where?: InputMaybe<ReportingSummaryWhere>;
};


export type QueryReportingSummariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ReportingSummarySort>>>;
  where?: InputMaybe<ReportingSummaryWhere>;
};


export type QueryRevokableRecordsReportsArgs = {
  options?: InputMaybe<RevokableRecordsReportOptions>;
  where?: InputMaybe<RevokableRecordsReportWhere>;
};


export type QueryRevokableRecordsReportsAggregateArgs = {
  where?: InputMaybe<RevokableRecordsReportWhere>;
};


export type QueryRevokableRecordsReportsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RevokableRecordsReportWhere>;
};


export type QuerySaveSimulationResultsArgs = {
  options?: InputMaybe<SaveSimulationResultOptions>;
  where?: InputMaybe<SaveSimulationResultWhere>;
};


export type QuerySaveSimulationResultsAggregateArgs = {
  where?: InputMaybe<SaveSimulationResultWhere>;
};


export type QuerySaveSimulationResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SaveSimulationResultSort>>>;
  where?: InputMaybe<SaveSimulationResultWhere>;
};


export type QueryScenarioActionsArgs = {
  options?: InputMaybe<ScenarioActionOptions>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type QueryScenarioActionsAggregateArgs = {
  where?: InputMaybe<ScenarioActionWhere>;
};


export type QueryScenarioActionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScenarioActionSort>>>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type QueryScenarioConditionsArgs = {
  options?: InputMaybe<ScenarioConditionOptions>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type QueryScenarioConditionsAggregateArgs = {
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type QueryScenarioConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScenarioConditionSort>>>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type QueryScenariosArgs = {
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type QueryScenariosAggregateArgs = {
  where?: InputMaybe<ScenarioWhere>;
};


export type QueryScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScenarioSort>>>;
  where?: InputMaybe<ScenarioWhere>;
};


export type QueryScheduledAgreementRunsArgs = {
  options?: InputMaybe<ScheduledAgreementRunOptions>;
  where?: InputMaybe<ScheduledAgreementRunWhere>;
};


export type QueryScheduledAgreementRunsAggregateArgs = {
  where?: InputMaybe<ScheduledAgreementRunWhere>;
};


export type QueryScheduledAgreementRunsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ScheduledAgreementRunSort>>>;
  where?: InputMaybe<ScheduledAgreementRunWhere>;
};


export type QuerySendDocumentToSmartMipResultsArgs = {
  options?: InputMaybe<SendDocumentToSmartMipResultOptions>;
  where?: InputMaybe<SendDocumentToSmartMipResultWhere>;
};


export type QuerySendDocumentToSmartMipResultsAggregateArgs = {
  where?: InputMaybe<SendDocumentToSmartMipResultWhere>;
};


export type QuerySendDocumentToSmartMipResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SendDocumentToSmartMipResultSort>>>;
  where?: InputMaybe<SendDocumentToSmartMipResultWhere>;
};


export type QuerySimulationCountResultsArgs = {
  options?: InputMaybe<SimulationCountResultOptions>;
  where?: InputMaybe<SimulationCountResultWhere>;
};


export type QuerySimulationCountResultsAggregateArgs = {
  where?: InputMaybe<SimulationCountResultWhere>;
};


export type QuerySimulationCountResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationCountResultSort>>>;
  where?: InputMaybe<SimulationCountResultWhere>;
};


export type QuerySimulationUserWithRolesArgs = {
  options?: InputMaybe<SimulationUserWithRoleOptions>;
  where?: InputMaybe<SimulationUserWithRoleWhere>;
};


export type QuerySimulationUserWithRolesAggregateArgs = {
  where?: InputMaybe<SimulationUserWithRoleWhere>;
};


export type QuerySimulationUserWithRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationUserWithRoleSort>>>;
  where?: InputMaybe<SimulationUserWithRoleWhere>;
};


export type QuerySimulationsArgs = {
  options?: InputMaybe<SimulationOptions>;
  where?: InputMaybe<SimulationWhere>;
};


export type QuerySimulationsAggregateArgs = {
  where?: InputMaybe<SimulationWhere>;
};


export type QuerySimulationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationSort>>>;
  where?: InputMaybe<SimulationWhere>;
};


export type QuerySimulationsTableSourceFilterDataArgs = {
  options?: InputMaybe<SimulationsTableSourceFilterDataOptions>;
  where?: InputMaybe<SimulationsTableSourceFilterDataWhere>;
};


export type QuerySimulationsTableSourceFilterDataAggregateArgs = {
  where?: InputMaybe<SimulationsTableSourceFilterDataWhere>;
};


export type QuerySimulationsTableSourceFilterDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SimulationsTableSourceFilterDataSort>>>;
  where?: InputMaybe<SimulationsTableSourceFilterDataWhere>;
};


export type QuerySmartMipInvoicePdfResultsArgs = {
  options?: InputMaybe<SmartMipInvoicePdfResultOptions>;
  where?: InputMaybe<SmartMipInvoicePdfResultWhere>;
};


export type QuerySmartMipInvoicePdfResultsAggregateArgs = {
  where?: InputMaybe<SmartMipInvoicePdfResultWhere>;
};


export type QuerySmartMipInvoicePdfResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SmartMipInvoicePdfResultSort>>>;
  where?: InputMaybe<SmartMipInvoicePdfResultWhere>;
};


export type QuerySmartMipPendingDocumentsArgs = {
  options?: InputMaybe<SmartMipPendingDocumentOptions>;
  where?: InputMaybe<SmartMipPendingDocumentWhere>;
};


export type QuerySmartMipPendingDocumentsAggregateArgs = {
  where?: InputMaybe<SmartMipPendingDocumentWhere>;
};


export type QuerySmartMipPendingDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SmartMipPendingDocumentSort>>>;
  where?: InputMaybe<SmartMipPendingDocumentWhere>;
};


export type QuerySourcesArgs = {
  options?: InputMaybe<SourcesOptions>;
  where?: InputMaybe<SourcesWhere>;
};


export type QuerySourcesAggregateArgs = {
  where?: InputMaybe<SourcesWhere>;
};


export type QuerySourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SourcesSort>>>;
  where?: InputMaybe<SourcesWhere>;
};


export type QuerySvgFlagsArgs = {
  options?: InputMaybe<SvgFlagOptions>;
  where?: InputMaybe<SvgFlagWhere>;
};


export type QuerySvgFlagsAggregateArgs = {
  where?: InputMaybe<SvgFlagWhere>;
};


export type QuerySvgFlagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SvgFlagSort>>>;
  where?: InputMaybe<SvgFlagWhere>;
};


export type QuerySyncRefundImpactsArgs = {
  options?: InputMaybe<SyncRefundImpactOptions>;
  where?: InputMaybe<SyncRefundImpactWhere>;
};


export type QuerySyncRefundImpactsAggregateArgs = {
  where?: InputMaybe<SyncRefundImpactWhere>;
};


export type QuerySyncRefundImpactsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SyncRefundImpactSort>>>;
  where?: InputMaybe<SyncRefundImpactWhere>;
};


export type QuerySyncResponsesArgs = {
  options?: InputMaybe<SyncResponseOptions>;
  where?: InputMaybe<SyncResponseWhere>;
};


export type QuerySyncResponsesAggregateArgs = {
  where?: InputMaybe<SyncResponseWhere>;
};


export type QuerySyncResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SyncResponseSort>>>;
  where?: InputMaybe<SyncResponseWhere>;
};


export type QueryTadisArgs = {
  options?: InputMaybe<TadiOptions>;
  where?: InputMaybe<TadiWhere>;
};


export type QueryTadisAggregateArgs = {
  where?: InputMaybe<TadiWhere>;
};


export type QueryTadisConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TadiSort>>>;
  where?: InputMaybe<TadiWhere>;
};


export type QueryTasksArgs = {
  options?: InputMaybe<TaskOptions>;
  where?: InputMaybe<TaskWhere>;
};


export type QueryTasksAggregateArgs = {
  where?: InputMaybe<TaskWhere>;
};


export type QueryTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TaskSort>>>;
  where?: InputMaybe<TaskWhere>;
};


export type QueryTenantSpecificAgreementUserRolesArgs = {
  options?: InputMaybe<TenantSpecificAgreementUserRoleOptions>;
  where?: InputMaybe<TenantSpecificAgreementUserRoleWhere>;
};


export type QueryTenantSpecificAgreementUserRolesAggregateArgs = {
  where?: InputMaybe<TenantSpecificAgreementUserRoleWhere>;
};


export type QueryTenantSpecificAgreementUserRolesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TenantSpecificAgreementUserRoleSort>>>;
  where?: InputMaybe<TenantSpecificAgreementUserRoleWhere>;
};


export type QueryTranslationsArgs = {
  options?: InputMaybe<TranslationOptions>;
  where?: InputMaybe<TranslationWhere>;
};


export type QueryTranslationsAggregateArgs = {
  where?: InputMaybe<TranslationWhere>;
};


export type QueryTranslationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TranslationSort>>>;
  where?: InputMaybe<TranslationWhere>;
};


export type QueryTranslationsResultsArgs = {
  options?: InputMaybe<TranslationsResultOptions>;
  where?: InputMaybe<TranslationsResultWhere>;
};


export type QueryTranslationsResultsAggregateArgs = {
  where?: InputMaybe<TranslationsResultWhere>;
};


export type QueryTranslationsResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TranslationsResultSort>>>;
  where?: InputMaybe<TranslationsResultWhere>;
};


export type QueryTreatingPhysiciansArgs = {
  options?: InputMaybe<TreatingPhysicianOptions>;
  where?: InputMaybe<TreatingPhysicianWhere>;
};


export type QueryTreatingPhysiciansAggregateArgs = {
  where?: InputMaybe<TreatingPhysicianWhere>;
};


export type QueryTreatingPhysiciansConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreatingPhysicianSort>>>;
  where?: InputMaybe<TreatingPhysicianWhere>;
};


export type QueryTreatmentPatientsArgs = {
  options?: InputMaybe<TreatmentPatientOptions>;
  where?: InputMaybe<TreatmentPatientWhere>;
};


export type QueryTreatmentPatientsAggregateArgs = {
  where?: InputMaybe<TreatmentPatientWhere>;
};


export type QueryTreatmentPatientsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreatmentPatientSort>>>;
  where?: InputMaybe<TreatmentPatientWhere>;
};


export type QueryTreatmentSetsArgs = {
  options?: InputMaybe<TreatmentSetOptions>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type QueryTreatmentSetsAggregateArgs = {
  where?: InputMaybe<TreatmentSetWhere>;
};


export type QueryTreatmentSetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreatmentSetSort>>>;
  where?: InputMaybe<TreatmentSetWhere>;
};


export type QueryTreatmentsArgs = {
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type QueryTreatmentsAggregateArgs = {
  where?: InputMaybe<TreatmentWhere>;
};


export type QueryTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<TreatmentSort>>>;
  where?: InputMaybe<TreatmentWhere>;
};


export type QueryUncertaintiesArgs = {
  options?: InputMaybe<UncertaintyOptions>;
  where?: InputMaybe<UncertaintyWhere>;
};


export type QueryUncertaintiesAggregateArgs = {
  where?: InputMaybe<UncertaintyWhere>;
};


export type QueryUncertaintiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UncertaintySort>>>;
  where?: InputMaybe<UncertaintyWhere>;
};


export type QueryUnfurlUrlsArgs = {
  options?: InputMaybe<UnfurlUrlOptions>;
  where?: InputMaybe<UnfurlUrlWhere>;
};


export type QueryUnfurlUrlsAggregateArgs = {
  where?: InputMaybe<UnfurlUrlWhere>;
};


export type QueryUnfurlUrlsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UnfurlUrlSort>>>;
  where?: InputMaybe<UnfurlUrlWhere>;
};


export type QueryUniqueModulesColumnsArgs = {
  options?: InputMaybe<UniqueModulesColumnsOptions>;
  where?: InputMaybe<UniqueModulesColumnsWhere>;
};


export type QueryUniqueModulesColumnsAggregateArgs = {
  where?: InputMaybe<UniqueModulesColumnsWhere>;
};


export type QueryUniqueModulesColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UniqueModulesColumnsWhere>;
};


export type QueryUploadFieldMappingsArgs = {
  options?: InputMaybe<UploadFieldMappingOptions>;
  where?: InputMaybe<UploadFieldMappingWhere>;
};


export type QueryUploadFieldMappingsAggregateArgs = {
  where?: InputMaybe<UploadFieldMappingWhere>;
};


export type QueryUploadFieldMappingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UploadFieldMappingSort>>>;
  where?: InputMaybe<UploadFieldMappingWhere>;
};


export type QueryUploadLimitationsArgs = {
  options?: InputMaybe<UploadLimitationOptions>;
  where?: InputMaybe<UploadLimitationWhere>;
};


export type QueryUploadLimitationsAggregateArgs = {
  where?: InputMaybe<UploadLimitationWhere>;
};


export type QueryUploadLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UploadLimitationSort>>>;
  where?: InputMaybe<UploadLimitationWhere>;
};


export type QueryUploadsArgs = {
  options?: InputMaybe<UploadOptions>;
  where?: InputMaybe<UploadWhere>;
};


export type QueryUploadsAggregateArgs = {
  where?: InputMaybe<UploadWhere>;
};


export type QueryUploadsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UploadSort>>>;
  where?: InputMaybe<UploadWhere>;
};


export type QueryUserContextsArgs = {
  options?: InputMaybe<UserContextOptions>;
  where?: InputMaybe<UserContextWhere>;
};


export type QueryUserContextsAggregateArgs = {
  where?: InputMaybe<UserContextWhere>;
};


export type QueryUserContextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserContextSort>>>;
  where?: InputMaybe<UserContextWhere>;
};


export type QueryUserLoginDatesArgs = {
  options?: InputMaybe<UserLoginDatesOptions>;
  where?: InputMaybe<UserLoginDatesWhere>;
};


export type QueryUserLoginDatesAggregateArgs = {
  where?: InputMaybe<UserLoginDatesWhere>;
};


export type QueryUserLoginDatesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserLoginDatesSort>>>;
  where?: InputMaybe<UserLoginDatesWhere>;
};


export type QueryUserOrgSettingsDataArgs = {
  options?: InputMaybe<UserOrgSettingsDataOptions>;
  where?: InputMaybe<UserOrgSettingsDataWhere>;
};


export type QueryUserOrgSettingsDataAggregateArgs = {
  where?: InputMaybe<UserOrgSettingsDataWhere>;
};


export type QueryUserOrgSettingsDataConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserOrgSettingsDataSort>>>;
  where?: InputMaybe<UserOrgSettingsDataWhere>;
};


export type QueryUserOrganizationInfosArgs = {
  options?: InputMaybe<UserOrganizationInfoOptions>;
  where?: InputMaybe<UserOrganizationInfoWhere>;
};


export type QueryUserOrganizationInfosAggregateArgs = {
  where?: InputMaybe<UserOrganizationInfoWhere>;
};


export type QueryUserOrganizationInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserOrganizationInfoSort>>>;
  where?: InputMaybe<UserOrganizationInfoWhere>;
};


export type QueryUserPersonalInfosArgs = {
  options?: InputMaybe<UserPersonalInfoOptions>;
  where?: InputMaybe<UserPersonalInfoWhere>;
};


export type QueryUserPersonalInfosAggregateArgs = {
  where?: InputMaybe<UserPersonalInfoWhere>;
};


export type QueryUserPersonalInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserPersonalInfoSort>>>;
  where?: InputMaybe<UserPersonalInfoWhere>;
};


export type QueryUsersArgs = {
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type QueryUsersAggregateArgs = {
  where?: InputMaybe<UserWhere>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<UserSort>>>;
  where?: InputMaybe<UserWhere>;
};


export type QueryValidatedComparisonResponsesArgs = {
  options?: InputMaybe<ValidatedComparisonResponseOptions>;
  where?: InputMaybe<ValidatedComparisonResponseWhere>;
};


export type QueryValidatedComparisonResponsesAggregateArgs = {
  where?: InputMaybe<ValidatedComparisonResponseWhere>;
};


export type QueryValidatedComparisonResponsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ValidatedComparisonResponseWhere>;
};

export type Quest = {
  __typename?: 'Quest';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Brand>;
  brandAggregate?: Maybe<QuestBrandBrandAggregationSelection>;
  brandConnection: QuestBrandConnection;
  brandName?: Maybe<Scalars['String']['output']>;
  case?: Maybe<Case>;
  caseAggregate?: Maybe<QuestCaseCaseAggregationSelection>;
  caseConnection: QuestCaseConnection;
  completedOn?: Maybe<Scalars['DateTime']['output']>;
  completionStatus: QuestCompletionStatus;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  patientsNo?: Maybe<Scalars['Int']['output']>;
  questContentDe?: Maybe<Scalars['String']['output']>;
  questContentEn?: Maybe<Scalars['String']['output']>;
  questOwner?: Maybe<User>;
  questOwnerName?: Maybe<Scalars['String']['output']>;
  questStatus?: Maybe<TaskStatus>;
  recordsCompleted?: Maybe<Scalars['Int']['output']>;
  recordsCount?: Maybe<Scalars['Int']['output']>;
  recordsRelationship: Array<Record>;
  recordsRelationshipAggregate?: Maybe<QuestRecordRecordsRelationshipAggregationSelection>;
  recordsRelationshipConnection: QuestRecordsRelationshipConnection;
  resolvedByName?: Maybe<Scalars['String']['output']>;
  tenantIds: Array<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Int']['output']>;
  timeStamp: Scalars['Float']['output'];
  triggerEventId: Scalars['Int']['output'];
  usersRelationship: Array<User>;
  usersRelationshipAggregate?: Maybe<QuestUserUsersRelationshipAggregationSelection>;
  usersRelationshipConnection: QuestUsersRelationshipConnection;
  value?: Maybe<Scalars['Float']['output']>;
};


export type QuestBrandArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type QuestBrandAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type QuestBrandConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestBrandConnectionSort>>;
  where?: InputMaybe<QuestBrandConnectionWhere>;
};


export type QuestCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type QuestCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type QuestCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestCaseConnectionSort>>;
  where?: InputMaybe<QuestCaseConnectionWhere>;
};


export type QuestRecordsRelationshipArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordOptions>;
  where?: InputMaybe<RecordWhere>;
};


export type QuestRecordsRelationshipAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RecordWhere>;
};


export type QuestRecordsRelationshipConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestRecordsRelationshipConnectionSort>>;
  where?: InputMaybe<QuestRecordsRelationshipConnectionWhere>;
};


export type QuestUsersRelationshipArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type QuestUsersRelationshipAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type QuestUsersRelationshipConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestUsersRelationshipConnectionSort>>;
  where?: InputMaybe<QuestUsersRelationshipConnectionWhere>;
};

export type QuestAggregateSelection = {
  __typename?: 'QuestAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  questContentDe: StringAggregateSelectionNullable;
  questContentEn: StringAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
  timeStamp: FloatAggregateSelectionNonNullable;
  triggerEventId: IntAggregateSelectionNonNullable;
  value: FloatAggregateSelectionNullable;
};

export type QuestBrandAggregateInput = {
  AND?: InputMaybe<Array<QuestBrandAggregateInput>>;
  NOT?: InputMaybe<QuestBrandAggregateInput>;
  OR?: InputMaybe<Array<QuestBrandAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestBrandNodeAggregationWhereInput>;
};

export type QuestBrandBrandAggregationSelection = {
  __typename?: 'QuestBrandBrandAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<QuestBrandBrandNodeAggregateSelection>;
};

export type QuestBrandBrandNodeAggregateSelection = {
  __typename?: 'QuestBrandBrandNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type QuestBrandConnection = {
  __typename?: 'QuestBrandConnection';
  edges: Array<QuestBrandRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestBrandConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type QuestBrandConnectionWhere = {
  AND?: InputMaybe<Array<QuestBrandConnectionWhere>>;
  NOT?: InputMaybe<QuestBrandConnectionWhere>;
  OR?: InputMaybe<Array<QuestBrandConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type QuestBrandNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestBrandNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestBrandNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<QuestBrandNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuestBrandRelationship = {
  __typename?: 'QuestBrandRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type QuestCaseAggregateInput = {
  AND?: InputMaybe<Array<QuestCaseAggregateInput>>;
  NOT?: InputMaybe<QuestCaseAggregateInput>;
  OR?: InputMaybe<Array<QuestCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestCaseNodeAggregationWhereInput>;
};

export type QuestCaseCaseAggregationSelection = {
  __typename?: 'QuestCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<QuestCaseCaseNodeAggregateSelection>;
};

export type QuestCaseCaseNodeAggregateSelection = {
  __typename?: 'QuestCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type QuestCaseConnection = {
  __typename?: 'QuestCaseConnection';
  edges: Array<QuestCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type QuestCaseConnectionWhere = {
  AND?: InputMaybe<Array<QuestCaseConnectionWhere>>;
  NOT?: InputMaybe<QuestCaseConnectionWhere>;
  OR?: InputMaybe<Array<QuestCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type QuestCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestCaseRelationship = {
  __typename?: 'QuestCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export enum QuestCompletionStatus {
  Active = 'ACTIVE',
  Dismissed = 'DISMISSED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  SubmittedForm = 'SUBMITTED_FORM'
}

export type QuestEdge = {
  __typename?: 'QuestEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Quest;
};

export type QuestNotification = {
  __typename?: 'QuestNotification';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subscribed: Array<Organization>;
  subscribedAggregate?: Maybe<QuestNotificationOrganizationSubscribedAggregationSelection>;
  subscribedConnection: QuestNotificationSubscribedConnection;
};


export type QuestNotificationSubscribedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<OrganizationOptions>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QuestNotificationSubscribedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<OrganizationWhere>;
};


export type QuestNotificationSubscribedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestNotificationSubscribedConnectionSort>>;
  where?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
};

export type QuestNotificationAggregateSelection = {
  __typename?: 'QuestNotificationAggregateSelection';
  count: Scalars['Int']['output'];
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type QuestNotificationEdge = {
  __typename?: 'QuestNotificationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: QuestNotification;
};

export type QuestNotificationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestNotificationSort objects to sort QuestNotifications by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuestNotificationSort>>;
};

export type QuestNotificationOrganizationSubscribedAggregationSelection = {
  __typename?: 'QuestNotificationOrganizationSubscribedAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<QuestNotificationOrganizationSubscribedEdgeAggregateSelection>;
  node?: Maybe<QuestNotificationOrganizationSubscribedNodeAggregateSelection>;
};

export type QuestNotificationOrganizationSubscribedEdgeAggregateSelection = {
  __typename?: 'QuestNotificationOrganizationSubscribedEdgeAggregateSelection';
  autocompletionThreshold: IntAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
};

export type QuestNotificationOrganizationSubscribedNodeAggregateSelection = {
  __typename?: 'QuestNotificationOrganizationSubscribedNodeAggregateSelection';
  BIC: StringAggregateSelectionNullable;
  IBAN: StringAggregateSelectionNullable;
  accountName: StringAggregateSelectionNullable;
  accountNumber: StringAggregateSelectionNullable;
  aggregationPriority: IntAggregateSelectionNullable;
  autoIssuanceDelay: FloatAggregateSelectionNullable;
  autoIssuanceThreshold: FloatAggregateSelectionNullable;
  billingAddress: StringAggregateSelectionNullable;
  contactEmail: StringAggregateSelectionNullable;
  contactFirstName: StringAggregateSelectionNullable;
  contactLastName: StringAggregateSelectionNullable;
  contactOccupation: StringAggregateSelectionNullable;
  contactPhone: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
  deliveryAddress: StringAggregateSelectionNullable;
  documentReviewReminderDelay: FloatAggregateSelectionNullable;
  documentReviewReminderRecurrentStep: FloatAggregateSelectionNullable;
  documentSftpSavePath: StringAggregateSelectionNullable;
  domicile: StringAggregateSelectionNullable;
  dualApprovalThreshold: IntAggregateSelectionNullable;
  eIN: StringAggregateSelectionNullable;
  fax: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  legalName: StringAggregateSelectionNullable;
  logo: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  organizationId: StringAggregateSelectionNullable;
  paymentTerms: IntAggregateSelectionNonNullable;
  pharmaId: StringAggregateSelectionNullable;
  phone: StringAggregateSelectionNullable;
  rebateProcessorId: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNullable;
  website: StringAggregateSelectionNullable;
};

/** Fields to sort QuestNotifications by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestNotificationSort object. */
export type QuestNotificationSort = {
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type QuestNotificationSubscribedAggregateInput = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedAggregateInput>>;
  NOT?: InputMaybe<QuestNotificationSubscribedAggregateInput>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<QuestNotificationSubscribedEdgeAggregationWhereInput>;
  node?: InputMaybe<QuestNotificationSubscribedNodeAggregationWhereInput>;
};

export type QuestNotificationSubscribedConnection = {
  __typename?: 'QuestNotificationSubscribedConnection';
  edges: Array<QuestNotificationSubscribedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestNotificationSubscribedConnectionSort = {
  edge?: InputMaybe<OrganizationQuestRelationshipSort>;
  node?: InputMaybe<OrganizationSort>;
};

export type QuestNotificationSubscribedConnectionWhere = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedConnectionWhere>>;
  NOT?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedConnectionWhere>>;
  edge?: InputMaybe<OrganizationQuestRelationshipWhere>;
  node?: InputMaybe<OrganizationWhere>;
};

export type QuestNotificationSubscribedEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestNotificationSubscribedEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedEdgeAggregationWhereInput>>;
  autocompletionThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autocompletionThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  autocompletionThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestNotificationSubscribedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestNotificationSubscribedNodeAggregationWhereInput>>;
  BIC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BIC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BIC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BIC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  IBAN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  IBAN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  IBAN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<QuestNotificationSubscribedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestNotificationSubscribedNodeAggregationWhereInput>>;
  accountName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  accountNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  accountNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  aggregationPriority_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  aggregationPriority_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  autoIssuanceDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  autoIssuanceThreshold_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  billingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  billingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactOccupation_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactOccupation_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  contactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  contactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deliveryAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deliveryAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReviewReminderDelay_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderDelay_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReviewReminderRecurrentStep_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSftpSavePath_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  domicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  domicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  domicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  dualApprovalThreshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  dualApprovalThreshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  fax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  fax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  fax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  legalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  legalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  legalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  logo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  logo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  logo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  organizationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  organizationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  organizationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentTerms_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  pharmaId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  pharmaId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateProcessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateProcessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  website_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  website_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  website_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestNotificationSubscribedRelationship = OrganizationQuestRelationship & {
  __typename?: 'QuestNotificationSubscribedRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  amountType?: Maybe<AmountsType>;
  autocompletionThreshold?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isAutocompletionEnabled?: Maybe<Scalars['Boolean']['output']>;
  node: Organization;
  threshold?: Maybe<Scalars['Int']['output']>;
};

export type QuestNotificationWhere = {
  AND?: InputMaybe<Array<QuestNotificationWhere>>;
  NOT?: InputMaybe<QuestNotificationWhere>;
  OR?: InputMaybe<Array<QuestNotificationWhere>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_GT?: InputMaybe<Scalars['Int']['input']>;
  id_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_LT?: InputMaybe<Scalars['Int']['input']>;
  id_LTE?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  subscribedAggregate?: InputMaybe<QuestNotificationSubscribedAggregateInput>;
  /** Return QuestNotifications where all of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_ALL?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where none of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_NONE?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where one of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_SINGLE?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where some of the related QuestNotificationSubscribedConnections match this filter */
  subscribedConnection_SOME?: InputMaybe<QuestNotificationSubscribedConnectionWhere>;
  /** Return QuestNotifications where all of the related Organizations match this filter */
  subscribed_ALL?: InputMaybe<OrganizationWhere>;
  /** Return QuestNotifications where none of the related Organizations match this filter */
  subscribed_NONE?: InputMaybe<OrganizationWhere>;
  /** Return QuestNotifications where one of the related Organizations match this filter */
  subscribed_SINGLE?: InputMaybe<OrganizationWhere>;
  /** Return QuestNotifications where some of the related Organizations match this filter */
  subscribed_SOME?: InputMaybe<OrganizationWhere>;
};

export type QuestNotificationsConnection = {
  __typename?: 'QuestNotificationsConnection';
  edges: Array<QuestNotificationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestSort objects to sort Quests by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuestSort>>;
};

export type QuestRecordRecordsRelationshipAggregationSelection = {
  __typename?: 'QuestRecordRecordsRelationshipAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<QuestRecordRecordsRelationshipNodeAggregateSelection>;
};

export type QuestRecordRecordsRelationshipNodeAggregateSelection = {
  __typename?: 'QuestRecordRecordsRelationshipNodeAggregateSelection';
  claimId: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  preparationId: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  purchaseOrPatientId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNullable;
  uuid: StringAggregateSelectionNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type QuestRecordRelationship = {
  isCompleted: Scalars['Boolean']['output'];
  wasAutoCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestRecordRelationshipSort = {
  isCompleted?: InputMaybe<SortDirection>;
  wasAutoCompleted?: InputMaybe<SortDirection>;
};

export type QuestRecordRelationshipWhere = {
  AND?: InputMaybe<Array<QuestRecordRelationshipWhere>>;
  NOT?: InputMaybe<QuestRecordRelationshipWhere>;
  OR?: InputMaybe<Array<QuestRecordRelationshipWhere>>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  wasAutoCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestRecordsRelationshipAggregateInput = {
  AND?: InputMaybe<Array<QuestRecordsRelationshipAggregateInput>>;
  NOT?: InputMaybe<QuestRecordsRelationshipAggregateInput>;
  OR?: InputMaybe<Array<QuestRecordsRelationshipAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestRecordsRelationshipNodeAggregationWhereInput>;
};

export type QuestRecordsRelationshipConnection = {
  __typename?: 'QuestRecordsRelationshipConnection';
  edges: Array<QuestRecordsRelationshipRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestRecordsRelationshipConnectionSort = {
  edge?: InputMaybe<QuestRecordRelationshipSort>;
  node?: InputMaybe<RecordSort>;
};

export type QuestRecordsRelationshipConnectionWhere = {
  AND?: InputMaybe<Array<QuestRecordsRelationshipConnectionWhere>>;
  NOT?: InputMaybe<QuestRecordsRelationshipConnectionWhere>;
  OR?: InputMaybe<Array<QuestRecordsRelationshipConnectionWhere>>;
  edge?: InputMaybe<QuestRecordRelationshipWhere>;
  node?: InputMaybe<RecordWhere>;
};

export type QuestRecordsRelationshipNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestRecordsRelationshipNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestRecordsRelationshipNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestRecordsRelationshipNodeAggregationWhereInput>>;
  claimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestRecordsRelationshipRelationship = QuestRecordRelationship & {
  __typename?: 'QuestRecordsRelationshipRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  node: Record;
  wasAutoCompleted?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields to sort Quests by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestSort object. */
export type QuestSort = {
  brandName?: InputMaybe<SortDirection>;
  completedOn?: InputMaybe<SortDirection>;
  completionStatus?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  patientsNo?: InputMaybe<SortDirection>;
  questContentDe?: InputMaybe<SortDirection>;
  questContentEn?: InputMaybe<SortDirection>;
  questOwner?: InputMaybe<SortDirection>;
  questOwnerName?: InputMaybe<SortDirection>;
  questStatus?: InputMaybe<SortDirection>;
  recordsCompleted?: InputMaybe<SortDirection>;
  recordsCount?: InputMaybe<SortDirection>;
  resolvedByName?: InputMaybe<SortDirection>;
  threshold?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
  triggerEventId?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type QuestTableRow = ITableRowView & {
  __typename?: 'QuestTableRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  completionStatus?: Maybe<QuestCompletionStatus>;
  formattedContent?: Maybe<Scalars['String']['output']>;
  formattedExposedToUserIds?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  patientsNo?: Maybe<Scalars['Int']['output']>;
  questOwner?: Maybe<User>;
  questOwnerAggregate?: Maybe<QuestTableRowUserQuestOwnerAggregationSelection>;
  questOwnerConnection: QuestTableRowQuestOwnerConnection;
  questOwnerName?: Maybe<Scalars['String']['output']>;
  questStatus?: Maybe<TaskStatus>;
  records: Array<Record>;
  recordsAggregate?: Maybe<QuestTableRowRecordRecordsAggregationSelection>;
  recordsCompleted?: Maybe<Scalars['Int']['output']>;
  recordsConnection: QuestTableRowRecordsConnection;
  recordsCount?: Maybe<Scalars['Int']['output']>;
  resolvedByName?: Maybe<Scalars['String']['output']>;
  timeStamp?: Maybe<Scalars['Float']['output']>;
  triggerEventId?: Maybe<Scalars['Int']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<QuestTableRowUserUsersAggregationSelection>;
  usersConnection: ITableRowViewUsersConnection;
  value?: Maybe<Scalars['Float']['output']>;
};


export type QuestTableRowQuestOwnerArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type QuestTableRowQuestOwnerAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type QuestTableRowQuestOwnerConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestTableRowQuestOwnerConnectionSort>>;
  where?: InputMaybe<QuestTableRowQuestOwnerConnectionWhere>;
};


export type QuestTableRowRecordsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordOptions>;
  where?: InputMaybe<RecordWhere>;
};


export type QuestTableRowRecordsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RecordWhere>;
};


export type QuestTableRowRecordsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<QuestTableRowRecordsConnectionSort>>;
  where?: InputMaybe<QuestTableRowRecordsConnectionWhere>;
};


export type QuestTableRowUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type QuestTableRowUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type QuestTableRowUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ITableRowViewUsersConnectionSort>>;
  where?: InputMaybe<ITableRowViewUsersConnectionWhere>;
};

export type QuestTableRowAggregateSelection = {
  __typename?: 'QuestTableRowAggregateSelection';
  brandName: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  formattedContent: StringAggregateSelectionNullable;
  formattedExposedToUserIds: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  patientsNo: IntAggregateSelectionNullable;
  questOwnerName: StringAggregateSelectionNullable;
  recordsCompleted: IntAggregateSelectionNullable;
  recordsCount: IntAggregateSelectionNullable;
  resolvedByName: StringAggregateSelectionNullable;
  timeStamp: FloatAggregateSelectionNullable;
  triggerEventId: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

export type QuestTableRowEdge = {
  __typename?: 'QuestTableRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: QuestTableRow;
};

export type QuestTableRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestTableRowSort objects to sort QuestTableRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QuestTableRowQuestOwnerAggregateInput = {
  AND?: InputMaybe<Array<QuestTableRowQuestOwnerAggregateInput>>;
  NOT?: InputMaybe<QuestTableRowQuestOwnerAggregateInput>;
  OR?: InputMaybe<Array<QuestTableRowQuestOwnerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestTableRowQuestOwnerNodeAggregationWhereInput>;
};

export type QuestTableRowQuestOwnerConnection = {
  __typename?: 'QuestTableRowQuestOwnerConnection';
  edges: Array<QuestTableRowQuestOwnerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestTableRowQuestOwnerConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type QuestTableRowQuestOwnerConnectionWhere = {
  AND?: InputMaybe<Array<QuestTableRowQuestOwnerConnectionWhere>>;
  NOT?: InputMaybe<QuestTableRowQuestOwnerConnectionWhere>;
  OR?: InputMaybe<Array<QuestTableRowQuestOwnerConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type QuestTableRowQuestOwnerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestTableRowQuestOwnerNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestTableRowQuestOwnerNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestTableRowQuestOwnerNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestTableRowQuestOwnerRelationship = {
  __typename?: 'QuestTableRowQuestOwnerRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type QuestTableRowRecordRecordsAggregationSelection = {
  __typename?: 'QuestTableRowRecordRecordsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<QuestTableRowRecordRecordsNodeAggregateSelection>;
};

export type QuestTableRowRecordRecordsNodeAggregateSelection = {
  __typename?: 'QuestTableRowRecordRecordsNodeAggregateSelection';
  claimId: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  preparationId: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  purchaseOrPatientId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNullable;
  uuid: StringAggregateSelectionNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type QuestTableRowRecordsAggregateInput = {
  AND?: InputMaybe<Array<QuestTableRowRecordsAggregateInput>>;
  NOT?: InputMaybe<QuestTableRowRecordsAggregateInput>;
  OR?: InputMaybe<Array<QuestTableRowRecordsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestTableRowRecordsNodeAggregationWhereInput>;
};

export type QuestTableRowRecordsConnection = {
  __typename?: 'QuestTableRowRecordsConnection';
  edges: Array<QuestTableRowRecordsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestTableRowRecordsConnectionSort = {
  node?: InputMaybe<RecordSort>;
};

export type QuestTableRowRecordsConnectionWhere = {
  AND?: InputMaybe<Array<QuestTableRowRecordsConnectionWhere>>;
  NOT?: InputMaybe<QuestTableRowRecordsConnectionWhere>;
  OR?: InputMaybe<Array<QuestTableRowRecordsConnectionWhere>>;
  node?: InputMaybe<RecordWhere>;
};

export type QuestTableRowRecordsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestTableRowRecordsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestTableRowRecordsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestTableRowRecordsNodeAggregationWhereInput>>;
  claimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestTableRowRecordsRelationship = {
  __typename?: 'QuestTableRowRecordsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Record;
};

/** Fields to sort QuestTableRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestTableRowSort object. */
export type QuestTableRowSort = {
  brandName?: InputMaybe<SortDirection>;
  completionStatus?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  formattedExposedToUserIds?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  patientsNo?: InputMaybe<SortDirection>;
  questOwnerName?: InputMaybe<SortDirection>;
  questStatus?: InputMaybe<SortDirection>;
  recordsCompleted?: InputMaybe<SortDirection>;
  recordsCount?: InputMaybe<SortDirection>;
  resolvedByName?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
  triggerEventId?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type QuestTableRowUserQuestOwnerAggregationSelection = {
  __typename?: 'QuestTableRowUserQuestOwnerAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<QuestTableRowUserQuestOwnerNodeAggregateSelection>;
};

export type QuestTableRowUserQuestOwnerNodeAggregateSelection = {
  __typename?: 'QuestTableRowUserQuestOwnerNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type QuestTableRowUserUsersAggregationSelection = {
  __typename?: 'QuestTableRowUserUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<QuestTableRowUserUsersNodeAggregateSelection>;
};

export type QuestTableRowUserUsersNodeAggregateSelection = {
  __typename?: 'QuestTableRowUserUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type QuestTableRowUsersAggregateInput = {
  AND?: InputMaybe<Array<QuestTableRowUsersAggregateInput>>;
  NOT?: InputMaybe<QuestTableRowUsersAggregateInput>;
  OR?: InputMaybe<Array<QuestTableRowUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<QuestTableRowUsersNodeAggregationWhereInput>;
};

export type QuestTableRowUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestTableRowUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestTableRowUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestTableRowUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestTableRowWhere = {
  AND?: InputMaybe<Array<QuestTableRowWhere>>;
  NOT?: InputMaybe<QuestTableRowWhere>;
  OR?: InputMaybe<Array<QuestTableRowWhere>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  brandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  completionStatus?: InputMaybe<QuestCompletionStatus>;
  completionStatus_IN?: InputMaybe<Array<InputMaybe<QuestCompletionStatus>>>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedExposedToUserIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientsNo?: InputMaybe<Scalars['Int']['input']>;
  patientsNo_GT?: InputMaybe<Scalars['Int']['input']>;
  patientsNo_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientsNo_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  patientsNo_LT?: InputMaybe<Scalars['Int']['input']>;
  patientsNo_LTE?: InputMaybe<Scalars['Int']['input']>;
  questOwner?: InputMaybe<UserWhere>;
  questOwnerAggregate?: InputMaybe<QuestTableRowQuestOwnerAggregateInput>;
  questOwnerConnection?: InputMaybe<QuestTableRowQuestOwnerConnectionWhere>;
  questOwnerConnection_NOT?: InputMaybe<QuestTableRowQuestOwnerConnectionWhere>;
  questOwnerName?: InputMaybe<Scalars['String']['input']>;
  questOwnerName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  questOwnerName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  questOwnerName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questOwnerName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  questOwnerName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questOwner_NOT?: InputMaybe<UserWhere>;
  questStatus?: InputMaybe<TaskStatus>;
  questStatus_IN?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
  recordsAggregate?: InputMaybe<QuestTableRowRecordsAggregateInput>;
  recordsCompleted?: InputMaybe<Scalars['Int']['input']>;
  recordsCompleted_GT?: InputMaybe<Scalars['Int']['input']>;
  recordsCompleted_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordsCompleted_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordsCompleted_LT?: InputMaybe<Scalars['Int']['input']>;
  recordsCompleted_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** Return QuestTableRows where all of the related QuestTableRowRecordsConnections match this filter */
  recordsConnection_ALL?: InputMaybe<QuestTableRowRecordsConnectionWhere>;
  /** Return QuestTableRows where none of the related QuestTableRowRecordsConnections match this filter */
  recordsConnection_NONE?: InputMaybe<QuestTableRowRecordsConnectionWhere>;
  /** Return QuestTableRows where one of the related QuestTableRowRecordsConnections match this filter */
  recordsConnection_SINGLE?: InputMaybe<QuestTableRowRecordsConnectionWhere>;
  /** Return QuestTableRows where some of the related QuestTableRowRecordsConnections match this filter */
  recordsConnection_SOME?: InputMaybe<QuestTableRowRecordsConnectionWhere>;
  recordsCount?: InputMaybe<Scalars['Int']['input']>;
  recordsCount_GT?: InputMaybe<Scalars['Int']['input']>;
  recordsCount_GTE?: InputMaybe<Scalars['Int']['input']>;
  recordsCount_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recordsCount_LT?: InputMaybe<Scalars['Int']['input']>;
  recordsCount_LTE?: InputMaybe<Scalars['Int']['input']>;
  /** Return QuestTableRows where all of the related Records match this filter */
  records_ALL?: InputMaybe<RecordWhere>;
  /** Return QuestTableRows where none of the related Records match this filter */
  records_NONE?: InputMaybe<RecordWhere>;
  /** Return QuestTableRows where one of the related Records match this filter */
  records_SINGLE?: InputMaybe<RecordWhere>;
  /** Return QuestTableRows where some of the related Records match this filter */
  records_SOME?: InputMaybe<RecordWhere>;
  resolvedByName?: InputMaybe<Scalars['String']['input']>;
  resolvedByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  resolvedByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  resolvedByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolvedByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  resolvedByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  timeStamp_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  triggerEventId_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_LTE?: InputMaybe<Scalars['Int']['input']>;
  usersAggregate?: InputMaybe<QuestTableRowUsersAggregateInput>;
  /** Return QuestTableRows where all of the related ITableRowViewUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return QuestTableRows where none of the related ITableRowViewUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return QuestTableRows where one of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return QuestTableRows where some of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return QuestTableRows where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return QuestTableRows where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return QuestTableRows where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return QuestTableRows where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestTableRowsConnection = {
  __typename?: 'QuestTableRowsConnection';
  edges: Array<QuestTableRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestUserUsersRelationshipAggregationSelection = {
  __typename?: 'QuestUserUsersRelationshipAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<QuestUserUsersRelationshipEdgeAggregateSelection>;
  node?: Maybe<QuestUserUsersRelationshipNodeAggregateSelection>;
};

export type QuestUserUsersRelationshipEdgeAggregateSelection = {
  __typename?: 'QuestUserUsersRelationshipEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type QuestUserUsersRelationshipNodeAggregateSelection = {
  __typename?: 'QuestUserUsersRelationshipNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type QuestUsersRelationshipAggregateInput = {
  AND?: InputMaybe<Array<QuestUsersRelationshipAggregateInput>>;
  NOT?: InputMaybe<QuestUsersRelationshipAggregateInput>;
  OR?: InputMaybe<Array<QuestUsersRelationshipAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<QuestUsersRelationshipEdgeAggregationWhereInput>;
  node?: InputMaybe<QuestUsersRelationshipNodeAggregationWhereInput>;
};

export type QuestUsersRelationshipConnection = {
  __typename?: 'QuestUsersRelationshipConnection';
  edges: Array<QuestUsersRelationshipRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestUsersRelationshipConnectionSort = {
  edge?: InputMaybe<UserQuestRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type QuestUsersRelationshipConnectionWhere = {
  AND?: InputMaybe<Array<QuestUsersRelationshipConnectionWhere>>;
  NOT?: InputMaybe<QuestUsersRelationshipConnectionWhere>;
  OR?: InputMaybe<Array<QuestUsersRelationshipConnectionWhere>>;
  edge?: InputMaybe<UserQuestRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type QuestUsersRelationshipEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestUsersRelationshipEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestUsersRelationshipEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestUsersRelationshipEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestUsersRelationshipNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<QuestUsersRelationshipNodeAggregationWhereInput>>;
  NOT?: InputMaybe<QuestUsersRelationshipNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<QuestUsersRelationshipNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestUsersRelationshipRelationship = UserQuestRelationship & {
  __typename?: 'QuestUsersRelationshipRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  order?: Maybe<Scalars['Int']['output']>;
};

export type QuestViewTableSourceFilterData = {
  __typename?: 'QuestViewTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amountRanges: Array<AmountRange>;
  brandNames: Array<Scalars['String']['output']>;
  maxAdministrationDate?: Maybe<Scalars['Date']['output']>;
  maxQuantity?: Maybe<Scalars['Float']['output']>;
  minAdministrationDate?: Maybe<Scalars['Date']['output']>;
  minQuantity?: Maybe<Scalars['Float']['output']>;
  patientIds: Array<Scalars['String']['output']>;
  questOwnerNames: Array<Scalars['String']['output']>;
  questStatuses: Array<Scalars['String']['output']>;
  recordIds: Array<Scalars['String']['output']>;
  recordsStatuses: Array<Scalars['String']['output']>;
};

export type QuestViewTableSourceFilterDataAggregateSelection = {
  __typename?: 'QuestViewTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  maxQuantity: FloatAggregateSelectionNullable;
  minQuantity: FloatAggregateSelectionNullable;
};

export type QuestViewTableSourceFilterDataConnection = {
  __typename?: 'QuestViewTableSourceFilterDataConnection';
  edges: Array<QuestViewTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestViewTableSourceFilterDataEdge = {
  __typename?: 'QuestViewTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: QuestViewTableSourceFilterData;
};

export type QuestViewTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestViewTableSourceFilterDataSort objects to sort QuestViewTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuestViewTableSourceFilterDataSort>>;
};

/** Fields to sort QuestViewTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestViewTableSourceFilterDataSort object. */
export type QuestViewTableSourceFilterDataSort = {
  maxAdministrationDate?: InputMaybe<SortDirection>;
  maxQuantity?: InputMaybe<SortDirection>;
  minAdministrationDate?: InputMaybe<SortDirection>;
  minQuantity?: InputMaybe<SortDirection>;
};

export type QuestViewTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<QuestViewTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<QuestViewTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<QuestViewTableSourceFilterDataWhere>>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxAdministrationDate?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxAdministrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  maxQuantity?: InputMaybe<Scalars['Float']['input']>;
  maxQuantity_GT?: InputMaybe<Scalars['Float']['input']>;
  maxQuantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  maxQuantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  maxQuantity_LT?: InputMaybe<Scalars['Float']['input']>;
  maxQuantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  minAdministrationDate?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minAdministrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minQuantity?: InputMaybe<Scalars['Float']['input']>;
  minQuantity_GT?: InputMaybe<Scalars['Float']['input']>;
  minQuantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  minQuantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  minQuantity_LT?: InputMaybe<Scalars['Float']['input']>;
  minQuantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  questOwnerNames?: InputMaybe<Array<Scalars['String']['input']>>;
  questOwnerNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  questStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  questStatuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordsStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  recordsStatuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type QuestWhere = {
  AND?: InputMaybe<Array<QuestWhere>>;
  NOT?: InputMaybe<QuestWhere>;
  OR?: InputMaybe<Array<QuestWhere>>;
  brand?: InputMaybe<BrandWhere>;
  brandAggregate?: InputMaybe<QuestBrandAggregateInput>;
  brandConnection?: InputMaybe<QuestBrandConnectionWhere>;
  brandConnection_NOT?: InputMaybe<QuestBrandConnectionWhere>;
  brand_NOT?: InputMaybe<BrandWhere>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<QuestCaseAggregateInput>;
  caseConnection?: InputMaybe<QuestCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<QuestCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  completedOn?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  completedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completionStatus?: InputMaybe<QuestCompletionStatus>;
  completionStatus_IN?: InputMaybe<Array<QuestCompletionStatus>>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  questContentDe?: InputMaybe<Scalars['String']['input']>;
  questContentDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  questContentDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  questContentDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questContentDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  questContentDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questContentEn?: InputMaybe<Scalars['String']['input']>;
  questContentEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  questContentEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  questContentEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questContentEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  questContentEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  questStatus?: InputMaybe<TaskStatus>;
  questStatus_IN?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
  recordsRelationshipAggregate?: InputMaybe<QuestRecordsRelationshipAggregateInput>;
  /** Return Quests where all of the related QuestRecordsRelationshipConnections match this filter */
  recordsRelationshipConnection_ALL?: InputMaybe<QuestRecordsRelationshipConnectionWhere>;
  /** Return Quests where none of the related QuestRecordsRelationshipConnections match this filter */
  recordsRelationshipConnection_NONE?: InputMaybe<QuestRecordsRelationshipConnectionWhere>;
  /** Return Quests where one of the related QuestRecordsRelationshipConnections match this filter */
  recordsRelationshipConnection_SINGLE?: InputMaybe<QuestRecordsRelationshipConnectionWhere>;
  /** Return Quests where some of the related QuestRecordsRelationshipConnections match this filter */
  recordsRelationshipConnection_SOME?: InputMaybe<QuestRecordsRelationshipConnectionWhere>;
  /** Return Quests where all of the related Records match this filter */
  recordsRelationship_ALL?: InputMaybe<RecordWhere>;
  /** Return Quests where none of the related Records match this filter */
  recordsRelationship_NONE?: InputMaybe<RecordWhere>;
  /** Return Quests where one of the related Records match this filter */
  recordsRelationship_SINGLE?: InputMaybe<RecordWhere>;
  /** Return Quests where some of the related Records match this filter */
  recordsRelationship_SOME?: InputMaybe<RecordWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  threshold_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  threshold_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeStamp?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeStamp_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  triggerEventId_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_LTE?: InputMaybe<Scalars['Int']['input']>;
  usersRelationshipAggregate?: InputMaybe<QuestUsersRelationshipAggregateInput>;
  /** Return Quests where all of the related QuestUsersRelationshipConnections match this filter */
  usersRelationshipConnection_ALL?: InputMaybe<QuestUsersRelationshipConnectionWhere>;
  /** Return Quests where none of the related QuestUsersRelationshipConnections match this filter */
  usersRelationshipConnection_NONE?: InputMaybe<QuestUsersRelationshipConnectionWhere>;
  /** Return Quests where one of the related QuestUsersRelationshipConnections match this filter */
  usersRelationshipConnection_SINGLE?: InputMaybe<QuestUsersRelationshipConnectionWhere>;
  /** Return Quests where some of the related QuestUsersRelationshipConnections match this filter */
  usersRelationshipConnection_SOME?: InputMaybe<QuestUsersRelationshipConnectionWhere>;
  /** Return Quests where all of the related Users match this filter */
  usersRelationship_ALL?: InputMaybe<UserWhere>;
  /** Return Quests where none of the related Users match this filter */
  usersRelationship_NONE?: InputMaybe<UserWhere>;
  /** Return Quests where one of the related Users match this filter */
  usersRelationship_SINGLE?: InputMaybe<UserWhere>;
  /** Return Quests where some of the related Users match this filter */
  usersRelationship_SOME?: InputMaybe<UserWhere>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type QuestsConnection = {
  __typename?: 'QuestsConnection';
  edges: Array<QuestEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestsTableSourceFilterData = {
  __typename?: 'QuestsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amountRanges: Array<AmountRange>;
  brandNames: Array<Scalars['String']['output']>;
  maxAdministrationDate?: Maybe<Scalars['Date']['output']>;
  minAdministrationDate?: Maybe<Scalars['Date']['output']>;
  patientIds: Array<Scalars['String']['output']>;
  quantityRanges: Array<AmountRange>;
  questOwners: Array<Scalars['String']['output']>;
  questStatuses: Array<Scalars['String']['output']>;
  recordIds: Array<Scalars['String']['output']>;
  recordStatuses: Array<Scalars['String']['output']>;
};

export type QuestsTableSourceFilterDataAggregateSelection = {
  __typename?: 'QuestsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
};

export type QuestsTableSourceFilterDataConnection = {
  __typename?: 'QuestsTableSourceFilterDataConnection';
  edges: Array<QuestsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestsTableSourceFilterDataEdge = {
  __typename?: 'QuestsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: QuestsTableSourceFilterData;
};

export type QuestsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more QuestsTableSourceFilterDataSort objects to sort QuestsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<QuestsTableSourceFilterDataSort>>;
};

/** Fields to sort QuestsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one QuestsTableSourceFilterDataSort object. */
export type QuestsTableSourceFilterDataSort = {
  maxAdministrationDate?: InputMaybe<SortDirection>;
  minAdministrationDate?: InputMaybe<SortDirection>;
};

export type QuestsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<QuestsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<QuestsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<QuestsTableSourceFilterDataWhere>>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxAdministrationDate?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxAdministrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minAdministrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  patientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  questOwners?: InputMaybe<Array<Scalars['String']['input']>>;
  questOwners_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  questStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  questStatuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recordIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  recordStatuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type RandomMicrocontentContent = {
  __typename?: 'RandomMicrocontentContent';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  randomMicrocontentContent?: Maybe<MicroContent>;
};

export type RandomMicrocontentContentAggregateSelection = {
  __typename?: 'RandomMicrocontentContentAggregateSelection';
  count: Scalars['Int']['output'];
};

export type RandomMicrocontentContentEdge = {
  __typename?: 'RandomMicrocontentContentEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: RandomMicrocontentContent;
};

export type RandomMicrocontentContentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RandomMicrocontentContentWhere = {
  AND?: InputMaybe<Array<RandomMicrocontentContentWhere>>;
  NOT?: InputMaybe<RandomMicrocontentContentWhere>;
  OR?: InputMaybe<Array<RandomMicrocontentContentWhere>>;
};

export type RandomMicrocontentContentsConnection = {
  __typename?: 'RandomMicrocontentContentsConnection';
  edges: Array<RandomMicrocontentContentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReasonOfTreatmentDiscontinuationReport = {
  __typename?: 'ReasonOfTreatmentDiscontinuationReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  result?: Maybe<ReasonsForDiscontinuation>;
};

export type ReasonOfTreatmentDiscontinuationReportAggregateSelection = {
  __typename?: 'ReasonOfTreatmentDiscontinuationReportAggregateSelection';
  count: IntAggregateSelectionNullable;
};

export type ReasonOfTreatmentDiscontinuationReportEdge = {
  __typename?: 'ReasonOfTreatmentDiscontinuationReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ReasonOfTreatmentDiscontinuationReport;
};

export type ReasonOfTreatmentDiscontinuationReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ReasonOfTreatmentDiscontinuationReportSort objects to sort ReasonOfTreatmentDiscontinuationReports by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ReasonOfTreatmentDiscontinuationReportSort>>;
};

/** Fields to sort ReasonOfTreatmentDiscontinuationReports by. The order in which sorts are applied is not guaranteed when specifying many fields in one ReasonOfTreatmentDiscontinuationReportSort object. */
export type ReasonOfTreatmentDiscontinuationReportSort = {
  count?: InputMaybe<SortDirection>;
  result?: InputMaybe<SortDirection>;
};

export type ReasonOfTreatmentDiscontinuationReportWhere = {
  AND?: InputMaybe<Array<ReasonOfTreatmentDiscontinuationReportWhere>>;
  NOT?: InputMaybe<ReasonOfTreatmentDiscontinuationReportWhere>;
  OR?: InputMaybe<Array<ReasonOfTreatmentDiscontinuationReportWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<ReasonsForDiscontinuation>;
  result_IN?: InputMaybe<Array<InputMaybe<ReasonsForDiscontinuation>>>;
};

export type ReasonOfTreatmentDiscontinuationReportsConnection = {
  __typename?: 'ReasonOfTreatmentDiscontinuationReportsConnection';
  edges: Array<ReasonOfTreatmentDiscontinuationReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ReasonsForDiscontinuation {
  AdverseEvent = 'ADVERSE_EVENT',
  AnotherTherapyStart = 'ANOTHER_THERAPY_START',
  Death = 'DEATH',
  NonAdherence = 'NON_ADHERENCE',
  NoInfo = 'NO_INFO',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE'
}

export type RecallToDraftInput = {
  invoiceId: Scalars['ID']['input'];
  wasIssuedWithReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Record = {
  __typename?: 'Record';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  administrationDate?: Maybe<Scalars['Date']['output']>;
  claimId?: Maybe<Scalars['String']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  financialDataPoints: Array<FlexFinancialDataPoint>;
  financialDataPointsAggregate?: Maybe<RecordFlexFinancialDataPointFinancialDataPointsAggregationSelection>;
  financialDataPointsConnection: RecordFinancialDataPointsConnection;
  flexEntityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insuranceClaimId?: Maybe<Scalars['String']['output']>;
  insuranceId?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isCaseless?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isRevoked: Scalars['Boolean']['output'];
  matchedCaseCount: Scalars['Int']['output'];
  occurrence?: Maybe<OccurrenceEnum>;
  predecessor?: Maybe<Record>;
  predecessorAggregate?: Maybe<RecordRecordPredecessorAggregationSelection>;
  predecessorConnection: RecordPredecessorConnection;
  preparationBrandNames?: Maybe<Scalars['String']['output']>;
  preparationGenericNames?: Maybe<Scalars['String']['output']>;
  preparationId?: Maybe<Scalars['String']['output']>;
  prescriptionDate?: Maybe<Scalars['Date']['output']>;
  purchase: Purchase;
  purchaseAggregate?: Maybe<RecordPurchasePurchaseAggregationSelection>;
  purchaseConnection: RecordPurchaseConnection;
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  purchaseId?: Maybe<Scalars['String']['output']>;
  purchaseOrPatientId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  revokedOn?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<FlexFormStatus>;
  successor?: Maybe<Record>;
  successorAggregate?: Maybe<RecordRecordSuccessorAggregationSelection>;
  successorConnection: RecordSuccessorConnection;
  tenantId: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<User>;
  verifiedByAggregate?: Maybe<RecordUserVerifiedByAggregationSelection>;
  verifiedByConnection: RecordVerifiedByConnection;
  viewCaseId?: Maybe<Scalars['String']['output']>;
  viewCases?: Maybe<Scalars['String']['output']>;
  viewDate?: Maybe<Scalars['Date']['output']>;
  viewFormattedContentDe?: Maybe<Scalars['String']['output']>;
  viewFormattedContentEn?: Maybe<Scalars['String']['output']>;
  viewSourceRefundStatus?: Maybe<RefundStatus>;
  viewSuccessorId?: Maybe<Scalars['String']['output']>;
};


export type RecordFinancialDataPointsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RecordFinancialDataPointsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RecordFinancialDataPointsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordFinancialDataPointsConnectionSort>>;
  where?: InputMaybe<RecordFinancialDataPointsConnectionWhere>;
};


export type RecordPredecessorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordOptions>;
  where?: InputMaybe<RecordWhere>;
};


export type RecordPredecessorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RecordWhere>;
};


export type RecordPredecessorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordPredecessorConnectionSort>>;
  where?: InputMaybe<RecordPredecessorConnectionWhere>;
};


export type RecordPurchaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PurchaseOptions>;
  where?: InputMaybe<PurchaseWhere>;
};


export type RecordPurchaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PurchaseWhere>;
};


export type RecordPurchaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordPurchaseConnectionSort>>;
  where?: InputMaybe<RecordPurchaseConnectionWhere>;
};


export type RecordSuccessorArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<RecordOptions>;
  where?: InputMaybe<RecordWhere>;
};


export type RecordSuccessorAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RecordWhere>;
};


export type RecordSuccessorConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordSuccessorConnectionSort>>;
  where?: InputMaybe<RecordSuccessorConnectionWhere>;
};


export type RecordVerifiedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type RecordVerifiedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type RecordVerifiedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RecordVerifiedByConnectionSort>>;
  where?: InputMaybe<RecordVerifiedByConnectionWhere>;
};

export type RecordAggregateSelection = {
  __typename?: 'RecordAggregateSelection';
  claimId: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  preparationId: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  purchaseOrPatientId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNullable;
  uuid: StringAggregateSelectionNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type RecordEdge = {
  __typename?: 'RecordEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Record;
};

export type RecordFinancialDataPointsAggregateInput = {
  AND?: InputMaybe<Array<RecordFinancialDataPointsAggregateInput>>;
  NOT?: InputMaybe<RecordFinancialDataPointsAggregateInput>;
  OR?: InputMaybe<Array<RecordFinancialDataPointsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordFinancialDataPointsNodeAggregationWhereInput>;
};

export type RecordFinancialDataPointsConnection = {
  __typename?: 'RecordFinancialDataPointsConnection';
  edges: Array<RecordFinancialDataPointsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordFinancialDataPointsConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type RecordFinancialDataPointsConnectionWhere = {
  AND?: InputMaybe<Array<RecordFinancialDataPointsConnectionWhere>>;
  NOT?: InputMaybe<RecordFinancialDataPointsConnectionWhere>;
  OR?: InputMaybe<Array<RecordFinancialDataPointsConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RecordFinancialDataPointsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordFinancialDataPointsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordFinancialDataPointsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordFinancialDataPointsNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RecordFinancialDataPointsRelationship = {
  __typename?: 'RecordFinancialDataPointsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export type RecordFlexFinancialDataPointFinancialDataPointsAggregationSelection = {
  __typename?: 'RecordFlexFinancialDataPointFinancialDataPointsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RecordFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection>;
};

export type RecordFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection = {
  __typename?: 'RecordFlexFinancialDataPointFinancialDataPointsNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export enum RecordNature {
  Administered = 'ADMINISTERED',
  Prescribed = 'PRESCRIBED',
  Purchased = 'PURCHASED'
}

export type RecordOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RecordSort objects to sort Records by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RecordSort>>;
};

export type RecordPredecessorAggregateInput = {
  AND?: InputMaybe<Array<RecordPredecessorAggregateInput>>;
  NOT?: InputMaybe<RecordPredecessorAggregateInput>;
  OR?: InputMaybe<Array<RecordPredecessorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordPredecessorNodeAggregationWhereInput>;
};

export type RecordPredecessorConnection = {
  __typename?: 'RecordPredecessorConnection';
  edges: Array<RecordPredecessorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordPredecessorConnectionSort = {
  node?: InputMaybe<RecordSort>;
};

export type RecordPredecessorConnectionWhere = {
  AND?: InputMaybe<Array<RecordPredecessorConnectionWhere>>;
  NOT?: InputMaybe<RecordPredecessorConnectionWhere>;
  OR?: InputMaybe<Array<RecordPredecessorConnectionWhere>>;
  node?: InputMaybe<RecordWhere>;
};

export type RecordPredecessorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordPredecessorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordPredecessorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordPredecessorNodeAggregationWhereInput>>;
  claimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordPredecessorRelationship = {
  __typename?: 'RecordPredecessorRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Record;
};

export type RecordPurchaseAggregateInput = {
  AND?: InputMaybe<Array<RecordPurchaseAggregateInput>>;
  NOT?: InputMaybe<RecordPurchaseAggregateInput>;
  OR?: InputMaybe<Array<RecordPurchaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordPurchaseNodeAggregationWhereInput>;
};

export type RecordPurchaseConnection = {
  __typename?: 'RecordPurchaseConnection';
  edges: Array<RecordPurchaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordPurchaseConnectionSort = {
  node?: InputMaybe<PurchaseSort>;
};

export type RecordPurchaseConnectionWhere = {
  AND?: InputMaybe<Array<RecordPurchaseConnectionWhere>>;
  NOT?: InputMaybe<RecordPurchaseConnectionWhere>;
  OR?: InputMaybe<Array<RecordPurchaseConnectionWhere>>;
  node?: InputMaybe<PurchaseWhere>;
};

export type RecordPurchaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordPurchaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordPurchaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordPurchaseNodeAggregationWhereInput>>;
  lastUpdateDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RecordPurchasePurchaseAggregationSelection = {
  __typename?: 'RecordPurchasePurchaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RecordPurchasePurchaseNodeAggregateSelection>;
};

export type RecordPurchasePurchaseNodeAggregateSelection = {
  __typename?: 'RecordPurchasePurchaseNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  purchaseId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type RecordPurchaseRelationship = {
  __typename?: 'RecordPurchaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Purchase;
};

export type RecordRecordPredecessorAggregationSelection = {
  __typename?: 'RecordRecordPredecessorAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RecordRecordPredecessorNodeAggregateSelection>;
};

export type RecordRecordPredecessorNodeAggregateSelection = {
  __typename?: 'RecordRecordPredecessorNodeAggregateSelection';
  claimId: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  preparationId: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  purchaseOrPatientId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNullable;
  uuid: StringAggregateSelectionNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type RecordRecordSuccessorAggregationSelection = {
  __typename?: 'RecordRecordSuccessorAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RecordRecordSuccessorNodeAggregateSelection>;
};

export type RecordRecordSuccessorNodeAggregateSelection = {
  __typename?: 'RecordRecordSuccessorNodeAggregateSelection';
  claimId: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  preparationId: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  purchaseOrPatientId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  type: StringAggregateSelectionNullable;
  uuid: StringAggregateSelectionNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

/** Fields to sort Records by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecordSort object. */
export type RecordSort = {
  administrationDate?: InputMaybe<SortDirection>;
  claimId?: InputMaybe<SortDirection>;
  createdByEmail?: InputMaybe<SortDirection>;
  createdByName?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  data?: InputMaybe<SortDirection>;
  flexEntityName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  insuranceClaimId?: InputMaybe<SortDirection>;
  insuranceId?: InputMaybe<SortDirection>;
  invoiceDate?: InputMaybe<SortDirection>;
  invoiceNumber?: InputMaybe<SortDirection>;
  isArchived?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isRevoked?: InputMaybe<SortDirection>;
  matchedCaseCount?: InputMaybe<SortDirection>;
  occurrence?: InputMaybe<SortDirection>;
  preparationBrandNames?: InputMaybe<SortDirection>;
  preparationGenericNames?: InputMaybe<SortDirection>;
  preparationId?: InputMaybe<SortDirection>;
  prescriptionDate?: InputMaybe<SortDirection>;
  purchaseDate?: InputMaybe<SortDirection>;
  purchaseId?: InputMaybe<SortDirection>;
  purchaseOrPatientId?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  revokedOn?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  uuid?: InputMaybe<SortDirection>;
  viewCaseId?: InputMaybe<SortDirection>;
  viewCases?: InputMaybe<SortDirection>;
  viewDate?: InputMaybe<SortDirection>;
  viewFormattedContentDe?: InputMaybe<SortDirection>;
  viewFormattedContentEn?: InputMaybe<SortDirection>;
  viewSourceRefundStatus?: InputMaybe<SortDirection>;
  viewSuccessorId?: InputMaybe<SortDirection>;
};

export type RecordSuccessorAggregateInput = {
  AND?: InputMaybe<Array<RecordSuccessorAggregateInput>>;
  NOT?: InputMaybe<RecordSuccessorAggregateInput>;
  OR?: InputMaybe<Array<RecordSuccessorAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordSuccessorNodeAggregationWhereInput>;
};

export type RecordSuccessorConnection = {
  __typename?: 'RecordSuccessorConnection';
  edges: Array<RecordSuccessorRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordSuccessorConnectionSort = {
  node?: InputMaybe<RecordSort>;
};

export type RecordSuccessorConnectionWhere = {
  AND?: InputMaybe<Array<RecordSuccessorConnectionWhere>>;
  NOT?: InputMaybe<RecordSuccessorConnectionWhere>;
  OR?: InputMaybe<Array<RecordSuccessorConnectionWhere>>;
  node?: InputMaybe<RecordWhere>;
};

export type RecordSuccessorNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordSuccessorNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordSuccessorNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordSuccessorNodeAggregationWhereInput>>;
  claimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  claimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  claimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  claimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseOrPatientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordSuccessorRelationship = {
  __typename?: 'RecordSuccessorRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Record;
};

export type RecordUserVerifiedByAggregationSelection = {
  __typename?: 'RecordUserVerifiedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RecordUserVerifiedByNodeAggregateSelection>;
};

export type RecordUserVerifiedByNodeAggregateSelection = {
  __typename?: 'RecordUserVerifiedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type RecordVerifiedByAggregateInput = {
  AND?: InputMaybe<Array<RecordVerifiedByAggregateInput>>;
  NOT?: InputMaybe<RecordVerifiedByAggregateInput>;
  OR?: InputMaybe<Array<RecordVerifiedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RecordVerifiedByNodeAggregationWhereInput>;
};

export type RecordVerifiedByConnection = {
  __typename?: 'RecordVerifiedByConnection';
  edges: Array<RecordVerifiedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordVerifiedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type RecordVerifiedByConnectionWhere = {
  AND?: InputMaybe<Array<RecordVerifiedByConnectionWhere>>;
  NOT?: InputMaybe<RecordVerifiedByConnectionWhere>;
  OR?: InputMaybe<Array<RecordVerifiedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type RecordVerifiedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RecordVerifiedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RecordVerifiedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RecordVerifiedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordVerifiedByRelationship = {
  __typename?: 'RecordVerifiedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type RecordWhere = {
  AND?: InputMaybe<Array<RecordWhere>>;
  NOT?: InputMaybe<RecordWhere>;
  OR?: InputMaybe<Array<RecordWhere>>;
  administrationDate?: InputMaybe<Scalars['Date']['input']>;
  administrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  administrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  administrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  administrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  administrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  claimId?: InputMaybe<Scalars['String']['input']>;
  claimId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  claimId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  claimId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  claimId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  claimId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Scalars['String']['input']>;
  createdByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  data_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  data_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  data_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  data_MATCHES?: InputMaybe<Scalars['String']['input']>;
  data_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  financialDataPointsAggregate?: InputMaybe<RecordFinancialDataPointsAggregateInput>;
  /** Return Records where all of the related RecordFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_ALL?: InputMaybe<RecordFinancialDataPointsConnectionWhere>;
  /** Return Records where none of the related RecordFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_NONE?: InputMaybe<RecordFinancialDataPointsConnectionWhere>;
  /** Return Records where one of the related RecordFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SINGLE?: InputMaybe<RecordFinancialDataPointsConnectionWhere>;
  /** Return Records where some of the related RecordFinancialDataPointsConnections match this filter */
  financialDataPointsConnection_SOME?: InputMaybe<RecordFinancialDataPointsConnectionWhere>;
  /** Return Records where all of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_ALL?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Records where none of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_NONE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Records where one of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SINGLE?: InputMaybe<FlexFinancialDataPointWhere>;
  /** Return Records where some of the related FlexFinancialDataPoints match this filter */
  financialDataPoints_SOME?: InputMaybe<FlexFinancialDataPointWhere>;
  flexEntityName?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flexEntityName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flexEntityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  insuranceClaimId?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceClaimId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceId?: InputMaybe<Scalars['String']['input']>;
  insuranceId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  invoiceDate_LT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  occurrence?: InputMaybe<OccurrenceEnum>;
  occurrence_IN?: InputMaybe<Array<InputMaybe<OccurrenceEnum>>>;
  predecessor?: InputMaybe<RecordWhere>;
  predecessorAggregate?: InputMaybe<RecordPredecessorAggregateInput>;
  predecessorConnection?: InputMaybe<RecordPredecessorConnectionWhere>;
  predecessorConnection_NOT?: InputMaybe<RecordPredecessorConnectionWhere>;
  predecessor_NOT?: InputMaybe<RecordWhere>;
  preparationBrandNames?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationGenericNames_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationGenericNames_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationId?: InputMaybe<Scalars['String']['input']>;
  preparationId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preparationId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preparationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preparationId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prescriptionDate?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  prescriptionDate_LT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  purchase?: InputMaybe<PurchaseWhere>;
  purchaseAggregate?: InputMaybe<RecordPurchaseAggregateInput>;
  purchaseConnection?: InputMaybe<RecordPurchaseConnectionWhere>;
  purchaseConnection_NOT?: InputMaybe<RecordPurchaseConnectionWhere>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_GT?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  purchaseDate_LT?: InputMaybe<Scalars['Date']['input']>;
  purchaseDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  purchaseId?: InputMaybe<Scalars['String']['input']>;
  purchaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseOrPatientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase_NOT?: InputMaybe<PurchaseWhere>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  revokedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<FlexFormStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<FlexFormStatus>>>;
  successor?: InputMaybe<RecordWhere>;
  successorAggregate?: InputMaybe<RecordSuccessorAggregateInput>;
  successorConnection?: InputMaybe<RecordSuccessorConnectionWhere>;
  successorConnection_NOT?: InputMaybe<RecordSuccessorConnectionWhere>;
  successor_NOT?: InputMaybe<RecordWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  uuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  uuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  uuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid_MATCHES?: InputMaybe<Scalars['String']['input']>;
  uuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  verifiedBy?: InputMaybe<UserWhere>;
  verifiedByAggregate?: InputMaybe<RecordVerifiedByAggregateInput>;
  verifiedByConnection?: InputMaybe<RecordVerifiedByConnectionWhere>;
  verifiedByConnection_NOT?: InputMaybe<RecordVerifiedByConnectionWhere>;
  verifiedBy_NOT?: InputMaybe<UserWhere>;
  viewCaseId?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCaseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCaseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCases?: InputMaybe<Scalars['String']['input']>;
  viewCases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewCases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewCases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewCases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewCases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewDate?: InputMaybe<Scalars['Date']['input']>;
  viewDate_GT?: InputMaybe<Scalars['Date']['input']>;
  viewDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  viewDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  viewDate_LT?: InputMaybe<Scalars['Date']['input']>;
  viewDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  viewFormattedContentDe?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewFormattedContentDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewFormattedContentEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewFormattedContentEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewSourceRefundStatus?: InputMaybe<RefundStatus>;
  viewSourceRefundStatus_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
  viewSuccessorId?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  viewSuccessorId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  viewSuccessorId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RecordsConnection = {
  __typename?: 'RecordsConnection';
  edges: Array<RecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordsTableSourceFilterData = {
  __typename?: 'RecordsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedByNames: Array<Scalars['String']['output']>;
  brandNames: Array<Scalars['String']['output']>;
  caseIds: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
  maxAddedOn?: Maybe<Scalars['DateTime']['output']>;
  maxRecordDate?: Maybe<Scalars['Date']['output']>;
  minAddedOn?: Maybe<Scalars['DateTime']['output']>;
  minRecordDate?: Maybe<Scalars['Date']['output']>;
  occurrences: Array<Scalars['String']['output']>;
  patientIds: Array<Scalars['String']['output']>;
  purchaseOrPatientIds: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};

export type RecordsTableSourceFilterDataAggregateSelection = {
  __typename?: 'RecordsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  maxAddedOn: DateTimeAggregateSelectionNullable;
  minAddedOn: DateTimeAggregateSelectionNullable;
};

export type RecordsTableSourceFilterDataConnection = {
  __typename?: 'RecordsTableSourceFilterDataConnection';
  edges: Array<RecordsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RecordsTableSourceFilterDataEdge = {
  __typename?: 'RecordsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: RecordsTableSourceFilterData;
};

export type RecordsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RecordsTableSourceFilterDataSort objects to sort RecordsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RecordsTableSourceFilterDataSort>>;
};

/** Fields to sort RecordsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one RecordsTableSourceFilterDataSort object. */
export type RecordsTableSourceFilterDataSort = {
  maxAddedOn?: InputMaybe<SortDirection>;
  maxRecordDate?: InputMaybe<SortDirection>;
  minAddedOn?: InputMaybe<SortDirection>;
  minRecordDate?: InputMaybe<SortDirection>;
};

export type RecordsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<RecordsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<RecordsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<RecordsTableSourceFilterDataWhere>>;
  addedByNames?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  brandNames?: InputMaybe<Array<Scalars['String']['input']>>;
  brandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  caseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  caseIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxAddedOn?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxAddedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxAddedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxRecordDate?: InputMaybe<Scalars['Date']['input']>;
  maxRecordDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxRecordDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxRecordDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxRecordDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxRecordDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minAddedOn?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minAddedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minAddedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minRecordDate?: InputMaybe<Scalars['Date']['input']>;
  minRecordDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minRecordDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minRecordDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minRecordDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minRecordDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  occurrences?: InputMaybe<Array<Scalars['String']['input']>>;
  occurrences_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  patientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseOrPatientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  types_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type Refund = {
  __typename?: 'Refund';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adjustedAmount?: Maybe<Scalars['Float']['output']>;
  adjustedBy?: Maybe<User>;
  adjustedByAggregate?: Maybe<RefundUserAdjustedByAggregationSelection>;
  adjustedByConnection: RefundAdjustedByConnection;
  adjustedRate?: Maybe<Scalars['Float']['output']>;
  adjustmentComment?: Maybe<Scalars['String']['output']>;
  agreement?: Maybe<BaseAgreement>;
  agreementAggregate?: Maybe<RefundBaseAgreementAgreementAggregationSelection>;
  agreementConnection: RefundAgreementConnection;
  agreementId: Scalars['String']['output'];
  agreementName: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  canBeReplacedInDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  canBeReplacementInDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  canUserModifyFinancials: Scalars['Boolean']['output'];
  case?: Maybe<Case>;
  caseAggregate?: Maybe<RefundCaseCaseAggregationSelection>;
  caseConnection: RefundCaseConnection;
  caseId?: Maybe<Scalars['String']['output']>;
  caseOrAgreementId: Scalars['String']['output'];
  counterParties: Scalars['String']['output'];
  creatableDocument: DocumentType;
  createdOn: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currentReviewerOrganization?: Maybe<Scalars['String']['output']>;
  documentFinancialDataPoint?: Maybe<FlexFinancialDataPoint>;
  documentFinancialDataPointAggregate?: Maybe<RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection>;
  documentFinancialDataPointConnection: RefundDocumentFinancialDataPointConnection;
  documentId?: Maybe<Scalars['ID']['output']>;
  documentIsConfirmedByBuyer?: Maybe<Scalars['Boolean']['output']>;
  documentIsConfirmedBySeller?: Maybe<Scalars['Boolean']['output']>;
  documentMessages: Array<DocumentMessage>;
  documentMessagesAggregate?: Maybe<RefundDocumentMessageDocumentMessagesAggregationSelection>;
  documentMessagesConnection: RefundDocumentMessagesConnection;
  documentRefundGroup?: Maybe<DocumentRefundGroup>;
  documentRefundGroupAggregate?: Maybe<RefundDocumentRefundGroupDocumentRefundGroupAggregationSelection>;
  documentRefundGroupConnection: RefundDocumentRefundGroupConnection;
  documentRefundGroupId?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<DocumentStatus>;
  documents?: Maybe<Document>;
  documentsAggregate?: Maybe<RefundDocumentDocumentsAggregationSelection>;
  documentsConnection: RefundDocumentsConnection;
  formattedTags: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  iin?: Maybe<Scalars['String']['output']>;
  isAgreementBuyer?: Maybe<Scalars['Boolean']['output']>;
  isAgreementSeller?: Maybe<Scalars['Boolean']['output']>;
  isCaseless?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastAdjustedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  nonObserverTenantIds?: Maybe<Array<Scalars['String']['output']>>;
  predecessorIds?: Maybe<Array<Scalars['String']['output']>>;
  product: Scalars['String']['output'];
  purchase?: Maybe<Purchase>;
  purchaseAggregate?: Maybe<RefundPurchasePurchaseAggregationSelection>;
  purchaseConnection: RefundPurchaseConnection;
  purchaseOrPatientId: Scalars['String']['output'];
  recordUuid: Scalars['ID']['output'];
  refundRate: Scalars['Float']['output'];
  removedFromDocumentId?: Maybe<Scalars['String']['output']>;
  revokedOn?: Maybe<Scalars['DateTime']['output']>;
  sourceFinancialDataPoint: FlexFinancialDataPoint;
  sourceFinancialDataPointAggregate?: Maybe<RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection>;
  sourceFinancialDataPointConnection: RefundSourceFinancialDataPointConnection;
  status: RefundStatus;
  successorIds?: Maybe<Array<Scalars['String']['output']>>;
  tags: Array<AgreementTag>;
  tagsAggregate?: Maybe<RefundAgreementTagTagsAggregationSelection>;
  tagsConnection: RefundTagsConnection;
  tenantIds: Array<Scalars['String']['output']>;
  threadMessageCount: Scalars['Int']['output'];
  wasDeclined?: Maybe<Scalars['Boolean']['output']>;
};


export type RefundAdjustedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type RefundAdjustedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type RefundAdjustedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundAdjustedByConnectionSort>>;
  where?: InputMaybe<RefundAdjustedByConnectionWhere>;
};


export type RefundAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type RefundAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type RefundAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundAgreementConnectionSort>>;
  where?: InputMaybe<RefundAgreementConnectionWhere>;
};


export type RefundCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type RefundCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type RefundCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundCaseConnectionSort>>;
  where?: InputMaybe<RefundCaseConnectionWhere>;
};


export type RefundDocumentFinancialDataPointArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundDocumentFinancialDataPointAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundDocumentFinancialDataPointConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundDocumentFinancialDataPointConnectionSort>>;
  where?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
};


export type RefundDocumentMessagesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentMessageOptions>;
  where?: InputMaybe<DocumentMessageWhere>;
};


export type RefundDocumentMessagesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentMessageWhere>;
};


export type RefundDocumentMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundDocumentMessagesConnectionSort>>;
  where?: InputMaybe<RefundDocumentMessagesConnectionWhere>;
};


export type RefundDocumentRefundGroupArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentRefundGroupOptions>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type RefundDocumentRefundGroupAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentRefundGroupWhere>;
};


export type RefundDocumentRefundGroupConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundDocumentRefundGroupConnectionSort>>;
  where?: InputMaybe<RefundDocumentRefundGroupConnectionWhere>;
};


export type RefundDocumentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type RefundDocumentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type RefundDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundDocumentsConnectionSort>>;
  where?: InputMaybe<RefundDocumentsConnectionWhere>;
};


export type RefundPurchaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PurchaseOptions>;
  where?: InputMaybe<PurchaseWhere>;
};


export type RefundPurchaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PurchaseWhere>;
};


export type RefundPurchaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundPurchaseConnectionSort>>;
  where?: InputMaybe<RefundPurchaseConnectionWhere>;
};


export type RefundSourceFinancialDataPointArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexFinancialDataPointOptions>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundSourceFinancialDataPointAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexFinancialDataPointWhere>;
};


export type RefundSourceFinancialDataPointConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundSourceFinancialDataPointConnectionSort>>;
  where?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
};


export type RefundTagsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementTagOptions>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type RefundTagsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementTagWhere>;
};


export type RefundTagsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundTagsConnectionSort>>;
  where?: InputMaybe<RefundTagsConnectionWhere>;
};

export type RefundAdjustedByAggregateInput = {
  AND?: InputMaybe<Array<RefundAdjustedByAggregateInput>>;
  NOT?: InputMaybe<RefundAdjustedByAggregateInput>;
  OR?: InputMaybe<Array<RefundAdjustedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundAdjustedByNodeAggregationWhereInput>;
};

export type RefundAdjustedByConnection = {
  __typename?: 'RefundAdjustedByConnection';
  edges: Array<RefundAdjustedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundAdjustedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type RefundAdjustedByConnectionWhere = {
  AND?: InputMaybe<Array<RefundAdjustedByConnectionWhere>>;
  NOT?: InputMaybe<RefundAdjustedByConnectionWhere>;
  OR?: InputMaybe<Array<RefundAdjustedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type RefundAdjustedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundAdjustedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundAdjustedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundAdjustedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundAdjustedByRelationship = {
  __typename?: 'RefundAdjustedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type RefundAggregateSelection = {
  __typename?: 'RefundAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNonNullable;
  amount: FloatAggregateSelectionNonNullable;
  caseId: StringAggregateSelectionNullable;
  caseOrAgreementId: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  counterParties: StringAggregateSelectionNonNullable;
  currency: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  recordUuid: IdAggregateSelectionNonNullable;
  refundRate: FloatAggregateSelectionNonNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
};

export type RefundAgreementAggregateInput = {
  AND?: InputMaybe<Array<RefundAgreementAggregateInput>>;
  NOT?: InputMaybe<RefundAgreementAggregateInput>;
  OR?: InputMaybe<Array<RefundAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundAgreementNodeAggregationWhereInput>;
};

export type RefundAgreementConnection = {
  __typename?: 'RefundAgreementConnection';
  edges: Array<RefundAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundAgreementConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type RefundAgreementConnectionWhere = {
  AND?: InputMaybe<Array<RefundAgreementConnectionWhere>>;
  NOT?: InputMaybe<RefundAgreementConnectionWhere>;
  OR?: InputMaybe<Array<RefundAgreementConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type RefundAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundAgreementRelationship = {
  __typename?: 'RefundAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type RefundAgreementTagTagsAggregationSelection = {
  __typename?: 'RefundAgreementTagTagsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundAgreementTagTagsNodeAggregateSelection>;
};

export type RefundAgreementTagTagsNodeAggregateSelection = {
  __typename?: 'RefundAgreementTagTagsNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type RefundBaseAgreementAgreementAggregationSelection = {
  __typename?: 'RefundBaseAgreementAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundBaseAgreementAgreementNodeAggregateSelection>;
};

export type RefundBaseAgreementAgreementNodeAggregateSelection = {
  __typename?: 'RefundBaseAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type RefundCaseAggregateInput = {
  AND?: InputMaybe<Array<RefundCaseAggregateInput>>;
  NOT?: InputMaybe<RefundCaseAggregateInput>;
  OR?: InputMaybe<Array<RefundCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundCaseNodeAggregationWhereInput>;
};

export type RefundCaseCaseAggregationSelection = {
  __typename?: 'RefundCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundCaseCaseNodeAggregateSelection>;
};

export type RefundCaseCaseNodeAggregateSelection = {
  __typename?: 'RefundCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type RefundCaseConnection = {
  __typename?: 'RefundCaseConnection';
  edges: Array<RefundCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundCaseConnectionSort = {
  node?: InputMaybe<CaseSort>;
};

export type RefundCaseConnectionWhere = {
  AND?: InputMaybe<Array<RefundCaseConnectionWhere>>;
  NOT?: InputMaybe<RefundCaseConnectionWhere>;
  OR?: InputMaybe<Array<RefundCaseConnectionWhere>>;
  node?: InputMaybe<CaseWhere>;
};

export type RefundCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundCaseRelationship = {
  __typename?: 'RefundCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Case;
};

export type RefundDocumentDocumentsAggregationSelection = {
  __typename?: 'RefundDocumentDocumentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundDocumentDocumentsNodeAggregateSelection>;
};

export type RefundDocumentDocumentsNodeAggregateSelection = {
  __typename?: 'RefundDocumentDocumentsNodeAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  creatorOrgName: StringAggregateSelectionNullable;
  creatorTenantId: StringAggregateSelectionNonNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  exposureLog: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastChangedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  lastSentForSmartMipReview: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  orderNo: StringAggregateSelectionNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  paymentReminderEmail: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipInvoiceFileId: StringAggregateSelectionNullable;
  smartMipInvoiceId: StringAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type RefundDocumentFinancialDataPointAggregateInput = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointAggregateInput>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointAggregateInput>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>;
  node?: InputMaybe<RefundDocumentFinancialDataPointNodeAggregationWhereInput>;
};

export type RefundDocumentFinancialDataPointConnection = {
  __typename?: 'RefundDocumentFinancialDataPointConnection';
  edges: Array<RefundDocumentFinancialDataPointRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundDocumentFinancialDataPointConnectionSort = {
  edge?: InputMaybe<DocumentRefundFinancialDataPointSort>;
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type RefundDocumentFinancialDataPointConnectionWhere = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointConnectionWhere>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointConnectionWhere>>;
  edge?: InputMaybe<DocumentRefundFinancialDataPointWhere>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RefundDocumentFinancialDataPointEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointEdgeAggregationWhereInput>>;
  changedByUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  changedByUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  changedByUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  changedByUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  changedByUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  changedByUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  changedByUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  changedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundDocumentFinancialDataPointNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentFinancialDataPointNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentFinancialDataPointNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentFinancialDataPointNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundDocumentFinancialDataPointRelationship = DocumentRefundFinancialDataPoint & {
  __typename?: 'RefundDocumentFinancialDataPointRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  changedByUserId?: Maybe<Scalars['String']['output']>;
  changedOn?: Maybe<Scalars['DateTime']['output']>;
  connectionId: Scalars['ID']['output'];
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
  smartMipStatus?: Maybe<SmartMipPositionStatus>;
  status?: Maybe<FinancialDataPointStatus>;
};

export type RefundDocumentMessageDocumentMessagesAggregationSelection = {
  __typename?: 'RefundDocumentMessageDocumentMessagesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundDocumentMessageDocumentMessagesNodeAggregateSelection>;
};

export type RefundDocumentMessageDocumentMessagesNodeAggregateSelection = {
  __typename?: 'RefundDocumentMessageDocumentMessagesNodeAggregateSelection';
  content: StringAggregateSelectionNonNullable;
  createdOn: FloatAggregateSelectionNonNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  externalMessageId: IntAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  resolvedOn: DateTimeAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  systemMessageName: StringAggregateSelectionNullable;
};

export type RefundDocumentMessagesAggregateInput = {
  AND?: InputMaybe<Array<RefundDocumentMessagesAggregateInput>>;
  NOT?: InputMaybe<RefundDocumentMessagesAggregateInput>;
  OR?: InputMaybe<Array<RefundDocumentMessagesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundDocumentMessagesNodeAggregationWhereInput>;
};

export type RefundDocumentMessagesConnection = {
  __typename?: 'RefundDocumentMessagesConnection';
  edges: Array<RefundDocumentMessagesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundDocumentMessagesConnectionSort = {
  node?: InputMaybe<DocumentMessageSort>;
};

export type RefundDocumentMessagesConnectionWhere = {
  AND?: InputMaybe<Array<RefundDocumentMessagesConnectionWhere>>;
  NOT?: InputMaybe<RefundDocumentMessagesConnectionWhere>;
  OR?: InputMaybe<Array<RefundDocumentMessagesConnectionWhere>>;
  node?: InputMaybe<DocumentMessageWhere>;
};

export type RefundDocumentMessagesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentMessagesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentMessagesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentMessagesNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  externalMessageId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalMessageId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  externalMessageId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  resolvedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  resolvedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  systemMessageName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  systemMessageName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundDocumentMessagesRelationship = {
  __typename?: 'RefundDocumentMessagesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentMessage;
};

export type RefundDocumentRefundGroupAggregateInput = {
  AND?: InputMaybe<Array<RefundDocumentRefundGroupAggregateInput>>;
  NOT?: InputMaybe<RefundDocumentRefundGroupAggregateInput>;
  OR?: InputMaybe<Array<RefundDocumentRefundGroupAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundDocumentRefundGroupNodeAggregationWhereInput>;
};

export type RefundDocumentRefundGroupConnection = {
  __typename?: 'RefundDocumentRefundGroupConnection';
  edges: Array<RefundDocumentRefundGroupRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundDocumentRefundGroupConnectionSort = {
  node?: InputMaybe<DocumentRefundGroupSort>;
};

export type RefundDocumentRefundGroupConnectionWhere = {
  AND?: InputMaybe<Array<RefundDocumentRefundGroupConnectionWhere>>;
  NOT?: InputMaybe<RefundDocumentRefundGroupConnectionWhere>;
  OR?: InputMaybe<Array<RefundDocumentRefundGroupConnectionWhere>>;
  node?: InputMaybe<DocumentRefundGroupWhere>;
};

export type RefundDocumentRefundGroupDocumentRefundGroupAggregationSelection = {
  __typename?: 'RefundDocumentRefundGroupDocumentRefundGroupAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundDocumentRefundGroupDocumentRefundGroupNodeAggregateSelection>;
};

export type RefundDocumentRefundGroupDocumentRefundGroupNodeAggregateSelection = {
  __typename?: 'RefundDocumentRefundGroupDocumentRefundGroupNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
};

export type RefundDocumentRefundGroupNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentRefundGroupNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentRefundGroupNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentRefundGroupNodeAggregationWhereInput>>;
};

export type RefundDocumentRefundGroupRelationship = {
  __typename?: 'RefundDocumentRefundGroupRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: DocumentRefundGroup;
};

export type RefundDocumentsAggregateInput = {
  AND?: InputMaybe<Array<RefundDocumentsAggregateInput>>;
  NOT?: InputMaybe<RefundDocumentsAggregateInput>;
  OR?: InputMaybe<Array<RefundDocumentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundDocumentsNodeAggregationWhereInput>;
};

export type RefundDocumentsConnection = {
  __typename?: 'RefundDocumentsConnection';
  edges: Array<RefundDocumentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundDocumentsConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type RefundDocumentsConnectionWhere = {
  AND?: InputMaybe<Array<RefundDocumentsConnectionWhere>>;
  NOT?: InputMaybe<RefundDocumentsConnectionWhere>;
  OR?: InputMaybe<Array<RefundDocumentsConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type RefundDocumentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundDocumentsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundDocumentsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundDocumentsNodeAggregationWhereInput>>;
  adjustedInvoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creatorOrgName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  orderNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reviewRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  senderLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentToReviewOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundDocumentsRelationship = {
  __typename?: 'RefundDocumentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Document;
};

export type RefundEdge = {
  __typename?: 'RefundEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Refund;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection = {
  __typename?: 'RefundFlexFinancialDataPointDocumentFinancialDataPointAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection>;
  node?: Maybe<RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection>;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection = {
  __typename?: 'RefundFlexFinancialDataPointDocumentFinancialDataPointEdgeAggregateSelection';
  changedByUserId: StringAggregateSelectionNullable;
  changedOn: DateTimeAggregateSelectionNullable;
  connectionId: IdAggregateSelectionNonNullable;
};

export type RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection = {
  __typename?: 'RefundFlexFinancialDataPointDocumentFinancialDataPointNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection = {
  __typename?: 'RefundFlexFinancialDataPointSourceFinancialDataPointAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection>;
};

export type RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection = {
  __typename?: 'RefundFlexFinancialDataPointSourceFinancialDataPointNodeAggregateSelection';
  basePrice: FloatAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  currencyCode: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  generatedUuid: IdAggregateSelectionNonNullable;
  netPrices: StringAggregateSelectionNullable;
  payable: FloatAggregateSelectionNonNullable;
  payablePercentage: FloatAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNonNullable;
  refundDeltaNumber: IntAggregateSelectionNonNullable;
  refundable: FloatAggregateSelectionNonNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  revokedOn: DateTimeAggregateSelectionNullable;
  scenarioZeroMainNetPrices: StringAggregateSelectionNullable;
  scenarioZeroNetPrices: StringAggregateSelectionNullable;
  scenarioZeroRelevantNetPrices: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
  variable: FloatAggregateSelectionNonNullable;
  variablePercentage: FloatAggregateSelectionNullable;
};

export type RefundOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RefundSort objects to sort Refunds by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RefundSort>>;
};

export type RefundPurchaseAggregateInput = {
  AND?: InputMaybe<Array<RefundPurchaseAggregateInput>>;
  NOT?: InputMaybe<RefundPurchaseAggregateInput>;
  OR?: InputMaybe<Array<RefundPurchaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundPurchaseNodeAggregationWhereInput>;
};

export type RefundPurchaseConnection = {
  __typename?: 'RefundPurchaseConnection';
  edges: Array<RefundPurchaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundPurchaseConnectionSort = {
  node?: InputMaybe<PurchaseSort>;
};

export type RefundPurchaseConnectionWhere = {
  AND?: InputMaybe<Array<RefundPurchaseConnectionWhere>>;
  NOT?: InputMaybe<RefundPurchaseConnectionWhere>;
  OR?: InputMaybe<Array<RefundPurchaseConnectionWhere>>;
  node?: InputMaybe<PurchaseWhere>;
};

export type RefundPurchaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundPurchaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundPurchaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundPurchaseNodeAggregationWhereInput>>;
  lastUpdateDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundPurchasePurchaseAggregationSelection = {
  __typename?: 'RefundPurchasePurchaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundPurchasePurchaseNodeAggregateSelection>;
};

export type RefundPurchasePurchaseNodeAggregateSelection = {
  __typename?: 'RefundPurchasePurchaseNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  purchaseId: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type RefundPurchaseRelationship = {
  __typename?: 'RefundPurchaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Purchase;
};

/** Fields to sort Refunds by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundSort object. */
export type RefundSort = {
  adjustedAmount?: InputMaybe<SortDirection>;
  adjustedRate?: InputMaybe<SortDirection>;
  adjustmentComment?: InputMaybe<SortDirection>;
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  amount?: InputMaybe<SortDirection>;
  canUserModifyFinancials?: InputMaybe<SortDirection>;
  caseId?: InputMaybe<SortDirection>;
  caseOrAgreementId?: InputMaybe<SortDirection>;
  case_legalEntity_name?: InputMaybe<Scalars['String']['input']>;
  counterParties?: InputMaybe<SortDirection>;
  creatableDocument?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  currentReviewerOrganization?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  documentIsConfirmedByBuyer?: InputMaybe<SortDirection>;
  documentIsConfirmedBySeller?: InputMaybe<SortDirection>;
  documentRefundGroupId?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  iin?: InputMaybe<SortDirection>;
  isAgreementBuyer?: InputMaybe<SortDirection>;
  isAgreementSeller?: InputMaybe<SortDirection>;
  isCaseless?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  lastAdjustedAt?: InputMaybe<SortDirection>;
  legalEntityName?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  purchaseOrPatientId?: InputMaybe<SortDirection>;
  recordUuid?: InputMaybe<SortDirection>;
  refundRate?: InputMaybe<SortDirection>;
  removedFromDocumentId?: InputMaybe<SortDirection>;
  revokedOn?: InputMaybe<SortDirection>;
  sourceFinancialDataPoint_basePrice?: InputMaybe<Scalars['String']['input']>;
  sourceFinancialDataPoint_evaluates_invoiceDate?: InputMaybe<Scalars['String']['input']>;
  sourceFinancialDataPoint_evaluates_type_localizationKey?: InputMaybe<Scalars['String']['input']>;
  sourceFinancialDataPoint_prescriptionDate?: InputMaybe<Scalars['String']['input']>;
  sourceFinancialDataPoint_quantity?: InputMaybe<Scalars['String']['input']>;
  sourceFinancialDataPoint_refundablePercentage?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SortDirection>;
  threadMessageCount?: InputMaybe<SortDirection>;
  wasDeclined?: InputMaybe<SortDirection>;
};

export type RefundSourceFinancialDataPointAggregateInput = {
  AND?: InputMaybe<Array<RefundSourceFinancialDataPointAggregateInput>>;
  NOT?: InputMaybe<RefundSourceFinancialDataPointAggregateInput>;
  OR?: InputMaybe<Array<RefundSourceFinancialDataPointAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundSourceFinancialDataPointNodeAggregationWhereInput>;
};

export type RefundSourceFinancialDataPointConnection = {
  __typename?: 'RefundSourceFinancialDataPointConnection';
  edges: Array<RefundSourceFinancialDataPointRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundSourceFinancialDataPointConnectionSort = {
  node?: InputMaybe<FlexFinancialDataPointSort>;
};

export type RefundSourceFinancialDataPointConnectionWhere = {
  AND?: InputMaybe<Array<RefundSourceFinancialDataPointConnectionWhere>>;
  NOT?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
  OR?: InputMaybe<Array<RefundSourceFinancialDataPointConnectionWhere>>;
  node?: InputMaybe<FlexFinancialDataPointWhere>;
};

export type RefundSourceFinancialDataPointNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundSourceFinancialDataPointNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundSourceFinancialDataPointNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundSourceFinancialDataPointNodeAggregationWhereInput>>;
  basePrice_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currencyCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currencyCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currencyCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  evaluationSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  netPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  netPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  netPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  payablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  payable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundDeltaNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  refundDeltaNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  refundablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  refundable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  revokedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroMainNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scenarioZeroRelevantNetPrices_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  variablePercentage_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variablePercentage_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  variable_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type RefundSourceFinancialDataPointRelationship = {
  __typename?: 'RefundSourceFinancialDataPointRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexFinancialDataPoint;
};

export enum RefundStatus {
  Declined = 'DECLINED',
  Invoiced = 'INVOICED',
  New = 'NEW',
  Pending = 'PENDING',
  Settled = 'SETTLED'
}

export type RefundTableRow = ITableRowView & {
  __typename?: 'RefundTableRow';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adjustedAmount?: Maybe<Scalars['Float']['output']>;
  adjustedBy?: Maybe<User>;
  adjustedByAggregate?: Maybe<RefundTableRowUserAdjustedByAggregationSelection>;
  adjustedByConnection: RefundTableRowAdjustedByConnection;
  adjustedRate?: Maybe<Scalars['Float']['output']>;
  adjustmentComment?: Maybe<Scalars['String']['output']>;
  agreementId?: Maybe<Scalars['ID']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  agreementTagTypes?: Maybe<Array<Scalars['String']['output']>>;
  amount?: Maybe<Scalars['Float']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  canBeReplacedInDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  canBeReplacementInDocumentIds?: Maybe<Array<Scalars['String']['output']>>;
  canUserModifyFinancials?: Maybe<Scalars['Boolean']['output']>;
  caseId?: Maybe<Scalars['ID']['output']>;
  caseOrAgreementId?: Maybe<Scalars['ID']['output']>;
  counterParties?: Maybe<Scalars['String']['output']>;
  creatableDocument?: Maybe<DocumentType>;
  createdOn?: Maybe<Scalars['Date']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyName?: Maybe<Scalars['String']['output']>;
  currentReviewerOrganization?: Maybe<Scalars['String']['output']>;
  dataPointUuid?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentIsConfirmedByBuyer?: Maybe<Scalars['Boolean']['output']>;
  documentIsConfirmedBySeller?: Maybe<Scalars['Boolean']['output']>;
  documentRefundGroupId?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<DocumentStatus>;
  evaluationSnapshot?: Maybe<Scalars['String']['output']>;
  finalAmount?: Maybe<Scalars['Float']['output']>;
  finalRefundablePercentage?: Maybe<Scalars['Float']['output']>;
  formattedContent?: Maybe<Scalars['String']['output']>;
  formattedExposedToUserIds?: Maybe<Scalars['String']['output']>;
  formattedTags?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iin?: Maybe<Scalars['String']['output']>;
  insuranceClaimId?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['Date']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAgreementBuyer?: Maybe<Scalars['Boolean']['output']>;
  isAgreementSeller?: Maybe<Scalars['Boolean']['output']>;
  isDelta?: Maybe<Scalars['Boolean']['output']>;
  lastAdjustedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityName?: Maybe<Scalars['String']['output']>;
  nonObserverTenantIds?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  predecessorIds?: Maybe<Scalars['String']['output']>;
  prescriptionDate?: Maybe<Scalars['Date']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  purchaseOrPatientId: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<CoverageRequestRating>;
  recordTypeLocalizationKey?: Maybe<Scalars['String']['output']>;
  refundRate?: Maybe<Scalars['Float']['output']>;
  refundablePercentage?: Maybe<Scalars['Float']['output']>;
  removedFromDocumentId?: Maybe<Scalars['String']['output']>;
  smartMipStatus?: Maybe<SmartMipPositionStatus>;
  status?: Maybe<RefundStatus>;
  successorIds?: Maybe<Scalars['String']['output']>;
  tenantIds?: Maybe<Array<Scalars['String']['output']>>;
  treatmentCountryName?: Maybe<Scalars['String']['output']>;
  treatmentName?: Maybe<Scalars['String']['output']>;
  treatmentPreparationBrandName?: Maybe<Scalars['String']['output']>;
  treatmentPreparationDescriptionDe?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  usersAggregate?: Maybe<RefundTableRowUserUsersAggregationSelection>;
  usersConnection: ITableRowViewUsersConnection;
};


export type RefundTableRowAdjustedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type RefundTableRowAdjustedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type RefundTableRowAdjustedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<RefundTableRowAdjustedByConnectionSort>>;
  where?: InputMaybe<RefundTableRowAdjustedByConnectionWhere>;
};


export type RefundTableRowUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type RefundTableRowUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type RefundTableRowUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ITableRowViewUsersConnectionSort>>;
  where?: InputMaybe<ITableRowViewUsersConnectionWhere>;
};

export type RefundTableRowAdjustedByAggregateInput = {
  AND?: InputMaybe<Array<RefundTableRowAdjustedByAggregateInput>>;
  NOT?: InputMaybe<RefundTableRowAdjustedByAggregateInput>;
  OR?: InputMaybe<Array<RefundTableRowAdjustedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundTableRowAdjustedByNodeAggregationWhereInput>;
};

export type RefundTableRowAdjustedByConnection = {
  __typename?: 'RefundTableRowAdjustedByConnection';
  edges: Array<RefundTableRowAdjustedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundTableRowAdjustedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type RefundTableRowAdjustedByConnectionWhere = {
  AND?: InputMaybe<Array<RefundTableRowAdjustedByConnectionWhere>>;
  NOT?: InputMaybe<RefundTableRowAdjustedByConnectionWhere>;
  OR?: InputMaybe<Array<RefundTableRowAdjustedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type RefundTableRowAdjustedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundTableRowAdjustedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundTableRowAdjustedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundTableRowAdjustedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundTableRowAdjustedByRelationship = {
  __typename?: 'RefundTableRowAdjustedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type RefundTableRowAggregateSelection = {
  __typename?: 'RefundTableRowAggregateSelection';
  adjustedAmount: FloatAggregateSelectionNullable;
  adjustedRate: FloatAggregateSelectionNullable;
  adjustmentComment: StringAggregateSelectionNullable;
  agreementId: IdAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  amount: FloatAggregateSelectionNullable;
  basePrice: FloatAggregateSelectionNullable;
  caseId: IdAggregateSelectionNullable;
  caseOrAgreementId: IdAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  counterParties: StringAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  currencyName: StringAggregateSelectionNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  dataPointUuid: StringAggregateSelectionNullable;
  documentId: StringAggregateSelectionNullable;
  documentRefundGroupId: StringAggregateSelectionNullable;
  evaluationSnapshot: StringAggregateSelectionNullable;
  finalAmount: FloatAggregateSelectionNullable;
  finalRefundablePercentage: FloatAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNullable;
  formattedExposedToUserIds: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  iin: StringAggregateSelectionNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastAdjustedAt: DateTimeAggregateSelectionNullable;
  legalEntityName: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  predecessorIds: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNullable;
  purchaseOrPatientId: StringAggregateSelectionNonNullable;
  quantity: FloatAggregateSelectionNullable;
  recordTypeLocalizationKey: StringAggregateSelectionNullable;
  refundRate: FloatAggregateSelectionNullable;
  refundablePercentage: FloatAggregateSelectionNullable;
  removedFromDocumentId: StringAggregateSelectionNullable;
  successorIds: StringAggregateSelectionNullable;
  treatmentCountryName: StringAggregateSelectionNullable;
  treatmentName: StringAggregateSelectionNullable;
  treatmentPreparationBrandName: StringAggregateSelectionNullable;
  treatmentPreparationDescriptionDe: StringAggregateSelectionNullable;
};

export type RefundTableRowEdge = {
  __typename?: 'RefundTableRowEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: RefundTableRow;
};

export type RefundTableRowOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RefundTableRowSort objects to sort RefundTableRows by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RefundTableRowSort>>;
};

/** Fields to sort RefundTableRows by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundTableRowSort object. */
export type RefundTableRowSort = {
  adjustedAmount?: InputMaybe<SortDirection>;
  adjustedRate?: InputMaybe<SortDirection>;
  adjustmentComment?: InputMaybe<SortDirection>;
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  amount?: InputMaybe<SortDirection>;
  basePrice?: InputMaybe<SortDirection>;
  canUserModifyFinancials?: InputMaybe<SortDirection>;
  caseId?: InputMaybe<SortDirection>;
  caseOrAgreementId?: InputMaybe<SortDirection>;
  counterParties?: InputMaybe<SortDirection>;
  creatableDocument?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  currencyName?: InputMaybe<SortDirection>;
  currentReviewerOrganization?: InputMaybe<SortDirection>;
  dataPointUuid?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  documentIsConfirmedByBuyer?: InputMaybe<SortDirection>;
  documentIsConfirmedBySeller?: InputMaybe<SortDirection>;
  documentRefundGroupId?: InputMaybe<SortDirection>;
  documentStatus?: InputMaybe<SortDirection>;
  evaluationSnapshot?: InputMaybe<SortDirection>;
  finalAmount?: InputMaybe<SortDirection>;
  finalRefundablePercentage?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  formattedExposedToUserIds?: InputMaybe<SortDirection>;
  formattedTags?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  iin?: InputMaybe<SortDirection>;
  insuranceClaimId?: InputMaybe<SortDirection>;
  invoiceDate?: InputMaybe<SortDirection>;
  invoiceNumber?: InputMaybe<SortDirection>;
  isAgreementBuyer?: InputMaybe<SortDirection>;
  isAgreementSeller?: InputMaybe<SortDirection>;
  isDelta?: InputMaybe<SortDirection>;
  lastAdjustedAt?: InputMaybe<SortDirection>;
  legalEntityName?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  predecessorIds?: InputMaybe<SortDirection>;
  prescriptionDate?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  purchaseOrPatientId?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
  rating?: InputMaybe<SortDirection>;
  recordTypeLocalizationKey?: InputMaybe<SortDirection>;
  refundRate?: InputMaybe<SortDirection>;
  refundablePercentage?: InputMaybe<SortDirection>;
  removedFromDocumentId?: InputMaybe<SortDirection>;
  smartMipStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  successorIds?: InputMaybe<SortDirection>;
  treatmentCountryName?: InputMaybe<SortDirection>;
  treatmentName?: InputMaybe<SortDirection>;
  treatmentPreparationBrandName?: InputMaybe<SortDirection>;
  treatmentPreparationDescriptionDe?: InputMaybe<SortDirection>;
};

export type RefundTableRowUserAdjustedByAggregationSelection = {
  __typename?: 'RefundTableRowUserAdjustedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundTableRowUserAdjustedByNodeAggregateSelection>;
};

export type RefundTableRowUserAdjustedByNodeAggregateSelection = {
  __typename?: 'RefundTableRowUserAdjustedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type RefundTableRowUserUsersAggregationSelection = {
  __typename?: 'RefundTableRowUserUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundTableRowUserUsersNodeAggregateSelection>;
};

export type RefundTableRowUserUsersNodeAggregateSelection = {
  __typename?: 'RefundTableRowUserUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type RefundTableRowUsersAggregateInput = {
  AND?: InputMaybe<Array<RefundTableRowUsersAggregateInput>>;
  NOT?: InputMaybe<RefundTableRowUsersAggregateInput>;
  OR?: InputMaybe<Array<RefundTableRowUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundTableRowUsersNodeAggregationWhereInput>;
};

export type RefundTableRowUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundTableRowUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundTableRowUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundTableRowUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundTableRowWhere = {
  AND?: InputMaybe<Array<RefundTableRowWhere>>;
  NOT?: InputMaybe<RefundTableRowWhere>;
  OR?: InputMaybe<Array<RefundTableRowWhere>>;
  adjustedAmount?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  adjustedAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedBy?: InputMaybe<UserWhere>;
  adjustedByAggregate?: InputMaybe<RefundTableRowAdjustedByAggregateInput>;
  adjustedByConnection?: InputMaybe<RefundTableRowAdjustedByConnectionWhere>;
  adjustedByConnection_NOT?: InputMaybe<RefundTableRowAdjustedByConnectionWhere>;
  adjustedBy_NOT?: InputMaybe<UserWhere>;
  adjustedRate?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  adjustedRate_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adjustmentComment_MATCHES?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementTagTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementTagTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  basePrice_GT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_GTE?: InputMaybe<Scalars['Float']['input']>;
  basePrice_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  basePrice_LT?: InputMaybe<Scalars['Float']['input']>;
  basePrice_LTE?: InputMaybe<Scalars['Float']['input']>;
  canBeReplacedInDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canBeReplacedInDocumentIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  canBeReplacementInDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canBeReplacementInDocumentIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  canUserModifyFinancials?: InputMaybe<Scalars['Boolean']['input']>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  caseId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  caseId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  caseId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  caseId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  caseOrAgreementId?: InputMaybe<Scalars['ID']['input']>;
  caseOrAgreementId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  caseOrAgreementId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  caseOrAgreementId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  caseOrAgreementId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  counterParties?: InputMaybe<Scalars['String']['input']>;
  counterParties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterParties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterParties_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterParties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterParties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  creatableDocument?: InputMaybe<DocumentType>;
  creatableDocument_IN?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  createdOn?: InputMaybe<Scalars['Date']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Date']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['Date']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currencyName?: InputMaybe<Scalars['String']['input']>;
  currencyName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currencyName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currencyName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currencyName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currencyName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentReviewerOrganization_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currentReviewerOrganization_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dataPointUuid?: InputMaybe<Scalars['String']['input']>;
  dataPointUuid_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dataPointUuid_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dataPointUuid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataPointUuid_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dataPointUuid_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentIsConfirmedByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  documentIsConfirmedBySeller?: InputMaybe<Scalars['Boolean']['input']>;
  documentRefundGroupId?: InputMaybe<Scalars['String']['input']>;
  documentRefundGroupId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentRefundGroupId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentRefundGroupId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentRefundGroupId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentRefundGroupId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentStatus?: InputMaybe<DocumentStatus>;
  documentStatus_IN?: InputMaybe<Array<InputMaybe<DocumentStatus>>>;
  evaluationSnapshot?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  evaluationSnapshot_MATCHES?: InputMaybe<Scalars['String']['input']>;
  evaluationSnapshot_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  finalAmount?: InputMaybe<Scalars['Float']['input']>;
  finalAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  finalAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  finalAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  finalAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  finalAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  finalRefundablePercentage?: InputMaybe<Scalars['Float']['input']>;
  finalRefundablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  finalRefundablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  finalRefundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  finalRefundablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  finalRefundablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedExposedToUserIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedExposedToUserIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  iin?: InputMaybe<Scalars['String']['input']>;
  iin_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  iin_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  iin_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iin_MATCHES?: InputMaybe<Scalars['String']['input']>;
  iin_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  insuranceClaimId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  invoiceDate_LT?: InputMaybe<Scalars['Date']['input']>;
  invoiceDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceNumber_MATCHES?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isAgreementBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  isAgreementSeller?: InputMaybe<Scalars['Boolean']['input']>;
  isDelta?: InputMaybe<Scalars['Boolean']['input']>;
  lastAdjustedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastAdjustedAt_IS_NULL?: InputMaybe<Scalars['Boolean']['input']>;
  lastAdjustedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legalEntityName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nonObserverTenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nonObserverTenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  predecessorIds?: InputMaybe<Scalars['String']['input']>;
  predecessorIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  predecessorIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  predecessorIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  predecessorIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  predecessorIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  prescriptionDate?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  prescriptionDate_LT?: InputMaybe<Scalars['Date']['input']>;
  prescriptionDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseOrPatientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantity_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  rating?: InputMaybe<CoverageRequestRating>;
  rating_IN?: InputMaybe<Array<InputMaybe<CoverageRequestRating>>>;
  recordTypeLocalizationKey?: InputMaybe<Scalars['String']['input']>;
  recordTypeLocalizationKey_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  recordTypeLocalizationKey_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  recordTypeLocalizationKey_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordTypeLocalizationKey_MATCHES?: InputMaybe<Scalars['String']['input']>;
  recordTypeLocalizationKey_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundRate?: InputMaybe<Scalars['Float']['input']>;
  refundRate_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  refundRate_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_GT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  refundablePercentage_LT?: InputMaybe<Scalars['Float']['input']>;
  refundablePercentage_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removedFromDocumentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipStatus?: InputMaybe<SmartMipPositionStatus>;
  smartMipStatus_IN?: InputMaybe<Array<InputMaybe<SmartMipPositionStatus>>>;
  status?: InputMaybe<RefundStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<RefundStatus>>>;
  successorIds?: InputMaybe<Scalars['String']['input']>;
  successorIds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  successorIds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  successorIds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  successorIds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  successorIds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  treatmentCountryName?: InputMaybe<Scalars['String']['input']>;
  treatmentCountryName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  treatmentCountryName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentCountryName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatmentCountryName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  treatmentCountryName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentName?: InputMaybe<Scalars['String']['input']>;
  treatmentName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  treatmentName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatmentName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  treatmentName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationBrandName?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationBrandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationBrandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationBrandName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatmentPreparationBrandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationBrandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationDescriptionDe?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationDescriptionDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationDescriptionDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationDescriptionDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  treatmentPreparationDescriptionDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  treatmentPreparationDescriptionDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  usersAggregate?: InputMaybe<RefundTableRowUsersAggregateInput>;
  /** Return RefundTableRows where all of the related ITableRowViewUsersConnections match this filter */
  usersConnection_ALL?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return RefundTableRows where none of the related ITableRowViewUsersConnections match this filter */
  usersConnection_NONE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return RefundTableRows where one of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SINGLE?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return RefundTableRows where some of the related ITableRowViewUsersConnections match this filter */
  usersConnection_SOME?: InputMaybe<ITableRowViewUsersConnectionWhere>;
  /** Return RefundTableRows where all of the related Users match this filter */
  users_ALL?: InputMaybe<UserWhere>;
  /** Return RefundTableRows where none of the related Users match this filter */
  users_NONE?: InputMaybe<UserWhere>;
  /** Return RefundTableRows where one of the related Users match this filter */
  users_SINGLE?: InputMaybe<UserWhere>;
  /** Return RefundTableRows where some of the related Users match this filter */
  users_SOME?: InputMaybe<UserWhere>;
};

export type RefundTableRowsConnection = {
  __typename?: 'RefundTableRowsConnection';
  edges: Array<RefundTableRowEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundTagsAggregateInput = {
  AND?: InputMaybe<Array<RefundTagsAggregateInput>>;
  NOT?: InputMaybe<RefundTagsAggregateInput>;
  OR?: InputMaybe<Array<RefundTagsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<RefundTagsNodeAggregationWhereInput>;
};

export type RefundTagsConnection = {
  __typename?: 'RefundTagsConnection';
  edges: Array<RefundTagsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundTagsConnectionSort = {
  node?: InputMaybe<AgreementTagSort>;
};

export type RefundTagsConnectionWhere = {
  AND?: InputMaybe<Array<RefundTagsConnectionWhere>>;
  NOT?: InputMaybe<RefundTagsConnectionWhere>;
  OR?: InputMaybe<Array<RefundTagsConnectionWhere>>;
  node?: InputMaybe<AgreementTagWhere>;
};

export type RefundTagsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<RefundTagsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<RefundTagsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<RefundTagsNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type RefundTagsRelationship = {
  __typename?: 'RefundTagsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementTag;
};

export type RefundUserAdjustedByAggregationSelection = {
  __typename?: 'RefundUserAdjustedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<RefundUserAdjustedByNodeAggregateSelection>;
};

export type RefundUserAdjustedByNodeAggregateSelection = {
  __typename?: 'RefundUserAdjustedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type RefundWhere = {
  AND?: InputMaybe<Array<RefundWhere>>;
  NOT?: InputMaybe<RefundWhere>;
  OR?: InputMaybe<Array<RefundWhere>>;
  adjustedAmount?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  adjustedAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedBy?: InputMaybe<UserWhere>;
  adjustedByAggregate?: InputMaybe<RefundAdjustedByAggregateInput>;
  adjustedByConnection?: InputMaybe<RefundAdjustedByConnectionWhere>;
  adjustedByConnection_NOT?: InputMaybe<RefundAdjustedByConnectionWhere>;
  adjustedBy_NOT?: InputMaybe<UserWhere>;
  adjustedRate?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  adjustedRate_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustmentComment?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adjustmentComment_MATCHES?: InputMaybe<Scalars['String']['input']>;
  adjustmentComment_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreement?: InputMaybe<BaseAgreementWhere>;
  agreementAggregate?: InputMaybe<RefundAgreementAggregateInput>;
  agreementConnection?: InputMaybe<RefundAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<RefundAgreementConnectionWhere>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreement_NOT?: InputMaybe<BaseAgreementWhere>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amount_GT?: InputMaybe<Scalars['Float']['input']>;
  amount_GTE?: InputMaybe<Scalars['Float']['input']>;
  amount_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  amount_LT?: InputMaybe<Scalars['Float']['input']>;
  amount_LTE?: InputMaybe<Scalars['Float']['input']>;
  canBeReplacedInDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canBeReplacedInDocumentIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  canBeReplacementInDocumentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canBeReplacementInDocumentIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<RefundCaseAggregateInput>;
  caseConnection?: InputMaybe<RefundCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<RefundCaseConnectionWhere>;
  caseId?: InputMaybe<Scalars['String']['input']>;
  caseId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caseId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caseId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  caseOrAgreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  caseOrAgreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  case_NOT?: InputMaybe<CaseWhere>;
  counterParties?: InputMaybe<Scalars['String']['input']>;
  counterParties_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterParties_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterParties_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  counterParties_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterParties_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['Date']['input']>;
  createdOn_GT?: InputMaybe<Scalars['Date']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['Date']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['Date']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['Date']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['Date']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentFinancialDataPoint?: InputMaybe<FlexFinancialDataPointWhere>;
  documentFinancialDataPointAggregate?: InputMaybe<RefundDocumentFinancialDataPointAggregateInput>;
  documentFinancialDataPointConnection?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
  documentFinancialDataPointConnection_NOT?: InputMaybe<RefundDocumentFinancialDataPointConnectionWhere>;
  documentFinancialDataPoint_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
  documentMessagesAggregate?: InputMaybe<RefundDocumentMessagesAggregateInput>;
  /** Return Refunds where all of the related RefundDocumentMessagesConnections match this filter */
  documentMessagesConnection_ALL?: InputMaybe<RefundDocumentMessagesConnectionWhere>;
  /** Return Refunds where none of the related RefundDocumentMessagesConnections match this filter */
  documentMessagesConnection_NONE?: InputMaybe<RefundDocumentMessagesConnectionWhere>;
  /** Return Refunds where one of the related RefundDocumentMessagesConnections match this filter */
  documentMessagesConnection_SINGLE?: InputMaybe<RefundDocumentMessagesConnectionWhere>;
  /** Return Refunds where some of the related RefundDocumentMessagesConnections match this filter */
  documentMessagesConnection_SOME?: InputMaybe<RefundDocumentMessagesConnectionWhere>;
  /** Return Refunds where all of the related DocumentMessages match this filter */
  documentMessages_ALL?: InputMaybe<DocumentMessageWhere>;
  /** Return Refunds where none of the related DocumentMessages match this filter */
  documentMessages_NONE?: InputMaybe<DocumentMessageWhere>;
  /** Return Refunds where one of the related DocumentMessages match this filter */
  documentMessages_SINGLE?: InputMaybe<DocumentMessageWhere>;
  /** Return Refunds where some of the related DocumentMessages match this filter */
  documentMessages_SOME?: InputMaybe<DocumentMessageWhere>;
  documentRefundGroup?: InputMaybe<DocumentRefundGroupWhere>;
  documentRefundGroupAggregate?: InputMaybe<RefundDocumentRefundGroupAggregateInput>;
  documentRefundGroupConnection?: InputMaybe<RefundDocumentRefundGroupConnectionWhere>;
  documentRefundGroupConnection_NOT?: InputMaybe<RefundDocumentRefundGroupConnectionWhere>;
  documentRefundGroup_NOT?: InputMaybe<DocumentRefundGroupWhere>;
  documents?: InputMaybe<DocumentWhere>;
  documentsAggregate?: InputMaybe<RefundDocumentsAggregateInput>;
  documentsConnection?: InputMaybe<RefundDocumentsConnectionWhere>;
  documentsConnection_NOT?: InputMaybe<RefundDocumentsConnectionWhere>;
  documents_NOT?: InputMaybe<DocumentWhere>;
  formattedTags?: InputMaybe<Scalars['String']['input']>;
  formattedTags_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedTags_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedTags_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedTags_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedTags_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  iin?: InputMaybe<Scalars['String']['input']>;
  iin_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  iin_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  iin_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iin_MATCHES?: InputMaybe<Scalars['String']['input']>;
  iin_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastAdjustedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastAdjustedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastAdjustedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityName?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legalEntityName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  legalEntityName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  predecessorIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase?: InputMaybe<PurchaseWhere>;
  purchaseAggregate?: InputMaybe<RefundPurchaseAggregateInput>;
  purchaseConnection?: InputMaybe<RefundPurchaseConnectionWhere>;
  purchaseConnection_NOT?: InputMaybe<RefundPurchaseConnectionWhere>;
  purchaseOrPatientId?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseOrPatientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  purchase_NOT?: InputMaybe<PurchaseWhere>;
  recordUuid?: InputMaybe<Scalars['ID']['input']>;
  recordUuid_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  recordUuid_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  recordUuid_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  recordUuid_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  refundRate?: InputMaybe<Scalars['Float']['input']>;
  refundRate_GT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_GTE?: InputMaybe<Scalars['Float']['input']>;
  refundRate_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  refundRate_LT?: InputMaybe<Scalars['Float']['input']>;
  refundRate_LTE?: InputMaybe<Scalars['Float']['input']>;
  removedFromDocumentId?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removedFromDocumentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  removedFromDocumentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  revokedOn?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  revokedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  revokedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sourceFinancialDataPoint?: InputMaybe<FlexFinancialDataPointWhere>;
  sourceFinancialDataPointAggregate?: InputMaybe<RefundSourceFinancialDataPointAggregateInput>;
  sourceFinancialDataPointConnection?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
  sourceFinancialDataPointConnection_NOT?: InputMaybe<RefundSourceFinancialDataPointConnectionWhere>;
  sourceFinancialDataPoint_NOT?: InputMaybe<FlexFinancialDataPointWhere>;
  status?: InputMaybe<RefundStatus>;
  status_IN?: InputMaybe<Array<RefundStatus>>;
  successorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successorIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  tagsAggregate?: InputMaybe<RefundTagsAggregateInput>;
  /** Return Refunds where all of the related RefundTagsConnections match this filter */
  tagsConnection_ALL?: InputMaybe<RefundTagsConnectionWhere>;
  /** Return Refunds where none of the related RefundTagsConnections match this filter */
  tagsConnection_NONE?: InputMaybe<RefundTagsConnectionWhere>;
  /** Return Refunds where one of the related RefundTagsConnections match this filter */
  tagsConnection_SINGLE?: InputMaybe<RefundTagsConnectionWhere>;
  /** Return Refunds where some of the related RefundTagsConnections match this filter */
  tagsConnection_SOME?: InputMaybe<RefundTagsConnectionWhere>;
  /** Return Refunds where all of the related AgreementTags match this filter */
  tags_ALL?: InputMaybe<AgreementTagWhere>;
  /** Return Refunds where none of the related AgreementTags match this filter */
  tags_NONE?: InputMaybe<AgreementTagWhere>;
  /** Return Refunds where one of the related AgreementTags match this filter */
  tags_SINGLE?: InputMaybe<AgreementTagWhere>;
  /** Return Refunds where some of the related AgreementTags match this filter */
  tags_SOME?: InputMaybe<AgreementTagWhere>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  wasDeclined?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundXmlReportData = {
  __typename?: 'RefundXmlReportData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  countryScopeId: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  hasArticle71Tag: Scalars['Boolean']['output'];
  hasSLLTag: Scalars['Boolean']['output'];
  insuranceClaimId: Scalars['String']['output'];
  pack: Scalars['String']['output'];
  patientId: Scalars['String']['output'];
  positionId: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type RefundXmlReportDataAggregateSelection = {
  __typename?: 'RefundXmlReportDataAggregateSelection';
  amount: StringAggregateSelectionNonNullable;
  brandName: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  countryScopeId: StringAggregateSelectionNonNullable;
  discount: StringAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNonNullable;
  pack: StringAggregateSelectionNonNullable;
  patientId: StringAggregateSelectionNonNullable;
  positionId: StringAggregateSelectionNonNullable;
  transactionId: StringAggregateSelectionNonNullable;
};

export type RefundXmlReportDataConnection = {
  __typename?: 'RefundXmlReportDataConnection';
  edges: Array<RefundXmlReportDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundXmlReportDataEdge = {
  __typename?: 'RefundXmlReportDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: RefundXmlReportData;
};

export type RefundXmlReportDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RefundXmlReportDataSort objects to sort RefundXmlReportData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RefundXmlReportDataSort>>;
};

/** Fields to sort RefundXmlReportData by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundXmlReportDataSort object. */
export type RefundXmlReportDataSort = {
  amount?: InputMaybe<SortDirection>;
  brandName?: InputMaybe<SortDirection>;
  countryScopeId?: InputMaybe<SortDirection>;
  discount?: InputMaybe<SortDirection>;
  hasArticle71Tag?: InputMaybe<SortDirection>;
  hasSLLTag?: InputMaybe<SortDirection>;
  insuranceClaimId?: InputMaybe<SortDirection>;
  pack?: InputMaybe<SortDirection>;
  patientId?: InputMaybe<SortDirection>;
  positionId?: InputMaybe<SortDirection>;
  transactionId?: InputMaybe<SortDirection>;
};

export type RefundXmlReportDataWhere = {
  AND?: InputMaybe<Array<RefundXmlReportDataWhere>>;
  NOT?: InputMaybe<RefundXmlReportDataWhere>;
  OR?: InputMaybe<Array<RefundXmlReportDataWhere>>;
  amount?: InputMaybe<Scalars['String']['input']>;
  amount_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  amount_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  amount_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  amount_MATCHES?: InputMaybe<Scalars['String']['input']>;
  amount_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  brandName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  brandName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  brandName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  brandName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  brandName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeId?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  countryScopeId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  countryScopeId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['String']['input']>;
  discount_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  discount_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  discount_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  discount_MATCHES?: InputMaybe<Scalars['String']['input']>;
  discount_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasArticle71Tag?: InputMaybe<Scalars['Boolean']['input']>;
  hasSLLTag?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceClaimId?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  insuranceClaimId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  insuranceClaimId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pack?: InputMaybe<Scalars['String']['input']>;
  pack_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  pack_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  pack_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  pack_MATCHES?: InputMaybe<Scalars['String']['input']>;
  pack_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  patientId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  patientId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  patientId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  patientId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  positionId?: InputMaybe<Scalars['String']['input']>;
  positionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  positionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  positionId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  positionId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  positionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  transactionId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  transactionId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  transactionId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  transactionId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type RefundsConnection = {
  __typename?: 'RefundsConnection';
  edges: Array<RefundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundsTableSourceFilterData = {
  __typename?: 'RefundsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  amountRanges: Array<AmountRange>;
  basePricesRanges: Array<AmountRange>;
  caseOrAgreementIds: Array<Scalars['String']['output']>;
  counterparties: Array<Scalars['String']['output']>;
  documentIds: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
  isDeltaValues: Array<Scalars['Boolean']['output']>;
  legalEntities: Array<Scalars['String']['output']>;
  maxAdjustedAt?: Maybe<Scalars['DateTime']['output']>;
  maxAdministrationDate?: Maybe<Scalars['Date']['output']>;
  maxInvoiceDate?: Maybe<Scalars['Date']['output']>;
  minAdjustedAt?: Maybe<Scalars['DateTime']['output']>;
  minAdministrationDate?: Maybe<Scalars['Date']['output']>;
  minInvoiceDate?: Maybe<Scalars['Date']['output']>;
  predecessorIds: Array<Scalars['String']['output']>;
  products: Array<Scalars['String']['output']>;
  purchaseOrPatientIds: Array<Scalars['String']['output']>;
  quantityRanges: Array<AmountRange>;
  rateRanges: Array<AmountRange>;
  recordTypes: Array<Scalars['String']['output']>;
  reviewersOrganizations: Array<Scalars['String']['output']>;
  statuses: Array<Scalars['String']['output']>;
  successorIds: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type RefundsTableSourceFilterDataAggregateSelection = {
  __typename?: 'RefundsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  maxAdjustedAt: DateTimeAggregateSelectionNullable;
  minAdjustedAt: DateTimeAggregateSelectionNullable;
};

export type RefundsTableSourceFilterDataConnection = {
  __typename?: 'RefundsTableSourceFilterDataConnection';
  edges: Array<RefundsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RefundsTableSourceFilterDataEdge = {
  __typename?: 'RefundsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: RefundsTableSourceFilterData;
};

export type RefundsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more RefundsTableSourceFilterDataSort objects to sort RefundsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<RefundsTableSourceFilterDataSort>>;
};

/** Fields to sort RefundsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one RefundsTableSourceFilterDataSort object. */
export type RefundsTableSourceFilterDataSort = {
  maxAdjustedAt?: InputMaybe<SortDirection>;
  maxAdministrationDate?: InputMaybe<SortDirection>;
  maxInvoiceDate?: InputMaybe<SortDirection>;
  minAdjustedAt?: InputMaybe<SortDirection>;
  minAdministrationDate?: InputMaybe<SortDirection>;
  minInvoiceDate?: InputMaybe<SortDirection>;
};

export type RefundsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<RefundsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<RefundsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<RefundsTableSourceFilterDataWhere>>;
  caseOrAgreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  caseOrAgreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  counterparties?: InputMaybe<Array<Scalars['String']['input']>>;
  counterparties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documentIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  isDeltaValues?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  legalEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntities_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  maxAdjustedAt?: InputMaybe<Scalars['DateTime']['input']>;
  maxAdjustedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  maxAdjustedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxAdjustedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  maxAdjustedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  maxAdjustedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  maxAdministrationDate?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxAdministrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxAdministrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  maxInvoiceDate?: InputMaybe<Scalars['Date']['input']>;
  maxInvoiceDate_GT?: InputMaybe<Scalars['Date']['input']>;
  maxInvoiceDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  maxInvoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  maxInvoiceDate_LT?: InputMaybe<Scalars['Date']['input']>;
  maxInvoiceDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minAdjustedAt?: InputMaybe<Scalars['DateTime']['input']>;
  minAdjustedAt_GT?: InputMaybe<Scalars['DateTime']['input']>;
  minAdjustedAt_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  minAdjustedAt_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  minAdjustedAt_LT?: InputMaybe<Scalars['DateTime']['input']>;
  minAdjustedAt_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  minAdministrationDate?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minAdministrationDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minAdministrationDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  minInvoiceDate?: InputMaybe<Scalars['Date']['input']>;
  minInvoiceDate_GT?: InputMaybe<Scalars['Date']['input']>;
  minInvoiceDate_GTE?: InputMaybe<Scalars['Date']['input']>;
  minInvoiceDate_IN?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  minInvoiceDate_LT?: InputMaybe<Scalars['Date']['input']>;
  minInvoiceDate_LTE?: InputMaybe<Scalars['Date']['input']>;
  predecessorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  predecessorIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  products_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  purchaseOrPatientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseOrPatientIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  recordTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  recordTypes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  reviewersOrganizations?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewersOrganizations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  successorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  successorIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export enum Reintervention {
  DidNotOccur = 'DID_NOT_OCCUR',
  Occured = 'OCCURED'
}

export enum ReportInterventionType {
  PrimaryIntervention = 'PRIMARY_INTERVENTION',
  SecondaryIntervention = 'SECONDARY_INTERVENTION'
}

export enum ReportItemsUsedFilter {
  All = 'ALL',
  PrimaryAndSecondaryIntervention = 'PRIMARY_AND_SECONDARY_INTERVENTION',
  PrimaryInterventionOnly = 'PRIMARY_INTERVENTION_ONLY'
}

export type ReportingDashboardSummariesConnection = {
  __typename?: 'ReportingDashboardSummariesConnection';
  edges: Array<ReportingDashboardSummaryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReportingDashboardSummary = {
  __typename?: 'ReportingDashboardSummary';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementsTreatments: Array<Treatment>;
  averageDiscountPerCase?: Maybe<Scalars['Float']['output']>;
  averageDiscountPerCaseDelta?: Maybe<Scalars['Float']['output']>;
  dashboardType: AgreementDashboardTarget;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountDelta?: Maybe<Scalars['Float']['output']>;
  discountRatio?: Maybe<Scalars['Float']['output']>;
  discountRatioDelta?: Maybe<Scalars['Float']['output']>;
  discountsTurnover?: Maybe<Scalars['Float']['output']>;
  dotThresholds?: Maybe<Array<Scalars['Int']['output']>>;
  durationDays?: Maybe<Scalars['Int']['output']>;
  durationDaysDiscontinued?: Maybe<Scalars['Int']['output']>;
  expenditureDistributionDataPoints?: Maybe<Array<ExpenditureDistributionDataPoint>>;
  financialReportDataPoints?: Maybe<Array<FinancialReportDataPoint>>;
  financialSummaryRows?: Maybe<Array<FinancialSummaryRow>>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  grossAmountDelta?: Maybe<Scalars['Float']['output']>;
  grossTurnover?: Maybe<Scalars['Float']['output']>;
  grossVariable?: Maybe<Scalars['Float']['output']>;
  patientReportDataPoints: Array<PatientReportDataPoint>;
  treatmentDurationData?: Maybe<Array<CaseReportDataPoint>>;
  treatmentPatients?: Maybe<Array<TreatmentPatient>>;
};

export type ReportingDashboardSummaryAggregateSelection = {
  __typename?: 'ReportingDashboardSummaryAggregateSelection';
  averageDiscountPerCase: FloatAggregateSelectionNullable;
  averageDiscountPerCaseDelta: FloatAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNullable;
  discountAmountDelta: FloatAggregateSelectionNullable;
  discountRatio: FloatAggregateSelectionNullable;
  discountRatioDelta: FloatAggregateSelectionNullable;
  discountsTurnover: FloatAggregateSelectionNullable;
  durationDays: IntAggregateSelectionNullable;
  durationDaysDiscontinued: IntAggregateSelectionNullable;
  grossAmount: FloatAggregateSelectionNullable;
  grossAmountDelta: FloatAggregateSelectionNullable;
  grossTurnover: FloatAggregateSelectionNullable;
  grossVariable: FloatAggregateSelectionNullable;
};

export type ReportingDashboardSummaryEdge = {
  __typename?: 'ReportingDashboardSummaryEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ReportingDashboardSummary;
};

export type ReportingDashboardSummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ReportingDashboardSummarySort objects to sort ReportingDashboardSummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ReportingDashboardSummarySort>>;
};

/** Fields to sort ReportingDashboardSummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one ReportingDashboardSummarySort object. */
export type ReportingDashboardSummarySort = {
  averageDiscountPerCase?: InputMaybe<SortDirection>;
  averageDiscountPerCaseDelta?: InputMaybe<SortDirection>;
  dashboardType?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  discountAmountDelta?: InputMaybe<SortDirection>;
  discountRatio?: InputMaybe<SortDirection>;
  discountRatioDelta?: InputMaybe<SortDirection>;
  discountsTurnover?: InputMaybe<SortDirection>;
  durationDays?: InputMaybe<SortDirection>;
  durationDaysDiscontinued?: InputMaybe<SortDirection>;
  grossAmount?: InputMaybe<SortDirection>;
  grossAmountDelta?: InputMaybe<SortDirection>;
  grossTurnover?: InputMaybe<SortDirection>;
  grossVariable?: InputMaybe<SortDirection>;
};

export type ReportingDashboardSummaryWhere = {
  AND?: InputMaybe<Array<ReportingDashboardSummaryWhere>>;
  NOT?: InputMaybe<ReportingDashboardSummaryWhere>;
  OR?: InputMaybe<Array<ReportingDashboardSummaryWhere>>;
  averageDiscountPerCase?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  averageDiscountPerCaseDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_GT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  averageDiscountPerCase_LT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_LTE?: InputMaybe<Scalars['Float']['input']>;
  dashboardType?: InputMaybe<AgreementDashboardTarget>;
  dashboardType_IN?: InputMaybe<Array<AgreementDashboardTarget>>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatioDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatioDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountRatio_LT?: InputMaybe<Scalars['Float']['input']>;
  discountRatio_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_GT?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountsTurnover_LT?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_LTE?: InputMaybe<Scalars['Float']['input']>;
  dotThresholds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dotThresholds_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  durationDays?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_GT?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationDaysDiscontinued_LT?: InputMaybe<Scalars['Int']['input']>;
  durationDaysDiscontinued_LTE?: InputMaybe<Scalars['Int']['input']>;
  durationDays_GT?: InputMaybe<Scalars['Int']['input']>;
  durationDays_GTE?: InputMaybe<Scalars['Int']['input']>;
  durationDays_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  durationDays_LT?: InputMaybe<Scalars['Int']['input']>;
  durationDays_LTE?: InputMaybe<Scalars['Int']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_GT?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossTurnover_LT?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossVariable?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_GT?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossVariable_LT?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ReportingSummariesConnection = {
  __typename?: 'ReportingSummariesConnection';
  edges: Array<ReportingSummaryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReportingSummary = {
  __typename?: 'ReportingSummary';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  averageDiscountPerCase?: Maybe<Scalars['Float']['output']>;
  averageDiscountPerCaseDelta?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountAmountDelta?: Maybe<Scalars['Float']['output']>;
  discountsTurnover?: Maybe<Scalars['Float']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  grossAmountDelta?: Maybe<Scalars['Float']['output']>;
  grossTurnover?: Maybe<Scalars['Float']['output']>;
  grossVariable?: Maybe<Scalars['Float']['output']>;
  netTurnover?: Maybe<Scalars['Float']['output']>;
  patientReportDataPoints: Array<PatientReportDataPoint>;
  variableTurnover?: Maybe<Scalars['Float']['output']>;
};

export type ReportingSummaryAggregateSelection = {
  __typename?: 'ReportingSummaryAggregateSelection';
  averageDiscountPerCase: FloatAggregateSelectionNullable;
  averageDiscountPerCaseDelta: FloatAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  discountAmount: FloatAggregateSelectionNullable;
  discountAmountDelta: FloatAggregateSelectionNullable;
  discountsTurnover: FloatAggregateSelectionNullable;
  grossAmount: FloatAggregateSelectionNullable;
  grossAmountDelta: FloatAggregateSelectionNullable;
  grossTurnover: FloatAggregateSelectionNullable;
  grossVariable: FloatAggregateSelectionNullable;
  netTurnover: FloatAggregateSelectionNullable;
  variableTurnover: FloatAggregateSelectionNullable;
};

export type ReportingSummaryEdge = {
  __typename?: 'ReportingSummaryEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ReportingSummary;
};

export type ReportingSummaryOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ReportingSummarySort objects to sort ReportingSummaries by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ReportingSummarySort>>;
};

/** Fields to sort ReportingSummaries by. The order in which sorts are applied is not guaranteed when specifying many fields in one ReportingSummarySort object. */
export type ReportingSummarySort = {
  averageDiscountPerCase?: InputMaybe<SortDirection>;
  averageDiscountPerCaseDelta?: InputMaybe<SortDirection>;
  discountAmount?: InputMaybe<SortDirection>;
  discountAmountDelta?: InputMaybe<SortDirection>;
  discountsTurnover?: InputMaybe<SortDirection>;
  grossAmount?: InputMaybe<SortDirection>;
  grossAmountDelta?: InputMaybe<SortDirection>;
  grossTurnover?: InputMaybe<SortDirection>;
  grossVariable?: InputMaybe<SortDirection>;
  netTurnover?: InputMaybe<SortDirection>;
  variableTurnover?: InputMaybe<SortDirection>;
};

export type ReportingSummaryWhere = {
  AND?: InputMaybe<Array<ReportingSummaryWhere>>;
  NOT?: InputMaybe<ReportingSummaryWhere>;
  OR?: InputMaybe<Array<ReportingSummaryWhere>>;
  averageDiscountPerCase?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  averageDiscountPerCaseDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCaseDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_GT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_GTE?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  averageDiscountPerCase_LT?: InputMaybe<Scalars['Float']['input']>;
  averageDiscountPerCase_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  discountAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_GT?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_GTE?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  discountsTurnover_LT?: InputMaybe<Scalars['Float']['input']>;
  discountsTurnover_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmountDelta_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmountDelta_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossAmount_LT?: InputMaybe<Scalars['Float']['input']>;
  grossAmount_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_GT?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossTurnover_LT?: InputMaybe<Scalars['Float']['input']>;
  grossTurnover_LTE?: InputMaybe<Scalars['Float']['input']>;
  grossVariable?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_GT?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_GTE?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grossVariable_LT?: InputMaybe<Scalars['Float']['input']>;
  grossVariable_LTE?: InputMaybe<Scalars['Float']['input']>;
  netTurnover?: InputMaybe<Scalars['Float']['input']>;
  netTurnover_GT?: InputMaybe<Scalars['Float']['input']>;
  netTurnover_GTE?: InputMaybe<Scalars['Float']['input']>;
  netTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  netTurnover_LT?: InputMaybe<Scalars['Float']['input']>;
  netTurnover_LTE?: InputMaybe<Scalars['Float']['input']>;
  variableTurnover?: InputMaybe<Scalars['Float']['input']>;
  variableTurnover_GT?: InputMaybe<Scalars['Float']['input']>;
  variableTurnover_GTE?: InputMaybe<Scalars['Float']['input']>;
  variableTurnover_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  variableTurnover_LT?: InputMaybe<Scalars['Float']['input']>;
  variableTurnover_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ResendDocumentToSmartMipInput = {
  documentId: Scalars['ID']['input'];
};

export type ResendInvoiceForReviewInput = {
  invoiceId: Scalars['ID']['input'];
};

export enum ResponseBaseStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS'
}

export enum ResponseInclusionType {
  Is = 'IS',
  IsNot = 'IS_NOT'
}

export enum ResponseType {
  CompleteResponse = 'COMPLETE_RESPONSE',
  NoInfo = 'NO_INFO',
  PartialResponse = 'PARTIAL_RESPONSE',
  PathologicalCompleteResponse = 'PATHOLOGICAL_COMPLETE_RESPONSE',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  StableDisease = 'STABLE_DISEASE'
}

export enum ResultSelectionType {
  Earliest = 'EARLIEST',
  Highest = 'HIGHEST',
  Latest = 'LATEST',
  Lowest = 'LOWEST'
}

export type RevokableRecordsReport = {
  __typename?: 'RevokableRecordsReport';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  notRevokableRecordIds: Array<Scalars['String']['output']>;
  revokableRecordIds: Array<Scalars['String']['output']>;
};

export type RevokableRecordsReportAggregateSelection = {
  __typename?: 'RevokableRecordsReportAggregateSelection';
  count: Scalars['Int']['output'];
};

export type RevokableRecordsReportEdge = {
  __typename?: 'RevokableRecordsReportEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: RevokableRecordsReport;
};

export type RevokableRecordsReportOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RevokableRecordsReportWhere = {
  AND?: InputMaybe<Array<RevokableRecordsReportWhere>>;
  NOT?: InputMaybe<RevokableRecordsReportWhere>;
  OR?: InputMaybe<Array<RevokableRecordsReportWhere>>;
  notRevokableRecordIds?: InputMaybe<Array<Scalars['String']['input']>>;
  notRevokableRecordIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  revokableRecordIds?: InputMaybe<Array<Scalars['String']['input']>>;
  revokableRecordIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type RevokableRecordsReportsConnection = {
  __typename?: 'RevokableRecordsReportsConnection';
  edges: Array<RevokableRecordsReportEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum RollingRangeType {
  CalendarMonth = 'CALENDAR_MONTH',
  CalendarQuarter = 'CALENDAR_QUARTER',
  CalendarYear = 'CALENDAR_YEAR',
  Exactly = 'EXACTLY'
}

export type SvgFlag = {
  __typename?: 'SVGFlag';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type SvgFlagAggregateSelection = {
  __typename?: 'SVGFlagAggregateSelection';
  count: Scalars['Int']['output'];
  fileName: StringAggregateSelectionNullable;
  height: IntAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  size: IntAggregateSelectionNullable;
  type: StringAggregateSelectionNullable;
  url: StringAggregateSelectionNullable;
  width: IntAggregateSelectionNullable;
};

export type SvgFlagEdge = {
  __typename?: 'SVGFlagEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SvgFlag;
};

export type SvgFlagOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SVGFlagSort objects to sort SvgFlags by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SvgFlagSort>>;
};

/** Fields to sort SvgFlags by. The order in which sorts are applied is not guaranteed when specifying many fields in one SVGFlagSort object. */
export type SvgFlagSort = {
  fileName?: InputMaybe<SortDirection>;
  height?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
  width?: InputMaybe<SortDirection>;
};

export type SvgFlagWhere = {
  AND?: InputMaybe<Array<SvgFlagWhere>>;
  NOT?: InputMaybe<SvgFlagWhere>;
  OR?: InputMaybe<Array<SvgFlagWhere>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_GT?: InputMaybe<Scalars['Int']['input']>;
  height_GTE?: InputMaybe<Scalars['Int']['input']>;
  height_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_LT?: InputMaybe<Scalars['Int']['input']>;
  height_LTE?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_GT?: InputMaybe<Scalars['Int']['input']>;
  size_GTE?: InputMaybe<Scalars['Int']['input']>;
  size_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_LT?: InputMaybe<Scalars['Int']['input']>;
  size_LTE?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  type_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_MATCHES?: InputMaybe<Scalars['String']['input']>;
  type_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_MATCHES?: InputMaybe<Scalars['String']['input']>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_GT?: InputMaybe<Scalars['Int']['input']>;
  width_GTE?: InputMaybe<Scalars['Int']['input']>;
  width_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_LT?: InputMaybe<Scalars['Int']['input']>;
  width_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveAdjustedAmountInput = {
  adjustedAmount: Scalars['String']['input'];
  adjustedAmountMessage: Scalars['String']['input'];
  adjustedRate: Scalars['String']['input'];
  adjustmentComment?: InputMaybe<Scalars['String']['input']>;
  documentRefundGroupId?: InputMaybe<Scalars['ID']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  refundId: Scalars['ID']['input'];
  reviewerOrganization?: InputMaybe<Scalars['String']['input']>;
};

export type SaveDraftInvoiceInput = {
  adjustedInvoiceAmount: Scalars['Float']['input'];
  deletedRefunds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceAmount: Scalars['Float']['input'];
  invoiceId: Scalars['ID']['input'];
  isAdjusted: Scalars['Boolean']['input'];
  refunds: Array<Scalars['ID']['input']>;
};

export type SaveInvoiceForInternalReviewInput = {
  adjustedInvoiceAmount: Scalars['Float']['input'];
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coveragePeriod?: InputMaybe<Scalars['String']['input']>;
  deletedRefunds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentType: DocumentType;
  financialDataPoints: Array<FinancialDataPointInput>;
  invoiceAmount: Scalars['Float']['input'];
  invoiceId: Scalars['ID']['input'];
  invoiceStatus: DocumentStatus;
  isAdjusted: Scalars['Boolean']['input'];
  refunds: Array<Scalars['ID']['input']>;
};

export type SaveReviewedInvoiceInput = {
  assignees?: InputMaybe<Array<InputMaybe<AssigneeInput>>>;
  confirmedByBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedBySeller?: InputMaybe<Scalars['Boolean']['input']>;
  documentType?: InputMaybe<DocumentType>;
  dunningDate?: InputMaybe<Scalars['String']['input']>;
  financialDataPoints?: InputMaybe<Array<FinancialDataPointInput>>;
  invoiceId: Scalars['ID']['input'];
  invoiceStatus: DocumentStatus;
  isApproved: Scalars['Boolean']['input'];
  isExposure?: InputMaybe<Scalars['Boolean']['input']>;
  reviewerOrganization?: InputMaybe<Scalars['String']['input']>;
  settledOn?: InputMaybe<Scalars['String']['input']>;
};

export type SaveSimulationResult = {
  __typename?: 'SaveSimulationResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  isRemovedFromComparison: Scalars['Boolean']['output'];
  simulationId: Scalars['ID']['output'];
};

export type SaveSimulationResultAggregateSelection = {
  __typename?: 'SaveSimulationResultAggregateSelection';
  count: Scalars['Int']['output'];
  simulationId: IdAggregateSelectionNonNullable;
};

export type SaveSimulationResultEdge = {
  __typename?: 'SaveSimulationResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SaveSimulationResult;
};

export type SaveSimulationResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SaveSimulationResultSort objects to sort SaveSimulationResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SaveSimulationResultSort>>;
};

/** Fields to sort SaveSimulationResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one SaveSimulationResultSort object. */
export type SaveSimulationResultSort = {
  isRemovedFromComparison?: InputMaybe<SortDirection>;
  simulationId?: InputMaybe<SortDirection>;
};

export type SaveSimulationResultWhere = {
  AND?: InputMaybe<Array<SaveSimulationResultWhere>>;
  NOT?: InputMaybe<SaveSimulationResultWhere>;
  OR?: InputMaybe<Array<SaveSimulationResultWhere>>;
  isRemovedFromComparison?: InputMaybe<Scalars['Boolean']['input']>;
  simulationId?: InputMaybe<Scalars['ID']['input']>;
  simulationId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  simulationId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  simulationId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  simulationId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveSimulationResultsConnection = {
  __typename?: 'SaveSimulationResultsConnection';
  edges: Array<SaveSimulationResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Scenario = {
  __typename?: 'Scenario';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  actionSets?: Maybe<Scalars['Boolean']['output']>;
  actionSetsOperator?: Maybe<ActionSetsOperator>;
  actions: Array<ScenarioAction>;
  actionsAggregate?: Maybe<ScenarioScenarioActionActionsAggregationSelection>;
  actionsConnection: ScenarioActionsConnection;
  agreement: BaseAgreement;
  agreementAggregate?: Maybe<ScenarioBaseAgreementAgreementAggregationSelection>;
  agreementConnection: ScenarioAgreementConnection;
  conditions: Array<ScenarioCondition>;
  conditionsAggregate?: Maybe<ScenarioScenarioConditionConditionsAggregationSelection>;
  conditionsConnection: ScenarioConditionsConnection;
  group?: Maybe<Scalars['Int']['output']>;
  hasMultipleBasePrices?: Maybe<Scalars['Boolean']['output']>;
  isGrouped?: Maybe<Scalars['Boolean']['output']>;
  isProRating?: Maybe<Scalars['Boolean']['output']>;
  isRelevantForArt71?: Maybe<Scalars['Boolean']['output']>;
  operator: ConditionLogicalOperator;
  order: Scalars['Int']['output'];
};


export type ScenarioActionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioActionOptions>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type ScenarioActionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioActionWhere>;
};


export type ScenarioActionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionsConnectionSort>>;
  where?: InputMaybe<ScenarioActionsConnectionWhere>;
};


export type ScenarioAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type ScenarioAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type ScenarioAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioAgreementConnectionSort>>;
  where?: InputMaybe<ScenarioAgreementConnectionWhere>;
};


export type ScenarioConditionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioConditionOptions>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type ScenarioConditionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioConditionWhere>;
};


export type ScenarioConditionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionsConnectionWhere>;
};

export type ScenarioAction = ITimeframe & ITreatmentCondition & {
  __typename?: 'ScenarioAction';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  actionLogicalOperator?: Maybe<ActionLogicalOperator>;
  actionSet?: Maybe<Scalars['Int']['output']>;
  actionType: ActionType;
  adHocPriceTypes?: Maybe<Array<PriceType>>;
  brands: Array<Brand>;
  brandsAggregate?: Maybe<ScenarioActionBrandBrandsAggregationSelection>;
  brandsConnection: ScenarioActionBrandsConnection;
  combinedItemBrands: Array<Brand>;
  combinedItemBrandsAggregate?: Maybe<ScenarioActionBrandCombinedItemBrandsAggregationSelection>;
  combinedItemBrandsConnection: ScenarioActionCombinedItemBrandsConnection;
  combinedItemGenerics: Array<Generic>;
  combinedItemGenericsAggregate?: Maybe<ScenarioActionGenericCombinedItemGenericsAggregationSelection>;
  combinedItemGenericsConnection: ScenarioActionCombinedItemGenericsConnection;
  combinedItemTimeframeEnd?: Maybe<Scalars['Int']['output']>;
  combinedItemTimeframeRangeType?: Maybe<TimeframeRangeType>;
  combinedItemTimeframeStart?: Maybe<Scalars['Int']['output']>;
  combinedItemTreatments: Array<Treatment>;
  combinedItemTreatmentsAggregate?: Maybe<ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection>;
  combinedItemTreatmentsConnection: ScenarioActionCombinedItemTreatmentsConnection;
  cycle?: Maybe<CycleConfiguration>;
  cycleAggregate?: Maybe<ScenarioActionCycleConfigurationCycleAggregationSelection>;
  cycleConnection: ScenarioActionCycleConnection;
  endItemNumber?: Maybe<Scalars['Int']['output']>;
  entityPriceType?: Maybe<EntityPriceType>;
  generics: Array<Generic>;
  genericsAggregate?: Maybe<ScenarioActionGenericGenericsAggregationSelection>;
  genericsConnection: ScenarioActionGenericsConnection;
  ingredientEndItemNumber?: Maybe<Scalars['Float']['output']>;
  ingredientRangeType?: Maybe<ActionItemRangeType>;
  ingredientStartItemNumber?: Maybe<Scalars['Float']['output']>;
  isAdHocDiscount: Scalars['Boolean']['output'];
  isCombinedScenarioRelevantDrugsActive?: Maybe<Scalars['Boolean']['output']>;
  isNamedTimeRangeUsed?: Maybe<Scalars['Boolean']['output']>;
  isScenarioRelevantDrugsActive?: Maybe<Scalars['Boolean']['output']>;
  isSortedByPackOrder?: Maybe<Scalars['Boolean']['output']>;
  itemCombinationRelation?: Maybe<ActionItemCombinationRelation>;
  itemCombinationRule?: Maybe<ActionItemCombinationRule>;
  itemRangeType?: Maybe<ActionItemRangeType>;
  itemScope: ItemScope;
  order: Scalars['Int']['output'];
  packOptionType?: Maybe<PackOptionType>;
  priceType?: Maybe<PriceType>;
  recordNature?: Maybe<RecordNature>;
  rollingRangeType?: Maybe<RollingRangeType>;
  scenario: Scenario;
  scenarioAggregate?: Maybe<ScenarioActionScenarioScenarioAggregationSelection>;
  scenarioConnection: ScenarioActionScenarioConnection;
  startItemNumber?: Maybe<Scalars['Int']['output']>;
  startingPoint?: Maybe<TimeframeStartingPoint>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeRelation?: Maybe<TimeframeRelation>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<ScenarioActionTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: ScenarioActionTreatmentsConnection;
  uoMType?: Maybe<UoMType>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type ScenarioActionBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionBrandsConnectionSort>>;
  where?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
};


export type ScenarioActionCombinedItemBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionCombinedItemBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioActionCombinedItemBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionSort>>;
  where?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
};


export type ScenarioActionCombinedItemGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionCombinedItemGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionCombinedItemGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCombinedItemGenericsConnectionSort>>;
  where?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
};


export type ScenarioActionCombinedItemTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionCombinedItemTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionCombinedItemTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionSort>>;
  where?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
};


export type ScenarioActionCycleArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CycleConfigurationOptions>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type ScenarioActionCycleAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CycleConfigurationWhere>;
};


export type ScenarioActionCycleConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionCycleConnectionSort>>;
  where?: InputMaybe<ScenarioActionCycleConnectionWhere>;
};


export type ScenarioActionGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioActionGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionGenericsConnectionSort>>;
  where?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
};


export type ScenarioActionScenarioArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioActionScenarioAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioActionScenarioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionScenarioConnectionSort>>;
  where?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
};


export type ScenarioActionTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioActionTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioActionTreatmentsConnectionSort>>;
  where?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
};

export type ScenarioActionAggregateSelection = {
  __typename?: 'ScenarioActionAggregateSelection';
  actionSet: IntAggregateSelectionNullable;
  combinedItemTimeframeEnd: IntAggregateSelectionNullable;
  combinedItemTimeframeStart: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  endItemNumber: IntAggregateSelectionNullable;
  ingredientEndItemNumber: FloatAggregateSelectionNullable;
  ingredientStartItemNumber: FloatAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  startItemNumber: IntAggregateSelectionNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

export type ScenarioActionBrandBrandsAggregationSelection = {
  __typename?: 'ScenarioActionBrandBrandsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<ScenarioActionBrandBrandsEdgeAggregateSelection>;
  node?: Maybe<ScenarioActionBrandBrandsNodeAggregateSelection>;
};

export type ScenarioActionBrandBrandsEdgeAggregateSelection = {
  __typename?: 'ScenarioActionBrandBrandsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type ScenarioActionBrandBrandsNodeAggregateSelection = {
  __typename?: 'ScenarioActionBrandBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionBrandCombinedItemBrandsAggregationSelection = {
  __typename?: 'ScenarioActionBrandCombinedItemBrandsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection>;
};

export type ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection = {
  __typename?: 'ScenarioActionBrandCombinedItemBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionBrandsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionBrandsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionBrandsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ScenarioActionBrandsEdgeAggregationWhereInput>;
  node?: InputMaybe<ScenarioActionBrandsNodeAggregationWhereInput>;
};

export type ScenarioActionBrandsConnection = {
  __typename?: 'ScenarioActionBrandsConnection';
  edges: Array<ScenarioActionBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionBrandsConnectionSort = {
  edge?: InputMaybe<ActionPrescriptionRelationshipSort>;
  node?: InputMaybe<BrandSort>;
};

export type ScenarioActionBrandsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionBrandsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionBrandsConnectionWhere>>;
  edge?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  node?: InputMaybe<BrandWhere>;
};

export type ScenarioActionBrandsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionBrandsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionBrandsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionBrandsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioActionBrandsRelationship = ActionPrescriptionRelationship & {
  __typename?: 'ScenarioActionBrandsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioActionCombinedItemBrandsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemBrandsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemBrandsConnection = {
  __typename?: 'ScenarioActionCombinedItemBrandsConnection';
  edges: Array<ScenarioActionCombinedItemBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCombinedItemBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type ScenarioActionCombinedItemBrandsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type ScenarioActionCombinedItemBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioActionCombinedItemBrandsRelationship = {
  __typename?: 'ScenarioActionCombinedItemBrandsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type ScenarioActionCombinedItemGenericsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemGenericsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemGenericsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemGenericsConnection = {
  __typename?: 'ScenarioActionCombinedItemGenericsConnection';
  edges: Array<ScenarioActionCombinedItemGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCombinedItemGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type ScenarioActionCombinedItemGenericsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemGenericsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type ScenarioActionCombinedItemGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemGenericsNodeAggregationWhereInput>>;
};

export type ScenarioActionCombinedItemGenericsRelationship = {
  __typename?: 'ScenarioActionCombinedItemGenericsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type ScenarioActionCombinedItemTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioActionCombinedItemTreatmentsConnection = {
  __typename?: 'ScenarioActionCombinedItemTreatmentsConnection';
  edges: Array<ScenarioActionCombinedItemTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCombinedItemTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type ScenarioActionCombinedItemTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionCombinedItemTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionCombinedItemTreatmentsRelationship = {
  __typename?: 'ScenarioActionCombinedItemTreatmentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type ScenarioActionCycleAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionCycleAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionCycleAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionCycleAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionCycleNodeAggregationWhereInput>;
};

export type ScenarioActionCycleConfigurationCycleAggregationSelection = {
  __typename?: 'ScenarioActionCycleConfigurationCycleAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionCycleConfigurationCycleNodeAggregateSelection>;
};

export type ScenarioActionCycleConfigurationCycleNodeAggregateSelection = {
  __typename?: 'ScenarioActionCycleConfigurationCycleNodeAggregateSelection';
  lengthFrom: IntAggregateSelectionNonNullable;
  lengthTo: IntAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
};

export type ScenarioActionCycleConnection = {
  __typename?: 'ScenarioActionCycleConnection';
  edges: Array<ScenarioActionCycleRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionCycleConnectionSort = {
  node?: InputMaybe<CycleConfigurationSort>;
};

export type ScenarioActionCycleConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionCycleConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionCycleConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionCycleConnectionWhere>>;
  node?: InputMaybe<CycleConfigurationWhere>;
};

export type ScenarioActionCycleNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionCycleNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionCycleNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionCycleNodeAggregationWhereInput>>;
  lengthFrom_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthFrom_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthFrom_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lengthTo_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  lengthTo_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionCycleRelationship = {
  __typename?: 'ScenarioActionCycleRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CycleConfiguration;
};

export type ScenarioActionEdge = {
  __typename?: 'ScenarioActionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ScenarioAction;
};

export enum ScenarioActionFailure {
  AddedAfterDiscontinuation = 'ADDED_AFTER_DISCONTINUATION',
  Combination = 'COMBINATION',
  Other = 'OTHER'
}

export type ScenarioActionGenericCombinedItemGenericsAggregationSelection = {
  __typename?: 'ScenarioActionGenericCombinedItemGenericsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection>;
};

export type ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection = {
  __typename?: 'ScenarioActionGenericCombinedItemGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionGenericGenericsAggregationSelection = {
  __typename?: 'ScenarioActionGenericGenericsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<ScenarioActionGenericGenericsEdgeAggregateSelection>;
  node?: Maybe<ScenarioActionGenericGenericsNodeAggregateSelection>;
};

export type ScenarioActionGenericGenericsEdgeAggregateSelection = {
  __typename?: 'ScenarioActionGenericGenericsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type ScenarioActionGenericGenericsNodeAggregateSelection = {
  __typename?: 'ScenarioActionGenericGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioActionGenericsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionGenericsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionGenericsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ScenarioActionGenericsEdgeAggregationWhereInput>;
  node?: InputMaybe<ScenarioActionGenericsNodeAggregationWhereInput>;
};

export type ScenarioActionGenericsConnection = {
  __typename?: 'ScenarioActionGenericsConnection';
  edges: Array<ScenarioActionGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionGenericsConnectionSort = {
  edge?: InputMaybe<ActionPrescriptionRelationshipSort>;
  node?: InputMaybe<GenericSort>;
};

export type ScenarioActionGenericsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionGenericsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionGenericsConnectionWhere>>;
  edge?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  node?: InputMaybe<GenericWhere>;
};

export type ScenarioActionGenericsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionGenericsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionGenericsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionGenericsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionGenericsNodeAggregationWhereInput>>;
};

export type ScenarioActionGenericsRelationship = ActionPrescriptionRelationship & {
  __typename?: 'ScenarioActionGenericsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioActionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScenarioActionSort objects to sort ScenarioActions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScenarioActionSort>>;
};

export type ScenarioActionScenarioAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionScenarioAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionScenarioAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionScenarioAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionScenarioNodeAggregationWhereInput>;
};

export type ScenarioActionScenarioConnection = {
  __typename?: 'ScenarioActionScenarioConnection';
  edges: Array<ScenarioActionScenarioRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionScenarioConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type ScenarioActionScenarioConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionScenarioConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionScenarioConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type ScenarioActionScenarioNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionScenarioNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionScenarioNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionScenarioNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionScenarioRelationship = {
  __typename?: 'ScenarioActionScenarioRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type ScenarioActionScenarioScenarioAggregationSelection = {
  __typename?: 'ScenarioActionScenarioScenarioAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionScenarioScenarioNodeAggregateSelection>;
};

export type ScenarioActionScenarioScenarioNodeAggregateSelection = {
  __typename?: 'ScenarioActionScenarioScenarioNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

/** Fields to sort ScenarioActions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioActionSort object. */
export type ScenarioActionSort = {
  actionLogicalOperator?: InputMaybe<SortDirection>;
  actionSet?: InputMaybe<SortDirection>;
  actionType?: InputMaybe<SortDirection>;
  combinedItemTimeframeEnd?: InputMaybe<SortDirection>;
  combinedItemTimeframeRangeType?: InputMaybe<SortDirection>;
  combinedItemTimeframeStart?: InputMaybe<SortDirection>;
  endItemNumber?: InputMaybe<SortDirection>;
  entityPriceType?: InputMaybe<SortDirection>;
  ingredientEndItemNumber?: InputMaybe<SortDirection>;
  ingredientRangeType?: InputMaybe<SortDirection>;
  ingredientStartItemNumber?: InputMaybe<SortDirection>;
  isAdHocDiscount?: InputMaybe<SortDirection>;
  isCombinedScenarioRelevantDrugsActive?: InputMaybe<SortDirection>;
  isNamedTimeRangeUsed?: InputMaybe<SortDirection>;
  isScenarioRelevantDrugsActive?: InputMaybe<SortDirection>;
  isSortedByPackOrder?: InputMaybe<SortDirection>;
  itemCombinationRelation?: InputMaybe<SortDirection>;
  itemCombinationRule?: InputMaybe<SortDirection>;
  itemRangeType?: InputMaybe<SortDirection>;
  itemScope?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  packOptionType?: InputMaybe<SortDirection>;
  priceType?: InputMaybe<SortDirection>;
  recordNature?: InputMaybe<SortDirection>;
  rollingRangeType?: InputMaybe<SortDirection>;
  startItemNumber?: InputMaybe<SortDirection>;
  startingPoint?: InputMaybe<SortDirection>;
  timeframeEnd?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeRelation?: InputMaybe<SortDirection>;
  timeframeStart?: InputMaybe<SortDirection>;
  uoMType?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection = {
  __typename?: 'ScenarioActionTreatmentCombinedItemTreatmentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection>;
};

export type ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection = {
  __typename?: 'ScenarioActionTreatmentCombinedItemTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type ScenarioActionTreatmentTreatmentsAggregationSelection = {
  __typename?: 'ScenarioActionTreatmentTreatmentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<ScenarioActionTreatmentTreatmentsEdgeAggregateSelection>;
  node?: Maybe<ScenarioActionTreatmentTreatmentsNodeAggregateSelection>;
};

export type ScenarioActionTreatmentTreatmentsEdgeAggregateSelection = {
  __typename?: 'ScenarioActionTreatmentTreatmentsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type ScenarioActionTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'ScenarioActionTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type ScenarioActionTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<ScenarioActionTreatmentsEdgeAggregationWhereInput>;
  node?: InputMaybe<ScenarioActionTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioActionTreatmentsConnection = {
  __typename?: 'ScenarioActionTreatmentsConnection';
  edges: Array<ScenarioActionTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionTreatmentsConnectionSort = {
  edge?: InputMaybe<ActionPrescriptionRelationshipSort>;
  node?: InputMaybe<TreatmentSort>;
};

export type ScenarioActionTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsConnectionWhere>>;
  edge?: InputMaybe<ActionPrescriptionRelationshipWhere>;
  node?: InputMaybe<TreatmentWhere>;
};

export type ScenarioActionTreatmentsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionTreatmentsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ScenarioActionTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioActionTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioActionTreatmentsRelationship = ActionPrescriptionRelationship & {
  __typename?: 'ScenarioActionTreatmentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
  order?: Maybe<Scalars['Int']['output']>;
};

export type ScenarioActionWhere = {
  AND?: InputMaybe<Array<ScenarioActionWhere>>;
  NOT?: InputMaybe<ScenarioActionWhere>;
  OR?: InputMaybe<Array<ScenarioActionWhere>>;
  actionLogicalOperator?: InputMaybe<ActionLogicalOperator>;
  actionLogicalOperator_IN?: InputMaybe<Array<InputMaybe<ActionLogicalOperator>>>;
  actionSet?: InputMaybe<Scalars['Int']['input']>;
  actionSet_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  actionSet_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionType?: InputMaybe<ActionType>;
  actionType_IN?: InputMaybe<Array<ActionType>>;
  adHocPriceTypes?: InputMaybe<Array<PriceType>>;
  adHocPriceTypes_INCLUDES?: InputMaybe<PriceType>;
  brandsAggregate?: InputMaybe<ScenarioActionBrandsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_ALL?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_NONE?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_SINGLE?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionBrandsConnections match this filter */
  brandsConnection_SOME?: InputMaybe<ScenarioActionBrandsConnectionWhere>;
  /** Return ScenarioActions where all of the related Brands match this filter */
  brands_ALL?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where none of the related Brands match this filter */
  brands_NONE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where one of the related Brands match this filter */
  brands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where some of the related Brands match this filter */
  brands_SOME?: InputMaybe<BrandWhere>;
  combinedItemBrandsAggregate?: InputMaybe<ScenarioActionCombinedItemBrandsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_ALL?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_NONE?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_SINGLE?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionCombinedItemBrandsConnections match this filter */
  combinedItemBrandsConnection_SOME?: InputMaybe<ScenarioActionCombinedItemBrandsConnectionWhere>;
  /** Return ScenarioActions where all of the related Brands match this filter */
  combinedItemBrands_ALL?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where none of the related Brands match this filter */
  combinedItemBrands_NONE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where one of the related Brands match this filter */
  combinedItemBrands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return ScenarioActions where some of the related Brands match this filter */
  combinedItemBrands_SOME?: InputMaybe<BrandWhere>;
  combinedItemGenericsAggregate?: InputMaybe<ScenarioActionCombinedItemGenericsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_ALL?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_NONE?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_SINGLE?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionCombinedItemGenericsConnections match this filter */
  combinedItemGenericsConnection_SOME?: InputMaybe<ScenarioActionCombinedItemGenericsConnectionWhere>;
  /** Return ScenarioActions where all of the related Generics match this filter */
  combinedItemGenerics_ALL?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where none of the related Generics match this filter */
  combinedItemGenerics_NONE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where one of the related Generics match this filter */
  combinedItemGenerics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where some of the related Generics match this filter */
  combinedItemGenerics_SOME?: InputMaybe<GenericWhere>;
  combinedItemTimeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  combinedItemTimeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
  combinedItemTimeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  combinedItemTimeframeStart?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  combinedItemTimeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTreatmentsAggregate?: InputMaybe<ScenarioActionCombinedItemTreatmentsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_ALL?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_NONE?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_SINGLE?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionCombinedItemTreatmentsConnections match this filter */
  combinedItemTreatmentsConnection_SOME?: InputMaybe<ScenarioActionCombinedItemTreatmentsConnectionWhere>;
  /** Return ScenarioActions where all of the related Treatments match this filter */
  combinedItemTreatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where none of the related Treatments match this filter */
  combinedItemTreatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where one of the related Treatments match this filter */
  combinedItemTreatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where some of the related Treatments match this filter */
  combinedItemTreatments_SOME?: InputMaybe<TreatmentWhere>;
  cycle?: InputMaybe<CycleConfigurationWhere>;
  cycleAggregate?: InputMaybe<ScenarioActionCycleAggregateInput>;
  cycleConnection?: InputMaybe<ScenarioActionCycleConnectionWhere>;
  cycleConnection_NOT?: InputMaybe<ScenarioActionCycleConnectionWhere>;
  cycle_NOT?: InputMaybe<CycleConfigurationWhere>;
  endItemNumber?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endItemNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  entityPriceType?: InputMaybe<EntityPriceType>;
  entityPriceType_IN?: InputMaybe<Array<InputMaybe<EntityPriceType>>>;
  genericsAggregate?: InputMaybe<ScenarioActionGenericsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_ALL?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_NONE?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_SINGLE?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionGenericsConnections match this filter */
  genericsConnection_SOME?: InputMaybe<ScenarioActionGenericsConnectionWhere>;
  /** Return ScenarioActions where all of the related Generics match this filter */
  generics_ALL?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where none of the related Generics match this filter */
  generics_NONE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where one of the related Generics match this filter */
  generics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return ScenarioActions where some of the related Generics match this filter */
  generics_SOME?: InputMaybe<GenericWhere>;
  ingredientEndItemNumber?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ingredientEndItemNumber_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientRangeType?: InputMaybe<ActionItemRangeType>;
  ingredientRangeType_IN?: InputMaybe<Array<InputMaybe<ActionItemRangeType>>>;
  ingredientStartItemNumber?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ingredientStartItemNumber_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_LTE?: InputMaybe<Scalars['Float']['input']>;
  isAdHocDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  isCombinedScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNamedTimeRangeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSortedByPackOrder?: InputMaybe<Scalars['Boolean']['input']>;
  itemCombinationRelation?: InputMaybe<ActionItemCombinationRelation>;
  itemCombinationRelation_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRelation>>>;
  itemCombinationRule?: InputMaybe<ActionItemCombinationRule>;
  itemCombinationRule_IN?: InputMaybe<Array<InputMaybe<ActionItemCombinationRule>>>;
  itemRangeType?: InputMaybe<ActionItemRangeType>;
  itemRangeType_IN?: InputMaybe<Array<InputMaybe<ActionItemRangeType>>>;
  itemScope?: InputMaybe<ItemScope>;
  itemScope_IN?: InputMaybe<Array<ItemScope>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  packOptionType?: InputMaybe<PackOptionType>;
  packOptionType_IN?: InputMaybe<Array<InputMaybe<PackOptionType>>>;
  priceType?: InputMaybe<PriceType>;
  priceType_IN?: InputMaybe<Array<InputMaybe<PriceType>>>;
  recordNature?: InputMaybe<RecordNature>;
  recordNature_IN?: InputMaybe<Array<InputMaybe<RecordNature>>>;
  rollingRangeType?: InputMaybe<RollingRangeType>;
  rollingRangeType_IN?: InputMaybe<Array<InputMaybe<RollingRangeType>>>;
  scenario?: InputMaybe<ScenarioWhere>;
  scenarioAggregate?: InputMaybe<ScenarioActionScenarioAggregateInput>;
  scenarioConnection?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
  scenarioConnection_NOT?: InputMaybe<ScenarioActionScenarioConnectionWhere>;
  scenario_NOT?: InputMaybe<ScenarioWhere>;
  startItemNumber?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startItemNumber_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_LTE?: InputMaybe<Scalars['Int']['input']>;
  startingPoint?: InputMaybe<TimeframeStartingPoint>;
  startingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeRelation?: InputMaybe<TimeframeRelation>;
  timeframeRelation_IN?: InputMaybe<Array<InputMaybe<TimeframeRelation>>>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatmentsAggregate?: InputMaybe<ScenarioActionTreatmentsAggregateInput>;
  /** Return ScenarioActions where all of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where none of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where one of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where some of the related ScenarioActionTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<ScenarioActionTreatmentsConnectionWhere>;
  /** Return ScenarioActions where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioActions where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
  uoMType?: InputMaybe<UoMType>;
  uoMType_IN?: InputMaybe<Array<InputMaybe<UoMType>>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioActionsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioActionsAggregateInput>>;
  NOT?: InputMaybe<ScenarioActionsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioActionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioActionsNodeAggregationWhereInput>;
};

export type ScenarioActionsConnection = {
  __typename?: 'ScenarioActionsConnection';
  edges: Array<ScenarioActionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioActionsConnectionSort = {
  node?: InputMaybe<ScenarioActionSort>;
};

export type ScenarioActionsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioActionsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioActionsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioActionsConnectionWhere>>;
  node?: InputMaybe<ScenarioActionWhere>;
};

export type ScenarioActionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioActionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioActionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioActionsNodeAggregationWhereInput>>;
  actionSet_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  actionSet_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  actionSet_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  actionSet_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  combinedItemTimeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  combinedItemTimeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  endItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  endItemNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  ingredientEndItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientEndItemNumber_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  ingredientStartItemNumber_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  startItemNumber_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  startItemNumber_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioActionsRelationship = {
  __typename?: 'ScenarioActionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ScenarioAction;
};

export type ScenarioAggregateSelection = {
  __typename?: 'ScenarioAggregateSelection';
  count: Scalars['Int']['output'];
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type ScenarioAgreementAggregateInput = {
  AND?: InputMaybe<Array<ScenarioAgreementAggregateInput>>;
  NOT?: InputMaybe<ScenarioAgreementAggregateInput>;
  OR?: InputMaybe<Array<ScenarioAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioAgreementNodeAggregationWhereInput>;
};

export type ScenarioAgreementConnection = {
  __typename?: 'ScenarioAgreementConnection';
  edges: Array<ScenarioAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioAgreementConnectionSort = {
  node?: InputMaybe<BaseAgreementSort>;
};

export type ScenarioAgreementConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioAgreementConnectionWhere>>;
  NOT?: InputMaybe<ScenarioAgreementConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioAgreementConnectionWhere>>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type ScenarioAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioAgreementNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioAgreementRelationship = {
  __typename?: 'ScenarioAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: BaseAgreement;
};

export type ScenarioBaseAgreementAgreementAggregationSelection = {
  __typename?: 'ScenarioBaseAgreementAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioBaseAgreementAgreementNodeAggregateSelection>;
};

export type ScenarioBaseAgreementAgreementNodeAggregateSelection = {
  __typename?: 'ScenarioBaseAgreementAgreementNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type ScenarioCondition = ITimeframe & ITreatmentCondition & {
  __typename?: 'ScenarioCondition';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  adverseEvents?: Maybe<Array<AdverseEventType>>;
  amountOfThresholdBasis?: Maybe<AmountOfThresholdBasis>;
  article71Status?: Maybe<Article71Status>;
  bothOperatorFirst?: Maybe<ArithmeticalOperator>;
  bothOperatorSecond?: Maybe<ArithmeticalOperator>;
  brands: Array<Brand>;
  brandsAggregate?: Maybe<ScenarioConditionBrandBrandsAggregationSelection>;
  brandsConnection: ScenarioConditionBrandsConnection;
  comparedCountdownPoint?: Maybe<CountdownPoint>;
  comparedStartingPoint?: Maybe<TimeframeStartingPoint>;
  comparedTimeframeEnd?: Maybe<Scalars['Int']['output']>;
  comparedTimeframeRangeType?: Maybe<TimeframeRangeType>;
  comparedTimeframeRelation?: Maybe<TimeframeRelation>;
  comparedTimeframeStart?: Maybe<Scalars['Int']['output']>;
  conditionStatus?: Maybe<Array<OutcomeBasedStatus>>;
  conditionType: ConditionType;
  consideredRating?: Maybe<ConditionConsideredRating>;
  consideredSecInterventionRate?: Maybe<ConditionConsideredSecIntervention>;
  countdownPoint?: Maybe<CountdownPoint>;
  customCondition?: Maybe<CustomCondition>;
  customConditionAggregate?: Maybe<ScenarioConditionCustomConditionCustomConditionAggregationSelection>;
  customConditionConnection: ScenarioConditionCustomConditionConnection;
  deltaType?: Maybe<DeltaType>;
  discontinuationReason?: Maybe<TreatmentDiscontinuationReason>;
  endRangeValue?: Maybe<Scalars['Float']['output']>;
  eventCategory?: Maybe<Scalars['String']['output']>;
  eventFrequency?: Maybe<CustomConditionEventFrequency>;
  eventResult?: Maybe<CustomConditionEventResult>;
  eventSubCategories?: Maybe<Array<Scalars['String']['output']>>;
  eventType?: Maybe<CustomConditionEventType>;
  generics: Array<Generic>;
  genericsAggregate?: Maybe<ScenarioConditionGenericGenericsAggregationSelection>;
  genericsConnection: ScenarioConditionGenericsConnection;
  grades?: Maybe<Array<AdverseEventGrades>>;
  intervention?: Maybe<InterventionType>;
  interventionOccurrence?: Maybe<InterventionOccurrence>;
  isNamedTimeRangeUsed?: Maybe<Scalars['Boolean']['output']>;
  isScenarioRelevantDrugsActive?: Maybe<Scalars['Boolean']['output']>;
  monitoringType?: Maybe<MonitoringType>;
  occurence?: Maybe<Occurrence>;
  operator?: Maybe<ArithmeticalOperator>;
  order: Scalars['Int']['output'];
  patentStatus?: Maybe<PatentStatus>;
  patientScope?: Maybe<PatientScope>;
  reintervention?: Maybe<Reintervention>;
  responseInclusionType?: Maybe<ResponseInclusionType>;
  responseType?: Maybe<UnitedResponseType>;
  rollingRangeType?: Maybe<RollingRangeType>;
  scenario: Scenario;
  scenarioAggregate?: Maybe<ScenarioConditionScenarioScenarioAggregationSelection>;
  scenarioConnection: ScenarioConditionScenarioConnection;
  startingPoint?: Maybe<TimeframeStartingPoint>;
  timeframeEnd?: Maybe<Scalars['Int']['output']>;
  timeframeRangeType?: Maybe<TimeframeRangeType>;
  timeframeRelation?: Maybe<TimeframeRelation>;
  timeframeStart?: Maybe<Scalars['Int']['output']>;
  treatmentDurationAspect?: Maybe<TreatmentDurationConditionAspect>;
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<ScenarioConditionTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: ScenarioConditionTreatmentsConnection;
  uoMType?: Maybe<UoMType>;
  value?: Maybe<Scalars['Float']['output']>;
};


export type ScenarioConditionBrandsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BrandOptions>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioConditionBrandsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BrandWhere>;
};


export type ScenarioConditionBrandsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionBrandsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
};


export type ScenarioConditionCustomConditionArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CustomConditionOptions>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type ScenarioConditionCustomConditionAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CustomConditionWhere>;
};


export type ScenarioConditionCustomConditionConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionCustomConditionConnectionSort>>;
  where?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
};


export type ScenarioConditionGenericsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioConditionGenericsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type ScenarioConditionGenericsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionGenericsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
};


export type ScenarioConditionScenarioArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioConditionScenarioAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type ScenarioConditionScenarioConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionScenarioConnectionSort>>;
  where?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
};


export type ScenarioConditionTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioConditionTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type ScenarioConditionTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ScenarioConditionTreatmentsConnectionSort>>;
  where?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
};

export type ScenarioConditionAggregateSelection = {
  __typename?: 'ScenarioConditionAggregateSelection';
  comparedTimeframeEnd: IntAggregateSelectionNullable;
  comparedTimeframeStart: IntAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  endRangeValue: FloatAggregateSelectionNullable;
  eventCategory: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

export type ScenarioConditionBrandBrandsAggregationSelection = {
  __typename?: 'ScenarioConditionBrandBrandsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionBrandBrandsNodeAggregateSelection>;
};

export type ScenarioConditionBrandBrandsNodeAggregateSelection = {
  __typename?: 'ScenarioConditionBrandBrandsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  art71DataLastUpdatedByEmail: StringAggregateSelectionNullable;
  art71DataLastUpdatedOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioConditionBrandsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionBrandsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionBrandsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionBrandsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionBrandsNodeAggregationWhereInput>;
};

export type ScenarioConditionBrandsConnection = {
  __typename?: 'ScenarioConditionBrandsConnection';
  edges: Array<ScenarioConditionBrandsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionBrandsConnectionSort = {
  node?: InputMaybe<BrandSort>;
};

export type ScenarioConditionBrandsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionBrandsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionBrandsConnectionWhere>>;
  node?: InputMaybe<BrandWhere>;
};

export type ScenarioConditionBrandsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionBrandsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionBrandsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioConditionBrandsNodeAggregationWhereInput>>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  art71DataLastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  art71DataLastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScenarioConditionBrandsRelationship = {
  __typename?: 'ScenarioConditionBrandsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Brand;
};

export type ScenarioConditionCustomConditionAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionCustomConditionAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionCustomConditionAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionCustomConditionAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionCustomConditionNodeAggregationWhereInput>;
};

export type ScenarioConditionCustomConditionConnection = {
  __typename?: 'ScenarioConditionCustomConditionConnection';
  edges: Array<ScenarioConditionCustomConditionRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionCustomConditionConnectionSort = {
  node?: InputMaybe<CustomConditionSort>;
};

export type ScenarioConditionCustomConditionConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionCustomConditionConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionCustomConditionConnectionWhere>>;
  node?: InputMaybe<CustomConditionWhere>;
};

export type ScenarioConditionCustomConditionCustomConditionAggregationSelection = {
  __typename?: 'ScenarioConditionCustomConditionCustomConditionAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection>;
};

export type ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection = {
  __typename?: 'ScenarioConditionCustomConditionCustomConditionNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  description: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type ScenarioConditionCustomConditionNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionCustomConditionNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionCustomConditionNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioConditionCustomConditionNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioConditionCustomConditionRelationship = {
  __typename?: 'ScenarioConditionCustomConditionRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: CustomCondition;
};

export type ScenarioConditionEdge = {
  __typename?: 'ScenarioConditionEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ScenarioCondition;
};

export type ScenarioConditionGenericGenericsAggregationSelection = {
  __typename?: 'ScenarioConditionGenericGenericsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionGenericGenericsNodeAggregateSelection>;
};

export type ScenarioConditionGenericGenericsNodeAggregateSelection = {
  __typename?: 'ScenarioConditionGenericGenericsNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type ScenarioConditionGenericsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionGenericsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionGenericsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionGenericsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionGenericsNodeAggregationWhereInput>;
};

export type ScenarioConditionGenericsConnection = {
  __typename?: 'ScenarioConditionGenericsConnection';
  edges: Array<ScenarioConditionGenericsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionGenericsConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type ScenarioConditionGenericsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionGenericsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionGenericsConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type ScenarioConditionGenericsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionGenericsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionGenericsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioConditionGenericsNodeAggregationWhereInput>>;
};

export type ScenarioConditionGenericsRelationship = {
  __typename?: 'ScenarioConditionGenericsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type ScenarioConditionOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScenarioConditionSort objects to sort ScenarioConditions by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScenarioConditionSort>>;
};

export type ScenarioConditionScenarioAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionScenarioAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionScenarioAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionScenarioAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionScenarioNodeAggregationWhereInput>;
};

export type ScenarioConditionScenarioConnection = {
  __typename?: 'ScenarioConditionScenarioConnection';
  edges: Array<ScenarioConditionScenarioRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionScenarioConnectionSort = {
  node?: InputMaybe<ScenarioSort>;
};

export type ScenarioConditionScenarioConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionScenarioConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionScenarioConnectionWhere>>;
  node?: InputMaybe<ScenarioWhere>;
};

export type ScenarioConditionScenarioNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionScenarioNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionScenarioNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioConditionScenarioNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioConditionScenarioRelationship = {
  __typename?: 'ScenarioConditionScenarioRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type ScenarioConditionScenarioScenarioAggregationSelection = {
  __typename?: 'ScenarioConditionScenarioScenarioAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionScenarioScenarioNodeAggregateSelection>;
};

export type ScenarioConditionScenarioScenarioNodeAggregateSelection = {
  __typename?: 'ScenarioConditionScenarioScenarioNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

/** Fields to sort ScenarioConditions by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioConditionSort object. */
export type ScenarioConditionSort = {
  amountOfThresholdBasis?: InputMaybe<SortDirection>;
  article71Status?: InputMaybe<SortDirection>;
  bothOperatorFirst?: InputMaybe<SortDirection>;
  bothOperatorSecond?: InputMaybe<SortDirection>;
  comparedCountdownPoint?: InputMaybe<SortDirection>;
  comparedStartingPoint?: InputMaybe<SortDirection>;
  comparedTimeframeEnd?: InputMaybe<SortDirection>;
  comparedTimeframeRangeType?: InputMaybe<SortDirection>;
  comparedTimeframeRelation?: InputMaybe<SortDirection>;
  comparedTimeframeStart?: InputMaybe<SortDirection>;
  conditionType?: InputMaybe<SortDirection>;
  consideredRating?: InputMaybe<SortDirection>;
  consideredSecInterventionRate?: InputMaybe<SortDirection>;
  countdownPoint?: InputMaybe<SortDirection>;
  deltaType?: InputMaybe<SortDirection>;
  discontinuationReason?: InputMaybe<SortDirection>;
  endRangeValue?: InputMaybe<SortDirection>;
  eventCategory?: InputMaybe<SortDirection>;
  eventFrequency?: InputMaybe<SortDirection>;
  eventResult?: InputMaybe<SortDirection>;
  eventType?: InputMaybe<SortDirection>;
  intervention?: InputMaybe<SortDirection>;
  interventionOccurrence?: InputMaybe<SortDirection>;
  isNamedTimeRangeUsed?: InputMaybe<SortDirection>;
  isScenarioRelevantDrugsActive?: InputMaybe<SortDirection>;
  monitoringType?: InputMaybe<SortDirection>;
  occurence?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
  patentStatus?: InputMaybe<SortDirection>;
  patientScope?: InputMaybe<SortDirection>;
  reintervention?: InputMaybe<SortDirection>;
  responseInclusionType?: InputMaybe<SortDirection>;
  responseType?: InputMaybe<SortDirection>;
  rollingRangeType?: InputMaybe<SortDirection>;
  startingPoint?: InputMaybe<SortDirection>;
  timeframeEnd?: InputMaybe<SortDirection>;
  timeframeRangeType?: InputMaybe<SortDirection>;
  timeframeRelation?: InputMaybe<SortDirection>;
  timeframeStart?: InputMaybe<SortDirection>;
  treatmentDurationAspect?: InputMaybe<SortDirection>;
  uoMType?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type ScenarioConditionTreatmentTreatmentsAggregationSelection = {
  __typename?: 'ScenarioConditionTreatmentTreatmentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioConditionTreatmentTreatmentsNodeAggregateSelection>;
};

export type ScenarioConditionTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'ScenarioConditionTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type ScenarioConditionTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionTreatmentsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionTreatmentsNodeAggregationWhereInput>;
};

export type ScenarioConditionTreatmentsConnection = {
  __typename?: 'ScenarioConditionTreatmentsConnection';
  edges: Array<ScenarioConditionTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type ScenarioConditionTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type ScenarioConditionTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<ScenarioConditionTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<ScenarioConditionTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenarioConditionTreatmentsRelationship = {
  __typename?: 'ScenarioConditionTreatmentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type ScenarioConditionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionWhere>>;
  NOT?: InputMaybe<ScenarioConditionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionWhere>>;
  adverseEvents?: InputMaybe<Array<AdverseEventType>>;
  adverseEvents_INCLUDES?: InputMaybe<AdverseEventType>;
  amountOfThresholdBasis?: InputMaybe<AmountOfThresholdBasis>;
  amountOfThresholdBasis_IN?: InputMaybe<Array<InputMaybe<AmountOfThresholdBasis>>>;
  article71Status?: InputMaybe<Article71Status>;
  article71Status_IN?: InputMaybe<Array<InputMaybe<Article71Status>>>;
  bothOperatorFirst?: InputMaybe<ArithmeticalOperator>;
  bothOperatorFirst_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  bothOperatorSecond?: InputMaybe<ArithmeticalOperator>;
  bothOperatorSecond_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  brandsAggregate?: InputMaybe<ScenarioConditionBrandsAggregateInput>;
  /** Return ScenarioConditions where all of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_ALL?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where none of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_NONE?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where one of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_SINGLE?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where some of the related ScenarioConditionBrandsConnections match this filter */
  brandsConnection_SOME?: InputMaybe<ScenarioConditionBrandsConnectionWhere>;
  /** Return ScenarioConditions where all of the related Brands match this filter */
  brands_ALL?: InputMaybe<BrandWhere>;
  /** Return ScenarioConditions where none of the related Brands match this filter */
  brands_NONE?: InputMaybe<BrandWhere>;
  /** Return ScenarioConditions where one of the related Brands match this filter */
  brands_SINGLE?: InputMaybe<BrandWhere>;
  /** Return ScenarioConditions where some of the related Brands match this filter */
  brands_SOME?: InputMaybe<BrandWhere>;
  comparedCountdownPoint?: InputMaybe<CountdownPoint>;
  comparedCountdownPoint_IN?: InputMaybe<Array<InputMaybe<CountdownPoint>>>;
  comparedStartingPoint?: InputMaybe<TimeframeStartingPoint>;
  comparedStartingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  comparedTimeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  comparedTimeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeRangeType?: InputMaybe<TimeframeRangeType>;
  comparedTimeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  comparedTimeframeRelation?: InputMaybe<TimeframeRelation>;
  comparedTimeframeRelation_IN?: InputMaybe<Array<InputMaybe<TimeframeRelation>>>;
  comparedTimeframeStart?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  comparedTimeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  conditionStatus?: InputMaybe<Array<OutcomeBasedStatus>>;
  conditionStatus_INCLUDES?: InputMaybe<OutcomeBasedStatus>;
  conditionType?: InputMaybe<ConditionType>;
  conditionType_IN?: InputMaybe<Array<ConditionType>>;
  consideredRating?: InputMaybe<ConditionConsideredRating>;
  consideredRating_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredRating>>>;
  consideredSecInterventionRate?: InputMaybe<ConditionConsideredSecIntervention>;
  consideredSecInterventionRate_IN?: InputMaybe<Array<InputMaybe<ConditionConsideredSecIntervention>>>;
  countdownPoint?: InputMaybe<CountdownPoint>;
  countdownPoint_IN?: InputMaybe<Array<InputMaybe<CountdownPoint>>>;
  customCondition?: InputMaybe<CustomConditionWhere>;
  customConditionAggregate?: InputMaybe<ScenarioConditionCustomConditionAggregateInput>;
  customConditionConnection?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
  customConditionConnection_NOT?: InputMaybe<ScenarioConditionCustomConditionConnectionWhere>;
  customCondition_NOT?: InputMaybe<CustomConditionWhere>;
  deltaType?: InputMaybe<DeltaType>;
  deltaType_IN?: InputMaybe<Array<InputMaybe<DeltaType>>>;
  discontinuationReason?: InputMaybe<TreatmentDiscontinuationReason>;
  discontinuationReason_IN?: InputMaybe<Array<InputMaybe<TreatmentDiscontinuationReason>>>;
  endRangeValue?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  endRangeValue_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory?: InputMaybe<Scalars['String']['input']>;
  eventCategory_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  eventCategory_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  eventCategory_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventCategory_MATCHES?: InputMaybe<Scalars['String']['input']>;
  eventCategory_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  eventFrequency?: InputMaybe<CustomConditionEventFrequency>;
  eventFrequency_IN?: InputMaybe<Array<InputMaybe<CustomConditionEventFrequency>>>;
  eventResult?: InputMaybe<CustomConditionEventResult>;
  eventResult_IN?: InputMaybe<Array<InputMaybe<CustomConditionEventResult>>>;
  eventSubCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  eventSubCategories_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<CustomConditionEventType>;
  eventType_IN?: InputMaybe<Array<InputMaybe<CustomConditionEventType>>>;
  genericsAggregate?: InputMaybe<ScenarioConditionGenericsAggregateInput>;
  /** Return ScenarioConditions where all of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_ALL?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where none of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_NONE?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where one of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_SINGLE?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where some of the related ScenarioConditionGenericsConnections match this filter */
  genericsConnection_SOME?: InputMaybe<ScenarioConditionGenericsConnectionWhere>;
  /** Return ScenarioConditions where all of the related Generics match this filter */
  generics_ALL?: InputMaybe<GenericWhere>;
  /** Return ScenarioConditions where none of the related Generics match this filter */
  generics_NONE?: InputMaybe<GenericWhere>;
  /** Return ScenarioConditions where one of the related Generics match this filter */
  generics_SINGLE?: InputMaybe<GenericWhere>;
  /** Return ScenarioConditions where some of the related Generics match this filter */
  generics_SOME?: InputMaybe<GenericWhere>;
  grades?: InputMaybe<Array<AdverseEventGrades>>;
  grades_INCLUDES?: InputMaybe<AdverseEventGrades>;
  intervention?: InputMaybe<InterventionType>;
  interventionOccurrence?: InputMaybe<InterventionOccurrence>;
  interventionOccurrence_IN?: InputMaybe<Array<InputMaybe<InterventionOccurrence>>>;
  intervention_IN?: InputMaybe<Array<InputMaybe<InterventionType>>>;
  isNamedTimeRangeUsed?: InputMaybe<Scalars['Boolean']['input']>;
  isScenarioRelevantDrugsActive?: InputMaybe<Scalars['Boolean']['input']>;
  monitoringType?: InputMaybe<MonitoringType>;
  monitoringType_IN?: InputMaybe<Array<InputMaybe<MonitoringType>>>;
  occurence?: InputMaybe<Occurrence>;
  occurence_IN?: InputMaybe<Array<InputMaybe<Occurrence>>>;
  operator?: InputMaybe<ArithmeticalOperator>;
  operator_IN?: InputMaybe<Array<InputMaybe<ArithmeticalOperator>>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  patentStatus?: InputMaybe<PatentStatus>;
  patentStatus_IN?: InputMaybe<Array<InputMaybe<PatentStatus>>>;
  patientScope?: InputMaybe<PatientScope>;
  patientScope_IN?: InputMaybe<Array<InputMaybe<PatientScope>>>;
  reintervention?: InputMaybe<Reintervention>;
  reintervention_IN?: InputMaybe<Array<InputMaybe<Reintervention>>>;
  responseInclusionType?: InputMaybe<ResponseInclusionType>;
  responseInclusionType_IN?: InputMaybe<Array<InputMaybe<ResponseInclusionType>>>;
  responseType?: InputMaybe<UnitedResponseType>;
  responseType_IN?: InputMaybe<Array<InputMaybe<UnitedResponseType>>>;
  rollingRangeType?: InputMaybe<RollingRangeType>;
  rollingRangeType_IN?: InputMaybe<Array<InputMaybe<RollingRangeType>>>;
  scenario?: InputMaybe<ScenarioWhere>;
  scenarioAggregate?: InputMaybe<ScenarioConditionScenarioAggregateInput>;
  scenarioConnection?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
  scenarioConnection_NOT?: InputMaybe<ScenarioConditionScenarioConnectionWhere>;
  scenario_NOT?: InputMaybe<ScenarioWhere>;
  startingPoint?: InputMaybe<TimeframeStartingPoint>;
  startingPoint_IN?: InputMaybe<Array<InputMaybe<TimeframeStartingPoint>>>;
  timeframeEnd?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeEnd_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeRangeType?: InputMaybe<TimeframeRangeType>;
  timeframeRangeType_IN?: InputMaybe<Array<InputMaybe<TimeframeRangeType>>>;
  timeframeRelation?: InputMaybe<TimeframeRelation>;
  timeframeRelation_IN?: InputMaybe<Array<InputMaybe<TimeframeRelation>>>;
  timeframeStart?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timeframeStart_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_LTE?: InputMaybe<Scalars['Int']['input']>;
  treatmentDurationAspect?: InputMaybe<TreatmentDurationConditionAspect>;
  treatmentDurationAspect_IN?: InputMaybe<Array<InputMaybe<TreatmentDurationConditionAspect>>>;
  treatmentsAggregate?: InputMaybe<ScenarioConditionTreatmentsAggregateInput>;
  /** Return ScenarioConditions where all of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where none of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where one of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where some of the related ScenarioConditionTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<ScenarioConditionTreatmentsConnectionWhere>;
  /** Return ScenarioConditions where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioConditions where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioConditions where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return ScenarioConditions where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
  uoMType?: InputMaybe<UoMType>;
  uoMType_IN?: InputMaybe<Array<InputMaybe<UoMType>>>;
  value?: InputMaybe<Scalars['Float']['input']>;
  value_GT?: InputMaybe<Scalars['Float']['input']>;
  value_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  value_LT?: InputMaybe<Scalars['Float']['input']>;
  value_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioConditionsAggregateInput = {
  AND?: InputMaybe<Array<ScenarioConditionsAggregateInput>>;
  NOT?: InputMaybe<ScenarioConditionsAggregateInput>;
  OR?: InputMaybe<Array<ScenarioConditionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<ScenarioConditionsNodeAggregationWhereInput>;
};

export type ScenarioConditionsConnection = {
  __typename?: 'ScenarioConditionsConnection';
  edges: Array<ScenarioConditionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScenarioConditionsConnectionSort = {
  node?: InputMaybe<ScenarioConditionSort>;
};

export type ScenarioConditionsConnectionWhere = {
  AND?: InputMaybe<Array<ScenarioConditionsConnectionWhere>>;
  NOT?: InputMaybe<ScenarioConditionsConnectionWhere>;
  OR?: InputMaybe<Array<ScenarioConditionsConnectionWhere>>;
  node?: InputMaybe<ScenarioConditionWhere>;
};

export type ScenarioConditionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ScenarioConditionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<ScenarioConditionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<ScenarioConditionsNodeAggregationWhereInput>>;
  comparedTimeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  comparedTimeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  comparedTimeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  endRangeValue_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  endRangeValue_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  eventCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  eventCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeEnd_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeEnd_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeStart_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeStart_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type ScenarioConditionsRelationship = {
  __typename?: 'ScenarioConditionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ScenarioCondition;
};

export type ScenarioEdge = {
  __typename?: 'ScenarioEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Scenario;
};

export type ScenarioInsightsUserContext = {
  categoryInput?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  rebateObjective?: Maybe<Scalars['String']['output']>;
  timeframeLabel: Scalars['String']['output'];
};

export type ScenarioInsightsUserContextInput = {
  categoryInput?: InputMaybe<Scalars['String']['input']>;
  rebateObjective?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioInsightsUserContextSort = {
  categoryInput?: InputMaybe<SortDirection>;
  groups?: InputMaybe<SortDirection>;
  rebateObjective?: InputMaybe<SortDirection>;
  timeframeLabel?: InputMaybe<SortDirection>;
};

export type ScenarioInsightsUserContextWhere = {
  AND?: InputMaybe<Array<ScenarioInsightsUserContextWhere>>;
  NOT?: InputMaybe<ScenarioInsightsUserContextWhere>;
  OR?: InputMaybe<Array<ScenarioInsightsUserContextWhere>>;
  categoryInput?: InputMaybe<Scalars['String']['input']>;
  categoryInput_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  categoryInput_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  categoryInput_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryInput_MATCHES?: InputMaybe<Scalars['String']['input']>;
  categoryInput_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  groups_INCLUDES?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rebateObjective_MATCHES?: InputMaybe<Scalars['String']['input']>;
  rebateObjective_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  timeframeLabel_MATCHES?: InputMaybe<Scalars['String']['input']>;
  timeframeLabel_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type ScenarioOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScenarioSort objects to sort Scenarios by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScenarioSort>>;
};

export type ScenarioScenarioActionActionsAggregationSelection = {
  __typename?: 'ScenarioScenarioActionActionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioScenarioActionActionsNodeAggregateSelection>;
};

export type ScenarioScenarioActionActionsNodeAggregateSelection = {
  __typename?: 'ScenarioScenarioActionActionsNodeAggregateSelection';
  actionSet: IntAggregateSelectionNullable;
  combinedItemTimeframeEnd: IntAggregateSelectionNullable;
  combinedItemTimeframeStart: IntAggregateSelectionNullable;
  endItemNumber: IntAggregateSelectionNullable;
  ingredientEndItemNumber: FloatAggregateSelectionNullable;
  ingredientStartItemNumber: FloatAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  startItemNumber: IntAggregateSelectionNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

export type ScenarioScenarioConditionConditionsAggregationSelection = {
  __typename?: 'ScenarioScenarioConditionConditionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<ScenarioScenarioConditionConditionsNodeAggregateSelection>;
};

export type ScenarioScenarioConditionConditionsNodeAggregateSelection = {
  __typename?: 'ScenarioScenarioConditionConditionsNodeAggregateSelection';
  comparedTimeframeEnd: IntAggregateSelectionNullable;
  comparedTimeframeStart: IntAggregateSelectionNullable;
  endRangeValue: FloatAggregateSelectionNullable;
  eventCategory: StringAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
  timeframeEnd: IntAggregateSelectionNullable;
  timeframeStart: IntAggregateSelectionNullable;
  value: FloatAggregateSelectionNullable;
};

/** Fields to sort Scenarios by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScenarioSort object. */
export type ScenarioSort = {
  actionSets?: InputMaybe<SortDirection>;
  actionSetsOperator?: InputMaybe<SortDirection>;
  group?: InputMaybe<SortDirection>;
  hasMultipleBasePrices?: InputMaybe<SortDirection>;
  isGrouped?: InputMaybe<SortDirection>;
  isProRating?: InputMaybe<SortDirection>;
  isRelevantForArt71?: InputMaybe<SortDirection>;
  operator?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type ScenarioWhere = {
  AND?: InputMaybe<Array<ScenarioWhere>>;
  NOT?: InputMaybe<ScenarioWhere>;
  OR?: InputMaybe<Array<ScenarioWhere>>;
  actionSets?: InputMaybe<Scalars['Boolean']['input']>;
  actionSetsOperator?: InputMaybe<ActionSetsOperator>;
  actionSetsOperator_IN?: InputMaybe<Array<InputMaybe<ActionSetsOperator>>>;
  actionsAggregate?: InputMaybe<ScenarioActionsAggregateInput>;
  /** Return Scenarios where all of the related ScenarioActionsConnections match this filter */
  actionsConnection_ALL?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where none of the related ScenarioActionsConnections match this filter */
  actionsConnection_NONE?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where one of the related ScenarioActionsConnections match this filter */
  actionsConnection_SINGLE?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where some of the related ScenarioActionsConnections match this filter */
  actionsConnection_SOME?: InputMaybe<ScenarioActionsConnectionWhere>;
  /** Return Scenarios where all of the related ScenarioActions match this filter */
  actions_ALL?: InputMaybe<ScenarioActionWhere>;
  /** Return Scenarios where none of the related ScenarioActions match this filter */
  actions_NONE?: InputMaybe<ScenarioActionWhere>;
  /** Return Scenarios where one of the related ScenarioActions match this filter */
  actions_SINGLE?: InputMaybe<ScenarioActionWhere>;
  /** Return Scenarios where some of the related ScenarioActions match this filter */
  actions_SOME?: InputMaybe<ScenarioActionWhere>;
  agreement?: InputMaybe<BaseAgreementWhere>;
  agreementAggregate?: InputMaybe<ScenarioAgreementAggregateInput>;
  agreementConnection?: InputMaybe<ScenarioAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<ScenarioAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<BaseAgreementWhere>;
  conditionsAggregate?: InputMaybe<ScenarioConditionsAggregateInput>;
  /** Return Scenarios where all of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_ALL?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where none of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_NONE?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where one of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_SINGLE?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where some of the related ScenarioConditionsConnections match this filter */
  conditionsConnection_SOME?: InputMaybe<ScenarioConditionsConnectionWhere>;
  /** Return Scenarios where all of the related ScenarioConditions match this filter */
  conditions_ALL?: InputMaybe<ScenarioConditionWhere>;
  /** Return Scenarios where none of the related ScenarioConditions match this filter */
  conditions_NONE?: InputMaybe<ScenarioConditionWhere>;
  /** Return Scenarios where one of the related ScenarioConditions match this filter */
  conditions_SINGLE?: InputMaybe<ScenarioConditionWhere>;
  /** Return Scenarios where some of the related ScenarioConditions match this filter */
  conditions_SOME?: InputMaybe<ScenarioConditionWhere>;
  group?: InputMaybe<Scalars['Int']['input']>;
  group_GT?: InputMaybe<Scalars['Int']['input']>;
  group_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  group_LT?: InputMaybe<Scalars['Int']['input']>;
  group_LTE?: InputMaybe<Scalars['Int']['input']>;
  hasMultipleBasePrices?: InputMaybe<Scalars['Boolean']['input']>;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
  isProRating?: InputMaybe<Scalars['Boolean']['input']>;
  isRelevantForArt71?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<ConditionLogicalOperator>;
  operator_IN?: InputMaybe<Array<ConditionLogicalOperator>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type ScenariosConnection = {
  __typename?: 'ScenariosConnection';
  edges: Array<ScenarioEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ScheduledAgreementRun = {
  __typename?: 'ScheduledAgreementRun';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ScheduledAgreementRunAggregateSelection = {
  __typename?: 'ScheduledAgreementRunAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
};

export type ScheduledAgreementRunEdge = {
  __typename?: 'ScheduledAgreementRunEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ScheduledAgreementRun;
};

export type ScheduledAgreementRunOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more ScheduledAgreementRunSort objects to sort ScheduledAgreementRuns by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<ScheduledAgreementRunSort>>;
};

/** Fields to sort ScheduledAgreementRuns by. The order in which sorts are applied is not guaranteed when specifying many fields in one ScheduledAgreementRunSort object. */
export type ScheduledAgreementRunSort = {
  id?: InputMaybe<SortDirection>;
};

export type ScheduledAgreementRunWhere = {
  AND?: InputMaybe<Array<ScheduledAgreementRunWhere>>;
  NOT?: InputMaybe<ScheduledAgreementRunWhere>;
  OR?: InputMaybe<Array<ScheduledAgreementRunWhere>>;
  agreementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
};

export type ScheduledAgreementRunsConnection = {
  __typename?: 'ScheduledAgreementRunsConnection';
  edges: Array<ScheduledAgreementRunEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ScopeId {
  AdjuvantTherapies = 'ADJUVANT_THERAPIES',
  CarTTherapies = 'CAR_T_THERAPIES',
  CombinationTherapies = 'COMBINATION_THERAPIES',
  Pcsk9I = 'PCSK9I'
}

export type SearchUserEmailByNameInput = {
  invoiceId: Scalars['ID']['input'];
  searchString?: InputMaybe<Scalars['String']['input']>;
  targetTenantId?: InputMaybe<Scalars['String']['input']>;
};

export type SendDecisionsToSmartMipInput = {
  documentId: Scalars['ID']['input'];
};

export type SendDocumentForExternalReviewInput = {
  id: Scalars['ID']['input'];
  receiverEmail: Scalars['String']['input'];
  useCC?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendDocumentToSmartMipInput = {
  documentId: Scalars['ID']['input'];
};

export type SendDocumentToSmartMipResult = {
  __typename?: 'SendDocumentToSmartMipResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  smartMipReimbursementId: Scalars['String']['output'];
};

export type SendDocumentToSmartMipResultAggregateSelection = {
  __typename?: 'SendDocumentToSmartMipResultAggregateSelection';
  count: Scalars['Int']['output'];
  smartMipReimbursementId: StringAggregateSelectionNonNullable;
};

export type SendDocumentToSmartMipResultEdge = {
  __typename?: 'SendDocumentToSmartMipResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SendDocumentToSmartMipResult;
};

export type SendDocumentToSmartMipResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SendDocumentToSmartMipResultSort objects to sort SendDocumentToSmartMipResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SendDocumentToSmartMipResultSort>>;
};

/** Fields to sort SendDocumentToSmartMipResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one SendDocumentToSmartMipResultSort object. */
export type SendDocumentToSmartMipResultSort = {
  smartMipReimbursementId?: InputMaybe<SortDirection>;
};

export type SendDocumentToSmartMipResultWhere = {
  AND?: InputMaybe<Array<SendDocumentToSmartMipResultWhere>>;
  NOT?: InputMaybe<SendDocumentToSmartMipResultWhere>;
  OR?: InputMaybe<Array<SendDocumentToSmartMipResultWhere>>;
  smartMipReimbursementId?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  smartMipReimbursementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SendDocumentToSmartMipResultsConnection = {
  __typename?: 'SendDocumentToSmartMipResultsConnection';
  edges: Array<SendDocumentToSmartMipResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Simulation = {
  __typename?: 'Simulation';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  accessibleUsers: Array<User>;
  accessibleUsersAggregate?: Maybe<SimulationUserAccessibleUsersAggregationSelection>;
  accessibleUsersConnection: SimulationAccessibleUsersConnection;
  addedBy: User;
  addedByAggregate?: Maybe<SimulationUserAddedByAggregationSelection>;
  addedByConnection: SimulationAddedByConnection;
  blueprint?: Maybe<ProductBlueprint>;
  blueprintAggregate?: Maybe<SimulationProductBlueprintBlueprintAggregationSelection>;
  blueprintConnection: SimulationBlueprintConnection;
  businessCase?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  configuration: Scalars['String']['output'];
  counterparty?: Maybe<Scalars['String']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['DateTime']['output'];
  deletedByEmail?: Maybe<Scalars['String']['output']>;
  deletedOn?: Maybe<Scalars['DateTime']['output']>;
  domain: Domain;
  domainAggregate?: Maybe<SimulationDomainDomainAggregationSelection>;
  domainConnection: SimulationDomainConnection;
  domainName?: Maybe<Scalars['String']['output']>;
  formattedContent: Scalars['String']['output'];
  hasUnassignedBlueprint: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indications: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isSimulationComplete: Scalars['Boolean']['output'];
  lastUpdatedByEmail?: Maybe<Scalars['String']['output']>;
  lastUpdatedOn: Scalars['DateTime']['output'];
  lockedSections?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  product: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  simulationUserRole: SimulatorUserRole;
  status: SimulationSavedStatus;
  tenantId: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};


export type SimulationAccessibleUsersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAccessibleUsersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAccessibleUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationAccessibleUsersConnectionSort>>;
  where?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
};


export type SimulationAddedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAddedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type SimulationAddedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationAddedByConnectionSort>>;
  where?: InputMaybe<SimulationAddedByConnectionWhere>;
};


export type SimulationBlueprintArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ProductBlueprintOptions>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type SimulationBlueprintAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProductBlueprintWhere>;
};


export type SimulationBlueprintConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationBlueprintConnectionSort>>;
  where?: InputMaybe<SimulationBlueprintConnectionWhere>;
};


export type SimulationDomainArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type SimulationDomainAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type SimulationDomainConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SimulationDomainConnectionSort>>;
  where?: InputMaybe<SimulationDomainConnectionWhere>;
};

export type SimulationAccessibleUsersAggregateInput = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersAggregateInput>>;
  NOT?: InputMaybe<SimulationAccessibleUsersAggregateInput>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<SimulationAccessibleUsersEdgeAggregationWhereInput>;
  node?: InputMaybe<SimulationAccessibleUsersNodeAggregationWhereInput>;
};

export type SimulationAccessibleUsersConnection = {
  __typename?: 'SimulationAccessibleUsersConnection';
  edges: Array<SimulationAccessibleUsersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationAccessibleUsersConnectionSort = {
  edge?: InputMaybe<SimulatorUserRoleRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type SimulationAccessibleUsersConnectionWhere = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersConnectionWhere>>;
  NOT?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersConnectionWhere>>;
  edge?: InputMaybe<SimulatorUserRoleRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type SimulationAccessibleUsersEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationAccessibleUsersEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersEdgeAggregationWhereInput>>;
  grantedByUserId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  grantedByUserId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  grantedByUserId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationAccessibleUsersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationAccessibleUsersNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationAccessibleUsersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationAccessibleUsersNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationAccessibleUsersRelationship = SimulatorUserRoleRelationship & {
  __typename?: 'SimulationAccessibleUsersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  node: User;
  role: SimulatorUserRole;
};

export type SimulationAddedByAggregateInput = {
  AND?: InputMaybe<Array<SimulationAddedByAggregateInput>>;
  NOT?: InputMaybe<SimulationAddedByAggregateInput>;
  OR?: InputMaybe<Array<SimulationAddedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SimulationAddedByNodeAggregationWhereInput>;
};

export type SimulationAddedByConnection = {
  __typename?: 'SimulationAddedByConnection';
  edges: Array<SimulationAddedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationAddedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type SimulationAddedByConnectionWhere = {
  AND?: InputMaybe<Array<SimulationAddedByConnectionWhere>>;
  NOT?: InputMaybe<SimulationAddedByConnectionWhere>;
  OR?: InputMaybe<Array<SimulationAddedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type SimulationAddedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationAddedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationAddedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationAddedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationAddedByRelationship = {
  __typename?: 'SimulationAddedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type SimulationAggregateSelection = {
  __typename?: 'SimulationAggregateSelection';
  businessCase: StringAggregateSelectionNullable;
  comments: StringAggregateSelectionNullable;
  configuration: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  counterparty: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNullable;
  createdByName: StringAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  domainName: StringAggregateSelectionNullable;
  formattedContent: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  lastUpdatedByEmail: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNonNullable;
  lockedSections: StringAggregateSelectionNullable;
  model: StringAggregateSelectionNonNullable;
  product: StringAggregateSelectionNonNullable;
  shortName: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  version: IntAggregateSelectionNonNullable;
};

export type SimulationBlueprintAggregateInput = {
  AND?: InputMaybe<Array<SimulationBlueprintAggregateInput>>;
  NOT?: InputMaybe<SimulationBlueprintAggregateInput>;
  OR?: InputMaybe<Array<SimulationBlueprintAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SimulationBlueprintNodeAggregationWhereInput>;
};

export type SimulationBlueprintConnection = {
  __typename?: 'SimulationBlueprintConnection';
  edges: Array<SimulationBlueprintRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationBlueprintConnectionSort = {
  node?: InputMaybe<ProductBlueprintSort>;
};

export type SimulationBlueprintConnectionWhere = {
  AND?: InputMaybe<Array<SimulationBlueprintConnectionWhere>>;
  NOT?: InputMaybe<SimulationBlueprintConnectionWhere>;
  OR?: InputMaybe<Array<SimulationBlueprintConnectionWhere>>;
  node?: InputMaybe<ProductBlueprintWhere>;
};

export type SimulationBlueprintNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationBlueprintNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationBlueprintNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationBlueprintNodeAggregationWhereInput>>;
  addedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  addedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  addedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  addedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  addedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  addedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formValues_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formValues_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formValues_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formValues_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indication_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indication_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indication_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  indications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  indications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  indications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  productName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  productName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  productName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  publishedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  publishedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  updatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SimulationBlueprintRelationship = {
  __typename?: 'SimulationBlueprintRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ProductBlueprint;
};

export type SimulationBusinessCaseInput = {
  businessCase?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type SimulationCountResult = {
  __typename?: 'SimulationCountResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
};

export type SimulationCountResultAggregateSelection = {
  __typename?: 'SimulationCountResultAggregateSelection';
  count: IntAggregateSelectionNonNullable;
};

export type SimulationCountResultEdge = {
  __typename?: 'SimulationCountResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SimulationCountResult;
};

export type SimulationCountResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationCountResultSort objects to sort SimulationCountResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationCountResultSort>>;
};

/** Fields to sort SimulationCountResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationCountResultSort object. */
export type SimulationCountResultSort = {
  count?: InputMaybe<SortDirection>;
};

export type SimulationCountResultWhere = {
  AND?: InputMaybe<Array<SimulationCountResultWhere>>;
  NOT?: InputMaybe<SimulationCountResultWhere>;
  OR?: InputMaybe<Array<SimulationCountResultWhere>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationCountResultsConnection = {
  __typename?: 'SimulationCountResultsConnection';
  edges: Array<SimulationCountResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationDomainAggregateInput = {
  AND?: InputMaybe<Array<SimulationDomainAggregateInput>>;
  NOT?: InputMaybe<SimulationDomainAggregateInput>;
  OR?: InputMaybe<Array<SimulationDomainAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<SimulationDomainNodeAggregationWhereInput>;
};

export type SimulationDomainConnection = {
  __typename?: 'SimulationDomainConnection';
  edges: Array<SimulationDomainRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationDomainConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type SimulationDomainConnectionWhere = {
  AND?: InputMaybe<Array<SimulationDomainConnectionWhere>>;
  NOT?: InputMaybe<SimulationDomainConnectionWhere>;
  OR?: InputMaybe<Array<SimulationDomainConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type SimulationDomainDomainAggregationSelection = {
  __typename?: 'SimulationDomainDomainAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<SimulationDomainDomainNodeAggregateSelection>;
};

export type SimulationDomainDomainNodeAggregateSelection = {
  __typename?: 'SimulationDomainDomainNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type SimulationDomainNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<SimulationDomainNodeAggregationWhereInput>>;
  NOT?: InputMaybe<SimulationDomainNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<SimulationDomainNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationDomainRelationship = {
  __typename?: 'SimulationDomainRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type SimulationEdge = {
  __typename?: 'SimulationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Simulation;
};

export type SimulationInput = {
  blueprintId?: InputMaybe<Scalars['String']['input']>;
  businessCase?: InputMaybe<Scalars['String']['input']>;
  comments: Scalars['String']['input'];
  configuration: Scalars['String']['input'];
  counterparty?: InputMaybe<Scalars['String']['input']>;
  domainId: Scalars['String']['input'];
  indications: Scalars['String']['input'];
  isSimulationComplete: Scalars['Boolean']['input'];
  lockedSections?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  product: Scalars['String']['input'];
  shortName?: InputMaybe<Scalars['String']['input']>;
  status: SimulationSavedStatus;
};

export type SimulationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationSort objects to sort Simulations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationSort>>;
};

export type SimulationProductBlueprintBlueprintAggregationSelection = {
  __typename?: 'SimulationProductBlueprintBlueprintAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<SimulationProductBlueprintBlueprintNodeAggregateSelection>;
};

export type SimulationProductBlueprintBlueprintNodeAggregateSelection = {
  __typename?: 'SimulationProductBlueprintBlueprintNodeAggregateSelection';
  addedByName: StringAggregateSelectionNonNullable;
  addedOn: DateTimeAggregateSelectionNonNullable;
  formValues: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  indication: StringAggregateSelectionNonNullable;
  indications: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  productName: StringAggregateSelectionNonNullable;
  publishedOn: DateTimeAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  updatedOn: DateTimeAggregateSelectionNonNullable;
};

export type SimulationRoleInput = {
  newRole: SimulatorUserRole;
  simulationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export enum SimulationSavedStatus {
  Complete = 'COMPLETE',
  Draft = 'DRAFT'
}

/** Fields to sort Simulations by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationSort object. */
export type SimulationSort = {
  businessCase?: InputMaybe<SortDirection>;
  comments?: InputMaybe<SortDirection>;
  configuration?: InputMaybe<SortDirection>;
  counterparty?: InputMaybe<SortDirection>;
  createdByEmail?: InputMaybe<SortDirection>;
  createdByName?: InputMaybe<SortDirection>;
  createdOn?: InputMaybe<SortDirection>;
  deletedByEmail?: InputMaybe<SortDirection>;
  deletedOn?: InputMaybe<SortDirection>;
  domainName?: InputMaybe<SortDirection>;
  formattedContent?: InputMaybe<SortDirection>;
  hasUnassignedBlueprint?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  indications?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isSimulationComplete?: InputMaybe<SortDirection>;
  lastUpdatedByEmail?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  lockedSections?: InputMaybe<SortDirection>;
  model?: InputMaybe<SortDirection>;
  product?: InputMaybe<SortDirection>;
  shortName?: InputMaybe<SortDirection>;
  simulationUserRole?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
  version?: InputMaybe<SortDirection>;
};

export type SimulationUnitsInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  dosage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type SimulationUserAccessibleUsersAggregationSelection = {
  __typename?: 'SimulationUserAccessibleUsersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<SimulationUserAccessibleUsersEdgeAggregateSelection>;
  node?: Maybe<SimulationUserAccessibleUsersNodeAggregateSelection>;
};

export type SimulationUserAccessibleUsersEdgeAggregateSelection = {
  __typename?: 'SimulationUserAccessibleUsersEdgeAggregateSelection';
  grantedByUserId: StringAggregateSelectionNullable;
};

export type SimulationUserAccessibleUsersNodeAggregateSelection = {
  __typename?: 'SimulationUserAccessibleUsersNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type SimulationUserAddedByAggregationSelection = {
  __typename?: 'SimulationUserAddedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<SimulationUserAddedByNodeAggregateSelection>;
};

export type SimulationUserAddedByNodeAggregateSelection = {
  __typename?: 'SimulationUserAddedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type SimulationUserWithRole = {
  __typename?: 'SimulationUserWithRole';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  role: SimulatorUserRole;
  userDomainId: Scalars['String']['output'];
  userDomainName?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRole?: Maybe<Scalars['String']['output']>;
};

export type SimulationUserWithRoleAggregateSelection = {
  __typename?: 'SimulationUserWithRoleAggregateSelection';
  count: Scalars['Int']['output'];
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  grantedByUserId: StringAggregateSelectionNullable;
  lastName: StringAggregateSelectionNonNullable;
  userDomainId: StringAggregateSelectionNonNullable;
  userDomainName: StringAggregateSelectionNullable;
  userId: StringAggregateSelectionNonNullable;
  userRole: StringAggregateSelectionNullable;
};

export type SimulationUserWithRoleEdge = {
  __typename?: 'SimulationUserWithRoleEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SimulationUserWithRole;
};

export type SimulationUserWithRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationUserWithRoleSort objects to sort SimulationUserWithRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationUserWithRoleSort>>;
};

/** Fields to sort SimulationUserWithRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationUserWithRoleSort object. */
export type SimulationUserWithRoleSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  grantedByUserId?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  userDomainId?: InputMaybe<SortDirection>;
  userDomainName?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
  userRole?: InputMaybe<SortDirection>;
};

export type SimulationUserWithRoleWhere = {
  AND?: InputMaybe<Array<SimulationUserWithRoleWhere>>;
  NOT?: InputMaybe<SimulationUserWithRoleWhere>;
  OR?: InputMaybe<Array<SimulationUserWithRoleWhere>>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantedByUserId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<SimulatorUserRole>;
  role_IN?: InputMaybe<Array<SimulatorUserRole>>;
  userDomainId?: InputMaybe<Scalars['String']['input']>;
  userDomainId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userDomainId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userDomainId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userDomainId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userDomainId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userDomainName?: InputMaybe<Scalars['String']['input']>;
  userDomainName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userDomainName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userDomainName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userDomainName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userDomainName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
  userRole_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userRole_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userRole_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userRole_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userRole_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SimulationUserWithRolesConnection = {
  __typename?: 'SimulationUserWithRolesConnection';
  edges: Array<SimulationUserWithRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationWhere = {
  AND?: InputMaybe<Array<SimulationWhere>>;
  NOT?: InputMaybe<SimulationWhere>;
  OR?: InputMaybe<Array<SimulationWhere>>;
  accessibleUsersAggregate?: InputMaybe<SimulationAccessibleUsersAggregateInput>;
  /** Return Simulations where all of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_ALL?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where none of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_NONE?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where one of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_SINGLE?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where some of the related SimulationAccessibleUsersConnections match this filter */
  accessibleUsersConnection_SOME?: InputMaybe<SimulationAccessibleUsersConnectionWhere>;
  /** Return Simulations where all of the related Users match this filter */
  accessibleUsers_ALL?: InputMaybe<UserWhere>;
  /** Return Simulations where none of the related Users match this filter */
  accessibleUsers_NONE?: InputMaybe<UserWhere>;
  /** Return Simulations where one of the related Users match this filter */
  accessibleUsers_SINGLE?: InputMaybe<UserWhere>;
  /** Return Simulations where some of the related Users match this filter */
  accessibleUsers_SOME?: InputMaybe<UserWhere>;
  addedBy?: InputMaybe<UserWhere>;
  addedByAggregate?: InputMaybe<SimulationAddedByAggregateInput>;
  addedByConnection?: InputMaybe<SimulationAddedByConnectionWhere>;
  addedByConnection_NOT?: InputMaybe<SimulationAddedByConnectionWhere>;
  addedBy_NOT?: InputMaybe<UserWhere>;
  blueprint?: InputMaybe<ProductBlueprintWhere>;
  blueprintAggregate?: InputMaybe<SimulationBlueprintAggregateInput>;
  blueprintConnection?: InputMaybe<SimulationBlueprintConnectionWhere>;
  blueprintConnection_NOT?: InputMaybe<SimulationBlueprintConnectionWhere>;
  blueprint_NOT?: InputMaybe<ProductBlueprintWhere>;
  businessCase?: InputMaybe<Scalars['String']['input']>;
  businessCase_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  businessCase_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  businessCase_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  businessCase_MATCHES?: InputMaybe<Scalars['String']['input']>;
  businessCase_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  comments_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  comments_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  comments_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comments_MATCHES?: InputMaybe<Scalars['String']['input']>;
  comments_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  configuration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  configuration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  configuration_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  configuration_MATCHES?: InputMaybe<Scalars['String']['input']>;
  configuration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterparty?: InputMaybe<Scalars['String']['input']>;
  counterparty_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  counterparty_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  counterparty_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterparty_MATCHES?: InputMaybe<Scalars['String']['input']>;
  counterparty_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Scalars['String']['input']>;
  createdByName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  createdByName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdByName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  createdByName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deletedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  deletedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  domain?: InputMaybe<DomainWhere>;
  domainAggregate?: InputMaybe<SimulationDomainAggregateInput>;
  domainConnection?: InputMaybe<SimulationDomainConnectionWhere>;
  domainConnection_NOT?: InputMaybe<SimulationDomainConnectionWhere>;
  domainName?: InputMaybe<Scalars['String']['input']>;
  domainName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  domainName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  domainName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domainName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  domainName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  domain_NOT?: InputMaybe<DomainWhere>;
  formattedContent?: InputMaybe<Scalars['String']['input']>;
  formattedContent_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  formattedContent_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  formattedContent_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedContent_MATCHES?: InputMaybe<Scalars['String']['input']>;
  formattedContent_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  indications?: InputMaybe<Scalars['String']['input']>;
  indications_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indications_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indications_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  indications_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indications_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSimulationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedByEmail?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastUpdatedByEmail_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedByEmail_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lockedSections?: InputMaybe<Scalars['String']['input']>;
  lockedSections_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lockedSections_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lockedSections_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lockedSections_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lockedSections_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  model_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  model_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  model_MATCHES?: InputMaybe<Scalars['String']['input']>;
  model_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  product_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  product_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  product_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  product_MATCHES?: InputMaybe<Scalars['String']['input']>;
  product_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  shortName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  shortName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  shortName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  shortName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SimulationSavedStatus>;
  status_IN?: InputMaybe<Array<SimulationSavedStatus>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_GT?: InputMaybe<Scalars['Int']['input']>;
  version_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  version_LT?: InputMaybe<Scalars['Int']['input']>;
  version_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SimulationsConnection = {
  __typename?: 'SimulationsConnection';
  edges: Array<SimulationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationsTableSourceFilterData = {
  __typename?: 'SimulationsTableSourceFilterData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  addedByNames: Array<Scalars['String']['output']>;
  counterparties: Array<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  models: Array<Scalars['String']['output']>;
  products: Array<Scalars['String']['output']>;
  shortNames: Array<Scalars['String']['output']>;
  statuses: Array<SimulationSavedStatus>;
};

export type SimulationsTableSourceFilterDataAggregateSelection = {
  __typename?: 'SimulationsTableSourceFilterDataAggregateSelection';
  count: Scalars['Int']['output'];
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
};

export type SimulationsTableSourceFilterDataConnection = {
  __typename?: 'SimulationsTableSourceFilterDataConnection';
  edges: Array<SimulationsTableSourceFilterDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SimulationsTableSourceFilterDataEdge = {
  __typename?: 'SimulationsTableSourceFilterDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SimulationsTableSourceFilterData;
};

export type SimulationsTableSourceFilterDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SimulationsTableSourceFilterDataSort objects to sort SimulationsTableSourceFilterData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SimulationsTableSourceFilterDataSort>>;
};

/** Fields to sort SimulationsTableSourceFilterData by. The order in which sorts are applied is not guaranteed when specifying many fields in one SimulationsTableSourceFilterDataSort object. */
export type SimulationsTableSourceFilterDataSort = {
  lastUpdatedOn?: InputMaybe<SortDirection>;
};

export type SimulationsTableSourceFilterDataWhere = {
  AND?: InputMaybe<Array<SimulationsTableSourceFilterDataWhere>>;
  NOT?: InputMaybe<SimulationsTableSourceFilterDataWhere>;
  OR?: InputMaybe<Array<SimulationsTableSourceFilterDataWhere>>;
  addedByNames?: InputMaybe<Array<Scalars['String']['input']>>;
  addedByNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  counterparties?: InputMaybe<Array<Scalars['String']['input']>>;
  counterparties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  domains_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  ids_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  models_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  products_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  shortNames?: InputMaybe<Array<Scalars['String']['input']>>;
  shortNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SimulationSavedStatus>>;
  statuses_INCLUDES?: InputMaybe<SimulationSavedStatus>;
};

export enum SimulatorUserRole {
  Editor = 'EDITOR',
  NonViewer = 'NON_VIEWER',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type SimulatorUserRoleRelationship = {
  grantedByUserId?: Maybe<Scalars['String']['output']>;
  role: SimulatorUserRole;
};

export type SimulatorUserRoleRelationshipSort = {
  grantedByUserId?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type SimulatorUserRoleRelationshipWhere = {
  AND?: InputMaybe<Array<SimulatorUserRoleRelationshipWhere>>;
  NOT?: InputMaybe<SimulatorUserRoleRelationshipWhere>;
  OR?: InputMaybe<Array<SimulatorUserRoleRelationshipWhere>>;
  grantedByUserId?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grantedByUserId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  grantedByUserId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<SimulatorUserRole>;
  role_IN?: InputMaybe<Array<SimulatorUserRole>>;
};

export enum SmartMipDocumentStatus {
  Cancelled = 'Cancelled',
  Cleared = 'Cleared',
  FullySigned = 'FullySigned',
  FurtherEnquiry = 'FurtherEnquiry',
  InvoiceCreated = 'InvoiceCreated',
  New = 'New',
  PartiallySigned = 'PartiallySigned'
}

export type SmartMipInvoicePdfResult = {
  __typename?: 'SmartMipInvoicePdfResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  content: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type SmartMipInvoicePdfResultAggregateSelection = {
  __typename?: 'SmartMipInvoicePdfResultAggregateSelection';
  content: StringAggregateSelectionNonNullable;
  contentType: StringAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  fileName: StringAggregateSelectionNonNullable;
};

export type SmartMipInvoicePdfResultEdge = {
  __typename?: 'SmartMipInvoicePdfResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SmartMipInvoicePdfResult;
};

export type SmartMipInvoicePdfResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SmartMipInvoicePdfResultSort objects to sort SmartMipInvoicePdfResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SmartMipInvoicePdfResultSort>>;
};

/** Fields to sort SmartMipInvoicePdfResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one SmartMipInvoicePdfResultSort object. */
export type SmartMipInvoicePdfResultSort = {
  content?: InputMaybe<SortDirection>;
  contentType?: InputMaybe<SortDirection>;
  fileName?: InputMaybe<SortDirection>;
};

export type SmartMipInvoicePdfResultWhere = {
  AND?: InputMaybe<Array<SmartMipInvoicePdfResultWhere>>;
  NOT?: InputMaybe<SmartMipInvoicePdfResultWhere>;
  OR?: InputMaybe<Array<SmartMipInvoicePdfResultWhere>>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  contentType_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  contentType_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  contentType_MATCHES?: InputMaybe<Scalars['String']['input']>;
  contentType_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  content_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  content_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  content_MATCHES?: InputMaybe<Scalars['String']['input']>;
  content_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  fileName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  fileName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  fileName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  fileName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SmartMipInvoicePdfResultsConnection = {
  __typename?: 'SmartMipInvoicePdfResultsConnection';
  edges: Array<SmartMipInvoicePdfResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SmartMipPendingDocument = {
  __typename?: 'SmartMipPendingDocument';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  documentId: Scalars['ID']['output'];
  smartMipReimbursementId: Scalars['String']['output'];
};

export type SmartMipPendingDocumentAggregateSelection = {
  __typename?: 'SmartMipPendingDocumentAggregateSelection';
  count: Scalars['Int']['output'];
  documentId: IdAggregateSelectionNonNullable;
  smartMipReimbursementId: StringAggregateSelectionNonNullable;
};

export type SmartMipPendingDocumentEdge = {
  __typename?: 'SmartMipPendingDocumentEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SmartMipPendingDocument;
};

export type SmartMipPendingDocumentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SmartMipPendingDocumentSort objects to sort SmartMipPendingDocuments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SmartMipPendingDocumentSort>>;
};

/** Fields to sort SmartMipPendingDocuments by. The order in which sorts are applied is not guaranteed when specifying many fields in one SmartMipPendingDocumentSort object. */
export type SmartMipPendingDocumentSort = {
  documentId?: InputMaybe<SortDirection>;
  smartMipReimbursementId?: InputMaybe<SortDirection>;
};

export type SmartMipPendingDocumentWhere = {
  AND?: InputMaybe<Array<SmartMipPendingDocumentWhere>>;
  NOT?: InputMaybe<SmartMipPendingDocumentWhere>;
  OR?: InputMaybe<Array<SmartMipPendingDocumentWhere>>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  documentId_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  smartMipReimbursementId?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  smartMipReimbursementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  smartMipReimbursementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SmartMipPendingDocumentsConnection = {
  __typename?: 'SmartMipPendingDocumentsConnection';
  edges: Array<SmartMipPendingDocumentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SmartMipPositionStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Cleared = 'Cleared',
  FurtherEnquiry = 'FurtherEnquiry',
  New = 'New'
}

export enum SmartMipReimbursementType {
  Article71 = 'Article71',
  PricingModel = 'PricingModel'
}

/** An enum for sorting in either ascending or descending order. */
export enum SortDirection {
  /** Sort by field values in ascending order. */
  Asc = 'ASC',
  /** Sort by field values in descending order. */
  Desc = 'DESC'
}

export type Sources = {
  __typename?: 'Sources';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementSynced?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SourcesAggregateSelection = {
  __typename?: 'SourcesAggregateSelection';
  count: Scalars['Int']['output'];
  url: StringAggregateSelectionNullable;
};

export type SourcesConnection = {
  __typename?: 'SourcesConnection';
  edges: Array<SourcesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SourcesEdge = {
  __typename?: 'SourcesEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Sources;
};

export type SourcesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SourcesSort objects to sort Sources by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SourcesSort>>;
};

/** Fields to sort Sources by. The order in which sorts are applied is not guaranteed when specifying many fields in one SourcesSort object. */
export type SourcesSort = {
  url?: InputMaybe<SortDirection>;
};

export type SourcesWhere = {
  AND?: InputMaybe<Array<SourcesWhere>>;
  NOT?: InputMaybe<SourcesWhere>;
  OR?: InputMaybe<Array<SourcesWhere>>;
  agreementSynced?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementSynced_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_MATCHES?: InputMaybe<Scalars['String']['input']>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum StatusHistorical {
  Mandatory = 'MANDATORY',
  MandatoryForSubmission = 'MANDATORY_FOR_SUBMISSION',
  Optional = 'OPTIONAL'
}

export type StringAggregateSelectionNonNullable = {
  __typename?: 'StringAggregateSelectionNonNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  longest: Scalars['String']['output'];
  shortest: Scalars['String']['output'];
};

export type StringAggregateSelectionNullable = {
  __typename?: 'StringAggregateSelectionNullable';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  longest?: Maybe<Scalars['String']['output']>;
  shortest?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementCreated: Array<Scalars['String']['output']>;
  agreementRun: AgreementRun;
  agreementsRunPlanned: PlannedAgreementRun;
  caseCreated: Array<Scalars['String']['output']>;
  documentAttachmentProgress: DocumentAttachmentProgressEvent;
  documentCreated: Array<Scalars['String']['output']>;
  documentThreadUpdated: DocumentThreadUpdate;
  documentUpdated: DocumentUpdated;
  flexEntityBulk: FlexEntityBulkProgress;
  flexEntityUploading: FlexEntityUploadProgress;
  formCreated: Array<Scalars['String']['output']>;
  questUpdated: Array<Scalars['String']['output']>;
  recordUpdated: Array<Scalars['String']['output']>;
  refundCreated: Array<Maybe<Scalars['String']['output']>>;
  simulationUpdated: Array<Scalars['String']['output']>;
  snapshotUpdated: Array<Scalars['String']['output']>;
  taskUpdated: Array<Scalars['String']['output']>;
  threadUpdated: Array<Scalars['String']['output']>;
};

export enum SupportedMessageNodes {
  Case = 'Case',
  Document = 'Document'
}

export type SvgFlagsConnection = {
  __typename?: 'SvgFlagsConnection';
  edges: Array<SvgFlagEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SyncRefundImpact = {
  __typename?: 'SyncRefundImpact';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementVersion: Scalars['Int']['output'];
  documentCreator?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  documentReviewer?: Maybe<Scalars['String']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
};

export type SyncRefundImpactAggregateSelection = {
  __typename?: 'SyncRefundImpactAggregateSelection';
  agreementVersion: IntAggregateSelectionNonNullable;
  count: Scalars['Int']['output'];
  documentCreator: StringAggregateSelectionNullable;
  documentId: StringAggregateSelectionNullable;
  documentReviewer: StringAggregateSelectionNullable;
  refundId: StringAggregateSelectionNullable;
};

export type SyncRefundImpactEdge = {
  __typename?: 'SyncRefundImpactEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SyncRefundImpact;
};

export type SyncRefundImpactOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SyncRefundImpactSort objects to sort SyncRefundImpacts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SyncRefundImpactSort>>;
};

/** Fields to sort SyncRefundImpacts by. The order in which sorts are applied is not guaranteed when specifying many fields in one SyncRefundImpactSort object. */
export type SyncRefundImpactSort = {
  agreementVersion?: InputMaybe<SortDirection>;
  documentCreator?: InputMaybe<SortDirection>;
  documentId?: InputMaybe<SortDirection>;
  documentReviewer?: InputMaybe<SortDirection>;
  refundId?: InputMaybe<SortDirection>;
};

export type SyncRefundImpactWhere = {
  AND?: InputMaybe<Array<SyncRefundImpactWhere>>;
  NOT?: InputMaybe<SyncRefundImpactWhere>;
  OR?: InputMaybe<Array<SyncRefundImpactWhere>>;
  agreementVersion?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  agreementVersion_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementVersion_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentCreator?: InputMaybe<Scalars['String']['input']>;
  documentCreator_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentCreator_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentCreator_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentCreator_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentCreator_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewer?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentReviewer_MATCHES?: InputMaybe<Scalars['String']['input']>;
  documentReviewer_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  refundId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  refundId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  refundId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  refundId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type SyncRefundImpactsConnection = {
  __typename?: 'SyncRefundImpactsConnection';
  edges: Array<SyncRefundImpactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SyncResponse = {
  __typename?: 'SyncResponse';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementId: Scalars['String']['output'];
  agreementName?: Maybe<Scalars['String']['output']>;
  dependentArt71AgreementsStatus?: Maybe<Scalars['String']['output']>;
  excludedScopes?: Maybe<Scalars['String']['output']>;
  newScopes?: Maybe<Scalars['String']['output']>;
  refundImpacts: Array<SyncRefundImpact>;
  scenariosStatus?: Maybe<Scalars['String']['output']>;
  scopesStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ResponseBaseStatus>;
  type: SyncType;
  validityStatus?: Maybe<Scalars['String']['output']>;
  versionNo: Scalars['Int']['output'];
};

export type SyncResponseAggregateSelection = {
  __typename?: 'SyncResponseAggregateSelection';
  agreementId: StringAggregateSelectionNonNullable;
  agreementName: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  dependentArt71AgreementsStatus: StringAggregateSelectionNullable;
  excludedScopes: StringAggregateSelectionNullable;
  newScopes: StringAggregateSelectionNullable;
  scenariosStatus: StringAggregateSelectionNullable;
  scopesStatus: StringAggregateSelectionNullable;
  validityStatus: StringAggregateSelectionNullable;
  versionNo: IntAggregateSelectionNonNullable;
};

export type SyncResponseEdge = {
  __typename?: 'SyncResponseEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: SyncResponse;
};

export type SyncResponseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more SyncResponseSort objects to sort SyncResponses by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<SyncResponseSort>>;
};

/** Fields to sort SyncResponses by. The order in which sorts are applied is not guaranteed when specifying many fields in one SyncResponseSort object. */
export type SyncResponseSort = {
  agreementId?: InputMaybe<SortDirection>;
  agreementName?: InputMaybe<SortDirection>;
  dependentArt71AgreementsStatus?: InputMaybe<SortDirection>;
  excludedScopes?: InputMaybe<SortDirection>;
  newScopes?: InputMaybe<SortDirection>;
  scenariosStatus?: InputMaybe<SortDirection>;
  scopesStatus?: InputMaybe<SortDirection>;
  status?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
  validityStatus?: InputMaybe<SortDirection>;
  versionNo?: InputMaybe<SortDirection>;
};

export type SyncResponseWhere = {
  AND?: InputMaybe<Array<SyncResponseWhere>>;
  NOT?: InputMaybe<SyncResponseWhere>;
  OR?: InputMaybe<Array<SyncResponseWhere>>;
  agreementId?: InputMaybe<Scalars['String']['input']>;
  agreementId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName?: InputMaybe<Scalars['String']['input']>;
  agreementName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  agreementName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  agreementName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agreementName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  agreementName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dependentArt71AgreementsStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dependentArt71AgreementsStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  excludedScopes?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedScopes_MATCHES?: InputMaybe<Scalars['String']['input']>;
  excludedScopes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  newScopes?: InputMaybe<Scalars['String']['input']>;
  newScopes_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  newScopes_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  newScopes_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newScopes_MATCHES?: InputMaybe<Scalars['String']['input']>;
  newScopes_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scenariosStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scenariosStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopesStatus?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopesStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  scopesStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResponseBaseStatus>;
  status_IN?: InputMaybe<Array<InputMaybe<ResponseBaseStatus>>>;
  type?: InputMaybe<SyncType>;
  type_IN?: InputMaybe<Array<SyncType>>;
  validityStatus?: InputMaybe<Scalars['String']['input']>;
  validityStatus_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  validityStatus_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  validityStatus_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  validityStatus_MATCHES?: InputMaybe<Scalars['String']['input']>;
  validityStatus_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  versionNo?: InputMaybe<Scalars['Int']['input']>;
  versionNo_GT?: InputMaybe<Scalars['Int']['input']>;
  versionNo_GTE?: InputMaybe<Scalars['Int']['input']>;
  versionNo_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  versionNo_LT?: InputMaybe<Scalars['Int']['input']>;
  versionNo_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type SyncResponsesConnection = {
  __typename?: 'SyncResponsesConnection';
  edges: Array<SyncResponseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SyncSmartMipAttachmentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
};

export type SyncSmartMipMessageInput = {
  approved: Scalars['Boolean']['input'];
  attachment?: InputMaybe<SyncSmartMipAttachmentInput>;
  messageId: Scalars['Int']['input'];
  pharmaComment?: InputMaybe<Scalars['String']['input']>;
  positions: Array<SyncSmartMipPositionInMessageInput>;
  sender?: InputMaybe<Scalars['String']['input']>;
};

export type SyncSmartMipPositionInMessageInput = {
  negotiatedRating?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['Int']['input'];
};

export type SyncSmartMipResultInput = {
  documentStatus: Scalars['String']['input'];
  messages: Array<SyncSmartMipMessageInput>;
  smartMipReimbursementId: Scalars['String']['input'];
};

export enum SyncType {
  SyncScenarios = 'SYNC_SCENARIOS',
  SyncScope = 'SYNC_SCOPE',
  SyncValidity = 'SYNC_VALIDITY'
}

export type Tadi = {
  __typename?: 'TADI';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  indication?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  therapeuticArea?: Maybe<Scalars['String']['output']>;
};

export type TadiAggregateSelection = {
  __typename?: 'TADIAggregateSelection';
  count: Scalars['Int']['output'];
  indication: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
  therapeuticArea: StringAggregateSelectionNullable;
};

export type TadiEdge = {
  __typename?: 'TADIEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Tadi;
};

export type TadiOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TADISort objects to sort Tadis by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TadiSort>>;
};

/** Fields to sort Tadis by. The order in which sorts are applied is not guaranteed when specifying many fields in one TADISort object. */
export type TadiSort = {
  indication?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  therapeuticArea?: InputMaybe<SortDirection>;
};

export type TadiWhere = {
  AND?: InputMaybe<Array<TadiWhere>>;
  NOT?: InputMaybe<TadiWhere>;
  OR?: InputMaybe<Array<TadiWhere>>;
  indication?: InputMaybe<Scalars['String']['input']>;
  indication_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  indication_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  indication_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  indication_MATCHES?: InputMaybe<Scalars['String']['input']>;
  indication_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  therapeuticArea_MATCHES?: InputMaybe<Scalars['String']['input']>;
  therapeuticArea_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TadisConnection = {
  __typename?: 'TadisConnection';
  edges: Array<TadiEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Task = {
  __typename?: 'Task';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreement?: Maybe<Agreement>;
  agreementAggregate?: Maybe<TaskAgreementAgreementAggregationSelection>;
  agreementConnection: TaskAgreementConnection;
  case?: Maybe<Case>;
  caseAggregate?: Maybe<TaskCaseCaseAggregationSelection>;
  caseConnection: TaskCaseConnection;
  createdBy?: Maybe<User>;
  createdByAggregate?: Maybe<TaskUserCreatedByAggregationSelection>;
  createdByConnection: TaskCreatedByConnection;
  document?: Maybe<Document>;
  documentAggregate?: Maybe<TaskDocumentDocumentAggregationSelection>;
  documentConnection: TaskDocumentConnection;
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  messageAggregate?: Maybe<TaskMessageMessageAggregationSelection>;
  messageConnection: TaskMessageConnection;
  taskContentDe?: Maybe<Scalars['String']['output']>;
  taskContentEn?: Maybe<Scalars['String']['output']>;
  taskStatus?: Maybe<TaskStatus>;
  tenantIds: Array<Scalars['String']['output']>;
  timeStamp: Scalars['Float']['output'];
  triggerEventId: Scalars['Int']['output'];
  usersRelationship: Array<User>;
  usersRelationshipAggregate?: Maybe<TaskUserUsersRelationshipAggregationSelection>;
  usersRelationshipConnection: TaskUsersRelationshipConnection;
};


export type TaskAgreementArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementOptions>;
  where?: InputMaybe<AgreementWhere>;
};


export type TaskAgreementAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementWhere>;
};


export type TaskAgreementConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaskAgreementConnectionSort>>;
  where?: InputMaybe<TaskAgreementConnectionWhere>;
};


export type TaskCaseArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CaseOptions>;
  where?: InputMaybe<CaseWhere>;
};


export type TaskCaseAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CaseWhere>;
};


export type TaskCaseConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaskCaseConnectionSort>>;
  where?: InputMaybe<TaskCaseConnectionWhere>;
};


export type TaskCreatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type TaskCreatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type TaskCreatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaskCreatedByConnectionSort>>;
  where?: InputMaybe<TaskCreatedByConnectionWhere>;
};


export type TaskDocumentArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DocumentOptions>;
  where?: InputMaybe<DocumentWhere>;
};


export type TaskDocumentAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentWhere>;
};


export type TaskDocumentConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaskDocumentConnectionSort>>;
  where?: InputMaybe<TaskDocumentConnectionWhere>;
};


export type TaskMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type TaskMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type TaskMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaskMessageConnectionSort>>;
  where?: InputMaybe<TaskMessageConnectionWhere>;
};


export type TaskUsersRelationshipArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type TaskUsersRelationshipAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type TaskUsersRelationshipConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TaskUsersRelationshipConnectionSort>>;
  where?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
};

export type TaskAggregateSelection = {
  __typename?: 'TaskAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  taskContentDe: StringAggregateSelectionNullable;
  taskContentEn: StringAggregateSelectionNullable;
  timeStamp: FloatAggregateSelectionNonNullable;
  triggerEventId: IntAggregateSelectionNonNullable;
};

export type TaskAgreementAggregateInput = {
  AND?: InputMaybe<Array<TaskAgreementAggregateInput>>;
  NOT?: InputMaybe<TaskAgreementAggregateInput>;
  OR?: InputMaybe<Array<TaskAgreementAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TaskAgreementNodeAggregationWhereInput>;
};

export type TaskAgreementAgreementAggregationSelection = {
  __typename?: 'TaskAgreementAgreementAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TaskAgreementAgreementNodeAggregateSelection>;
};

export type TaskAgreementAgreementNodeAggregateSelection = {
  __typename?: 'TaskAgreementAgreementNodeAggregateSelection';
  daysToExpiry: IntAggregateSelectionNullable;
  description: StringAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type TaskAgreementConnection = {
  __typename?: 'TaskAgreementConnection';
  edges: Array<TaskAgreementRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskAgreementConnectionSort = {
  node?: InputMaybe<AgreementSort>;
};

export type TaskAgreementConnectionWhere = {
  AND?: InputMaybe<Array<TaskAgreementConnectionWhere>>;
  NOT?: InputMaybe<TaskAgreementConnectionWhere>;
  OR?: InputMaybe<Array<TaskAgreementConnectionWhere>>;
  node?: InputMaybe<AgreementWhere>;
};

export type TaskAgreementNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskAgreementNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskAgreementNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskAgreementNodeAggregationWhereInput>>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskAgreementRelationship = {
  __typename?: 'TaskAgreementRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Agreement;
};

export type TaskCaseAggregateInput = {
  AND?: InputMaybe<Array<TaskCaseAggregateInput>>;
  NOT?: InputMaybe<TaskCaseAggregateInput>;
  OR?: InputMaybe<Array<TaskCaseAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TaskCaseEdgeAggregationWhereInput>;
  node?: InputMaybe<TaskCaseNodeAggregationWhereInput>;
};

export type TaskCaseCaseAggregationSelection = {
  __typename?: 'TaskCaseCaseAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<TaskCaseCaseEdgeAggregateSelection>;
  node?: Maybe<TaskCaseCaseNodeAggregateSelection>;
};

export type TaskCaseCaseEdgeAggregateSelection = {
  __typename?: 'TaskCaseCaseEdgeAggregateSelection';
  formDueOrOverdue: StringAggregateSelectionNullable;
};

export type TaskCaseCaseNodeAggregateSelection = {
  __typename?: 'TaskCaseCaseNodeAggregateSelection';
  actualAgreementId: StringAggregateSelectionNullable;
  agreementName: StringAggregateSelectionNullable;
  counterpartyInReview: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastStatusChangeDate: DateTimeAggregateSelectionNullable;
  patientInitials: StringAggregateSelectionNullable;
  patientInsuranceId: StringAggregateSelectionNonNullable;
  preparationBrandName: StringAggregateSelectionNullable;
  preparationGenericName: StringAggregateSelectionNullable;
  sourceTenantId: StringAggregateSelectionNonNullable;
  submissionDate: DateTimeAggregateSelectionNullable;
  suspensionReason: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
};

export type TaskCaseConnection = {
  __typename?: 'TaskCaseConnection';
  edges: Array<TaskCaseRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskCaseConnectionSort = {
  edge?: InputMaybe<CaseTaskRelationshipSort>;
  node?: InputMaybe<CaseSort>;
};

export type TaskCaseConnectionWhere = {
  AND?: InputMaybe<Array<TaskCaseConnectionWhere>>;
  NOT?: InputMaybe<TaskCaseConnectionWhere>;
  OR?: InputMaybe<Array<TaskCaseConnectionWhere>>;
  edge?: InputMaybe<CaseTaskRelationshipWhere>;
  node?: InputMaybe<CaseWhere>;
};

export type TaskCaseEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskCaseEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskCaseEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskCaseEdgeAggregationWhereInput>>;
  formDueOrOverdue_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formDueOrOverdue_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formDueOrOverdue_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formDueOrOverdue_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formDueOrOverdue_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formDueOrOverdue_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formDueOrOverdue_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskCaseNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskCaseNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskCaseNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskCaseNodeAggregationWhereInput>>;
  actualAgreementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  actualAgreementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  actualAgreementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  agreementName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  agreementName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  agreementName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterpartyInReview_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterpartyInReview_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastStatusChangeDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastStatusChangeDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientInitials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInitials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInitials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientInsuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientInsuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  sourceTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  sourceTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  submissionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  submissionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  suspensionReason_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  suspensionReason_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  suspensionReason_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type TaskCaseRelationship = CaseTaskRelationship & {
  __typename?: 'TaskCaseRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  formDueOrOverdue?: Maybe<Scalars['String']['output']>;
  node: Case;
};

export type TaskCreatedByAggregateInput = {
  AND?: InputMaybe<Array<TaskCreatedByAggregateInput>>;
  NOT?: InputMaybe<TaskCreatedByAggregateInput>;
  OR?: InputMaybe<Array<TaskCreatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TaskCreatedByNodeAggregationWhereInput>;
};

export type TaskCreatedByConnection = {
  __typename?: 'TaskCreatedByConnection';
  edges: Array<TaskCreatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskCreatedByConnectionSort = {
  node?: InputMaybe<UserSort>;
};

export type TaskCreatedByConnectionWhere = {
  AND?: InputMaybe<Array<TaskCreatedByConnectionWhere>>;
  NOT?: InputMaybe<TaskCreatedByConnectionWhere>;
  OR?: InputMaybe<Array<TaskCreatedByConnectionWhere>>;
  node?: InputMaybe<UserWhere>;
};

export type TaskCreatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskCreatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskCreatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskCreatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskCreatedByRelationship = {
  __typename?: 'TaskCreatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type TaskDocumentAggregateInput = {
  AND?: InputMaybe<Array<TaskDocumentAggregateInput>>;
  NOT?: InputMaybe<TaskDocumentAggregateInput>;
  OR?: InputMaybe<Array<TaskDocumentAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TaskDocumentNodeAggregationWhereInput>;
};

export type TaskDocumentConnection = {
  __typename?: 'TaskDocumentConnection';
  edges: Array<TaskDocumentRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskDocumentConnectionSort = {
  node?: InputMaybe<DocumentSort>;
};

export type TaskDocumentConnectionWhere = {
  AND?: InputMaybe<Array<TaskDocumentConnectionWhere>>;
  NOT?: InputMaybe<TaskDocumentConnectionWhere>;
  OR?: InputMaybe<Array<TaskDocumentConnectionWhere>>;
  node?: InputMaybe<DocumentWhere>;
};

export type TaskDocumentDocumentAggregationSelection = {
  __typename?: 'TaskDocumentDocumentAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TaskDocumentDocumentNodeAggregateSelection>;
};

export type TaskDocumentDocumentNodeAggregateSelection = {
  __typename?: 'TaskDocumentDocumentNodeAggregateSelection';
  adjustedInvoiceAmount: FloatAggregateSelectionNullable;
  counterParties: StringAggregateSelectionNullable;
  coveragePeriod: StringAggregateSelectionNullable;
  createdByEmail: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  creatorOrgName: StringAggregateSelectionNullable;
  creatorTenantId: StringAggregateSelectionNonNullable;
  currentReviewerOrganization: StringAggregateSelectionNullable;
  documentReceiverBillingAddress: StringAggregateSelectionNullable;
  documentReceiverDetails: StringAggregateSelectionNullable;
  documentReceiverLegalName: StringAggregateSelectionNullable;
  documentSenderContactEmail: StringAggregateSelectionNullable;
  documentSenderContactFirstName: StringAggregateSelectionNullable;
  documentSenderContactLastName: StringAggregateSelectionNullable;
  documentSenderContactPhone: StringAggregateSelectionNullable;
  documentSenderDomicile: StringAggregateSelectionNullable;
  documentSenderFax: StringAggregateSelectionNullable;
  documentSenderPhone: StringAggregateSelectionNullable;
  exposureLog: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  invoiceAmount: FloatAggregateSelectionNullable;
  issuedOn: DateTimeAggregateSelectionNullable;
  lastChangedOn: DateTimeAggregateSelectionNullable;
  lastRemindedOn: DateTimeAggregateSelectionNullable;
  lastSentForSmartMipReview: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  orderNo: StringAggregateSelectionNullable;
  paymentReferenceLyfegen: StringAggregateSelectionNullable;
  paymentReminderEmail: StringAggregateSelectionNullable;
  product: StringAggregateSelectionNonNullable;
  reviewRemindedOn: DateTimeAggregateSelectionNullable;
  senderLegalName: StringAggregateSelectionNullable;
  sentToReviewOn: DateTimeAggregateSelectionNullable;
  smartMipInvoiceFileId: StringAggregateSelectionNullable;
  smartMipInvoiceId: StringAggregateSelectionNullable;
  smartMipReimbursementId: StringAggregateSelectionNullable;
  uploadedOn: DateTimeAggregateSelectionNullable;
  uploadedVariantKey: StringAggregateSelectionNullable;
};

export type TaskDocumentNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskDocumentNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskDocumentNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskDocumentNodeAggregationWhereInput>>;
  adjustedInvoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  adjustedInvoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  counterParties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  counterParties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  counterParties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveragePeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  coveragePeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  creatorOrgName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorOrgName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorOrgName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  creatorTenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  creatorTenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currentReviewerOrganization_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverBillingAddress_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentReceiverLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactFirstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactLastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderContactPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderDomicile_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderFax_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderFax_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  documentSenderPhone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  documentSenderPhone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  exposureLog_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  exposureLog_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  issuedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  issuedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastChangedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastSentForSmartMipReview_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  orderNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  orderNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  orderNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  orderNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReferenceLyfegen_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  paymentReminderEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  product_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  product_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  product_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reviewRemindedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  reviewRemindedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  senderLegalName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  senderLegalName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  senderLegalName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  sentToReviewOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  sentToReviewOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceFileId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipInvoiceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  smartMipReimbursementId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uploadedVariantKey_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskDocumentRelationship = {
  __typename?: 'TaskDocumentRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Document;
};

export type TaskEdge = {
  __typename?: 'TaskEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Task;
};

export type TaskMessageAggregateInput = {
  AND?: InputMaybe<Array<TaskMessageAggregateInput>>;
  NOT?: InputMaybe<TaskMessageAggregateInput>;
  OR?: InputMaybe<Array<TaskMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TaskMessageEdgeAggregationWhereInput>;
  node?: InputMaybe<TaskMessageNodeAggregationWhereInput>;
};

export type TaskMessageConnection = {
  __typename?: 'TaskMessageConnection';
  edges: Array<TaskMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskMessageConnectionSort = {
  edge?: InputMaybe<UserMessageRelationshipSort>;
  node?: InputMaybe<MessageSort>;
};

export type TaskMessageConnectionWhere = {
  AND?: InputMaybe<Array<TaskMessageConnectionWhere>>;
  NOT?: InputMaybe<TaskMessageConnectionWhere>;
  OR?: InputMaybe<Array<TaskMessageConnectionWhere>>;
  edge?: InputMaybe<UserMessageRelationshipWhere>;
  node?: InputMaybe<MessageWhere>;
};

export type TaskMessageEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskMessageEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskMessageEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskMessageEdgeAggregationWhereInput>>;
  nodeContext_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nodeContext_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  nodeContext_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  nodeContext_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  nodeContext_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  nodeContext_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  nodeContext_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskMessageMessageAggregationSelection = {
  __typename?: 'TaskMessageMessageAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<TaskMessageMessageEdgeAggregateSelection>;
  node?: Maybe<TaskMessageMessageNodeAggregateSelection>;
};

export type TaskMessageMessageEdgeAggregateSelection = {
  __typename?: 'TaskMessageMessageEdgeAggregateSelection';
  nodeContext: StringAggregateSelectionNullable;
  nodeId: IdAggregateSelectionNullable;
};

export type TaskMessageMessageNodeAggregateSelection = {
  __typename?: 'TaskMessageMessageNodeAggregateSelection';
  content: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
};

export type TaskMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskMessageNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type TaskMessageRelationship = UserMessageRelationship & {
  __typename?: 'TaskMessageRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Message;
  nodeContext?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['ID']['output']>;
  nodeLabel: SupportedMessageNodes;
};

export type TaskOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TaskSort objects to sort Tasks by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TaskSort>>;
};

/** Fields to sort Tasks by. The order in which sorts are applied is not guaranteed when specifying many fields in one TaskSort object. */
export type TaskSort = {
  id?: InputMaybe<SortDirection>;
  taskContentDe?: InputMaybe<SortDirection>;
  taskContentEn?: InputMaybe<SortDirection>;
  taskStatus?: InputMaybe<SortDirection>;
  timeStamp?: InputMaybe<SortDirection>;
  triggerEventId?: InputMaybe<SortDirection>;
};

export enum TaskStatus {
  Read = 'READ',
  Unread = 'UNREAD'
}

export type TaskUserCreatedByAggregationSelection = {
  __typename?: 'TaskUserCreatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TaskUserCreatedByNodeAggregateSelection>;
};

export type TaskUserCreatedByNodeAggregateSelection = {
  __typename?: 'TaskUserCreatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type TaskUserUsersRelationshipAggregationSelection = {
  __typename?: 'TaskUserUsersRelationshipAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<TaskUserUsersRelationshipEdgeAggregateSelection>;
  node?: Maybe<TaskUserUsersRelationshipNodeAggregateSelection>;
};

export type TaskUserUsersRelationshipEdgeAggregateSelection = {
  __typename?: 'TaskUserUsersRelationshipEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type TaskUserUsersRelationshipNodeAggregateSelection = {
  __typename?: 'TaskUserUsersRelationshipNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type TaskUsersRelationshipAggregateInput = {
  AND?: InputMaybe<Array<TaskUsersRelationshipAggregateInput>>;
  NOT?: InputMaybe<TaskUsersRelationshipAggregateInput>;
  OR?: InputMaybe<Array<TaskUsersRelationshipAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<TaskUsersRelationshipEdgeAggregationWhereInput>;
  node?: InputMaybe<TaskUsersRelationshipNodeAggregationWhereInput>;
};

export type TaskUsersRelationshipConnection = {
  __typename?: 'TaskUsersRelationshipConnection';
  edges: Array<TaskUsersRelationshipRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TaskUsersRelationshipConnectionSort = {
  edge?: InputMaybe<UserTaskRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type TaskUsersRelationshipConnectionWhere = {
  AND?: InputMaybe<Array<TaskUsersRelationshipConnectionWhere>>;
  NOT?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
  OR?: InputMaybe<Array<TaskUsersRelationshipConnectionWhere>>;
  edge?: InputMaybe<UserTaskRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type TaskUsersRelationshipEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskUsersRelationshipEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskUsersRelationshipEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskUsersRelationshipEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskUsersRelationshipNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TaskUsersRelationshipNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TaskUsersRelationshipNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TaskUsersRelationshipNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TaskUsersRelationshipRelationship = UserTaskRelationship & {
  __typename?: 'TaskUsersRelationshipRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  node: User;
  order?: Maybe<Scalars['Int']['output']>;
};

export type TaskWhere = {
  AND?: InputMaybe<Array<TaskWhere>>;
  NOT?: InputMaybe<TaskWhere>;
  OR?: InputMaybe<Array<TaskWhere>>;
  agreement?: InputMaybe<AgreementWhere>;
  agreementAggregate?: InputMaybe<TaskAgreementAggregateInput>;
  agreementConnection?: InputMaybe<TaskAgreementConnectionWhere>;
  agreementConnection_NOT?: InputMaybe<TaskAgreementConnectionWhere>;
  agreement_NOT?: InputMaybe<AgreementWhere>;
  case?: InputMaybe<CaseWhere>;
  caseAggregate?: InputMaybe<TaskCaseAggregateInput>;
  caseConnection?: InputMaybe<TaskCaseConnectionWhere>;
  caseConnection_NOT?: InputMaybe<TaskCaseConnectionWhere>;
  case_NOT?: InputMaybe<CaseWhere>;
  createdBy?: InputMaybe<UserWhere>;
  createdByAggregate?: InputMaybe<TaskCreatedByAggregateInput>;
  createdByConnection?: InputMaybe<TaskCreatedByConnectionWhere>;
  createdByConnection_NOT?: InputMaybe<TaskCreatedByConnectionWhere>;
  createdBy_NOT?: InputMaybe<UserWhere>;
  document?: InputMaybe<DocumentWhere>;
  documentAggregate?: InputMaybe<TaskDocumentAggregateInput>;
  documentConnection?: InputMaybe<TaskDocumentConnectionWhere>;
  documentConnection_NOT?: InputMaybe<TaskDocumentConnectionWhere>;
  document_NOT?: InputMaybe<DocumentWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<MessageWhere>;
  messageAggregate?: InputMaybe<TaskMessageAggregateInput>;
  messageConnection?: InputMaybe<TaskMessageConnectionWhere>;
  messageConnection_NOT?: InputMaybe<TaskMessageConnectionWhere>;
  message_NOT?: InputMaybe<MessageWhere>;
  taskContentDe?: InputMaybe<Scalars['String']['input']>;
  taskContentDe_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  taskContentDe_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  taskContentDe_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskContentDe_MATCHES?: InputMaybe<Scalars['String']['input']>;
  taskContentDe_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  taskContentEn?: InputMaybe<Scalars['String']['input']>;
  taskContentEn_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  taskContentEn_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  taskContentEn_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  taskContentEn_MATCHES?: InputMaybe<Scalars['String']['input']>;
  taskContentEn_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  taskStatus?: InputMaybe<TaskStatus>;
  taskStatus_IN?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
  tenantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  timeStamp?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_IN?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeStamp_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  triggerEventId_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_LTE?: InputMaybe<Scalars['Int']['input']>;
  usersRelationshipAggregate?: InputMaybe<TaskUsersRelationshipAggregateInput>;
  /** Return Tasks where all of the related TaskUsersRelationshipConnections match this filter */
  usersRelationshipConnection_ALL?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
  /** Return Tasks where none of the related TaskUsersRelationshipConnections match this filter */
  usersRelationshipConnection_NONE?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
  /** Return Tasks where one of the related TaskUsersRelationshipConnections match this filter */
  usersRelationshipConnection_SINGLE?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
  /** Return Tasks where some of the related TaskUsersRelationshipConnections match this filter */
  usersRelationshipConnection_SOME?: InputMaybe<TaskUsersRelationshipConnectionWhere>;
  /** Return Tasks where all of the related Users match this filter */
  usersRelationship_ALL?: InputMaybe<UserWhere>;
  /** Return Tasks where none of the related Users match this filter */
  usersRelationship_NONE?: InputMaybe<UserWhere>;
  /** Return Tasks where one of the related Users match this filter */
  usersRelationship_SINGLE?: InputMaybe<UserWhere>;
  /** Return Tasks where some of the related Users match this filter */
  usersRelationship_SOME?: InputMaybe<UserWhere>;
};

export type TasksConnection = {
  __typename?: 'TasksConnection';
  edges: Array<TaskEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantSpecificAgreementUserRole = {
  __typename?: 'TenantSpecificAgreementUserRole';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  isAssignee?: Maybe<Scalars['Boolean']['output']>;
  node: User;
  role: AgreementUserRole;
};

export type TenantSpecificAgreementUserRoleAggregateSelection = {
  __typename?: 'TenantSpecificAgreementUserRoleAggregateSelection';
  count: Scalars['Int']['output'];
};

export type TenantSpecificAgreementUserRoleEdge = {
  __typename?: 'TenantSpecificAgreementUserRoleEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TenantSpecificAgreementUserRole;
};

export type TenantSpecificAgreementUserRoleOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TenantSpecificAgreementUserRoleSort objects to sort TenantSpecificAgreementUserRoles by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TenantSpecificAgreementUserRoleSort>>;
};

/** Fields to sort TenantSpecificAgreementUserRoles by. The order in which sorts are applied is not guaranteed when specifying many fields in one TenantSpecificAgreementUserRoleSort object. */
export type TenantSpecificAgreementUserRoleSort = {
  isAssignee?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
};

export type TenantSpecificAgreementUserRoleWhere = {
  AND?: InputMaybe<Array<TenantSpecificAgreementUserRoleWhere>>;
  NOT?: InputMaybe<TenantSpecificAgreementUserRoleWhere>;
  OR?: InputMaybe<Array<TenantSpecificAgreementUserRoleWhere>>;
  isAssignee?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgreementUserRole>;
  role_IN?: InputMaybe<Array<AgreementUserRole>>;
};

export type TenantSpecificAgreementUserRolesConnection = {
  __typename?: 'TenantSpecificAgreementUserRolesConnection';
  edges: Array<TenantSpecificAgreementUserRoleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum TestPurposeType {
  Baseline = 'BASELINE',
  Final = 'FINAL',
  Other = 'OTHER',
  Routine = 'ROUTINE'
}

export enum TestType {
  AbsoluteReticulocyteCount = 'ABSOLUTE_RETICULOCYTE_COUNT',
  Hemoglobin = 'HEMOGLOBIN',
  LactateDehydrogenase = 'LACTATE_DEHYDROGENASE',
  NeutrophilCount = 'NEUTROPHIL_COUNT',
  PlateletCount = 'PLATELET_COUNT'
}

export enum TestUoMType {
  GramsPerDecilitre = 'GRAMS_PER_DECILITRE',
  PerBillionPerLitre = 'PER_BILLION_PER_LITRE',
  PerMicrolitre = 'PER_MICROLITRE',
  TimesUln = 'TIMES_ULN'
}

export type ThresholdConfigurationRelationship = {
  threshold: Scalars['Int']['output'];
};

export type ThresholdConfigurationRelationshipSort = {
  threshold?: InputMaybe<SortDirection>;
};

export type ThresholdConfigurationRelationshipWhere = {
  AND?: InputMaybe<Array<ThresholdConfigurationRelationshipWhere>>;
  NOT?: InputMaybe<ThresholdConfigurationRelationshipWhere>;
  OR?: InputMaybe<Array<ThresholdConfigurationRelationshipWhere>>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  threshold_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  threshold_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export enum TimeframeRangeType {
  BetweenMedicalApprovalPlus_365 = 'BETWEEN_MEDICAL_APPROVAL_PLUS_365',
  Ever = 'EVER',
  StartingFrom = 'STARTING_FROM',
  UpTo = 'UP_TO',
  Within = 'WITHIN',
  WithinRollingRangeOf = 'WITHIN_ROLLING_RANGE_OF',
  WithinTherapyTrial = 'WITHIN_THERAPY_TRIAL',
  WithinTheCoveragePeriod = 'WITHIN_THE_COVERAGE_PERIOD',
  WithinTheLast = 'WITHIN_THE_LAST'
}

export enum TimeframeRelation {
  Before = 'BEFORE',
  StartingFrom = 'STARTING_FROM'
}

export enum TimeframeStartingPoint {
  AgreementStartDate = 'AGREEMENT_START_DATE',
  AgreementVersionStartDate = 'AGREEMENT_VERSION_START_DATE',
  CoveragePeriodStart = 'COVERAGE_PERIOD_START',
  DiscontinuationDate = 'DISCONTINUATION_DATE',
  FirstAdministrationDate = 'FIRST_ADMINISTRATION_DATE',
  FirstPrescriptionDate = 'FIRST_PRESCRIPTION_DATE',
  IntendedStartDate = 'INTENDED_START_DATE',
  ProgressionDate = 'PROGRESSION_DATE',
  RequestReceiptDate = 'REQUEST_RECEIPT_DATE',
  TherapyTrialStartDate = 'THERAPY_TRIAL_START_DATE',
  TreatmentStartDate = 'TREATMENT_START_DATE'
}

export enum TransfusionType {
  RedBloodCell = 'RED_BLOOD_CELL'
}

export type Translation = {
  __typename?: 'Translation';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  key: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TranslationAggregateSelection = {
  __typename?: 'TranslationAggregateSelection';
  count: Scalars['Int']['output'];
  key: StringAggregateSelectionNonNullable;
  languageCode: StringAggregateSelectionNonNullable;
  value: StringAggregateSelectionNonNullable;
};

export type TranslationEdge = {
  __typename?: 'TranslationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Translation;
};

export type TranslationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TranslationSort objects to sort Translations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TranslationSort>>;
};

/** Fields to sort Translations by. The order in which sorts are applied is not guaranteed when specifying many fields in one TranslationSort object. */
export type TranslationSort = {
  key?: InputMaybe<SortDirection>;
  languageCode?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
};

export type TranslationWhere = {
  AND?: InputMaybe<Array<TranslationWhere>>;
  NOT?: InputMaybe<TranslationWhere>;
  OR?: InputMaybe<Array<TranslationWhere>>;
  key?: InputMaybe<Scalars['String']['input']>;
  key_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  key_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  key_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  key_MATCHES?: InputMaybe<Scalars['String']['input']>;
  key_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  languageCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  languageCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  languageCode_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  languageCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  languageCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  value_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  value_MATCHES?: InputMaybe<Scalars['String']['input']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export enum Translations {
  De = 'DE',
  En = 'EN'
}

export type TranslationsConnection = {
  __typename?: 'TranslationsConnection';
  edges: Array<TranslationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TranslationsResult = {
  __typename?: 'TranslationsResult';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  de: Scalars['String']['output'];
  en: Scalars['String']['output'];
};

export type TranslationsResultAggregateSelection = {
  __typename?: 'TranslationsResultAggregateSelection';
  count: Scalars['Int']['output'];
  de: StringAggregateSelectionNonNullable;
  en: StringAggregateSelectionNonNullable;
};

export type TranslationsResultEdge = {
  __typename?: 'TranslationsResultEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TranslationsResult;
};

export type TranslationsResultOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TranslationsResultSort objects to sort TranslationsResults by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TranslationsResultSort>>;
};

/** Fields to sort TranslationsResults by. The order in which sorts are applied is not guaranteed when specifying many fields in one TranslationsResultSort object. */
export type TranslationsResultSort = {
  de?: InputMaybe<SortDirection>;
  en?: InputMaybe<SortDirection>;
};

export type TranslationsResultWhere = {
  AND?: InputMaybe<Array<TranslationsResultWhere>>;
  NOT?: InputMaybe<TranslationsResultWhere>;
  OR?: InputMaybe<Array<TranslationsResultWhere>>;
  de?: InputMaybe<Scalars['String']['input']>;
  de_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  de_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  de_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  de_MATCHES?: InputMaybe<Scalars['String']['input']>;
  de_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  en_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  en_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  en_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  en_MATCHES?: InputMaybe<Scalars['String']['input']>;
  en_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationsResultsConnection = {
  __typename?: 'TranslationsResultsConnection';
  edges: Array<TranslationsResultEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatingPhysician = {
  __typename?: 'TreatingPhysician';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hospitalName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  nr?: Maybe<Scalars['String']['output']>;
  phoneNo?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  title?: Maybe<TreatingPhysicianTitle>;
};

export type TreatingPhysicianAggregateSelection = {
  __typename?: 'TreatingPhysicianAggregateSelection';
  count: Scalars['Int']['output'];
  department: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  hospitalName: StringAggregateSelectionNullable;
  lastName: StringAggregateSelectionNonNullable;
  nr: StringAggregateSelectionNullable;
  phoneNo: StringAggregateSelectionNullable;
  place: StringAggregateSelectionNullable;
  postcode: StringAggregateSelectionNullable;
  street: StringAggregateSelectionNullable;
};

export type TreatingPhysicianEdge = {
  __typename?: 'TreatingPhysicianEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TreatingPhysician;
};

export type TreatingPhysicianOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreatingPhysicianSort objects to sort TreatingPhysicians by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreatingPhysicianSort>>;
};

/** Fields to sort TreatingPhysicians by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatingPhysicianSort object. */
export type TreatingPhysicianSort = {
  department?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  hospitalName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  nr?: InputMaybe<SortDirection>;
  phoneNo?: InputMaybe<SortDirection>;
  place?: InputMaybe<SortDirection>;
  postcode?: InputMaybe<SortDirection>;
  street?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
};

export enum TreatingPhysicianTitle {
  Doctor = 'DOCTOR',
  Professor = 'PROFESSOR'
}

export type TreatingPhysicianWhere = {
  AND?: InputMaybe<Array<TreatingPhysicianWhere>>;
  NOT?: InputMaybe<TreatingPhysicianWhere>;
  OR?: InputMaybe<Array<TreatingPhysicianWhere>>;
  department?: InputMaybe<Scalars['String']['input']>;
  department_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  department_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  department_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  department_MATCHES?: InputMaybe<Scalars['String']['input']>;
  department_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hospitalName?: InputMaybe<Scalars['String']['input']>;
  hospitalName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  hospitalName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  hospitalName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hospitalName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  hospitalName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nr?: InputMaybe<Scalars['String']['input']>;
  nr_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  nr_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  nr_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nr_MATCHES?: InputMaybe<Scalars['String']['input']>;
  nr_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  phoneNo?: InputMaybe<Scalars['String']['input']>;
  phoneNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  phoneNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  phoneNo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  phoneNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  place_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  place_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  place_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  place_MATCHES?: InputMaybe<Scalars['String']['input']>;
  place_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  postcode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  postcode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postcode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  postcode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  street_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  street_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  street_MATCHES?: InputMaybe<Scalars['String']['input']>;
  street_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<TreatingPhysicianTitle>;
  title_IN?: InputMaybe<Array<InputMaybe<TreatingPhysicianTitle>>>;
};

export type TreatingPhysiciansConnection = {
  __typename?: 'TreatingPhysiciansConnection';
  edges: Array<TreatingPhysicianEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Treatment = {
  __typename?: 'Treatment';
  BagDossierNo?: Maybe<Scalars['String']['output']>;
  Code: Scalars['String']['output'];
  DIN?: Maybe<Scalars['String']['output']>;
  FlagModal?: Maybe<Scalars['String']['output']>;
  FlagNarcosis?: Maybe<Scalars['String']['output']>;
  GTIN?: Maybe<Scalars['String']['output']>;
  LOT?: Maybe<Scalars['String']['output']>;
  NDC?: Maybe<Scalars['String']['output']>;
  Name: Scalars['String']['output'];
  Partners: Array<Partner>;
  PartnersAggregate?: Maybe<TreatmentPartnerPartnersAggregationSelection>;
  PartnersConnection: TreatmentPartnersConnection;
  PharmaCode?: Maybe<Scalars['String']['output']>;
  PrevPharmacode?: Maybe<Scalars['String']['output']>;
  REF?: Maybe<Scalars['String']['output']>;
  Status?: Maybe<PreparationStatus>;
  StatusAggregate?: Maybe<TreatmentPreparationStatusStatusAggregationSelection>;
  StatusConnection: TreatmentStatusConnection;
  SwissmedicCategory?: Maybe<Scalars['String']['output']>;
  SwissmedicNo8?: Maybe<Scalars['String']['output']>;
  UDI?: Maybe<Scalars['String']['output']>;
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  activeIngredientQuantity?: Maybe<Scalars['Float']['output']>;
  canBeMain?: Maybe<Scalars['Boolean']['output']>;
  classificationSystem?: Maybe<Scalars['String']['output']>;
  codeCategories: Array<CodeCategory>;
  concentration?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryAggregate?: Maybe<TreatmentCountryCountryAggregationSelection>;
  countryConnection: TreatmentCountryConnection;
  hasLimitations: Array<Limitation>;
  hasLimitationsAggregate?: Maybe<TreatmentLimitationHasLimitationsAggregationSelection>;
  hasLimitationsConnection: TreatmentHasLimitationsConnection;
  newCode?: Maybe<Scalars['String']['output']>;
  packVolume?: Maybe<Scalars['String']['output']>;
  packVolumeUoMType?: Maybe<PackVolumeUoMType>;
  prices: Array<Price>;
  pricesAggregate?: Maybe<TreatmentPricePricesAggregationSelection>;
  pricesConnection: TreatmentPricesConnection;
  regulatedBy: Preparation;
  regulatedByAggregate?: Maybe<TreatmentPreparationRegulatedByAggregationSelection>;
  regulatedByConnection: TreatmentRegulatedByConnection;
  uoMType?: Maybe<UoMType>;
};


export type TreatmentPartnersArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PartnerOptions>;
  where?: InputMaybe<PartnerWhere>;
};


export type TreatmentPartnersAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PartnerWhere>;
};


export type TreatmentPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentPartnersConnectionSort>>;
  where?: InputMaybe<TreatmentPartnersConnectionWhere>;
};


export type TreatmentStatusArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationStatusOptions>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type TreatmentStatusAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationStatusWhere>;
};


export type TreatmentStatusConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentStatusConnectionSort>>;
  where?: InputMaybe<TreatmentStatusConnectionWhere>;
};


export type TreatmentCountryArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<CountryOptions>;
  where?: InputMaybe<CountryWhere>;
};


export type TreatmentCountryAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountryWhere>;
};


export type TreatmentCountryConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentCountryConnectionSort>>;
  where?: InputMaybe<TreatmentCountryConnectionWhere>;
};


export type TreatmentHasLimitationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<LimitationOptions>;
  where?: InputMaybe<LimitationWhere>;
};


export type TreatmentHasLimitationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LimitationWhere>;
};


export type TreatmentHasLimitationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentHasLimitationsConnectionSort>>;
  where?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
};


export type TreatmentPricesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PriceOptions>;
  where?: InputMaybe<PriceWhere>;
};


export type TreatmentPricesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PriceWhere>;
};


export type TreatmentPricesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentPricesConnectionSort>>;
  where?: InputMaybe<TreatmentPricesConnectionWhere>;
};


export type TreatmentRegulatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentRegulatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentRegulatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentRegulatedByConnectionSort>>;
  where?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
};

export type TreatmentAggregateSelection = {
  __typename?: 'TreatmentAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  count: Scalars['Int']['output'];
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type TreatmentCountryAggregateInput = {
  AND?: InputMaybe<Array<TreatmentCountryAggregateInput>>;
  NOT?: InputMaybe<TreatmentCountryAggregateInput>;
  OR?: InputMaybe<Array<TreatmentCountryAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentCountryNodeAggregationWhereInput>;
};

export type TreatmentCountryConnection = {
  __typename?: 'TreatmentCountryConnection';
  edges: Array<TreatmentCountryRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentCountryConnectionSort = {
  node?: InputMaybe<CountrySort>;
};

export type TreatmentCountryConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentCountryConnectionWhere>>;
  NOT?: InputMaybe<TreatmentCountryConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentCountryConnectionWhere>>;
  node?: InputMaybe<CountryWhere>;
};

export type TreatmentCountryCountryAggregationSelection = {
  __typename?: 'TreatmentCountryCountryAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentCountryCountryNodeAggregateSelection>;
};

export type TreatmentCountryCountryNodeAggregateSelection = {
  __typename?: 'TreatmentCountryCountryNodeAggregateSelection';
  alpha2Code: StringAggregateSelectionNonNullable;
  alpha3Code: StringAggregateSelectionNonNullable;
  flag: StringAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  numericCode: StringAggregateSelectionNonNullable;
};

export type TreatmentCountryNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentCountryNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentCountryNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentCountryNodeAggregationWhereInput>>;
  alpha2Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha2Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha2Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  alpha3Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  alpha3Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flag_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flag_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flag_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  numericCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  numericCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  numericCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentCountryRelationship = {
  __typename?: 'TreatmentCountryRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Country;
};

export enum TreatmentDiscontinuationReason {
  AnotherTherapyStart = 'ANOTHER_THERAPY_START',
  Any = 'ANY',
  NonAdherence = 'NON_ADHERENCE',
  NoInfo = 'NO_INFO',
  PatientDeath = 'PATIENT_DEATH',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  Trae = 'TRAE'
}

export enum TreatmentDurationConditionAspect {
  Discontinued = 'DISCONTINUED',
  Lasted = 'LASTED'
}

export type TreatmentEdge = {
  __typename?: 'TreatmentEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type TreatmentHasLimitationsAggregateInput = {
  AND?: InputMaybe<Array<TreatmentHasLimitationsAggregateInput>>;
  NOT?: InputMaybe<TreatmentHasLimitationsAggregateInput>;
  OR?: InputMaybe<Array<TreatmentHasLimitationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentHasLimitationsNodeAggregationWhereInput>;
};

export type TreatmentHasLimitationsConnection = {
  __typename?: 'TreatmentHasLimitationsConnection';
  edges: Array<TreatmentHasLimitationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentHasLimitationsConnectionSort = {
  node?: InputMaybe<LimitationSort>;
};

export type TreatmentHasLimitationsConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentHasLimitationsConnectionWhere>>;
  NOT?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentHasLimitationsConnectionWhere>>;
  node?: InputMaybe<LimitationWhere>;
};

export type TreatmentHasLimitationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentHasLimitationsNodeAggregationWhereInput>>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentHasLimitationsNodeAggregationWhereInput>;
  Niveau_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Niveau_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Niveau_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Niveau_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<TreatmentHasLimitationsNodeAggregationWhereInput>>;
  Type_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Type_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Type_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Type_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentHasLimitationsRelationship = {
  __typename?: 'TreatmentHasLimitationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Limitation;
};

export type TreatmentLimitationHasLimitationsAggregationSelection = {
  __typename?: 'TreatmentLimitationHasLimitationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentLimitationHasLimitationsNodeAggregateSelection>;
};

export type TreatmentLimitationHasLimitationsNodeAggregateSelection = {
  __typename?: 'TreatmentLimitationHasLimitationsNodeAggregateSelection';
  Code: StringAggregateSelectionNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionEn: StringAggregateSelectionNullable;
  Niveau: StringAggregateSelectionNullable;
  Type: StringAggregateSelectionNullable;
  uuid: IdAggregateSelectionNonNullable;
};

export type TreatmentOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreatmentSort objects to sort Treatments by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreatmentSort>>;
};

export type TreatmentPartnerPartnersAggregationSelection = {
  __typename?: 'TreatmentPartnerPartnersAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPartnerPartnersNodeAggregateSelection>;
};

export type TreatmentPartnerPartnersNodeAggregateSelection = {
  __typename?: 'TreatmentPartnerPartnersNodeAggregateSelection';
  Description: StringAggregateSelectionNullable;
  PartnerType: StringAggregateSelectionNullable;
  Phone: StringAggregateSelectionNullable;
  Place: StringAggregateSelectionNullable;
  Street: StringAggregateSelectionNullable;
  ZipCode: IntAggregateSelectionNullable;
};

export type TreatmentPartnersAggregateInput = {
  AND?: InputMaybe<Array<TreatmentPartnersAggregateInput>>;
  NOT?: InputMaybe<TreatmentPartnersAggregateInput>;
  OR?: InputMaybe<Array<TreatmentPartnersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentPartnersNodeAggregationWhereInput>;
};

export type TreatmentPartnersConnection = {
  __typename?: 'TreatmentPartnersConnection';
  edges: Array<TreatmentPartnersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentPartnersConnectionSort = {
  node?: InputMaybe<PartnerSort>;
};

export type TreatmentPartnersConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentPartnersConnectionWhere>>;
  NOT?: InputMaybe<TreatmentPartnersConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentPartnersConnectionWhere>>;
  node?: InputMaybe<PartnerWhere>;
};

export type TreatmentPartnersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentPartnersNodeAggregationWhereInput>>;
  Description_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Description_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Description_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Description_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Description_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentPartnersNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentPartnersNodeAggregationWhereInput>>;
  PartnerType_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PartnerType_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PartnerType_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Phone_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Phone_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Phone_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Phone_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Place_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Place_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Place_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Place_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Place_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Street_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Street_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Street_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Street_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Street_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  ZipCode_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  ZipCode_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentPartnersRelationship = {
  __typename?: 'TreatmentPartnersRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Partner;
};

export type TreatmentPatient = {
  __typename?: 'TreatmentPatient';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  days: Scalars['Int']['output'];
  noInactivePatients: Scalars['Int']['output'];
  noPatients: Scalars['Int']['output'];
};

export type TreatmentPatientAggregateSelection = {
  __typename?: 'TreatmentPatientAggregateSelection';
  count: Scalars['Int']['output'];
  days: IntAggregateSelectionNonNullable;
  noInactivePatients: IntAggregateSelectionNonNullable;
  noPatients: IntAggregateSelectionNonNullable;
};

export type TreatmentPatientEdge = {
  __typename?: 'TreatmentPatientEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TreatmentPatient;
};

export type TreatmentPatientOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreatmentPatientSort objects to sort TreatmentPatients by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreatmentPatientSort>>;
};

/** Fields to sort TreatmentPatients by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentPatientSort object. */
export type TreatmentPatientSort = {
  days?: InputMaybe<SortDirection>;
  noInactivePatients?: InputMaybe<SortDirection>;
  noPatients?: InputMaybe<SortDirection>;
};

export type TreatmentPatientWhere = {
  AND?: InputMaybe<Array<TreatmentPatientWhere>>;
  NOT?: InputMaybe<TreatmentPatientWhere>;
  OR?: InputMaybe<Array<TreatmentPatientWhere>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  days_GT?: InputMaybe<Scalars['Int']['input']>;
  days_GTE?: InputMaybe<Scalars['Int']['input']>;
  days_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  days_LT?: InputMaybe<Scalars['Int']['input']>;
  days_LTE?: InputMaybe<Scalars['Int']['input']>;
  noInactivePatients?: InputMaybe<Scalars['Int']['input']>;
  noInactivePatients_GT?: InputMaybe<Scalars['Int']['input']>;
  noInactivePatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  noInactivePatients_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  noInactivePatients_LT?: InputMaybe<Scalars['Int']['input']>;
  noInactivePatients_LTE?: InputMaybe<Scalars['Int']['input']>;
  noPatients?: InputMaybe<Scalars['Int']['input']>;
  noPatients_GT?: InputMaybe<Scalars['Int']['input']>;
  noPatients_GTE?: InputMaybe<Scalars['Int']['input']>;
  noPatients_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  noPatients_LT?: InputMaybe<Scalars['Int']['input']>;
  noPatients_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentPatientsConnection = {
  __typename?: 'TreatmentPatientsConnection';
  edges: Array<TreatmentPatientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentPreparationRegulatedByAggregationSelection = {
  __typename?: 'TreatmentPreparationRegulatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPreparationRegulatedByNodeAggregateSelection>;
};

export type TreatmentPreparationRegulatedByNodeAggregateSelection = {
  __typename?: 'TreatmentPreparationRegulatedByNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type TreatmentPreparationStatusStatusAggregationSelection = {
  __typename?: 'TreatmentPreparationStatusStatusAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPreparationStatusStatusNodeAggregateSelection>;
};

export type TreatmentPreparationStatusStatusNodeAggregateSelection = {
  __typename?: 'TreatmentPreparationStatusStatusNodeAggregateSelection';
  FlagApd: StringAggregateSelectionNullable;
  StatusTypeCodeSl: StringAggregateSelectionNullable;
  StatusTypeDescriptionSl: StringAggregateSelectionNullable;
};

export type TreatmentPricePricesAggregationSelection = {
  __typename?: 'TreatmentPricePricesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentPricePricesNodeAggregateSelection>;
};

export type TreatmentPricePricesNodeAggregateSelection = {
  __typename?: 'TreatmentPricePricesNodeAggregateSelection';
  Price: StringAggregateSelectionNonNullable;
  PriceChangeTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceChangeTypeDescriptionIt: StringAggregateSelectionNullable;
  PriceTypeDescriptionDe: StringAggregateSelectionNullable;
  PriceTypeDescriptionFr: StringAggregateSelectionNullable;
  PriceTypeDescriptionIt: StringAggregateSelectionNullable;
  countriesConsidered: StringAggregateSelectionNullable;
  uniqueCode: StringAggregateSelectionNonNullable;
};

export type TreatmentPricesAggregateInput = {
  AND?: InputMaybe<Array<TreatmentPricesAggregateInput>>;
  NOT?: InputMaybe<TreatmentPricesAggregateInput>;
  OR?: InputMaybe<Array<TreatmentPricesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentPricesNodeAggregationWhereInput>;
};

export type TreatmentPricesConnection = {
  __typename?: 'TreatmentPricesConnection';
  edges: Array<TreatmentPricesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentPricesConnectionSort = {
  node?: InputMaybe<PriceSort>;
};

export type TreatmentPricesConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentPricesConnectionWhere>>;
  NOT?: InputMaybe<TreatmentPricesConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentPricesConnectionWhere>>;
  node?: InputMaybe<PriceWhere>;
};

export type TreatmentPricesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentPricesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentPricesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentPricesNodeAggregationWhereInput>>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceChangeTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PriceTypeDescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Price_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Price_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Price_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  countriesConsidered_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  countriesConsidered_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uniqueCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uniqueCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentPricesRelationship = {
  __typename?: 'TreatmentPricesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Price;
};

export type TreatmentRegulatedByAggregateInput = {
  AND?: InputMaybe<Array<TreatmentRegulatedByAggregateInput>>;
  NOT?: InputMaybe<TreatmentRegulatedByAggregateInput>;
  OR?: InputMaybe<Array<TreatmentRegulatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentRegulatedByNodeAggregationWhereInput>;
};

export type TreatmentRegulatedByConnection = {
  __typename?: 'TreatmentRegulatedByConnection';
  edges: Array<TreatmentRegulatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentRegulatedByConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type TreatmentRegulatedByConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentRegulatedByConnectionWhere>>;
  NOT?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentRegulatedByConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type TreatmentRegulatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentRegulatedByNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentRegulatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentRegulatedByNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentRegulatedByRelationship = {
  __typename?: 'TreatmentRegulatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type TreatmentSet = {
  __typename?: 'TreatmentSet';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  generic: Generic;
  genericAggregate?: Maybe<TreatmentSetGenericGenericAggregationSelection>;
  genericConnection: TreatmentSetGenericConnection;
  isFixedPriceTarget: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  preparations: Array<Preparation>;
  preparationsAggregate?: Maybe<TreatmentSetPreparationPreparationsAggregationSelection>;
  preparationsConnection: TreatmentSetPreparationsConnection;
  scope: AgreementScope;
  scopeAggregate?: Maybe<TreatmentSetAgreementScopeScopeAggregationSelection>;
  scopeConnection: TreatmentSetScopeConnection;
  treatments: Array<Treatment>;
  treatmentsAggregate?: Maybe<TreatmentSetTreatmentTreatmentsAggregationSelection>;
  treatmentsConnection: TreatmentSetTreatmentsConnection;
};


export type TreatmentSetGenericArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<GenericOptions>;
  where?: InputMaybe<GenericWhere>;
};


export type TreatmentSetGenericAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericWhere>;
};


export type TreatmentSetGenericConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetGenericConnectionSort>>;
  where?: InputMaybe<TreatmentSetGenericConnectionWhere>;
};


export type TreatmentSetPreparationsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PreparationOptions>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentSetPreparationsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PreparationWhere>;
};


export type TreatmentSetPreparationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetPreparationsConnectionSort>>;
  where?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
};


export type TreatmentSetScopeArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementScopeOptions>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type TreatmentSetScopeAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementScopeWhere>;
};


export type TreatmentSetScopeConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetScopeConnectionSort>>;
  where?: InputMaybe<TreatmentSetScopeConnectionWhere>;
};


export type TreatmentSetTreatmentsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TreatmentOptions>;
  where?: InputMaybe<TreatmentWhere>;
};


export type TreatmentSetTreatmentsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TreatmentWhere>;
};


export type TreatmentSetTreatmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<TreatmentSetTreatmentsConnectionSort>>;
  where?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
};

export type TreatmentSetAggregateSelection = {
  __typename?: 'TreatmentSetAggregateSelection';
  count: Scalars['Int']['output'];
  order: IntAggregateSelectionNonNullable;
};

export type TreatmentSetAgreementScopeScopeAggregationSelection = {
  __typename?: 'TreatmentSetAgreementScopeScopeAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetAgreementScopeScopeNodeAggregateSelection>;
};

export type TreatmentSetAgreementScopeScopeNodeAggregateSelection = {
  __typename?: 'TreatmentSetAgreementScopeScopeNodeAggregateSelection';
  code: StringAggregateSelectionNonNullable;
  order: IntAggregateSelectionNonNullable;
  scopeId: StringAggregateSelectionNonNullable;
};

export type TreatmentSetEdge = {
  __typename?: 'TreatmentSetEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: TreatmentSet;
};

export type TreatmentSetGenericAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetGenericAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetGenericAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetGenericAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetGenericNodeAggregationWhereInput>;
};

export type TreatmentSetGenericConnection = {
  __typename?: 'TreatmentSetGenericConnection';
  edges: Array<TreatmentSetGenericRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetGenericConnectionSort = {
  node?: InputMaybe<GenericSort>;
};

export type TreatmentSetGenericConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetGenericConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetGenericConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetGenericConnectionWhere>>;
  node?: InputMaybe<GenericWhere>;
};

export type TreatmentSetGenericGenericAggregationSelection = {
  __typename?: 'TreatmentSetGenericGenericAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetGenericGenericNodeAggregateSelection>;
};

export type TreatmentSetGenericGenericNodeAggregateSelection = {
  __typename?: 'TreatmentSetGenericGenericNodeAggregateSelection';
  Name: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type TreatmentSetGenericNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetGenericNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentSetGenericNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<TreatmentSetGenericNodeAggregationWhereInput>>;
};

export type TreatmentSetGenericRelationship = {
  __typename?: 'TreatmentSetGenericRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Generic;
};

export type TreatmentSetOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more TreatmentSetSort objects to sort TreatmentSets by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<TreatmentSetSort>>;
};

export type TreatmentSetPreparationPreparationsAggregationSelection = {
  __typename?: 'TreatmentSetPreparationPreparationsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetPreparationPreparationsNodeAggregateSelection>;
};

export type TreatmentSetPreparationPreparationsNodeAggregateSelection = {
  __typename?: 'TreatmentSetPreparationPreparationsNodeAggregateSelection';
  AtcCode: StringAggregateSelectionNullable;
  BrandName: StringAggregateSelectionNonNullable;
  DescriptionDe: StringAggregateSelectionNullable;
  DescriptionFr: StringAggregateSelectionNullable;
  DescriptionIt: StringAggregateSelectionNullable;
  GenericName: StringAggregateSelectionNullable;
  SwissmedicNo5: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
};

export type TreatmentSetPreparationsAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetPreparationsAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetPreparationsAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetPreparationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetPreparationsNodeAggregationWhereInput>;
};

export type TreatmentSetPreparationsConnection = {
  __typename?: 'TreatmentSetPreparationsConnection';
  edges: Array<TreatmentSetPreparationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetPreparationsConnectionSort = {
  node?: InputMaybe<PreparationSort>;
};

export type TreatmentSetPreparationsConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetPreparationsConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetPreparationsConnectionWhere>>;
  node?: InputMaybe<PreparationWhere>;
};

export type TreatmentSetPreparationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetPreparationsNodeAggregationWhereInput>>;
  AtcCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  AtcCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  AtcCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BrandName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BrandName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BrandName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionFr_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionFr_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DescriptionIt_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DescriptionIt_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GenericName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GenericName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GenericName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentSetPreparationsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentSetPreparationsNodeAggregationWhereInput>>;
  SwissmedicNo5_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo5_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentSetPreparationsRelationship = {
  __typename?: 'TreatmentSetPreparationsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Preparation;
};

export type TreatmentSetScopeAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetScopeAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetScopeAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetScopeAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetScopeNodeAggregationWhereInput>;
};

export type TreatmentSetScopeConnection = {
  __typename?: 'TreatmentSetScopeConnection';
  edges: Array<TreatmentSetScopeRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetScopeConnectionSort = {
  node?: InputMaybe<AgreementScopeSort>;
};

export type TreatmentSetScopeConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetScopeConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetScopeConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetScopeConnectionWhere>>;
  node?: InputMaybe<AgreementScopeWhere>;
};

export type TreatmentSetScopeNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetScopeNodeAggregationWhereInput>>;
  NOT?: InputMaybe<TreatmentSetScopeNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentSetScopeNodeAggregationWhereInput>>;
  code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  scopeId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  scopeId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  scopeId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentSetScopeRelationship = {
  __typename?: 'TreatmentSetScopeRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementScope;
};

/** Fields to sort TreatmentSets by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentSetSort object. */
export type TreatmentSetSort = {
  isFixedPriceTarget?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type TreatmentSetTreatmentTreatmentsAggregationSelection = {
  __typename?: 'TreatmentSetTreatmentTreatmentsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<TreatmentSetTreatmentTreatmentsNodeAggregateSelection>;
};

export type TreatmentSetTreatmentTreatmentsNodeAggregateSelection = {
  __typename?: 'TreatmentSetTreatmentTreatmentsNodeAggregateSelection';
  BagDossierNo: StringAggregateSelectionNullable;
  Code: StringAggregateSelectionNonNullable;
  DIN: StringAggregateSelectionNullable;
  FlagModal: StringAggregateSelectionNullable;
  FlagNarcosis: StringAggregateSelectionNullable;
  GTIN: StringAggregateSelectionNullable;
  LOT: StringAggregateSelectionNullable;
  NDC: StringAggregateSelectionNullable;
  Name: StringAggregateSelectionNonNullable;
  PharmaCode: StringAggregateSelectionNullable;
  PrevPharmacode: StringAggregateSelectionNullable;
  REF: StringAggregateSelectionNullable;
  SwissmedicCategory: StringAggregateSelectionNullable;
  SwissmedicNo8: StringAggregateSelectionNullable;
  UDI: StringAggregateSelectionNullable;
  activeIngredientQuantity: FloatAggregateSelectionNullable;
  classificationSystem: StringAggregateSelectionNullable;
  concentration: StringAggregateSelectionNullable;
  newCode: StringAggregateSelectionNullable;
  packVolume: StringAggregateSelectionNullable;
};

export type TreatmentSetTreatmentsAggregateInput = {
  AND?: InputMaybe<Array<TreatmentSetTreatmentsAggregateInput>>;
  NOT?: InputMaybe<TreatmentSetTreatmentsAggregateInput>;
  OR?: InputMaybe<Array<TreatmentSetTreatmentsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentSetTreatmentsNodeAggregationWhereInput>;
};

export type TreatmentSetTreatmentsConnection = {
  __typename?: 'TreatmentSetTreatmentsConnection';
  edges: Array<TreatmentSetTreatmentsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentSetTreatmentsConnectionSort = {
  node?: InputMaybe<TreatmentSort>;
};

export type TreatmentSetTreatmentsConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentSetTreatmentsConnectionWhere>>;
  NOT?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentSetTreatmentsConnectionWhere>>;
  node?: InputMaybe<TreatmentWhere>;
};

export type TreatmentSetTreatmentsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentSetTreatmentsNodeAggregationWhereInput>>;
  BagDossierNo_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  BagDossierNo_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  BagDossierNo_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Code_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Code_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Code_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  DIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  DIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  DIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagModal_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagModal_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagNarcosis_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagNarcosis_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  GTIN_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  GTIN_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  GTIN_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  LOT_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  LOT_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  LOT_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  NDC_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  NDC_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  NDC_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentSetTreatmentsNodeAggregationWhereInput>;
  Name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  Name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  Name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  Name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  OR?: InputMaybe<Array<TreatmentSetTreatmentsNodeAggregationWhereInput>>;
  PharmaCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PharmaCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PharmaCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  PrevPharmacode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  PrevPharmacode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  REF_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  REF_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  REF_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicCategory_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  SwissmedicNo8_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  UDI_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  UDI_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  UDI_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  activeIngredientQuantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  classificationSystem_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  classificationSystem_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  concentration_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  concentration_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  concentration_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  newCode_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  newCode_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  newCode_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  packVolume_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  packVolume_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  packVolume_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentSetTreatmentsRelationship = {
  __typename?: 'TreatmentSetTreatmentsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Treatment;
};

export type TreatmentSetWhere = {
  AND?: InputMaybe<Array<TreatmentSetWhere>>;
  NOT?: InputMaybe<TreatmentSetWhere>;
  OR?: InputMaybe<Array<TreatmentSetWhere>>;
  generic?: InputMaybe<GenericWhere>;
  genericAggregate?: InputMaybe<TreatmentSetGenericAggregateInput>;
  genericConnection?: InputMaybe<TreatmentSetGenericConnectionWhere>;
  genericConnection_NOT?: InputMaybe<TreatmentSetGenericConnectionWhere>;
  generic_NOT?: InputMaybe<GenericWhere>;
  isFixedPriceTarget?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationsAggregate?: InputMaybe<TreatmentSetPreparationsAggregateInput>;
  /** Return TreatmentSets where all of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_ALL?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where none of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_NONE?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where one of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_SINGLE?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where some of the related TreatmentSetPreparationsConnections match this filter */
  preparationsConnection_SOME?: InputMaybe<TreatmentSetPreparationsConnectionWhere>;
  /** Return TreatmentSets where all of the related Preparations match this filter */
  preparations_ALL?: InputMaybe<PreparationWhere>;
  /** Return TreatmentSets where none of the related Preparations match this filter */
  preparations_NONE?: InputMaybe<PreparationWhere>;
  /** Return TreatmentSets where one of the related Preparations match this filter */
  preparations_SINGLE?: InputMaybe<PreparationWhere>;
  /** Return TreatmentSets where some of the related Preparations match this filter */
  preparations_SOME?: InputMaybe<PreparationWhere>;
  scope?: InputMaybe<AgreementScopeWhere>;
  scopeAggregate?: InputMaybe<TreatmentSetScopeAggregateInput>;
  scopeConnection?: InputMaybe<TreatmentSetScopeConnectionWhere>;
  scopeConnection_NOT?: InputMaybe<TreatmentSetScopeConnectionWhere>;
  scope_NOT?: InputMaybe<AgreementScopeWhere>;
  treatmentsAggregate?: InputMaybe<TreatmentSetTreatmentsAggregateInput>;
  /** Return TreatmentSets where all of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_ALL?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where none of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_NONE?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where one of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_SINGLE?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where some of the related TreatmentSetTreatmentsConnections match this filter */
  treatmentsConnection_SOME?: InputMaybe<TreatmentSetTreatmentsConnectionWhere>;
  /** Return TreatmentSets where all of the related Treatments match this filter */
  treatments_ALL?: InputMaybe<TreatmentWhere>;
  /** Return TreatmentSets where none of the related Treatments match this filter */
  treatments_NONE?: InputMaybe<TreatmentWhere>;
  /** Return TreatmentSets where one of the related Treatments match this filter */
  treatments_SINGLE?: InputMaybe<TreatmentWhere>;
  /** Return TreatmentSets where some of the related Treatments match this filter */
  treatments_SOME?: InputMaybe<TreatmentWhere>;
};

export type TreatmentSetsConnection = {
  __typename?: 'TreatmentSetsConnection';
  edges: Array<TreatmentSetEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Fields to sort Treatments by. The order in which sorts are applied is not guaranteed when specifying many fields in one TreatmentSort object. */
export type TreatmentSort = {
  BagDossierNo?: InputMaybe<SortDirection>;
  Code?: InputMaybe<SortDirection>;
  DIN?: InputMaybe<SortDirection>;
  FlagModal?: InputMaybe<SortDirection>;
  FlagNarcosis?: InputMaybe<SortDirection>;
  GTIN?: InputMaybe<SortDirection>;
  LOT?: InputMaybe<SortDirection>;
  NDC?: InputMaybe<SortDirection>;
  Name?: InputMaybe<SortDirection>;
  PharmaCode?: InputMaybe<SortDirection>;
  PrevPharmacode?: InputMaybe<SortDirection>;
  REF?: InputMaybe<SortDirection>;
  SwissmedicCategory?: InputMaybe<SortDirection>;
  SwissmedicNo8?: InputMaybe<SortDirection>;
  UDI?: InputMaybe<SortDirection>;
  activeIngredientQuantity?: InputMaybe<SortDirection>;
  canBeMain?: InputMaybe<SortDirection>;
  classificationSystem?: InputMaybe<SortDirection>;
  concentration?: InputMaybe<SortDirection>;
  newCode?: InputMaybe<SortDirection>;
  packVolume?: InputMaybe<SortDirection>;
  packVolumeUoMType?: InputMaybe<SortDirection>;
  uoMType?: InputMaybe<SortDirection>;
};

export type TreatmentStatusAggregateInput = {
  AND?: InputMaybe<Array<TreatmentStatusAggregateInput>>;
  NOT?: InputMaybe<TreatmentStatusAggregateInput>;
  OR?: InputMaybe<Array<TreatmentStatusAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<TreatmentStatusNodeAggregationWhereInput>;
};

export type TreatmentStatusConnection = {
  __typename?: 'TreatmentStatusConnection';
  edges: Array<TreatmentStatusRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TreatmentStatusConnectionSort = {
  node?: InputMaybe<PreparationStatusSort>;
};

export type TreatmentStatusConnectionWhere = {
  AND?: InputMaybe<Array<TreatmentStatusConnectionWhere>>;
  NOT?: InputMaybe<TreatmentStatusConnectionWhere>;
  OR?: InputMaybe<Array<TreatmentStatusConnectionWhere>>;
  node?: InputMaybe<PreparationStatusWhere>;
};

export type TreatmentStatusNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<TreatmentStatusNodeAggregationWhereInput>>;
  FlagApd_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  FlagApd_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  FlagApd_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  NOT?: InputMaybe<TreatmentStatusNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<TreatmentStatusNodeAggregationWhereInput>>;
  StatusTypeCodeSl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeCodeSl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  StatusTypeDescriptionSl_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type TreatmentStatusRelationship = {
  __typename?: 'TreatmentStatusRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: PreparationStatus;
};

export type TreatmentWhere = {
  AND?: InputMaybe<Array<TreatmentWhere>>;
  BagDossierNo?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  BagDossierNo_MATCHES?: InputMaybe<Scalars['String']['input']>;
  BagDossierNo_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code?: InputMaybe<Scalars['String']['input']>;
  Code_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Code_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Code_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Code_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Code_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  DIN?: InputMaybe<Scalars['String']['input']>;
  DIN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  DIN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  DIN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  DIN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  DIN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagModal?: InputMaybe<Scalars['String']['input']>;
  FlagModal_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  FlagModal_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagModal_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FlagModal_MATCHES?: InputMaybe<Scalars['String']['input']>;
  FlagModal_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  FlagNarcosis_MATCHES?: InputMaybe<Scalars['String']['input']>;
  FlagNarcosis_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  GTIN?: InputMaybe<Scalars['String']['input']>;
  GTIN_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  GTIN_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  GTIN_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  GTIN_MATCHES?: InputMaybe<Scalars['String']['input']>;
  GTIN_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  LOT?: InputMaybe<Scalars['String']['input']>;
  LOT_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  LOT_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  LOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  LOT_MATCHES?: InputMaybe<Scalars['String']['input']>;
  LOT_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NDC?: InputMaybe<Scalars['String']['input']>;
  NDC_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  NDC_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  NDC_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  NDC_MATCHES?: InputMaybe<Scalars['String']['input']>;
  NDC_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<TreatmentWhere>;
  Name?: InputMaybe<Scalars['String']['input']>;
  Name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  Name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  Name_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  Name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  Name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  OR?: InputMaybe<Array<TreatmentWhere>>;
  PartnersAggregate?: InputMaybe<TreatmentPartnersAggregateInput>;
  /** Return Treatments where all of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_ALL?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where none of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_NONE?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where one of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_SINGLE?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where some of the related TreatmentPartnersConnections match this filter */
  PartnersConnection_SOME?: InputMaybe<TreatmentPartnersConnectionWhere>;
  /** Return Treatments where all of the related Partners match this filter */
  Partners_ALL?: InputMaybe<PartnerWhere>;
  /** Return Treatments where none of the related Partners match this filter */
  Partners_NONE?: InputMaybe<PartnerWhere>;
  /** Return Treatments where one of the related Partners match this filter */
  Partners_SINGLE?: InputMaybe<PartnerWhere>;
  /** Return Treatments where some of the related Partners match this filter */
  Partners_SOME?: InputMaybe<PartnerWhere>;
  PharmaCode?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PharmaCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PharmaCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  PrevPharmacode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  PrevPharmacode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  REF?: InputMaybe<Scalars['String']['input']>;
  REF_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  REF_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  REF_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  REF_MATCHES?: InputMaybe<Scalars['String']['input']>;
  REF_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  Status?: InputMaybe<PreparationStatusWhere>;
  StatusAggregate?: InputMaybe<TreatmentStatusAggregateInput>;
  StatusConnection?: InputMaybe<TreatmentStatusConnectionWhere>;
  StatusConnection_NOT?: InputMaybe<TreatmentStatusConnectionWhere>;
  Status_NOT?: InputMaybe<PreparationStatusWhere>;
  SwissmedicCategory?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SwissmedicCategory_MATCHES?: InputMaybe<Scalars['String']['input']>;
  SwissmedicCategory_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  SwissmedicNo8_MATCHES?: InputMaybe<Scalars['String']['input']>;
  SwissmedicNo8_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  UDI?: InputMaybe<Scalars['String']['input']>;
  UDI_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  UDI_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  UDI_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  UDI_MATCHES?: InputMaybe<Scalars['String']['input']>;
  UDI_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  activeIngredientQuantity?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_GT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_GTE?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  activeIngredientQuantity_LT?: InputMaybe<Scalars['Float']['input']>;
  activeIngredientQuantity_LTE?: InputMaybe<Scalars['Float']['input']>;
  canBeMain?: InputMaybe<Scalars['Boolean']['input']>;
  classificationSystem?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  classificationSystem_MATCHES?: InputMaybe<Scalars['String']['input']>;
  classificationSystem_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  codeCategories?: InputMaybe<Array<CodeCategory>>;
  codeCategories_INCLUDES?: InputMaybe<CodeCategory>;
  concentration?: InputMaybe<Scalars['String']['input']>;
  concentration_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  concentration_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  concentration_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  concentration_MATCHES?: InputMaybe<Scalars['String']['input']>;
  concentration_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryWhere>;
  countryAggregate?: InputMaybe<TreatmentCountryAggregateInput>;
  countryConnection?: InputMaybe<TreatmentCountryConnectionWhere>;
  countryConnection_NOT?: InputMaybe<TreatmentCountryConnectionWhere>;
  country_NOT?: InputMaybe<CountryWhere>;
  hasLimitationsAggregate?: InputMaybe<TreatmentHasLimitationsAggregateInput>;
  /** Return Treatments where all of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_ALL?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where none of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_NONE?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where one of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_SINGLE?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where some of the related TreatmentHasLimitationsConnections match this filter */
  hasLimitationsConnection_SOME?: InputMaybe<TreatmentHasLimitationsConnectionWhere>;
  /** Return Treatments where all of the related Limitations match this filter */
  hasLimitations_ALL?: InputMaybe<LimitationWhere>;
  /** Return Treatments where none of the related Limitations match this filter */
  hasLimitations_NONE?: InputMaybe<LimitationWhere>;
  /** Return Treatments where one of the related Limitations match this filter */
  hasLimitations_SINGLE?: InputMaybe<LimitationWhere>;
  /** Return Treatments where some of the related Limitations match this filter */
  hasLimitations_SOME?: InputMaybe<LimitationWhere>;
  newCode?: InputMaybe<Scalars['String']['input']>;
  newCode_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  newCode_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  newCode_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newCode_MATCHES?: InputMaybe<Scalars['String']['input']>;
  newCode_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  packVolume?: InputMaybe<Scalars['String']['input']>;
  packVolumeUoMType?: InputMaybe<PackVolumeUoMType>;
  packVolumeUoMType_IN?: InputMaybe<Array<InputMaybe<PackVolumeUoMType>>>;
  packVolume_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  packVolume_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  packVolume_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  packVolume_MATCHES?: InputMaybe<Scalars['String']['input']>;
  packVolume_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  pricesAggregate?: InputMaybe<TreatmentPricesAggregateInput>;
  /** Return Treatments where all of the related TreatmentPricesConnections match this filter */
  pricesConnection_ALL?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where none of the related TreatmentPricesConnections match this filter */
  pricesConnection_NONE?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where one of the related TreatmentPricesConnections match this filter */
  pricesConnection_SINGLE?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where some of the related TreatmentPricesConnections match this filter */
  pricesConnection_SOME?: InputMaybe<TreatmentPricesConnectionWhere>;
  /** Return Treatments where all of the related Prices match this filter */
  prices_ALL?: InputMaybe<PriceWhere>;
  /** Return Treatments where none of the related Prices match this filter */
  prices_NONE?: InputMaybe<PriceWhere>;
  /** Return Treatments where one of the related Prices match this filter */
  prices_SINGLE?: InputMaybe<PriceWhere>;
  /** Return Treatments where some of the related Prices match this filter */
  prices_SOME?: InputMaybe<PriceWhere>;
  regulatedBy?: InputMaybe<PreparationWhere>;
  regulatedByAggregate?: InputMaybe<TreatmentRegulatedByAggregateInput>;
  regulatedByConnection?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
  regulatedByConnection_NOT?: InputMaybe<TreatmentRegulatedByConnectionWhere>;
  regulatedBy_NOT?: InputMaybe<PreparationWhere>;
  uoMType?: InputMaybe<UoMType>;
  uoMType_IN?: InputMaybe<Array<InputMaybe<UoMType>>>;
};

export type TreatmentsConnection = {
  __typename?: 'TreatmentsConnection';
  edges: Array<TreatmentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UncertaintiesConnection = {
  __typename?: 'UncertaintiesConnection';
  edges: Array<UncertaintyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Uncertainty = {
  __typename?: 'Uncertainty';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UncertaintyAggregateSelection = {
  __typename?: 'UncertaintyAggregateSelection';
  count: Scalars['Int']['output'];
  explanation: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNullable;
  name: StringAggregateSelectionNullable;
};

export type UncertaintyEdge = {
  __typename?: 'UncertaintyEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Uncertainty;
};

export type UncertaintyOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UncertaintySort objects to sort Uncertainties by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UncertaintySort>>;
};

/** Fields to sort Uncertainties by. The order in which sorts are applied is not guaranteed when specifying many fields in one UncertaintySort object. */
export type UncertaintySort = {
  explanation?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
};

export type UncertaintyWhere = {
  AND?: InputMaybe<Array<UncertaintyWhere>>;
  NOT?: InputMaybe<UncertaintyWhere>;
  OR?: InputMaybe<Array<UncertaintyWhere>>;
  explanation?: InputMaybe<Scalars['String']['input']>;
  explanation_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  explanation_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  explanation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  explanation_MATCHES?: InputMaybe<Scalars['String']['input']>;
  explanation_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_MATCHES?: InputMaybe<Scalars['String']['input']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UnfurlUrl = {
  __typename?: 'UnfurlUrl';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type UnfurlUrlAggregateSelection = {
  __typename?: 'UnfurlUrlAggregateSelection';
  count: Scalars['Int']['output'];
  description: StringAggregateSelectionNullable;
  favicon: StringAggregateSelectionNullable;
  image: StringAggregateSelectionNullable;
  title: StringAggregateSelectionNullable;
  url: StringAggregateSelectionNullable;
};

export type UnfurlUrlEdge = {
  __typename?: 'UnfurlUrlEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UnfurlUrl;
};

export type UnfurlUrlOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UnfurlUrlSort objects to sort UnfurlUrls by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UnfurlUrlSort>>;
};

/** Fields to sort UnfurlUrls by. The order in which sorts are applied is not guaranteed when specifying many fields in one UnfurlUrlSort object. */
export type UnfurlUrlSort = {
  description?: InputMaybe<SortDirection>;
  favicon?: InputMaybe<SortDirection>;
  image?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  url?: InputMaybe<SortDirection>;
};

export type UnfurlUrlWhere = {
  AND?: InputMaybe<Array<UnfurlUrlWhere>>;
  NOT?: InputMaybe<UnfurlUrlWhere>;
  OR?: InputMaybe<Array<UnfurlUrlWhere>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_MATCHES?: InputMaybe<Scalars['String']['input']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  favicon_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  favicon_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  favicon_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favicon_MATCHES?: InputMaybe<Scalars['String']['input']>;
  favicon_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  image_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  image_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  image_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_MATCHES?: InputMaybe<Scalars['String']['input']>;
  image_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  title_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  title_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_MATCHES?: InputMaybe<Scalars['String']['input']>;
  title_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  url_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  url_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_MATCHES?: InputMaybe<Scalars['String']['input']>;
  url_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UnfurlUrlsConnection = {
  __typename?: 'UnfurlUrlsConnection';
  edges: Array<UnfurlUrlEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UniqueClaimsIdentifiers = {
  administrationDate?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  preparationId?: InputMaybe<Scalars['String']['input']>;
};

export type UniqueModulesColumns = {
  __typename?: 'UniqueModulesColumns';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  counterParties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  counterparties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdByName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  formattedTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preparationBrandNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UniqueModulesColumnsAggregateSelection = {
  __typename?: 'UniqueModulesColumnsAggregateSelection';
  count: Scalars['Int']['output'];
};

export type UniqueModulesColumnsConnection = {
  __typename?: 'UniqueModulesColumnsConnection';
  edges: Array<UniqueModulesColumnsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UniqueModulesColumnsEdge = {
  __typename?: 'UniqueModulesColumnsEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UniqueModulesColumns;
};

export type UniqueModulesColumnsOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UniqueModulesColumnsWhere = {
  AND?: InputMaybe<Array<UniqueModulesColumnsWhere>>;
  NOT?: InputMaybe<UniqueModulesColumnsWhere>;
  OR?: InputMaybe<Array<UniqueModulesColumnsWhere>>;
  counterParties?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterParties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  counterparties?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  counterparties_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  createdByName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdByName_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  formattedTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formattedTags_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  preparationBrandNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preparationBrandNames_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  products_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export enum UnitedResponseType {
  CompleteResponse = 'COMPLETE_RESPONSE',
  GoodResponse = 'GOOD_RESPONSE',
  MajorResponse = 'MAJOR_RESPONSE',
  MinorResponse = 'MINOR_RESPONSE',
  NoInfo = 'NO_INFO',
  NoPcr = 'NO_PCR',
  PartialResponse = 'PARTIAL_RESPONSE',
  PathologicalCompleteResponse = 'PATHOLOGICAL_COMPLETE_RESPONSE',
  ProgressiveDisease = 'PROGRESSIVE_DISEASE',
  StableDisease = 'STABLE_DISEASE'
}

export enum UoMType {
  Cur = 'CUR',
  Gram = 'GRAM',
  Milligram = 'MILLIGRAM',
  Millilitre = 'MILLILITRE',
  Pack = 'PACK'
}

export type UpdateCaseAssigneeInput = {
  assignees: Array<CaseAssigneeDataInput>;
  caseId: Scalars['ID']['input'];
};

export type UpdateDocumentPaymentFieldsInput = {
  beneficiary?: InputMaybe<DocumentBeneficiary>;
  documentId: Scalars['ID']['input'];
  paymentReceiptPayer?: InputMaybe<Scalars['Date']['input']>;
  paymentReferenceLyfegen?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDomainInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateInvoiceForReviewInput = {
  adjustedInvoiceAmount: Scalars['Float']['input'];
  deletedRefunds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  invoiceAmount: Scalars['Float']['input'];
  invoiceId: Scalars['ID']['input'];
  isAdjusted: Scalars['Boolean']['input'];
  receiverEmail?: InputMaybe<Scalars['String']['input']>;
  refunds: Array<Scalars['ID']['input']>;
  reviewerOrganization: Scalars['String']['input'];
  useCC?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Upload = {
  __typename?: 'Upload';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  flexEntities: Array<FlexEntity>;
  flexEntitiesAggregate?: Maybe<UploadFlexEntityFlexEntitiesAggregationSelection>;
  flexEntitiesConnection: UploadFlexEntitiesConnection;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
};


export type UploadFlexEntitiesArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<FlexEntityOptions>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type UploadFlexEntitiesAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FlexEntityWhere>;
};


export type UploadFlexEntitiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UploadFlexEntitiesConnectionSort>>;
  where?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
};

export type UploadAggregateSelection = {
  __typename?: 'UploadAggregateSelection';
  count: Scalars['Int']['output'];
  id: IdAggregateSelectionNonNullable;
  timestamp: DateTimeAggregateSelectionNonNullable;
};

export type UploadClaimsInput = {
  administrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  insuranceId: Scalars['String']['input'];
  invoiceAmount?: InputMaybe<Scalars['String']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  preparationId: Scalars['String']['input'];
  preparationIdType?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
};

export type UploadEdge = {
  __typename?: 'UploadEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Upload;
};

export type UploadFieldMapping = {
  __typename?: 'UploadFieldMapping';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  derivedFrom?: Maybe<Scalars['String']['output']>;
  flexEntityField: Scalars['String']['output'];
  userField: Scalars['String']['output'];
};

export type UploadFieldMappingAggregateSelection = {
  __typename?: 'UploadFieldMappingAggregateSelection';
  count: Scalars['Int']['output'];
  derivedFrom: StringAggregateSelectionNullable;
  flexEntityField: StringAggregateSelectionNonNullable;
  userField: StringAggregateSelectionNonNullable;
};

export type UploadFieldMappingEdge = {
  __typename?: 'UploadFieldMappingEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UploadFieldMapping;
};

export type UploadFieldMappingOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UploadFieldMappingSort objects to sort UploadFieldMappings by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UploadFieldMappingSort>>;
};

/** Fields to sort UploadFieldMappings by. The order in which sorts are applied is not guaranteed when specifying many fields in one UploadFieldMappingSort object. */
export type UploadFieldMappingSort = {
  derivedFrom?: InputMaybe<SortDirection>;
  flexEntityField?: InputMaybe<SortDirection>;
  userField?: InputMaybe<SortDirection>;
};

export type UploadFieldMappingWhere = {
  AND?: InputMaybe<Array<UploadFieldMappingWhere>>;
  NOT?: InputMaybe<UploadFieldMappingWhere>;
  OR?: InputMaybe<Array<UploadFieldMappingWhere>>;
  derivedFrom?: InputMaybe<Scalars['String']['input']>;
  derivedFrom_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  derivedFrom_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  derivedFrom_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  derivedFrom_MATCHES?: InputMaybe<Scalars['String']['input']>;
  derivedFrom_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityField?: InputMaybe<Scalars['String']['input']>;
  flexEntityField_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  flexEntityField_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  flexEntityField_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  flexEntityField_MATCHES?: InputMaybe<Scalars['String']['input']>;
  flexEntityField_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userField?: InputMaybe<Scalars['String']['input']>;
  userField_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userField_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userField_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  userField_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userField_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFieldMappingsConnection = {
  __typename?: 'UploadFieldMappingsConnection';
  edges: Array<UploadFieldMappingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadFlexEntitiesAggregateInput = {
  AND?: InputMaybe<Array<UploadFlexEntitiesAggregateInput>>;
  NOT?: InputMaybe<UploadFlexEntitiesAggregateInput>;
  OR?: InputMaybe<Array<UploadFlexEntitiesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UploadFlexEntitiesNodeAggregationWhereInput>;
};

export type UploadFlexEntitiesConnection = {
  __typename?: 'UploadFlexEntitiesConnection';
  edges: Array<UploadFlexEntitiesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadFlexEntitiesConnectionSort = {
  node?: InputMaybe<FlexEntitySort>;
};

export type UploadFlexEntitiesConnectionWhere = {
  AND?: InputMaybe<Array<UploadFlexEntitiesConnectionWhere>>;
  NOT?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  OR?: InputMaybe<Array<UploadFlexEntitiesConnectionWhere>>;
  node?: InputMaybe<FlexEntityWhere>;
};

export type UploadFlexEntitiesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UploadFlexEntitiesNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UploadFlexEntitiesNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UploadFlexEntitiesNodeAggregationWhereInput>>;
  createdByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  createdByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  createdByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  dataKeys_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dataKeys_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dataKeys_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  externalFormId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  externalFormId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  flexEntityName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  flexEntityName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceClaimId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceClaimId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  invoiceNumber_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  invoiceNumber_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  patientId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  patientId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  patientId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  patientId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationBrandNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationBrandNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preparationGenericNames_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preparationGenericNames_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  purchaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  purchaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  uuid_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  uuid_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  uuid_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCaseId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCaseId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewCreatedByName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewCreatedByName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewFormattedContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  viewSuccessorId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  viewSuccessorId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFlexEntitiesRelationship = {
  __typename?: 'UploadFlexEntitiesRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: FlexEntity;
};

export type UploadFlexEntityFlexEntitiesAggregationSelection = {
  __typename?: 'UploadFlexEntityFlexEntitiesAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UploadFlexEntityFlexEntitiesNodeAggregateSelection>;
};

export type UploadFlexEntityFlexEntitiesNodeAggregateSelection = {
  __typename?: 'UploadFlexEntityFlexEntitiesNodeAggregateSelection';
  createdByEmail: StringAggregateSelectionNonNullable;
  createdByName: StringAggregateSelectionNonNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  dataKeys: StringAggregateSelectionNonNullable;
  externalFormId: StringAggregateSelectionNullable;
  flexEntityName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  insuranceClaimId: StringAggregateSelectionNullable;
  invoiceNumber: StringAggregateSelectionNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  patientId: StringAggregateSelectionNullable;
  preparationBrandNames: StringAggregateSelectionNullable;
  preparationGenericNames: StringAggregateSelectionNullable;
  purchaseId: StringAggregateSelectionNullable;
  quantity: FloatAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
  uuid: StringAggregateSelectionNonNullable;
  viewCaseId: StringAggregateSelectionNullable;
  viewCases: StringAggregateSelectionNullable;
  viewCreatedByName: StringAggregateSelectionNullable;
  viewFormattedContentDe: StringAggregateSelectionNullable;
  viewFormattedContentEn: StringAggregateSelectionNullable;
  viewSuccessorId: StringAggregateSelectionNullable;
};

export type UploadFlexEntityInput = {
  file?: InputMaybe<Scalars['FileUpload']['input']>;
  flexEntityTypeId: Scalars['String']['input'];
  mappedFields: Array<FieldMappingInput>;
  saveMapping?: InputMaybe<Scalars['Boolean']['input']>;
  sourceKeys: Array<Scalars['String']['input']>;
};

export type UploadLimitation = {
  __typename?: 'UploadLimitation';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  entityType: FlexContainerType;
  maxItems: Scalars['Int']['output'];
  updatedBy?: Maybe<User>;
  updatedByAggregate?: Maybe<UploadLimitationUserUpdatedByAggregationSelection>;
  updatedByConnection: UploadLimitationUpdatedByConnection;
};


export type UploadLimitationUpdatedByArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserOptions>;
  where?: InputMaybe<UserWhere>;
};


export type UploadLimitationUpdatedByAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type UploadLimitationUpdatedByConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UploadLimitationUpdatedByConnectionSort>>;
  where?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
};

export type UploadLimitationAggregateSelection = {
  __typename?: 'UploadLimitationAggregateSelection';
  count: Scalars['Int']['output'];
  maxItems: IntAggregateSelectionNonNullable;
};

export type UploadLimitationEdge = {
  __typename?: 'UploadLimitationEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UploadLimitation;
};

export type UploadLimitationOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UploadLimitationSort objects to sort UploadLimitations by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UploadLimitationSort>>;
};

/** Fields to sort UploadLimitations by. The order in which sorts are applied is not guaranteed when specifying many fields in one UploadLimitationSort object. */
export type UploadLimitationSort = {
  entityType?: InputMaybe<SortDirection>;
  maxItems?: InputMaybe<SortDirection>;
};

export type UploadLimitationUpdatedByAggregateInput = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByAggregateInput>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByAggregateInput>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UploadLimitationUpdatedByEdgeAggregationWhereInput>;
  node?: InputMaybe<UploadLimitationUpdatedByNodeAggregationWhereInput>;
};

export type UploadLimitationUpdatedByConnection = {
  __typename?: 'UploadLimitationUpdatedByConnection';
  edges: Array<UploadLimitationUpdatedByRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadLimitationUpdatedByConnectionSort = {
  edge?: InputMaybe<UploadLimitationUpdaterRelationshipSort>;
  node?: InputMaybe<UserSort>;
};

export type UploadLimitationUpdatedByConnectionWhere = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByConnectionWhere>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByConnectionWhere>>;
  edge?: InputMaybe<UploadLimitationUpdaterRelationshipWhere>;
  node?: InputMaybe<UserWhere>;
};

export type UploadLimitationUpdatedByEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByEdgeAggregationWhereInput>>;
  setOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadLimitationUpdatedByNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UploadLimitationUpdatedByNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UploadLimitationUpdatedByNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UploadLimitationUpdatedByNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  currency_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  currency_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  currency_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  department_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  department_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  department_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  dosageMeasureUnit_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  firstName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  firstName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  lastName_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastName_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  lastName_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  position_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  position_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  position_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  position_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  preferredLanguage_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  preferredLanguage_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  signature_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  signature_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  signature_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadLimitationUpdatedByRelationship = UploadLimitationUpdaterRelationship & {
  __typename?: 'UploadLimitationUpdatedByRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
  setOn: Scalars['DateTime']['output'];
};

export type UploadLimitationUpdaterRelationship = {
  setOn: Scalars['DateTime']['output'];
};

export type UploadLimitationUpdaterRelationshipSort = {
  setOn?: InputMaybe<SortDirection>;
};

export type UploadLimitationUpdaterRelationshipWhere = {
  AND?: InputMaybe<Array<UploadLimitationUpdaterRelationshipWhere>>;
  NOT?: InputMaybe<UploadLimitationUpdaterRelationshipWhere>;
  OR?: InputMaybe<Array<UploadLimitationUpdaterRelationshipWhere>>;
  setOn?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  setOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  setOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadLimitationUserUpdatedByAggregationSelection = {
  __typename?: 'UploadLimitationUserUpdatedByAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<UploadLimitationUserUpdatedByEdgeAggregateSelection>;
  node?: Maybe<UploadLimitationUserUpdatedByNodeAggregateSelection>;
};

export type UploadLimitationUserUpdatedByEdgeAggregateSelection = {
  __typename?: 'UploadLimitationUserUpdatedByEdgeAggregateSelection';
  setOn: DateTimeAggregateSelectionNonNullable;
};

export type UploadLimitationUserUpdatedByNodeAggregateSelection = {
  __typename?: 'UploadLimitationUserUpdatedByNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type UploadLimitationWhere = {
  AND?: InputMaybe<Array<UploadLimitationWhere>>;
  NOT?: InputMaybe<UploadLimitationWhere>;
  OR?: InputMaybe<Array<UploadLimitationWhere>>;
  entityType?: InputMaybe<FlexContainerType>;
  entityType_IN?: InputMaybe<Array<FlexContainerType>>;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  maxItems_GT?: InputMaybe<Scalars['Int']['input']>;
  maxItems_GTE?: InputMaybe<Scalars['Int']['input']>;
  maxItems_IN?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxItems_LT?: InputMaybe<Scalars['Int']['input']>;
  maxItems_LTE?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<UserWhere>;
  updatedByAggregate?: InputMaybe<UploadLimitationUpdatedByAggregateInput>;
  updatedByConnection?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
  updatedByConnection_NOT?: InputMaybe<UploadLimitationUpdatedByConnectionWhere>;
  updatedBy_NOT?: InputMaybe<UserWhere>;
};

export type UploadLimitationsConnection = {
  __typename?: 'UploadLimitationsConnection';
  edges: Array<UploadLimitationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UploadOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UploadSort objects to sort Uploads by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UploadSort>>;
};

/** Fields to sort Uploads by. The order in which sorts are applied is not guaranteed when specifying many fields in one UploadSort object. */
export type UploadSort = {
  id?: InputMaybe<SortDirection>;
  timestamp?: InputMaybe<SortDirection>;
};

export enum UploadStatus {
  AgreementExecution = 'AGREEMENT_EXECUTION',
  Completing = 'COMPLETING',
  FinalReport = 'FINAL_REPORT',
  GeneratingForms = 'GENERATING_FORMS',
  Inspecting = 'INSPECTING',
  PreliminaryReport = 'PRELIMINARY_REPORT',
  Uploading = 'UPLOADING'
}

export type UploadWhere = {
  AND?: InputMaybe<Array<UploadWhere>>;
  NOT?: InputMaybe<UploadWhere>;
  OR?: InputMaybe<Array<UploadWhere>>;
  flexEntitiesAggregate?: InputMaybe<UploadFlexEntitiesAggregateInput>;
  /** Return Uploads where all of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_ALL?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where none of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_NONE?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where one of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SINGLE?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where some of the related UploadFlexEntitiesConnections match this filter */
  flexEntitiesConnection_SOME?: InputMaybe<UploadFlexEntitiesConnectionWhere>;
  /** Return Uploads where all of the related FlexEntities match this filter */
  flexEntities_ALL?: InputMaybe<FlexEntityWhere>;
  /** Return Uploads where none of the related FlexEntities match this filter */
  flexEntities_NONE?: InputMaybe<FlexEntityWhere>;
  /** Return Uploads where one of the related FlexEntities match this filter */
  flexEntities_SINGLE?: InputMaybe<FlexEntityWhere>;
  /** Return Uploads where some of the related FlexEntities match this filter */
  flexEntities_SOME?: InputMaybe<FlexEntityWhere>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_GT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_IN?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  timestamp_LT?: InputMaybe<Scalars['DateTime']['input']>;
  timestamp_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadsConnection = {
  __typename?: 'UploadsConnection';
  edges: Array<UploadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementRunAttempts: Array<AgreementRunAttemptInfo>;
  agreementRunAttemptsAggregate?: Maybe<UserAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection>;
  agreementRunAttemptsConnection: UserAgreementRunAttemptsConnection;
  comparableModels?: Maybe<Array<Scalars['String']['output']>>;
  comparisonSimulations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  context?: Maybe<UserContext>;
  contextAggregate?: Maybe<UserUserContextContextAggregationSelection>;
  contextConnection: UserContextConnection;
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedOn?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  domainWithChildren: Array<Domain>;
  domains: Array<Domain>;
  domainsAggregate?: Maybe<UserDomainDomainsAggregationSelection>;
  domainsConnection: UserDomainsConnection;
  dosageMeasureUnit?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  favoriteModels?: Maybe<Array<Scalars['String']['output']>>;
  filtersSimulations?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isGuest: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  lastUpdatedOn?: Maybe<Scalars['DateTime']['output']>;
  mentions: Array<Message>;
  mentionsAggregate?: Maybe<UserMessageMentionsAggregationSelection>;
  mentionsConnection: UserMentionsConnection;
  negotiationRounds: Array<NegotiationRound>;
  negotiationRoundsAggregate?: Maybe<UserNegotiationRoundNegotiationRoundsAggregationSelection>;
  negotiationRoundsConnection: UserNegotiationRoundsConnection;
  organization: Organization;
  patients: Array<Patient>;
  patientsAggregate?: Maybe<UserPatientPatientsAggregationSelection>;
  patientsConnection: UserPatientsConnection;
  position?: Maybe<Scalars['String']['output']>;
  preferredLanguage: Scalars['String']['output'];
  publicAgreementView?: Maybe<PublicAgreementView>;
  quests: Array<Quest>;
  questsAggregate?: Maybe<UserQuestQuestsAggregationSelection>;
  questsConnection: UserQuestsConnection;
  reads: Array<Scalars['String']['output']>;
  sentMessage?: Maybe<Message>;
  sentMessageAggregate?: Maybe<UserMessageSentMessageAggregationSelection>;
  sentMessageConnection: UserSentMessageConnection;
  signature?: Maybe<Scalars['String']['output']>;
  simulationsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  simulatorWasteReportingEnabled?: Maybe<Scalars['Boolean']['output']>;
  subscribed: Array<Notification>;
  subscribedAggregate?: Maybe<UserNotificationSubscribedAggregationSelection>;
  subscribedConnection: UserSubscribedConnection;
  tasks: Array<Task>;
  tasksAggregate?: Maybe<UserTaskTasksAggregationSelection>;
  tasksConnection: UserTasksConnection;
  tenantId: Scalars['String']['output'];
  writes: Array<Scalars['String']['output']>;
};


export type UserAgreementRunAttemptsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<AgreementRunAttemptInfoOptions>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type UserAgreementRunAttemptsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AgreementRunAttemptInfoWhere>;
};


export type UserAgreementRunAttemptsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserAgreementRunAttemptsConnectionSort>>;
  where?: InputMaybe<UserAgreementRunAttemptsConnectionWhere>;
};


export type UserContextArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<UserContextOptions>;
  where?: InputMaybe<UserContextWhere>;
};


export type UserContextAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UserContextWhere>;
};


export type UserContextConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserContextConnectionSort>>;
  where?: InputMaybe<UserContextConnectionWhere>;
};


export type UserDomainsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<DomainOptions>;
  where?: InputMaybe<DomainWhere>;
};


export type UserDomainsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DomainWhere>;
};


export type UserDomainsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserDomainsConnectionSort>>;
  where?: InputMaybe<UserDomainsConnectionWhere>;
};


export type UserMentionsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type UserMentionsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type UserMentionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserMentionsConnectionSort>>;
  where?: InputMaybe<UserMentionsConnectionWhere>;
};


export type UserNegotiationRoundsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NegotiationRoundOptions>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type UserNegotiationRoundsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NegotiationRoundWhere>;
};


export type UserNegotiationRoundsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserNegotiationRoundsConnectionSort>>;
  where?: InputMaybe<UserNegotiationRoundsConnectionWhere>;
};


export type UserPatientsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<PatientOptions>;
  where?: InputMaybe<PatientWhere>;
};


export type UserPatientsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PatientWhere>;
};


export type UserPatientsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserPatientsConnectionSort>>;
  where?: InputMaybe<UserPatientsConnectionWhere>;
};


export type UserQuestsArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<QuestOptions>;
  where?: InputMaybe<QuestWhere>;
};


export type UserQuestsAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuestWhere>;
};


export type UserQuestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserQuestsConnectionSort>>;
  where?: InputMaybe<UserQuestsConnectionWhere>;
};


export type UserSentMessageArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<MessageOptions>;
  where?: InputMaybe<MessageWhere>;
};


export type UserSentMessageAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MessageWhere>;
};


export type UserSentMessageConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSentMessageConnectionSort>>;
  where?: InputMaybe<UserSentMessageConnectionWhere>;
};


export type UserSubscribedArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<NotificationOptions>;
  where?: InputMaybe<NotificationWhere>;
};


export type UserSubscribedAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NotificationWhere>;
};


export type UserSubscribedConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserSubscribedConnectionSort>>;
  where?: InputMaybe<UserSubscribedConnectionWhere>;
};


export type UserTasksArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<TaskOptions>;
  where?: InputMaybe<TaskWhere>;
};


export type UserTasksAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TaskWhere>;
};


export type UserTasksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserTasksConnectionSort>>;
  where?: InputMaybe<UserTasksConnectionWhere>;
};

export type UserAggregateSelection = {
  __typename?: 'UserAggregateSelection';
  count: Scalars['Int']['output'];
  createdOn: DateTimeAggregateSelectionNullable;
  currency: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  email: StringAggregateSelectionNonNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
  signature: StringAggregateSelectionNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type UserAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection = {
  __typename?: 'UserAgreementRunAttemptInfoAgreementRunAttemptsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection>;
};

export type UserAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection = {
  __typename?: 'UserAgreementRunAttemptInfoAgreementRunAttemptsNodeAggregateSelection';
  attemptedAgreementCount: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  filtersAppliedForRun: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  nonAttemptedAgreementCount: IntAggregateSelectionNullable;
  runEnd: DateTimeAggregateSelectionNullable;
  runStart: DateTimeAggregateSelectionNullable;
  succeededCount: IntAggregateSelectionNullable;
};

export type UserAgreementRunAttemptsAggregateInput = {
  AND?: InputMaybe<Array<UserAgreementRunAttemptsAggregateInput>>;
  NOT?: InputMaybe<UserAgreementRunAttemptsAggregateInput>;
  OR?: InputMaybe<Array<UserAgreementRunAttemptsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserAgreementRunAttemptsNodeAggregationWhereInput>;
};

export type UserAgreementRunAttemptsConnection = {
  __typename?: 'UserAgreementRunAttemptsConnection';
  edges: Array<UserAgreementRunAttemptsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAgreementRunAttemptsConnectionSort = {
  node?: InputMaybe<AgreementRunAttemptInfoSort>;
};

export type UserAgreementRunAttemptsConnectionWhere = {
  AND?: InputMaybe<Array<UserAgreementRunAttemptsConnectionWhere>>;
  NOT?: InputMaybe<UserAgreementRunAttemptsConnectionWhere>;
  OR?: InputMaybe<Array<UserAgreementRunAttemptsConnectionWhere>>;
  node?: InputMaybe<AgreementRunAttemptInfoWhere>;
};

export type UserAgreementRunAttemptsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserAgreementRunAttemptsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserAgreementRunAttemptsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserAgreementRunAttemptsNodeAggregationWhereInput>>;
  attemptedAgreementCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  attemptedAgreementCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  attemptedAgreementCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAppliedForRun_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  nonAttemptedAgreementCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  nonAttemptedAgreementCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  runEnd_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runEnd_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  runStart_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  succeededCount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  succeededCount_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  succeededCount_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAgreementRunAttemptsRelationship = {
  __typename?: 'UserAgreementRunAttemptsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: AgreementRunAttemptInfo;
};

export type UserContext = {
  __typename?: 'UserContext';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  agreementsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  baseAgreementContext: Array<BaseAgreement>;
  baseAgreementContextAggregate?: Maybe<UserContextBaseAgreementBaseAgreementContextAggregationSelection>;
  baseAgreementContextConnection: UserContextBaseAgreementContextConnection;
  comparisonSimulations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  defaultMessageSharingType?: Maybe<DocumentMessageSharingType>;
  documentsTableColumns?: Maybe<Array<Scalars['String']['output']>>;
  email: Scalars['String']['output'];
  filterCaseLogs?: Maybe<Scalars['String']['output']>;
  filtersAgreements?: Maybe<Scalars['String']['output']>;
  filtersCases?: Maybe<Scalars['String']['output']>;
  filtersDataForms?: Maybe<Scalars['String']['output']>;
  filtersDataRecords?: Maybe<Scalars['String']['output']>;
  filtersDocuments?: Maybe<Scalars['String']['output']>;
  filtersRefunds?: Maybe<Scalars['String']['output']>;
  filtersSimulations?: Maybe<Scalars['String']['output']>;
  scenarios: Array<Scenario>;
  scenariosAggregate?: Maybe<UserContextScenarioScenariosAggregationSelection>;
  scenariosConnection: UserContextScenariosConnection;
  timePeriodCaseDetails?: Maybe<Scalars['String']['output']>;
  timePeriodFilterDashboard?: Maybe<Scalars['String']['output']>;
  timePeriodFilterHome?: Maybe<Scalars['String']['output']>;
  timePeriodFilterReporting?: Maybe<Scalars['String']['output']>;
  transactionsInCreditNoteDocumentTableColumns?: Maybe<Scalars['String']['output']>;
  transactionsInDocumentTableColumnsRefundInvoice?: Maybe<Scalars['String']['output']>;
  transactionsInFreeOfChargeDocumentTableColumns?: Maybe<Scalars['String']['output']>;
};


export type UserContextBaseAgreementContextArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<BaseAgreementOptions>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type UserContextBaseAgreementContextAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BaseAgreementWhere>;
};


export type UserContextBaseAgreementContextConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserContextBaseAgreementContextConnectionSort>>;
  where?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
};


export type UserContextScenariosArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  options?: InputMaybe<ScenarioOptions>;
  where?: InputMaybe<ScenarioWhere>;
};


export type UserContextScenariosAggregateArgs = {
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ScenarioWhere>;
};


export type UserContextScenariosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  directed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<UserContextScenariosConnectionSort>>;
  where?: InputMaybe<UserContextScenariosConnectionWhere>;
};

export type UserContextAggregateInput = {
  AND?: InputMaybe<Array<UserContextAggregateInput>>;
  NOT?: InputMaybe<UserContextAggregateInput>;
  OR?: InputMaybe<Array<UserContextAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserContextNodeAggregationWhereInput>;
};

export type UserContextAggregateSelection = {
  __typename?: 'UserContextAggregateSelection';
  count: Scalars['Int']['output'];
  email: StringAggregateSelectionNonNullable;
  filterCaseLogs: StringAggregateSelectionNullable;
  filtersAgreements: StringAggregateSelectionNullable;
  filtersCases: StringAggregateSelectionNullable;
  filtersDataForms: StringAggregateSelectionNullable;
  filtersDataRecords: StringAggregateSelectionNullable;
  filtersDocuments: StringAggregateSelectionNullable;
  filtersRefunds: StringAggregateSelectionNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  timePeriodCaseDetails: StringAggregateSelectionNullable;
  timePeriodFilterDashboard: StringAggregateSelectionNullable;
  timePeriodFilterHome: StringAggregateSelectionNullable;
  timePeriodFilterReporting: StringAggregateSelectionNullable;
  transactionsInCreditNoteDocumentTableColumns: StringAggregateSelectionNullable;
  transactionsInDocumentTableColumnsRefundInvoice: StringAggregateSelectionNullable;
  transactionsInFreeOfChargeDocumentTableColumns: StringAggregateSelectionNullable;
};

export type UserContextBaseAgreementBaseAgreementContextAggregationSelection = {
  __typename?: 'UserContextBaseAgreementBaseAgreementContextAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<UserContextBaseAgreementBaseAgreementContextEdgeAggregateSelection>;
  node?: Maybe<UserContextBaseAgreementBaseAgreementContextNodeAggregateSelection>;
};

export type UserContextBaseAgreementBaseAgreementContextEdgeAggregateSelection = {
  __typename?: 'UserContextBaseAgreementBaseAgreementContextEdgeAggregateSelection';
  categoryInput: StringAggregateSelectionNullable;
  rebateObjective: StringAggregateSelectionNullable;
  timeframeLabel: StringAggregateSelectionNonNullable;
};

export type UserContextBaseAgreementBaseAgreementContextNodeAggregateSelection = {
  __typename?: 'UserContextBaseAgreementBaseAgreementContextNodeAggregateSelection';
  caseSuspensionIntervalDays: IntAggregateSelectionNullable;
  caselessAgreementDataSnapshot: StringAggregateSelectionNullable;
  coveringFormWaitInterval: IntAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNonNullable;
  daysToExpiry: IntAggregateSelectionNullable;
  defaultPriceRate: FloatAggregateSelectionNullable;
  firstExecutionDate: DateTimeAggregateSelectionNullable;
  formattedAmount: StringAggregateSelectionNullable;
  formattedCounterparties: StringAggregateSelectionNullable;
  formattedDiseases: StringAggregateSelectionNullable;
  formattedIndications: StringAggregateSelectionNullable;
  formattedProducts: StringAggregateSelectionNullable;
  formattedTags: StringAggregateSelectionNonNullable;
  formattedValidityPeriod: StringAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  initialVersionId: StringAggregateSelectionNonNullable;
  lastExecutionDate: DateTimeAggregateSelectionNullable;
  lastUpdatedOn: FloatAggregateSelectionNullable;
  name: StringAggregateSelectionNonNullable;
  pushedOn: DateTimeAggregateSelectionNullable;
  reportData: StringAggregateSelectionNullable;
  totalAmount: FloatAggregateSelectionNullable;
  version: IntAggregateSelectionNonNullable;
};

export type UserContextBaseAgreementContextAggregateInput = {
  AND?: InputMaybe<Array<UserContextBaseAgreementContextAggregateInput>>;
  NOT?: InputMaybe<UserContextBaseAgreementContextAggregateInput>;
  OR?: InputMaybe<Array<UserContextBaseAgreementContextAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserContextBaseAgreementContextEdgeAggregationWhereInput>;
  node?: InputMaybe<UserContextBaseAgreementContextNodeAggregationWhereInput>;
};

export type UserContextBaseAgreementContextConnection = {
  __typename?: 'UserContextBaseAgreementContextConnection';
  edges: Array<UserContextBaseAgreementContextRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserContextBaseAgreementContextConnectionSort = {
  edge?: InputMaybe<ScenarioInsightsUserContextSort>;
  node?: InputMaybe<BaseAgreementSort>;
};

export type UserContextBaseAgreementContextConnectionWhere = {
  AND?: InputMaybe<Array<UserContextBaseAgreementContextConnectionWhere>>;
  NOT?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
  OR?: InputMaybe<Array<UserContextBaseAgreementContextConnectionWhere>>;
  edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
  node?: InputMaybe<BaseAgreementWhere>;
};

export type UserContextBaseAgreementContextEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserContextBaseAgreementContextEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<UserContextBaseAgreementContextEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserContextBaseAgreementContextEdgeAggregationWhereInput>>;
  categoryInput_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserContextBaseAgreementContextNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserContextBaseAgreementContextNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserContextBaseAgreementContextNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserContextBaseAgreementContextNodeAggregationWhereInput>>;
  caseSuspensionIntervalDays_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  caseSuspensionIntervalDays_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  caseSuspensionIntervalDays_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  caselessAgreementDataSnapshot_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  coveringFormWaitInterval_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  coveringFormWaitInterval_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  daysToExpiry_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  daysToExpiry_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  daysToExpiry_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  defaultPriceRate_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  defaultPriceRate_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  firstExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  firstExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  formattedAmount_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedAmount_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedAmount_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedCounterparties_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedCounterparties_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedDiseases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedDiseases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedIndications_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedIndications_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedProducts_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedProducts_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedTags_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedTags_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  formattedValidityPeriod_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initialVersionId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initialVersionId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastExecutionDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastExecutionDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  lastUpdatedOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  pushedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  pushedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  reportData_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  reportData_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  reportData_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  reportData_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  totalAmount_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  totalAmount_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  version_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  version_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  version_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  version_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserContextBaseAgreementContextRelationship = ScenarioInsightsUserContext & {
  __typename?: 'UserContextBaseAgreementContextRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  categoryInput?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  node: BaseAgreement;
  rebateObjective?: Maybe<Scalars['String']['output']>;
  timeframeLabel: Scalars['String']['output'];
};

export type UserContextConnection = {
  __typename?: 'UserContextConnection';
  edges: Array<UserContextRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserContextConnectionSort = {
  node?: InputMaybe<UserContextSort>;
};

export type UserContextConnectionWhere = {
  AND?: InputMaybe<Array<UserContextConnectionWhere>>;
  NOT?: InputMaybe<UserContextConnectionWhere>;
  OR?: InputMaybe<Array<UserContextConnectionWhere>>;
  node?: InputMaybe<UserContextWhere>;
};

export type UserContextEdge = {
  __typename?: 'UserContextEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UserContext;
};

export type UserContextNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserContextNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserContextNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserContextNodeAggregationWhereInput>>;
  email_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  email_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  email_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  email_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filterCaseLogs_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filterCaseLogs_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersAgreements_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersAgreements_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersCases_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersCases_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataForms_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataForms_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDataRecords_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDataRecords_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersDocuments_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersDocuments_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersRefunds_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersRefunds_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  filtersSimulations_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  filtersSimulations_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodCaseDetails_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterDashboard_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterHome_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timePeriodFilterReporting_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInCreditNoteDocumentTableColumns_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserContextOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserContextSort objects to sort UserContexts by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserContextSort>>;
};

export type UserContextRelationship = {
  __typename?: 'UserContextRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UserContext;
};

export type UserContextScenarioScenariosAggregationSelection = {
  __typename?: 'UserContextScenarioScenariosAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<UserContextScenarioScenariosEdgeAggregateSelection>;
  node?: Maybe<UserContextScenarioScenariosNodeAggregateSelection>;
};

export type UserContextScenarioScenariosEdgeAggregateSelection = {
  __typename?: 'UserContextScenarioScenariosEdgeAggregateSelection';
  categoryInput: StringAggregateSelectionNullable;
  rebateObjective: StringAggregateSelectionNullable;
  timeframeLabel: StringAggregateSelectionNonNullable;
};

export type UserContextScenarioScenariosNodeAggregateSelection = {
  __typename?: 'UserContextScenarioScenariosNodeAggregateSelection';
  group: IntAggregateSelectionNullable;
  order: IntAggregateSelectionNonNullable;
};

export type UserContextScenariosAggregateInput = {
  AND?: InputMaybe<Array<UserContextScenariosAggregateInput>>;
  NOT?: InputMaybe<UserContextScenariosAggregateInput>;
  OR?: InputMaybe<Array<UserContextScenariosAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserContextScenariosEdgeAggregationWhereInput>;
  node?: InputMaybe<UserContextScenariosNodeAggregationWhereInput>;
};

export type UserContextScenariosConnection = {
  __typename?: 'UserContextScenariosConnection';
  edges: Array<UserContextScenariosRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserContextScenariosConnectionSort = {
  edge?: InputMaybe<ScenarioInsightsUserContextSort>;
  node?: InputMaybe<ScenarioSort>;
};

export type UserContextScenariosConnectionWhere = {
  AND?: InputMaybe<Array<UserContextScenariosConnectionWhere>>;
  NOT?: InputMaybe<UserContextScenariosConnectionWhere>;
  OR?: InputMaybe<Array<UserContextScenariosConnectionWhere>>;
  edge?: InputMaybe<ScenarioInsightsUserContextWhere>;
  node?: InputMaybe<ScenarioWhere>;
};

export type UserContextScenariosEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserContextScenariosEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<UserContextScenariosEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserContextScenariosEdgeAggregationWhereInput>>;
  categoryInput_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  categoryInput_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  categoryInput_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  rebateObjective_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  rebateObjective_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeframeLabel_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  timeframeLabel_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserContextScenariosNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserContextScenariosNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserContextScenariosNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserContextScenariosNodeAggregationWhereInput>>;
  group_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  group_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  group_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  group_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  group_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserContextScenariosRelationship = ScenarioInsightsUserContext & {
  __typename?: 'UserContextScenariosRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  categoryInput?: Maybe<Scalars['String']['output']>;
  cursor: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  node: Scenario;
  rebateObjective?: Maybe<Scalars['String']['output']>;
  timeframeLabel: Scalars['String']['output'];
};

/** Fields to sort UserContexts by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserContextSort object. */
export type UserContextSort = {
  defaultMessageSharingType?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  filterCaseLogs?: InputMaybe<SortDirection>;
  filtersAgreements?: InputMaybe<SortDirection>;
  filtersCases?: InputMaybe<SortDirection>;
  filtersDataForms?: InputMaybe<SortDirection>;
  filtersDataRecords?: InputMaybe<SortDirection>;
  filtersDocuments?: InputMaybe<SortDirection>;
  filtersRefunds?: InputMaybe<SortDirection>;
  filtersSimulations?: InputMaybe<SortDirection>;
  timePeriodCaseDetails?: InputMaybe<SortDirection>;
  timePeriodFilterDashboard?: InputMaybe<SortDirection>;
  timePeriodFilterHome?: InputMaybe<SortDirection>;
  timePeriodFilterReporting?: InputMaybe<SortDirection>;
  transactionsInCreditNoteDocumentTableColumns?: InputMaybe<SortDirection>;
  transactionsInDocumentTableColumnsRefundInvoice?: InputMaybe<SortDirection>;
  transactionsInFreeOfChargeDocumentTableColumns?: InputMaybe<SortDirection>;
};

export type UserContextWhere = {
  AND?: InputMaybe<Array<UserContextWhere>>;
  NOT?: InputMaybe<UserContextWhere>;
  OR?: InputMaybe<Array<UserContextWhere>>;
  agreementsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  agreementsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  baseAgreementContextAggregate?: InputMaybe<UserContextBaseAgreementContextAggregateInput>;
  /** Return UserContexts where all of the related UserContextBaseAgreementContextConnections match this filter */
  baseAgreementContextConnection_ALL?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
  /** Return UserContexts where none of the related UserContextBaseAgreementContextConnections match this filter */
  baseAgreementContextConnection_NONE?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
  /** Return UserContexts where one of the related UserContextBaseAgreementContextConnections match this filter */
  baseAgreementContextConnection_SINGLE?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
  /** Return UserContexts where some of the related UserContextBaseAgreementContextConnections match this filter */
  baseAgreementContextConnection_SOME?: InputMaybe<UserContextBaseAgreementContextConnectionWhere>;
  /** Return UserContexts where all of the related BaseAgreements match this filter */
  baseAgreementContext_ALL?: InputMaybe<BaseAgreementWhere>;
  /** Return UserContexts where none of the related BaseAgreements match this filter */
  baseAgreementContext_NONE?: InputMaybe<BaseAgreementWhere>;
  /** Return UserContexts where one of the related BaseAgreements match this filter */
  baseAgreementContext_SINGLE?: InputMaybe<BaseAgreementWhere>;
  /** Return UserContexts where some of the related BaseAgreements match this filter */
  baseAgreementContext_SOME?: InputMaybe<BaseAgreementWhere>;
  comparisonSimulations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comparisonSimulations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  defaultMessageSharingType?: InputMaybe<DocumentMessageSharingType>;
  defaultMessageSharingType_IN?: InputMaybe<Array<InputMaybe<DocumentMessageSharingType>>>;
  documentsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  documentsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filterCaseLogs?: InputMaybe<Scalars['String']['input']>;
  filterCaseLogs_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filterCaseLogs_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filterCaseLogs_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterCaseLogs_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filterCaseLogs_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersAgreements_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersAgreements_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersCases?: InputMaybe<Scalars['String']['input']>;
  filtersCases_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersCases_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersCases_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersCases_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersCases_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersDataForms?: InputMaybe<Scalars['String']['input']>;
  filtersDataForms_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersDataForms_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersDataForms_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersDataForms_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersDataForms_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersDataRecords?: InputMaybe<Scalars['String']['input']>;
  filtersDataRecords_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersDataRecords_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersDataRecords_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersDataRecords_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersDataRecords_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersDocuments?: InputMaybe<Scalars['String']['input']>;
  filtersDocuments_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersDocuments_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersDocuments_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersDocuments_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersDocuments_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersRefunds?: InputMaybe<Scalars['String']['input']>;
  filtersRefunds_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersRefunds_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersRefunds_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersRefunds_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersRefunds_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersSimulations_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  scenariosAggregate?: InputMaybe<UserContextScenariosAggregateInput>;
  /** Return UserContexts where all of the related UserContextScenariosConnections match this filter */
  scenariosConnection_ALL?: InputMaybe<UserContextScenariosConnectionWhere>;
  /** Return UserContexts where none of the related UserContextScenariosConnections match this filter */
  scenariosConnection_NONE?: InputMaybe<UserContextScenariosConnectionWhere>;
  /** Return UserContexts where one of the related UserContextScenariosConnections match this filter */
  scenariosConnection_SINGLE?: InputMaybe<UserContextScenariosConnectionWhere>;
  /** Return UserContexts where some of the related UserContextScenariosConnections match this filter */
  scenariosConnection_SOME?: InputMaybe<UserContextScenariosConnectionWhere>;
  /** Return UserContexts where all of the related Scenarios match this filter */
  scenarios_ALL?: InputMaybe<ScenarioWhere>;
  /** Return UserContexts where none of the related Scenarios match this filter */
  scenarios_NONE?: InputMaybe<ScenarioWhere>;
  /** Return UserContexts where one of the related Scenarios match this filter */
  scenarios_SINGLE?: InputMaybe<ScenarioWhere>;
  /** Return UserContexts where some of the related Scenarios match this filter */
  scenarios_SOME?: InputMaybe<ScenarioWhere>;
  timePeriodCaseDetails?: InputMaybe<Scalars['String']['input']>;
  timePeriodCaseDetails_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timePeriodCaseDetails_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodCaseDetails_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timePeriodCaseDetails_MATCHES?: InputMaybe<Scalars['String']['input']>;
  timePeriodCaseDetails_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterDashboard?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterDashboard_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterDashboard_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterDashboard_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timePeriodFilterDashboard_MATCHES?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterDashboard_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterHome?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterHome_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterHome_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterHome_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timePeriodFilterHome_MATCHES?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterHome_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterReporting?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterReporting_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterReporting_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterReporting_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timePeriodFilterReporting_MATCHES?: InputMaybe<Scalars['String']['input']>;
  timePeriodFilterReporting_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInCreditNoteDocumentTableColumns?: InputMaybe<Scalars['String']['input']>;
  transactionsInCreditNoteDocumentTableColumns_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  transactionsInCreditNoteDocumentTableColumns_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInCreditNoteDocumentTableColumns_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionsInCreditNoteDocumentTableColumns_MATCHES?: InputMaybe<Scalars['String']['input']>;
  transactionsInCreditNoteDocumentTableColumns_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice?: InputMaybe<Scalars['String']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionsInDocumentTableColumnsRefundInvoice_MATCHES?: InputMaybe<Scalars['String']['input']>;
  transactionsInDocumentTableColumnsRefundInvoice_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns?: InputMaybe<Scalars['String']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionsInFreeOfChargeDocumentTableColumns_MATCHES?: InputMaybe<Scalars['String']['input']>;
  transactionsInFreeOfChargeDocumentTableColumns_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserContextsConnection = {
  __typename?: 'UserContextsConnection';
  edges: Array<UserContextEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDomainDomainsAggregationSelection = {
  __typename?: 'UserDomainDomainsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserDomainDomainsNodeAggregateSelection>;
};

export type UserDomainDomainsNodeAggregateSelection = {
  __typename?: 'UserDomainDomainsNodeAggregateSelection';
  createdOn: DateTimeAggregateSelectionNonNullable;
  deletedByEmail: StringAggregateSelectionNullable;
  deletedOn: DateTimeAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
  level: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNonNullable;
};

export type UserDomainsAggregateInput = {
  AND?: InputMaybe<Array<UserDomainsAggregateInput>>;
  NOT?: InputMaybe<UserDomainsAggregateInput>;
  OR?: InputMaybe<Array<UserDomainsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserDomainsNodeAggregationWhereInput>;
};

export type UserDomainsConnection = {
  __typename?: 'UserDomainsConnection';
  edges: Array<UserDomainsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDomainsConnectionSort = {
  node?: InputMaybe<DomainSort>;
};

export type UserDomainsConnectionWhere = {
  AND?: InputMaybe<Array<UserDomainsConnectionWhere>>;
  NOT?: InputMaybe<UserDomainsConnectionWhere>;
  OR?: InputMaybe<Array<UserDomainsConnectionWhere>>;
  node?: InputMaybe<DomainWhere>;
};

export type UserDomainsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserDomainsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserDomainsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserDomainsNodeAggregationWhereInput>>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedByEmail_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  deletedByEmail_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  deletedByEmail_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  deletedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  level_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  level_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  level_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  level_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  level_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDomainsRelationship = {
  __typename?: 'UserDomainsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserLoginDates = {
  __typename?: 'UserLoginDates';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  currentLoginDate?: Maybe<Scalars['DateTime']['output']>;
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UserLoginDatesAggregateSelection = {
  __typename?: 'UserLoginDatesAggregateSelection';
  count: Scalars['Int']['output'];
  currentLoginDate: DateTimeAggregateSelectionNullable;
  lastLoginDate: DateTimeAggregateSelectionNullable;
};

export type UserLoginDatesConnection = {
  __typename?: 'UserLoginDatesConnection';
  edges: Array<UserLoginDatesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserLoginDatesEdge = {
  __typename?: 'UserLoginDatesEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UserLoginDates;
};

export type UserLoginDatesOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserLoginDatesSort objects to sort UserLoginDates by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserLoginDatesSort>>;
};

/** Fields to sort UserLoginDates by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserLoginDatesSort object. */
export type UserLoginDatesSort = {
  currentLoginDate?: InputMaybe<SortDirection>;
  lastLoginDate?: InputMaybe<SortDirection>;
};

export type UserLoginDatesWhere = {
  AND?: InputMaybe<Array<UserLoginDatesWhere>>;
  NOT?: InputMaybe<UserLoginDatesWhere>;
  OR?: InputMaybe<Array<UserLoginDatesWhere>>;
  currentLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  currentLoginDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastLoginDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserMentionsAggregateInput = {
  AND?: InputMaybe<Array<UserMentionsAggregateInput>>;
  NOT?: InputMaybe<UserMentionsAggregateInput>;
  OR?: InputMaybe<Array<UserMentionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserMentionsNodeAggregationWhereInput>;
};

export type UserMentionsConnection = {
  __typename?: 'UserMentionsConnection';
  edges: Array<UserMentionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserMentionsConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type UserMentionsConnectionWhere = {
  AND?: InputMaybe<Array<UserMentionsConnectionWhere>>;
  NOT?: InputMaybe<UserMentionsConnectionWhere>;
  OR?: InputMaybe<Array<UserMentionsConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type UserMentionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserMentionsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserMentionsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserMentionsNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserMentionsRelationship = {
  __typename?: 'UserMentionsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Message;
};

export type UserMessageMentionsAggregationSelection = {
  __typename?: 'UserMessageMentionsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserMessageMentionsNodeAggregateSelection>;
};

export type UserMessageMentionsNodeAggregateSelection = {
  __typename?: 'UserMessageMentionsNodeAggregateSelection';
  content: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
};

export type UserMessageRelationship = {
  nodeContext?: Maybe<Scalars['String']['output']>;
  nodeId?: Maybe<Scalars['ID']['output']>;
  nodeLabel: SupportedMessageNodes;
};

export type UserMessageRelationshipSort = {
  nodeContext?: InputMaybe<SortDirection>;
  nodeId?: InputMaybe<SortDirection>;
  nodeLabel?: InputMaybe<SortDirection>;
};

export type UserMessageRelationshipWhere = {
  AND?: InputMaybe<Array<UserMessageRelationshipWhere>>;
  NOT?: InputMaybe<UserMessageRelationshipWhere>;
  OR?: InputMaybe<Array<UserMessageRelationshipWhere>>;
  nodeContext?: InputMaybe<Scalars['String']['input']>;
  nodeContext_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  nodeContext_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  nodeContext_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nodeContext_MATCHES?: InputMaybe<Scalars['String']['input']>;
  nodeContext_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<Scalars['ID']['input']>;
  nodeId_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  nodeId_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  nodeId_IN?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  nodeId_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  nodeLabel?: InputMaybe<SupportedMessageNodes>;
  nodeLabel_IN?: InputMaybe<Array<SupportedMessageNodes>>;
};

export type UserMessageSentMessageAggregationSelection = {
  __typename?: 'UserMessageSentMessageAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserMessageSentMessageNodeAggregateSelection>;
};

export type UserMessageSentMessageNodeAggregateSelection = {
  __typename?: 'UserMessageSentMessageNodeAggregateSelection';
  content: StringAggregateSelectionNullable;
  createdOn: FloatAggregateSelectionNullable;
};

export type UserNegotiationRoundNegotiationRoundsAggregationSelection = {
  __typename?: 'UserNegotiationRoundNegotiationRoundsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserNegotiationRoundNegotiationRoundsNodeAggregateSelection>;
};

export type UserNegotiationRoundNegotiationRoundsNodeAggregateSelection = {
  __typename?: 'UserNegotiationRoundNegotiationRoundsNodeAggregateSelection';
  changedOn: DateTimeAggregateSelectionNonNullable;
  data: StringAggregateSelectionNonNullable;
  id: IdAggregateSelectionNonNullable;
};

export type UserNegotiationRoundsAggregateInput = {
  AND?: InputMaybe<Array<UserNegotiationRoundsAggregateInput>>;
  NOT?: InputMaybe<UserNegotiationRoundsAggregateInput>;
  OR?: InputMaybe<Array<UserNegotiationRoundsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserNegotiationRoundsNodeAggregationWhereInput>;
};

export type UserNegotiationRoundsConnection = {
  __typename?: 'UserNegotiationRoundsConnection';
  edges: Array<UserNegotiationRoundsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserNegotiationRoundsConnectionSort = {
  node?: InputMaybe<NegotiationRoundSort>;
};

export type UserNegotiationRoundsConnectionWhere = {
  AND?: InputMaybe<Array<UserNegotiationRoundsConnectionWhere>>;
  NOT?: InputMaybe<UserNegotiationRoundsConnectionWhere>;
  OR?: InputMaybe<Array<UserNegotiationRoundsConnectionWhere>>;
  node?: InputMaybe<NegotiationRoundWhere>;
};

export type UserNegotiationRoundsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserNegotiationRoundsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserNegotiationRoundsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserNegotiationRoundsNodeAggregationWhereInput>>;
  changedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  changedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  data_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  data_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  data_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  data_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserNegotiationRoundsRelationship = {
  __typename?: 'UserNegotiationRoundsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: NegotiationRound;
};

export type UserNotificationSubscribedAggregationSelection = {
  __typename?: 'UserNotificationSubscribedAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserNotificationSubscribedNodeAggregateSelection>;
};

export type UserNotificationSubscribedNodeAggregateSelection = {
  __typename?: 'UserNotificationSubscribedNodeAggregateSelection';
  id: IntAggregateSelectionNonNullable;
  name: StringAggregateSelectionNonNullable;
};

export type UserOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserSort objects to sort Users by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserSort>>;
};

export type UserOrgSettingsData = {
  __typename?: 'UserOrgSettingsData';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  domainIds: Array<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasOperativeDataAccess?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserOrgSettingsDataAggregateSelection = {
  __typename?: 'UserOrgSettingsDataAggregateSelection';
  count: Scalars['Int']['output'];
  email: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNullable;
  lastName: StringAggregateSelectionNullable;
  role: StringAggregateSelectionNullable;
  userId: StringAggregateSelectionNullable;
};

export type UserOrgSettingsDataConnection = {
  __typename?: 'UserOrgSettingsDataConnection';
  edges: Array<UserOrgSettingsDataEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserOrgSettingsDataEdge = {
  __typename?: 'UserOrgSettingsDataEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UserOrgSettingsData;
};

export type UserOrgSettingsDataOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserOrgSettingsDataSort objects to sort UserOrgSettingsData by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserOrgSettingsDataSort>>;
};

/** Fields to sort UserOrgSettingsData by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserOrgSettingsDataSort object. */
export type UserOrgSettingsDataSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  hasOperativeDataAccess?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  role?: InputMaybe<SortDirection>;
  userId?: InputMaybe<SortDirection>;
};

export type UserOrgSettingsDataWhere = {
  AND?: InputMaybe<Array<UserOrgSettingsDataWhere>>;
  NOT?: InputMaybe<UserOrgSettingsDataWhere>;
  OR?: InputMaybe<Array<UserOrgSettingsDataWhere>>;
  domainIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  domainIds_INCLUDES?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  hasOperativeDataAccess?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  role_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  role_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  role_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role_MATCHES?: InputMaybe<Scalars['String']['input']>;
  role_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  userId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  userId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrganizationInfo = {
  __typename?: 'UserOrganizationInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  defaultAgreementUserRoles: Array<AgreementUserRole>;
  email: Scalars['String']['output'];
  enabledEntryModules: Array<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type UserOrganizationInfoAggregateSelection = {
  __typename?: 'UserOrganizationInfoAggregateSelection';
  count: Scalars['Int']['output'];
  email: StringAggregateSelectionNonNullable;
  firstName: StringAggregateSelectionNullable;
  id: StringAggregateSelectionNonNullable;
  lastName: StringAggregateSelectionNullable;
};

export type UserOrganizationInfoEdge = {
  __typename?: 'UserOrganizationInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UserOrganizationInfo;
};

export type UserOrganizationInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserOrganizationInfoSort objects to sort UserOrganizationInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserOrganizationInfoSort>>;
};

/** Fields to sort UserOrganizationInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserOrganizationInfoSort object. */
export type UserOrganizationInfoSort = {
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
};

export type UserOrganizationInfoWhere = {
  AND?: InputMaybe<Array<UserOrganizationInfoWhere>>;
  NOT?: InputMaybe<UserOrganizationInfoWhere>;
  OR?: InputMaybe<Array<UserOrganizationInfoWhere>>;
  defaultAgreementUserRoles?: InputMaybe<Array<AgreementUserRole>>;
  defaultAgreementUserRoles_INCLUDES?: InputMaybe<AgreementUserRole>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  enabledEntryModules?: InputMaybe<Array<Scalars['String']['input']>>;
  enabledEntryModules_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  id_MATCHES?: InputMaybe<Scalars['String']['input']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrganizationInfosConnection = {
  __typename?: 'UserOrganizationInfosConnection';
  edges: Array<UserOrganizationInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPatientPatientsAggregationSelection = {
  __typename?: 'UserPatientPatientsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserPatientPatientsNodeAggregateSelection>;
};

export type UserPatientPatientsNodeAggregateSelection = {
  __typename?: 'UserPatientPatientsNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  initials: StringAggregateSelectionNullable;
  insuranceId: StringAggregateSelectionNullable;
  lastUpdateDate: DateTimeAggregateSelectionNonNullable;
  tenantId: StringAggregateSelectionNullable;
  yearOfBirth: IntAggregateSelectionNullable;
};

export type UserPatientsAggregateInput = {
  AND?: InputMaybe<Array<UserPatientsAggregateInput>>;
  NOT?: InputMaybe<UserPatientsAggregateInput>;
  OR?: InputMaybe<Array<UserPatientsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserPatientsNodeAggregationWhereInput>;
};

export type UserPatientsConnection = {
  __typename?: 'UserPatientsConnection';
  edges: Array<UserPatientsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserPatientsConnectionSort = {
  node?: InputMaybe<PatientSort>;
};

export type UserPatientsConnectionWhere = {
  AND?: InputMaybe<Array<UserPatientsConnectionWhere>>;
  NOT?: InputMaybe<UserPatientsConnectionWhere>;
  OR?: InputMaybe<Array<UserPatientsConnectionWhere>>;
  node?: InputMaybe<PatientWhere>;
};

export type UserPatientsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserPatientsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserPatientsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserPatientsNodeAggregationWhereInput>>;
  initials_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  initials_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  initials_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  initials_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  insuranceId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  insuranceId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  lastUpdateDate_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdateDate_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  tenantId_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  tenantId_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  tenantId_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  tenantId_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  yearOfBirth_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  yearOfBirth_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserPatientsRelationship = {
  __typename?: 'UserPatientsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Patient;
};

export type UserPersonalInfo = {
  __typename?: 'UserPersonalInfo';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currentLoginDate?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  dosageMeasureUnit?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastLoginDate?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  position?: Maybe<Scalars['String']['output']>;
  preferredLanguage: Scalars['String']['output'];
  simulatorWasteReportingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type UserPersonalInfoAggregateSelection = {
  __typename?: 'UserPersonalInfoAggregateSelection';
  count: Scalars['Int']['output'];
  currency: StringAggregateSelectionNullable;
  currentLoginDate: DateTimeAggregateSelectionNullable;
  department: StringAggregateSelectionNullable;
  dosageMeasureUnit: StringAggregateSelectionNullable;
  firstName: StringAggregateSelectionNonNullable;
  lastLoginDate: DateTimeAggregateSelectionNullable;
  lastName: StringAggregateSelectionNonNullable;
  position: StringAggregateSelectionNullable;
  preferredLanguage: StringAggregateSelectionNonNullable;
};

export type UserPersonalInfoEdge = {
  __typename?: 'UserPersonalInfoEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: UserPersonalInfo;
};

export type UserPersonalInfoInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage: Scalars['String']['input'];
  simulatorWasteReportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sourceUserImage?: InputMaybe<Scalars['String']['input']>;
};

export type UserPersonalInfoOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Specify one or more UserPersonalInfoSort objects to sort UserPersonalInfos by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<UserPersonalInfoSort>>;
};

/** Fields to sort UserPersonalInfos by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserPersonalInfoSort object. */
export type UserPersonalInfoSort = {
  currency?: InputMaybe<SortDirection>;
  currentLoginDate?: InputMaybe<SortDirection>;
  department?: InputMaybe<SortDirection>;
  dosageMeasureUnit?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastLoginDate?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  preferredLanguage?: InputMaybe<SortDirection>;
  simulatorWasteReportingEnabled?: InputMaybe<SortDirection>;
};

export type UserPersonalInfoWhere = {
  AND?: InputMaybe<Array<UserPersonalInfoWhere>>;
  NOT?: InputMaybe<UserPersonalInfoWhere>;
  OR?: InputMaybe<Array<UserPersonalInfoWhere>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  currentLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  currentLoginDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  currentLoginDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  department_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  department_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  department_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  department_MATCHES?: InputMaybe<Scalars['String']['input']>;
  department_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dosageMeasureUnit_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastLoginDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastLoginDate_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastLoginDate_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  position_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  position_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position_MATCHES?: InputMaybe<Scalars['String']['input']>;
  position_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredLanguage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  simulatorWasteReportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPersonalInfosConnection = {
  __typename?: 'UserPersonalInfosConnection';
  edges: Array<UserPersonalInfoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserProfileOrSignatureInput = {
  blobContainerType: BlobContainerType;
  blobName?: InputMaybe<Scalars['String']['input']>;
  blobNameSource?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentSource?: InputMaybe<Scalars['String']['input']>;
};

export type UserQuestQuestsAggregationSelection = {
  __typename?: 'UserQuestQuestsAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<UserQuestQuestsEdgeAggregateSelection>;
  node?: Maybe<UserQuestQuestsNodeAggregateSelection>;
};

export type UserQuestQuestsEdgeAggregateSelection = {
  __typename?: 'UserQuestQuestsEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type UserQuestQuestsNodeAggregateSelection = {
  __typename?: 'UserQuestQuestsNodeAggregateSelection';
  completedOn: DateTimeAggregateSelectionNullable;
  createdOn: DateTimeAggregateSelectionNullable;
  id: IdAggregateSelectionNonNullable;
  lastUpdatedOn: DateTimeAggregateSelectionNullable;
  questContentDe: StringAggregateSelectionNullable;
  questContentEn: StringAggregateSelectionNullable;
  threshold: IntAggregateSelectionNullable;
  timeStamp: FloatAggregateSelectionNonNullable;
  triggerEventId: IntAggregateSelectionNonNullable;
  value: FloatAggregateSelectionNullable;
};

export type UserQuestRelationship = {
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type UserQuestRelationshipSort = {
  isOwner?: InputMaybe<SortDirection>;
  isResolved?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type UserQuestRelationshipWhere = {
  AND?: InputMaybe<Array<UserQuestRelationshipWhere>>;
  NOT?: InputMaybe<UserQuestRelationshipWhere>;
  OR?: InputMaybe<Array<UserQuestRelationshipWhere>>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQuestsAggregateInput = {
  AND?: InputMaybe<Array<UserQuestsAggregateInput>>;
  NOT?: InputMaybe<UserQuestsAggregateInput>;
  OR?: InputMaybe<Array<UserQuestsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserQuestsEdgeAggregationWhereInput>;
  node?: InputMaybe<UserQuestsNodeAggregationWhereInput>;
};

export type UserQuestsConnection = {
  __typename?: 'UserQuestsConnection';
  edges: Array<UserQuestsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserQuestsConnectionSort = {
  edge?: InputMaybe<UserQuestRelationshipSort>;
  node?: InputMaybe<QuestSort>;
};

export type UserQuestsConnectionWhere = {
  AND?: InputMaybe<Array<UserQuestsConnectionWhere>>;
  NOT?: InputMaybe<UserQuestsConnectionWhere>;
  OR?: InputMaybe<Array<UserQuestsConnectionWhere>>;
  edge?: InputMaybe<UserQuestRelationshipWhere>;
  node?: InputMaybe<QuestWhere>;
};

export type UserQuestsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserQuestsEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<UserQuestsEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserQuestsEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserQuestsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserQuestsNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserQuestsNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserQuestsNodeAggregationWhereInput>>;
  completedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  completedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MAX_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_EQUAL?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_MIN_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  questContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  questContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  questContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  questContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  questContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  questContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  questContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  questContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  questContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  questContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  questContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  questContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  questContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  threshold_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  threshold_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  threshold_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  value_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  value_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserQuestsRelationship = UserQuestRelationship & {
  __typename?: 'UserQuestsRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  isResolved?: Maybe<Scalars['Boolean']['output']>;
  node: Quest;
  order?: Maybe<Scalars['Int']['output']>;
};

export type UserRoleRequestUpdateInput = {
  agreementId: Scalars['String']['input'];
  agreementName: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserSentMessageAggregateInput = {
  AND?: InputMaybe<Array<UserSentMessageAggregateInput>>;
  NOT?: InputMaybe<UserSentMessageAggregateInput>;
  OR?: InputMaybe<Array<UserSentMessageAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserSentMessageNodeAggregationWhereInput>;
};

export type UserSentMessageConnection = {
  __typename?: 'UserSentMessageConnection';
  edges: Array<UserSentMessageRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSentMessageConnectionSort = {
  node?: InputMaybe<MessageSort>;
};

export type UserSentMessageConnectionWhere = {
  AND?: InputMaybe<Array<UserSentMessageConnectionWhere>>;
  NOT?: InputMaybe<UserSentMessageConnectionWhere>;
  OR?: InputMaybe<Array<UserSentMessageConnectionWhere>>;
  node?: InputMaybe<MessageWhere>;
};

export type UserSentMessageNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSentMessageNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSentMessageNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSentMessageNodeAggregationWhereInput>>;
  content_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  content_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  content_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  content_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  createdOn_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  createdOn_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
};

export type UserSentMessageRelationship = {
  __typename?: 'UserSentMessageRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Message;
};

/** Fields to sort Users by. The order in which sorts are applied is not guaranteed when specifying many fields in one UserSort object. */
export type UserSort = {
  createdOn?: InputMaybe<SortDirection>;
  currency?: InputMaybe<SortDirection>;
  deletedOn?: InputMaybe<SortDirection>;
  department?: InputMaybe<SortDirection>;
  dosageMeasureUnit?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  filtersSimulations?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  isDeleted?: InputMaybe<SortDirection>;
  isGuest?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  lastUpdatedOn?: InputMaybe<SortDirection>;
  organization?: InputMaybe<SortDirection>;
  position?: InputMaybe<SortDirection>;
  preferredLanguage?: InputMaybe<SortDirection>;
  publicAgreementView?: InputMaybe<SortDirection>;
  signature?: InputMaybe<SortDirection>;
  simulatorWasteReportingEnabled?: InputMaybe<SortDirection>;
  tenantId?: InputMaybe<SortDirection>;
};

export type UserSubscribedAggregateInput = {
  AND?: InputMaybe<Array<UserSubscribedAggregateInput>>;
  NOT?: InputMaybe<UserSubscribedAggregateInput>;
  OR?: InputMaybe<Array<UserSubscribedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  node?: InputMaybe<UserSubscribedNodeAggregationWhereInput>;
};

export type UserSubscribedConnection = {
  __typename?: 'UserSubscribedConnection';
  edges: Array<UserSubscribedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserSubscribedConnectionSort = {
  node?: InputMaybe<NotificationSort>;
};

export type UserSubscribedConnectionWhere = {
  AND?: InputMaybe<Array<UserSubscribedConnectionWhere>>;
  NOT?: InputMaybe<UserSubscribedConnectionWhere>;
  OR?: InputMaybe<Array<UserSubscribedConnectionWhere>>;
  node?: InputMaybe<NotificationWhere>;
};

export type UserSubscribedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserSubscribedNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserSubscribedNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserSubscribedNodeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  id_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  id_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  id_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  name_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  name_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  name_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSubscribedRelationship = {
  __typename?: 'UserSubscribedRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: Notification;
};

export type UserTaskRelationship = {
  isCompleted: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
};

export type UserTaskRelationshipSort = {
  isCompleted?: InputMaybe<SortDirection>;
  order?: InputMaybe<SortDirection>;
};

export type UserTaskRelationshipWhere = {
  AND?: InputMaybe<Array<UserTaskRelationshipWhere>>;
  NOT?: InputMaybe<UserTaskRelationshipWhere>;
  OR?: InputMaybe<Array<UserTaskRelationshipWhere>>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  order_GT?: InputMaybe<Scalars['Int']['input']>;
  order_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  order_LT?: InputMaybe<Scalars['Int']['input']>;
  order_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTaskTasksAggregationSelection = {
  __typename?: 'UserTaskTasksAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  edge?: Maybe<UserTaskTasksEdgeAggregateSelection>;
  node?: Maybe<UserTaskTasksNodeAggregateSelection>;
};

export type UserTaskTasksEdgeAggregateSelection = {
  __typename?: 'UserTaskTasksEdgeAggregateSelection';
  order: IntAggregateSelectionNullable;
};

export type UserTaskTasksNodeAggregateSelection = {
  __typename?: 'UserTaskTasksNodeAggregateSelection';
  id: IdAggregateSelectionNonNullable;
  taskContentDe: StringAggregateSelectionNullable;
  taskContentEn: StringAggregateSelectionNullable;
  timeStamp: FloatAggregateSelectionNonNullable;
  triggerEventId: IntAggregateSelectionNonNullable;
};

export type UserTasksAggregateInput = {
  AND?: InputMaybe<Array<UserTasksAggregateInput>>;
  NOT?: InputMaybe<UserTasksAggregateInput>;
  OR?: InputMaybe<Array<UserTasksAggregateInput>>;
  count?: InputMaybe<Scalars['Int']['input']>;
  count_GT?: InputMaybe<Scalars['Int']['input']>;
  count_GTE?: InputMaybe<Scalars['Int']['input']>;
  count_LT?: InputMaybe<Scalars['Int']['input']>;
  count_LTE?: InputMaybe<Scalars['Int']['input']>;
  edge?: InputMaybe<UserTasksEdgeAggregationWhereInput>;
  node?: InputMaybe<UserTasksNodeAggregationWhereInput>;
};

export type UserTasksConnection = {
  __typename?: 'UserTasksConnection';
  edges: Array<UserTasksRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserTasksConnectionSort = {
  edge?: InputMaybe<UserTaskRelationshipSort>;
  node?: InputMaybe<TaskSort>;
};

export type UserTasksConnectionWhere = {
  AND?: InputMaybe<Array<UserTasksConnectionWhere>>;
  NOT?: InputMaybe<UserTasksConnectionWhere>;
  OR?: InputMaybe<Array<UserTasksConnectionWhere>>;
  edge?: InputMaybe<UserTaskRelationshipWhere>;
  node?: InputMaybe<TaskWhere>;
};

export type UserTasksEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserTasksEdgeAggregationWhereInput>>;
  NOT?: InputMaybe<UserTasksEdgeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserTasksEdgeAggregationWhereInput>>;
  order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  order_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  order_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  order_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  order_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTasksNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UserTasksNodeAggregationWhereInput>>;
  NOT?: InputMaybe<UserTasksNodeAggregationWhereInput>;
  OR?: InputMaybe<Array<UserTasksNodeAggregationWhereInput>>;
  taskContentDe_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  taskContentDe_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  taskContentDe_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  taskContentDe_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  taskContentDe_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  taskContentDe_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  taskContentDe_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_AVERAGE_LENGTH_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  taskContentEn_AVERAGE_LENGTH_GT?: InputMaybe<Scalars['Float']['input']>;
  taskContentEn_AVERAGE_LENGTH_GTE?: InputMaybe<Scalars['Float']['input']>;
  taskContentEn_AVERAGE_LENGTH_LT?: InputMaybe<Scalars['Float']['input']>;
  taskContentEn_AVERAGE_LENGTH_LTE?: InputMaybe<Scalars['Float']['input']>;
  taskContentEn_LONGEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_LONGEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_LONGEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_LONGEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_LONGEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_SHORTEST_LENGTH_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_SHORTEST_LENGTH_GT?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_SHORTEST_LENGTH_GTE?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_SHORTEST_LENGTH_LT?: InputMaybe<Scalars['Int']['input']>;
  taskContentEn_SHORTEST_LENGTH_LTE?: InputMaybe<Scalars['Int']['input']>;
  timeStamp_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MAX_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_MIN_LTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_GT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_GTE?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_LT?: InputMaybe<Scalars['Float']['input']>;
  timeStamp_SUM_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_GT?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_GTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_LT?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_AVERAGE_LTE?: InputMaybe<Scalars['Float']['input']>;
  triggerEventId_MAX_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MAX_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_MIN_LTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_EQUAL?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_GT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_GTE?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_LT?: InputMaybe<Scalars['Int']['input']>;
  triggerEventId_SUM_LTE?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTasksRelationship = UserTaskRelationship & {
  __typename?: 'UserTasksRelationship';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  node: Task;
  order?: Maybe<Scalars['Int']['output']>;
};

export type UserUserContextContextAggregationSelection = {
  __typename?: 'UserUserContextContextAggregationSelection';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  node?: Maybe<UserUserContextContextNodeAggregateSelection>;
};

export type UserUserContextContextNodeAggregateSelection = {
  __typename?: 'UserUserContextContextNodeAggregateSelection';
  email: StringAggregateSelectionNonNullable;
  filterCaseLogs: StringAggregateSelectionNullable;
  filtersAgreements: StringAggregateSelectionNullable;
  filtersCases: StringAggregateSelectionNullable;
  filtersDataForms: StringAggregateSelectionNullable;
  filtersDataRecords: StringAggregateSelectionNullable;
  filtersDocuments: StringAggregateSelectionNullable;
  filtersRefunds: StringAggregateSelectionNullable;
  filtersSimulations: StringAggregateSelectionNullable;
  timePeriodCaseDetails: StringAggregateSelectionNullable;
  timePeriodFilterDashboard: StringAggregateSelectionNullable;
  timePeriodFilterHome: StringAggregateSelectionNullable;
  timePeriodFilterReporting: StringAggregateSelectionNullable;
  transactionsInCreditNoteDocumentTableColumns: StringAggregateSelectionNullable;
  transactionsInDocumentTableColumnsRefundInvoice: StringAggregateSelectionNullable;
  transactionsInFreeOfChargeDocumentTableColumns: StringAggregateSelectionNullable;
};

export type UserWhere = {
  AND?: InputMaybe<Array<UserWhere>>;
  NOT?: InputMaybe<UserWhere>;
  OR?: InputMaybe<Array<UserWhere>>;
  agreementRunAttemptsAggregate?: InputMaybe<UserAgreementRunAttemptsAggregateInput>;
  /** Return Users where all of the related UserAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_ALL?: InputMaybe<UserAgreementRunAttemptsConnectionWhere>;
  /** Return Users where none of the related UserAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_NONE?: InputMaybe<UserAgreementRunAttemptsConnectionWhere>;
  /** Return Users where one of the related UserAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_SINGLE?: InputMaybe<UserAgreementRunAttemptsConnectionWhere>;
  /** Return Users where some of the related UserAgreementRunAttemptsConnections match this filter */
  agreementRunAttemptsConnection_SOME?: InputMaybe<UserAgreementRunAttemptsConnectionWhere>;
  /** Return Users where all of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_ALL?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Users where none of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_NONE?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Users where one of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_SINGLE?: InputMaybe<AgreementRunAttemptInfoWhere>;
  /** Return Users where some of the related AgreementRunAttemptInfos match this filter */
  agreementRunAttempts_SOME?: InputMaybe<AgreementRunAttemptInfoWhere>;
  comparableModels?: InputMaybe<Array<Scalars['String']['input']>>;
  comparableModels_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  comparisonSimulations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comparisonSimulations_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<UserContextWhere>;
  contextAggregate?: InputMaybe<UserContextAggregateInput>;
  contextConnection?: InputMaybe<UserContextConnectionWhere>;
  contextConnection_NOT?: InputMaybe<UserContextConnectionWhere>;
  context_NOT?: InputMaybe<UserContextWhere>;
  createdOn?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  createdOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currency_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  currency_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  currency_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency_MATCHES?: InputMaybe<Scalars['String']['input']>;
  currency_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  deletedOn?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  deletedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  deletedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  department_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  department_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  department_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  department_MATCHES?: InputMaybe<Scalars['String']['input']>;
  department_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  domainsAggregate?: InputMaybe<UserDomainsAggregateInput>;
  /** Return Users where all of the related UserDomainsConnections match this filter */
  domainsConnection_ALL?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where none of the related UserDomainsConnections match this filter */
  domainsConnection_NONE?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where one of the related UserDomainsConnections match this filter */
  domainsConnection_SINGLE?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where some of the related UserDomainsConnections match this filter */
  domainsConnection_SOME?: InputMaybe<UserDomainsConnectionWhere>;
  /** Return Users where all of the related Domains match this filter */
  domains_ALL?: InputMaybe<DomainWhere>;
  /** Return Users where none of the related Domains match this filter */
  domains_NONE?: InputMaybe<DomainWhere>;
  /** Return Users where one of the related Domains match this filter */
  domains_SINGLE?: InputMaybe<DomainWhere>;
  /** Return Users where some of the related Domains match this filter */
  domains_SOME?: InputMaybe<DomainWhere>;
  dosageMeasureUnit?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dosageMeasureUnit_MATCHES?: InputMaybe<Scalars['String']['input']>;
  dosageMeasureUnit_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  email_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  email_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  email_MATCHES?: InputMaybe<Scalars['String']['input']>;
  email_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  favoriteModels?: InputMaybe<Array<Scalars['String']['input']>>;
  favoriteModels_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filtersSimulations_MATCHES?: InputMaybe<Scalars['String']['input']>;
  filtersSimulations_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  firstName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  firstName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  firstName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_CONTAINS?: InputMaybe<Scalars['ID']['input']>;
  id_ENDS_WITH?: InputMaybe<Scalars['ID']['input']>;
  id_IN?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_STARTS_WITH?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isGuest?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  lastName_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastName_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName_MATCHES?: InputMaybe<Scalars['String']['input']>;
  lastName_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  lastUpdatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_GTE?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_IN?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lastUpdatedOn_LT?: InputMaybe<Scalars['DateTime']['input']>;
  lastUpdatedOn_LTE?: InputMaybe<Scalars['DateTime']['input']>;
  mentionsAggregate?: InputMaybe<UserMentionsAggregateInput>;
  /** Return Users where all of the related UserMentionsConnections match this filter */
  mentionsConnection_ALL?: InputMaybe<UserMentionsConnectionWhere>;
  /** Return Users where none of the related UserMentionsConnections match this filter */
  mentionsConnection_NONE?: InputMaybe<UserMentionsConnectionWhere>;
  /** Return Users where one of the related UserMentionsConnections match this filter */
  mentionsConnection_SINGLE?: InputMaybe<UserMentionsConnectionWhere>;
  /** Return Users where some of the related UserMentionsConnections match this filter */
  mentionsConnection_SOME?: InputMaybe<UserMentionsConnectionWhere>;
  /** Return Users where all of the related Messages match this filter */
  mentions_ALL?: InputMaybe<MessageWhere>;
  /** Return Users where none of the related Messages match this filter */
  mentions_NONE?: InputMaybe<MessageWhere>;
  /** Return Users where one of the related Messages match this filter */
  mentions_SINGLE?: InputMaybe<MessageWhere>;
  /** Return Users where some of the related Messages match this filter */
  mentions_SOME?: InputMaybe<MessageWhere>;
  negotiationRoundsAggregate?: InputMaybe<UserNegotiationRoundsAggregateInput>;
  /** Return Users where all of the related UserNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_ALL?: InputMaybe<UserNegotiationRoundsConnectionWhere>;
  /** Return Users where none of the related UserNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_NONE?: InputMaybe<UserNegotiationRoundsConnectionWhere>;
  /** Return Users where one of the related UserNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_SINGLE?: InputMaybe<UserNegotiationRoundsConnectionWhere>;
  /** Return Users where some of the related UserNegotiationRoundsConnections match this filter */
  negotiationRoundsConnection_SOME?: InputMaybe<UserNegotiationRoundsConnectionWhere>;
  /** Return Users where all of the related NegotiationRounds match this filter */
  negotiationRounds_ALL?: InputMaybe<NegotiationRoundWhere>;
  /** Return Users where none of the related NegotiationRounds match this filter */
  negotiationRounds_NONE?: InputMaybe<NegotiationRoundWhere>;
  /** Return Users where one of the related NegotiationRounds match this filter */
  negotiationRounds_SINGLE?: InputMaybe<NegotiationRoundWhere>;
  /** Return Users where some of the related NegotiationRounds match this filter */
  negotiationRounds_SOME?: InputMaybe<NegotiationRoundWhere>;
  patientsAggregate?: InputMaybe<UserPatientsAggregateInput>;
  /** Return Users where all of the related UserPatientsConnections match this filter */
  patientsConnection_ALL?: InputMaybe<UserPatientsConnectionWhere>;
  /** Return Users where none of the related UserPatientsConnections match this filter */
  patientsConnection_NONE?: InputMaybe<UserPatientsConnectionWhere>;
  /** Return Users where one of the related UserPatientsConnections match this filter */
  patientsConnection_SINGLE?: InputMaybe<UserPatientsConnectionWhere>;
  /** Return Users where some of the related UserPatientsConnections match this filter */
  patientsConnection_SOME?: InputMaybe<UserPatientsConnectionWhere>;
  /** Return Users where all of the related Patients match this filter */
  patients_ALL?: InputMaybe<PatientWhere>;
  /** Return Users where none of the related Patients match this filter */
  patients_NONE?: InputMaybe<PatientWhere>;
  /** Return Users where one of the related Patients match this filter */
  patients_SINGLE?: InputMaybe<PatientWhere>;
  /** Return Users where some of the related Patients match this filter */
  patients_SOME?: InputMaybe<PatientWhere>;
  position?: InputMaybe<Scalars['String']['input']>;
  position_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  position_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  position_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  position_MATCHES?: InputMaybe<Scalars['String']['input']>;
  position_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredLanguage_MATCHES?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  publicAgreementView?: InputMaybe<PublicAgreementView>;
  publicAgreementView_IN?: InputMaybe<Array<InputMaybe<PublicAgreementView>>>;
  questsAggregate?: InputMaybe<UserQuestsAggregateInput>;
  /** Return Users where all of the related UserQuestsConnections match this filter */
  questsConnection_ALL?: InputMaybe<UserQuestsConnectionWhere>;
  /** Return Users where none of the related UserQuestsConnections match this filter */
  questsConnection_NONE?: InputMaybe<UserQuestsConnectionWhere>;
  /** Return Users where one of the related UserQuestsConnections match this filter */
  questsConnection_SINGLE?: InputMaybe<UserQuestsConnectionWhere>;
  /** Return Users where some of the related UserQuestsConnections match this filter */
  questsConnection_SOME?: InputMaybe<UserQuestsConnectionWhere>;
  /** Return Users where all of the related Quests match this filter */
  quests_ALL?: InputMaybe<QuestWhere>;
  /** Return Users where none of the related Quests match this filter */
  quests_NONE?: InputMaybe<QuestWhere>;
  /** Return Users where one of the related Quests match this filter */
  quests_SINGLE?: InputMaybe<QuestWhere>;
  /** Return Users where some of the related Quests match this filter */
  quests_SOME?: InputMaybe<QuestWhere>;
  reads?: InputMaybe<Array<Scalars['String']['input']>>;
  reads_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  sentMessage?: InputMaybe<MessageWhere>;
  sentMessageAggregate?: InputMaybe<UserSentMessageAggregateInput>;
  sentMessageConnection?: InputMaybe<UserSentMessageConnectionWhere>;
  sentMessageConnection_NOT?: InputMaybe<UserSentMessageConnectionWhere>;
  sentMessage_NOT?: InputMaybe<MessageWhere>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signature_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  signature_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  signature_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signature_MATCHES?: InputMaybe<Scalars['String']['input']>;
  signature_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  simulationsTableColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  simulationsTableColumns_INCLUDES?: InputMaybe<Scalars['String']['input']>;
  simulatorWasteReportingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  subscribedAggregate?: InputMaybe<UserSubscribedAggregateInput>;
  /** Return Users where all of the related UserSubscribedConnections match this filter */
  subscribedConnection_ALL?: InputMaybe<UserSubscribedConnectionWhere>;
  /** Return Users where none of the related UserSubscribedConnections match this filter */
  subscribedConnection_NONE?: InputMaybe<UserSubscribedConnectionWhere>;
  /** Return Users where one of the related UserSubscribedConnections match this filter */
  subscribedConnection_SINGLE?: InputMaybe<UserSubscribedConnectionWhere>;
  /** Return Users where some of the related UserSubscribedConnections match this filter */
  subscribedConnection_SOME?: InputMaybe<UserSubscribedConnectionWhere>;
  /** Return Users where all of the related Notifications match this filter */
  subscribed_ALL?: InputMaybe<NotificationWhere>;
  /** Return Users where none of the related Notifications match this filter */
  subscribed_NONE?: InputMaybe<NotificationWhere>;
  /** Return Users where one of the related Notifications match this filter */
  subscribed_SINGLE?: InputMaybe<NotificationWhere>;
  /** Return Users where some of the related Notifications match this filter */
  subscribed_SOME?: InputMaybe<NotificationWhere>;
  tasksAggregate?: InputMaybe<UserTasksAggregateInput>;
  /** Return Users where all of the related UserTasksConnections match this filter */
  tasksConnection_ALL?: InputMaybe<UserTasksConnectionWhere>;
  /** Return Users where none of the related UserTasksConnections match this filter */
  tasksConnection_NONE?: InputMaybe<UserTasksConnectionWhere>;
  /** Return Users where one of the related UserTasksConnections match this filter */
  tasksConnection_SINGLE?: InputMaybe<UserTasksConnectionWhere>;
  /** Return Users where some of the related UserTasksConnections match this filter */
  tasksConnection_SOME?: InputMaybe<UserTasksConnectionWhere>;
  /** Return Users where all of the related Tasks match this filter */
  tasks_ALL?: InputMaybe<TaskWhere>;
  /** Return Users where none of the related Tasks match this filter */
  tasks_NONE?: InputMaybe<TaskWhere>;
  /** Return Users where one of the related Tasks match this filter */
  tasks_SINGLE?: InputMaybe<TaskWhere>;
  /** Return Users where some of the related Tasks match this filter */
  tasks_SOME?: InputMaybe<TaskWhere>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tenantId_CONTAINS?: InputMaybe<Scalars['String']['input']>;
  tenantId_ENDS_WITH?: InputMaybe<Scalars['String']['input']>;
  tenantId_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId_MATCHES?: InputMaybe<Scalars['String']['input']>;
  tenantId_STARTS_WITH?: InputMaybe<Scalars['String']['input']>;
  writes?: InputMaybe<Array<Scalars['String']['input']>>;
  writes_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type UsersConnection = {
  __typename?: 'UsersConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ValidatedComparisonResponse = {
  __typename?: 'ValidatedComparisonResponse';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  validSimulationIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ValidatedComparisonResponseAggregateSelection = {
  __typename?: 'ValidatedComparisonResponseAggregateSelection';
  count: Scalars['Int']['output'];
};

export type ValidatedComparisonResponseEdge = {
  __typename?: 'ValidatedComparisonResponseEdge';
  _count?: Maybe<Scalars['Int']['output']>;
  _dbNodeId?: Maybe<Scalars['Int']['output']>;
  cursor: Scalars['String']['output'];
  node: ValidatedComparisonResponse;
};

export type ValidatedComparisonResponseOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidatedComparisonResponseWhere = {
  AND?: InputMaybe<Array<ValidatedComparisonResponseWhere>>;
  NOT?: InputMaybe<ValidatedComparisonResponseWhere>;
  OR?: InputMaybe<Array<ValidatedComparisonResponseWhere>>;
  validSimulationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  validSimulationIds_INCLUDES?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatedComparisonResponsesConnection = {
  __typename?: 'ValidatedComparisonResponsesConnection';
  edges: Array<ValidatedComparisonResponseEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum WidgetType {
  InitialResponseReview = 'INITIAL_RESPONSE_REVIEW',
  ProgressionFreePatients = 'PROGRESSION_FREE_PATIENTS',
  TotalResponses = 'TOTAL_RESPONSES'
}
